(function() {

  'use strict';

  appConfig.$inject = ['$compileProvider', '$httpProvider', 'iScrollServiceProvider', 'AnalyticsProvider'];
  angular.module('ptCrm', [
    'config',
    'ui.router',
    'translations',
    'templates-dist',
    'ngTouch',
    'ngSanitize',
    'angular-iscroll',
    'toastr',
    'rzModule',
    'permission',
    'permission.ui',
    'ui.select',
    'ui.mask',
    'ui.bootstrap',
    'ngFileUpload',
    'angularTrix',
    'angular-carousel',
    'ngPromiseExtras',
    'ngMessages',
    'angular-google-analytics',
    'ng-sortable',
    'ptConvert',
    'ptExerciseMetaData',
    'ptDefaultCompletedProfile',
    'ptDisplayMetrics',
    'ng-showdown',
    window.angularDragula(angular) // angularDragula initialization requirements
  ])
    .constant('STRINGS', {
      APPLICATION_NAME: 'Personal Trainer Admin'
    })
    .config(appConfig);


  function appConfig($compileProvider, $httpProvider, iScrollServiceProvider, AnalyticsProvider) {

    var env = window.config && window.config.env,
      gaTrackingID = window.config && window.config.googleAnalytics;

    $compileProvider.debugInfoEnabled(env !== 'prod');

    $httpProvider.interceptors.push('maintenanceModeInterceptor');
    $httpProvider.interceptors.push('authInterceptorService');

    // iScroll always overwrites mouseWheel option with default value
    // we can remove this fix when https://github.com/mtr/angular-iscroll/pull/17 wil be merged
    var iScrollDefaults = iScrollServiceProvider.getDefaults(); // eslint-disable-line one-var
    delete iScrollDefaults.iScroll.mouseWheel;

    if (gaTrackingID) {
      AnalyticsProvider.setAccount(gaTrackingID);
    } else {
      AnalyticsProvider.startOffline(true);
    }

    AnalyticsProvider.trackPages(true);
    AnalyticsProvider.setPageEvent('$stateChangeSuccess');

  }

  // Gets overridden during by templates.js during build
  angular.module('templates-dist', []);

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .run(['PermissionStrategies', '$rootScope', 'profileService', '$urlRouter', 'langService', 'Analytics', 'metricsService', '$window', 'serverStatus', '$state', '$translate', function(PermissionStrategies, $rootScope, profileService, $urlRouter, langService, Analytics, metricsService, $window, serverStatus, $state, $translate) {
      $rootScope.PermissionStrategies = PermissionStrategies;
      $rootScope.PermissionStrategies.disableUiSelect = function(scope) {
        return function() {
          scope.$select.disabled = true;
        };
      };

      $rootScope.PermissionStrategies.enableUiSelect = function(scope) {
        return function() {
          scope.$select.disabled = false;
        };
      };

      $rootScope.PermissionStrategies.disableTab = function($el) {
        $el.remove();
        $rootScope.$emit('tabs:disabled', $el.attr('name'));
      };

      var promise = /^#\/maintenance/.test($window.location.hash) ?
        serverStatus.isServerReady()
          .then(function(serverReady) {
            if (serverReady) {
              window.location.hash = '';
              window.location.reload();
            } else {
              window.location.hash = '#/maintenance';
            }
            return;
          }) :
        profileService.authorize();

      promise
        .then(langService.setAppLanguage)
        .then(function() {
          if (!_.isEmpty(profileService.user)) {
            return metricsService.getMetrics();
          }
          return;
        })
        .finally(function() {
          $urlRouter.sync();
          $urlRouter.listen();
        })
        .catch(function(err) {
          if (err.status === 404) {
            return langService.setAppLanguage()
              .then(function() {
                return $state.go('login.form', { lang: $translate.use() });
              });
          }
        });
    }]);


}());
(function() {
  'use strict';

  angular.module('config', [])
    .provider('config', function() {

      // Disable moment humanize rounding
      var retainValue = function(value) {
        return value;
      };
      moment.relativeTimeRounding(retainValue);

      // Default config
      var config = {
        basePath: '/', // Should match <base href=""/> in index.html
        assetBaseUrl: '',
        translationsUrl: '/translations/',
        defaultLanguage: 'en',

          // Language key expected format: two letter ISO_639-1 code + region
          // http://www.w3.org/International/articles/language-tags/
        languages: {
          en: {
            name: 'English'
          },
          de: {
            name: 'Deutsch'
          },
          'zh-CN': {
            name: '简体中国',
            aliases: ['zh']
          },
          'zh-TW': {
            name: '中國傳統'
          }
        },
        availableLanguages: [], // Generated from languages
        languageAliases: {},    // Generated from languages,
        firstDayOfWeek: 1, // 0 for Sunday | 1 for Monday,
        assignmentRecurrenceOptions: ['once', 'daily', 'weekly', 'monthly'],
        assignmentDurationOptions: [
          moment.duration(30, 'minutes'),
          moment.duration(60, 'minutes'),
          moment.duration(90, 'minutes'),
          moment.duration(120, 'minutes'),
          moment.duration(150, 'minutes'),
          moment.duration(180, 'minutes'),
          moment.duration(210, 'minutes'),
          moment.duration(240, 'minutes'),
          moment.duration(270, 'minutes'),
          moment.duration(300, 'minutes'),
          moment.duration(330, 'minutes'),
          moment.duration(6, 'hours'),
          moment.duration(7, 'hours'),
          moment.duration(8, 'hours'),
          moment.duration(9, 'hours'),
          moment.duration(10, 'hours'),
          moment.duration(11, 'hours'),
          moment.duration(12, 'hours')
        ],
        apiUrl: '/',
        get apiBase() {
          return this.apiUrl + 'api/v1';
        },
        env: 'dev'
      };

      // Build | dist config based off of global config object
      if (!_.isUndefined(window.buildConfig)) {
        _.extend(config, window.buildConfig);
      }
      // Runtime config
      if (!_.isUndefined(window.config)) {
        _.extend(config, window.config);
      }

      if (config.version) {
        config.assetBaseUrl += config.version;
        config.translationsUrl = config.assetBaseUrl + '/translations/';
      }

      config.availableLanguages = _.map(config.languages, function(obj, key) {
        return key;
      });

      // TODO: Examine the necessity of all this aliasing and consider
      // replacing it with a language/region resolver that's used
      // directly by angular translate
      //
      // https://github.com/angular-translate/angular-translate/blob/a2ac7000f94bcee6dd8e206cab5d7cec3527dd25/src/service/translate.js#L694

      // Maps language_region to language-region.  zh_TW to zh-TW for example.
      function createUnderscoreAlias(name) {
        if (name.indexOf('-') > -1) {
          config.languageAliases[name.replace('-', '_')] = name;
        }
      }

      // Create map of aliases
      _.each(config.languages, function(obj, key) {
        _.each(obj.aliases, function(alias) {
          if (alias.length > 1) {
            config.languageAliases[alias] = key;
            createUnderscoreAlias(alias);
          }
        });

        if (key.length === 2) {
          config.languageAliases[key + '*'] = key;
        }

        createUnderscoreAlias(key);
      });

      this.$get = function() {
        return config;
      };
    });

}());
(function() {
  'use strict';

  appRoutes.$inject = ['configProvider', '$locationProvider', '$stateProvider', '$urlRouterProvider', 'USER_HOME_PAGE'];
  angular.module('ptCrm')
    .constant('USER_HOME_PAGE', {
      URL: 'login.form'
    })
    .constant('PAGES_PRIORITIES', [
      {
        permission:  'DASHBOARD_VIEW_READ',
        URL: 'app.dashboard'
      },{
        permission:  'SCHEDULE_VIEW_READ',
        URL: 'app.calendar'
      },{
        permission:  'TRAINING_LIBRARY_VIEW_READ',
        URL: 'app.library.list'
      },{
        permission: 'ROSTER_CLIENT_VIEW_READ',
        URL: 'app.users.list'
      },{
        permission: 'ROSTER_NON_CLIENT_VIEW_READ',
        URL: 'app.users.list'
      },{
        permission: 'FACILITY_ASSIGNMENTS_READ',
        URL: 'app.facilityAssignments'
      },{
        permission:  'DASHBOARD_VIEW_READ',
        URL: 'app.messaging'
      },{
        permission: 'SETTINGS_VIEW_READ',
        URL: 'app.settings'
      },{
        permission: 'CLIENT_PERSONAL_DETAILS_SELF_READ',
        URL: 'app.users.details',
        PARAMS: {
          userId: 'me'
        }
      }
    ])
    .config(appRoutes);

  function appRoutes(configProvider, $locationProvider, $stateProvider, $urlRouterProvider, USER_HOME_PAGE) {
    var config = configProvider.$get();

    $stateProvider
      .state('nolang', {
        url: '^/',
        controller: 'AppController'
      })

      .state('app', {
        url: '^/:lang?token',
        abstract: true,
        controller: 'AppController as app',
        templateUrl: '/app/layout/layout.html'
      })

      .state('maintenance', {
        url: '^/maintenance',
        templateUrl: '/app/maintenance/maintenance.html',
        controller: 'maintenanceCtrl as maintenanceCtrl'
      })

      .state('privacy', {
        url: '/policy',
        controller: 'PrivacyController as privacy',
        templateUrl: '/app/privacy/privacy.html'
      })

      .state('termsofuse', {
        url: '/terms_of_use',
        controller: 'TermsOfUseController as termsofuse',
        templateUrl: '/app/termsOfUse/termsOfUse.html'
      })

      .state('subscription_change', {
        url: '^/subscription_change',
        templateUrl: '/app/unsubscribe/unsubscribe.html'
      })

    // ------------------------------ LOGIN ------------------------------
      .state('login', {
        abstract: true,
        url: '^/:lang/login',
        templateUrl: '/app/auth/login.html',
        controller: 'LoginController as loginCtrl',
        data: {
          loginNotRequired: true
        }
      })
      .state('login.form', {
        url: '?next',
        templateUrl: '/app/auth/login_form.html'
      })

    // ------------------------------ FORGOT PASSWORD ------------------------------

      .state('login.forgot', {
        abstract: true,
        url: '^/:lang/forgot',
        templateUrl: '/app/forgot/layout.html'
      })
      .state('login.forgot.request', {
        abstract: true,
        url: '/request',
        template: '<ui-view/>'
      })
      .state('login.forgot.request.form', {
        url: '',
        templateUrl: '/app/forgot/request/form.html',
        controller: 'forgotRequestCtrl as forgotRequestCtrl',
        params: {
          email: null
        }
      })
      .state('login.forgot.request.sent', {
        templateUrl: '/app/forgot/request/sent.html',
        params: {
          email: null
        },
        controllerAs: 'sent',
        controller: ['$stateParams', function($stateParams) {
          this.email = $stateParams.email;
        }]
      })
      .state('login.forgot.request.error', {
        templateUrl: '/app/forgot/request/error.html',
        params: {
          email: null
        },
        controller: ['$stateParams', function($stateParams) {
          this.email = $stateParams.email;
        }],
        controllerAs: 'error'
      })
      .state('login.forgot.reset', {
        abstract: true,
        url: '/reset?token',
        template: '<ui-view/>'
      })
      .state('login.forgot.reset.form', {
        url: '',
        templateUrl: '/app/forgot/reset/form.html',
        controller: 'forgotResetCtrl as forgotResetCtrl'
      })
      .state('login.forgot.reset.expired', {
        templateUrl: '/app/forgot/reset/expired.html',
        params: {
          email: null
        },
        controller: ['$stateParams', function($stateParams) {
          this.email = $stateParams.email;
        }],
        controllerAs: 'expired'
      })
      .state('login.forgot.reset.invalid', {
        templateUrl: '/app/forgot/reset/invalid.html'
      })
      .state('login.forgot.reset.error', {
        templateUrl: '/app/forgot/reset/error.html',
        params: {
          email: null
        },
        controller: ['$stateParams', function($stateParams) {
          this.email = $stateParams.email;
        }],
        controllerAs: 'error'
      })
      .state('login.forgot.reset.success', {
        url: '/success',
        templateUrl: '/app/forgot/reset/success.html',
        params: {
          email: null
        },
        controller: ['$stateParams', function($stateParams) {
          this.email = $stateParams.email;
        }],
        controllerAs: 'success'
      })

    // ------------------------------ DASHBOARD ------------------------------
      .state('app.dashboard', {
        url: '/',
        controller: 'DashboardController as dashboard',
        templateUrl: '/app/dashboard/dashboard.html',
        data: {
          permissions: {
            only: 'DASHBOARD_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

    // ------------------------------ SCHEDULE ------------------------------
      .state('app.calendar', {
        url: '/calendar/:userId?roles',
        params: {
          date: null,
          userId: null,
          roles:null
        },
        controller: 'CalendarController as calendar',
        templateUrl: '/app/calendar/calendar.html',
        data: {
          permissions: {
            only: 'SCHEDULE_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ LIBRARY ------------------------------
      .state('app.library', {
        abstract: true,
        url: '/library',
        template: '<div ui-view class="library-view fade-onload"></div>'
      })

      .state('app.library.list', {
        url: '/?tab',
        controller: 'LibraryController as library',
        templateUrl: '/app/library/library.html',
        params: {
          tab: null
        },
        data: {
          permissions: {
            only: 'TRAINING_LIBRARY_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ USERS ------------------------------
      .state('app.users', {
        abstract: true,
        url: '/users',
        template: '<div ui-view class="roster-view fade-onload"></div>'
      })

      .state('app.users.list', {
        url: '/',
        controller: 'RosterController as roster',
        templateUrl: '/app/roster/roster.html',
        data: {
          permissions: {
            only: ['ROSTER_CLIENT_VIEW_READ', 'ROSTER_NON_CLIENT_VIEW_READ'],
            redirectTo: redirectToHome
          }
        }
      })

      // ----------- Facility Assignments / WORKOUT OF THE DAY ----------------
      .state('app.facility_assignments', {
        url: '/facility_assignments',

        controller: 'FacilityAssignmentsController as facilityAssignments',
        templateUrl: '/app/facilityAssignments/facilityAssignments.html',
        data: {
          permissions: {
            only: 'FACILITY_ASSIGNMENTS_READ',
            redirectTo: redirectToHome
          }
        }
      })

      .state('app.facility_assignment', {
        url: '/facility_assignments/:id',
        controller: 'FacilityAssignmentController as facilityAssignment',
        templateUrl: '/app/facilityAssignments/facilityAssignment/facilityAssignment.html',
        data: {
          permissions: {
            only: ['FACILITY_ASSIGNMENTS_CREATE', 'FACILITY_ASSIGNMENTS_UPDATE', 'FACILITY_ASSIGNMENTS_DELETE'],
            redirectTo: redirectToHome
          }
        },
        params: {
          title: null,
          counter: null
        }
      })

      // ----------------------------- Messaging ------------------------------
      .state('app.messaging', {
        url: '/messages',
        controller: 'MessagingController as messaging',
        templateUrl: '/app/messaging/messaging.html',
        data: {
          permissions: {
            only: 'MESSAGES_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ SETTINGS ------------------------------
      .state('app.settings', {
        url: '/settings?tab',
        controller: 'SettingsController as settingsCtrl',
        templateUrl: '/app/settings/settings.html',
        data: {
          permissions: {
            only: 'SETTINGS_VIEW_READ',
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ EXERCISES ------------------------------
      .state('app.library.exercise', {
        url: '/exercise/:id',
        controller: 'ExerciseController as exerciseCtrl',
        templateUrl: '/app/library/exercise/exercise.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ SETS ------------------------------
      .state('app.library.set', {
        url: '/set/:id',
        controller: 'CreateTrainingSetController as createSetCtrl',
        templateUrl: '/app/library/training-set/training-set.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ TRAINING PROGRAM TEMPLATES ------------------------------
      .state('app.library.training_program_template', {
        url: '/training_program_template/:id',
        controller: 'TrainingProgramTemplateController as trainingProgramCtrl',
        templateUrl: '/app/library/training-program-template/training-program-template.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ ASSIGNMENTS ------------------------------
      .state('app.assignment', {
        url: '/assignment/:id?userId&editSeries&copyFrom',
        params: {
          prevState: null,
          prevParams: null,
          userId: null,
          isMe: null,
          startDate: null,
          endDate: null,
          editSeries: null,
          copyFrom: null
        },
        controller: 'CreateAssignmentController as createCtrl',
        templateUrl: '/app/library/create-assignment/create-assignment.html',
        data: {
          permissions: {
            only: ['WORKOUT_ASSIGNMENTS_OTHER_CREATE', 'WORKOUT_ASSIGNMENTS_SELF_CREATE'],
            redirectTo: redirectToHome
          }
        }
      })

      .state('app.trainingPlan', {
        url: '/training_plan/:id?userId&editSeries&copyFrom',
        params: {
          prevState: null,
          prevParams: null,
          userId: null,
          isMe: null,
          startDate: null,
          endDate: null,
          editSeries: null,
          copyFrom: null
        },
        controller: 'CreateAssignmentWorkflowController as createWorkflowCtrl',
        templateUrl: '/app/library/assignment-workflow/create-assignment.html',
        data: {
          permissions: {
            only: ['WORKOUT_ASSIGNMENTS_OTHER_CREATE', 'WORKOUT_ASSIGNMENTS_SELF_CREATE'],
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ TASK   ------------------------------
      .state('app.task', {
        url: '/task/:id?userId,startDate,endDate,isMe',
        params: {
          prevState: null,
          prevParams: null,
          userId: null,
          isMe: null,
          startDate: null,
          endDate: null
        },
        controller: 'TaskController as taskCtrl',
        templateUrl: '/app/library/task/task.html',
        data: {
          permissions: {
            only: getPermission,
            redirectTo: redirectToHome
          }
        }
      })

      // ------------------------------ USER DETAILS ------------------------------
      .state('app.users.details', {
        url: '/:userId?tab&roles',
        params: {
          tab: null,
          prevState: null,
          prevParams: null,
          roles:null
        },
        controller: 'UserController as userCtrl',
        templateUrl: '/app/user/user.html'
      });

    // Redirect unknown routes to root
    $urlRouterProvider

      // removed when because of http://goo.gl/FD1uJb
      .otherwise('/')
      .deferIntercept();

    // =============== HELPERS =============
    function getPermission(router) {
      var subject = '',
        action = router.toParams.id ? '_UPDATE' : '_CREATE';
      switch (router.toState.name) {
      case 'app.library.set':
        subject = 'TRAINING_SETS';
        break;
      case 'app.library.exercise':
        subject = 'EXERCISES';
        break;
      case 'app.library.training_program_template':
        subject = 'WORKOUT_ASSIGNMENTS_OTHER';
        break;
      case 'app.task':
        var owner = router.toParams.isMe || router.toParams.userId === 'me' ? '_SELF' : '_OTHER'; // eslint-disable-line one-var
        subject = 'TASKS' + owner;
        break;
      default:
        return [];
      }
      return [subject + action];
    }

    function redirectToHome(unresolvedPermission, router) {
      var additionalParams = {};
      if (USER_HOME_PAGE.URL === 'login.form') {
        additionalParams = { next: encodeURIComponent(window.location.href) };
      }

      return {
        state: USER_HOME_PAGE.URL,
        params: _.extend(router.toParams, USER_HOME_PAGE.PARAMS, additionalParams)
      };
    }

    // You will probably want to use html5 mode as it gives clean urls,
    // but currently, this breaks if your <base href=""/> is anything
    // besides "/".
    //
    // https://github.com/angular/angular.js/issues/11091
    //
    // Disabled html5 mode to be consistent with how routes were during development
    $locationProvider.html5Mode(false);
  }

}());
(function() {
  'use strict';

  AppController.$inject = ['langService', '$rootScope', 'authService', 'profileService'];
  angular.module('ptCrm')
    .controller('AppController', AppController);

  function AppController(langService, $rootScope, authService, profileService) {

    var vm = this;

    vm.profile = profileService;

    langService.addLanguageKeyToUrl();

    $rootScope.$on('auth:loginRequired', function() {
      authService.logout(window.location.href);
    });
  }

}());
(function() {
  'use strict';

  angular.module('translations', [
    'pascalprecht.translate',
    'config'
  ])
    .factory('customLoader', ['$http', '$q', 'config', function($http, $q, config) {
      return function(options) {
        return $http.get(config.apiBase + '/translations/' + options.key)
          .then(function(res) {
            return res.data;
          })
          .catch(function() {
            return options.key;
          });
      };
    }])
    .config(['$translateProvider', 'configProvider', function($translateProvider, configProvider) {
      var config = configProvider.$get();

      $translateProvider.useLoader('customLoader')
        .registerAvailableLanguageKeys(config.availableLanguages, config.languageAliases)
        .fallbackLanguage(config.defaultLanguage)
        .useSanitizeValueStrategy('escaped');
    }]);

}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .service('storageService', storageService);

  function storageService() {
    var TOKEN_KEY = 'jht-token';

    return {
      getToken: getToken,
      setToken: setToken,
      removeToken: removeToken
    };

    function getToken() {
      return localStorage.getItem(TOKEN_KEY) || null;
    }

    function setToken(token) {
      localStorage.setItem(TOKEN_KEY, token);
    }

    function removeToken() {
      localStorage.removeItem(TOKEN_KEY);
    }

  }
}());
(function() {
  'use strict';

  authService.$inject = ['$http', '$state', 'config', 'storageService'];
  angular.module('ptCrm')
    .service('authService', authService);

  function authService($http, $state, config, storageService) {
    return {
      login: login,
      logout: logout,

      refreshPage: refreshPage
    };

    function login(user) {
      return $http.post(config.apiBase + '/auth_token?isCRM=true' , user).then(function(response) { //// ?????
        return response.data;
      });
    }

    function logout(next) {
      storageService.removeToken();

      if (next) {
        $state.params.next = encodeURIComponent(next);
      }

      $state.go('login.form', $state.params, { reload: false, notify: false })
        .finally(refreshPage);
    }

    function refreshPage() {
      setTimeout(function() {
        window.location.reload();
      });
    }

  }
}());
(function() {
  'use strict';

  authInterceptorService.$inject = ['$rootScope', '$q', 'storageService', 'config'];
  angular.module('ptCrm')
    .service('authInterceptorService', authInterceptorService);

  function authInterceptorService($rootScope, $q, storageService, config) {


    angular.extend(this, {
      request: request,
      responseError: responseError
    });


    function request(reqConfig) {
      var token = storageService.getToken();

      if (reqConfig.url.indexOf(config.apiBase) === 0 && token) {
        reqConfig.headers.authorization = 'Bearer ' + token;

        if (reqConfig.method === 'GET') {
          // TODO: Evaluate if this is necessary
          // disable IE ajax request caching
          reqConfig.headers['If-Modified-Since'] = 'Thu, 01 Jan 1970 00:00:00 GMT';
        }
      }

      return reqConfig;
    }

    function responseError(response) {
      switch (response.status) {
      // TODO handle 403 state too
      case 401:
        if ( !(response.data && /\/api\/v1\/users\/xid\/[0-9]+/.test(response.config.url) )) {
          $rootScope.$broadcast('auth:loginRequired', response);
        }

        return $q.reject(response);


      default:
        return $q.reject(response);
      }
    }

  }
}());
/**
 * A service that helps you handle fetching paginate lists from backend page by page
 *
 * @typedef {object} paginateConfigObject
 * @property {string} url - $http url to fetch data
 * @property {string} params - object that each $http request will be extended with
 * @property {function=} responseExtract - function for transform response list
 * @property {function=} convertFunc - function for the unit conversion
 */

(function() {
  'use strict';

  PaginateList.$inject = ['$http', '$q', '$timeout', '$rootScope'];
  angular.module('ptCrm')
    .service('PaginateList', PaginateList);

  function PaginateList($http, $q, $timeout, $rootScope) {

    function List(config) {
      config = config || {};

      this.items = [];
      this.nextPage = 1;
      this.url = config.url;
      this.defaultParams = config.params;
      this.responseExtract = config.responseExtract;
      this.convertFunc = config.convertFunc;
      this.label = config.label;

      this.isLoading = false;
      this.deferredAbortList = null;
      return this;
    }

    List.prototype._extendItems = _extendItems;
    List.prototype.extendDefaultParams = extendDefaultParams;
    List.prototype.load = load;
    List.prototype.loadClientStaff = loadClientStaff;
    List.prototype.reset = reset;

    function reset() {
      this.items.length = 0;
      this.nextPage = 1;
    }

    function _extendItems(data) {
      var vm = this;

      // keep reference to the model
      _.each(data, function(item) {
        vm.items.push(item);
      });

      return this;
    }

    /**
     * @name extendDefaultParams
     * @description
     * Use this function to set default $http params
     *
     * @param {Object} params object that each $http request will be extended with
     *
     * @returns {Object} current List object
     */
    function extendDefaultParams(params) {
      var extendedParams = _.extend({}, this.defaultParams, params);
      this.defaultParams = _validateParams(extendedParams);
      return this;
    }

    function _validateParams(params) {
      // remove empty or undefined params
      return _.pickBy(params, _.identity);
    }

    /**
     * @name load
     * @description
     * Use this function to start loading next chunk of data
     *
     * @param {Object} config The object has following properties:
     *
     * - **params** – `{Object}` – params object that $http requests will be extended with
     * - **responseExtract** – `{Function}` – function for transform response list
     *
     * @returns {promise} $http.get promise
     */
    function load(config) {
      config = _.extend({
        responseExtract: this.responseExtract,
        convertFunc: this.convertFunc
      }, config);

      var vm = this,
        params = config.params || {};

      if (config.update || !vm.items.length) {
        vm.nextPage = 1;
      }

      if (!vm.nextPage) {
        return $q.reject();
      }

      vm.isLoading = true;

      if (vm.deferredAbortList) {
        vm.deferredAbortList.resolve();
      }
      vm.deferredAbortList = $q.defer();

      return $http
        .get(vm.url, {
          params: _.extend({}, vm.defaultParams, params, {
            page: vm.nextPage
          }),

          // abort request if another request started
          timeout: vm.deferredAbortList.promise
        })
        .finally(function() {
          vm.isLoading = false;
        })
        .then(function(res) {
          // TODO: we should refactor this service such that it
          // does not perform its own http GETs, but instead is passed a getter
          // function that handles GETs.  This way, we don't have
          // to have multiple places that convert various objects, nor does this
          // class need to know anything about what it is paginating.

          var resultData = res.data.data;

          if (res.data.meta.page === 1) {
            vm.items.length = 0;
          }

          if (_.isFunction(config.convertFunc)) {
            resultData = config.convertFunc(resultData);
          }

          if (_.isFunction(config.responseExtract)) {
            resultData = config.responseExtract(resultData);
          }

          return $q.when(resultData).then(function(transformedData) {
            vm._extendItems(transformedData);
            vm.nextPage = _getNextPage(res.data.meta);

            $timeout(function() {
              $rootScope.$emit('infiniteScroll:complete');
            });

            return res.data;
          });
        });
    }
    function loadClientStaff(config) {
      config = _.extend(
        {
          responseExtract: this.responseExtract,
          convertFunc: this.convertFunc
        },
        config
      );

      var vm = this,
        promises=[],
        response = [],
        resultData={ data:[],meta:{} },
        params = config.params || {};

      if (config.update || !vm.items.length) {
        vm.nextPage = 1;
      }

      if (!vm.nextPage) {
        return $q.reject();
      }

      vm.isLoading = true;

      if (vm.deferredAbortList) {
        vm.deferredAbortList.resolve();
      }
      vm.deferredAbortList = $q.defer();

      if (vm.url && vm.url.length) {
        vm.url.forEach(function(url) {
          promises.push($http
            .get(url, {
              params: _.extend({}, vm.defaultParams, params, {
                page: vm.nextPage
              }),
              // abort request if another request started
              timeout: vm.deferredAbortList.promise
            }));
        });
      }

      return $q.all(promises).then(function(res) {
        // TODO: we should refactor this service such that it
        // does not perform its own http GETs, but instead is passed a getter
        // function that handles GETs.  This way, we don't have
        // to have multiple places that convert various objects, nor does this
        // class need to know anything about what it is paginating.

        res.forEach((val)=>{
          if (resultData.data.length === 0) {
            response = (val.data.data);
            resultData.data = (val.data.data);
            resultData.meta.totalCount = val.data.meta.totalCount;
            resultData.meta.limit = val.data.meta.limit;
            resultData.meta.page = val.data.meta.page;
          } else {
            response = [...response,...val.data.data];
            resultData.data= [...resultData.data,...val.data.data];
            resultData.meta.totalCount+= val.data.meta.totalCount;
          }
          if (val.data.meta.page === 1) {
            vm.items.length = 0;
          }
        });
        if (_.isFunction(config.convertFunc)) {
          response = config.convertFunc(response);
        }

        if (_.isFunction(config.responseExtract)) {
          response = config.responseExtract(response);
        }

        return $q.when(response).then(function(transformedData) {
          vm._extendItems(transformedData);
          vm.nextPage = _getNextPage(resultData.meta);

          $timeout(function() {
            $rootScope.$emit('infiniteScroll:complete');
          });

          return resultData;
        });
      });
    }
    function _getNextPage(meta) {
      return meta.page * meta.limit < meta.totalCount ? meta.page + 1 : null;
    }

    return List;
  }
}());
(function() {
  'use strict';

  userService.$inject = ['$http', 'config', 'urlService', '$q', 'convert', 'profileService'];
  angular.module('ptCrm')
    .service('userService', userService);

  function userService($http, config, urlService, $q, convert, profileService) {
    return {
      // getUsers: getUsers,
      getStaff:getStaff,
      // createUser: createUser,
      createStaffUser:createStaffUser,
      // updateUser: updateUser,
      updateClientUser:updateClientUser,
      updateStaffUser:updateStaffUser,
      // updateTrainerClients: updateTrainerClients,
      updateStaffTrainerClients: updateStaffTrainerClients,
      // deleteUser: deleteUser,
      deleteAccount: deleteAccount,
      changePassword: changePassword,
      getNetpulseProfile: getNetpulseProfile,
      // createClientByXid: createClientByXid,
      // assignUserToFacility: assignUserToFacility,
      assignClientUserToFacility:assignClientUserToFacility,
      assignStaffUserToFacility:assignStaffUserToFacility,
      updateCurrentUser: updateCurrentUser,
      getFullUserName: getFullUserName,
      // removeFromFacility: removeFromFacility,
      getExerciserProfile: getExerciserProfile,
      activateClientByPtApiId: activateClientByPtApiId,
      // updateUserMembershipGroups: updateUserMembershipGroups,
      // getUserMembershipGroups: getUserMembershipGroups,
      getStaffUserMembershipGroups:getStaffUserMembershipGroups,
      // deleteUserMembershipGroup: deleteUserMembershipGroup,
      getClientUserMembershipGroups:getClientUserMembershipGroups,
      deleteClientUserMembershipGroup:deleteClientUserMembershipGroup,
      deleteStaffUserMembershipGroup:deleteStaffUserMembershipGroup,
      removeStaffFromFacility:removeStaffFromFacility,
      removeClientFromFacility:removeClientFromFacility,
      deleteStaffUser:deleteStaffUser,
      deleteClientUser:deleteClientUser,
      updateClientUserMembershipGroups:updateClientUserMembershipGroups,
      updateStaffUserMembershipGroups:updateStaffUserMembershipGroups,
      getSmartHealthProfile: getSmartHealthProfile,
      loginToExerciser:loginToExerciser
    };

    function _convertBody(user) {
      if (user.clientProfile && user.clientProfile.body) {
        user.clientProfile.body = convert.bodyToExternal(user.clientProfile.body, profileService.user.settings.measurementUnit);
      }
      return user;
    }

    // function removeFromFacility(userId) {
    //   return $http.delete(urlService.interpolate(config.apiBase + '/users/{{userId}}/permission?isCRM=true', { userId: userId }))
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function getUsers(params) {
    //   return $http.get(config.apiBase + '/users?isCRM=true', { params: params })
    //     .then(function(response) {
    //       return response.data.data.map(_convertBody);
    //     });
    // }

    function updateCurrentUser(data) {
      return $http.put(config.apiBase + '/users/me?isCRM=true', data)
        .then(function(response) {
          return response.data;
        });
    }

    // function createUser(user, chainWide) {
    //   var url = config.apiBase + '/users' + (chainWide ? '?chainWide=true&isCRM=true' : '?isCRM=true');
    //   return $http.post(url, user)
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function updateUser(user, id) {
    //   if (user.clientProfile && user.clientProfile.body) {
    //     user.clientProfile.body = convert.bodyToInternal(user.clientProfile.body);
    //   }
    //   return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}?isCRM=true', { uuid: id }), user)
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function updateTrainerClients(clientsIds, id) {
    //   return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}/clients?isCRM=true', { uuid: id }), clientsIds)
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function deleteUser(uuid) {
    //   return $http.delete(urlService.interpolate(config.apiBase + '/users/{{uuid}}?isCRM=true', { uuid: uuid }))
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    function getNetpulseProfile(xID) {
      return $http.get(urlService.interpolate(config.apiBase + '/netpulse_profiles/{{xID}}?isCRM=true', { xID: xID }))
        .then(function(response) {
          return response.data;
        });
    }

    function getExerciserProfile(ptApiId) {
      var url = config.apiBase + '/exerciser/validate?isCRM=true';
      return $http.post(url, { memberId: ptApiId })
        .then(function(response) {
          return response.data;
        });
    }

    function loginToExerciser(userInfo) {
      var url = config.apiBase + '/exerciser/login?isCRM=true';
      return $http.post(url, userInfo)
        .then(function(response) {
          return response.data;
        });
    }

    function getSmartHealthProfile(ptApiId, clubId) {
      var url = config.apiBase + '/smarthealthusers?search=' +ptApiId + '&clubID=' + clubId +'&isCRM=true';
      return $http.get(url)
        .then(function(response) {
          return response.data;
        });
    }

    // function createClientByXid(xID, password) {
    //   return $http.post(urlService.interpolate(config.apiBase + '/users/xid/{{xID}}?isCRM=true', { xID: xID }), { password: password })
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    function activateClientByPtApiId(ptApiId) {
      var url = config.apiBase + '/exerciser/activate?isCRM=true';
      return $http.post(url, { memberId: ptApiId })
        .then(function(response) {
          return response.data;
        });
    }

    // function assignUserToFacility(id) {
    //   return $http.post(urlService.interpolate(config.apiBase + '/users/{{id}}/permission?isCRM=true', { id: id }))
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function updateUserMembershipGroups(facilityId, userId, membershipGroupIds, isMembershipNew) {
    //   var body = { facilityId: facilityId, membershipIds: membershipGroupIds },
    //     methodType = '';
    //   if (isMembershipNew !== undefined) {
    //     methodType = 'POST';
    //   } else {
    //     methodType = 'PUT';
    //   }
    //   return $http({
    //     method: methodType,
    //     url: config.apiBase + '/users/' + userId + '/user_membership?isCRM=true',
    //     data: JSON.stringify(body)
    //   })
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function deleteUserMembershipGroup(facilityId, userId, membershipGroupIds) {
    //   var body = { facilityId: facilityId, membershipIds: membershipGroupIds };
    //   return $http({
    //     method: 'DELETE',
    //     url: config.apiBase + '/users/' + userId + '/user_membership?isCRM=true',
    //     data: JSON.stringify(body),
    //     headers: {
    //       'Content-type': 'application/json;charset=utf-8'
    //     }
    //   })
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // function getUserMembershipGroups(facilityId, userId) {
    //   return $http.get(urlService.interpolate(config.apiBase + '/users/{{id}}/user_membership?facilityId={{facilityId}}&isCRM=true', { id: userId, facilityId: facilityId }))
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    // ======Client Users =====
    function getClientUserMembershipGroups(facilityId, userId) {
      return $http.get(urlService.interpolate(config.apiBase + '/clients/{{id}}/user_membership?facilityId={{facilityId}}&isCRM=true', { id: userId, facilityId: facilityId }))
        .then(function(response) {
          return response.data;
        });
    }

    function assignClientUserToFacility(id) {
      return $http.post(urlService.interpolate(config.apiBase + '/clients/{{id}}/permission?isCRM=true', { id: id }))
        .then(function(response) {
          return response.data;
        });
    }
    function deleteClientUser(uuid) {
      return $http.delete(urlService.interpolate(config.apiBase + '/clients/{{uuid}}?isCRM=true', { uuid: uuid }))
        .then(function(response) {
          return response.data;
        });
    }

    function updateClientUser(user, id) {
      if (user.clientProfile && user.clientProfile.body) {
        user.clientProfile.body = convert.bodyToInternal(user.clientProfile.body);
      }
      return $http.put(urlService.interpolate(config.apiBase + '/clients/{{uuid}}?isCRM=true', { uuid: id }), user)
        .then(function(response) {
          return response.data;
        });
    }

    function deleteClientUserMembershipGroup(facilityId, userId, membershipGroupIds) {
      var body = { facilityId: facilityId, membershipIds: membershipGroupIds };
      return $http({
        method: 'DELETE',
        url: config.apiBase + '/clients/' + userId + '/user_membership?isCRM=true',
        data: JSON.stringify(body),
        headers: {
          'Content-type': 'application/json;charset=utf-8'
        }
      })
        .then(function(response) {
          return response.data;
        });
    }
    function removeClientFromFacility(userId) {
      return $http.delete(urlService.interpolate(config.apiBase + '/clients/{{userId}}/permission?isCRM=true', { userId: userId }))
        .then(function(response) {
          return response.data;
        });
    }
    function updateClientUserMembershipGroups(facilityId, userId, membershipGroupIds, isMembershipNew) {
      var body = { facilityId: facilityId, membershipIds: membershipGroupIds },
        methodType = '';
      if (isMembershipNew !== undefined) {
        methodType = 'POST';
      } else {
        methodType = 'PUT';
      }
      return $http({
        method: methodType,
        url: config.apiBase + '/clients/' + userId + '/user_membership?isCRM=true',
        data: JSON.stringify(body)
      })
        .then(function(response) {
          return response.data;
        });
    }
    //  ==== Staff Users Endpoint ====
    function createStaffUser(user, chainWide) {
      var url = config.apiBase + '/staffs' + (chainWide ? '?chainWide=true&isCRM=true' : '?isCRM=true');
      return $http.post(url, user)
        .then(function(response) {
          return response.data;
        });
    }
    function updateStaffUser(user, id) {
      if (user.clientProfile && user.clientProfile.body) {
        user.clientProfile.body = convert.bodyToInternal(user.clientProfile.body);
      }
      return $http.put(urlService.interpolate(config.apiBase + '/staffs/{{uuid}}?isCRM=true', { uuid: id }), user)
        .then(function(response) {
          return response.data;
        });
    }
    function deleteStaffUser(uuid) {
      return $http.delete(urlService.interpolate(config.apiBase + '/staffs/{{uuid}}?isCRM=true', { uuid: uuid }))
        .then(function(response) {
          return response.data;
        });
    }
    function getStaffUserMembershipGroups(facilityId, userId) {
      return $http.get(urlService.interpolate(config.apiBase + '/staffs/{{id}}/user_membership?facilityId={{facilityId}}&isCRM=true', { id: userId, facilityId: facilityId }))
        .then(function(response) {
          return response.data;
        });
    }

    function getStaff(params) {
      return $http.get(config.apiBase + '/staffs?isCRM=true', { params: params })
        .then(function(response) {
          return response.data.data.map(_convertBody);
        });
    }

    function assignStaffUserToFacility(id) {
      return $http.post(urlService.interpolate(config.apiBase + '/staffs/{{id}}/permission?isCRM=true', { id: id }))
        .then(function(response) {
          return response.data;
        });
    }

    function deleteStaffUserMembershipGroup(facilityId, userId, membershipGroupIds) {
      var body = { facilityId: facilityId, membershipIds: membershipGroupIds };
      return $http({
        method: 'DELETE',
        url: config.apiBase + '/staffs/' + userId + '/user_membership?isCRM=true',
        data: JSON.stringify(body),
        headers: {
          'Content-type': 'application/json;charset=utf-8'
        }
      })
        .then(function(response) {
          return response.data;
        });
    }

    function removeStaffFromFacility(userId) {
      return $http.delete(urlService.interpolate(config.apiBase + '/staffs/{{userId}}/permission?isCRM=true', { userId: userId }))
        .then(function(response) {
          return response.data;
        });
    }

    function updateStaffUserMembershipGroups(facilityId, userId, membershipGroupIds, isMembershipNew) {
      var body = { facilityId: facilityId, membershipIds: membershipGroupIds },
        methodType = '';
      if (isMembershipNew !== undefined) {
        methodType = 'POST';
      } else {
        methodType = 'PUT';
      }
      return $http({
        method: methodType,
        url: config.apiBase + '/staffs/' + userId + '/user_membership?isCRM=true',
        data: JSON.stringify(body)
      })
        .then(function(response) {
          return response.data;
        });
    }

    function updateStaffTrainerClients(clientsIds, id) {
      return $http.put(urlService.interpolate(config.apiBase + '/staffs/{{uuid}}/clients?isCRM=true', { uuid: id }), clientsIds)
        .then(function(response) {
          return response.data;
        });
    }

    // ========= SETTINGS INFO BLOCK ===========
    // ================= MOCKUPS ==========
    // TODO @ilukianov remove this after integration with API

    function deleteAccount(id) {
      return $q.when({ id: id, success: true });
    }

    function changePassword(id, currentPassword, newPassword) {
      return $http.put(urlService.interpolate(config.apiBase + '/users/{{uuid}}?isCRM=true', { uuid: id }), {
        currentPassword: currentPassword,
        newPassword: newPassword
      });
    }

    function getFullUserName(user) {
      return _.get(user, 'firstName', '') + ' ' + _.get(user, 'lastName', '');
    }
  }
}());


(function() {

  facilityService.$inject = ['$http', 'config', 'urlService'];
  angular.module('ptCrm')
    .service('facilityService', facilityService);

  function facilityService($http, config, urlService) {
    var facilityProfile = {
      getFacility: getFacility,
      updateFacility: updateFacility,
      updateMembershipGroup: updateMembershipGroup,
      getMembershipGroup: getMembershipGroup,
      deleteMembershipGroup: deleteMembershipGroup,
      createMembershipGroup: createMembershipGroup,
      getFacilityMembershipGroups: getFacilityMembershipGroups,
      setFacilityServiceMembershipGroups: setFacilityServiceMembershipGroups,
      getMembershipGroupMembers: getMembershipGroupMembers,
      defaultNote: {},
      facilityId:''
    };

    return facilityProfile;

    function getFacility(facilityId) {
      return $http.get(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}?isCRM=true', { facilityId: facilityId }))
        .then(function(response) {
          if (response.data.defaultNote) {
            facilityProfile.facilityId=response.data._id;
            facilityProfile.defaultNote=response.data.defaultNote;
          }
          return response.data;
        });
    }

    function updateFacility(facility, facilityId) {
      return $http.put(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}?isCRM=true', { facilityId: facilityId }), facility)
        .then(function(response) {
          return response.data;
        });
    }

    function getMembershipGroup(facilityId, membershipGroupId) {
      return $http.put(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}/membership_group/{{membershipGroupId}}?isCRM=true', { facilityId: facilityId, membershipGroupId: membershipGroupId }))
        .then(function(response) {
          return response.data;
        });
    }

    function updateMembershipGroup(facilityId, membershipGroupId, newMembershipGroupName) {
      return $http.put(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}/membership_group/{{membershipGroupId}}?isCRM=true', { facilityId: facilityId, membershipGroupId: membershipGroupId }), { name: newMembershipGroupName })
        .then(function(response) {
          return response.data;
        });
    }

    function deleteMembershipGroup(facilityId, membershipGroupId) {
      return $http.delete(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}/membership_group/{{membershipGroupId}}?isCRM=true', { facilityId: facilityId, membershipGroupId: membershipGroupId }))
        .then(function(response) {
          return response.data;
        });
    }

    function createMembershipGroup(facilityId, newMembershipGroupName) {
      var body = { name: newMembershipGroupName };
      return $http({
        method: 'POST',
        url: config.apiBase + '/facilities/' + facilityId + '/membership_group?isCRM=true',
        data: JSON.stringify(body)
      })
        .then(function(response) {
          return response.data;
        });
    }

    function getFacilityMembershipGroups(facilityId) {
      return $http.get(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}/membership_group?isCRM=true', { facilityId: facilityId }))
        .then(function(response) {
          return response.data;
        });
    }

    function setFacilityServiceMembershipGroups(facilityId) {
      getFacilityMembershipGroups(facilityId)
        .then(function(response) {
          facilityProfile.membershipGroups = response;
        });
    }

    function getMembershipGroupMembers(facilityId, membershipGroupId) {
      return $http.get(urlService.interpolate(config.apiBase + '/facilities/{{facilityId}}/membership_group/{{membershipGroupId}}/members?isCRM=true', { facilityId: facilityId, membershipGroupId: membershipGroupId }))
        .then(function(response) {
          return response.data;
        });
    }
  }
}());
(function() {
  'use strict';

  workInfoService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('workInfoService', workInfoService);

  function workInfoService($http, config) {
    return {
      // getWorkInfo: getWorkInfo,
      putWorkInfo: putWorkInfo,
      getStaffWorkInfo:getStaffWorkInfo,
      getClientWorkInfo:getClientWorkInfo
    };

    // function getWorkInfo(userId) {
    //   return $http
    //     .get(config.apiBase + '/users/' + userId + '/work_info?isCRM=true')
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    function getClientWorkInfo(userId) {
      return $http
        .get(config.apiBase + '/clients/' + userId + '/work_info?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getStaffWorkInfo(userId) {
      return $http
        .get(config.apiBase + '/staffs/' + userId + '/work_info?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function putWorkInfo(userId, data) {
      return $http
        .put(config.apiBase + '/staffs/' + userId + '/work_info?isCRM=true', data)
        .then(function() {
          return getStaffWorkInfo(userId);
        });
    }
  }
}());
(function() {
  'use strict';

  langService.$inject = ['$location', '$translate', '$stateParams', 'config', 'STRINGS', 'langRegex', 'profileService'];
  angular.module('ptCrm')
    .constant('langRegex', /^[a-z]{2}([-_][A-Z]{2})?$/)
    .service('langService', langService);

  function langService($location, $translate, $stateParams, config, STRINGS, langRegex, profileService) {

    return {
      setAppLanguage: setAppLanguage,
      addLanguageKeyToUrl: addLanguageKeyToUrl
    };

    function normalizeLanguageKey(lang) {
      var normLang = $translate.negotiateLocale(lang) || config.defaultLanguage;
      normLang = normLang.split('-');

      if (normLang.length > 1) {
        normLang = normLang[0].toLowerCase() + '-' + normLang[1].toUpperCase();
      } else {
        normLang = normLang[0].toLowerCase();
      }

      return normLang;
    }

    function setAppLanguage() {
      var lang = (profileService.user.settings && profileService.user.settings.language) || $stateParams.lang || $translate.resolveClientLocale();
      $translate.preferredLanguage(normalizeLanguageKey(lang));

      return $translate.use($translate.preferredLanguage())
        .then(function() {
          moment.locale($translate.use());
        })
        .catch(function() {
          // assumed, that default language will be always available
          return $translate.use($translate.fallbackLanguage());
        });
    }


    function addLanguageKeyToUrl() {
      var path,
        newpath;

      // to prevent possible infinite looop
      if (!$translate.preferredLanguage()) {
        return;
      }

      // add language to url
      if (!langRegex.test($stateParams.lang)) {
        $location.path('/' + $translate.preferredLanguage() + $location.path());
      } else if ($translate.preferredLanguage() !== $stateParams.lang) {
        path = $location.path();
        newpath = '/' + path.split('/').splice(2).join('/');
        newpath += (newpath.length > 1 && path[path.length - 1] === '/' ? '/' : '');

        $location.path('/' + $translate.preferredLanguage() + newpath);
      }
    }
  }
}());
(function() {
  'use strict';

  permissionsService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('permissionsService', permissionsService);

  function permissionsService($http, config) {
    return {
      // getUserPermissions: getUserPermissions,
      // saveUserPermissions: saveUserPermissions,
      saveStaffUserPermissions: saveStaffUserPermissions,
      saveClientUserPermissions: saveClientUserPermissions,
      getPermissionSubjects: getPermissionSubjects,
      getMyCompiledPermission: getMyCompiledPermission,
      getMyPermissions: getMyPermissions,
      getMasterPermissions: getMasterPermissions,
      getStaffUserPermissions: getStaffUserPermissions,
      getClientUserPermissions: getClientUserPermissions
    };

    function getPermissionSubjects() {
      return $http
        .get(config.apiBase + '/permission_subjects?isCRM=true', {
          cache: true
        })
        .then(function(response) {
          return response.data;
        });
    }

    // function getUserPermissions(userId) {
    //   return $http.get(config.apiBase + '/users/' + userId + '/permission?isCRM=true')
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }

    function getStaffUserPermissions(userId) {
      return $http
        .get(config.apiBase + '/staffs/' + userId + '/permission?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getClientUserPermissions(userId) {
      return $http
        .get(config.apiBase + '/clients/' + userId + '/permission?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    // function saveUserPermissions(userId, data) {
    //   var groupsIds = _.map(data.groups, '_id');
    //   data.groups = _.compact(groupsIds);
    //   // api doesn't want .roles included
    //   delete data.roles;
    //   return $http.put(config.apiBase + '/users/' + userId + '/permission?isCRM=true', data)
    //     .then(function(response) {
    //       return response.data;
    //     });
    // }
    function saveStaffUserPermissions(userId, data) {
      var groupsIds = _.map(data.groups, '_id');
      data.groups = _.compact(groupsIds);
      // api doesn't want .roles included
      delete data.roles;
      return $http
        .put(
          config.apiBase + '/staffs/' + userId + '/permission?isCRM=true',
          data
        )
        .then(function(response) {
          return response.data;
        });
    }
    function saveClientUserPermissions(userId, data) {
      var groupsIds = _.map(data.groups, '_id');
      data.groups = _.compact(groupsIds);
      // api doesn't want .roles included
      delete data.roles;
      return $http
        .put(
          config.apiBase + '/clients/' + userId + '/permission?isCRM=true',
          data
        )
        .then(function(response) {
          return response.data;
        });
    }

    function getMyCompiledPermission() {
      return $http
        .get(config.apiBase + '/staffs/me/compiled_permission?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getMyPermissions() {
      return $http
        .get(config.apiBase + '/staffs/me/permission?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getMasterPermissions() {
      return $http
        .get(config.apiBase + '/permissions/master?isCRM=true')
        .then(function(response) {
          if (response && response.data && response.data.subjects) {
            const keysToRemove = ['STAFFS_ADMIN', 'CLIENTS_ADMIN'],
              filteredArray = response.data.subjects.filter(
                (item) => !keysToRemove.includes(item.name)
              );
            response.data.subjects = filteredArray;
          }
          return response.data;
        });
    }
  }
}());
(function() {
  'use strict';

  CertificationsList.$inject = ['$state', '$http', 'config', '$q', '$translate', 'PaginateList', 'popup', 'Upload'];
  angular.module('ptCrm')
    .service('CertificationsList', CertificationsList);

  function CertificationsList($state,$http, config, $q, $translate, PaginateList, popup, Upload) {


    function List(userId) {
      this.forms = {};
      this.items = [];

      this._isLoading = false;
      if ($state.params.roles === 'client' || ($state.params.tab === 'assignments') && $state.params.userId!=='me') {
        this._apiPrefix = config.apiBase + '/clients/' + userId + '/certificates';
      } else {
        this._apiPrefix = config.apiBase + '/staffs/' + userId + '/certificates';
      }
      return this;
    }

    List.prototype.load = load;
    List.prototype.add = addEmpty;
    List.prototype.addCertification = addCertification;
    List.prototype.deleteCertification = deleteCertification;
    List.prototype.copy = copy;
    List.prototype.update = update;
    List.prototype.remove = remove;
    List.prototype.saveAll = saveAll;
    List.prototype.revertAll = revertAll;

    return List;

    function addCertification(item) {
      return Upload.upload({
        url: this._apiPrefix + '?isCRM=true',
        data: item.data
      }).then(function(response) {
        item.data = response.data;
      });
    }

    function deleteCertification(id) {
      var vm = this;

      return $http.delete(vm._apiPrefix + '/' + id + '?isCRM=true').then(function() {
        vm.items = _.reject(vm.items, function(item) {
          return item.data._id === id;
        });
      });
    }

    function load() {
      var vm = this;

      return $http.get(vm._apiPrefix + '?isCRM=true')
        .then(function(response) {
          vm.items = _.map(response.data, function(certification) {
            return { data: certification };
          });

          return vm.items;
        });
    }

    function addEmpty() {
      return this.items.push({
        _virtualId: _.uniqueId('virtual_'),
        data: {}
      });
    }

    function copy(item) {
      var index = _.findIndex(this.items, item);

      return this.items.splice(index + 1, 0, {
        _virtualId: _.uniqueId('virtual_'),
        data: _.omit(_.clone(item.data), '_id')
      });
    }

    function update(item) {

      Upload.upload({
        method: 'PUT',
        url: this._apiPrefix + '/' + item._id + '?isCRM=true',
        data: item
      });
    }

    function remove(item) {
      var vm = this;

      return popup.confirm({
        okText: $translate.instant('DELETE_CERTIFICATION'),
        description: $translate.instant('CONFIRM_DELETE_CERTIFICATION')
      })
        .then(function() {
          if (item.data._id) {
            item._isDeleted = true;
            saveAll();
          } else if (item._virtualId) {
            vm.items = _.reject(vm.items, { _virtualId: item._virtualId });
          }
        });
    }

    function saveAll() {
      var vm = this;

      _.forEach(vm.forms, function(form) {
        if (form) {
          form.$setSubmitted(true);
        }
      });

      vm._isLoading = true;
      var aggregationRequests = _.chain(vm.items)
        .filter(function(item) {
          var itemForm = vm.forms[item.data._id || item._virtualId];

          if (item.data._id) {
            return item._isDeleted || (itemForm.$dirty && itemForm.$valid);
          } else {
            return itemForm.$valid;
          }
        })
        .map(function(item) {
          if (item._isDeleted) {
            return vm.deleteCertification(item.data._id);
          } else if (item.data._id) {
            return vm.update(item.data);
          } else if (item._virtualId) {
            return vm.addCertification(item);
          }
        })
        .value();

      $q.all(aggregationRequests).finally(function() {
        vm._isLoading = false;
      });
    }

    function revertAll() {
      return this.load();
    }
  }
}());
(function() {
  'use strict';

  profileService.$inject = ['$rootScope', '$q', 'PermissionStore', 'RoleStore', 'permissionsService', '$http', 'config', 'convert', 'storageService', 'facilityService', 'USER_HOME_PAGE', 'PAGES_PRIORITIES'];
  angular.module('ptCrm')
    .service('profileService', profileService);

  function profileService($rootScope, $q, PermissionStore, RoleStore, permissionsService, $http,
    config, convert, storageService, facilityService, USER_HOME_PAGE, PAGES_PRIORITIES) {

    var profile = {
      user: {},
      permissionNames: [],

      update: updateProfile,
      authorize: authorize
    };

    return profile;

    function updateProfile() {
      if (!storageService.getToken()) {
        return $q.when(profile);
      }

      return $q.all({
        compiledPermissions: permissionsService.getMyCompiledPermission(),
        details: $http.get(config.apiBase + '/users/me?isCRM=true' )
          .then(function(response) {
            var user = response.data;
            if (user.clientProfile && user.clientProfile.body) {
              user.clientProfile.body = convert.bodyToExternal(user.clientProfile.body, user.settings.measurementUnit);
            }
            return user;
          })
      }).then(function(data) {
        profile.user = data.details;
        profile.permissionNames = transformPermissionsToList(data.compiledPermissions);

        return facilityService.getFacility(profile.user.activeFacility);
      }).then(function(facility) {
        profile.user.activeFacility = facility;

        profile.betaFeatures = config.env === 'beta' || !!facility.betaFeatures;

        if (profile.user.activeFacility.messaging) {
          // TODO - Remove after permissions are implemented for messaging endpoints
          profile.permissionNames.push('MESSAGES_READ');
        }
        facilityService.setFacilityServiceMembershipGroups(facility._id);
        return $http.get(config.apiBase + '/staffs/' + profile.user._id + '/user_membership?facilityId=' + facility._id + '&isCRM=true')
          .then(function(response) {
            return response.data;
          });
      }).then(function(response) {
        if (response && response.length) {
          profile.user.membershipGroups = response[0].memberships.length ?
            response[0].memberships[0].membershipGroups : [];
        }
        return profile;
      });
    }

    function authorize() {
      return updateProfile().then(function(profile) {
        $rootScope.user = profile.user;

        PermissionStore.defineManyPermissions(profile.permissionNames, function(name) {
          return _.includes(profile.permissionNames, name);
        });

        var homePage = defineUserHomePage(PAGES_PRIORITIES, profile.permissionNames);
        USER_HOME_PAGE.URL = homePage.URL;
        USER_HOME_PAGE.PARAMS = homePage.PARAMS;

        defineAdditionalsRoles();
        return profile;
      });
    }

    // ================ HELPERS ==============
    function defineUserHomePage(pages, permissions) {
      var page = _.find(pages, function(page) {
        return _.includes(permissions, page.permission);
      });
      return page || USER_HOME_PAGE;
    }

    function defineAdditionalsRoles() {
      RoleStore.defineRole('EXERCISES_READ+TRAINING_SETS_READ',
        ['EXERCISES_READ', 'TRAINING_SETS_READ']);

      RoleStore.defineRole('CHAIN_WIDE_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['CHAIN_WIDE_UPDATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('CHAIN_WIDE_CREATE+RESTRICTED_FLAG_UPDATE',
        ['CHAIN_WIDE_CREATE', 'RESTRICTED_FLAG_UPDATE']);

      RoleStore.defineRole('EXERCISES_CREATE+RESTRICTED_FLAG_UPDATE',
        ['EXERCISES_CREATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('EXERCISES_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['EXERCISES_UPDATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('EXERCISES_DELETE+RESTRICTED_FLAG_DELETE',
        ['EXERCISES_DELETE', 'RESTRICTED_FLAG_DELETE']);

      RoleStore.defineRole('TRAINING_SETS_CREATE+RESTRICTED_FLAG_UPDATE',
        ['TRAINING_SETS_CREATE', 'RESTRICTED_FLAG_UPDATE']);
      RoleStore.defineRole('TRAINING_SETS_UPDATE+RESTRICTED_FLAG_UPDATE',
        ['TRAINING_SETS_UPDATE', 'RESTRICTED_FLAG_UPDATE']);

      RoleStore.defineRole('TRAINING_SETS_DELETE+RESTRICTED_FLAG_DELETE+CHAIN_WIDE_DELETE',
        ['TRAINING_SETS_DELETE', 'RESTRICTED_FLAG_DELETE', 'CHAIN_WIDE_DELETE']);
      RoleStore.defineRole('TRAINING_SETS_DELETE+RESTRICTED_FLAG_DELETE',
        ['TRAINING_SETS_DELETE', 'RESTRICTED_FLAG_DELETE']);
      RoleStore.defineRole('TRAINING_SETS_DELETE+CHAIN_WIDE_DELETE',
        ['TRAINING_SETS_DELETE', 'CHAIN_WIDE_DELETE']);

      RoleStore.defineRole('TRAINING_SETS_UPDATE+CHAIN_WIDE_UPDATE',
        ['TRAINING_SETS_UPDATE', 'CHAIN_WIDE_UPDATE']);
      RoleStore.defineRole('TRAINING_SETS_UPDATE+RESTRICTED_FLAG_UPDATE+CHAIN_WIDE_UPDATE',
        ['TRAINING_SETS_UPDATE', 'RESTRICTED_FLAG_UPDATE', 'CHAIN_WIDE_UPDATE']);

      RoleStore.defineRole('EXERCISES_UPDATE+CHAIN_WIDE_UPDATE',
        ['EXERCISES_UPDATE', 'CHAIN_WIDE_UPDATE']);
      RoleStore.defineRole('EXERCISES_UPDATE+RESTRICTED_FLAG_UPDATE+CHAIN_WIDE_UPDATE',
        ['EXERCISES_UPDATE', 'RESTRICTED_FLAG_UPDATE', 'CHAIN_WIDE_UPDATE']);
    }

    function transformPermissionsToList(permissions) {
      return _.chain(permissions)
        .map(function(permission) {
          return _.chain(permission.options)
            .pickBy(_.identity)
            .map(function(value, optionName) {
              return permission.name + '_' + optionName;
            }).value();
        })
        .flatten()
        .value();
    }
  }
}());
/* eslint-disable one-var */
(function() {
  'use strict';
  angular.module('ptCrm')
    .service('formatUserService', formatUserService);

  function formatUserService() {
    return {
      restructureUser: restructureUser,
      destructureUser: destructureUser,
      _unixToDate: _unixToDate,
      _dateToUnix: _dateToUnix
    };

    function destructureUser(user) {
      user.clientProfile = user.clientProfile || {};
      var destructuredUser = {
        _id: user._id,
        npXid: user.npXid,
        smartHealthId: user.smartHealthId,
        upaceId:user.upaceId,
        firstName: user.firstName,
        lastName: user.lastName,
        pictureUrl: user.pictureUrl,
        roles: _.invert(_.mapValues(user.roles)),
        admin: user.admin,
        isDemoUser: user.isDemoUser,
        interested: user.clientProfile.interested,
        active: user.clientProfile.active,
        stats: {
          birthday: _unixToDate(user.clientProfile.birthday),
          gender: user.clientProfile.gender,
          body: user.clientProfile.body
        },

        personalInfo: {
          address1: user.address1,
          address2: user.address2,
          phoneNumber1: user.phoneNumber1,
          phoneNumber2: user.phoneNumber2,
          email: user.email,
          club: user.club,
          isDemoUser: user.isDemoUser,
          planDetails: {
            lastWorkoutDate: _unixToDate(user.clientProfile.lastWorkoutDate),
            lastConsoleSignInDate: _unixToDate(user.clientProfile.lastConsoleSignInDate),
            nextAssignmentDate: _unixToDate(user.clientProfile.nextAssignmentDate)
          }
        },
        trainers: user.clientProfile.trainers || [],
        settings: user.settings || {}
      };
      if (user.clients) {
        destructuredUser.clients = user.clients || [];
      }

      if (!user.roles.client && user.facilities) {
        var activeFacility = _.find(user.facilities, { _id: user.activeFacility });
        destructuredUser.personalInfo.club.name = activeFacility && activeFacility.name;
      }

      return destructuredUser;
    }

    function restructureUser(subj, data) {
      var exclude = new Set(['smartHealthEnabled', 'clubId']);
      switch (subj) {
      default:
        break;
      case 'stats':
        return {
          clientProfile: {
            birthday: data.birthday && moment(data.birthday).unix(),
            gender: data.gender,
            body: data.body
          }
        };
      case 'personalInfo':
        var user = {
          address1: data.address1,
          address2: data.address2,
          phoneNumber1: data.phoneNumber1,
          phoneNumber2: data.phoneNumber2,
          email: data.email,
          club: Object.fromEntries(Object.entries(data.club).filter(e => !exclude.has(e[0]))),
          isDemoUser: data.isDemoUser
          // this fields not editable for now
          // lastWorkoutDate: moment(data.planDetails.lastWorkoutDate).valueOf(),
          // lastConsoleSignInDate: moment(data.planDetails.lastConsoleSignInDate).valueOf(),
          // nextAssignmentDate: moment(data.planDetails.nextAssignmentDate).valueOf(),
        };
        return user;
      case 'trainers':
        return {
          clientProfile: {
            trainers: _.map(data, '_id')
          }
        };
      case 'settings':
        return {
          settings: data
        };
      }
    }

    function _unixToDate(unixTimeStamp) {
      return _.isNumber(unixTimeStamp) ?
        moment.unix(unixTimeStamp).toDate() :
        unixTimeStamp;
    }

    function _dateToUnix(dateObject) {
      return dateObject && moment(dateObject).unix();
    }


  }
}());
(function() {
  'use strict';

  trainingSetService.$inject = ['$http', '$q', 'config', 'PaginateList', 'Upload', 'profileService', 'convert', 'metricsService'];
  angular.module('ptCrm')
    .service('trainingSetService', trainingSetService);

  function trainingSetService($http, $q, config, PaginateList, Upload, profileService, convert, metricsService) {

    return {
      getTrainingSetsPaginateList: getTrainingSetsPaginateList,
      getTrainingSet: getTrainingSet,
      createTrainingSet: createTrainingSet,
      deleteTrainingSet: deleteTrainingSet,
      editTrainingSet: editTrainingSet
    };

    function _convertExercisesExternal(exercises) {
      return exercises.map(function(exercise) {
        exercise.preset = metricsService.getPresetForExercise(exercise);
        return convert.exerciseToExternal(exercise, profileService.user.settings.measurementUnit);
      });
    }

    function _convertExercisesInternal(exercises) {
      return exercises.map(function(exercise) {
        return convert.exerciseToInternal(exercise);
      });
    }

    function getTrainingSetsPaginateList(params) {
      return new PaginateList({
        url: config.apiBase + '/training_sets?isCRM=true',
        params: _.extend({ limit: 10, preset: false }, params),
        convertFunc: function(responseData) {
          responseData.forEach(function(trainingSet) {
            if (trainingSet.exercises) {
              trainingSet.exercises = _convertExercisesExternal(trainingSet.exercises);
            }
          });

          return responseData;
        }
      });
    }

    function createTrainingSet(data) {
      // strip out the $$hashKey values
      var strippedData = JSON.parse(angular.toJson(data));

      // add the picture back
      strippedData.picture = data.picture;

      strippedData.exercises = _convertExercisesInternal(strippedData.exercises);
      strippedData.exercises = convert.removeExercisePreset(strippedData.exercises);

      return $http.post(config.apiBase + '/training_sets?isCRM=true', strippedData);
    }

    function editTrainingSet(data) {
      // strip out the $$hashKey values
      var strippedData = JSON.parse(angular.toJson(data));

      strippedData.exercises = _convertExercisesInternal(strippedData.exercises);
      strippedData.exercises = convert.removeExercisePreset(strippedData.exercises);

      return $http.put(config.apiBase + '/training_sets/' + data._id + '?isCRM=true', strippedData);
    }

    function deleteTrainingSet(id) {
      return $http.delete(config.apiBase + '/training_sets/' + id + '?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getTrainingSet(id) {
      return $http.get(config.apiBase + '/training_sets/' + id + '?isCRM=true', {
        params: {
          preset: false
        }
      })
        .then(function(response) {
          response.data.exercises = _convertExercisesExternal(response.data.exercises);
          return response.data;
        });
    }

  }
}());

trainingPlanService.$inject = ['$http', 'config', 'profileService', 'convert', 'PaginateList', 'metricsService'];angular.module('ptCrm')
  .service('trainingPlanService', trainingPlanService);

function trainingPlanService($http, config, profileService, convert, PaginateList, metricsService) {

  return {
    createTrainingPlan: createTrainingPlan,
    getTrainingPlanById: getTrainingPlanById,
    updateTrainingPlanById: updateTrainingPlanById,
    deleteTrainingPlanById: deleteTrainingPlanById,
    getClientTrainingPlansPaginateList: getClientTrainingPlansPaginateList
  };

  function _convertSavedPlanToExternal(plan) {
    plan.workouts.forEach(function(workout) {
      workout.exercises = workout.exercises.map(function(exercise) {
        exercise.preset = metricsService.getPresetForExercise(exercise);
        return convert.exerciseToExternal(_prepareExercise(exercise), profileService.user.settings.measurementUnit);
      });
    });
    return plan;
  }

  function _convertSavedPlanToInternal(plan) {
    plan.workouts.forEach(function(workout) {
      workout.exercises = workout.exercises.map(function(exercise) {
        return convert.exerciseToInternal(_prepareExercise(exercise));
      });
    });
    return plan;
  }

  function _convertExpandedPlanToExternal(plan) {
    plan.workouts.forEach(function(workout) {
      workout.exercises = workout.exercises.map(function(exercise) {
        exercise.preset = metricsService.getPresetForExercise(exercise);
        return convert.exerciseToExternal(exercise, profileService.user.settings.measurementUnit);
      });
    });
    plan.weeks.forEach(function(week) {
      week.forEach(function(workout) {
        workout.exercises = workout.exercises.map(function(exercise) {
          exercise.preset = metricsService.getPresetForExercise(exercise);
          return convert.exerciseToExternal(exercise, profileService.user.settings.measurementUnit);
        });
      });
    });
    return plan;
  }

  function _prepareExercise(exercise) {
    exercise.exerciseTemplateId = exercise.exerciseTemplateId || exercise._id;
    return _.omit(exercise, [
      'restricted',
      'facility',
      'totalDuration',
      'completedManually',
      'pictureUrl',
      'id',
      '_id',
      'isEditable',
      'featured'
    ]);
  }

  function createTrainingPlan(data) {
    // strip out the $$hashKey values
    var strippedData = JSON.parse(angular.toJson(data));

    strippedData = _convertSavedPlanToInternal(strippedData);

    strippedData.workouts.forEach(function(workout) {
      workout.exercises = convert.removeExercisePreset(workout.exercises);
    });

    return $http.post(config.apiBase + '/training_plans?isCRM=true', strippedData)
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }

  function getTrainingPlanById(id) {
    return $http.get(config.apiBase + '/training_plans/' + id + '?isCRM=true', {
      params: {
        preset: false
      }
    })
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }

  function updateTrainingPlanById(id, data) {
    // strip out the $$hashKey values
    var strippedData = JSON.parse(angular.toJson(data));

    strippedData = _convertSavedPlanToInternal(strippedData);
    strippedData.workouts.forEach(function(workout) {
      workout.exercises = convert.removeExercisePreset(workout.exercises);
    });

    return $http.put(config.apiBase + '/training_plans/' + id +'?isCRM=true', strippedData)
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }

  function deleteTrainingPlanById(id, cancel, userId) {
    var query = '?cancel=' + cancel;

    if (userId) {
      query += '&user=' + userId;
    }
    return $http.delete(config.apiBase + '/training_plans/' + id + query + '&isCRM=true');
  }

  function getClientTrainingPlansPaginateList(userId) {
    return new PaginateList({
      url: config.apiBase + '/clients/' + userId + '/training_plans?isCRM=true',
      params: { limit: 100, preset: false },
      convertFunc: function(responseData) {
        var results = responseData.map(function(plan) {
          return _convertExpandedPlanToExternal(plan);
        });
        return results;
      }
    });
  }
}

savedTrainingPlanService.$inject = ['$http', '$q', 'config', 'PaginateList', 'profileService', 'convert', 'metricsService'];angular.module('ptCrm')
  .service('savedTrainingPlanService', savedTrainingPlanService);

function savedTrainingPlanService($http, $q, config, PaginateList, profileService, convert, metricsService) {

  return {
    getTrainingPlansPaginateList: getTrainingPlansPaginateList,
    getTrainingPlan: getTrainingPlan,
    createTrainingPlan: createTrainingPlan,
    deleteTrainingPlan: deleteTrainingPlan,
    editTrainingPlan: editTrainingPlan
  };

  function _convertSavedPlanToExternal(plan) {
    plan.workouts.forEach(function(workout) {
      workout.exercises = workout.exercises.map(function(exercise) {
        exercise.preset = metricsService.getPresetForExercise(exercise);
        return convert.exerciseToExternal(_prepareExercise(exercise), profileService.user.settings.measurementUnit);
      });
    });
    return plan;
  }

  function _convertSavedPlanToInternal(plan) {
    plan.workouts.forEach(function(workout) {
      workout.exercises = workout.exercises.map(function(exercise) {
        return convert.exerciseToInternal(_prepareExercise(exercise));
      });
    });
    return plan;
  }

  function _prepareExercise(exercise) {
    exercise.exerciseTemplateId = exercise.exerciseTemplateId || exercise._id;
    return _.omit(exercise, [
      'restricted',
      'facility',
      'totalDuration',
      'completedManually',
      'pictureUrl',
      'id',
      '_id',
      'isEditable',
      'featured'
    ]);
  }

  function getTrainingPlansPaginateList(params) {
    return new PaginateList({
      url: config.apiBase + '/saved_training_plans?isCRM=true',
      params: _.extend({ limit: 100, preset: false }, params),
      responseExtract: function(responseData) {
        return responseData.map(function(trainingPlan) {
          return _convertSavedPlanToExternal(trainingPlan);
        });
      }
    });
  }

  function createTrainingPlan(data) {
    // strip out the $$hashKey values
    var strippedData = JSON.parse(angular.toJson(data));

    strippedData = _convertSavedPlanToInternal(strippedData);
    strippedData.workouts.forEach(function(workout) {
      workout.exercises = convert.removeExercisePreset(workout.exercises);
    });

    return $http.post(config.apiBase + '/saved_training_plans?isCRM=true', strippedData)
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }

  function editTrainingPlan(data, planId) {
    // strip out the $$hashKey values
    var strippedData = JSON.parse(angular.toJson(data));

    strippedData = _convertSavedPlanToInternal(strippedData);
    strippedData.workouts.forEach(function(workout) {
      workout.exercises = convert.removeExercisePreset(workout.exercises);
    });

    return $http.put(config.apiBase + '/saved_training_plans/' + planId + '?isCRM=true', strippedData)
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }

  function deleteTrainingPlan(id) {
    return $http.delete(config.apiBase + '/saved_training_plans/' + id + '?isCRM=true')
      .then(function(response) {
        return response.data;
      });
  }

  function getTrainingPlan(id) {
    return $http.get(config.apiBase + '/saved_training_plans/' + id + '?isCRM=true', {
      params: {
        preset: false
      }
    })
      .then(function(response) {
        return _convertSavedPlanToExternal(response.data);
      });
  }
}
(function() {
  'use strict';

  riskService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('riskService', riskService);

  function riskService($http, config) {
    return {
      getRisks: getRisks,
      updateRisks: updateRisks
    };

    function getRisks() {
      return $http.get(config.apiBase + '/risks?isCRM=true').then(function(response) {
        return response.data;
      });
    }

    function updateRisks(risks) {
      return $http.put(config.apiBase + '/risks?isCRM=true', risks).then(function(response) {
        return response.data;
      });
    }

  }
}());
(function() {
  'use strict';

  urlService.$inject = ['$interpolate'];
  angular.module('ptCrm')
    .service('urlService', urlService);

  function urlService($interpolate) {

    return {
      interpolate: interpolate
    };

    function interpolate(url, params) {
      if (!params) {
        return;
      }

      return $interpolate(url, false, null, true)(params);
    }
  }
}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .service('userPermissionsService', userPermissionsService);

  function userPermissionsService() {
    return {
      getUserStaticPermissions: getUserStaticPermissions,
      getUserDynamicPermissions: getUserDynamicPermissions
    };
    function getUserStaticPermissions(isMe) {

      return {
        task: {
          create: isMe ? 'TASKS_SELF_CREATE' : 'TASKS_OTHER_CREATE'
        },
        workout: {
          create: isMe ? 'WORKOUT_ASSIGNMENTS_SELF_CREATE' : 'WORKOUT_ASSIGNMENTS_OTHER_CREATE'
        },
        stats: {
          read: isMe ? 'CLIENT_FITNESS_DETAILS_SELF_READ' : 'CLIENT_FITNESS_DETAILS_OTHER_READ',
          update: isMe ? 'CLIENT_FITNESS_DETAILS_SELF_UPDATE' : 'CLIENT_FITNESS_DETAILS_OTHER_UPDATE'
        },
        trainers: {
          create: isMe ? 'CLIENT_TRAINER_SELF_CREATE' : 'CLIENT_TRAINER_OTHER_CREATE',
          read: isMe ? 'CLIENT_TRAINER_SELF_READ' : 'CLIENT_TRAINER_OTHER_READ',
          update: isMe ? 'CLIENT_TRAINER_SELF_UPDATE' : 'CLIENT_TRAINER_OTHER_UPDATE',
          delete: isMe ? 'CLIENT_TRAINER_SELF_DELETE' : 'CLIENT_TRAINER_OTHER_DELETE'
        },
        certifications: {
          create: isMe ? 'TRAINER_CERTIFICATIONS_SELF_CREATE' : 'TRAINER_CERTIFICATIONS_OTHER_CREATE',
          read: isMe ? 'TRAINER_CERTIFICATIONS_SELF_READ' : 'TRAINER_CERTIFICATIONS_OTHER_READ',
          update: isMe ? 'TRAINER_CERTIFICATIONS_SELF_UPDATE' : 'TRAINER_CERTIFICATIONS_OTHER_UPDATE',
          delete: isMe ? 'TRAINER_CERTIFICATIONS_SELF_DELETE' : 'TRAINER_CERTIFICATIONS_OTHER_DELETE'
        },
        clients: {
          create: isMe ? 'TRAINER_CLIENTS_SELF_CREATE' : 'TRAINER_CLIENTS_OTHER_CREATE',
          read: isMe ? 'TRAINER_CLIENTS_SELF_READ' : 'TRAINER_CLIENTS_OTHER_READ',
          update: isMe ? 'TRAINER_CLIENTS_SELF_UPDATE' : 'TRAINER_CLIENTS_OTHER_UPDATE',
          delete: isMe ? 'TRAINER_CLIENTS_SELF_DELETE' : 'TRAINER_CLIENTS_OTHER_DELETE'
        },
        settings: {
          read: isMe ? 'USER_SETTINGS_SELF_READ' : 'USER_SETTINGS_OTHER_READ',
          update: isMe ? 'USER_SETTINGS_SELF_UPDATE' : 'USER_SETTINGS_OTHER_UPDATE'
        },
        assignments: {
          read: isMe ? 'WORKOUT_HISTORY_SELF_READ' : 'WORKOUT_HISTORY_OTHER_READ',
          update: isMe ? 'WORKOUT_HISTORY_SELF_UPDATE' : 'WORKOUT_HISTORY_OTHER_UPDATE'
        },
        nutrition: {
          read: isMe ? 'NUTRITION_SELF_READ' : 'NUTRITION_OTHER_READ',
          update: isMe ? 'NUTRITION_SELF_UPDATE' : 'NUTRITION_OTHER_UPDATE'
        },
        reminder: {
          create: 'REMINDER_CREATE'
        }
      };
    }

    function getUserDynamicPermissions(isMe, isClient) {

      /* eslint-disable no-nested-ternary */
      return {
        personalDetails: {
          read: isMe ? (isClient ? 'CLIENT_PERSONAL_DETAILS_SELF_READ' : 'STAFF_PERSONAL_DETAILS_SELF_READ') :
            (isClient ? 'CLIENT_PERSONAL_DETAILS_OTHER_READ' : 'STAFF_PERSONAL_DETAILS_OTHER_READ'),
          update: isMe ? (isClient ? 'CLIENT_PERSONAL_DETAILS_SELF_UPDATE' : 'STAFF_PERSONAL_DETAILS_SELF_UPDATE') :
            (isClient ? 'CLIENT_PERSONAL_DETAILS_OTHER_UPDATE' : 'STAFF_PERSONAL_DETAILS_OTHER_UPDATE')
        },
        resetPassword: {
          update: isMe ? 'CLIENT_PERSONAL_DETAILS_SELF_UPDATE' :
            (isClient ? 'CLIENT_PASSWORD_OTHER_UPDATE' : 'STAFF_PASSWORD_OTHER_UPDATE')
        }
      };

      /* eslint-enable */
    }


  }
}());
(function() {
  'use strict';

  exercisersService.$inject = ['$http', '$filter', 'config', 'PaginateList', 'profileService', 'convert', '$translate', 'exerciseMetaData'];
  angular.module('ptCrm')
    .service('exercisersService', exercisersService);

  function exercisersService($http, $filter, config, PaginateList,profileService, convert, $translate, exerciseMetaData) {
    return {
      getExerciser: getExerciser,
      getTrainers: getTrainers,
      // getExercisers: getExercisers,
      getStaffExercisers: getStaffExercisers,
      getCSExercisers:getCSExercisers,
      getStaffExerciser:getStaffExerciser,
      getClientExerciser:getClientExerciser,
      getNotClients: getNotClients,
      // getPaginateList:getPaginateList,
      parseExercise: parseExercise,
      getClientStaffPaginateList: getClientStaffPaginateList,
      getStaffPaginateList:getStaffPaginateList,
      getClientPaginateList:getClientPaginateList
    };

    // Round the metric to display properly
    function roundMetric(metric, key) {
      var precision;

      switch (key) {
      case 'duration':
        precision = 0;
        break;
      case 'startingIncline':
        // Check if incline is a whole number
        if ((metric % 1) === 0) {
          precision = 0;
        } else {
          precision = 1;
        }
        break;
      case 'startingSpeed':
        precision = 1;
        break;
      default:
        precision = 2;
        break;
      }

      return metric.toFixed(precision);
    }

    function parseExercise(exercise) {
      var presetMetrics = {},
        result = {
          metrics: {},
          assignedData: {},
          completedData: {}
        },
        exerciseType = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular).classifyExercise;

      if (exercise.preset) {
        exercise.preset.metrics.forEach(function(metric) {
          presetMetrics[metric.name] = {
            unit: metric.unit,
            math: metric.math
          };
        });
      }

      if (exercise.assignedProfile && exercise.assignedProfile.global) {
        Object.keys(exercise.assignedProfile.global).forEach(function(key) {

          if (exerciseType(exercise) === 'non-connected-exercise' && exercise.assignedProfile.global[key] === 0) {
            result.metrics[key] = '-';
          } else if (presetMetrics[key] && presetMetrics[key].unit === 'calories') {
            result.metrics[key] = (exercise.assignedProfile.global[key]) +
            (presetMetrics[key] ? (' ' + $translate.instant('CALORIES_' + profileService.user.settings.measurementUnit)) : '' );
          } else {
            result.metrics[key] = (+exercise.assignedProfile.global[key]).toFixed(2) +
            (presetMetrics[key] ? (' ' + $translate.instant(presetMetrics[key].unit)) : '');
          }

          result.assignedData[key] = {
            value: +exercise.assignedProfile.global[key],
            unit: presetMetrics[key] ? presetMetrics[key].unit || '' : ''
          };
        });
      }
      if (exercise.assignedProfile && exercise.assignedProfile.segments) {

        Object.keys(exercise.assignedProfile.segments[0] || {}).forEach(function(key) {
          if (key === '$$hashKey' || key === '_isActive') {
            return;
          }

          if (!result.metrics[key]) {
            var calculatedValue;

            if (presetMetrics[key]) {

              switch (presetMetrics[key].math) {
              case 'sum':
                calculatedValue = exercise.assignedProfile.segments.reduce(function(prev, next) {
                  return prev + next[key];
                }, 0);
                break;
              case 'average':
                calculatedValue = (exercise.assignedProfile.segments.reduce(function(prev, next) {
                  return prev + next[key];
                }, 0) / exercise.assignedProfile.segments.length);
                break;
              default:
                calculatedValue = exercise.assignedProfile.segments[0][key];
              }

              calculatedValue = roundMetric(+calculatedValue, key);
            } else {
              calculatedValue = _.isNumber(exercise.assignedProfile.segments[0][key]) ?
                exercise.assignedProfile.segments[0][key].toFixed(2) :
                exercise.assignedProfile.segments[0][key];
            }

            result.assignedData[key] = {
              value: calculatedValue,
              unit: (presetMetrics[key] && presetMetrics[key].unit) || ''
            };

            result.metrics[key] = calculatedValue;
            if (presetMetrics[key] && presetMetrics[key].unit) {
              if (presetMetrics[key].unit !== '%') {
                result.metrics[key] += ' ';
              }
              result.metrics[key] += $translate.instant(presetMetrics[key].unit);
            }
          }
        });
      }

      if (exercise.completedProfile) {
        result.completedData = getProfileCompleted(exercise);
        _buildAssignedVsCompletedComparison(result);
      }
      return result;
    }

    function getProfileCompleted(exercise) {
      var params = {},
        profile = exercise.completedProfile;

      if (angular.isDefined(profile.duration)) {
        params.duration = _getExerciseCompletedDuration(exercise);
      }

      if (angular.isDefined(profile.calories)) {
        params.calories = _getExerciseCompletedCalories(exercise);
      }

      if (angular.isDefined(profile.distance)) {
        params.distance = _getExerciseCompletedDistance(exercise);
      }

      if (profile.speedHistory && profile.speedHistory.length) {
        params.averageSpeed = _getExerciseCompletedSpeedFromHistory(exercise);
      } else if (angular.isDefined(profile.duration) && angular.isDefined(profile.distance)) {
        params.averageSpeed = _getExerciseCompletedSpeedCalculated(exercise);
      }

      if (angular.isDefined(profile.averageIncline)) {
        params.averageIncline = _getExerciseCompletedIncline(exercise);
      }

      if (angular.isDefined(profile.averageHeartRate)) {
        params.averageHeartRate = _getExerciseCompletedHeartRate(exercise);
      }

      return params;
    }

    function _buildAssignedVsCompletedComparison(exercise) {
      var assigned = exercise.assignedData,
        completed = exercise.completedData;

      if (completed.duration) {
        completed.duration.comparison = _compareValues(completed.duration, assigned.duration);
      }

      if (completed.calories) {
        completed.calories.comparison = _compareValues(completed.calories, assigned.calories);
      }

      if (completed.distance) {
        completed.distance.comparison = _compareValues(completed.distance, assigned.distance);
      }

      if (completed.averageSpeed) {
        completed.averageSpeed.comparison = _compareValues(completed.averageSpeed, assigned.startingSpeed);
      }

      if (completed.averageIncline) {
        completed.averageIncline.comparison = _compareValues(completed.averageIncline, assigned.startingIncline);
      }

      if (completed.averageHeartRate) {
        completed.averageHeartRate.comparison = _compareValues(completed.averageHeartRate, assigned.heartRate);
      }

      if (completed.level) {
        completed.level.comparison = _compareValues(completed.level, assigned.level);
      }
    }

    function _compareValues(a, b) {
      if (_.isUndefined(a) || _.isUndefined(b)) {
        return;
      }
      if (Number(a.value) === Number(b.value)) {
        return 'equal';
      }

      if (Number(a.value) > Number(b.value)) {
        return 'greater';
      }

      if (Number(a.value) < Number(b.value)) {
        return 'less';
      }
    }

    function _getExerciseCompletedDuration(exercise) {
      // TODO: investigate if we can get rid of hardcode
      var timeUnits = exercise.completedManually ? 'minutes' : 'seconds';

      return {
        value: _getFormattedDuration(exercise.completedProfile.duration, timeUnits),
        unit: 'min'
      };
    }

    function _getExerciseCompletedCalories(exercise) {
      return {
        value: exercise.completedProfile.calories,
        unit: 'cal'
      };
    }

    function _getExerciseCompletedDistance(exercise) {
      return {
        name: 'distance',
        value: _getFormattedDistance(exercise.completedProfile.distance),
        unit: exercise.completedProfile.distanceUnit
      };
    }

    function _getExerciseCompletedSpeedFromHistory(exercise) {
      return {
        name: 'averageSpeed',
        value: _getFormattedSpeedHistory(exercise.completedProfile.speedHistory),
        unit: $translate.instant(exercise.completedProfile.speedUnit)
      };
    }

    function _getExerciseCompletedSpeedCalculated(exercise) {
      var speedMetrics = exercise.preset && _.find(exercise.preset.metrics, { name: 'startingSpeed' });
      if (speedMetrics) {
        // Note: duration is always stored in minutes
        // eslint-disable-next-line one-var
        var MINUTES_IN_HOUR = 60,
          unit = speedMetrics ? speedMetrics.unit : '',
          value = MINUTES_IN_HOUR * exercise.completedProfile.distance / exercise.completedProfile.duration;
        value = parseFloat(value.toFixed(2));

        return {
          name: 'averageSpeed',
          value: value,
          unit: unit
        };
      }
      return null;
    }

    function _getExerciseCompletedIncline(exercise) {
      return {
        name: 'averageIncline',
        value: exercise.completedProfile.averageIncline,
        unit: '%'
      };
    }

    function _getExerciseCompletedHeartRate(exercise) {
      return {
        name: 'averageHeartRate',
        value: exercise.completedProfile.averageHeartRate,
        unit: ''
      };
    }

    function _getFormattedDistance(distance) {
      return $filter('number')(distance, '2');
    }

    function _getFormattedSpeedHistory(speedHistory) {
      return $filter('number')(_averageFilter(speedHistory), '1');
    }

    function _getFormattedDuration(duration, timeUnits) {
      timeUnits = timeUnits || 'minutes';
      return +moment.duration(duration, timeUnits).asMinutes().toFixed(2);
    }

    function _averageFilter(collection) {
      collection = angular.isString(collection) ? collection.split(',') : collection;

      if (!angular.isArray(collection) || collection.length === 0) {
        return;
      }

      return _.reduce(collection, function(memo, num) {
        return memo + parseFloat(num);
      }, 0) / collection.length;
    }

    function _convertBody(user) {
      if (user.clientProfile && user.clientProfile.body) {
        user.clientProfile.body = convert.bodyToExternal(user.clientProfile.body, profileService.user.settings.measurementUnit);
      }
      return user;
    }

    function getExerciser(id) {
      return $http.get(config.apiBase + '/clients/' + id + '?isCRM=true').then(function(response) {
        return _convertBody(response.data);
      });
    }
    function getTrainers(id) {
      return $http.get(config.apiBase + '/staffs/' + id + '?isCRM=true').then(function(response) {
        return _convertBody(response.data);
      });
    }
    //  New Endpoint For Dashboard Users
    function getCSExercisers(params) {
      return $http.get(config.apiBase + '/clients?isCRM=true', {
        params: _.extend(params || {}, { limit: 100 })
      }).then(function(response) {
        var res = response.data;
        res.data.forEach(function(user) {
          return _convertBody(user);
        });
        return res;
      });
    }

    // function getExercisers(params) {
    //   return $http.get(config.apiBase + '/users?isCRM=true', {
    //     params: _.extend(params || {}, { limit: 100 })
    //   }).then(function(response) {
    //     var res = response.data;
    //     res.data.forEach(function(user) {
    //       return _convertBody(user);
    //     });
    //     return res;
    //   });
    // }
    function getStaffExercisers(params) {
      return $http.get(config.apiBase + '/staffs?isCRM=true', {
        params: _.extend(params || {}, { limit: 100 })
      }).then(function(response) {
        var res = response.data;
        res.data.forEach(function(user) {
          return _convertBody(user);
        });
        return res;
      });
    }

    function getStaffExerciser(id) {
      return $http.get(config.apiBase + '/staffs/' + id + '?isCRM=true').then(function(response) {
        return _convertBody(response.data);
      });
    }

    function getClientExerciser(id) {
      return $http.get(config.apiBase + '/clients/' + id + '?isCRM=true').then(function(response) {
        return _convertBody(response.data);
      });
    }

    function getNotClients(params) {
      return getStaffExercisers(params).then(function(users) {
        return _.filter(users.data, function(user) {
          return _.intersection(user.roles, ['facility_staff']).length;
        });
      });
    }

    // function getPaginateList(options, responseExtract) {
    //   return new PaginateList({
    //     url: config.apiBase + '/users?isCRM=true',
    //     responseExtract: responseExtract,
    //     convertFunc: function(users) {
    //       var convertedUsers = users.map(function(user) {
    //         return _convertBody(user);
    //       });
    //       return convertedUsers;
    //     },
    //     params: _.extend({ limit: 10 }, options)
    //   });
    // }

    function getStaffPaginateList(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/staffs?isCRM=true',
        responseExtract: responseExtract,
        convertFunc: function(users) {
          var convertedUsers = users.map(function(user) {
            return _convertBody(user);
          });
          return convertedUsers;
        },
        params: _.extend({ limit: 10 }, options)
      });
    }

    function getClientPaginateList(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/clients?isCRM=true',
        responseExtract: responseExtract,
        convertFunc: function(users) {
          var convertedUsers = users.map(function(user) {
            return _convertBody(user);
          });
          return convertedUsers;
        },
        params: _.extend({ limit: 10 }, options)
      });
    }

    //  Pagination using Client & Staff APIs
    function getClientStaffPaginateList(options, responseExtract) {
      var urlList = [config.apiBase + '/staffs?isCRM=true', config.apiBase + '/clients?isCRM=true'];
      return new PaginateList({
        url: urlList,
        responseExtract: responseExtract,
        convertFunc: function(users) {
          var convertedUsers = users.map(function(user) {
            return _convertBody(user);
          });
          return convertedUsers;
        },
        params: _.extend({ limit: 5 }, options)
      });
    }
  }
}());
(function() {
  'use strict';

  exercisesService.$inject = ['$http', '$q', 'config', 'PaginateList', 'profileService', 'convert', 'metricsService', 'exerciseMetaData', '$translate'];
  angular.module('ptCrm')
    .service('exercisesService', exercisesService);

  function exercisesService($http, $q, config, PaginateList, profileService, convert, metricsService, exerciseMetaData, $translate) {
    var videoUrl = '',
      pictureLookup = {
        weightlifting: '//images.jhtassets.com/76037ca8035c93efb502dff134c6c459ce23eb89/',
        'weightlifting-active': '//images.jhtassets.com/13403a59b6d2dab0c5b7b774c9d0bb5509e4bb3f/',
        treadmill: '//images.jhtassets.com/01ed464107b44bbf658284e7c3d6521c99dc1114/',
        'treadmill-active': '//images.jhtassets.com/8e3dfad173766d0ce8cc319f380253451fea91ea/',
        stretching: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
        'stretching-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
        strength: '//images.jhtassets.com/76037ca8035c93efb502dff134c6c459ce23eb89/',
        'strength-active': '//images.jhtassets.com/13403a59b6d2dab0c5b7b774c9d0bb5509e4bb3f/',
        stepper: '//images.jhtassets.com/b2b24179bc42af2640083e32e434a6c53dc2ea1f/',
        'stepper-active': '//images.jhtassets.com/77ea13f0c57cc6f040099d63543615d87e388084/',
        rower: '//images.jhtassets.com/5bc6fbb81f30292f0497bbc150d4ac61594382a4/',
        'rower-active': '//images.jhtassets.com/e66ffde952192d1c66c995f3c55489b8aa4a2d55/',
        elliptical: '//images.jhtassets.com/999b4c88c85d81b7596ae3362bb64469c42c15c9/',
        'elliptical-active': '//images.jhtassets.com/dc2d55c187e0cf19045cff114f74886ce0cd309c/',
        default_exercise: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
        'default_exercise-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
        climbmill: '//images.jhtassets.com/b337878ce1d2d74b76db88f424f66a444370439d/',
        'climbmill-active': '//images.jhtassets.com/4ac51639626adfb82d28481f4861fe777711c7f2/',
        class: '//images.jhtassets.com/bfa9008baf7ad17ea6b371631a69ed1fdd03a246/',
        'class-active': '//images.jhtassets.com/077d24ff365c88f5bf4347889380fa0dab0cdded/',
        bike: '//images.jhtassets.com/932f36e4ef511eb6687697d40ff2db132d0572a9/',
        'bike-active': '//images.jhtassets.com/3f5c1f3b4198214212df6a17eabb7d9d7bd4f186/',
        arc_trainer: '//images.jhtassets.com/c594197de85b02fdc4a61657daafcfe847a3fd00/',
        'arc_trainer-active': '//images.jhtassets.com/3e9d6e0db1512c035c768b1a3f598c269396ead7/',
        '3rd_party': '//images.jhtassets.com/a63d76b26d40418b110f4a016b2e391f2726a385/',
        '3rd_party-active': '//images.jhtassets.com/384127ff4e5e8caf29978ed55f56f2184cd4fa8c/'
      };

    return {
      getExerciseCategories: getExerciseCategories,
      getTemplatesPaginateList: getTemplatesPaginateList,
      createExercise: createExercise,
      deleteExercise: deleteExercise,
      updateExercise: updateExercise,
      getExercise: getExercise,
      getExercises: getExercises,
      setVideoUrl: setVideoUrl,
      extendExercises: extendExercises,
      hasPermission: hasPermission,
      getExerciseTags: getExerciseTags,
      getAvailableExerciseTags: getAvailableExerciseTags,
      setExerciseTag: setExerciseTag,
      removeExerciseTag: removeExerciseTag,
      getAllExercises: getAllExercises
    };

    function createExercise(data) {
      if (videoUrl.length) {
        data.video = videoUrl;
      }
      data = convert.exerciseToInternal(data);
      data = convert.removeExercisePreset(data);
      return $http.post(config.apiBase + '/exercise_templates?isCRM=true', data)
        .then(function(response) {
          return response.data;
        });
    }

    function deleteExercise(exerciseId) {
      return $http.delete(config.apiBase + '/exercise_templates/' + exerciseId + '?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function updateExercise(exerciseId, data, updateAssigned) {
      var url = config.apiBase + '/exercise_templates/' + exerciseId + '?isCRM=true';
      if (updateAssigned) {
        url += '?updateAssigned=true';
      }
      data = convert.exerciseToInternal(data);
      data = convert.removeExercisePreset(data);
      return $http.put(url, data)
        .then(function(response) {
          return response.data;
        });
    }

    function getExercise(exerciseId) {
      return $http.get(config.apiBase + '/exercise_templates/' + exerciseId + '?isCRM=true', { params: { preset: false }})
        .then(function(response) {
          response.data.preset = metricsService.getPresetForExercise(response.data);
          response.data = convert.exerciseToExternal(response.data, profileService.user.settings.measurementUnit);   
          return ensureValidAssignedProfile(response.data);
        });
    }

    function getExercises(exerciseIds) {
      return $q.all(_.map(exerciseIds, getExercise));
    }

    function getTemplatesPaginateList(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/exercise_templates?isCRM=true',
        responseExtract: responseExtract,
        convertFunc: function(responseData) {
          var results = responseData.map(function(exercise) {
            exercise.preset = metricsService.getPresetForExercise(exercise);
            exercise = convert.exerciseToExternal(exercise, profileService.user.settings.measurementUnit);
            return ensureValidAssignedProfile(exercise);
          });
          if(results&& results.length){
            results.filter(function(obj) {
              Object.entries(obj).forEach(function(key){ 
                if((key[1] === null)){
                  delete obj[key[0]];
                } 
              });
            });
          }
          return results;
        },
        params: _.extend({ limit: 20, preset: false }, options)
      });
    }

    function getAllExercises(options, responseExtract) {
      return new PaginateList({
        url: config.apiBase + '/exercise_templates?isCRM=true',
        responseExtract: responseExtract,
        params: _.extend({ limit: 1000, preset: true }, options)
      });
    }

    function getExerciseCategories() {
      return $http.get(config.apiBase + '/exercise_categories?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function getAvailableExerciseTags(search) {
      return $http.get(config.apiBase + '/tags?isCRM=true', {
        params: {
          search: search
        }
      })
        .then(function(response) {
          return {
            all: response.data.data,
            atLeastOneExercise: response.data.data.filter(function(tag) { return tag.exerciseCount > 0; })
          };
        });
    }

    function getExerciseTags(exerciseId) {
      return $http.get(config.apiBase +'/exercise_templates/' + exerciseId + '/tags?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function setExerciseTag(exerciseId, tag) {
      return $http.post(config.apiBase +'/exercise_templates/' + exerciseId + '/tags?isCRM=true', {
        tag: tag
      })
        .then(function(response) {
          return response.data;
        });
    }

    function removeExerciseTag(exerciseId, tagId) {
      return $http.delete(config.apiBase +'/exercise_templates/' + exerciseId + '/tags/' + tagId + '?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function setVideoUrl(url) {
      videoUrl = url || '';
    }

    function hasPermission(permission) {
      return _.includes(profileService.permissionNames, permission);
    }

    function extendExercises(items) {
      // extend with custom pictures
      return _.map(items, function(exercise) {
        if (exercise.assignedProfile && !exercise.assignedProfile.global) {
          exercise.assignedProfile.global = {};
        }
        // check if exercise is editable, using safe _ method to prevent ref errors
        exercise.isEditable = _.has(exercise, 'assignedProfile.cardioProgram');
        var pictureName = exercise.equipmentType || exercise.category || 'default_exercise';
        return _.assign(exercise, { pictureUrl: pictureLookup[pictureName.toLowerCase()] || pictureLookup['default_exercise'] });
      });
    }

    function ensureValidAssignedProfile(exercise) {
      var type = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular).classifyExercise(exercise),
        cardioPrograms = ['virtual-active-exercise', 'sprint8-exercise', 'migros-exercise', 'thr-exercise'];

      if (_.includes(cardioPrograms, type)) {
        exercise.preset.metrics.forEach(function(metric) {
          if (!exercise.assignedProfile.cardioProgram[metric.name]) {
            exercise.assignedProfile.cardioProgram[metric.name] = metric.validation.default;
          }
        });
      }

      return exercise;
    }
  }
}());
(function() {
  'use strict';

  exerciseImagesService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('exerciseImagesService', exerciseImagesService);

  function exerciseImagesService($http, config) {


    function Images(images) {
      this.items = images || [];
      this.newPrimaryItem = null;
    }

    Images.prototype.add = add;
    Images.prototype.remove = remove;
    Images.prototype.setAsPrimary = setAsPrimary;
    Images.prototype._autoSetPrimary = _autoSetPrimary;
    Images.prototype._upload = _upload;
    Images.prototype._handleSuccessfulUpload = _handleSuccessfulUpload;
    Images.prototype.getImages = getImages;
    Images.prototype.setTrainingSetImage = setTrainingSetImage;
    Images.prototype.getTrainingSetImage = getTrainingSetImage;

    return {
      getInstance: getInstance
    };

    function getInstance(images) {
      return new Images(images);
    }

    function getImages() {
      return this.items.map(function(image) {
        delete image.aspectRatio;
        delete image.pictureTransform;
        return image;
      });
    }

    function setTrainingSetImage(url, transform) {
      this.items = [
        {
          picturePath: url,
          pictureTransform: transform
        }
      ];
    }

    function getTrainingSetImage() {
      return this.items[0] ? this.items[0] : undefined;
    }

    function _upload(image) {
      var formData = new FormData();
      formData.append('picture', image);

      return $http.post(config.apiBase + '/images?isCRM=true', formData, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      })
        .then(function(response) {
          return response.data && response.data.url;
        });
    }

    function _handleSuccessfulUpload(url) {
      this.items.shift();
      this.items.unshift({
        picturePath: url
      });
      this._autoSetPrimary();
    }

    function add(files, limit) {
      if (!files || !files.length || this.items.length >= limit) {
        return;
      }

      this.items.unshift({
        loading: true
      });

      return this._upload(files[0])
        .then(this._handleSuccessfulUpload.bind(this));
    }

    function remove(image) {
      var index = this.items.indexOf(image),
        previousIndex = index === 0 ? 0 : index - 1;
      this.items.splice(index, 1);

      this._autoSetPrimary(previousIndex);
    }

    function _autoSetPrimary(index) {
      var primary = _.find(this.items, { isPrimary: true });
      if (primary) {
        return;
      }
      this.setAsPrimary(this.items[index || 0]);
    }

    function setAsPrimary(image) {
      if (!image) {
        return;
      }

      _.each(this.items, function(item) {
        delete item.isPrimary;
      });

      image.isPrimary = true;

      // set new primary image from the list of already existed images on server
      if (image._id) {
        this.newPrimaryItem = image;
      }
    }
  }
}());
(function() {
  'use strict';

  assignmentsService.$inject = ['$http', 'config', '$q', '$translate', '$state', 'PaginateList', 'urlService', 'userService', 'popup', 'profileService', 'convert', 'metricsService', 'defaultCompletedProfile'];
  angular.module('ptCrm')
    .service('assignmentsService', assignmentsService);

  function assignmentsService(
    $http,
    config,
    $q,
    $translate,
    $state,
    PaginateList,
    urlService,
    userService,
    popup,
    profileService,
    convert,
    metricsService,
    defaultCompletedProfile) {

    return {
      createAssignment: createAssignment,
      updateMassAssignment: updateMassAssignment,
      deleteMassAssignment: deleteMassAssignment,
      getAssignments: getAssignments,
      getAppointedAssignments: getAppointedAssignments,
      getAppointedAssignment: getAppointedAssignment,
      prepareSelectedClients: prepareSelectedClients,
      getSingleAssignments: getSingleAssignments,
      getClientAssignmentsPaginateList: getClientAssignmentsPaginateList,
      getAssignmentsById: getAssignmentsById,
      chooseAssignmentEditMode: chooseAssignmentEditMode,
      goEditRecurringAssignment: goEditRecurringAssignment,
      calculateInferredRecurrences: calculateInferredRecurrences,
      getRecurrenceUnit: getRecurrenceUnit,
      assignmentTitle: assignmentTitle,
      completeExercise: completeExercise,
      uncompleteExercise: uncompleteExercise,
      skipExercise: skipExercise,
      massCompleteExercises: massCompleteExercises
    };

    function getAssignments(params) {
      params.preset = false;
      return $http.get(config.apiBase + '/mass_assignments?isCRM=true', { params: params })
        .then(function(response) {
          response.data.data = _.map(response.data.data, function(assignment) {
            assignment.exercises = assignment.exercises.map(function(exercise) {
              exercise.preset = metricsService.getPresetForExercise(exercise);
              return exercise;
            });
            return convert.assignmentToExternal(assignment, profileService.user.settings.measurementUnit);
          });
          return response.data;
        });
    }

    function getAssignmentsById(id) {
      return $http.get(urlService.interpolate(config.apiBase + '/mass_assignments/{{id}}?isCRM=true', { id: id }), {
        params : {
          preset: false
        }
      })
        .then(function(response) {
          var assignment = _.isArray(response.data) ? response.data[0] : response.data;
          assignment.exercises = assignment.exercises.map(function(exercise) {
            exercise.preset = metricsService.getPresetForExercise(exercise);
            return exercise;
          });
          return convert.assignmentToExternal(assignment, profileService.user.settings.measurementUnit);
        });
    }

    function getSingleAssignments(params) {
      params.preset = false;
      return $http.get(config.apiBase + '/assignments?isCRM=true', { params: params })
        .then(function(response) {
          response.data.data = _.map(response.data.data, function(assignment) {
            assignment.exercises = assignment.exercises.map(function(exercise) {
              exercise.preset = metricsService.getPresetForExercise(exercise);
              return exercise;
            });
            return convert.assignmentToExternal(assignment, profileService.user.settings.measurementUnit);
          });
          return response.data;
        });
    }

    function getClientAssignmentsPaginateList(userId) {
      return new PaginateList({
        url: config.apiBase + '/assignments?isCRM=true',
        params: { limit: 100, exerciserId: userId, preset: false },
        convertFunc: function(responseData) {
          var results = responseData.map(function(assignment) {
            assignment.exercises = assignment.exercises.map(function(exercise) {
              exercise.preset = metricsService.getPresetForExercise(exercise);
              return exercise;
            });
            return convert.assignmentToExternal(assignment, profileService.user.settings.measurementUnit);
          });
          return results;
        }
      });
    }

    function createAssignment(assignment, clients) {
      var error = _validateBody(assignment);
      if (error) {
        return $q.reject(error);
      }
      assignment = convert.assignmentToInternal(assignment, profileService.user.settings.measurementUnit);
      assignment.exercises = convert.removeExercisePreset(assignment.exercises);
      return $http
        .post(
          config.apiBase + '/mass_assignments?isCRM=true&role=true',
          assignment
        )
        .catch(getCreateAssignmentErrorHandler(clients));
    }

    function updateMassAssignment(assignment, clients, id, modifySeries) {
      var error = _validateBody(assignment),
        massAssignmentsUrl = clients &&
        clients[0] &&
        clients[0].roles &&
        clients[0].roles[0] &&
        clients[0].roles[0] === 'client' ? config.apiBase + '/mass_assignments/' + id +'?isCRM=true&role=true': config.apiBase + '/mass_assignments/' + id +'?isCRM=true';
      if (error) {
        return $q.reject(error);
      }

      if (modifySeries) {
        massAssignmentsUrl += '&modify_series=true';
      }
      assignment = convert.assignmentToInternal(assignment, profileService.user.settings.measurementUnit);
      assignment.exercises = convert.removeExercisePreset(assignment.exercises);

      return $http.put(massAssignmentsUrl, assignment)
        .catch(getCreateAssignmentErrorHandler(clients));
    }

    function deleteMassAssignment(id, modifySeries) {
      var massAssignmentsUrl = config.apiBase + '/mass_assignments/' + id +'?isCRM=true';

      if (modifySeries) {
        massAssignmentsUrl += '&modify_series=true';
      }

      return $http.delete(massAssignmentsUrl)
        .then(function(response) {
          return response.data;
        });
    }

    function _getNextEditableMassAssignment(id) {
      return $http.get(config.apiBase + '/mass_assignments/' + id + '/next_editable?isCRM=true')
        .then(function(res) {
          return res.data;
        });
    }

    function _validateBody(body) {
      if (!body.startDate || !body.endDate) {
        return $translate.instant('PLEASE_PICK_DATES');
      }

      if (body.startDate >= body.endDate) {
        return $translate.instant('END_DATE_MUST_BE_GREATER_THEN_START_DATE');
      }

      if (!body.exercises.length) {
        return $translate.instant('PLEASE_PICK_EXERCISES');
      }
    }

    function getCreateAssignmentErrorHandler(clients) {
      return function handleCreateAssignmentError(response) {
        var errorData = response.data,
          intersectionError = _getIntersectionError(errorData.errors, clients);

        if (intersectionError) {
          return $q.reject(intersectionError);
        } else if (errorData.message) {
          return $q.reject(errorData.message);
        }
        return $q.reject(response.statusText);

      };
    }

    function _getIntersectionError(errors, clients) {
      return _.chain(errors)
        .filter({ key: 'exercisers' })
        .groupBy('message')
        .mapValues(function(errorGroup) {
          return _.chain(errorGroup)
            .map(function(err) {
              var client = _.find(clients, { _id: err.value });
              return userService.getFullUserName(client);
            })
            .filter()
            .uniq()
            .join(', ')
            .value();
        })
        .reduce(function(result, names, errorName) {
          var message = names ?
            $translate.instant(_.toUpper(_.snakeCase(errorName)) + '_CLIENTS_ERROR') + ' ' + names + '; ' :
            '';
          return result + message;
        }, '')
        .value();
    }

    function getAppointedAssignments(assignments, user) {
      return _.chain(assignments)
        .filter('exercises')
        .map(function(assn) {
          // No image placeholder
          var img = '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png',
            from = getTimeOf('start', assn),
            to = getTimeOf('end', assn);
          if (from.isSame(moment(to).subtract(1, 'minute'), 'day')) {
            from = momentToInteger(from);
            to = momentToInteger(to) || 24;
          } else {
            from = 0;
            to = 24;
          }

          // eslint-disable-next-line one-var
          var appointedAssignment = {
            _id: assn._id,
            timeFrom: from,
            timeTo: to,
            dateFrom: moment.unix(assn.startDate),
            dateTo: moment.unix(assn.endDate),
            type: 'assignment',
            name: assignmentTitle(assn),
            scheduleType: assn.scheduleType
          };

          switch (assn.exercisers && assn.exercisers.length) {

          // single assignment
          case undefined:
            appointedAssignment = _.extend(appointedAssignment, {
              exerciserId: assn.exerciserId,
              caption: getCaption(user, 1),
              img: user.pictureUrl || img,
              club: _.get(user, 'club.name', '')
            });
            break;

          // mass_assignment with one client
          case 1:
            appointedAssignment = _.extend(appointedAssignment, {
              caption: getCaption(assn.exercisers[0], 1),
              img: assn.exercisers[0].pictureUrl || img,
              club: _.get(assn.exercisers[0], 'club.name', '')
            });
            break;

          // mass_assignment with many clients
          default:
            appointedAssignment = _.extend(appointedAssignment, {
              caption: getCaption(false, assn.exercisers.length),
              img: img,
              club: _.get(assn.exercisers[0], 'club.name', '')
            });
          }

          if (assn.recurrence) {
            appointedAssignment.recurrence = angular.copy(assn.recurrence);
          }

          return appointedAssignment;

        })
        .value();
    }

    function assignmentTitle(assignment) {
      if (assignment.name) {
        return assignment.name;
      }
      if (assignment.exercises && assignment.exercises.length === 1
        && assignment.exercises[0] && assignment.exercises[0].title) {
        return assignment.exercises[0].title;
      }
      return $translate.instant('WORKOUT');
    }

    function getCaption(user, amount) {
      if (user) {
        return userService.getFullUserName(user);
      }
      return $translate.instant('AMOUNT_EXERCISERS', { amount: amount });

    }

    function getAppointedAssignment(user, assignment) {
      return _.first(getAppointedAssignments([assignment], user));
    }

    function getTimeOf(point, assignment) {
      var correction = point === 'end' ? 1 : 0;
      return moment.unix(assignment[point + 'Date'] + correction);
    }

    function momentToInteger(momentTime) {
      return momentTime.get('hours') + (momentTime.get('minutes') ? 0.5 : 0);
    }

    function prepareSelectedClients(selectedClients) {
      var caption,
        img;

      if (!selectedClients.length) {
        return {};
      }
      caption = selectedClients.length > 1 ? selectedClients.length + ' ' + $translate.instant('EXERCISERS') :
        userService.getFullUserName(selectedClients[0]);
      //                               No image placeholder
      img = selectedClients.length > 1 ? '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png' :
      //                                No image placeholder
        (selectedClients[0].pictureUrl || '//images.jhtassets.com/264082bb3a1af70d5499c7d22b0902cb454b6d12/');

      return {
        img: img,
        club: _.get(selectedClients[0], 'club.name', ''),
        caption: caption
      };

    }

    /**
      * goEditRecurringAssignment - Prepares route params and navigates to app.assignment route
      * @param {object} stateParams
      * @param {prop} stateParams.id - assignment id to pass through to app.assignment route
      * @param {prop} stateParams.userId - user id to pass through to app.assignment route
      */
    function goEditRecurringAssignment(editSeries, stateParams, closePopup) {
      var promise = editSeries ? _getNextEditableMassAssignment(stateParams.id) : $q.resolve(false);

      if (this && !this.isLoading && !this.editType) {
        this.isLoading = true;
        this.editType = editSeries ? 'SERIES' : 'SINGLE';
      }

      return promise.then(function(result) {
        if (result && result.nextEditable) {
          stateParams.id = result.nextEditable;
        }

        var mergedParams = _.extend(stateParams, {
          editSeries: editSeries
        });

        $state.go('app.assignment', mergedParams);
        if (closePopup) {
          closePopup();
        }
      });
    }

    /**
      * chooseAssignmentEditMode - Pops a modal window to decide between editing
      * the assignment as an individual assignment or as a series
      * @param {object} stateParams
      * @param {prop} stateParams.id - assignment id to pass through to goEditRecurreingAssignment
      * @param {prop} stateParams.userId - user id to pass through to goEditRecurreingAssignment
      * @return {popup} popup modal instance
      */
    function chooseAssignmentEditMode(stateParams) {

      return popup.show({
        title: $translate.instant('EDIT_RECURRING_ASSIGNMENT'),
        cssClass: 'modal--select-from-list',
        templateUrl: '/app/library/create-assignment/choose-assignment-edit-mode.html',
        scope: {
          editAssignment: goEditRecurringAssignment,
          stateParams: stateParams
        },
        showOk: false,
        showCancel: false
      });
    }

    /**
      * calculateInferredRecurrences - Reconstruct the start/end dates of each assignment
      * in a series of recurring assignments
      * @param {moment} startMoment - Start moment of any one of the occurrences
      * @param {object} recurrence
      * @param {prop} recurrence.recurrenceType - one of 'daily', 'weekly', 'monthly'
      * @param {prop} recurrence.recurrenceIdx - index position in list of occurrences
      * @param {prop} recurrence.recurrenceNumber - total number of occurrences
      * @return {Array.<moment>} - Start moment of all occurrence in the series
      */
    function calculateInferredRecurrences(startMoment, recurrence) {
      var recurrences = [],
        firstOccurrence,
        recurrenceUnit,
        dateOffset;

      if (!recurrence || recurrence.recurrenceType === 'once') {
        recurrences.push(startMoment);
        return recurrences;
      }

      dateOffset = recurrence.recurrenceIdx - 1;
      recurrenceUnit = getRecurrenceUnit(recurrence.recurrenceType);
      firstOccurrence = moment(startMoment).subtract(dateOffset, recurrenceUnit);

      // eslint-disable-next-line one-var
      for (var i = 0; i < (recurrence.recurrenceNumber || 1); i++) {
        recurrences.push(moment(firstOccurrence).add(i, recurrenceUnit));
      }

      return recurrences;
    }

    function getRecurrenceUnit(recurrenceType) {
      var recurrenceUnit;

      switch (recurrenceType) {
      case 'weekly':
        recurrenceUnit = 'weeks';
        break;
      case 'monthly':
        recurrenceUnit = 'months';
        break;
      default:
        recurrenceUnit = 'days';
      }

      return recurrenceUnit;
    }

    function completeExercise(exercise, completedWorkout) {
      var exerciseUrl = config.apiBase + '/combined_assignments/exercises/' + exercise._id + '/associate?isCRM=true',
        body = {
          workout: completedWorkout || defaultCompletedProfile(exercise, profileService.user.settings.measurementUnit)
        };
      return $http.post(exerciseUrl, body);
    }

    function uncompleteExercise(id) {
      var exerciseUrl = config.apiBase + '/combined_assignments/exercises/' + id + '/associate?isCRM=true';
      return $http.delete(exerciseUrl);
    }

    function skipExercise(id, category) {
      var exerciseUrl = config.apiBase + '/combined_assignments/exercises/' + id + '/associate?isCRM=true',
        body = {
          workout : {
            category: category,
            completedDate: moment().unix(),
            completedProfile: { },
            completeState: 'skipped'
          }
        };
      return $http.post(exerciseUrl, body);
    }

    function massCompleteExercises(exercises, isSkip) {
      var promises = exercises.reduce(function(prev, exercise) {
        var exerciseUrl = config.apiBase + '/combined_assignments/exercises/' + exercise._id + '/associate?isCRM=true',
          body;
        if (isSkip) {
          body = {
            workout : {
              category: exercise.category,
              completedDate: moment().unix(),
              completedProfile: { },
              completeState: 'skipped'
            }
          };
        } else {
          body = {
            workout : defaultCompletedProfile(exercise, profileService.user.settings.measurementUnit)
          };
        }
        return prev.then(function() {
          return $http.post(exerciseUrl, body);
        });
      }, $q.resolve());
      return promises;
    }

  }
}());
/* eslint-disable one-var */
(function() {
  'use strict';

  notesService.$inject = ['$http', '$q', 'config', 'urlService'];
  angular.module('ptCrm')
    .service('notesService', notesService);

  function notesService($http, $q, config, urlService) {

    return {
      getNotes: getNotes,
      getNoteFile: getNoteFile,
      updateNote: updateNote,
      deleteNote: deleteNote,
      createNote: createNote,
      createDefaultNote:createDefaultNote
    };

    function getNotes(userId, admin) {
      let url = config.apiBase + '/clients';
      if ( admin) {url= config.apiBase + '/staffs';}
      return $http.get(urlService.interpolate(url + '/{{id}}/notes?isCRM=true', { id: userId }))
        .then(function(response) {
          return response.data;
        }
        );
    }

    function getNoteFile(userId, noteId, file, admin) {
      let url = config.apiBase + '/clients';
      if ( admin) {url= config.apiBase + '/staffs';}
      return $http.get(
        urlService.interpolate(url + '/{{userId}}/notes/{{noteId}}/file/{{fileId}}?isCRM=true', {
          userId: userId,
          noteId: noteId,
          fileId: file.fileId
        }), { responseType: 'blob' })
        .then(function(response) {
          var responseFile = new Blob([response.data]);

          saveAs(responseFile, decodeURIComponent(file.fileName));
        });
    }

    function getDefaultNoteFile(facilityId, noteId, file, userNotesId,userId) {
      let url = config.apiBase + '/facilities';
      return $http.get(
        urlService.interpolate(url + '/{{facilityId}}/notes/{{noteId}}/file/{{fileId}}?isCRM=true', {
          facilityId: facilityId,
          noteId: noteId,
          fileId: file.fileId
        }), { responseType: 'blob' })
        .then(function(response) {
          var responseFile = new Blob([response.data]);
          var fileToBeUploaded = new File([responseFile],file.fileName);
          var filesToAdd = [];
          filesToAdd.push(_addFileToNote(userId, userNotesId, fileToBeUploaded));
          return $q.all(filesToAdd);
        });
    }
    function updateNote(userId, note, admin) {
      var url = urlService.interpolate(config.apiBase + '/clients/{{id}}/notes/{{noteId}}?isCRM=true',
        { id: userId, noteId: note._id }
      );
      if ( admin) {
        url= url = urlService.interpolate(config.apiBase + '/staffs/{{id}}/notes/{{noteId}}?isCRM=true',
          { id: userId, noteId: note._id }
        );
      }
      // eslint-disable-next-line one-var
      var data = { title: note.title, content: note.content };

      if (note && note.files) {
        // eslint-disable-next-line one-var
        var updatedFiles = note.files;

        return $http.put(url, data)
          .then(function(response) {

            var updatedNote = response.data;

            var imagePromises = [],
              filesToAdd = updatedFiles.filter(function(file) {
                // if no fileId, then it is a new image to be added
                return !file.fileId;
              }),
              filesToRemove = [];

            if (updatedNote.files) {
              updatedNote.files.forEach(function(file) {
                if (!_.find(updatedFiles, function(noteFile) {
                  return noteFile.fileId && noteFile.fileId === file.fileId;
                })) {
                  filesToRemove.push(file);
                }
              });
            }

            filesToAdd.forEach(function(file) {
              imagePromises.push(_addFileToNote(userId, updatedNote._id, file));
            });

            filesToRemove.forEach(function(file) {
              imagePromises.push(_removeFileFromNote(userId, updatedNote._id, file.fileId));
            });

            return $q.all(imagePromises);
          })
          .then(function() {
            return $http.get(url);
          });
      }

      return $http.put(url, data)
        .then(function(response) {
          return response.data;
        }
        );
    }

    function deleteNote(userId, noteId, admin) {
      var url = urlService.interpolate(config.apiBase + '/clients/{{id}}/notes/{{noteId}}?isCRM=true', { id: userId, noteId: noteId });
      if ( admin) {
        url = urlService.interpolate(config.apiBase + '/staffs/{{id}}/notes/{{noteId}}?isCRM=true', { id: userId, noteId: noteId });
      }
      return $http.delete(url)
        .then(function(response) {
          return response.data;
        }
        );
    }

    function createNote(userId, note, admin) {
      var url = urlService.interpolate(config.apiBase + '/clients/{{id}}/notes?isCRM=true', { id: userId });
      if ( admin) {
        url = urlService.interpolate(config.apiBase + '/staffs/{{id}}/notes?isCRM=true', { id: userId });
      }
      var data = { title: note.title, content: note.content };
      var returnedNote;
      return $http.post(url, data)
        .then(function(response) {
          returnedNote = response.data;

          if (note.files) {
            return $q.all(note.files.map(function(file) {
              return _addFileToNote(userId, returnedNote._id, file);
            }));
          }

          return $q.resolve(returnedNote);

        })
        .then(function() {
          return $http.get(url + '/' + returnedNote._id);
        });
    }

    function createDefaultNote(userId, note, admin,facilityId,defaultNoteId) {
      var url = urlService.interpolate(config.apiBase + '/clients/{{id}}/notes?isCRM=true', { id: userId });
      if ( admin) {
        url = urlService.interpolate(config.apiBase + '/staffs/{{id}}/notes?isCRM=true', { id: userId });
      }
      var data = { title: note.title, content: note.content, isDefault: true };
      var returnedNote;
      return $http.post(url, data)
        .then(function(response) {
          returnedNote = response.data;
          return $q.all(note.files.map(function(file) {
            return getDefaultNoteFile(facilityId, defaultNoteId, file,returnedNote._id,userId);
          }));
        });
    }
    function _addFileToNote(userId, noteId, file, admin) {
      var formData = new FormData();
      formData.append('userNoteFile', file);
      var url = urlService.interpolate(config.apiBase + '/clients/{{userId}}/notes/{{noteId}}/file?isCRM=true', {
        userId: userId,
        noteId: noteId
      });
      if (admin) {
        url = urlService.interpolate(config.apiBase + '/staffs/{{userId}}/notes/{{noteId}}/file?isCRM=true', {
          userId: userId,
          noteId: noteId
        });
      }
      return $http.put(
        url, formData, {
          transformRequest: angular.identity,
          headers: { 'Content-Type': undefined }
        });
    }

    function _removeFileFromNote(userId, noteId, fileId, admin) {
      var url = urlService.interpolate(config.apiBase + '/clients/{{userId}}/notes/{{noteId}}/file/{{fileId}}?isCRM=true', {
        userId: userId,
        noteId: noteId,
        fileId: fileId
      });
      if (admin) {
        url = urlService.interpolate(config.apiBase + '/staffs/{{userId}}/notes/{{noteId}}/file/{{fileId}}?isCRM=true', {
          userId: userId,
          noteId: noteId,
          fileId: fileId
        });
      }
      return $http.delete(url);
    }
  }
}());
(function() {
  'use strict';

  taskService.$inject = ['$q', 'config', '$http', '$translate'];
  angular.module('ptCrm')
    .service('taskService', taskService);

  function taskService($q, config, $http, $translate) {

    return {
      createTask: createTask,
      getTask: getTask,
      getTasks: getTasks,
      deleteTask: deleteTask,
      editTask: editTask,
      prepareTask: prepareTask,
      isTask: isTask
    };

    function getTask(id) {
      return $http.get(config.apiBase + '/tasks/' + id + '?isCRM=true').then(function(response) {
        return response.data;
      });
    }

    function getTasks(params) {
      return $http.get(config.apiBase + '/tasks?isCRM=true', { params: params })
        .then(function(response) {
          return response.data;
        });
    }

    function createTask(task) {
      return $http.post(config.apiBase + '/tasks?isCRM=true', task)
        .then(function(response) {
          return response.data;
        });
    }

    function deleteTask(id) {
      return $http.delete(config.apiBase + '/tasks/' + id + '?isCRM=true')
        .then(function(response) {
          return response.data;
        });
    }

    function editTask(task) {
      return $http.put(config.apiBase + '/tasks/' + task._id + '?isCRM=true', _.omit(task, '_id'))
        .then(function(response) {
          return response.data;
        });
    }

    // helper
    function prepareTask(user, task) {
      var from = moment.unix(task.startTime),
        to = moment.unix(task.endTime),
        caption = task.users.length + ' ' + $translate.instant('USERS'),
        // No image placeholder
        img = '//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png',
        userId = null,
        _id = task._id;

      // if start and end times is not in the same day -
      // then this day is fully occupied
      if (from.isSame(to, 'day')) {
        from = from.get('hours') + (from.get('minutes') ? 0.5 : 0);
        to = to.get('hours') + (to.get('minutes') ? 0.5 : 0);
      } else {
        from = 0;
        to = 24;
      }

      // as far as we have only one user
      // we use user info from model not from response
      if (task.users.length === 1) {
        caption = (user.firstName || '') + ' ' + (user.lastName || '');
        //                       No image placeholder
        img = user.pictureUrl || '//images.jhtassets.com/264082bb3a1af70d5499c7d22b0902cb454b6d12/';
        userId = user._id;
      }

      return {
        _id: _id,
        exerciserId: userId,
        timeFrom: from,
        timeTo: to,
        caption: caption,
        title: task.title,
        description: task.description,
        img: img,
        type: 'task'
      };

    }

    function isTask(item) {
      return item.type === 'task';
    }

  }
}());
(function() {
  'use strict';

  printService.$inject = ['$http', 'config', 'urlService', '$window', '$translate', 'convert'];
  angular.module('ptCrm')
    .service('printService', printService);

  function printService($http, config, urlService, $window, $translate, convert) {
    return {
      printExerciseTemplate: printExerciseTemplate,
      printTrainingSet: printTrainingSet,
      printExercise: printExercise,
      printAssignment: printAssignment,
      printSavedTrainingPlan: printSavedTrainingPlan,
      printAssignedTrainingPlan: printAssignedTrainingPlan,
      printOnTheFlyTrainingPlan: printOnTheFlyTrainingPlan
    };

    function printExerciseTemplate(item) {
      var printPopup = $window.open('', '_blank');
      getExerciseTemplatePDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printTrainingSet(item) {
      var printPopup = $window.open('', '_blank');
      getTrainingSetPDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printExercise(item) {
      var printPopup = $window.open('', '_blank');
      getExercisePDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printAssignment(item) {
      var printPopup = $window.open('', '_blank'),
        exerciserId = item.exerciserId;
      getAssignmentPDF(item).then(function(response) {
        openPdfInNewTab(printPopup, response, exerciserId);
      });
    }

    function printSavedTrainingPlan(plan) {
      var printPopup = $window.open('', '_blank');
      getSavedTrainingPlanPDF(plan).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function printAssignedTrainingPlan(assignedPlan, exerciserId) {
      var printPopup = $window.open('', '_blank');
      getAssignedTrainingPlanPDF(assignedPlan).then(function(response) {
        openPdfInNewTab(printPopup, response, exerciserId);
      });
    }

    function printOnTheFlyTrainingPlan(body) {
      var printPopup = $window.open('', '_blank');
      getOnTheFlyTrainingPlanPDF(body).then(function(response) {
        openPdfInNewTab(printPopup, response);
      });
    }

    function getExerciseTemplatePDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/exercise_templates/{{id}}/pdf?isCRM=true', { id: item._id }
        )
      );
    }

    function getTrainingSetPDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/training_sets/{{id}}/pdf?isCRM=true', { id: item._id }
        )
      );
    }

    function getExercisePDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/exercises/{{id}}/pdf?isCRM=true', { id: item._id }
        )
      );
    }

    function getAssignmentPDF(item) {
      return $http.post(
        urlService.interpolate(
          config.apiBase + '/assignments/{{id}}/pdf?isCRM=true', { id: item._id }
        )
      );
    }

    function getSavedTrainingPlanPDF(plan) {
      return $http.post(config.apiBase + '/saved_training_plans/' + plan._id + '/pdf?isCRM=true');
    }

    function getAssignedTrainingPlanPDF(plan) {
      return $http.post(config.apiBase + '/training_plans/' + plan._id + '/pdf?isCRM=true');
    }

    function getOnTheFlyTrainingPlanPDF(body) {
      var strippedData = JSON.parse(angular.toJson(body));
      strippedData = _convertSavedPlanToInternal(strippedData);
      return $http.post(config.apiBase + '/saved_training_plans/generated_pdf?isCRM=true', strippedData);
    }

    function openPdfInNewTab(popup, response, exerciserId) {
      popup.location.href = config.apiBase + '/pdfs/' + response.data.link +
        '?locale=' + $translate.preferredLanguage() + (exerciserId ? '&exerciserId=' + exerciserId : '') + '&isCRM=true';
    }

    function _convertSavedPlanToInternal(plan) {
      plan.workouts.forEach(function(workout) {
        workout.exercises = workout.exercises.map(function(exercise) {
          return convert.exerciseToInternal(_prepareExercise(exercise));
        });
      });
      return plan;
    }

    function _prepareExercise(exercise) {
      exercise.exerciseTemplateId = exercise.exerciseTemplateId || exercise._id;
      return _.omit(exercise, [
        'restricted',
        'facility',
        'totalDuration',
        'completedManually',
        'pictureUrl',
        'id',
        '_id',
        'isEditable',
        'featured'
      ]);
    }
  }
}());
(function() {

  forgotPasswordService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
  .factory('forgotPasswordService', forgotPasswordService);

  function forgotPasswordService($http, config) {
    return {
      request: function(email) {
        return $http.post(config.apiBase + '/forgot/request?isCRM=true', {
          email: email
        })
        .then(function(res) {
          return res.data;
        });
      },
      reset: function(token, password) {
        return $http.post(config.apiBase + '/forgot/reset?isCRM=true', {
          token: token,
          password: password
        })
        .then(function(res) {
          return res.data;
        });
      }
    };
  }
}());
(function() {
  'use strict';

  facilityAssignmentsService.$inject = ['$http', 'config', '$q', 'profileService', 'convert', 'metricsService', '$window'];
  angular.module('ptCrm')
    .service('facilityAssignmentsService', facilityAssignmentsService);

  function facilityAssignmentsService($http, config, $q, profileService, convert, metricsService, $window) {
    var date = {};

    return {
      getFacilityAssignmentsInMonth: function(monthStart, monthEnd) {
        return $http.get(config.apiBase + '/facility_assignments?isCRM=true', {
          params: {
            startDate: monthStart,
            endDate: monthEnd,
            preset: false
          }
        })
          .then(function(response) {
            if (response.status < 200 || response.status > 299) {
              return $q.reject(new Error('Bad response'));
            }
            if (response.data) {
              return response.data.map(function(assignment) {
                assignment.exercises = assignment.exercises.map(function(exercise) {
                  exercise.preset = metricsService.getPresetForExercise(exercise);
                  return exercise;
                });
                return convert.assignmentToExternal(assignment, profileService.user.settings.measurementUnit);
              });
            }
          })
          .catch(function(err) {
            // don't do anything with error here
            return [];
          });
      },
      getFacilityAssignmentById: function(id) {
        return $http.get(config.apiBase + '/facility_assignments/' + id + '?isCRM=true', {
          params: {
            preset: false
          }
        })
          .then(function(response) {
            if (response.data) {
              response.data.exercises = response.data.exercises.map(function(exercise) {
                exercise.preset = metricsService.getPresetForExercise(exercise);
                return exercise;
              });
              return convert.assignmentToExternal(response.data, profileService.user.settings.measurementUnit);
            }
          });
      },
      setNewAssignmentDate: function(startDate, endDate) {
        date = {
          startDate: startDate,
          endDate: endDate
        };
        $window.localStorage.setItem('newFacAssignmentStart', startDate);
        $window.localStorage.setItem('newFacAssignmentEnd', endDate);
      },
      getNewAssignmentDate: function() {
        if (_.isEmpty(date)) {
          date.startDate = +$window.localStorage.getItem('newFacAssignmentStart');
          date.endDate = +$window.localStorage.getItem('newFacAssignmentEnd');
        }
        return date;
      },
      createFacilityAssignment: function(body) {
        body = convert.assignmentToInternal(body, profileService.user.settings.measurementUnit);
        body.exercises = convert.removeExercisePreset(body.exercises);
        return $http.post(config.apiBase + '/facility_assignments?isCRM=true', body)
          .then(function(response) {
            return response.data;
          });
      },
      updateFacilityAssignment: function(id, body) {
        body = convert.assignmentToInternal(body, profileService.user.settings.measurementUnit);
        body.exercises = convert.removeExercisePreset(body.exercises);
        return $http.put(config.apiBase + '/facility_assignments/' + id + '?isCRM=true', body)
          .then(function(response) {
            return response.data;
          });
      },
      deleteFacilityAssignment: function(id) {
        return $http.delete(config.apiBase + '/facility_assignments/' + id + '?isCRM=true')
          .then(function(response) {
            return response.data;
          });
      }
    };
  }

}());

sprint8ExerciseHelperService.$inject = ['profileService', 'sprint8constant', '$translate'];angular.module('ptCrm')
  .service('sprint8ExerciseHelperService', sprint8ExerciseHelperService);

function sprint8ExerciseHelperService(profileService, sprint8constant, $translate) {
  var metric_units = false,
    MASTER_CHART_DATA = angular.copy(sprint8constant.MASTER_CHART_DATA);

  // if current user measurment is in metric, use MASTER_CHART_DATA_METRIC
  if (profileService.user.settings.measurementUnit === 'M') {
    MASTER_CHART_DATA = angular.copy(sprint8constant.MASTER_CHART_DATA_METRIC);
  }

  // returns: [#,#,#...]
  function getLevelIntervalData(equipmentType, sprintLevel) {
    if (validEquipmentType(equipmentType) && validLevel(sprintLevel)) {
      var equipmentData = MASTER_CHART_DATA[equipmentType];
      return equipmentData.levels[sprintLevel - 1].intervalData;
    }
    return null;
  }

  // returns the largest sprint value for a given equipment
  function getLargestDataPoint(equipmentType) {
    return validEquipmentType(equipmentType) ? MASTER_CHART_DATA[equipmentType].maxValue : sprint8constant.DEFAULT_LARGEST_DATA_POINT;
  }

  function getChartUnits(equipmentType) {
    return validEquipmentType(equipmentType) ?
      $translate.instant(MASTER_CHART_DATA[equipmentType].unit + '_CAPS') :
      $translate.instant(sprint8constant.DEFAULT_UNIT + '_CAPS');
  }

  // returns: [['#-# mph/lvl', 'optional incline: #-#%'],[<one for each lvl>],[]..., []]
  function getAllSprintIntervalTxt(equipmentType) {
    if (validEquipmentType(equipmentType)) {
      return MASTER_CHART_DATA[equipmentType].levels.reduce(function(rtnArray, lvl) {
        rtnArray.push(lvl.sprintIntervalTxt.map(function(txt, idx) {
          return $translate.instant(
            MASTER_CHART_DATA[equipmentType]['sprintIntervalTranslation' + idx],
            { n: txt }
          );
        }));
        return rtnArray;
      }, []);
    }
    return [];
  }

  // returns: [['#-# mph/lvl', 'optional incline: #-#%'],[<one for each lvl>],[]..., []]
  function getAllActiveRecoverTxt(equipmentType) {
    if (validEquipmentType(equipmentType)) {
      return MASTER_CHART_DATA[equipmentType].levels.reduce(function(rtnArray, lvl, idx) {
        rtnArray.push(lvl.activeRecoverTxt.map(function(txt, idx) {
          return $translate.instant(
            MASTER_CHART_DATA[equipmentType]['sprintIntervalTranslation' + idx],
            { n: txt }
          );
        }));
        return rtnArray;
      }, []);
    }
    return [];
  }

  function validEquipmentType(equipmentType) {
    return typeof MASTER_CHART_DATA[equipmentType] !== 'undefined';
  }

  function validLevel(lvl) {
    return (lvl && (lvl % 1) === 0 && lvl <= sprint8constant.MAX_LEVEL && lvl >= sprint8constant.MIN_LEVEL);
  }

  function getChartLabels() {
    return sprint8constant.CHART_LABELS;
  }

  function getChartBackgroundColors() {
    return sprint8constant.CHART_BACKGROUND_COLORS;
  }

  return {
    validEquipmentType: validEquipmentType,
    getLargestDataPoint: getLargestDataPoint,
    getChartUnits: getChartUnits,
    getLevelIntervalData: getLevelIntervalData,
    validLevel: validLevel,
    getAllSprintIntervalTxt: getAllSprintIntervalTxt,
    getAllActiveRecoverTxt: getAllActiveRecoverTxt,
    getChartLabels: getChartLabels,
    getChartBackgroundColors: getChartBackgroundColors
  };
}



/**
  * @ngdoc service
  * @name ptCrm.strengthEquipment
  * @description
  * Service that contains valid strength equipment types.
  * @example
  * strengthEquipment.getTypes returns an array of valid types.
**/
strengthEquipment.$inject = ['profileService'];
angular.module('ptCrm').service('strengthEquipment', strengthEquipment);
function strengthEquipment(profileService) {
  function getTypes(typeList) {
    if (typeList === 'functional') {
      return FUNCTIONAL_EQUIPMENT_TYPES;
    }
    return STRENGTH_EQUIPMENT_TYPES;
  }
  return {
    getTypes: getTypes
  };
}
var FUNCTIONAL_EQUIPMENT_TYPES = [
    'kettlebell',
    'freeweights',
    'barbell',
    'dumbbells',
    'resistancebands',
    'medicineball',
    'stabilityball',
    'bulgarianbags',
    'battleropes',
    'Plyo Boxes',
    'tire',
    'sandbags',
    'bosuball'
  ],
  STRENGTH_EQUIPMENT_TYPES = [
    'legextension',
    'seatedlegcurl',
    'abdominalcrunch',
    'convergingchestpress',
    'hipabductor',
    'hipadductor',
    'backextension',
    'independentbicepscurl',
    'calfextension',
    'freeweights',
    'glute',
    'kettlebell',
    'diverginglatpulldown',
    'lateralraise',
    'legpress',
    'pronelegcurl',
    'reardeltfly',
    'pecfly',
    'rotarytorso',
    'divergingseatedrow',
    'convergingshoulderpress',
    'tricepspress',
    'dumbbells',
    'barbell',
    'cables',
    'tricepsextension',
    'dependentcurl',
    'hipthrust',
  ];
angular.module('ptCrm').service('maintenanceModeInterceptor', ['$window', '$location', '$injector', 'config', '$q', function ($window, $location, $injector, config, $q) {
  return {
    responseError: function (response) {
      // If our api responds with a maintenance mode header, we bail to the maintenance page
      if (response.headers('X-Maintenance-Mode')) {
        $window.location.hash = '#/maintenance';
        return;
      } else if ((response.config.url.indexOf('/api/v1/health') < 0) && navigator.onLine) {
        var serverTest = $injector.get('serverStatus');
        serverTest.isServerReady().then(function (serverReady) {
          if (serverReady) {
            return;
          } else {
              $window.location.hash = '#/maintenance';
              return;
          }
        });
      }

      return $q.reject(response);
    },
  };
}]);
angular.module('ptCrm').service('serverStatus', ['$http', 'config', function ($http, config) {
  return {
    isServerReady: function () {
      return $http.get(config.apiBase + '/health?isCRM=true')
        .then(function (result) {
          return !(result.headers('X-Maintenance-Mode') === '1');
        }).catch(function () {
          return false;
        });
    }
  };
}]);angular.module('ptCrm').factory('fileVerify', function() {
  var fileTypes = ['image/png', 'image/jpeg', 'application/pdf'],
    maxSize = 10;
  return {
    verifyFileList: function(fileArr) {
      return fileArr.filter(function(file) {
        return _.includes(fileTypes, file.type) &&
          ((file.size/1024)/1024).toFixed(4) < maxSize;
      });
    }
  };
});(function() {
  'use strict';

  messagingService.$inject = ['$http', 'config', 'profileService', '$interval', '$rootScope', '$q'];
  angular.module('ptCrm')
    .service('messagingService', messagingService);

  function messagingService($http, config, profileService, $interval, $rootScope, $q) {

    var messageObj = {
        messages: [],
        threadList: [],
        messagingUsers: [],
        unreadMessages: false,
        lastMessageTime: 0,

        getMessages: getMessages,
        getMessagingUsers: getMessagingUsers,
        getThread: getThread,
        sendMessage: sendMessage,
        markMessageReadStatus: markMessageReadStatus
      },
      selfId = profileService.user._id;

    if (profileService.user.activeFacility.messaging) {
      // kick off initially
      getMessages();

      // refresh messages every 15 seconds
      $interval(getMessages, 15000);
    }

    return messageObj;

    function getMessages() {
      var url = config.apiBase + '/messages?isCRM=true';

      if (messageObj.lastMessageTime) {
        url += ('&newerThan=' + messageObj.lastMessageTime);
      }

      return $http.get(url)
      .then(function(res) {

        // console.log('got ' + res.data.length + ' new message(s) this refresh cycle');
        // update messageObj metadata
        messageObj.messages = _.uniq(messageObj.messages.concat(res.data), false, function(item) {
          return item._id;
        });

        messageObj.lastMessageTime = messageObj.messages.length ?
          _.maxBy(messageObj.messages, 'time').time : 0;

        messageObj.unreadMessages = _userHasUnreadMessages(messageObj.messages, selfId);
        return _generateThreadList(messageObj.messages);
      })
      .then(function() {
        // tell listening controllers about change to messageObj data
        $rootScope.$emit('messageUpdate');
      });
    }

    /**
     * 
     * for future if we want to change this get api to post api.
     */
    // function getMessagingUsers(extraUserIds) {
    //   var url = config.apiBase + '/messages/users?isCRM=true';
    //   return $http.post(url, {
    //     userIds: extraUserIds && extraUserIds.length ? extraUserIds : []
    //   })
    //     .then(function (res) {
    //       return res.data;
    //     });
    // }

    function chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    }
    
    function callApiForChunks(chunks, apiCall) {
      const promises = chunks.map(chunk => apiCall(chunk));
      return Promise.all(promises).then(responses => responses.flat());
    }

    function getMessagingUsers(extraUserIds) {
      var url = config.apiBase + '/messages/users?isCRM=true';
      if (!extraUserIds) {
        return $http.get(url)
          .then(function (res) {
            return res.data;
          });
      } else if (extraUserIds && extraUserIds.length > 300) {
        const chunks = chunkArray(extraUserIds, 300);
        return callApiForChunks(chunks, chunk =>
          $http.get(url + '&userIds=' + chunk.join(',')).then(res => res.data)
        );
      }
    
      return $http.get(url + '&userIds=' + extraUserIds.join(','))
        .then(res => res.data);
    }
        

    function getThread(userId) {
      return $http.get(config.apiBase + '/messages/thread/' + userId + '?isCRM=true')
      .then(function(res) {
        return res.data;
      });
    }

    function markMessageReadStatus(messageId, status) {
      return $http.put(config.apiBase + '/messages/message/' + messageId + '?isCRM=true', {
        read: status
      })
      .then(function() {
        var idx = _.findIndex(messageObj.messages, function(item) {
          return item._id === messageId;
        });
        messageObj.messages[idx].read = status;
      });
    }

    function sendMessage(userId, messageText) {
      return $http.post(config.apiBase + '/messages/thread/' + userId + '?isCRM=true', {
        message: messageText
      })
      .then(function(res) {
        return res.data;
      });
    }

    function _userHasUnreadMessages(messages, userId) {
      return _.some(messages, function(msg) {
        return msg.to === userId && !msg.read;
      });
    }

    function _generateThreadList(messages) {
      var threadObj = {};

      messages.forEach(function(message) {
        if (threadObj[message.threadId]) {
          threadObj[message.threadId].mostRecent = Math.max(message.time, threadObj[message.threadId].mostRecent);
          threadObj[message.threadId].unreadMessages =
            threadObj[message.threadId].unreadMessages ||
            message.to === selfId && !message.read;
        } else {
          threadObj[message.threadId] = {
            threadId: message.threadId,
            mostRecent: message.time,
            unreadMessages: message.to === selfId && !message.read,
            otherUserId: message.to === selfId ? message.from : message.to
          };

          if (messageObj.messagingUsers) {
            var userIdx = _.findIndex(messageObj.messagingUsers, function(user) { return user._id === threadObj[message.threadId].otherUserId; });
            if (userIdx > -1) {
              threadObj[message.threadId].otherUser = _.clone(messageObj.messagingUsers[userIdx]);
            }
          }
        }
      });

      var threadList = _.values(threadObj);

      var promise = $q.resolve();

      if (threadList.filter(function(thread) { return !thread.otherUser; }).length) {
        promise = getMessagingUsers(threadList.map(function(thread) { return thread.otherUserId; }))
          .then(function(users) {
            messageObj.messagingUsers = users.map(function(user) {
              user.fullName = user.firstName + ' ' + user.lastName;
              return user;
            });
            threadList.forEach(function(thread) {
              var userIdx = _.findIndex(messageObj.messagingUsers, function(user) { return user._id === thread.otherUserId; });
              if (userIdx > -1) {
                thread.otherUser = _.clone(messageObj.messagingUsers[userIdx]);
              }
            });
          });
      }

      if (threadList.length === 0) {
        promise = getMessagingUsers()
          .then(function(users) {
            messageObj.messagingUsers = users.map(function(user) {
              user.fullName = user.firstName + ' ' + user.lastName;
              return user;
            });
          });
      }

      return promise.then(function() {
        messageObj.threadList = threadList;
      });
    }
  }
}());
angular.module('ptCrm').service('metricsService', ['$http', 'config', 'EQUIPMENT_PRESET', '$q', 'convert', 'profileService', 'exerciseMetaData', '$translate', function($http, config, EQUIPMENT_PRESET, $q, convert, profileService, exerciseMetaData, $translate) {
  var metricsList = [],
    presetsObj = {};

  return {
    getMetrics: function() {
      return $http.get(config.apiBase + '/metrics?isCRM=true')
      .then(function(res) {
        metricsList = res.data;
        presetsObj = metricsList.reduce(function(memo, curr) {
          memo[curr.type] = {
            metrics: curr.metrics
          };

          if (curr.maxSegments) {
            memo[curr.type].maxSegments = curr.maxSegments;
          }

          return memo;
        }, {});
      });
    },
    getEquipmentPresets: function() {
      var promise = _.isEmpty(presetsObj) ? this.getMetrics() : $q.resolve();
      return promise
      .then(function() {
        var equipmentPresets = [];
        EQUIPMENT_PRESET.forEach(function(preset) {
          var enhanced = _.clone(preset);
          enhanced.metrics = presetsObj[preset.metrics].metrics.map(function(metric) {
            return convert.presetMetricToExternal(metric, profileService.user.settings.measurementUnit);
          });
          enhanced.maxSegments = presetsObj[preset.metrics].maxSegments || 0;
          equipmentPresets.push(enhanced);
        });
        return equipmentPresets;
      });
    },
    getPresetForExercise: function(exercise) {
      var classification = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular).classifyExercise(exercise),
        equipmentType = _.get(exercise, 'equipmentType'),
        cardioProgramId = _.get(exercise, 'assignedProfile.cardioProgram.cardioProgramId'),
        typeString,
        programIdString;

      if (classification && equipmentType) {
        typeString = classification + ':' + equipmentType;
      }

      if (classification && equipmentType && cardioProgramId) {
        programIdString = classification + ':' + equipmentType + ':' + cardioProgramId;
      }

      if (presetsObj[classification]) {
        return presetsObj[classification];
      } else if (presetsObj[typeString]) {
        return presetsObj[typeString];
      } else if (presetsObj[programIdString]) {
        return presetsObj[programIdString];
      } else {
        return presetsObj['non-connected-exercise'];
      }
    }
  };

}]);angular.module('ptCrm').constant('EQUIPMENT_PRESET', [
  {
    category: 'Running',
    equipmentType: 'Treadmill',
    metrics: 'connected-exercise:Treadmill'
  },
  {
    category: 'Running',
    equipmentType: 'Bike',
    metrics: 'connected-exercise:Bike'
  },
  {
    category: 'Running',
    equipmentType: 'Elliptical',
    metrics: 'connected-exercise:Elliptical'
  },
  {
    category: 'Running',
    equipmentType: 'Arc_Trainer',
    metrics: 'connected-exercise:Arc_Trainer'
  },
  {
    category: 'Running',
    equipmentType: 'Stepper',
    metrics: 'connected-exercise:Stepper'
  },
  {
    category: 'Running',
    equipmentType: 'Climbmill',
    metrics: 'connected-exercise:Climbmill'
  },
  {
    category: 'Strength',
    metrics: 'strength-exercise'
  },
  {
    category: 'Stretching',
    metrics: 'non-connected-exercise'
  },
  {
    category: 'Class',
    metrics: 'non-connected-exercise'
  },
  {
    category: '3rd Party App',
    metrics: 'non-connected-exercise'
  },
  {
    category: 'Other',
    metrics: 'non-connected-exercise'
  },
  {
    category: 'Functional',
    metrics: 'functional-exercise'
  }
]);

biometricsService.$inject = ['$http', '$window', '$translate', 'config', 'profileService'];angular.module('ptCrm')
  .service('biometricsService', biometricsService);

function biometricsService(
  $http,
  $window,
  $translate,
  config,
  profileService
) {

  var KG_TO_LB = 2.2046,
    M_TO_CM = 100,
    M_TO_IN = 39.3700,
    M_TO_FT = 3.28084,
    FT_TO_IN = 12,
    MULTIPLICATIVE_IDENTITY = 1;

  return {
    getBiometrics: function(userId) {
      return $http.get(config.apiBase + '/clients/' + userId + '/biometrics?isCRM=true')
        .then(function(response) {
          return response.data.map(convertToExternal);
        })
        .catch(function() {
          return [];
        });
    },
    postBiometrics: function(userId, metricName, value, goalValue, unitType) {
      var body = {
        value: value,
        goalValue: goalValue
      };
      if (unitType) {
        body.unitType = unitType;
        body.value = convertToInternal(value, unitType);
      }
      return $http.post(config.apiBase + '/clients/' + userId + '/biometrics/' + metricName + '?isCRM=true', body);
    },
    putBiometrics: function(userId, metricName, metricId, value, unitType) {
      return $http.put(config.apiBase + '/clients/' + userId + '/biometrics/' + metricName + '/' + metricId + '?isCRM=true', {
        value: convertToInternal(value, unitType)
      });
    },
    putHiddenBiometrics: function(userId, list) {
      return $http.put(config.apiBase + '/clients/' + userId + '/hidden_biometrics?isCRM=true',{ hiddenBiometrics: list });
    },
    getHiddenBiometrics: function(userId) {
      return $http.get(config.apiBase + '/clients/' + userId + '/hidden_biometrics?isCRM=true');
    },
    exportCSV: exportCSV
  };

  function convertToExternal(biometric) {
    if (!biometric.unitType || biometric.unitType === 'bpm') {
      return biometric;
    }

    var metric = profileService.user.settings.measurementUnit === 'M',
      converted = _convertValueFields(biometric, _getConversionFactor(biometric.unitType, metric));
    converted.history = _.orderBy(converted.history, ['timestamp'], ['asc']);
    return converted;
  }

  function convertToInternal(value, unitType) {
    if (!unitType || unitType === 'bpm') {
      return value;
    }

    var metric = profileService.user.settings.measurementUnit === 'M';

    // we currently won't have inputs for length_long values, this is future proofing
    if (unitType === 'length_long' && !metric) {
      return _feetAndInchesToMeters(value);
    }

    return _convertToInternalValue(value, _getConversionFactor(unitType, metric));
  }

  // TODO: add work from PT-4473 after PT-4923 is done
  // PT-4937 - Commenting out the rounding out logic, may come up again in the future
  function _convertValueFields(biometric, conversionFactor) {
    var lengthLong = biometric.unitType && biometric.unitType === 'length_long',
      metric = profileService.user.settings.measurementUnit === 'M',
      decimals = 2;
    //   roundToNearest = biometric.unitType && biometric.unitType === 'length_short' ?
    //     0.5 : 0.1;

    // if (metric && lengthLong) {
    //   roundToNearest = 0.01;
    // }

    biometric.goal.forEach(function(entry) {
      entry.value = lengthLong && !metric ?
        _metersToFeetAndInches(entry.value) :
        _formatBodyStat(Number(entry.value * conversionFactor).toFixed(decimals).toString());
    });


    biometric.history.forEach(function(entry) {
      entry.value = lengthLong && !metric ?
        _metersToFeetAndInches(entry.value) :
        _formatBodyStat(Number(entry.value * conversionFactor).toFixed(decimals).toString());
    });
    return biometric;
  }
  // PT-4937 - Body stat formatting
  function _formatBodyStat(currBiometricValue) {
    if (typeof currBiometricValue === 'string') {
      if (currBiometricValue.indexOf('.') !== -1) {
        var splitBiometricVal = currBiometricValue.split('.');
        return splitBiometricVal.length > 1 && splitBiometricVal[1] !== '00' ? Number(currBiometricValue).toFixed(2) : splitBiometricVal[0];
      }
    }
    return currBiometricValue;
  }

  function _convertToInternalValue(value, conversionFactor) {
    return value / conversionFactor;
  }

  function _getConversionFactor(unitType, metric) {
    switch (unitType) {
    case 'weight':
      return metric ? MULTIPLICATIVE_IDENTITY : KG_TO_LB;
    case 'length_short':
      return metric ? M_TO_CM : M_TO_IN;
    case 'length_long':
      return metric ? MULTIPLICATIVE_IDENTITY : M_TO_FT;
    default:
      return MULTIPLICATIVE_IDENTITY;
    }
  }

  function _round(value, roundToNearest) {
    return Math.round(value / roundToNearest) * roundToNearest;
  }

  function _metersToFeetAndInches(meterValue) {
    var feet = meterValue * M_TO_FT,
      remainder = feet % 1;

    return (feet - remainder) + '\'' + _round(FT_TO_IN * remainder, 1) + '"';
  }

  function _feetAndInchesToMeters(feetAndInches) {
    var matches = new RegExp(/([\d]+)'([\d]+)"/gm).exec(feetAndInches);
    return ((FT_TO_IN * +matches[1]) + (+matches[2])) / M_TO_IN;
  }

  function exportCSV(stats, clientName) {
    var biometricsNameList = _.map(stats, function(stat) {
        return {
          biometricName: stat.biometricName,
          unitType: stat.unitType
        };
      }),
      dateProp = $translate.instant('DATE'),
      dateFormat = profileService.user.settings.dateFormat,
      Papi = $window.Papa,
      saveAs = $window.saveAs,
      mappedData = [];
    stats.forEach(function(stat) {
      stat.goal.forEach(function(goalEntry) {
        mappedData.push(generateRow(
          biometricsNameList,
          goalEntry,
          stat.biometricName,
          true
        ));
      });
      stat.history.forEach(function(historyEntry) {
        mappedData.push(generateRow(
          biometricsNameList,
          historyEntry,
          stat.biometricName,
          false
        ));
      });
    });

    mappedData.sort(function(a, b) { // Sort the entries from most recent to oldest
      if (a[dateProp] > b[dateProp]) {
        return -1;
      } else if (a[dateProp] < b[dateProp]) {
        return 1;
      }
      return 0;
    });
    mappedData = mappedData.map(function(value) {
      value[dateProp] = moment.unix(value[dateProp]).format(dateFormat);
      return value;
    });

    var csvStats = Papi.unparse(mappedData), // eslint-disable-line one-var
      blob = new Blob([csvStats], {
        type: 'text/csv;charset=utf-8'
      });
    saveAs(blob, clientName + '.csv', true);

  }

  function generateRow(biometricsNameList, entry, statName, goal) {
    var newObj = {},
      rowData = {},
      goalBiometricTitle,
      biometricName,
      rowName,
      nameListEntry,
      dateTitle = $translate.instant('DATE');
    newObj[dateTitle] = '--';
    biometricsNameList.forEach(function(item) {
      goalBiometricTitle = $translate.instant('GOAL_STAT', { stat: $translate.instant(item.biometricName.toUpperCase()) });
      biometricName = $translate.instant(item.biometricName.toUpperCase());
      if (item.unitType) {
        goalBiometricTitle = appendUnits(item.unitType,goalBiometricTitle);
        biometricName = appendUnits(item.unitType,biometricName);
      }
      newObj[goalBiometricTitle] = '--';
      newObj[biometricName] = '--';
    });
    rowData[dateTitle] = entry.timestamp;
    nameListEntry = _.find(biometricsNameList, { biometricName: statName });
    rowName = goal ? $translate.instant('GOAL_STAT', { stat: $translate.instant(statName.toUpperCase()) }) : $translate.instant(statName.toUpperCase());
    if (nameListEntry.unitType) {
      rowName = appendUnits(nameListEntry.unitType,rowName);
    }
    rowData[rowName] = entry.value;
    return _.assign(newObj, rowData);
  }

  function appendUnits(unitType,titleString) {
    if (!unitType) {
      return titleString;
    }
    var unit;
    if (unitType === 'weight') {
      unit = profileService.user.settings.measurementUnit === 'M'? 'KG': 'LB';
    }
    if (unitType === 'length_short') {
      unit = profileService.user.settings.measurementUnit === 'M'? 'CM': 'INCH';
    }
    if (unitType === 'length_long') {
      unit = profileService.user.settings.measurementUnit === 'M'? 'METER': 'FT';
    }
    if (unitType === 'heartrate') {
      unit = 'BPM';
    }
    return titleString + ' (' + $translate.instant(unit) + ')';
  }
}angular.module('ptCrm').service('reminderService', ['config', '$http', function(config, $http) {
  return {
    setReminder: function(userId, date) {
      return $http.post(config.apiBase + '/messages/reminder/' + userId + '?isCRM=true', {
        time: date
      });
    }
  };
}]);angular.module('ptCrm').service('workoutHistoryService', ['$http', 'config', '$q', '$filter', 'profileService', '$translate', function($http, config, $q, $filter, profileService, $translate) {
  var workoutHistoryCache = {},
    conversions = {
      distance: {
        METERS: 1, // distance units are in meters from the API
        KILOMETERS: 0.001,
        MILES: 0.000621371,
        FEET: 3.28084
      },
      speed: {
        KILOMETERS_PER_HOUR: 1, // speed units are in kmph from the API
        MILES_PER_HOUR: 0.621371
      },
      weight: {
        GRAMS: 1, // weight units are in grams from the API
        KG: 0.001,
        LBS: 0.00220462
      }
    },
    STEPS_PER_FLOOR = 16,
    units = profileService.user.settings.measurementUnit;

  return {
    getWorkoutHistory: function(userId) {
      var promise = workoutHistoryCache[userId] && workoutHistoryCache[userId].length ?
        $q.resolve(workoutHistoryCache[userId]) :
        _fetchWorkoutHistory(userId);

      return promise
        .then(function(res) {
          return _groupDataByDate(res);
        });
    }
  };

  function _fetchWorkoutHistory(userId) {
    return $http.get(config.apiBase + '/clients/' + userId + '/workout_history?isCRM=true')
      .then(function(res) {
        workoutHistoryCache[userId] = res.data;
        return workoutHistoryCache[userId];
      })
      .catch(function() {
        workoutHistoryCache[userId] = [];
        return workoutHistoryCache[userId];
      });
  }

  function _groupDataByDate(history) {
    return _.chain(history)
      .sortBy('workout_time')
      .reverse()
      .groupBy(function(item) { return $filter('dateFormatter')(moment(item.workout_time), 'dateMedium'); })
      .toPairs()
      .map(function(item) { return { date: item[0], exercises: _enhanceWorkouts(item[1]), showDetails: false }; } )
      .value();
  }

  function _enhanceWorkouts(workouts) {
    return _.map(workouts, function(workout) {
      workout.cardName = workout.exercise_title || workout.machine_type || 'UNKNOWN';

      if (workout.workout_type !== 'strength') {
        workout.displayStats = _cardioDisplayStats(workout);
      } else {
        workout.displayStats = _strengthDisplayStats(workout);
      }

      return workout;
    });
  }

  function _cardioDisplayStats(workout) {
    var displayStats = {};
    if (workout.calories) {
      displayStats.CALORIES = workout.calories;
    }

    if (workout.duration) {
      displayStats.DURATION = _formattedDuration(workout.duration);
    }

    if (workout.machine_type === 'climbmill' || workout.machine_type === 'stepper') {
      displayStats.DISTANCE = $translate.instant('N_FLOORS', { n: _round(workout.distance / STEPS_PER_FLOOR, 2) });
    } else {
      displayStats.DISTANCE = $translate.instant(units === 'M' ? 'N_KM' : 'N_MI', {
        n: _round(workout.distance *= (units === 'M' ? conversions.distance.KILOMETERS : conversions.distance.MILES), 2)
      });
    }

    return displayStats;
  }

  function _strengthDisplayStats(workout) {
    var displayStats = {};

    if (workout.sets.length) {
      displayStats.TOTAL_SETS_REPS = $translate.instant('N_SETS', { n: workout.sets.length }) + ' / ' + $translate.instant('N_REPS', { n: _strengthTotalReps(workout.sets) });
      displayStats.TOTAL_WEIGHT = $translate.instant(units === 'M' ? 'N_KG' : 'N_LBS', { n: _strengthTotalWeight(workout.sets) });
    }
    return displayStats;
  }

  function _formattedDuration(seconds) {
    if (_.isUndefined(seconds) || !_.isNumber(+seconds)) {
      return '';
    }
    var duration = moment.duration(+seconds, 'seconds');
    if (duration.asMinutes() >= 60) {
      return moment.utc(duration.asMilliseconds()).format('H[h] mm[m]');
    }
    return moment.utc(duration.asMilliseconds()).format('m[m] ss[s]');
  }

  function _round(value, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  }

  function _strengthTotalReps(sets) {
    return _.reduce(sets, function(memo, set) {
      return memo + set.reps.length;
    }, 0);
  }

  function _strengthTotalWeight(sets) {
    var totalGrams = _.reduce(sets, function(memo, set) {
      return memo + (set.weight * set.reps.length);
    }, 0);

    totalGrams *= (units === 'M' ? conversions.weight.KG : conversions.weight.LBS);
    return _round(totalGrams, 2);
  }
}]);(function() {
  'use strict';

  authConfig.$inject = ['$httpProvider'];
  angular.module('ptCrm')
    .config(authConfig);

  function authConfig($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
  }

}());



(function() {
  'use strict';

  loginController.$inject = ['authService', '$state', 'storageService', 'toastr', '$translate', 'profileService', 'USER_HOME_PAGE', 'metricsService'];
  angular.module('ptCrm')
    .controller('LoginController', loginController);

  function loginController(authService, $state, storageService, toastr, $translate, profileService, USER_HOME_PAGE, metricsService) {

    var vm = this;

    vm.user = {};
    vm.login = login;


    function login() {
      authService.login(vm.user).then(function(data) {
        storageService.setToken(data.authToken);
        profileService.authorize()
        .then(metricsService.getMetrics)
        .then(function() {
          if ($state.params.next) {
            window.location.href = decodeURIComponent($state.params.next);
          } else {
            return $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS),
              { reload: false, notify: false })
              .finally(authService.refreshPage);
          }
        })
          .catch(function(err) {
            if (err.status === 404) {
              toastr.error($translate.instant('ERROR_NO_PERMISSIONS'));
            }
          });
      }, function(e) {
        if (e.status === 401) {
          toastr.error($translate.instant('ERROR_LOGIN_INCORRECT'));
        } else {
          toastr.error($translate.instant('ERROR_COMMON'));
        }
      });
    }

  }
}());
(function() {

  'use strict';

  dashboardController.$inject = ['$q', '$state', 'exercisersService', 'assignmentsService', 'taskService', 'profileService', 'workInfoService'];
  angular.module('ptCrm')
    .controller('DashboardController', dashboardController);

  function dashboardController($q, $state, exercisersService, assignmentsService, taskService, profileService, workInfoService) {

    var vm = this;

    vm.timelineClients = [];
    vm.anytimeClients = [];
    vm.workInfo = null;
    vm.today = moment();
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.clients = {};
    vm.user = profileService.user;
    vm.onEditAssigment = onEditAssigment;
    vm.onEditTask = onEditTask;

    getClientGroups();
    getTodayAppointments();
    getUserWorkInfo();

    function getClientGroups() {
      var groups = [
        'interested',
        'in_gym',
        'at_risk'
      ];

      _.each(groups, function(group) {
        _getExercisersDataByFilter(group).then(function(data) {
          vm.clients[group] = data;
        });
      });

    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId, roles: user.roles[0] });
      }
    }

    function getTodayAppointments() {
      var now = moment();

      return $q.all([
        assignmentsService.getAssignments({
          startDate: now.startOf('day').unix(),
          endDate: now.endOf('day').unix()
        })
          .then(function(response) {
            return assignmentsService.getAppointedAssignments(response.data);
          }),
        taskService.getTasks({ userId: vm.user._id,
          startTime: now.startOf('day').unix(),
          endTime: now.endOf('day').unix()
        })
          .then(function(response) {
            return response.data.map(function(task) {
              return taskService.prepareTask(vm.user, task);
            });
          })
      ])
        .then(function(response) {
          var allClients = response[0].concat(response[1]);
          vm.timelineClients = _.filter(allClients, function(assignment) {
            return assignment.scheduleType ?
              assignment.scheduleType === 'appointment' : !(assignment.timeFrom === 0 && assignment.timeTo === 24);
          });
          vm.anytimeClients = _.filter(allClients, function(assignment) {
            return assignment.scheduleType ?
              assignment.scheduleType !== 'appointment' : assignment.timeFrom === 0 && assignment.timeTo === 24;
          });
        });
    }

    function getUserWorkInfo() {
      return workInfoService.getStaffWorkInfo(vm.user._id)
        .then(function(workInfo) {
          vm.workInfo = workInfo;
        });
    }

    function _getExercisersDataByFilter(filter) {
      return exercisersService.getCSExercisers({ filter: filter }).then(function(res) {
        return res.data;
      });
    }

    function onEditAssigment(assignment) {
      if (assignment._id) {
        if (assignment.recurrence) {
          assignmentsService.chooseAssignmentEditMode({ id: assignment._id });
        } else {
          $state.go('app.assignment', { id: assignment._id });
        }
      }
    }

    function onEditTask(task) {
      if (task._id) {
        $state.go('app.task', {
          id: task._id,
          userId: task.exerciserId,
          isMe: task.exerciserId === 'me' || task.exerciserId === profileService.user._id
        });
      }
    }
  }
}());
(function() {
  'use strict';

  CalendarController.$inject = ['$scope', '$state', 'assignmentsService', 'exercisersService', 'taskService', 'profileService', 'userService', '$q'];
  angular.module('ptCrm').controller('CalendarController', CalendarController);

  function CalendarController($scope, $state,
    assignmentsService, exercisersService, taskService, profileService, userService, $q) {

    var vm = this;

    vm.monthOffset = 6;
    vm.isLoading = true;

    vm.selectedDate = $state.params.date ? moment.unix($state.params.date) : moment();
    vm.selectedUser = { _id: $state.params.userId || profileService.user._id };

    vm.users = [];

    vm.showTimeline = false;
    $scope.$on('calendar-body:day:init', chooseDateIfUserIsReady);
    vm.timelineDisplayDate = null;

    // public methods
    vm.selectMonth = selectMonth;
    vm.chooseDate = chooseDate;
    vm.addEvent = addEvent;
    vm.toggleTimelineVeiw = toggleTimelineVeiw;
    vm.selectSiblingDay = selectSiblingDay;
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.onEditAssigment = onEditAssigment;
    vm.onEditTask = onEditTask;
    vm.changeUser = changeUser;
    vm.getFullUserName = userService.getFullUserName;
    vm.searchByName = searchByName;
    vm.loadUsersByName = loadUsersByName;

    _calculateRange();
    var userReadyPromise = getPaginatedClients().then(function(response) { // eslint-disable-line one-var
      vm.showSpinner = true;
      vm.loadedUsers = response;
      response.loadClientStaff().then(function(loadedUsers) {
        vm.users = _.chain([profileService.user])
          .unionBy(loadedUsers.data, '_id')
          .map(function(user) {
            return _.assign(user, { fullName: userService.getFullUserName(user) });
          })
          .value();
        if ((profileService.user._id !== vm.selectedUser._id) && !(_.find(vm.users, { _id: vm.selectedUser._id }))) {
          if ($state.params.roles && $state.params.roles === 'facility_staff') {
            exercisersService.getTrainers(vm.selectedUser._id).then(function(user) {
              user.fullName = userService.getFullUserName(user);
              vm.selectedUser = user;
              vm.searchStr = vm.selectedUser.fullName;
              vm.showSpinner = false;
            });
          } else {
            exercisersService.getExerciser(vm.selectedUser._id).then(function(user) {
              user.fullName = userService.getFullUserName(user);
              vm.selectedUser = user;
              vm.searchStr = vm.selectedUser.fullName;
              vm.showSpinner = false;
            });
          }
        } else {
          vm.selectedUser = _.find(vm.users, { _id: vm.selectedUser._id });
          vm.searchStr = vm.selectedUser.fullName;
          vm.showSpinner = false;
        }

      });

    });
    function getPaginatedClients() {
      return $q.resolve(exercisersService.getClientStaffPaginateList());
    }
    function searchByName(searchName) {
      return loadUsersByName(searchName).then(function(result) {
        return result.data.map(function(user) {
          return _.assign(user, { fullName: userService.getFullUserName(user) });
        });
      });
    }
    function loadUsersByName(searchName) {
      return vm.loadedUsers
        .extendDefaultParams({ search: searchName })
        .loadClientStaff({ update: true });
    }
    function selectSiblingDay(dayDiff) {
      if (vm.selectedDate && _.isNumber(dayDiff)) {
        var newDay = moment(vm.selectedDate).add(dayDiff, 'day'),
          isSameMonth = newDay.isSame(vm.selectedDate, 'month');

        _updateSelectedDate(newDay);

        if (!isSameMonth) {
          _calculateRange();
        }

        $scope.$broadcast('calendar:day:changed', newDay);
      }
    }

    function selectMonth(monthNumber, year) {
      var newDate = moment(vm.selectedDate).set('month', monthNumber).set('year', year);
      _updateSelectedDate(newDate);
      toggleTimelineVeiw(false);
      _updateTimelineClients([]);
      _calculateRange();

      $scope.$broadcast('calendar:month:changed', monthNumber, year);
    }

    function toggleTimelineVeiw(force) {
      vm.showTimeline = _.isUndefined(force) ? !vm.showTimeline : !!force;
    }

    function _updateSelectedDate(date) {
      vm.selectedDate = date;
      vm.timelineDisplayDate = date;
    }

    function chooseDateIfUserIsReady() {
      var args = arguments;
      return userReadyPromise.then(function() {
        chooseDate.apply(null, args);
      }).finally(function() {
        vm.isLoading = false;
      });
    }

    function chooseDate(clickEvent, day) {
      var assignments = _.chain(day.events)
          .filter({ type: 'assignment' })
          .map('assignment')
          .map(assignmentsService.getAppointedAssignment.bind(null, vm.selectedUser))
          .value(),

        tasks = _.chain(day.events)
          .filter({ type: 'task' })
          .map('assignment')
          .map(taskService.prepareTask.bind(null, vm.selectedUser))
          .value(),

        events = assignments.concat(tasks);
      _updateSelectedDate(day.moment);
      _updateTimelineClients(events);

      // show timeline only after click on calendar day
      if (clickEvent) {
        toggleTimelineVeiw(true);
      }
    }

    function addEvent(day) {
      var destination = _.includes(vm.selectedUser.roles, 'client') ? 'app.assignment' : 'app.task';
      return $state.go(destination, {
        startDate: day.moment.startOf('day').unix(),
        endDate: day.moment.clone().endOf('day').unix(),
        userId: vm.selectedUser._id,
        isMe: vm.selectedUser._id === 'me' || vm.selectedUser._id === profileService.user._id
      });
    }

    function _updateTimelineClients(list) {
      list = _.isArray(list) ? list : [];
      vm.timelineClients = _.filter(list, function(assignment) {
        return assignment.scheduleType ?
          assignment.scheduleType === 'appointment' : !(assignment.timeFrom === 0 && assignment.timeTo === 24);
      });
      vm.anytimeClients = _.filter(list, function(assignment) {
        return assignment.scheduleType ?
          assignment.scheduleType !== 'appointment' : assignment.timeFrom === 0 && assignment.timeTo === 24;
      });
    }

    function _calculateRange() {
      var range,
        month,
        selectedDate = moment(vm.selectedDate)
          .set('date', 1)
          .subtract(vm.monthOffset, 'months');

      range = [{
        number: selectedDate.month(),
        displayText: selectedDate.format('MM'),
        year: selectedDate.format('YYYY')
      }];

      vm.fromYear = selectedDate.year();
      for (month = 0; month < 11; month++) {
        selectedDate.add(1, 'months');
        range.push({
          number: selectedDate.month(),
          displayText: selectedDate.format('MM'),
          year: selectedDate.format('YYYY')
        });
      }
      vm.toYear = selectedDate.year();

      vm.monthRange = range;
    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId,roles:$state.params.roles });
      }
    }

    function onEditAssigment(assignment) {
      if (assignment._id) {
        if (assignment.recurrence) {
          assignmentsService.chooseAssignmentEditMode({ id: assignment._id, userId: assignment.exerciserId });
        } else {
          $state.go('app.assignment', { id: assignment._id, userId: assignment.exerciserId });
        }
      }
    }

    function onEditTask(task) {
      if (task._id) {
        $state.go('app.task', {
          id: task._id,
          userId: task.exerciserId,
          isMe: task.exerciserId === 'me' || task.exerciserId === profileService.user._id
        });
      }
    }

    function changeUser(user) {
      $state.go('app.calendar', { userId: user._id, date: moment(vm.timelineDisplayDate).unix(),roles:user.roles[0] });
    }

  }


}());


(function() {
  'use strict';

  userController.$inject = ['$uibModal', '$translate', '$state', 'Upload', 'popup', 'CertificationsList', 'config', 'assignmentsService', 'exercisersService', 'userPermissionsService', 'formatUserService', 'profileService', 'userService', 'printService', 'authService', '$filter', 'forgotPasswordService', 'exerciseMetaData', 'workInfoService', 'trainingPlanService', 'reminderService', 'toastr', 'workoutHistoryService', '$rootScope', 'displayMetrics', 'facilityService', 'PermissionStore', 'staffMessagingService'];
  angular.module('ptCrm')
    .controller('UserController', userController);

  function userController($uibModal, $translate, $state, Upload, popup, CertificationsList, config,
    assignmentsService, exercisersService, userPermissionsService, formatUserService, profileService,
    userService, printService, authService, $filter, forgotPasswordService, exerciseMetaData,
    workInfoService, trainingPlanService, reminderService, toastr, workoutHistoryService, $rootScope, displayMetrics, facilityService,
    PermissionStore,staffMessagingService) {
    var vm = this,
      isMe = $state.params.userId === 'me' || $state.params.userId === profileService.user._id,
      exerciseMetaDataInstance = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular);
    vm.isMe = isMe;
    vm.isAdmin = profileService.user.admin;
    vm.userId = isMe ? profileService.user._id : $state.params.userId;
    vm.isSmartHealthFacility = profileService.user.club.smartHealthEnabled;
    vm.user = {};
    vm.loggedInUser = formatUserService.destructureUser(profileService.user);
    vm.assignments = assignmentsService.getClientAssignmentsPaginateList(vm.userId);
    vm.trainingPlans = trainingPlanService.getClientTrainingPlansPaginateList(vm.userId);
    vm.certifications = new CertificationsList(vm.userId);
    vm.forms = {};
    vm.permissions = userPermissionsService.getUserStaticPermissions(isMe);
    vm.initialDataIsLoaded = false;
    vm.languages = config.availableLanguages.map(function(langCode) { return langCode.toUpperCase(); });
    vm.showFuture = true;
    vm.showPast = false;
    vm.showPlans = false;
    vm.showActivePlans = true;
    vm.showCompletedPlans = false;
    vm.showResetLoading = false;
    vm.showCertificateSavebar = false;
    vm.selectedAssignmentSubtab = 'assignments';
    vm.assignmentFromCurrentFacility = function(assignment) {
      return _.get(assignment, 'facility._id') === profileService.user.activeFacility._id;
    };
    vm.makeWeekSubtitle = makeWeekSubtitle;
    vm.selectedSessions = {};
    vm.facilityWorkoutHistoryEnabled = profileService.user.activeFacility.workoutHistory;

    vm.weightUnit = profileService.user.settings.measurementUnit === 'I' ? 'LB' : 'KG';

    vm.membershipGroup = [];
    vm.userMembershipGroups = [];
    vm.userMembershipGroupsCopy = [];

    vm.membershipGroupEnabled = profileService.user.activeFacility.settings.membershipGroups &&
      profileService.user.activeFacility.settings.membershipGroups !== undefined;

    vm.dateFormat = profileService.user.settings.dateFormat.split('')
      .map(function(char) {
        return (char === 'Y' || char === 'D') ? char.toLowerCase() : char;
      }).join('');

    _.extend(vm, {
      loadAssignments: loadAssignments,
      initialLoadAssignments: initialLoadAssignments,
      hasDescription: hasDescription,
      uploadImg: uploadImg,
      save: saveData,
      savePersonalInfo: savePersonalInfo,
      saveWorkInfo: saveWorkInfo,
      updateTrainerClients: updateTrainerClients,
      updateClientFlags: updateClientFlags,
      reset: resetClientData,
      resetWorkInfoData: resetWorkInfoData,
      removeTrainer: removeTrainer,
      removeClient: removeClient,
      showTrainerPopup: showTrainerPopup,
      showClientPopup: showClientPopup,
      showDeleteAcc: showDeleteAcc,
      resetPassword: resetPassword,
      changePassword: changePassword,
      deleteUser: deleteUser,
      showDeleteButton: showDeleteButton,
      showCompletionState: showCompletionState,
      onEditAssigment: onEditAssigment,
      onEditPlan: onEditPlan,
      onDeleteAssignment: onDeleteAssignment,
      onCompleteExercise: onCompleteExercise,
      onMassCompleteAssignment: onMassCompleteAssignment,
      onDeletePlan: onDeletePlan,
      onCopyAssignment: onCopyAssignment,
      onCopyPlan: onCopyPlan,
      printAssignment: printAssignment,
      printPlan: printPlan,
      extendPlan: extendPlan,
      updateAvatar: updateAvatar,
      removeFromFacility: removeFromFacility,
      setCertificateSavebar: setCertificateSavebar,
      goToUserAssignmentView: goToUserAssignmentView,
      planIsActive: planIsActive,
      selectSession: selectSession,
      togglePlan: togglePlan,
      isExerciseSkipped: isExerciseSkipped,
      incompleteExercises: incompleteExercises,
      changeSubtab: changeSubtab,
      onClickReminder: onClickReminder,
      loadWorkoutHistory: loadWorkoutHistory,
      isShowable: isShowable,
      updateSelection: updateSelection,
      isUserMembershipGroupChecked: isUserMembershipGroupChecked,
      isEditable: isEditable,
      getUserMembershipGroupNames: getUserMembershipGroupNames
    });

    init();

    async function init() {
      var fetchUserDetails,
        user_memberships;
      if (vm.isMe) {
        fetchUserDetails = exercisersService.getTrainers($state.params.userId);
      } else if (($state.params && $state.params.roles === 'client') || ($state.params.tab === 'assignments')) {
        fetchUserDetails = exercisersService.getClientExerciser($state.params.userId);
      } else {
        fetchUserDetails =exercisersService.getStaffExerciser($state.params.userId);
      }
      if (($state.params && $state.params.roles === 'facility_staff') && profileService.permissionNames.includes("ALL_USER_MESSAGES_READ")) {
        await staffMessagingService.getMessages($state.params.userId);
     }
      // eslint-disable-next-line no-unused-expressions
      fetchUserDetails
        .then(_assignResponseClient)
        .then(saveBackup.bind(this, 'all'))
        .then(function() {
          if (($state.params && $state.params.roles === 'client') || ($state.params.tab === 'assignments')) {
            return workInfoService.getClientWorkInfo($state.params.userId);
          }
          return workInfoService.getStaffWorkInfo($state.params.userId);
        })
        .then(function(response) {
          vm.workInfo = _mapWorkInfoResponse(response);
          return vm.workInfo;
        })
        .then(saveBackup.bind(this, 'workInfo'))
        .finally(function() {
          vm.initialDataIsLoaded = true;
          vm.workoutHistoryEnabled = _.has(vm.user, 'settings.showWorkoutHistory') ? _.get(vm.user, 'settings.showWorkoutHistory') : vm.facilityWorkoutHistoryEnabled;
        });
       
      facilityService.getFacilityMembershipGroups(profileService.user.activeFacility._id)
        .then(function(groups) {
          vm.membershipGroup = groups;
        });

      if (($state.params && $state.params.roles === 'client') || ($state.params.tab === 'assignments') ) {
        user_memberships = userService.getClientUserMembershipGroups(profileService.user.activeFacility._id, vm.userId);
      } else {
        user_memberships = userService.getStaffUserMembershipGroups(profileService.user.activeFacility._id, vm.userId);
      }
      user_memberships
        .then(function(response) {
          if (response && response.length && response[0].memberships && response[0].memberships.length && response[0].memberships[0].membershipGroups) {
            vm.userMembershipGroups = response[0].memberships[0].membershipGroups;
            vm.userMembershipGroupsCopy = vm.userMembershipGroups.slice();
          }
        });
    }

    function isUserMembershipGroupChecked(groupId) {
      return vm.userMembershipGroups.includes(groupId);
    }

    function getUserMembershipGroupNames() {
      var names = [];
      for (var i = 0; i < vm.userMembershipGroups.length; i++) { //eslint-disable-line
        var index = vm.membershipGroup.findIndex(function(group) { //eslint-disable-line
          return group._id === vm.userMembershipGroups[i];
        });
        if (index !== -1) {
          names.push(vm.membershipGroup[index].name);
        }
      }
      return names;
    }

    function isEditable(permissionList) {
      var permissions = Object.keys(PermissionStore.getStore());
      function includesValue(mainArr, target) {
        return target.some(function(value) {
          return mainArr.includes(value);
        });
      }
      return includesValue(permissions, permissionList);
    }

    function removeFromFacility(user) {
      return popup.confirm({
        title: $translate.instant('REMOVE_USER_FROM_FACILITY'),
        description: $translate.instant('CONFIRM_REMOVE_USER_FROM_FACILITY'),
        templateUrl: '/app/user/tabs/removeFromFacility/removeFromFacility.html',
        scope: {
          user: user,
          facility: user.personalInfo.club
        }
      })
        .then(function() {
          return removeUser(user);
        })
        .then(function() {
          $state.go('app.users.list');
        });
    }

    function removeUser(user) {
      if (user && user.roles && user.roles['facility_staff']) {
        userService
          .getStaffUserMembershipGroups(
            profileService.user.activeFacility._id,
            user._id
          ) //eslint-disable-line
          .then(function(groups) {
            if (
              groups &&
              groups.length &&
              groups[0].memberships &&
              groups[0].memberships.length &&
              groups[0].memberships[0].membershipGroups
            ) {
              var allGroups = groups[0].memberships[0].membershipGroups;
              userService.deleteStaffUserMembershipGroup(
                profileService.user.activeFacility._id,
                user._id,
                allGroups
              );
            }
          });
        userService.removeStaffFromFacility(user._id);
      } else {
        userService
          .getClientUserMembershipGroups(
            profileService.user.activeFacility._id,
            user._id
          ) //eslint-disable-line
          .then(function(groups) {
            if (
              groups &&
              groups.length &&
              groups[0].memberships &&
              groups[0].memberships.length &&
              groups[0].memberships[0].membershipGroups
            ) {
              var allGroups = groups[0].memberships[0].membershipGroups;
              userService.deleteClientUserMembershipGroup(
                profileService.user.activeFacility._id,
                user._id,
                allGroups
              );
            }
          });
        userService.removeClientFromFacility(user._id);
      }
    }

    function initialLoadAssignments() {
      vm.initialLoad = true;
      vm.completeSkipLoading = false;
      return loadAssignments()
        .then(function() {
          vm.initialLoad = false;
        });
    }

    function loadWorkoutHistory() {
      vm.loadingHistory = true;
      workoutHistoryService.getWorkoutHistory(vm.userId)
        .then(function(history) {
          vm.workoutHistory = history;
          vm.loadingHistory = false;
        });
    }

    function loadAssignments() {
      return Promise.all([
        vm.assignments.load({ responseExtract: extractAssignmentMetadata })
          .then(function() {
            vm.futureAssignments = _.filter(vm.assignments.items, function(assignment) {
              return !assignment.isPassed;
            });
            vm.pastAssignments = _.filter(vm.assignments.items, function(assignment) {
              return assignment.isPassed;
            });
          }),
        vm.trainingPlans.load({ responseExtract: extractPlanMetadata })
          .then(function() {
            _partitionTrainingPlans(vm.trainingPlans.items);
          })
      ]);
    }

    function _assignResponseClient(user) {
      vm.user = formatUserService.destructureUser(user);
      $rootScope.activeUserName = user.firstName + ' ' + user.lastName;
      vm.permissions = _.extend(vm.permissions,
        userPermissionsService.getUserDynamicPermissions(isMe, !!vm.user.roles.client));
      // if showWorkoutHistory has not been set but facility level it is enabled, override the setting
      // so that the setting box is checked if it has never been set
      if (!_.has(vm.user, 'settings.showWorkoutHistory') && vm.facilityWorkoutHistoryEnabled) {
        vm.user.settings.showWorkoutHistory = vm.facilityWorkoutHistoryEnabled;
      }
      return vm.user;
    }

    function extractAssignmentMetadata(assignments) {
      if (_.isEmpty(assignments)) {
        return assignments;
      }

      return _.map(assignments, function(assignment) {
        return _.extend({}, assignment, _prepareAssignments(assignment));
      });
    }

    function extractPlanMetadata(plans) {
      if (_.isEmpty(plans)) {
        return plans;
      }

      plans.forEach(function(plan) {
        plan.weeks = _.map(plan.weeks, function(week) {
          return _.map(week, function(assignment) {
            return _.extend({}, assignment, _prepareAssignments(assignment));
          });
        });
      });

      return plans;
    }

    function _prepareAssignments(assignment) {

      // TODO: reafactor
      var result = {
          showDetails: false
        },

        ds = moment.unix(assignment.startDate),
        de = moment.unix(assignment.endDate),
        wholeDayInSeconds;

      if (ds.isDST() && !de.isDST()) {
        // if day starts in DST and ends not in it, day is "25" hours
        wholeDayInSeconds = 89999;
      } else if (!ds.isDST() && de.isDST()) {
        // if day starts not in DST and ends in it, day is "23" hours
        wholeDayInSeconds = 82799;
      } else {
        // else 86399 seconds = 24 hours - 1 second, the timespan of an "all day" event
        wholeDayInSeconds = 86399;
      }


      if (assignment.startDate || assignment.endDate) {
        // 86399 seconds = 24 hours - 1 second, the timespan of an "all day" event
        if (de.diff(ds, 'seconds') < wholeDayInSeconds) {
          if (ds.isSame(de, 'day')) {
            // add 1 second because PTP intervals end 1 second before we would normally think to so as to have no overlap
            result.date = $filter('dateFormatter')(ds, 'time') + ' - '
              + $filter('dateFormatter')(de.add(1, 'second'), 'time')
              + ' ' + $filter('dateFormatter')(ds, 'dateMedium');
          } else {
            result.date = $filter('dateFormatter')(ds, 'mediumDateTime')
              + ' - ' + $filter('dateFormatter')(de.add(1, 'second'), 'mediumDateTime');
          }
        } else if (de.diff(ds, 'seconds') === wholeDayInSeconds) {
          if (ds.isSame(de, 'day')) {
            result.date = $filter('dateFormatter')(ds, 'dateMedium');
          } else {
            result.date = $filter('dateFormatter')(ds, 'dateMedium')
              + ' - ' + $filter('dateFormatter')(de, 'dateMedium');
          }
        } else {
          result.date = $filter('dateFormatter')(ds, 'dateMedium')
            + ' - ' + $filter('dateFormatter')(de, 'dateMedium');
        }
      }

      result.count = assignment.exercises.length;
      result.completedCount = assignment.exercises.filter(function(exercise) {
        if (!exercise.completeState) {
          return exercise.completedProfile;
        }

        return exercise.completeState !== 'not_complete';
      }).length;

      result.exercises = assignment.exercises.map(function(ex) {
        return angular.extend(ex, exercisersService.parseExercise(ex));
      });

      result.exercises = result.exercises.map(function(ex) {
        ex.displayData = displayMetrics(ex, profileService.user.settings.measurementUnit, $translate.instant, true);
        return ex;
      });

      result.isPassed = moment().isAfter(moment.unix(assignment.endDate));

      result.title = assignmentsService.assignmentTitle(assignment);

      return result;
    }

    function makeWeekSubtitle(sessions, weekIndex) {
      if (sessions.length === 1) {
        return '(' + $translate.instant('TRAINING_SESSION_N', { n: (weekIndex + 1) }) + ')';
      }
      var range = ((weekIndex * sessions.length) + 1) + ' - ' + (((weekIndex * sessions.length) + 1) + sessions.length - 1);
      return '(' + $translate.instant('TRAINING_SESSION_RANGE', { n: range }) + ')';
    }

    function hasDescription(ex) {
      return ex.description && (ex.description.length > 0);
    }


    //  =============== USER DETAILS SECTION ==============

    function removeTrainer(trainer) {
      vm.user.trainers = _.without(vm.user.trainers, trainer);
      vm.forms.trainers.$setDirty();
    }

    function removeClient(client) {
      vm.user.clients = _.without(vm.user.clients, client);
      vm.forms.clients.$setDirty();
    }

    function saveBackup(subj, data) {
      if (subj === 'all') {
        vm.backup = angular.copy(data);
      } else {
        vm.backup[subj] = angular.copy(data);
      }
    }

    // =========== SAVE USER DATA BLOCK ================

    function updateSelection($event, groupId) {
      var checkbox = $event.target;
      if (checkbox.checked) {
        vm.userMembershipGroups.push(groupId);
      } else {
        var index = vm.userMembershipGroups.indexOf(groupId); // eslint-disable-line
        vm.userMembershipGroups.splice(index, 1);
      }
      vm.forms.personalInfoClient.$setDirty();
    }

    function saveData(subj, data, role, user) {
      role = role || '';
      if (!role) {
        role= $state.params.roles;
      }
      var updatedUser = formatUserService.restructureUser(subj, data);

      if (role === 'client' || ((Object.keys(user.roles)[0] === 'client') && Object.keys(user.roles).length === 1)) {
        userService.updateClientUser(updatedUser, vm.userId).then(function() {
          if (subj === 'settings') {
            _updateSettings(updatedUser);
          }
        })
          .then(saveBackup.bind(this, subj, data));
        userService.updateClientUserMembershipGroups(profileService.user.activeFacility._id, vm.userId, vm.userMembershipGroups)
          .then(function() {
            vm.userMembershipGroupsCopy = vm.userMembershipGroups.slice();
            vm.forms.personalInfoClient.$setPristine();
          })
          .then(saveBackup.bind(this, subj, data));
        if (subj === 'settings') {
          vm.forms[subj+role].$setPristine();
        } else {
          vm.forms[subj].$setPristine();
        }
      } else {
        userService.updateStaffUser(updatedUser, vm.userId).then(function() {
          if (subj === 'settings') {
            _updateSettings(updatedUser);
          }
        })
          .then(saveBackup.bind(this, subj, data));
        userService.updateStaffUserMembershipGroups(profileService.user.activeFacility._id, vm.userId, vm.userMembershipGroups)
          .then(function() {
            vm.userMembershipGroupsCopy = vm.userMembershipGroups.slice();
            vm.forms.personalInfoClient.$setPristine();
          })
          .then(saveBackup.bind(this, subj, data));
      }
      if (role === 'Facility') {
        vm.forms[subj + role].$setPristine();
      } else {
        vm.forms[subj].$setPristine();
      }



    }

    function savePersonalInfo(subj, data, role,user) {
      if (!isValidPersonalInfo()) {
        popup.alert({
          title: $translate.instant('FORM_VALIDATION_ALERT_MSG')
        });
      } else {
        saveData(subj, data, role,user);
      }
    }

    function isValidPersonalInfo() {
      return !(vm.forms.personalInfoClient.$error.pattern || vm.forms.personalInfoClient.$error.required);
    }

    //  here is separated methods because we have serparated endpoints
    function saveWorkInfo(workInfo) {
      var formattedWorkInfo = _.mapValues(workInfo.days, function(val) {
        val = _.map(val, function(timeItem) {
          return {
            min: moment(timeItem.min).format('HH:mm'),
            max: moment(timeItem.max).format('HH:mm')
          };
        });
        return val;
      });
      workInfoService.putWorkInfo(vm.userId, formattedWorkInfo)
        .then(function(response) {
          vm.workInfo = _mapWorkInfoResponse(response);
          return vm.workInfo;
        })
        .then(saveBackup.bind(this, 'workInfo'));
      vm.forms.workInfo.$setPristine();
    }

    function updateTrainerClients(clients) {
      var clientsIds = _.map(clients, '_id');
      userService.updateStaffTrainerClients(clientsIds, vm.userId)
        .then(saveBackup.bind(this, 'clients', clients));
      vm.forms.clients.$setPristine();
    }

    function updateClientFlags(value, field) {
      switch (field) {
      default:
        break;
      case 'interested':
        userService.updateClientUser({
          clientProfile: {
            interested: value
          }
        }, vm.userId);
        break;
      }
    }

    function resetClientData(subj, role) {
      role = role || '';
      vm.user[subj] = angular.copy(vm.backup[subj]);
      vm.userMembershipGroups = vm.userMembershipGroupsCopy.slice();
      vm.forms[subj + role].$setPristine();
    }

    function resetWorkInfoData() {
      vm.workInfo = angular.copy(vm.backup.workInfo);
      vm.forms.workInfo.$setPristine();
    }

    // ====================== POPUPS SECTION =================

    // ============= TRAINER POPUP  ==========
    function showTrainerPopup() {
      var handler = function(trainers) {
        // selected from popup
          vm.user.trainers = vm.user.trainers.concat(trainers);
          vm.forms.trainers.$setDirty();
        },
        errorHandler = function(reason) {
          if (reason === 'ALL_USERS_SELECTED') {
            popup.alert({
              title: $translate.instant(reason)
            });
          }
        };

      return showAddUserPopup(vm.user.trainers, 'facility_staff', vm.user).result.then(handler, errorHandler);
    }

    // ============= CLIENT POPUP  ==========
    function showClientPopup() {
      var handler = function(clients) {
          vm.user.clients = vm.user.clients.concat(clients);
          vm.forms.clients.$setDirty();
        },
        errorHandler = function(reason) {
          if (reason === 'ALL_USERS_SELECTED') {
            popup.alert({
              title: $translate.instant(reason)
            });
          }
        };

      return showAddUserPopup(vm.user.clients, 'client', vm.user).result.then(handler, errorHandler);
    }

    function showAddUserPopup(chosenUsers, userType, subjectUser) {
      return $uibModal.open({
        windowClass: 'modal--trainer user-details__trainer-popup',
        controller: 'userModalController',
        controllerAs: 'usersCtrl',
        templateUrl: '/app/user/tabs/userDetails/userModal/userModal.html',
        bindToController: true,
        resolve: {
          chosenUsers: function() {
            return chosenUsers;
          },
          userType: function() {
            return userType;
          },
          subjectUser: function() {
            return subjectUser;
          }
        }
      });
    }

    // ============ DELETE ACCOUNT POPUP ===========
    function showDeleteAcc(user) {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_ACCOUNT?'),
        description: $translate.instant('DELETE_ACCOUNT_MESSAGE'),
        templateUrl: '/app/user/tabs/userDetails/deleteAccount/deleteAccount.html',
        scope: {
          user: user
        }
      }).then(function() {
        userService.deleteAccount(user._id)
          .then(function() {
            popup.alert({
              title: $translate.instant('ACCOUNT_DELETED')
            });
          });
      });
    }

    function resetPassword() {
      vm.showResetLoading = true;
      forgotPasswordService.request(vm.user.personalInfo.email)
        .then(function() {
          vm.showResetLoading = false;
          return popup.alert({
            title: $translate.instant('PASSWORD_RESET_SENT')
          });
        });
    }

    function changePassword() {
      return $uibModal.open({
        // windowClass: 'modal--workout-accomplishment-status',
        templateUrl: '/app/user/tabs/userDetails/changePassword/change-password-modal.html',
        resolve: {
          userId: function() {
            return vm.userId;
          }
        },
        controller: 'changePasswordModalController',
        controllerAs: 'changePasswordController',
        bindToController: true
      });
    }
    function showDeleteButton(user) {
      if (vm.user.isDemoUser && !user.admin) {
        return false;
      }
      return true;
    }

    function deleteUser() {
      return $uibModal.open({
        templateUrl: '/app/user/tabs/userDetails/deleteUser/delete-user-modal.html',
        resolve: {
          userId: function() {
            return vm.userId;
          }
        },
        controller: 'deleteUserModalController',
        controllerAs: 'deleteUserController',
        bindToController: true
      });
    }

    function uploadImg() {
    }

    function onEditAssigment(assignment, event) {
      if (assignment.parentAssignmentId) {
        if (assignment.recurrence) {
          event.stopPropagation();
          assignmentsService.chooseAssignmentEditMode({ id: assignment.parentAssignmentId });
        } else {
          $state.go('app.assignment', { id: assignment.parentAssignmentId });
        }
      }
    }

    function onEditPlan(plan, event) {
      event.stopPropagation();
      $state.go('app.trainingPlan', { id: plan._id });
    }

    function extendPlan(plan, event) {
      $uibModal.open({
        windowClass: 'modal--extend-training-plan',
        templateUrl: '/app/user/tabs/assignments/extend-training-plan-modal.html',
        controller: 'extendTrainingPlanModalController',
        controllerAs: 'extendTrainingPlanController',
        bindToController: true,
        resolve: {
          trainingProgram: function() {
            return plan;
          }
        }
      }).result.then(function(data) {
        var extendedPlanBody = {
          planName: plan.planName,
          repeats: plan.repeats + data.numWeeksToExtend,
          workouts: plan.workouts
        };
        trainingPlanService.updateTrainingPlanById(plan._id, extendedPlanBody)
          .then(function(response) {
            $state.reload();
          })
          .catch(function(error) {
            if (error.status === 409) {
              return popup.alert({
                title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
                description: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM_MESSAGE')
              });
            }
            return popup.alert({
              title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
              description: error
            });
          });
      });
    }

    function onDeletePlan(plan, event) {
      event.stopPropagation();
      return $uibModal.open({
        windowClass: 'modal--delete-training-plan',
        templateUrl: '/app/user/tabs/assignments/delete-training-plan-modal.html',
        resolve: {},
        controller: 'deleteTrainingPlanModalController',
        controllerAs: 'deleteTrainingPlanController',
        bindToController: true
      }).result.then(function(res) {
        return trainingPlanService.deleteTrainingPlanById(plan._id, res.cancel, res.allUsers ? undefined : vm.userId);
      })
        .then(function() {
          return vm.trainingPlans.load({ responseExtract: extractPlanMetadata, update: true });
        })
        .then(function() {
          _partitionTrainingPlans(vm.trainingPlans.items);
        });
    }

    function onDeleteAssignment(assignment, event) {
      event.stopPropagation();
      return $uibModal.open({
        windowClass: 'modal--delete-assignment',
        templateUrl: '/app/user/tabs/assignments/delete-assignment-modal.html',
        resolve: {
          massAssignment: assignmentsService.getAssignmentsById(assignment.parentAssignmentId)
        },
        controller: 'deleteAssignmentModalController',
        controllerAs: 'deleteAssignmentModalController',
        bindToController: true
      }).result.then(function(res) {
        return assignmentsService.deleteMassAssignment(assignment.parentAssignmentId, res.deleteAll);
      }).then(function() {
        $state.reload();
      });
    }

    function onCompleteExercise(exercise, event) {
      event.stopPropagation();
      return $uibModal.open({
        windowClass: 'modal--complete-exercise',
        templateUrl: '/app/user/tabs/assignments/skip-complete-modal.html',
        resolve: {
          hasId: function() {
            return exercise._id;
          },
          isCompleted: function() {
            return exercise.completeState === 'completed_manually' ||
              exercise.completeState === 'completed_automatically' ||
              exercise.completeState === 'skipped' ||
              exercise.completedProfile;
          }
        },
        controller: 'completeExerciseModalController',
        controllerAs: 'completeExerciseModalController',
        bindToController: true
      }).result.then(function(res) {
        switch (res.action) {
        case 'skip':
          vm.completeSkipLoading = true;
          return assignmentsService.skipExercise(exercise._id, exercise.category).catch(function(error) {
            vm.completeSkipLoading = false;
            if (error.status === 403) {
              return popup.alert({
                title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
                description: error.data.message
              });
            }
            return popup.alert({
              title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
              description: $translate.instant('ERROR_COMMON')
            });
          });
        case 'complete':
          vm.completeSkipLoading = true;
          return assignmentsService.completeExercise(exercise).catch(function(error) {
            vm.completeSkipLoading = false;
            if (error.status === 403) {
              return popup.alert({
                title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
                description: error.data.message
              });
            }
            return popup.alert({
              title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
              description: $translate.instant('ERROR_COMMON')
            });
          });
        case 'uncomplete':
          return assignmentsService.uncompleteExercise(exercise._id);
        default:
          return;
        }
      }).then(function() {
        $state.reload();
      });
    }

    function onMassCompleteAssignment(exercises, isSkip, event) {
      event.stopPropagation();
      return $uibModal.open({
        windowClass: 'modal--mass-complete',
        templateUrl: '/app/user/tabs/assignments/mass-complete-modal.html',
        controller: 'massCompleteModalController',
        controllerAs: 'massCompleteModalController',
        resolve: {
          allExercises: function() {
            return exercises;
          },
          isSkip: function() {
            return isSkip;
          }
        },
        bindToController: true
      }).result.then(function() {
        $state.reload();
      });
    }

    function onCopyAssignment(assignment) {
      if (assignment.parentAssignmentId) {
        $state.go('app.assignment', { copyFrom: assignment.parentAssignmentId });
      }
    }

    function onCopyPlan(plan, event) {
      var planCopy = _.clone(plan);
      $state.go('app.trainingPlan', { copyFrom: planCopy._id });
    }

    function setCertificateSavebar(buttonPressed) {
      vm.showCertificateSavebar = (buttonPressed === 'add' || buttonPressed === 'delete');
    }

    // ============ SHOW COMPLETION STATE POPUP ===========
    function showCompletionState(assignment, exercise, plan) {
      return $uibModal.open({
        windowClass: 'modal--workout-accomplishment-status',
        templateUrl: '/app/user/tabs/assignments/assignment-status-modal.html',
        resolve: {
          selectedExercise: function() {
            return exercise;
          },
          selectedAssignment: function() {
            return assignment;
          },
          assignments: function() {
            return _.filter(vm.assignments.items, 'isPassed');
          },
          selectedPlan: function() {
            return plan;
          }
        },
        controller: 'workoutStatusModalController',
        controllerAs: 'workoutStatusController',
        bindToController: true
      });
    }

    function printAssignment(exercise, event) {
      event.stopPropagation();
      printService.printAssignment(exercise);
    }

    function printPlan(plan, event) {
      event.stopPropagation();
      printService.printAssignedTrainingPlan(plan, vm.userId);
    }

    // ============ UPDATE AVATAR ===========
    function updateAvatar(file,user) {
      var apiPrefix;
      if (file) {
        if ((Object.keys(user.roles)[0] === 'facility_staff') || Object.keys(user.roles).length > 1) {
          apiPrefix = config.apiBase + '/staffs/'+ vm.user._id + '/avatars?isCRM=true';
        } else {
          apiPrefix = config.apiBase + '/clients/'+ vm.user._id + '/avatars?isCRM=true';
        }
        // var apiPrefix = config.apiBase + {vm.role === 'client'? '/clients/' : '/staffs/'} + vm.user._id + '/avatars?isCRM=true';
        return Upload.upload({
          url: apiPrefix,
          data: {
            picture: file
          }
        }).then(function(response) {
          vm.user.pictureUrl = response.data;

          if (isMe) {
            profileService.user.pictureUrl = response.data;
          }
        });
      }
    }

    function goToUserAssignmentView() {
      popup.confirm({
        title: $translate.instant('SELECT_ASSIGNMENT_TYPE'),
        templateUrl: '/app/components/left_menu/assignment_flow.html',
        showOk: false,
        okAction: function(popupScope, modalInstance) {
          if (popupScope.okArgs) {
            var type = popupScope.okArgs[0];
            if (type === 'assignment') {
              $state.go('app.assignment', {
                prevState: 'app.users.details',
                prevParams:{ userId: vm.userId },
                userId: vm.userId
              });
              modalInstance.close();
            }
            if (type === 'trainingPlan') {
              $state.go('app.trainingPlan', {
                prevState: 'app.users.details',
                prevParams:{ userId: vm.userId },
                userId: vm.userId
              });
              modalInstance.close();
            }
          }
        }
      });
    }

    function _updateSettings(updatedUser) {
      var newLang = _.get(updatedUser, 'settings.language'),
        oldLang = _.get(vm.backup, 'settings.language'),

        newUnits = _.get(updatedUser, 'settings.measurementUnit'),
        oldUnits = _.get(vm.backup, 'settings.measurementUnit'),

        newDateFormat = _.get(updatedUser, 'settings.dateFormat'),
        oldDateFormat = _.get(vm.backup, 'settings.dateFormat'),

        newTimeFormat = _.get(updatedUser, 'settings.timeFormat'),
        oldTimeFormat = _.get(vm.backup, 'settings.timeFormat'),

        newShowWorkoutHistory = _.get(updatedUser, 'settings.showWorkoutHistory'),
        oldShowWorkoutHistory = _.get(vm.backup, 'settings.showWorkoutHistory');

      // Have to reload page due to one-time bindings
      if (isMe && (
        (newLang && newLang !== oldLang) ||
        (newUnits && newUnits !== oldUnits) ||
        (newDateFormat && newDateFormat !== oldDateFormat) ||
        (newTimeFormat && newTimeFormat !== oldTimeFormat) ||
        (newShowWorkoutHistory && newShowWorkoutHistory !== oldShowWorkoutHistory)
      )) {
        authService.refreshPage();
      }
    }

    function _mapWorkInfoResponse(workInfo) {
      var mappableFields = ['days', 'otherFacilityHours'];
      mappableFields.forEach(function(item) {
        if (workInfo[item]) {
          workInfo[item] = _.mapValues(workInfo[item], function(day) {
            return day.map(function(item) {
              var minSplit = item.min.split(':'),
                maxSplit = item.max.split(':');
              return {
                min: new Date(1970, 0, 1, minSplit[0], minSplit[1], 0),
                max: new Date(1970, 0, 1, maxSplit[0], maxSplit[1], 0)
              };
            });
          });
        }
      });
      return workInfo;
    }

    function planIsActive(plan) {
      var allComplete = _.every(plan.weeks, function(week) {
        return _.every(week, function(assignment) {
          return assignment.completedCount === assignment.count;
        });
      });
      return plan.status === 'Active' && !allComplete;
    }

    function getCompletionDate(plan) {
      var maxDate = 0;
      plan.weeks.forEach(function(week) {
        week.forEach(function(assignment) {
          assignment.exercises.forEach(function(exercise) {
            if (exercise.completedDate && exercise.completedDate > maxDate) {
              maxDate = exercise.completedDate;
            }
          });
        });
      });
      plan.completionDate = maxDate;
      return plan;
    }

    function getActiveWeek(plan) {
      var highestGeneratedWeek = 0;

      plan.weeks.forEach(function(week) {
        if (_.every(week, function(assignment) {
          return _.has(assignment, '_id');
        })) {
          highestGeneratedWeek++;
        }
      });

      plan.activeWeekNumber = highestGeneratedWeek;
      plan.activeWeek = highestGeneratedWeek > 0 ?
        // WEEK_OF: 'Week {{current}} of {{total}}'
        $translate.instant('WEEK_OF', { current: highestGeneratedWeek, total: plan.weeks.length }) :
        $translate.instant('NOT_STARTED');

      return plan;
    }

    function _partitionTrainingPlans(plans) {
      var partition = _.partition(plans, function(plan) {
        return vm.planIsActive(plan);
      });
      vm.activeTrainingPlans = _.map(partition[0], getActiveWeek);
      vm.completedTrainingPlans = _.map(partition[1], getCompletionDate);
    }

    function togglePlan(plan) {
      plan.showDetails = !plan.showDetails;

      if (plan.showDetails && !vm.selectedSessions[plan._id]) {
        var highGeneratedWeek = _.findLastIndex(plan.weeks, function(week) {
            return _.every(week, function(assignment) {
              return assignment._id;
            });
          }),
          highCompletedAssignment,
          allAssignmentsCompletedInWeek,
          lastWeek,
          weekToShow,
          sessionToShow;

        if (highGeneratedWeek === -1) {
          weekToShow = 0;
          sessionToShow = 0;
        } else {
          lastWeek = (highGeneratedWeek === plan.weeks.length - 1);
          highCompletedAssignment = _.findIndex(plan.weeks[highGeneratedWeek], function(assignment) {
            return assignment.completedCount !== assignment.count;
          });

          allAssignmentsCompletedInWeek = highCompletedAssignment === -1;

          if (allAssignmentsCompletedInWeek && lastWeek) {
            weekToShow = plan.weeks.length - 1;
            sessionToShow = plan.weeks[highGeneratedWeek].length - 1;
          } else if (allAssignmentsCompletedInWeek && !lastWeek) {
            weekToShow = highGeneratedWeek + 1;
            sessionToShow = 0;
          } else {
            weekToShow = highGeneratedWeek;
            sessionToShow = highCompletedAssignment;
          }
        }
        plan.weeks[weekToShow].showSessions = true;
        selectSession(plan, weekToShow, sessionToShow);
      }
    }

    function selectSession(plan, week, assignment) {
      vm.selectedSessions[plan._id] = {
        assignment: plan.weeks[week][assignment],
        weekIdx: week,
        assignmentIdx: assignment
      };
    }

    function isExerciseSkipped(exercise) {
      if (!exercise) {
        return false;
      }

      if (exercise.completeState) {
        return exercise.completeState === 'skipped';
      }

      return exerciseMetaDataInstance.wasSkipped(exercise);
    }

    function incompleteExercises(exercises) {
      return exercises.filter(function(ex) {
        return ex.completeState === 'not_complete';
      }).length;
    }

    function changeSubtab(newTab) {
      vm.selectedAssignmentSubtab = newTab;
    }

    function onClickReminder() {
      return $uibModal.open({
        templateUrl: '/app/user/tabs/reminder/reminder-modal.html',
        controller: 'reminderModalCtrl',
        controllerAs: 'reminderCtrl',
        bindToController: true,
        resolve: {
          firstName: function() {
            return vm.user.firstName;
          },
          lastName: function() {
            return vm.user.lastName;
          }
        }
      }).result.then(function(res) {
        return reminderService.setReminder(vm.user._id, res.date);
      })
        .then(function() {
          toastr.success($translate.instant('FOLLOWUP_SCHEDULED'));
        });
    }

    function isShowable(displayData) {
      if (displayData.completedValue) {
        if (displayData.completedValue === '--') {
          return false;
        }
        return true;
      }
      if (displayData.value === '--') {
        return false;
      }
      return true;
    }
  }
}());
/* eslint-disable one-var */
(function() {

  'use strict';

  UserPermissionsController.$inject = ['$state', '$translate', '$q', 'popup', 'permissionsService', 'permissionGroupsService', 'authService', 'profileService'];
  angular.module('ptCrm')
    .controller('UserPermissionsController', UserPermissionsController);

  function UserPermissionsController($state, $translate, $q,
    popup, permissionsService, permissionGroupsService, authService, profileService) {

    var vm = this,
      backupUserPermissions,
      backupDisabledOptions,
      backupMasterPermissions;
    vm.userId = $state.params.userId;

    vm.disabledOptions = {};
    vm.selectedPermissionGroup = {};
    vm.permissionsGroups = [];
    vm.userPermissions = {};
    vm.displayedPermissions = [];
    vm.masterPermissions = null;
    vm.forms = {};

    vm.showGroupsPopup = showGroupsPopup;
    vm.savePermissions = savePermissions;
    vm.resetPermissions = resetPermissions;
    vm.onGroupClick = onGroupClick;
    vm.hasUserTheGroup = hasUserTheGroup;

    loadPermissions();


    function loadPermissions() {
      if (($state.params.roles === 'client' || $state.params.tab === 'assignments') && $state.params.userId!=='me' ) {
        $q.all([permissionGroupsService.getGroups(), permissionsService.getClientUserPermissions(vm.userId), permissionsService.getMasterPermissions()])
          .then(setInitState);
      } else {
        $q.all([permissionGroupsService.getGroups(), permissionsService.getStaffUserPermissions(vm.userId), permissionsService.getMasterPermissions()])
          .then(setInitState);
      }
    }

    function _filterTruthyOptions(backupList) {
      return backupList.filter(function(item) {
        item.options = Object.entries(item.options)
          .reduce(function(result, key) {
            if (key[1]) {
              result[key[0]] = key[1];
            }
            return result;
          }, {});
        return !_.isEmpty(item.options);
      });
    }

    function savePermissions() {
      var backupList = angular.copy(vm.masterPermissions);
      vm.userPermissions.subjects = _filterTruthyDisabledValues(_filterTruthyOptions(backupList));
      if ($state.params.roles === 'client') {
        permissionsService.saveClientUserPermissions(vm.userId, vm.userPermissions).then(function() {
          var isMe = vm.userId === 'me' || vm.userId === profileService.user._id; // no need of me in this case
          if (isMe) {
            authService.refreshPage();
          } else {
            $state.reload();
          }
        });
      } else {
        permissionsService.saveStaffUserPermissions(vm.userId, vm.userPermissions).then(function() {
          var isMe = vm.userId === 'me' || vm.userId === profileService.user._id;
          if (isMe) {
            authService.refreshPage();
          } else {
            $state.reload();
          }
        });
      }
    }

    function _filterTruthyDisabledValues(subjects) {
      var cloneSubjects = angular.copy(subjects),
        newSubjects = subjects.filter(function(subject) {return !vm.disabledOptions.hasOwnProperty(subject.name);});
      cloneSubjects.forEach(function(subject) {
        var disabledOptions = Object.entries(vm.disabledOptions);
        for (var i=0; i < disabledOptions.length; i++) {
          if (subject.name === disabledOptions[i][0]) {
            var userSubject = _.find(vm.userPermissions.subjects, { name : disabledOptions[i][0] });
            subject.options = Object.entries(subject.options)
              // eslint-disable-next-line no-loop-func
              .reduce(function(result, key) {
                if (key[1]) {
                  if (!disabledOptions[i][1].hasOwnProperty(key[0])) {
                    result[key[0]] = key[1];
                  } else if (userSubject && userSubject.options[key[0]]) {
                    result[key[0]] = key[1];
                  }
                }
                return result;
              }, {});
            if (!_.isEmpty(subject.options)) {
              newSubjects.push(subject);
            }
          }
        }
      });
      return _.uniqBy(newSubjects, 'name');
    }

    function resetPermissions() {
      vm.userPermissions = angular.copy(backupUserPermissions);
      vm.selectedPermissionGroup = {};
      vm.disabledOptions = angular.copy(backupDisabledOptions);
      vm.forms.permissions.$setPristine();
    }

    function setInitState(resps) {
      vm.permissionsGroups = resps[0].data;
      vm.userPermissions = resps[1];
      var invertedMasterPermissionSubjects = _.map(resps[2].subjects, function(subject) {
        return {
          name: subject.name,
          options: _.mapValues(subject.options, function() {
            return false;
          })
        };
      });
      vm.masterPermissions = invertedMasterPermissionSubjects;
      vm.userPermissions.groups = _.map(vm.userPermissions.groups, function(id) {
        return _.find(vm.permissionsGroups, { _id: id });
      });
      var tempSubjects = angular.copy(vm.userPermissions.subjects),
        findSubjectNotInSubjects = [];
      _.each(vm.userPermissions.groups, function(group) {
        // Finding Common(with different subject options) as well as uncommon subjects which are not in user permissions from permission groups.
        findSubjectNotInSubjects = [];
        if (group && group.subjects) {
          _.each(group.subjects, function(subject) {
            var subjectIndex = _.findIndex(tempSubjects, function(userPermission) {
              return userPermission.name === subject.name;
            });
            if (subjectIndex !== -1) {
              var tempSubject = tempSubjects[subjectIndex];
              if (!_.isEqual(tempSubject.options, subject.options)) {
                tempSubject.options = _.merge(tempSubject.options, subject.options);
                findSubjectNotInSubjects.push(tempSubject);
              }
            } else {
              findSubjectNotInSubjects.push(subject);
            }
          });
        }
      });
      var permList = _.union(tempSubjects, findSubjectNotInSubjects);
      permList = _.sortBy(permList, 'name');

      for (var i = 0, l = vm.masterPermissions.length; i < l; i++) {
        for (var j = 0, ll = permList.length; j < ll; j++) {
          if (vm.masterPermissions[i].name === permList[j].name) {
            for (var key in vm.masterPermissions[i].options) {
              if (key in permList[j].options) {
                vm.masterPermissions[i].options[key] = permList[j].options[key];
              }
            }
            break;
          }
        }
      }
      vm.displayedPermissions = vm.masterPermissions;
      disablePermissionGroupsSubjects();
      if (vm.userPermissions.subjects && vm.userPermissions.subjects.length > 0) {
        _.each(vm.userPermissions.groups, function(group) {
          _syncGroupWithUserPermissions(group);
        });
      }
      vm.displayedPermissions = _.sortBy(vm.displayedPermissions, 'name');
      backupUserPermissions = angular.copy(vm.userPermissions);
      backupDisabledOptions = angular.copy(vm.disabledOptions);
      backupMasterPermissions = angular.copy(vm.masterPermissions);
    }

    function disablePermissionGroupsSubjects() {
      _.each(vm.userPermissions.groups, function(group) {
        if (group && group.subjects) {
          _.each(group.subjects, function(subject) {
            _toggleDisableOptionsAccordinglyToGroup(subject, true);
          });
        }
      });
    }
    function onGroupClick(selectedGroup) {

      if (hasUserTheGroup(selectedGroup)) {
        _revokeSelectedGroupOptions(selectedGroup);
        vm.userPermissions.groups = _.filter(vm.userPermissions.groups, function(group) {
          return group._id !== selectedGroup._id;
        });
      } else {
        vm.userPermissions.groups.push(selectedGroup);
      }

      _.each(vm.userPermissions.groups, function(group) {
        _syncGroupWithUserPermissions(group);
      });
      disablePermissionGroupsSubjects();

      vm.forms.permissions.$setDirty();
    }

    function hasUserTheGroup(group) {
      return !!_.find(vm.userPermissions.groups, { _id: group._id });
    }

    function _syncGroupWithUserPermissions(group) {
      _.each(vm.displayedPermissions, function(userSubject) {
        var selectedSubject;
        if (group && group.subjects) {
          selectedSubject = _.find(group.subjects, { name: userSubject.name }) || _.find(vm.userPermissions.subjects, { name: userSubject.name });
        }

        if (!selectedSubject) {
          return;
        }
        _applySelectedGroupOptions(userSubject, selectedSubject);
      });
    }

    function showGroupsPopup() {
      return popup.show({
        title: $translate.instant('PERMISSIONS_GROUPS'),
        templateUrl: '/app/user/tabs/permissions/groups-modal.html',
        cssClass: 'permissions-groups-pop-up modal--select-from-list',
        showCancel: false,
        showOk: false,
        scope: {
          permissionsGroups: vm.permissionsGroups,
          hasUserTheGroup: hasUserTheGroup,
          onGroupClick: onGroupClick
        }
      });
    }

    function _applySelectedGroupOptions(userSubject, groupSubject) {
      _.each(groupSubject.options, function(val, key) {
        if (val) {
          userSubject.options[key] = val;
        }
      });
    }

    function _revokeSelectedGroupOptions(group) {
      var groupSubjsWithTrueOption = _.filter(group.subjects, function(subj) {
        return _.some(subj.options);
      });

      _.each(groupSubjsWithTrueOption, function(groupSubj) {
        var userSubject = _.find(vm.displayedPermissions, { name: groupSubj.name });
        if (!userSubject) {
          return;
        }
        _.each(groupSubj.options, function(val, key) {
          if (val) {
            userSubject.options[key] = false;
            _toggleDisableOptionsAccordinglyToGroup(groupSubj, false);
          }
        });
      });
    }

    function _toggleDisableOptionsAccordinglyToGroup(subject, mode) {
      _.each(subject.options, function(val, key) {
        if (val) {
          vm.disabledOptions[subject.name] =
            vm.disabledOptions[subject.name] || {};
          vm.disabledOptions[subject.name][key] = mode;
        }
      });
    }
  }

}());
(function() {

  'use strict';

  NotesController.$inject = ['$state', '$scope', 'notesService', '$translate', 'popup', 'profileService'];
  angular.module('ptCrm')
    .controller('NotesController', NotesController);

  function NotesController($state, $scope, notesService, $translate, popup, profileService) {

    var vm = this;

    vm.userId = $state.params.userId;
    vm.isAdmin =$state.params.userId === 'me' && profileService.user.admin;
    vm.forms = {};
    vm.notes = [];
    vm.fileError = false;

    vm.save = save;
    vm.edit = edit;
    vm.add = add;
    vm.remove = remove;
    vm.reset = reset;
    vm.applyNoteEdit = applyNoteEdit;
    vm.cancelNoteEdit = cancelNoteEdit;
    vm.onTitleChange = onTitleChange;
    vm.addFiles = addFiles;
    vm.wrapAddFiles = wrapAddFiles;
    vm.removeFile = removeFile;
    vm.toggleFileError = toggleFileError;
    vm.noteEdit = noteEdit;
    vm.trixChange = trixChange;
    vm.openFile = openFile;
    vm.getConfirmationOnDeletedNote = getConfirmationOnDeletedNote;
    vm.triggerIsLoading = triggerIsLoading;
    vm.decodeFileName = decodeFileName;
    vm.selectText = selectText;
    vm.creatingNewNote = false;
    vm.selectedNote = null;
    vm.isLoading = {};

    loadNotes();

    function loadNotes() {
      notesService.getNotes(vm.userId , vm.isAdmin).then(_init);
    }

    function remove(note, index) {
      note.isDeleted = true;
      vm.forms.notes.$setDirty();

      vm.creatingNewNote = false;

      if (note && !note._isNew) {
        save(note, index);
      }
    }

    function save(updatedNote, index) {
      var parser = new DOMParser();
      let note = updatedNote,
        doc = parser.parseFromString(note.content, 'text/html'),
        figure = doc.getElementsByTagName('figure');
      if (figure.length) {
        for (let figIndex = figure.length - 1; figIndex >= 0; figIndex--) {
          figure[figIndex].remove();
        }
        note.content = doc.getElementsByTagName('body')[0].innerHTML;
      }
      // eslint-disable-next-line one-var
      var promise;
      if (note.isDeleted) {
        if (!note._isNew) {

          promise = notesService.deleteNote(vm.userId, note._id ,vm.isAdmin);
        }
      } else if (note._isNew) {
        promise = notesService.createNote(vm.userId, note,vm.isAdmin).then(function(data) {
          _updateNoteId(note, data);
          delete note._isNew;
        });
      } else if ((vm.forms[note._id || note._virtualId].$dirty)) {
        promise = notesService.updateNote(vm.userId, note, vm.isAdmin);
      } else {
        return Promise.resolve();
      }

      return promise.then(function() {
        vm.forms.notes.$setPristine();
        vm.backup = angular.copy(vm.notes);
        triggerIsLoading(index);

        vm.creatingNewNote = false;
      })
        .catch(function() {
          triggerIsLoading(index);
          popup.alert({
            title: $translate.instant('ERROR_CANNOT_CREATE_NOTE')
          });
        });
    }

    function triggerIsLoading(index) {
      vm.isLoading[index] = !vm.isLoading[index];
    }

    function add() {
      vm.creatingNewNote = true;
      var note = angular.copy(vm.blank);
      note._isNew = true;
      note.isEdited = true;
      note.isExpanded = true;
      note._virtualId = _getVirtualId();
      note.date = moment().unix();
      note.formattedDate = moment.unix(note.date);
      vm.notes.push(note);
      vm.forms.notes.$setDirty();
      vm.selectedNote = note._virtualId;
    }

    function reset(note, index) {
      vm.notes = angular.copy(vm.backup);
      vm.forms.notes.$setPristine();

      vm.creatingNewNote = false;

      if (note && note._isNew) {
        remove(note, index);
      }
    }

    function edit(note) {
      note.isEdited = true;
    }

    function applyNoteEdit(note) {
      note.isEdited = false;
      note.backup = note.content;
      vm.forms.notes.$setDirty();
    }

    function cancelNoteEdit(note) {
      note.isEdited = false;
      note.content = note.backup;
    }

    function onTitleChange() {
      vm.forms.notes.$setDirty();
    }

    function selectText(event) {
      event.target.select();
    }

    function addFiles(note, files) {
      var noteToEdit = _.findIndex(vm.notes, function(n) { return n._id === note || n._virtualId === note; });
      vm.notes[noteToEdit].files = (vm.notes[noteToEdit].files || []).concat(files);
      $scope.$apply();
      vm.forms.notes.$setDirty();
      vm.forms[note].$setDirty();
    }

    function wrapAddFiles(note) {
      return _.partial(addFiles, note);
    }

    function removeFile(note, index) {
      var noteToEdit = _.findIndex(vm.notes, function(n) { return n._id === note || n._virtualId === note; });
      vm.notes[noteToEdit].files.splice(index, 1);
      vm.forms[note].$setDirty();
    }

    function toggleFileError() {
      vm.fileError = !vm.fileError;
      if (vm.fileError) {
        $scope.$apply();
      }
    }

    function noteEdit(note) {
      note.isEdited = true;
      note.isExpanded = true;
      var noteToEdit = _.findIndex(vm.notes, function(n) { return n._id === note._id; });
      vm.selectedNote = vm.notes[noteToEdit]._id;
      vm.forms.notes.$setDirty();
    }

    function trixChange(n) {
      vm.selectedNote = n._id || n._virtualId;
    }

    function openFile(note, file, event) {
      event.stopPropagation();
      notesService.getNoteFile(vm.userId, note._id, file, vm.isAdmin);
    }

    function getConfirmationOnDeletedNote(note) {
      return popup.confirm({
        title: $translate.instant('ARE_YOU_SURE_DELETE_NOTE'),
        okText: $translate.instant('DELETE_NOTE'),
        cancelText: $translate.instant('CANCEL_NOTE')
      }).then(function() {
        remove(note);
      });
    }

    function _init(data) {
      vm.notes = data.map(function(note) {
        note.isEdited = false;
        note.backup = note.content;
        note.formattedDate = moment.unix(note.date);
        return note;
      }).sort(function(a, b) {
        return b.date - a.date;
      });
      vm.backup = angular.copy(vm.notes);
      vm.blank = _createBlank();
    }

    function _createBlank() {
      return {
        userId: vm.userId,
        title: 'New note',
        content: ''
      };
    }

    function _getVirtualId() {
      return _.uniqueId('virtual_');
    }

    function _updateNoteId(note, data) {
      note._id = data.data._id;

      delete note._virtualId;
      vm.backup = angular.copy(vm.notes);
    }

    function decodeFileName(encodedFileName) {
      return decodeURIComponent(encodedFileName);
    }

    document.addEventListener('trix-attachment-add', function(event) {
      if (event.attachment.file) {
        var fileSize = Math.round((event.attachment.file.size / 1024)),
          allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
        if (fileSize <= 10*1024 && allowedTypes.includes(event.attachment.file.type)) {
          addFiles(vm.selectedNote, [event.attachment.file]);
        } else {
          toggleFileError();
        }
      }
    });
    document.addEventListener('trix-attachment-remove', function(event) {
      if (event.attachment.file) {
        var noteToEdit = _.findIndex(vm.notes, function(n) { return n._id === vm.selectedNote || n._virtualId === vm.selectedNote; }),
          fileToDelete = _.findIndex(vm.notes[noteToEdit].files, function(n) { return n.name === event.attachment.file.name; });
        if (fileToDelete > -1) {
          removeFile(vm.selectedNote, fileToDelete);
        }
      }
    });
  }
}());
(function() {

  'use strict';

  userModalController.$inject = ['exercisersService', '$uibModalInstance', 'profileService'];
  angular.module('ptCrm')
    .controller('userModalController', userModalController);

  function userModalController(exercisersService, $uibModalInstance, profileService) {

    var vm = this;
    vm.modal = {};
    vm.user.modalType = vm.$resolve.userType;
    if (vm.user.modalType === 'client') {
      vm.usersList = exercisersService.getClientPaginateList(
        function(users) {
          return filterSelectedUsers(users, vm.$resolve.chosenUsers);
        }
      );
    } else {
      vm.usersList = exercisersService.getStaffPaginateList(
        function(users) {
          return filterSelectedUsers(users, vm.$resolve.chosenUsers);
        }
      );
    }

    vm.loadUsers = loadUsers;
    vm.searcUsersByStr = filterByName;
    vm.searchStr = '';
    vm.isAllSelected = false;
    vm.selectAll = selectAll;
    vm.addUsers = addUsers;
    vm.resetTrainers = resetTrainers;
    vm.closeModal = closeModal.bind(this, 'cancelled');
    vm.isMe = vm.user._id === profileService.user._id;

    loadUsers();

    function loadUsers() {
      return vm.usersList.load().then(function() {
        if (_.isEmpty(vm.usersList.items)) {
          closeModal('ALL_USERS_SELECTED');
        }
      });
    }

    function filterSelectedUsers(users, selectedUsers) {
      var _users = _.differenceBy(users, selectedUsers, '_id');
      return _.filter(_users, function(user) {
        return user._id !== vm.$resolve.subjectUser._id;
      });
    }

    function filterByName() {
      vm.usersList
        .extendDefaultParams({ search: vm.searchStr })
        .load({ update: true });
    }

    function selectAll(selected, usersList) {
      usersList = _.map(usersList, function(el) {
        return _.assign(el, { selected: selected });
      });
    }

    function addUsers(users) {
      $uibModalInstance.close(_.filter(users, {
        selected: true
      }));
    }

    function resetTrainers() {
      vm.usersList.items = _.map(vm.usersList.items, function(el) {
        return _.assign(el, { selected: false });
      });
      vm.searchStr = '';
      vm.isAllSelected = false;
      vm.trainerModalForm.$setPristine();
    }

    function closeModal(reason) {
      $uibModalInstance.dismiss(reason);
    }

  }

}());
(function() {

  'use strict';

  changePasswordModalController.$inject = ['$uibModalInstance', 'userId', 'userService'];
  angular.module('ptCrm')
    .controller('changePasswordModalController', changePasswordModalController);

  function changePasswordModalController($uibModalInstance, userId, userService) {

    var vm = this;

    _init();

    function _init() {
      vm.cancel = cancel;
      vm.ok = ok;
    }

    function ok() {
      vm.loading = true;
      vm.error = null;

      userService.changePassword(userId, vm.currentPassword, vm.newPassword)
      .then(function() {
        cancel();
      })
      .catch(function(error) {
        vm.error = error;
      })
      .finally(function() {
        vm.loading = true;
      });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
}());
var compareTo = function() {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link: function(scope, element, attributes, ngModel) {

      ngModel.$validators.compareTo = function(modelValue) {
        return modelValue === scope.otherModelValue;
      };

      scope.$watch('otherModelValue', function(newVal, oldVal) {
        if (oldVal) {
          ngModel.$validate();
        }
      });
    }
  };
};

angular.module('ptCrm').directive('compareTo', compareTo);
(function() {

  'use strict';

  deleteUserModalController.$inject = ['$uibModalInstance', 'userId', 'userService', '$state'];
  angular.module('ptCrm')
    .controller('deleteUserModalController', deleteUserModalController);

  function deleteUserModalController($uibModalInstance, userId, userService, $state) {

    var vm = this;

    _init();

    function _init() {
      vm.cancel = cancel;
      vm.ok = ok;
    }

    function ok() {
      vm.error = null;
      if ($state.params.roles === 'facility_staff') {
        userService.deleteStaffUser(userId)
          .then(function() {
            cancel();
          })
          .then(function() {
            $state.go('app.users.list');
          })
          .catch(function(error) {
            vm.error = error;
          });
      } else {
        userService.deleteClientUser(userId)
          .then(function() {
            cancel();
          })
          .then(function() {
            $state.go('app.users.list');
          })
          .catch(function(error) {
            vm.error = error;
          });
      }
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
}());
(function() {

  'use strict';

  workoutStatusModalController.$inject = ['$uibModalInstance', 'profileService', '$translate', 'exerciseMetaData', 'displayMetrics', 'defaultCompletedProfile', 'convert', 'assignmentsService', '$state'];
  angular.module('ptCrm')
    .controller('workoutStatusModalController', workoutStatusModalController);

  function workoutStatusModalController($uibModalInstance, profileService, $translate, exerciseMetaData, displayMetrics, defaultCompletedProfile, convert, assignmentsService, $state) {

    var vm = this,
      exerciseMetaDataInstance = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular);
    vm.modal = {};
    vm.selectAssignment = selectAssignment;
    vm.selectExercise = selectExercise;
    vm.exerciseIsStrength = exerciseIsStrength;
    vm.exerciseIsFunctional = exerciseIsFunctional;
    vm.getSetTypeTranslation = getSetTypeTranslation;
    vm.isSkipped = isSkipped;
    vm.canEditData = canEditData;
    vm.toggleEdit = toggleEdit;
    vm.completedSegmentsEdit = completedSegmentsEdit;
    vm.saveCompletionData = saveCompletionData;
    vm.completedProfileEdit = completedProfileEdit;
    vm.editState = false;
    // this below order in the list is required to display fields in order in assignment status modal page
    vm.nonStrengthFields = [
      { field: 'duration', translation: 'DURATION' },
      { field: 'startingIncline', translation: 'INCLINE' },
      { field: 'startingSpeed', translation: 'SPEED' },
      { field: 'startingResistance', translation: 'RESISTANCE' },
      { field: 'distance', translation: 'DISTANCE' },
      { field: 'level', translation: 'LEVEL' },
      { field: 'calories', translation: 'CALORIES' }
    ];
    vm.setFields = [
      { field: 'weight', translation: 'WEIGHT' },
      { field: 'reps', translation: 'REPS' },
      { field: 'restTime', translation: 'REST_TIME' }
    ];
    vm.weightUnit = profileService.user.settings.measurementUnit === 'I' ? 'LB' : 'KG';
    vm.compareCompletedExercise = compareCompletedExercise;
    vm.compareNonCompletedExercise = compareNonCompletedExercise;
    vm.compareStrengthExercise = compareStrengthExercise;
    vm.exerciseType = exerciseMetaDataInstance.classifyExercise;
    vm.completedNonConnectedExerciseData = exerciseMetaDataInstance.completedNonConnectedExerciseData;
    vm.isShowable = isShowable;

    _init();

    function _init() {
      vm.assignments = vm.$resolve.assignments;
      vm.closeModal = closeModal;
      vm.selectedAssignment = vm.$resolve.selectedAssignment;
      vm.selectedAssignmentIndex = _.findIndex(vm.assignments, { _id: vm.selectedAssignment._id });
      vm.selectedExercise = vm.$resolve.selectedExercise;
      vm.selectedExercise.displayData = displayMetrics(vm.selectedExercise, profileService.user.settings.measurementUnit, $translate.instant, true);
      vm.selectedPlan = vm.$resolve.selectedPlan;
      _matchCompletedStrengthLength();
      vm.selectedExerciseIndex = _.findIndex(vm.selectedAssignment.exercises, { _id: vm.selectedExercise._id });
    }

    function selectAssignment(direction) {
      direction = direction || 0;
      vm.selectedAssignmentIndex += direction;
      if (vm.selectedAssignmentIndex >= vm.assignments.length) {
        vm.selectedAssignmentIndex = 0;
      }
      if (vm.selectedAssignmentIndex < 0) {
        vm.selectedAssignmentIndex = vm.assignments.length - 1;
      }
      vm.editState = false;
      vm.selectedAssignment = vm.assignments[vm.selectedAssignmentIndex];
      vm.selectedExerciseIndex = 0;
      vm.selectedExercise = vm.selectedAssignment.exercises[vm.selectedExerciseIndex];
      vm.selectedExercise.displayData = displayMetrics(vm.selectedExercise, profileService.user.settings.measurementUnit, $translate.instant, true);
      _matchCompletedStrengthLength();
    }

    function selectExercise(direction) {
      direction = direction || 0;
      vm.selectedExerciseIndex += direction;
      if (vm.selectedExerciseIndex >= vm.selectedAssignment.exercises.length) {
        vm.selectedExerciseIndex = 0;
      }
      if (vm.selectedExerciseIndex < 0) {
        vm.selectedExerciseIndex = vm.selectedAssignment.exercises.length - 1;
      }
      vm.editState = false;
      vm.selectedExercise = vm.selectedAssignment.exercises[vm.selectedExerciseIndex];
      vm.selectedExercise.displayData = displayMetrics(vm.selectedExercise, profileService.user.settings.measurementUnit, $translate.instant, true);
      _matchCompletedStrengthLength();
    }

    function exerciseIsStrength() {
      return vm.selectedExercise && vm.selectedExercise.category === 'Strength';
    }

    function exerciseIsFunctional() {
      return vm.selectedExercise && vm.selectedExercise.category === 'Functional';
    }

    function getSetTypeTranslation(type) {
      switch (type) {
      case 'standard':
        return $translate.instant('Reps');
      case 'asManyReps':
        return $translate.instant('AMAP');
      case 'toFailure':
        return $translate.instant('UF');
      default:
        return '';
      }
    }

    function toggleEdit() {
      vm.editableProfile = _.clone(vm.selectedExercise.completedProfile);
      vm.editState = !vm.editState;
    }

    function completedSegmentsEdit(segments) {
      vm.editableProfile.segments = segments;
    }

    function completedProfileEdit(newProfile) {
      vm.editableProfile = newProfile;
    }

    function saveCompletionData() {
      var defaultProfile = defaultCompletedProfile(vm.selectedExercise, profileService.user.settings.measurementUnit);

      if (vm.editableProfile && vm.editableProfile.segments) {
        defaultProfile.completedProfile.segments = vm.editableProfile.segments;
      } else {
        defaultProfile.completedProfile = vm.editableProfile;
      }

      defaultProfile.completedProfile = convert.completedProfileToInternal(
        defaultProfile.completedProfile,
        profileService.user.settings.measurementUnit,
        vm.selectedExercise.preset.metrics
      );

      return assignmentsService.completeExercise(vm.selectedExercise, defaultProfile)
        .then(function() {
          $uibModalInstance.dismiss();
          $state.reload();
        });
    }

    function canEditData() {
      if (vm.selectedExercise.completeState !== 'completed_manually') {
        return false;
      }
      if (exerciseIsStrength() || exerciseIsFunctional()) {
        return true;
      }
      return vm.selectedExercise.displayData.filter(function(value) {
        return value.editable;
      }).length > 0;
    }

    function isSkipped(exercise) {
      if (!exercise) {
        return false;
      }

      if (exercise.completeState) {
        return exercise.completeState === 'skipped';
      }

      return exerciseMetaDataInstance.wasSkipped(exercise);
    }

    function closeModal() {
      $uibModalInstance.dismiss();
    }

    function compareCompletedExercise(exercise, field) {
      var assignedData = exercise.assignedData,
        completedData = exercise.completedData;
      if (parseInt(completedData[field].value, 10) === 0 || (assignedData[field] && completedData[field] && completedData[field].comparison === 'less')) {
        return 'less';
      }
    }

    function compareNonCompletedExercise(exercise, field) {
      var assignedData = exercise.assignedData,
        completedData = exercise.completedData,
        convertedField = field.toLowerCase();

      if ((assignedData[convertedField] && completedData[convertedField] && completedData[convertedField].comparison === 'less')) {
        return 'less';
      } else if ((assignedData[convertedField] && completedData[convertedField] && completedData[convertedField].comparison === 'greater')
        || (assignedData[convertedField] && completedData[convertedField] && completedData[convertedField].comparison === 'equal')) {
        return 'greater';
      }
    }

    function compareStrengthExercise(assignedProfile, setNumber, comparedField, comparedValue) {
      if (setNumber > (assignedProfile.segments.length - 1)) {
        return 'greater';
      }

      var assignedValue = (!assignedProfile.segments[setNumber] && comparedField !== 'restTime') ? 0 : Number(assignedProfile.segments[setNumber][comparedField]);

      if (assignedValue > comparedValue) {
        return 'less';
      } else if (assignedValue < comparedValue) {
        return 'greater';
      }
      return '';

    }

    function _matchCompletedStrengthLength() {
      if (exerciseIsStrength() && vm.selectedExercise && vm.selectExercise.completedProfile
        && vm.selectedExercise.completedProfile.segments.length
        && vm.selectedExercise.completedProfile.segments.length < vm.selectedExercise.assignedProfile.segments.length) {
        var diff = vm.selectedExercise.assignedProfile.segments.length - vm.selectedExercise.completedProfile.segments.length;
        _.range(diff).forEach(function() {
          vm.selectedExercise.completedProfile.segments.push({
            missingSet: true
          });
        });
      }
    }

    function isShowable(displayData) {
      if (displayData.completedValue) {
        if (displayData.completedValue === '--') {
          return false;
        }
        return true;
      }
      if (displayData.value === '--') {
        return false;
      }
      return true;
    }
  }
}());
'use strict';

deleteTrainingPlanModalController.$inject = ['$uibModalInstance'];
angular.module('ptCrm')
  .controller('deleteTrainingPlanModalController', deleteTrainingPlanModalController);

function deleteTrainingPlanModalController($uibModalInstance) {
  var vm = this;

  vm.modal = {};
  vm.endEarly = true;
  vm.allUsers = false;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function() {
    $uibModalInstance.close({
      allUsers: vm.allUsers,
      cancel: vm.endEarly
    });
  };
}
'use strict';

extendTrainingPlanModalController.$inject = ['$uibModalInstance', 'trainingProgram'];
angular.module('ptCrm').controller('extendTrainingPlanModalController', extendTrainingPlanModalController);

function extendTrainingPlanModalController($uibModalInstance, trainingProgram) {
  var vm = this;
  vm.trainingProgram = trainingProgram;
  vm.numWeeks = 1;
  vm.weekOptions = _.range(1, 53);

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function() {
    $uibModalInstance.close({
      numWeeksToExtend: vm.numWeeks
    });
  };
}
'use strict';

deleteAssignmentModalController.$inject = ['$uibModalInstance'];
angular.module('ptCrm')
  .controller('deleteAssignmentModalController', deleteAssignmentModalController);

function deleteAssignmentModalController($uibModalInstance) {
  var vm = this;

  vm.modal = {};

  vm.hasRecurrence = vm.$resolve.massAssignment.recurrence !== null;
  vm.hasMultipleUsers = vm.$resolve.massAssignment.exercisers.length > 1;
  vm.deleteAllOccurrences = false;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function() {
    $uibModalInstance.close({
      deleteAll: vm.deleteAllOccurrences
    });
  };
}
'use strict';

completeExerciseModalController.$inject = ['$uibModalInstance'];
angular.module('ptCrm')
  .controller('completeExerciseModalController', completeExerciseModalController);

function completeExerciseModalController($uibModalInstance) {
  var vm = this;
  vm.modal = {};
  vm.action = '';

  vm.isCompleted = vm.$resolve.isCompleted;
  vm.hasId = vm.$resolve.hasId;

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };

  vm.skip = function() {
    vm.action = 'skip';
    vm.submit();
  };
  vm.complete = function() {
    vm.action = 'complete';
    vm.submit();
  };
  vm.uncomplete = function() {
    vm.action = 'uncomplete';
    vm.submit();
  };

  vm.submit = function() {
    $uibModalInstance.close({
      action: vm.action
    });
  };

}'use strict';

massCompleteModalController.$inject = ['$scope', '$uibModalInstance', 'assignmentsService', 'popup', '$translate'];
angular.module('ptCrm')
  .controller('massCompleteModalController', massCompleteModalController);

function massCompleteModalController($scope, $uibModalInstance, assignmentsService, popup, $translate) {
  var vm = this;
  vm.modal = {};

  vm.isSkip = vm.$resolve.isSkip;

  vm.toComplete = vm.$resolve.allExercises.filter(function(ex) {
    return ex.completeState === 'not_complete';
  });

  vm.cancel = function() {
    if (!vm.loading) {
      $uibModalInstance.dismiss();
    }
  };
  vm.submit = function() {
    vm.loading = true;
    assignmentsService.massCompleteExercises(vm.toComplete, vm.isSkip)
      .then(function() {
        vm.loading = false;
        $uibModalInstance.close({
          toComplete: vm.toComplete
        });
      })
      .catch(function(error) {
        vm.loading = false;
        $uibModalInstance.dismiss();
        if (error.status === 403) {
          return popup.alert({
            title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
            description: error.data.message
          });
        }
        return popup.alert({
          title: $translate.instant('ERROR_COMPLETE_EXERCISE_MESSAGE'),
          description: $translate.instant('ERROR_COMMON')
        });
      });
  };

  $scope.$on('modal.closing', function(event) {
    if (vm.loading) {
      event.preventDefault();
    }
  });
}
biometricsController.$inject = ['$state', 'biometricsService', 'ORDERED_BIOMETRICS', '$uibModal', '$q', 'profileService', '$rootScope'];angular.module('ptCrm').controller('biometricsController', biometricsController);

function biometricsController($state, biometricsService, ORDERED_BIOMETRICS, $uibModal, $q, profileService, $rootScope) {
  var vm = this,
    user = $state.params.userId === 'me' ? profileService.user._id : $state.params.userId;
  fetchBiometrics();

  function fetchBiometrics(statToOpen) {

    $q.all([
      biometricsService.getBiometrics(user),
      biometricsService.getHiddenBiometrics(user)
    ])
      .then(function(res) {
        vm.hiddenList = res[1].data.hiddenBiometrics;
        vm.biometrics = generateShownBiometrics(res[0]);
        vm.selectedRow = null;
        vm.selectedRowElement = null;
        if (statToOpen) {
          vm.biometrics.forEach(function(row, rowIdx) {
            row.forEach(function(element, elementIdx) {
              if (element.biometricName === statToOpen) {
                vm.selectedRow = rowIdx;
                vm.selectedRowElement = elementIdx;
              }
            });
          });
        }
      });
  }
  function generateShownBiometrics(biometrics) {
    var shown = [],
      addOptions = [];

    _getBiometricOrder().forEach(function(stat) {
      var idx = _.findIndex(biometrics, function(biometric) {
        return stat.biometricName === biometric.biometricName;
      });

      if (idx > -1) {
        shown.push(biometrics[idx]);
      } else if (profileService.user.activeFacility.defaultBodyStats && _.includes(profileService.user.activeFacility.defaultBodyStats, stat.biometricName)) {
        shown.push({
          biometricName: stat.biometricName,
          history: [],
          userId: user,
          goal: [],
          hidden: false
        });
      } else {
        addOptions.push(stat);
      }
    });

    vm.addOptions = addOptions;

    return _.chunk(shown, 4);
  }

  vm.toggleDetails = function(row, index) {
    if (!(row === vm.selectedRow && index === vm.selectedRowElement)) {
      vm.selectedRow = row;
      vm.selectedRowElement = index;
    } else {
      vm.selectedRow = undefined;
      vm.selectedRowElement = undefined;
    }
  };

  vm.isSelected = function(row, index) {
    return vm.selectedRow === row && vm.selectedRowElement === index;
  };

  vm.showDetails = function(index) {
    return vm.selectedRow === index;
  };

  vm.closeDetails = function() {
    vm.selectedRow = undefined;
    vm.selectedRowElement = undefined;
  };

  vm.handleCsv = function() {
    biometricsService.exportCSV(_.flatten(vm.biometrics),$rootScope.activeUserName);
  };

  vm.handleButtonPressEvent = function(type) {
    if (type === 'hide') {
      hideStat();
    } else {
      valueChange(type);
    }
  };

  vm.handleAddButtonPress = function() {
    var newStat;
    return $uibModal.open({
      controller: 'biometricCreateModalController',
      controllerAs: 'biometricCreate',
      templateUrl: '/app/user/tabs/biometrics/biometric-create/biometric-create-modal.html',
      bindToController: true,
      resolve: {
        addOptions: function() {
          return vm.addOptions;
        }
      }
    }).result.then(function(res) {

      newStat = res.option.biometricName;

      var requests = [];

      if (res.currentValue) {
        requests.push(biometricsService.postBiometrics(
          user,
          res.option.biometricName,
          res.currentValue,
          false,
          res.option.unitType || null
        ));
      }

      if (res.goalValue) {
        requests.push(biometricsService.postBiometrics(
          user,
          res.option.biometricName,
          res.goalValue,
          true,
          res.option.unitType || null
        ));
      }

      return $q.all(requests);
    })
      .then(function() {
        return fetchBiometrics(newStat);
      });
  };

  function valueChange(type) {
    var currentMetric = vm.biometrics[vm.selectedRow][vm.selectedRowElement];
    return $uibModal.open({
      controller: 'biometricEntryModalController',
      controllerAs: 'biometricEntry',
      templateUrl: '/app/user/tabs/biometrics/biometric-entry/biometric-entry-modal.html',
      bindToController: true,
      resolve: {
        biometricName: function() { return currentMetric.biometricName; },
        value: function() {
          var sortedHistory = _.orderBy(currentMetric.history, ['timestamp'], ['asc']),
            noCasting = currentMetric.unitType && currentMetric.unitType === 'length_long' && profileService.user.settings.measurementUnit === 'I',
            valueToReturn = type === 'goal' ?
              currentMetric.goal && currentMetric.goal.length && currentMetric.goal[currentMetric.goal.length - 1].value :
              sortedHistory && sortedHistory.length && sortedHistory[sortedHistory.length - 1].value;

          return noCasting ? valueToReturn : +valueToReturn;
        },
        entryType: function() {
          return type;
        }
      }
    }).result.then(function(res) {
      if (type === 'goal' && currentMetric.goal && currentMetric.goal._id) {
        return biometricsService.putBiometrics(
          user,
          currentMetric.biometricName,
          currentMetric.goal._id,
          res.newValue,
          currentMetric.unitType
        );
      }
      return biometricsService.postBiometrics(
        user,
        currentMetric.biometricName,
        res.newValue,
        type === 'goal',
        currentMetric.unitType
      );
    })
      .then(function() {
        return fetchBiometrics(currentMetric.biometricName);
      });
  }

  function _getBiometricOrder() {
    if (profileService.user.activeFacility.defaultBodyStats) {
      var ordered = [];
      profileService.user.activeFacility.defaultBodyStats.forEach(function(name) {
        var idx = _.findIndex(ORDERED_BIOMETRICS, function(biometric) {
          return name === biometric.biometricName;
        });

        if (idx > -1) {
          ordered.push(ORDERED_BIOMETRICS[idx]);
        }
      });

      return ordered.concat(_.difference(ORDERED_BIOMETRICS, ordered)).filter(filterHidden);
    }
    return ORDERED_BIOMETRICS.filter(filterHidden);
  }

  function filterHidden(obj) {
    return !_.includes(vm.hiddenList, obj.biometricName);
  }
  function hideStat() {
    var currentMetric = vm.biometrics[vm.selectedRow][vm.selectedRowElement];
    updateHidden(vm.hiddenList.concat(currentMetric.biometricName));
  }
  vm.getHiddenStats = function() {
    return $uibModal.open({
      controller: 'biometricHiddenModalController',
      controllerAs: 'biometricHidden',
      templateUrl: '/app/user/tabs/biometrics/biometric-hidden/biometric-hidden-modal.html',
      bindToController: true,
      resolve: {
        showHidden: function() {
          return vm.hiddenList;
        }
      }
    }).result.then(function(res) {
      updateHidden(res);
    });
  };
  function updateHidden(list) {
    return biometricsService.putHiddenBiometrics(
      user,
      list
    ).then(function() {
      return fetchBiometrics();
    });
  }
}

biometricDetailsCtrl.$inject = ['profileService', '$translate', '$uibModal', 'biometricsService', '$rootScope'];function biometricDetailsCtrl(profileService, $translate, $uibModal, biometricsService, $rootScope) {

  var vm = this;

  vm.$onChanges = function(changes) {
    if (changes.stats && changes.stats.currentValue) {
      vm.stats = angular.copy(changes.stats.currentValue);
      vm.detailsAvailable = vm.stats.biometricName !== 'height';
      vm.goalValue = goalValue(vm.stats);
      vm.units = units(vm.stats, profileService.user.settings.measurementUnit);
      vm.goalCaption = $translate.instant('GOAL_STAT', {
        stat: $translate.instant(vm.stats.biometricName.toUpperCase())
      });
      vm.historyCaption = $translate.instant('HISTORY_STAT', {
        stat: $translate.instant(vm.stats.biometricName.toUpperCase())
      });
    }
  };

  vm.handleButtonPress = function(type) {
    vm.onButtonPress({ $event: type });
  };

  vm.showAllHistory = function() {
    return $uibModal.open({
      controller: 'biometricHistoryModalController',
      controllerAs: 'biometricHistory',
      templateUrl: '/app/user/tabs/biometrics/biometric-history/biometric-history-modal.html',
      bindToController: true,
      resolve: {
        userStats: function() {
          var stats = vm.stats;
          return stats;
        },
        userUnits: function() {
          var units = vm.units;
          return units;
        },
        userDateFormat: function() {
          var dateFormat = profileService.user.settings.dateFormat;
          return dateFormat;
        }
      }
    });
  };
  vm.exportCSV = function() {
    biometricsService.exportCSV([vm.stats],$rootScope.activeUserName);
  };
  vm.formatVal = function(value) {
    return _formatBodyStat(value.toString());
  }

}
//PT-4937 - Formatting body stat
function _formatBodyStat(currBiometricValue){
  if (typeof currBiometricValue === 'string'){
    if(currBiometricValue.indexOf('.') !== -1){
      var splitBiometricVal = currBiometricValue.split('.');
      return splitBiometricVal.length > 1 && splitBiometricVal[1] !== '00' ? Number(currBiometricValue).toFixed(2) : splitBiometricVal[0];
    }
  }
  return currBiometricValue;
}



function goalValue(stats) {
  return stats.goal && stats.goal.length && _.last(stats.goal).value ? _formatBodyStat(_.last(stats.goal).value.toString()) : '--';
}

function units(stats, measurementUnit) {
  if (!stats.unitType) {
    return '';
  }
  if (stats.unitType === 'weight') {
    return measurementUnit === 'M'? 'KG': 'LB';
  }
  if (stats.unitType === 'length_short') {
    return measurementUnit === 'M'? 'CM': 'INCH';
  }
  if (stats.unitType === 'length_long') {
    return measurementUnit === 'M'? 'METER': 'FT';
  }
  if (stats.unitType === 'heartrate') {
    return 'BPM';
  }
  return '';
}

angular.module('ptCrm')
  .component('biometricDetails', {
    templateUrl:'/app/user/tabs/biometrics/biometric-details/biometric-details.component.html',
    controller: biometricDetailsCtrl,
    controllerAs: 'biometricDetailsCtrl',
    bindings: {
      stats: '<',
      onButtonPress: '&'
    }
  });
angular.module('ptCrm').constant('ORDERED_BIOMETRICS', [
  {
    biometricName: 'height',
    unitType: 'length_long'
  },
  {
    biometricName: 'weight',
    unitType: 'weight'
  },
  {
    biometricName: 'body_fat',
    unitType: 'weight'
  },
  {
    biometricName: 'skeletal_muscle_mass'
  },
  {
    biometricName: 'physique_rating'
  },
  {
    biometricName: 'bmi'
  },
  {
    biometricName: 'body_fat_pct'
  },
  {
    biometricName: 'resting_hr',
    unitType: 'heartrate'
  },
  {
    biometricName: 'average_hr',
    unitType: 'heartrate'
  },
  {
    biometricName: 'muscle_mass'
  },
  {
    biometricName: 'total_body_water_pct'
  },
  {
    biometricName: 'bone_mineral_mass'
  },
  {
    biometricName: 'basal_metabolic_rate'
  },
  {
    biometricName: 'visceral_fat'
  },
  {
    biometricName: 'triceps',
    unitType: 'length_short'
  },
  {
    biometricName: 'pectorals',
    unitType: 'length_short'
  },
  {
    biometricName: 'abdominals',
    unitType: 'length_short'
  },
  {
    biometricName: 'lean_body_mass',
    unitType: 'weight'
  },
  {
    biometricName: 'min_hr',
    unitType: 'heartrate'
  },
  {
    biometricName: 'max_hr',
    unitType: 'heartrate'
  },
  {
    biometricName: 'vo2'
  },
  {
    biometricName: 'systolic_bp'
  },
  {
    biometricName: 'diastolic_bp'
  },
  {
    biometricName: 'neck',
    unitType: 'length_short'
  },
  {
    biometricName: 'chest',
    unitType: 'length_short'
  },
  {
    biometricName: 'waist',
    unitType: 'length_short'
  },
  {
    biometricName: 'hips',
    unitType: 'length_short'
  },
  {
    biometricName: 'thigh',
    unitType: 'length_short'
  }
]);
angular.module('ptCrm').controller('biometricEntryModalController', ['$uibModalInstance', '$scope', 'profileService', function($uibModalInstance, $scope, profileService) {
  var vm = this,
    parts;

  vm.value = vm.$resolve.value || 0;
  vm.entryType = vm.$resolve.entryType;
  vm.biometricName = vm.$resolve.biometricName;
  vm.units = profileService.user.settings.measurementUnit;
  vm.metersOptions = _.range(4);
  vm.centimetersOptions = _.range(100);
  vm.feetOptions = _.range(9);
  vm.inchesOptions = _.range(12);

  if (vm.biometricName === 'height') {
    if (vm.units === 'M') {
      parts = ('' + vm.value).split('.');
      vm.meters = +parts[0];
      if(parts[1] !== undefined)
        vm.centimeters = +(parts[1].length === 1 ? parts[1] + '0' : parts[1]);
      else
        vm.centimeters = 0;
    } else {
      vm.feet = +/(\d)'(\d*)"/.exec(vm.value)[1];
      vm.inches = +/(\d)'(\d*)"/.exec(vm.value)[2];
    }
  }

  vm.isInvalidInput = function() {
    var biometricInputTextbox = document.getElementById('biometricInput');
    if (biometricInputTextbox !== null) {
      return !biometricInputTextbox.value;
    }
    if (vm.biometricName === 'height') {
      if (vm.units === 'M') {
        return isNaN(vm.meters) || isNaN(vm.centimeters);
      }
      return isNaN(vm.feet) || isNaN(vm.inches);
    }
    return isNaN(vm.value);
  };

  vm.dismiss = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function() {
    if (vm.biometricName !== 'height') {
      return $uibModalInstance.close({
        newValue: vm.value
      });
    }
    var value = vm.units === 'M' ? (vm.meters + (vm.centimeters / 100)) : (vm.feet + '\'' + vm.inches + '"');
    return $uibModalInstance.close({
      newValue: value
    });

  };

  $scope.$on('modal.closing', function(event) {
    if (document.activeElement.id && document.activeElement.id === 'biometricInput') {
      event.preventDefault();
    }
  });
}]);

biometricChartController.$inject = ['$element', '$translate', 'profileService'];angular.module('ptCrm').component('biometricChart', {
  controller: biometricChartController,
  controllerAs: 'chartCtrl',
  templateUrl: '/app/user/tabs/biometrics/biometric-chart/biometric-chart.html',
  bindings: {
    stats: '<'
  }
});

function biometricChartController($element, $translate, profileService) {

  var chart;

  this.filter = $translate.instant('LAST_FOUR');
  this.filterOptionsTranslated = [$translate.instant('ALL_DATA'), $translate.instant('LAST_FOUR')];

  this.$onChanges = function(changes) {
    if (changes.stats && changes.stats.currentValue) {
      this.stats = angular.copy(changes.stats.currentValue);
      this.chartLabel = $translate.instant('STAT_OVERVIEW', {
        stat: $translate.instant(this.stats.biometricName.toUpperCase())
      });
      this.filter = $translate.instant('LAST_FOUR');
      initGraph(this.stats, this.filter, this.filterOptionsTranslated);
    }
  };

  this.onFilterChange = function() {
    initGraph(this.stats, this.filter, this.filterOptionsTranslated);
  };

  function initGraph(stats, filter, filterOptions) {
    var container = $element[0].querySelector('.biometric-chart__chart-container'),
      ctx;

    if (chart) {
      chart.destroy();
      $element.find('canvas').remove();
    }

    container.innerHTML = '<canvas></canvas>';

    ctx = $element.find('canvas')[0].getContext('2d');
    chart = new Chart(ctx, getChartConfig(stats, filter, filterOptions));
  }

  function getChartConfig(stats, filter, filterOptions) {
    var chartUnits = units(stats, profileService.user.settings.measurementUnit),
      unitsLabel = chartUnits ?
        ' (' + $translate.instant(chartUnits) + ')' : '',
      chartLabel = $translate.instant(stats.biometricName.toUpperCase()) + unitsLabel,
      config = {
        type: 'line',
        data: {
          datasets: [{
            backgroundColor: '#5B8391',
            borderColor: '#5B8391',
            borderWidth: 1,
            pointRadius: 6,
            pointHoverRadius: 6,
            lineTension: 0,
            data: getChartHistoryData(stats.history, filter, undefined, filterOptions),
            fill: false
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          },
          maintainAspectRatio: false,
          tooltips: {
            enabled: false
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'MMM D'
                }
              },
              distrbution: 'series',
              ticks: {
                autoSkip: true,
                maxTicksLimit: 5,
                maxRotation: 0
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: chartLabel
              }
            }]
          }
        }
      },
      goalValue = stats.goal && stats.goal.length && _.last(stats.goal).value;

    if (goalValue) {
      config.data.datasets.push({
        fill: false,
        backgroundColor: '#81A5C8',
        borderColor: '#81A5C8',
        borderWidth: 2,
        pointRadius: 0,
        lineTension: 0,
        data: getChartHistoryData(stats.history, filter, goalValue, filterOptions)
      });
    }

    return config;
  }
}

function units(stats,measurementUnit) {
  if (!stats.unitType) {
    return '';
  }
  if (stats.unitType === 'weight') {
    return measurementUnit === 'M'? 'KG': 'LB';
  }
  if (stats.unitType === 'length_short') {
    return measurementUnit === 'M'? 'CM': 'INCH';
  }
  if (stats.unitType === 'length_long') {
    return measurementUnit === 'M'? 'METER': 'FT';
  }
  if (stats.unitType === 'heartrate') {
    return 'BPM';
  }
  return '';
}

function getChartHistoryData(historyList, filter, goalValue, allFilterOptions) {
  var filteredList;

  switch (filter) {
  case allFilterOptions[0]: // All Data
    filteredList = historyList.slice();
    break;
  case allFilterOptions[1]: // Last Four
    filteredList = historyList.slice(-4);
    break;
  default:
    filteredList = historyList.slice();
    break;
  }

  return filteredList.map(function(entry) {
    return {
      y: goalValue || entry.value,
      x: moment.unix(entry.timestamp).toDate()
    };
  });
}

biometricStatsCtrl.$inject = ['profileService'];function biometricStatsCtrl(profileService) {
  this.units = units(this.stats,profileService.user.settings.measurementUnit);
  this.currentValue = currentValue(this.stats);
  this.arrowDirection = progress(this.stats);
}


function progress(stats) {
  if (stats.history.length < 2) {
    return 'no-change';
  }
  var compare = stats.history.slice(-2);
  if (+compare[0].value < compare[1].value) {
    return 'up';
  }
  if (+compare[0].value > compare[1].value) {
    return 'down';
  }
  return 'no-change';
}

function _formatBodyStat(currBiometricValue) {
  if (typeof currBiometricValue === 'string') {
    if (currBiometricValue.indexOf('.') !== -1) {
      var splitBiometricVal = currBiometricValue.split('.');
      return splitBiometricVal.length > 1 && splitBiometricVal[1] !== '00' ? Number(currBiometricValue).toFixed(2) : splitBiometricVal[0];
    }
  }
  return currBiometricValue;
}
function currentValue(stats) {
  if (stats.history.length === 0) {
    return '--';
  }
  var sortedHistory = _.orderBy(stats.history, ['timestamp'], ['asc']),
    currBiometricValue = sortedHistory[sortedHistory.length - 1].value;
  return _formatBodyStat(currBiometricValue.toString());
}

function units(stats,measurementUnit) {
  if (!stats.unitType) {
    return '';
  }
  if (stats.unitType === 'weight') {
    return measurementUnit === 'M'? 'KG': 'LB';
  }
  if (stats.unitType === 'length_short') {
    return measurementUnit === 'M'? 'CM': 'INCH';
  }
  if (stats.unitType === 'length_long') {
    return measurementUnit === 'M'? 'METER': 'FT';
  }
  if (stats.unitType === 'heartrate') {
    return 'BPM';
  }
  return '';
}

angular.module('ptCrm')
  .component('biometricStats', {
    templateUrl:'/app/user/tabs/biometrics/biometric-stats/biometric-stats.html',
    controller: biometricStatsCtrl,
    controllerAs: 'biometricStatsCtrl',
    bindings: {
      stats: '<'
    }
  }
  );angular.module('ptCrm').controller('biometricHistoryModalController', ['$uibModalInstance', 'userStats', 'userUnits', 'userDateFormat', '$translate', function($uibModalInstance, userStats, userUnits, userDateFormat, $translate) {
  var vm = this;

  vm.stats = userStats;
  vm.history = userStats.history;
  vm.unit = userUnits;
  vm.dateFormat = userDateFormat;

  vm.dismiss = function() {
    $uibModalInstance.dismiss();
  };

  vm.getBiometricName = function() {
    return $translate.instant(userStats.biometricName.toUpperCase());
  };

  vm.formatUserDate = function(timestamp) {
    return moment.unix(timestamp).format(vm.dateFormat);
  };
}]);
angular.module('ptCrm').controller('biometricCreateModalController', ['$uibModalInstance', '$translate', 'profileService', function($uibModalInstance, $translate, profileService) {
  var vm = this;

  vm.dismiss = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function(isValid) {
    if (isValid) {
      $uibModalInstance.close({
        option: vm.selectedOption,
        currentValue: vm.currentValue,
        goalValue: vm.goalValue
      });
    }
  };
  vm.options = vm.$resolve.addOptions.map(function(item, idx) {
    item.id = idx;
    item.label = $translate.instant(item.biometricName.toUpperCase()) +
      (item.unitType ? ' (' + $translate.instant(units(item, profileService.user.settings.measurementUnit)) + ')' : '');
    return item;
  });
  function units(stats, measurementUnit) {
    if (!stats.unitType) {
      return '';
    }
    if (stats.unitType === 'weight') {
      return measurementUnit === 'M'? 'KG': 'LB';
    }
    if (stats.unitType === 'length_short') {
      return measurementUnit === 'M'? 'CM': 'INCH';
    }
    if (stats.unitType === 'length_long') {
      return measurementUnit === 'M'? 'METER': 'FT';
    }
    if (stats.unitType === 'heartrate') {
      return 'BPM';
    }
    return '';
  }
}]);
angular.module('ptCrm').controller('biometricHiddenModalController', ['$uibModalInstance', '$scope', function($uibModalInstance, $scope) {
  var vm = this;
  vm.tracker = _.fill(_.clone(vm.$resolve.showHidden), true);
  vm.originalList = vm.$resolve.showHidden;
  vm.dismiss = function() {
    $uibModalInstance.dismiss();
  };

  vm.toggleHiddenStatus = function(idx) {
    vm.tracker[idx] = !vm.tracker[idx];
  };

  vm.submit = function() {
    $uibModalInstance.close(
      vm.originalList.filter(function(entry,idx) {
        return vm.tracker[idx];
      })
    );
  };
}]);angular.module('ptCrm').controller('reminderModalCtrl', ['$uibModalInstance', 'profileService', '$translate', function($uibModalInstance, profileService, $translate) {
  var vm = this,
    tomorrow = moment().add(1, 'day').startOf('day').toDate(),
    fpDateFormat,
    selectedDate = moment(tomorrow).unix();

  if (profileService.user.settings.dateFormat === 'YYYY-MM-DD') {
    fpDateFormat = 'Y-m-d';
  } else if (profileService.user.settings.dateFormat === 'DD/MM/YYYY') {
    fpDateFormat = 'd/m/Y';
  } else {
    fpDateFormat = 'm/d/Y';
  }

  $uibModalInstance.rendered.then(function() {
    vm.firstName = vm.$resolve.firstName;
    vm.fullName = vm.$resolve.firstName + ' ' + vm.$resolve.lastName;

    flatpickr('#timepicker', {
      minDate: tomorrow,
      defaultDate: tomorrow,
      dateFormat: fpDateFormat,
      locale: $translate.use(),
      onChange: function(dates) {
        selectedDate = moment(dates[0]).unix();
      }
    });
  });

  vm.submit = function() {
    $uibModalInstance.close({
      date: selectedDate
    });
  };

  vm.dismiss = function() {
    $uibModalInstance.dismiss();
  };
}]);
(function () {
  'use strict';

  angular
    .module('ptCrm')
    .controller(
      'StaffMessagesController',
      ['staffMessagingService', 'profileService', '$timeout', '$state', '$translate', '$sce', '$filter', function (
        staffMessagingService,
        profileService,
        $timeout,
        $state,
        $translate,
        $sce,
        $filter
      ) {
        var vm = this,
          otherUserInfo;
        vm.selfId = $state.params.userId === 'me' ? profileService.user._id : $state.params.userId;
        vm.highlightAddressBar = false;
        vm.deliberatelyTrustDangerousHtml = function (message) {
          return $sce.trustAsHtml(message);
        };
        init();
        function init() {
          vm.threadList = staffMessagingService.threadList;
        }
        vm.selectThread = function (thread) {
          vm.showNewThread = false;
          vm.activeThread = thread;
          _getThreadMessages(false, true);
          otherUserInfo = vm.activeThread.otherUser;
        };
        vm.generateSystemMessage = function (message) {
          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'UnderPerformance'
          ) {
            return (
              $translate.instant('SYSTEM_MESSAGE_TAG') +
              ': ' +
              $translate.instant('UNDERPERFORMANCE_REPORT') +
              '\n' +
              $translate.instant('client') +
              ': ' +
              vm.activeThread.otherUser.firstName +
              ' ' +
              vm.activeThread.otherUser.lastName +
              '\n' +
              $translate.instant('ASSIGNMENT_TITLE') +
              ': ' +
              message.messageMetadata.assignmentName +
              '\n' +
              $translate.instant('ASSIGNMENT_START_DATE') +
              ': ' +
              $filter('dateFormatter')(
                moment.unix(message.messageMetadata.assignmentStartDate),
                'dateShort'
              ) +
              '\n' +
              $translate.instant('EXERCISE_TITLE_TAG') +
              ': ' +
              message.messageMetadata.exerciseTitle
            );
          }
          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'Skipped'
          ) {
            return (
              $translate.instant('SYSTEM_MESSAGE_TAG') +
              ': ' +
              $translate.instant('EXERCISE_SKIPPED') +
              '\n' +
              $translate.instant('client') +
              ': ' +
              vm.activeThread.otherUser.firstName +
              ' ' +
              vm.activeThread.otherUser.lastName +
              '\n' +
              $translate.instant('ASSIGNMENT_TITLE') +
              ': ' +
              message.messageMetadata.assignmentName +
              '\n' +
              $translate.instant('ASSIGNMENT_START_DATE') +
              ': ' +
              $filter('dateFormatter')(
                moment.unix(message.messageMetadata.assignmentStartDate),
                'dateShort'
              ) +
              '\n' +
              $translate.instant('EXERCISE_TITLE_TAG') +
              ': ' +
              message.messageMetadata.exerciseTitle
            );
          }
          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'Reminder'
          ) {
            return $translate.instant('REMINDER_MESSAGE', {
              name: otherUserInfo.fullName,
              date: moment
                .unix(message.time)
                .format(profileService.user.settings.dateFormat),
            });
          }
          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'atRisk'
          ) {
            var phoneNumber =
              message.messageMetadata.clientPhone !== null
                ? message.messageMetadata.clientPhone
                : $translate.instant('NA');
            return (
              $translate.instant('AT_RISK_SYSTEM_MESSAGE', {
                firstName: vm.activeThread.otherUser.firstName,
                lastName: vm.activeThread.otherUser.lastName,
              }) +
              ':\n' +
              $translate.instant('EMAIL_ADDRESS') +
              ': ' +
              message.messageMetadata.clientEmail +
              '\n' +
              $translate.instant('PHONE_NUMBER') +
              ': ' +
              phoneNumber
            );
          }
          return message.message;
        };

        function _scrollToBottom() {
          $timeout(function () {
            var msgContainer = document.getElementsByClassName(
              'staffMessaging__thread-staffContainer'
            );
            if (msgContainer[0]) {
              msgContainer[0].scrollTop =
                msgContainer[0].scrollHeight - msgContainer[0].clientHeight;
            }
          }, 50);
        }

        function _getThreadMessages(afterMessageSend, refreshMessages) {
          return staffMessagingService
            .getThread(vm.activeThread.otherUserId,$state.params.userId)
            .then(function (messages) {
              // assign thread messages
              vm.threadMessages = _.sortBy(messages, 'time');
              // clear message if we're refreshing after message send
              if (afterMessageSend) {
                vm.newMessage = '';
              }
              _scrollToBottom();
              return;
            })
            .then(function () {
              // To prevent infinite loop, only refresh messages after update if needed
              if (refreshMessages) {
                return staffMessagingService.getMessages($state.params.userId);
              }
            });
        }
      }]
    );
})();
(function() {
  'use strict';

  staffMessagingService.$inject = ['$http', 'config', 'profileService', '$rootScope', '$q'];
  angular.module('ptCrm')
    .service('staffMessagingService', staffMessagingService);

  function staffMessagingService($http, config, profileService, $rootScope, $q) {

    var messageObj = {
        messages: [],
        threadList: [],
        messagingUsers: [],
        unreadMessages: false,
        lastMessageTime: 0,
        getMessages: getMessages,
        getMessagingUsers: getMessagingUsers,
        getThread: getThread,
      }

    return messageObj;

    function getMessages(staffUserId) {
      messageObj.messages=[];
      messageObj.threadList=[];
      messageObj.messagingUsers=[];
      messageObj.unreadMessages=false;
      messageObj.lastMessageTime=0;
      var url = config.apiBase + '/staff_messages?isCRM=true&staffId=' + staffUserId;
      return $http.get(url)
      .then(async function(res) {
        messageObj.messages = _.uniq(messageObj.messages.concat(res.data), false, function(item) {
          return item._id;
        });
        messageObj.lastMessageTime = messageObj.messages.length ?
          _.maxBy(messageObj.messages, 'time').time : 0;
        messageObj.unreadMessages = _userHasUnreadMessages(messageObj.messages, staffUserId);
        return await _generateThreadList(messageObj.messages,staffUserId, profileService.user.activeFacility._id);
      })
      .then(function() {
        $rootScope.$emit('messageUpdate');
      });
    }

    function chunkArray(array, chunkSize) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    }
    
    function callApiForChunks(chunks, apiCall) {
      const promises = chunks.map(chunk => apiCall(chunk));
      return Promise.all(promises).then(responses => responses.flat());
    }

    async function getMessagingUsers(extraUserIds, staffId, activeFacilityId) {
      let url = config.apiBase + '/messages/staff_users?isCRM=true&staffUserId=' + staffId + '&staffUserIdActFacility=' + activeFacilityId;
      
      if (extraUserIds.length > 300) {
        const chunks = chunkArray(extraUserIds, 300);
        return callApiForChunks(chunks, chunk => 
          $http.get(url + '&userIds=' + chunk.join(',')).then(res => res.data)
        );
      }
      return $http.get(url + '&userIds=' + extraUserIds.join(','))
        .then(res => res.data);
    }

    function getThread(userId,staffId) {
      return $http.get(config.apiBase + '/messages/thread/' + userId + '?isCRM=true&staffId='+staffId)
      .then(function(res) {
        return res.data;
      });
    }

    function _userHasUnreadMessages(messages, userId) {
      return _.some(messages, function(msg) {
        return msg.to === userId && !msg.read;
      });
    }

    function _generateThreadList(messages,staffId, activeFacilityId) {
      var threadObj = {};

      messages.forEach(function(message) {
        if (threadObj[message.threadId]) {
          threadObj[message.threadId].mostRecent = Math.max(message.time, threadObj[message.threadId].mostRecent);
          threadObj[message.threadId].unreadMessages =
            threadObj[message.threadId].unreadMessages ||
            message.to === staffId && !message.read;
        } else {
          threadObj[message.threadId] = {
            threadId: message.threadId,
            mostRecent: message.time,
            unreadMessages: message.to === staffId && !message.read,
            otherUserId: message.to === staffId ? message.from : message.to
          };

          if (messageObj.messagingUsers) {
            var userIdx = _.findIndex(messageObj.messagingUsers, function(user) { return user._id === threadObj[message.threadId].otherUserId; });
            if (userIdx > -1) {
              threadObj[message.threadId].otherUser = _.clone(messageObj.messagingUsers[userIdx]);
            }
          }
        }
      });

      var threadList = _.values(threadObj);

      var promise = $q.resolve();
      if (threadList.filter(function(thread) { return !thread.otherUser; }).length) {
        promise = getMessagingUsers(threadList.map(function(thread) { return thread.otherUserId; }),staffId, activeFacilityId)
          .then(function(users) {
            messageObj.messagingUsers = users.map(function(user) {
              user.fullName = user.firstName + ' ' + user.lastName;
              return user;
            });
            threadList.forEach(function(thread) {
              var userIdx = _.findIndex(messageObj.messagingUsers, function(user) { return user._id === thread.otherUserId; });
              if (userIdx > -1) {
                thread.otherUser = _.clone(messageObj.messagingUsers[userIdx]);
              }
            });
          });
      }

      return promise.then(function() {
        messageObj.threadList = threadList;
      });
    }
  }
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('calendarBody', ['assignmentsService', 'taskService', 'facilityAssignmentsService', '$q', function(assignmentsService, taskService, facilityAssignmentsService, $q) {
      return {
        restrict: 'E',
        templateUrl: '/app/components/calendar/calendar-body.html',
        scope: {
          monthOffset: '=?',
          options: '=?',
          user: '=?',
          onDaySelected: '&',
          addEvent: '&',
          canAddEvent: '=?'
        },
        link: calendarBodyLink
      };


      function calendarBodyLink($scope) {
        var body = $scope.body = {};

        $scope.options = $scope.options || {};

        // date for updating calendar view
        body.selectedDate = null;

        // day which will be highlighted as selected
        body.selectedMoment = null;

        _initDefaults();

        _calculateInitialDate();

        // public
        body.onDaySelected = onDaySelected;
        body.addEvent = addEvent;
        body.canAddEvent = $scope.canAddEvent === undefined ? true : $scope.canAddEvent;
        body.getSelectedMonthName = getSelectedMonthName;
        body.getSelectedMonthNumber = getSelectedMonthNumber;

        // remove becuse it because options.initialDate is not working
        // $scope.$watch('options.initialDate', _calculateInitialDate);
        $scope.$on('calendar:month:changed', _onMonthChanged);
        $scope.$on('calendar:day:changed', _onDayChanged);


        // //////////////////////////////////////////////////////////
        function onDaySelected(day, event) {
          if (!day) {
            console.warn('[Calendar] No  data'); // eslint-disable-line no-console
            return;
          }

          body.selectedDate = day.moment;
          _selectCalendarDay(day);

          if (angular.isFunction($scope.onDaySelected)) {
            $scope.onDaySelected({
              day: day,
              event: event
            });
          }
        }

        function addEvent(day) {
          if (!day) {
            return;
          }

          if (angular.isFunction($scope.addEvent)) {
            $scope.addEvent({
              day: day
            });
          }
        }

        function _selectCalendarDay(day) {
          var alreadySelectedDay = _findCalendarDay({ selected: true });
          if (alreadySelectedDay) {
            alreadySelectedDay.selected = false;
          }

          day.selected = true;
          _updateSelectedMoment(day.moment);
        }

        function _onDayChanged(e, day) {
          if ($scope.monthOffset) {
            return false;
          }

          var updateMonth = $q.when(),
            isSameMonth = day.isSame(body.selectedDate, 'month');

          if (!isSameMonth) {
            body.selectedDate = day;
            updateMonth = _calculateWeeks();
          }

          updateMonth.then(function() {
            var calendarDay = _findCalendarDay(function(weekDay) {
              return day.isSame(weekDay.moment, 'day');
            });

            onDaySelected(calendarDay);
          });
        }

        function _updateSelectedMoment(dayMoment) {
          body.selectedMoment = moment(dayMoment);
        }

        function _findCalendarDay(predicateFn) {
          return _.chain(body.weeks)
            .flatten()
            .filter()
            .find(predicateFn)
            .value();
        }

        function _findSelectedCalendarMoment() {
          return _findCalendarDay(function(weekDay) {
            return moment(body.selectedMoment).isSame(weekDay.moment, 'day');
          });
        }

        function getSelectedMonthName() {
          return body.selectedDate.format('MMMM');
        }

        function getSelectedMonthNumber() {
          return body.selectedDate.format('MM');
        }

        function _initDefaults() {
          body.weekdays = moment.weekdaysShort();
        }

        function _calculateWeeks(isInit) {
          var day, dayNumber, dateMoment, daysInCurrentMonth, week, // eslint-disable-line
            now = moment(),
            selectedYear = body.selectedDate.year(),
            selectedMonth = body.selectedDate.month();

          body.weeks = [];

          daysInCurrentMonth = body.selectedDate.daysInMonth();

          for (day = 1; day <= daysInCurrentMonth; day++) {
            dateMoment = moment().set({ year: selectedYear, month: selectedMonth, date: day });
            dayNumber = dateMoment.day();

            if (!week) {
              // 7days of week
              week = [null, null, null, null, null, null, null];
            }
            week[dayNumber] = {
              day: day,
              moment: dateMoment,
              current: now.isSame(dateMoment, 'day'),
              isFuture: dateMoment.isAfter(now, 'day'),
              selected: body.selectedDate.isSame(dateMoment, 'day')
            };


            if (dayNumber === 6 || day === daysInCurrentMonth) {
              body.weeks.push(week);
              week = null;
            }
          }


          return $scope.options.facilityAssignmentsCalendar ?
            _applyFacilityAssignmentsToWeeks(isInit) : _applyEventsToWeekDays(isInit);


        }

        function _calculateInitialDate() {
          if ($scope.options.initialDate) {
            body.selectedDate = moment($scope.options.initialDate);
          } else {
            body.selectedDate = moment();
          }

          _applyOffset();
          return _calculateWeeks(true);
        }

        function _onMonthChanged(e, month, year) {
          body.selectedDate.set('month', month).set('year', year);
          _applyOffset();

          return _calculateWeeks().then(function() {
            var selectedCalendarDay = _findSelectedCalendarMoment();
            onDaySelected(selectedCalendarDay);
          });
        }

        function _applyOffset() {
          if ($scope.monthOffset) {
            body.selectedDate.add($scope.monthOffset, 'month');
          }
        }


        function _applyEventsToWeekDays(isInit) {
          var startOfMonth = moment(body.selectedDate).startOf('month'),
            endOfMonth = moment(body.selectedDate).endOf('month');
          return $q.allSettled({
            assignments: fetchAssignments(startOfMonth, endOfMonth),
            massAssignments: fetchMassAssignments(startOfMonth, endOfMonth),
            tasks: fetchTasks(startOfMonth, endOfMonth)
          }).then(function(response) {
            var eventsGroups = [],
              massAssignments = _.get(response, 'massAssignments.value.data', []),
              assignments = _.get(response, 'assignments.value.data', []),
              tasks = _.get(response, 'tasks.value.data', []),

              allAssignments = _.concat(massAssignments, assignments);
            angular.forEach(allAssignments, function(assignment) {
              if (!_.isEmpty(assignment.exercises)) {
                eventsGroups.push({
                  assignmentId: assignment._id,
                  startDate: moment.unix(assignment.startDate),
                  endDate: moment.unix(assignment.endDate),
                  count: assignment.exercises.length,
                  assignment: assignment,
                  type: 'assignment'
                });
              }
            });

            angular.forEach(tasks, function(task) {
              if (!_.isEmpty(task.users)) {
                eventsGroups.push({
                  assignmentId: task._id,
                  startDate: moment.unix(task.startTime),
                  endDate: moment.unix(task.endTime),
                  count: 1,
                  assignment: task,
                  type: 'task'
                });
              }
            });

            populateCalendarEvents(eventsGroups, isInit);
          });
        }

        function _applyFacilityAssignmentsToWeeks(isInit) {
          var startOfMonth = moment(body.selectedDate).startOf('month').unix(),
            endOfMonth = moment(body.selectedDate).endOf('month').unix();
          return facilityAssignmentsService.getFacilityAssignmentsInMonth(startOfMonth, endOfMonth)
            .then(function(response) {
              var facilityAssignments = response || [];
              populateCalendarEvents(facilityAssignments.map(function(fa) {
                fa.startDate = moment.unix(fa.startDate);
                fa.endDate = moment.unix(fa.endDate);
                return fa;
              }), isInit);
            });
        }

        function fetchAssignments(startOfMonth, endOfMonth) {
          return assignmentsService.getSingleAssignments({
            startDate: moment(startOfMonth).startOf('day').unix(),
            endDate: moment(endOfMonth).endOf('day').unix(),
            exerciserId: $scope.user && $scope.user._id,
            limit: 1000
          });
        }

        function fetchMassAssignments(startOfMonth, endOfMonth) {
          return assignmentsService.getAssignments({
            startDate: moment(startOfMonth).startOf('day').unix(),
            endDate: moment(endOfMonth).endOf('day').unix(),
            trainerId: $scope.user && $scope.user._id,
            limit: 1000
          });
        }

        function fetchTasks(startOfMonth, endOfMonth) {
          return taskService.getTasks({
            startTime: moment(startOfMonth).startOf('day').unix(),
            endTime: moment(endOfMonth).add(1, 'day').startOf('day').unix(),
            userId: $scope.user && $scope.user._id,
            limit: 1000
          });
        }

        function populateCalendarEvents(eventList, isInit) {
          angular.forEach(body.weeks, function(week) {
            angular.forEach(week, function(date) {
              if (!date) {
                return;
              }
              var startOfDay = moment(date.moment).startOf('day'),
                endOfDay = moment(date.moment).add(1, 'day').startOf('day'),


                events = _.reject(eventList, function(event) {

                  //     event finished before this day           or  event will be started after this day
                  return startOfDay.isSameOrAfter(event.endDate) || endOfDay.isSameOrBefore(event.startDate);
                });

              // during initialiazing of calendar throw current day up
              if (isInit && date.selected) {
                $scope.$emit('calendar-body:day:init', date);
              }

              if (!events.length) {
                return;
              }

              date.events = events;
            });
          });
        }

      }
    }]);

}());
/* eslint-disable no-console */
(function() {
  'use strict';

  addClientService.$inject = ['$http', '$uibModal', '$translate', 'popup', 'userService', 'profileService', 'facilityService', '$state', 'toastr', 'formatUserService'];
  angular.module('ptCrm')
    .service('addClientService', addClientService);

  function addClientService($http, $uibModal, $translate, popup, userService, profileService, facilityService, $state, toastr, formatUserService) {


    return {
      addUser: addUserModal,
      addClientModal: addClientModal
    };

    function addUserModal(scope) {

      if (scope) {
        // closes the previous popup
        scope.cancel();
      }

      return popup.confirm({
        title: $translate.instant('ADD_USER'),
        cssClass: 'modal--select-from-list',
        templateUrl: '/app/components/add-client/add-user.modal.html',
        scope: {
          addClient: addClientModal,
          findFacility: findFacilityModal
        },
        showOk: false,
        showCancel: false
      });
    }

    function getConfirmUserModalConfig(user,previousDemoUserStatus, identifier, groups) {
      var selectedGroups = [];
      return {
        templateUrl: '/app/components/add-client/confirm-staff.modal.html',
        okText: $translate.instant('CONFIRM'),
        cssClass: 'modal--confirm-client',
        scope: {
          user: user,
          identifier: identifier,
          membershipGroups: groups,
          selectedGroups: selectedGroups,
          previousDemoUser: previousDemoUserStatus,
          isAdmin: profileService && profileService.user && profileService.user.admin ? profileService.user.admin : false
        }
      };
    }

    // ============ Client =============
    function addClientModal(scope) {
      if (scope) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_CLIENT'),
        templateUrl: '/app/components/add-client/add-client.modal.html',
        okText: $translate.instant('CONNECT'),
        cssClass: 'modal--add-client',
        okAction: findClient,
        showBack: true,
        backAction: addUserModal,
        scope: {
          ptApiId: null,
          isSmartHealth: profileService.user.club.smartHealthEnabled,
          isUpace: profileService.user.club.clubId===14283,
          addClientForm: {}
        }
      });

    }

    function findClient(scope, modalInstance) {
      if (scope.addClientForm.$valid) {
        scope.showLoading(true);
        if (!profileService.user.club.smartHealthEnabled) {
          userService.getExerciserProfile(scope.ptApiId).then(function(user) {
            modalInstance.close();
            confirmClientModal(user, scope.ptApiId);
          }).catch(function() {
            modalInstance.close();
            popup.alert({
              title: $translate.instant('NOT_FOUND'),
              okAction: addClientModal
            });
          });
        } else {
          // eslint-disable-next-line no-console
          userService.getSmartHealthProfile(encodeURIComponent(scope.ptApiId),profileService.user.club.clubId).then(function(user) {
            // eslint-disable-next-line no-console
            if (user && user.length) {
              modalInstance.close();
              confirmClientModal(user, scope.ptApiId);
            } else {
              modalInstance.close();
              popup.alert({
                title: $translate.instant('SMART_HEALTH_USER_NOT_FOUND'),
                okAction: addClientModal
              });
            }
          }).catch(function() {
            modalInstance.close();
            popup.alert({
              title: profileService.user.club.smartHealthEnabled ? $translate.instant('SMART_HEALTH_USER_NOT_FOUND') : $translate.instant('NOT_FOUND'),
              okAction: addClientModal
            });
          });
        }
      }
    }

    function confirmClientModal(user, ptApiId) {
      facilityService.getFacilityMembershipGroups(profileService.user.activeFacility._id).then(function(groups) {

        return $uibModal.open({
          templateUrl: '/app/components/add-client/confirm-client.modal.html',
          okText: $translate.instant('CONFIRM'),
          windowClass: 'modal--confirm-client',
          controller: 'confirmClientController',
          controllerAs: 'confirmClientCtrl',
          bindToController: true,
          resolve: {
            user: function() {
              return user;
            },
            membershipGroups: function() {
              return groups;
            },
            identifier: function() {
              return ptApiId;
            },
            facilityId: function() {
              return profileService.user.activeFacility._id;
            },
            activeFacility: function() {
              return profileService.user.activeFacility;
            }
          }
        });
      });
    }

    // ============ Facility =============
    function addFacility(scope, modalInstance) {
      if (scope.addFacilityForm.$valid) {
        scope.showLoading(true);
        userService.createStaffUser({
          email: scope.email,
          firstName: scope.firstName,
          lastName: scope.lastName,
          isDemoUser: scope.isDemoUser
        }, scope.chainWide).then(function(user) {
          modalInstance.close();
          $state.go('app.users.details', { userId: user._id , roles:'facility_staff' });
        }).catch(function(error) {
          scope.showLoading(false);
          toastr.warning(error.data.message);
        });
      }
    }

    function confirmFacilityModal(user) {
      var csmValue = user && user.roles[0] === 'facility_staff' ? 'CONFIRM_EXISTING_STAFF_USER' : 'CONFIRM_EXISTING_USER',
        isDemoUser=user.isDemoUser,
        template = _.extend(getConfirmUserModalConfig(user,isDemoUser), {
          title: $translate.instant(csmValue),
          okAction: confirmFacility
        });

      return popup.confirm(template);
    }

    function confirmFacility(scope, modalInstance) {
      scope.showLoading(true);

      var confirmCLient = userService.assignStaffUserToFacility(scope.user._id);
      confirmCLient.then(function() {
        if (scope.previousDemoUser !== scope.user.isDemoUser) {
          var updatedUser = formatUserService.restructureUser('personalInfo', scope.user);
          userService.updateStaffUser(updatedUser, scope.user._id).then(function() {
            modalInstance.close();
            $state.go('app.users.details', { userId: scope.user._id ,roles:'facility_staff' });
          });
        } else {
          modalInstance.close();
          $state.go('app.users.details', { userId: scope.user._id ,roles:'facility_staff' });
        }
      });
    }

    function findFacilityModal(scope) {
      if (scope) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_STAFF'),
        templateUrl: '/app/components/add-client/find-staff.modal.html',
        okText: $translate.instant('FIND'),
        cssClass: 'modal--add-client',
        okAction: findFacility,
        showBack: true,
        backAction: addUserModal,
        scope: {
          email: null,
          findFacilityForm: {}
        }
      });
    }

    function findFacility(scope, modalInstance) {
      if (scope.findFacilityForm.$valid) {
        scope.showLoading(true);
        userService.getStaff({
          email: scope.email,
          allUsers: true
        }).then(function(users) {
          modalInstance.close();
          if (_.isEmpty(users)) {
            addFacilityModal(users, scope.email);
          } else {
            confirmFacilityModal(_.first(users));
          }
        });
      }
    }

    function addFacilityModal(scope, email) {
      if (scope && scope.cancel) {
        // closes the previous popup
        scope.cancel();
      }
      return popup.confirm({
        title: $translate.instant('ADD_STAFF'),
        templateUrl: '/app/components/add-client/add-staff.modal.html',
        okText: $translate.instant('CONNECT'),
        cssClass: 'modal--add-client',
        okAction: addFacility,
        showBack: true,
        backAction: findFacilityModal,
        scope: {
          firstName: null,
          lastName: null,
          email: email || null,
          password: null,
          isAdmin: profileService && profileService.user && profileService.user.admin ? profileService.user.admin : false,
          addFacilityForm: {}
        }
      });
    }

  }
}());
/* eslint-disable no-console */
'use strict';

angular.module('ptCrm').controller('confirmClientController', ['user', 'identifier', 'facilityId', 'activeFacility', 'userService', 'addClientService', 'membershipGroups', '$uibModalInstance', '$state', '$translate', 'popup', 'profileService', 'notesService', 'facilityService', '$q', function(user, identifier, facilityId, activeFacility, userService, addClientService, membershipGroups, $uibModalInstance, $state, $translate, popup, profileService, notesService, facilityService, $q) {
  var vm = this;
  vm.user = user;
  vm.membershipGroups = membershipGroups;
  vm.identifier = identifier;
  vm.facilityId = facilityId;
  vm.allGroups = { name: '-- All --' };
  vm.membershipGroups.push(vm.allGroups);
  vm.activeFacility = activeFacility;
  vm.selectedUser = null;
  vm.isSmartHealth = profileService.user.club.smartHealthEnabled;
  vm.defaultNote = facilityService.defaultNote;
  vm.isAdmin =$state.params.userId === 'me' && profileService.user.admin;
  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };

  vm.submit = function() {
    vm.isLoading = true;
    if (!profileService.user.club.smartHealthEnabled) {

      userService.activateClientByPtApiId(vm.identifier).then(function(user) {

        var groupIds = _.map(vm.selectedGroups, function(group) {
          return group._id;
        });
        userService.updateClientUserMembershipGroups(vm.facilityId, user._id, groupIds).then(function() {
          if (Object.keys(vm.defaultNote).length && vm.defaultNote.title !== undefined && vm.defaultNote.title !== '') {
            return $q.resolve(notesService.createDefaultNote(user._id, vm.defaultNote,vm.isAdmin,facilityService.facilityId,vm.defaultNote._id).then(()=>{
              $uibModalInstance.close();
              $state.go('app.users.details', { userId: user._id ,roles: user.roles[0] });
            }));
          }
          $uibModalInstance.close();
          $state.go('app.users.details', { userId: user._id ,roles: user.roles[0] });
        });
      })
        .catch(function(err) {
          $uibModalInstance.close();

          var errorDescription;

          switch (err.status) {
          case 400:
            errorDescription = $translate.instant('ERROR_LOGIN_INCORRECT');
            break;
          case 401:
            errorDescription = $translate.instant('ERROR_XID_PASSCODE_INCORRECT');
            break;
          case 409:
            errorDescription = $translate.instant('ERROR_XID_CONFLICT');
            break;
          default:
            errorDescription = $translate.instant('ERROR_COMMON');
            break;
          }

          popup.alert({
            title: $translate.instant('ERROR'),
            description: errorDescription,
            okAction: addClientService.addClientModal
          });
        });
    } else {
      const userInfo = {
        username: String(vm.selectedUser.UserId),
        password: '',
        type: 'custom',
        club_id: profileService.user.club.clubId
      };
      userService.loginToExerciser(userInfo).then(function(user) {
        var groupIds = _.map(vm.selectedGroups, function(group) {
          return group._id;
        });
        userService.updateClientUserMembershipGroups(vm.facilityId, user._id, groupIds).then(function() {
          $uibModalInstance.close();
          $state.go('app.users.details', { userId: user._id , roles: user.roles[0] });
        });
      })
        .catch(function(err) {
          $uibModalInstance.close();

          var errorDescription;

          switch (err.status) {
          case 400:
            errorDescription = $translate.instant('ERROR_LOGIN_INCORRECT');
            break;
          case 401:
            errorDescription = $translate.instant('ERROR_XID_PASSCODE_INCORRECT');
            break;
          case 409:
            errorDescription = $translate.instant('ERROR_XID_CONFLICT');
            break;
          default:
            errorDescription = $translate.instant('ERROR_COMMON');
            break;
          }

          popup.alert({
            title: $translate.instant('ERROR'),
            description: errorDescription,
            okAction: addClientService.addClientModal
          });
        });
    }
  };

  vm.addAllGroups = function(item, model) {
    if (item.name === vm.allGroups.name) {
      vm.selectedGroups = vm.membershipGroups.filter(function(group) {
        return group.name !== item.name;
      });
    }
    if (vm.selectedGroups.length === vm.membershipGroups.length - 1) {
      var removeAll = vm.membershipGroups.filter(function(group) {
        return group.name !== vm.allGroups.name;
      });
      vm.membershipGroups = removeAll.slice();
    }
  };

  vm.addAllCheck = function(item, model) {
    var value = vm.membershipGroups.find(function(group) {
      return group.name === vm.allGroups.name;
    });
    if (!value) {
      vm.membershipGroups.push(vm.allGroups);
    }
  };

  vm.setSelectedUser = function(user) {
    vm.selectedUser = user;
  };

  vm.ifObject = (obj) => {
    return (
      typeof obj === 'object' &&
      obj !== null &&
      !Array.isArray(obj)
    );
  };
}]);(function() {

  'use strict';

  headerController.$inject = ['authService', 'popup', 'profileService', 'userService'];
  angular.module('ptCrm')
    .controller('HeaderController', headerController);

  function headerController(authService, popup, profileService, userService) {

    var vm = this;
    vm.selectNewFacility = selectNewFacility;
    vm.logout = logout;
    vm.showAllFacilities = showAllFacilities;

    vm.facilities = _.sortBy(profileService.user.facilities, function(facility) {
      return facility.name.toLowerCase();
    });

    vm.selectedFacility = profileService.user.activeFacility._id;

    function logout() {
      authService.logout();
    }

    function showAllFacilities() {
      vm.modal = popup.show({
        title: 'Your Facilities',
        showCancel: false,
        showOk: false,
        templateUrl: '/app/components/header/facility.modal.html',
        cssClass: 'modal--select-from-list',
        backdrop: 'static',
        scope: {
          facilities: vm.facilities,
          selectNewFacility: selectNewFacility,
          selectedFacility: vm.selectedFacility
        },
        afterModalRendered: function() {
          document.querySelector('.modal__list-item--active-facility').scrollIntoView(true);
        }
      });
    }

    function selectNewFacility(facility) {
      if (!(this.$parent && this.$parent.isLoading)
        && profileService.user.activeFacility._id !== facility._id &&
        _.includes(profileService.permissionNames, 'CURRENT_FACILITY_UPDATE')) {
        if (this.$parent) {
          this.$parent.isLoading = true;
          this.$parent.selectedFacility = facility._id;
        }
        userService.updateCurrentUser({
          activeFacility: facility._id
        }).then(authService.refreshPage);
      }
    }

  }


}());
(function(angular) {

  'use strict';

  angular.module('ptCrm')
    .directive('ptCrmHeader', function() {
      return {
        restrict: 'E',
        templateUrl: '/app/components/header/header.html',
        controller: 'HeaderController',
        controllerAs: 'header'
      };
    });

}(angular));
(function(angular) {

  'use strict';

  leftMenuController.$inject = ['$rootScope', 'addClientService', 'profileService', 'messagingService', 'popup', '$state', '$translate'];
  angular.module('ptCrm')
    .directive('ptCrmLeftMenu', function() {
      return {
        restrict: 'E',
        templateUrl: '/app/components/left_menu/left_menu.html',
        controller: leftMenuController,
        controllerAs: 'menu'
      };
    });

  angular.module('ptCrm')
    .directive('ptCrmLeftMenuToggle', function() {
      return {
        require: '^ptCrmLeftMenu',
        link: function($scope, $element, $attrs, menuCtrl) {
          $element.bind('click', function() {
            $scope.$apply(menuCtrl.toggle);
          });
        }
      };
    });

  function leftMenuController($rootScope, addClientService, profileService, messagingService, popup, $state, $translate) {

    var vm = this;

    vm.toggle = toggleMenu;
    vm.addUser = addClientService.addUser;

    document.body.addEventListener('click', function(e) {
      var target = e.target;
      if(!target.closest('.left-menu__section--collapsed-button-container')) {
        document.getElementById('left-menu_blue_add_icon').classList.remove('left-menu__item-img--arrow_icon');
        document.getElementById('left-menu_blue_add_icon').classList.add('left-menu__item-img--collapsed_add_icon');
        document.getElementById('collapsed-blue-icons-container').classList.add('blue-icons-container__hide');
      }
    }, true);

    vm.assignmentFlowSelect = function() {
      popup.confirm({
        title: $translate.instant('SELECT_ASSIGNMENT_TYPE'),
        templateUrl: '/app/components/left_menu/assignment_flow.html',
        showOk: false,
        okAction: function(popupScope, modalInstance) {
          if (popupScope.okArgs) {
            var type = popupScope.okArgs[0];
            if (type === 'assignment') {
              $state.go('app.assignment');
              modalInstance.close();
            }
            if (type === 'trainingPlan') {
              $state.go('app.trainingPlan');
              modalInstance.close();
            }
          }
        }
      });
    };

    vm.toggleCollapsedBtns = function() {
      var element = document.getElementById('left-menu_blue_add_icon');
      document.getElementById('collapsed-blue-icons-container').classList.toggle('blue-icons-container__hide');
      if(element.classList.contains('left-menu__item-img--arrow_icon')) {
        element.classList.remove('left-menu__item-img--arrow_icon');
        element.classList.add('left-menu__item-img--collapsed_add_icon');
      } else {
        element.classList.remove('left-menu__item-img--collapsed_add_icon');
        element.classList.add('left-menu__item-img--arrow_icon');
      }
    };

    vm.showWorkoutOfTheDay = profileService.user.activeFacility.workoutOfTheDay;
    vm.showMessaging = profileService.user.activeFacility.messaging;

    if (vm.showMessaging) {
      $rootScope.$on('messageUpdate', function() {
        // listen for changes to unreadMessages to show dot
        vm.unreadMessages = vm.showMessaging && messagingService.unreadMessages;
      });
    }

    $rootScope.$on('$stateChangeStart', closeMenu);

    closeMenu();

    function closeMenu() {
      vm.isOpened = false;
    }

    function toggleMenu() {
      vm.isOpened = !vm.isOpened;
    }
  }

}(angular));
(function() {

  'use strict';

  angular.module('ptCrm')
    .controller('ItemsSwitcherCtrl', ItemsSwitcherCtrl);

  function ItemsSwitcherCtrl() {
    var vm = this;
    vm.activeItemIndex = 0;

    this.activateItem = function(index) {
      vm.activeItemIndex = index;
      this.onIndexUpdate({ newIndex:index });
    };
  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptItemsSwitcher', ptItemsSwitcher);

  function ptItemsSwitcher() {
    return {
      templateUrl: '/app/components/items-switcher/items-switcher.html',
      bindToController: {
        selectedItems: '=?', // array of already selected into bag items
        bagType: '@', // type of main result item in terms of app (exercises, sets ...)
        onIndexUpdate: '&' // callback with new index when a new exercise is clicked on for editing
      },
      controller: 'ItemsSwitcherCtrl as switcherCtrl'
    };
  }

}());
(function() {

  'use strict';

  ItemsSelectorCtrl.$inject = ['$scope', '$rootScope', 'toastr', 'exercisesService', 'camelToSnakeCaseFilter', 'trainingSetService', 'exercisersService', '$window'];
  angular.module('ptCrm')
    .controller('ItemsSelectorCtrl', ItemsSelectorCtrl);

  function ItemsSelectorCtrl($scope, $rootScope, toastr, exercisesService, camelToSnakeCaseFilter, trainingSetService, exercisersService, $window) {

    $window.onclick = function(event) {
      if (vm.showDropdown) {
        var isDropdownButton = event.target.classList.contains('training-library__tags-dropdown-button'),
          isTag = event.target.classList.contains('training-library__tags-dropdown-item');
        if (!isTag && !isDropdownButton) {
          vm.toggleShowDropdown();
          $scope.$apply();
        }
      }
    };

    var vm = this,
      previousMouseYPosition,
      selectedItemsBackup = [];
    vm.scope = $scope;
    vm.removedItems = [];
    vm.selectedTagList = [];
    vm.allTags = '';
    vm.buttonTags = '';
    vm.dropdownTags = '';
    vm.showDropdown = false;
    vm.toggleShowDropdown = toggleShowDropdown;
    vm.selectedTab = 'EXERCISES';
    vm.allExercises = exercisesService.getAllExercises({}, exercisesService.extendExercises);
    vm.allExercises.load();
    vm.addItem = function(item) {
      vm.selectedItems.push(angular.copy(item));
      extractSet();
    };

    vm.removeItem = function(idx) {
      vm.selectedItems.splice(idx, 1);
    };

    exercisesService.getAvailableExerciseTags().then(function(value) {
      vm.allTags = value.all;
      vm.buttonTags = value.atLeastOneExercise.slice(0, 5);
      vm.dropdownTags = value.atLeastOneExercise.slice(5);
    });

    vm.setFilterTag = function(tag) {

      if (tag === 'allExercises' ) {
        vm.selectedTagList = [];
      } else if (_.find(vm.selectedTagList, function(item) { return item._id === tag._id; })) {
        removeTagFromSelectedTagList(tag);
      } else {
        vm.selectedTagList.push(tag);
      }

      filterByTag();
    };

    function filterByTag() {
      var queryParamObject = {};
      if (vm.selectedTagList.length > 0) {
        queryParamObject.tag = _.map(vm.selectedTagList, function(tag) { return tag.tag; });
      } else {
        queryParamObject.tag = '';
      }
      if (vm.itemSearch) {
        queryParamObject.search = vm.itemSearch;
      }

      return Promise.all(_.map(vm.itemsLists, function(itemsList) {
        return itemsList
          .extendDefaultParams(queryParamObject)
          .load({ update: true });
      }));
    }

    function toggleShowDropdown() {
      vm.showDropdown = !vm.showDropdown;
    }

    function removeTagFromSelectedTagList(tagToRemove) {
      var tagIndex = _.findIndex(vm.selectedTagList, function(item) { return item._id === tagToRemove._id; });
      vm.selectedTagList.splice(tagIndex, 1);
    }

    vm.checkIfTabIsSelected = function(tag) {
      return _.findIndex(vm.selectedTagList, function(item) { return item._id === tag._id; }) > -1;
    };

    vm.changeTab = function(name) {
      vm.selectedTab = name;
    };

    vm.filterItems = filterItems;
    vm.dragCopy = !!vm.dragCopy;
    $scope.$watch('selectorCtrl.id', function() {
      var action = vm.id ? '_UPDATE' : '_CREATE',
        subject = vm.isChainWide ? 'CHAIN_WIDE' : camelToSnakeCaseFilter(vm.bagType);
      vm.editBagPermission = subject + action;
    });

    if (!vm.dragCopy) {
      $scope.$watch(function() {
        return vm.selectedItems;
      }, function(newArr, oldArr) {
        if (newArr.length > oldArr.length) {
          vm.selectedItems = oldArr.concat(_.differenceBy(newArr, oldArr, '_id'));
        }
      }, true);
    }

    // Configure ng-sortable drag and drop sorting directive

    vm.sortableDestinationConfig = {
      group: {
        name: 'itemsList.selected',
        put: 'itemsList.source',
        pull: true
      },
      draggable: '.draggable',
      handle: '.js-drag-handle',
      animation: 250,
      forceFallback: true,
      fallbackOnBody: true,
      onStart: function(evt) {
        // In case a sort order occurs before dropping an item to remove it,
        // we need to store the initial order of the list
        selectedItemsBackup = angular.copy(vm.selectedItems);
        vm.allowItemRemoval = true;
        document.body.classList.add('drag-in-progress');
      },
      onEnd: function(evt) {
        vm.allowItemRemoval = false;
        document.body.classList.remove('drag-in-progress');
      },
      onRemove: function(evt) {
        selectedItemsBackup.splice(evt.oldIndex,1);
        vm.selectedItems = selectedItemsBackup;
        vm.removedItems.splice(0,1);
      },
      onMove: function(evt, originalEvt) {
        ifDragGhostExists(function(dragGhost) {
          if (evt.to.classList.contains('items-selector__item-removal-area')) {
            dragGhost.classList.add('sortable-fallback--removing');
            dragGhost.classList.remove('sortable-drag');
          } else {
            dragGhost.classList.remove('sortable-fallback--removing');
            dragGhost.classList.add('sortable-drag');
          }
        });

        // by returning a 1 or a -1 (not just any positive or negative value)
        // we can effect whether the element will be placed before or after
        // the current element.  This is undocumented in the SortableJS docs.
        // The code:
        // https://github.com/RubaXa/Sortable/blob/56022568d9f1f485dff620c89a9092bb13293bc4/Sortable.js#L806-L830
        // I also opened an issue: https://github.com/RubaXa/Sortable/issues/1183
        var vector = originalEvt.clientY > previousMouseYPosition ? 1 : -1;
        previousMouseYPosition = originalEvt.clientY;
        return vector;
      },
      onAdd: extractSet
    };

    vm.sortableSourceConfig = {
      group: {
        name: 'itemsList.source',
        pull: 'clone',
        put: false
      },
      sort: false,
      forceFallback: true,
      fallbackOnBody: true,
      draggable: '.draggable',
      onStart: function(evt) {
        document.body.classList.add('drag-in-progress');
        vm.allowItemRemoval = true;
      },
      onEnd: function(evt) {
        document.body.classList.remove('drag-in-progress');
        vm.allowItemRemoval = false;
      },
      onMove: function(evt, originalEvt) {
        ifDragGhostExists(function(dragGhost) {
          if (evt.to.classList.contains('items-selector__selected-list')) {
            dragGhost.classList.add('sortable-fallback--adding');
          } else {
            dragGhost.classList.remove('sortable-fallback--adding');
          }
        });

        var vector = originalEvt.clientY > previousMouseYPosition ? 1 : -1;
        previousMouseYPosition = originalEvt.clientY;
        return vector;
      }
    };

    vm.sortableRemoveAreaConfig = {
      group: {
        name: 'itemsList.remove',
        put: ['itemsList.selected', 'itemsList.source']
      },
      draggable: '.draggable',
      forceFallback: true,
      fallbackOnBody: true,
      sort: false
    };

    // =============== METHODS =====================

    function filterItems() {
      return Promise.all(_.map(vm.itemsLists, function(itemsList) {
        var list = itemsList.extendDefaultParams({
          search: vm.itemSearch
        });

        if (vm.getItemParams) {
          var customParams = vm.getItemParams(); // eslint-disable-line
          list = list.extendDefaultParams(customParams);
        }

        var loadParams = { // eslint-disable-line
          update: true
        };

        if (vm.getLoadParams) {
          loadParams = _.extend(loadParams, vm.getLoadParams());
        }

        return list.load(loadParams);
      }));
    }

    function extractSet() {
      // only trainingSet will have exercises
      var index = _.findIndex(vm.selectedItems, 'exercises.length'),
        args;

      if (index > -1) {
        args = [index, 1].concat(exercisesService.extendExercises(vm.selectedItems[index].exercises));
        Array.prototype.splice.apply(vm.selectedItems, args);
      }
    }

    function ifDragGhostExists(handler) {
      var dragGhost = document.querySelector('.sortable-fallback');
      if (dragGhost) {
        handler(dragGhost);
      }
    }
  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptItemsSelector', ptItemsSelector);

  function ptItemsSelector() {
    return {
      templateUrl: '/app/components/items-selector/items-selector.html',
      bindToController: {
        selectedItems: '=?', // array of already selected into bag items
        activeItemIndex: '=?', // selected from bag item index to show details (1,2)
        isChainWide: '<?', // if it is set and it is chainwide
        id: '=?', // id of main element, if exists
        itemsLists: '=', // array of paginationLists of possible items
        editItem: '=?', // function to edit part items
        bagType: '@', // type of main result item in terms of app (exercises, sets ...)
        itemType: '@', // type of items(parts) in terms of app (exercises, sets ...)
        hidePrintIcon: '=', // define showing print icon on library card
        dragCopy: '=?', // set dragula-copy inside the directive
        getItemParams: '=', // get custom item load request parameters from caller
        getLoadParams: '=', // get custom load parameters from caller
        showTags: '=?'
      },
      controller: 'ItemsSelectorCtrl as selectorCtrl',
      link: function(scope, element) {
        // Ensure horizontal scroll is engaged when dragging items beyond edge of viewport
        autoScroll([document.querySelector('.scroll-wrapper')], {
          margin: 100,
          maxSpeed: 5,
          scrollWhenOutside: true,
          autoScroll: function() {
            // Only scroll when mouse/touch is down
            return this.down;
          }
        });
      }
    };
  }

}());
(function() {

  'use strict';

  UsersBagCtrl.$inject = ['$scope', 'toastr'];
  angular.module('ptCrm')
    .controller('UsersBagCtrl', UsersBagCtrl);

  function UsersBagCtrl($scope, toastr) {
    var vm = this;

    // need this for dragula
    vm.scope = $scope;
    vm.searchStr = '';

    vm.deselectUser = deselectUser;
    vm.loadUsers = loadUsers;
    vm.filterDuplicates = filterDuplicates;

    $scope.$watch(function() {
      return vm.selectedUsers;
    }, function(newArr, oldArr) {
      if (newArr.length > oldArr.length) {
        vm.selectedUsers = oldArr.concat(_.differenceBy(newArr, oldArr, '_id'));
      }
    }, true);

    loadUsers();

    // =============== METHODS =====================
    function deselectUser(index) {
      var user = vm.selectedUsers[index];
      if (user) {
        vm.selectedUsers.splice(index, 1);
        vm.usersList.items.push(user);
      } else {
        toastr.error('Cannot find selected user');
      }
    }

    function loadUsers(searchStr) {
      return vm.usersList
        .extendDefaultParams({ search: searchStr })
        .load({
          update: angular.isDefined(searchStr)
        })
        .then(vm.filterDuplicates);
    }


    //  ============ HELPERS ===============
    function filterDuplicates() {
      vm.usersList.items = _.reject(vm.usersList.items, function(user) {
        return _.find(vm.selectedUsers, { _id: user._id });
      });

      return vm.usersList.items;
    }
  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptUsersBag', ptUsersBag);

  function ptUsersBag() {
    return {
      templateUrl: '/app/components/users-bag/users-bag.html',
      bindToController: {
        selectedUsers: '=?',      // array of already selected into bag users
        usersList: '=',           // paginationList of possible users
        bagType: '@',             // type of main result user in terms of app (exercises, sets ...)
        userType: '@',            // type of users(parts) in terms of app (exercises, sets ...)
        editBagPermission: '=?',  // permission to edit bag (as training_sets_update)
        bagLimit: '@?'            // max number of items in a bag
      },
      controller: 'UsersBagCtrl as bagCtrl'
    };
  }

}());
(function() {

  'use strict';

  TimeSlotController.$inject = ['profileService', 'popup', 'taskService'];
  angular.module('ptCrm')
    .controller('TimeSlotController', TimeSlotController);

  function TimeSlotController(profileService, popup, taskService) {


    var vm = this;
    vm.showTaskInfo = showTaskInfo;
    vm.editTimeSlot = editTimeSlot; // proxy to stop propogation
    vm.isTask = taskService.isTask;

    var isMy = vm.item.exerciserId === profileService.user._id;
    var owner = isMy ? '_SELF' : '_OTHER';
    var subject = taskService.isTask(vm.item) ? 'TASKS' : 'WORKOUT_ASSIGNMENTS';
    vm.editPermission = subject + owner + '_UPDATE';
    vm.readPermission = subject + owner + '_READ';

    var dateTimeTo = moment(vm.item.dateTo).hour(0).minute(0).second(0).add(vm.item.timeTo, 'hours');
    vm.isPassedAssignment = vm.item.type === 'assignment' && dateTimeTo.isBefore(moment());

    // =============== METHODS ===============
    function showTaskInfo($event) {
      $event.stopPropagation();
      popup.alert({
        title: vm.item.title,
        description: vm.item.description
      });
    }

    function editTimeSlot($event, client) {
      $event.stopPropagation();
      vm.editSlot(client);
    }

  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptTimeSlot', ptTimeSlot);

  function ptTimeSlot() {
    return {
      templateUrl: '/app/components/time-slot/time-slot.html',
      bindToController: {
        item: '=',            // item (timeTo, timeFrom, img, caption, club, type, exerciserId)
        editSlot: '=?',       // function to call for editing timeslot
        isEditable: '='
      },
      controller: 'TimeSlotController as timeCtrl'
    };
  }

}());
(function() {

  'use strict';

  TaskCardController.$inject = ['profileService', 'popup', 'taskService'];
  angular.module('ptCrm')
    .controller('TaskCardController', TaskCardController);

  function TaskCardController(profileService, popup, taskService) {


    var vm = this;
    vm.showTaskInfo = showTaskInfo;
    vm.editTaskCard = editTaskCard; // proxy to stop propogation
    vm.isTask = taskService.isTask;

    var isMy = vm.item.exerciserId === profileService.user._id;
    var owner = isMy ? '_SELF' : '_OTHER';
    var subject = taskService.isTask(vm.item) ? 'TASKS' : 'WORKOUT_ASSIGNMENTS';
    vm.editPermission = subject + owner + '_UPDATE';
    vm.readPermission = subject + owner + '_READ';

    var dateTimeTo = moment(vm.item.dateTo).hour(0).minute(0).second(0).add(vm.item.timeTo, 'hours');
    vm.isPassedAssignment = vm.item.type === 'assignment' && dateTimeTo.isBefore(moment());

    // =============== METHODS ===============
    function showTaskInfo($event) {
      $event.stopPropagation();
      popup.alert({
        title: vm.item.title,
        description: vm.item.description
      });
    }

    function editTaskCard($event, client) {
      $event.stopPropagation();
      vm.editCard(client);
    }

  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('taskCard', taskCard);

  function taskCard() {
    return {
      templateUrl: '/app/components/task-card/task-card.html',
      bindToController: {
        item: '=',            // item (timeTo, timeFrom, img, caption, club, type, exerciserId)
        editCard: '=?',       // function to call for editing task card
        isEditable: '='
      },
      controller: 'TaskCardController as taskCtrl'
    };
  }

}());
(function() {
  'use strict';

  ExerciseItemDetailsController.$inject = ['$scope', 'camelToSnakeCaseFilter'];
  angular.module('ptCrm')
    .controller('ExerciseItemDetailsController', ExerciseItemDetailsController);

  function ExerciseItemDetailsController($scope, camelToSnakeCaseFilter) {

    var vm = this;
    if (!vm.editPermission) {
      $scope.$watch('itemCtrl.item', function() {
        var action = (vm.item && vm.item._id) ? '_UPDATE' : '_CREATE',
          subject = (vm.item && vm.item.chainWide) ? 'CHAIN_WIDE' : camelToSnakeCaseFilter(vm.type);
        vm.editPermission = subject + action;
      });
    }

  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptExerciseItemDetails', function() {

      return {
        templateUrl: '/app/components/exercise-item-details/exercise-item-details.html',
        bindToController: {
          item: '=',
          editPermission: '=?',
          type: '@'
        },
        controller: 'ExerciseItemDetailsController as itemCtrl'
      };
    });

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptEmbedVideo', ['$sce', function($sce) {

      var youTubeRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
        vimeoRegExp = /^(http:\/\/|https:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/,
        youtubeBaseSrc = 'https://www.youtube.com/embed/',
        vimeoBaseSrc = 'https://player.vimeo.com/video/';

      return {
        templateUrl: '/app/components/embed-video/embed-video.html',
        scope: {
          url: '<',
          onInvalid: '&'
        },
        link: ptEmbedVideoLink
      };

      function ptEmbedVideoLink(scope) {
        var youtubeSrc,
          vimeoSrc;
        scope.trustedYoutubeSrc = '';
        scope.trustedVimeoSrc = '';

        scope.$watch('url', function(newVal) {

          if (_isValidYoutubeUrl(newVal)) {
            youtubeSrc = youtubeBaseSrc + _getYoutubeVideoId(newVal);
            scope.trustedYoutubeSrc = getTrustedSrc(youtubeSrc);
            scope.trustedVimeoSrc = '';
            return;
          }

          if (_isValidVimeoUrl(newVal)) {
            vimeoSrc = vimeoBaseSrc + _getVimeoVideoId(newVal);
            scope.trustedVimeoSrc = getTrustedSrc(vimeoSrc);
            scope.trustedYoutubeSrc = '';
            return;
          }

          scope.onInvalid();
        });


      }

      function _isValidYoutubeUrl(url) {
        return youTubeRegExp.test(url);
      }

      function _isValidVimeoUrl(url) {
        return vimeoRegExp.test(url);
      }

      function _getYoutubeVideoId(url) {
        var match = url.match(youTubeRegExp);
        return match[1];
      }

      function _getVimeoVideoId(url) {
        var match = url.match(vimeoRegExp);
        return match[4];
      }

      function getTrustedSrc(src) {
        return $sce.trustAsResourceUrl(src);
      }

    }]);

}());
(function() {

  'use strict';

  ExerciseMultimediaCtrl.$inject = ['$scope'];
  angular.module('ptCrm')
    .controller('ExerciseMultimediaCtrl', ExerciseMultimediaCtrl);

  function ExerciseMultimediaCtrl($scope) {

    var vm = this;

    vm.videoUrl = '';
    vm.isVideoUrlInvalid = false;
    vm.showEmbedVideo = false;

    vm.onVideoUrlChange = onVideoUrlChange;
    vm.onVideoPreview = onVideoPreview;
    vm.onVideoUrlInvalid = onVideoUrlInvalid;

    $scope.$watch(function() {
      return vm.video;
    }, function(newVal) {
      if (newVal) {
        vm.videoUrl = newVal;
        onVideoPreview();
      }
    });

    function onVideoUrlChange() {
      if (!vm.videoUrl) {
        vm.isVideoUrlInvalid = false;
      }
    }

    function onVideoPreview() {
      if (vm.videoUrl) {
        vm.videoUrlForEmbedVideo = vm.videoUrl;
        vm.onVideoUpdate({ url: vm.videoUrl });
        vm.isVideoUrlInvalid = false;
        vm.showEmbedVideo = true;
      }
    }

    function onVideoUrlInvalid() {
      vm.showEmbedVideo = false;
      vm.isVideoUrlInvalid = true;
      vm.onVideoUpdate('');
    }

  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptExerciseMultimedia', ptExerciseMultimedia);

  function ptExerciseMultimedia() {
    return {
      templateUrl: '/app/components/exercise-multimedia/exercise-multimedia.html',
      bindToController: {
        video: '<',
        type: '@',
        imagesList: '=',
        imagesLimit: '<?',
        onVideoUpdate: '&'
      },
      controller: 'ExerciseMultimediaCtrl as exMultCtrl'
    };
  }

}());
(function() {

  'use strict';

  ImageCarouselCtrl.$inject = ['$q', '$scope'];
  angular.module('ptCrm')
    .controller('ImageCarouselCtrl', ImageCarouselCtrl);

  function ImageCarouselCtrl($q, $scope) {
    var vm = this;

    vm.imagesLimit = vm.imagesLimit || Infinity;
    vm.setTransform = _setImageTransform;
    vm.getTransformType = _getTransformType;
    vm.getBackgroundColor = _getBackgroundColor;
    vm.setBackgroundColor = _setBackgroundColor;


    $scope.$watchCollection(function() {
      return vm.imagesList.items;
    }, function() {
      $q.all(_.map(vm.imagesList.items, _setTransformData))
        .then(function(images) {
          vm.imagesList.items = images;
        });
    });

    function _getBackgroundColor(image) {
      var currentTransform = image.transform || image.pictureTransform;
      return _parseTransform(currentTransform).b;
    }

    function _getTransformType(image) {
      var currentTransform = image.transform || image.pictureTransform;
      return _parseTransform(currentTransform).c;
    }

    function _generateTransformString(transformObj) {
      var transform = '';

      if (transformObj.ar) {
        transform += 'ar_' + transformObj.ar;
      }

      if (transformObj.c) {
        transform += ',c_' + transformObj.c;
      }

      if (transformObj.b) {
        transform += ',b_' + transformObj.b;
      }

      return transform;
    }

    function _parseTransform(transformString) {
      if (!transformString) {
        return {};
      }

      var transforms = transformString.split(','),
        transformObj = {};

      _.each(transforms, function(transform) {
        var tokens = transform.split('_');

        if (tokens.length === 2) {
          transformObj[tokens[0]] = tokens[1];
        }
      });

      return transformObj;
    }

    function _setBackgroundColor(image, color) {
      var currentTransform = image.transform || image.pictureTransform,
        transformObj = _parseTransform(currentTransform);

      transformObj.b = color;
      image.transform = image.pictureTransform = _generateTransformString(transformObj);
    }

    function _setImageTransform(image, type) {
      var transformObj = {
        ar: 1.00,
        c: type,
        b: _getBackgroundColor(image)
      };

      if (type === 'pad' && !transformObj.b) {
        transformObj.b = 'white';
      }

      image.transform = image.pictureTransform = _generateTransformString(transformObj);
    }

    function _setTransformData(image) {
      return $q(function(resolve, reject) {

        var img = new Image();

        img.onload = function() {
          image.aspectRatio = img.width / img.height;

          if (!(image.transform || image.pictureTransform)) {
            // if there is not a transform already set

            if (image.aspectRatio >= 1.00) {
              _setImageTransform(image, 'fill');
            } else {
              _setImageTransform(image, 'pad');
            }
          }

          resolve(image);
        };

        img.onerror = function() {
          reject();
        };

        img.src = image.picturePath;
      });
    }
  }
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptImageCarousel', ptImageCarousel);

  function ptImageCarousel() {
    return {
      templateUrl: '/app/components/image-carousel/image-carousel.html',
      bindToController: {
        imagesList: '=',
        imagesLimit: '<?'
      },
      controller: 'ImageCarouselCtrl as imageCarouselCtrl'
    };
  }

}());
(function() {

  'use strict';

  TabsController.$inject = ['$state', '$timeout', '$rootScope'];
  angular.module('ptCrm')
    .controller('TabsController', TabsController);

  function TabsController($state, $timeout, $rootScope) {

    var vm = this;

    vm.tabs = [];
    vm.select = select;
    vm.addTab = addTab;
    vm.removeTab = removeTab;

    $rootScope.$on('tabs:disabled', function(e, tabName) {
      removeTab(tabName);
    });

    $rootScope.$on('tabs:select', function(e, tabName) {
      var targetTab = _.find(vm.tabs, { name: tabName });
      if (targetTab) {
        select(targetTab);
      }
    });

    var selectActiveTab = _.debounce(function() {
      $timeout(function() {
        var selectTab = getFirstActiveTab() || getActiveStateTab() || getFirstValidTab();
        select(selectTab);
      });
    });

    function getFirstActiveTab() {
      return _.find(vm.tabs, { active: true });
    }

    function getActiveStateTab() {
      return _.find(vm.tabs, { name: $state.params.tab });
    }

    function getFirstValidTab() {
      return _.find(vm.tabs, function(tab) {
        return !(tab.button || tab.disabled);
      });
    }

    function deactivateNotSelectedTabs(selectedTab) {
      _.forEach(vm.tabs, function(tab) {
        if (tab.active && tab !== selectedTab) {
          tab.onDeselect();
        }

        selectedTab.alreadySelected = false;
        tab.active = false;
      });
    }

    function activateTab(selectedTab) {
      selectedTab.active = true;

      if (!selectedTab.alreadySelected) {
        selectedTab.onSelect();
        selectedTab.alreadySelected = true;
      }

      if (selectedTab.name && selectedTab.name !== $state.params.tab) {
        $state.go($state.current.name, { tab: selectedTab.name }, {
          notify: false, reload: false, location: 'replace'
        });
      }
    }

    function select(selectedTab) {
      if (!selectedTab || selectedTab.button || selectedTab.disabled) {
        return false;
      }

      deactivateNotSelectedTabs(selectedTab);
      activateTab(selectedTab);
    }

    function addTab(tab) {
      vm.tabs.push(tab);
      selectActiveTab();
    }

    function removeTab(tab) {
      if (_.isString(tab)) {
        tab = _.find(vm.tabs, { name: tab });
      }

      if (_.isObject(tab)) {
        tab.hidden = true;
        vm.tabs = _.reject(vm.tabs, tab);
        selectActiveTab();
      }
    }
  }

}());
(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Container for tabs
     * @see tab directive for example
     */
    .directive('tabs', function() {
      return {
        transclude: true,
        replace: true,
        scope: true,
        bindToController: {
          hideIfSingular: '='
        },
        controller: 'TabsController as tabsCtrl',
        templateUrl: '/app/components/tabs/tabs.html'
      };
    });


}());
(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Creates a tab. Must be placed under tabs directive
     *
     * @example
     <example>
       <tabs>
         <tab>
          <tab-head><button>{{'CREATE_WORKOUT'|translate}}</button></tab-head>
           <tab-content>
             <div class="create-assignment__selected-clients">
               <client-card></client-card>
             </div>
             <div class="create-assignment__scrollbar"></div>

             <library-search></library-search>

             <div class="create-assignment__clients">
              <client-card></client-card>
             </div>
           </tab-content>
         </tab>
        <tab button="true">
        </tab>
       </tabs>
     </example>
     */
    .directive('tab', function() {
      return {
        require: '^tabs',
        replace: true,
        templateUrl: '/app/components/tabs/tab.html',
        transclude: true,
        scope: {
          name: '@',
          active: '=?',
          disabled: '=?isDisabled',
          hidden: '<?isHidden',
          button: '=?isButton',
          onSelect: '&select',
          onDeselect: '&deselect'
        },
        link: function($scope, $element, $attrs, tabsCtrl, $transclude) {
          if ($scope.hidden) {
            $element.remove();
            return false;
          }

          tabsCtrl.addTab($scope);

          $element[0].addEventListener('click', _handleClicks, true);
          $element[0].addEventListener('touchstart', _handleClicks, true);


          // public
          $scope.select = select;
          $scope.tabClick = function() {
            if (!$scope.button) {
              select();
            } else if ($scope.button && $scope.onSelect) {
              $scope.onSelect();
            }
          };
          $scope.transcludeContent = transcludeContent;

          // events
          $scope.$watch('active', onActiveTabChanged);
          $scope.$on('$destroy', onDestroy);


          // ///////////////////////////////////////////
          function select() {
            if (!$scope.disabled) {
              $scope.active = true;
            }
          }

          function onDestroy() {
            tabsCtrl.removeTab($scope);
          }

          function onActiveTabChanged(active) {
            if (active) {
              tabsCtrl.select($scope);
            }
          }

          // we have to transclude content during content linking phase to apply correct scope
          function transcludeContent($contentElement) {
            $transclude($scope.$parent, function(clone) {
              angular.forEach(clone, function(node) {
                switch (node.tagName) {
                default:
                  break;
                case 'TAB-HEAD':
                  $element.append(node);
                  break;

                case 'TAB-CONTENT':
                  $contentElement.append(node);
                  break;
                }
              });
            });
          }


          function _handleClicks(e) {
            if ($scope.disabled) {
              e.stopPropagation();
            }
          }

        }
      };
    });

}());
(function() {

  'use strict';

  angular.module('ptCrm')

    /**
     * Place for tab content
     */
    .directive('tabContent', ['$timeout', function($timeout) {
      return {
        restrict: 'A',
        require: '^tabs',
        replace: true,
        transclude: true,
        scope: {
          tab: '=?tabInstance'
        },
        link: function($scope, $element) {
          $timeout(function() {
            if (!$scope.tab.hidden) {
              $scope.tab.transcludeContent($element);
            }
          });
        }
      };
    }]);

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('datepicker', function() {
      return {
        restrict: 'E',
        scope: {
          validator: '&',
          selected: '=',
          firstAvailiable: '=?',
          from: '=',
          to: '='
        },
        templateUrl: '/app/components/datepicker/datepicker.html',
        link: datepickerLink
      };

      function datepickerLink(scope) {
        var currentMoment = moment();

        scope.selected = scope.selected || moment();
        scope.isValid = true;
        scope.weeks = [];
        scope.togglePicker = togglePicker;
        scope.getSelected = getSelected;
        scope.getTitle = getTitle;
        scope.isSelected = isSelected;
        scope.selectDay = selectDay;
        scope.prev = prev;
        scope.next = next;
        scope.now = now;
        scope.isAvailiable = isAvailiable;

        scope.$watch(function() {
          return scope.selected;
        }, function(newVal, oldVal) {
          if (angular.isFunction(scope.validator) && newVal !== oldVal) {
            scope.isValid = scope.validator({ selectedDay: newVal });
          }
        });

        scope.$watch(function() {
          return scope.from;
        }, function(val) {
          if (!val || !val.isValid()) {
            _init();
          } else if (!moment(scope.from).isSame(currentMoment, 'month')) {
            currentMoment = moment(val);
            _init();
          }
        });

        _init();

        function getTitle() {
          return scope.selected ? scope.selected.format('DD MMMM') : currentMoment.format('MMMM');
        }

        function togglePicker() {
          scope.collapsed = !scope.collapsed;
          if (!scope.collapsed) {
            scope.isValid = true;
          }
        }

        function getSelected(format) {
          return scope.selected ? scope.selected.format(format) : '';
        }

        function isSelected(day) {
          var _day = moment(currentMoment).set('date', day);

          if (scope.selected) {
            if (scope.from) {
              return scope.from <= _day && _day <= scope.selected;
            }
            return angular.isFunction(_day.isSame) && _day.isSame(scope.selected, 'day');
          }
          return false;
        }

        function selectDay(day) {
          if ((day !== null) && isAvailiable(day)) {
            scope.selected = moment(currentMoment).date(day);
          }
        }

        function prev() {
          var startOfMonth = moment(currentMoment).startOf('month').startOf('day');

          if (!scope.from || startOfMonth.diff(moment(scope.from).startOf('day')) > 0) {
            currentMoment.subtract(1, 'M');
            _getMonth();
          }
        }

        function next() {
          var endOfMonth = moment(currentMoment).endOf('month').startOf('day');

          if (!scope.to || endOfMonth.diff(moment(scope.to).endOf('day')) < 0) {
            currentMoment.add(1, 'M');
            _getMonth();
          }
        }

        function now() {
          var time = moment();

          return time.year() === currentMoment.year() && time.month() === currentMoment.month() ? time.date() : null;
        }

        function isAvailiable(day) {
          var date = moment(currentMoment);

          date.date(day);
          var isAfterFirstAvailiable = scope.firstAvailiable ? scope.firstAvailiable.isSameOrBefore(date) : true; // eslint-disable-line
          return ((!scope.from || date.diff(moment(scope.from).startOf('day')) >= 0) &&
          (!scope.to || date.diff(moment(scope.to).endOf('day')) <= 0)) && isAfterFirstAvailiable;
        }

        function _init() {
          if (angular.isFunction(scope.validator)) {
            scope.isValid = scope.validator({ selectedDay: scope.selected });
          }
          _getMonth();
        }

        function _getMonth() {
          var i, len, idx, newWeeks = [], // eslint-disable-line
            _currentMoment = moment(currentMoment);

          idx = (_currentMoment.startOf('month').day() + 6) % 7;
          newWeeks.length = Math.ceil((idx + _currentMoment.endOf('month').date()) / 7);
          for (i = 0, len = newWeeks.length; i < len; i++) {
            newWeeks[i] = [null, null, null, null, null, null, null];
          }
          for (i = 0, len = _currentMoment.endOf('month').date(); i < len; i++) {
            newWeeks[Math.floor((idx + i) / 7)][(idx + i) % 7] = i + 1;
          }
          scope.weeks = newWeeks;
        }
      }
    });
}());
(function() {
  'use strict';
  angular.module('ptCrm')
    .directive('datetimeDetails', ['assignmentsService', function(assignmentsService) {
      datetimeDetailsCtrl.$inject = ['$scope', '$element', '$rootScope', '$timeout'];
      return {
        restrict: 'E',
        scope: { // Expecting momentjs 'moment' objects
          dateStartMoment: '=startDate',
          dateEndMoment: '=endDate',
          timeStartMoment: '=startTime',
          timeEndMoment: '=endTime',
          recurrence: '=',
          recurrenceOptions: '=',
          timeDurationOptions: '=',
          disableTimeDurationOption: '=timeDurationOptionValidator',
          isEditingIndividualRecurrence: '=',
          disableRecurrence: '=',
          onEditSeries: '&'
        },
        templateUrl: '/app/components/datetime-details/datetime-details.html',
        controller: datetimeDetailsCtrl
      };

      function datetimeDetailsCtrl($scope, $element, $rootScope, $timeout) {

        $scope.inferredRecurrenceMoments = [];
        $scope.pastRecurrenceMoments = [];
        _calculateRecurrences();

        $scope.timeDuration = {};
        if ($scope.timeStartMoment && $scope.timeEndMoment) {
          $scope.timeDuration.selected = _calculateDuration($scope.timeStartMoment, $scope.timeEndMoment);
        } else {
          $scope.timeDuration.selected = _calculateDuration(moment(), moment().add(1, 'hour'));
        }
        $scope.isSameDay = true;
        $scope.getRecurrenceUnit = assignmentsService.getRecurrenceUnit;
        $scope.recurrenceForm = {
          form: {}
        };

        function _resetRecurrence() {
          $scope.recurrence.recurrenceType = 'once';
          $scope.recurrence.recurrenceNumber = 1;
        }

        function _calculateDuration(startMoment, endMoment) {
          if (startMoment && endMoment) {
            var minutesDuration = endMoment.diff(startMoment, 'minutes');
            return moment.duration(minutesDuration, 'minutes');
          }
          return moment.duration(1, 'days');
        }

        function _calculateRecurrences() {
          if ($scope.recurrence && $scope.dateEndMoment) {
            var startMoment = $scope.timeEndMoment || $scope.dateEndMoment;
            $scope.inferredRecurrenceMoments = assignmentsService.calculateInferredRecurrences(startMoment, $scope.recurrence);
            $scope.pastRecurrenceMoments = _.filter($scope.inferredRecurrenceMoments, function(recurrenceMoment) {
              return recurrenceMoment.isBefore(moment());
            });

            // Make sure the recurrenceType is still valid
            if ($scope.recurrence.recurrenceType !== 'once') {
              _.each($scope.recurrenceOptions, function(option) {
                checkRecurrenceOptionValidity(option);
              });
            }
          } else {
            $scope.inferredRecurrenceMoments = [];
            $scope.pastRecurrenceMoments = [];
          }
        }

        function checkRecurrenceOptionValidity(option) {
          if (option === 'daily' && $scope.isSameDay === false) {
            if ($scope.recurrence && $scope.recurrence.recurrenceType === 'daily') {
              _resetRecurrence();
            }
            return false;
          }
          if (option === 'weekly' && $scope.dateEndMoment.diff($scope.dateStartMoment, 'days') >= 7) {
            if ($scope.recurrence && $scope.recurrence.recurrenceType === 'weekly') {
              _resetRecurrence();
            }
            return false;
          }
          if (option === 'monthly' && $scope.dateEndMoment.diff($scope.dateStartMoment, 'days') >= 28) {
            if ($scope.recurrence && $scope.recurrence.recurrenceType === 'monthly') {
              _resetRecurrence();
            }
            return false;
          }
          return true;
        }

        $scope.checkRecurrenceOptionValidity = checkRecurrenceOptionValidity;

        $scope.showSchedule = function() {
          $scope.$emit('tabs:select', 'datetime-schedule');
        };

        $scope.editSeries = function() {
          $scope.onEditSeries();
        };

        $scope.$watch(function() {
          return {
            start: $scope.timeStartMoment,
            end: $scope.timeEndMoment
          };
        }, function(newVal, oldVal) {
          if (moment.isMoment(newVal.start) && newVal.start.isValid() && moment.isMoment(newVal.end) && newVal.end.isValid()) {
            $scope.timeDuration.selected = _calculateDuration(newVal.start, newVal.end);
            _calculateRecurrences();
          }
        }, true);

        $scope.$watch(function() {
          return {
            start: $scope.dateStartMoment,
            end: $scope.dateEndMoment
          };
        }, function(newVal, oldVal) {
          if (moment.isMoment(newVal.start) && newVal.start.isValid() && moment.isMoment(newVal.end) && newVal.end.isValid()) {
            $scope.isSameDay = newVal.start.isSame(newVal.end, 'day');
            _calculateRecurrences();
          }
        }, true);

        $scope.$watch('recurrence', function(newVal, oldVal) {
          if (!_.isEqual(newVal, oldVal)) {
            _calculateRecurrences();
          }
        }, true);

        $scope.$watch('timeDuration.selected', function(newVal, oldVal) {
          // $scope.timeDuration.selected is a momentjs duration object
          if (newVal && oldVal && (newVal.asMinutes() !== oldVal.asMinutes()) && newVal.asMinutes() > 0) {
            $scope.timeEndMoment = moment($scope.timeStartMoment).add(newVal.asMinutes(), 'minutes');
          }
        });
      }
    }]);
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('scrollingDatepicker', function() {
      scrollingDatepicker.$inject = ['$scope', '$element', '$rootScope', '$timeout', 'config', 'facilityAssignmentsService', '$q'];
      return {
        restrict: 'E',
        scope: { // Expecting momentjs 'moment' objects
          selectionStartMoment: '=startMoment',
          selectionEndMoment: '=endMoment',
          singleDay: '=',
          includeFacilityAssignments: '=',
          disabled: '='
        },
        templateUrl: '/app/components/scrolling-datepicker/scrolling-datepicker.html',
        controller: scrollingDatepicker,
        replace: true // So that the scrollable area is the $element
      };

      function scrollingDatepicker($scope, $element, $rootScope, $timeout, config, facilityAssignmentsService, $q) {
        var todayStartMoment = moment().startOf('day');

        // When this directive loads, the first 'selection' will be auto-populated.
        // This flag indicates that we are waiting for the user to make their first click.
        var awaitingManualSelection = true;
        var monthBatchSize = 6;
        var scrollToMonth = '';
        var firstMonthToDisplay = todayStartMoment;
        var numberMonthsToDisplay = monthBatchSize;

        $scope.months = [];
        $scope.dayNames = _generateDayNames(config.firstDayOfWeek);

        // Determine first month to display
        if ($scope.selectionStartMoment) {
          $scope.selectionStartMoment = moment($scope.selectionStartMoment).startOf('day');
          $scope.selectionEndMoment = $scope.selectionEndMoment ? moment($scope.selectionEndMoment).endOf('day') : moment($scope.selectionStartMoment).endOf('day');

          var monthsInFuture = moment($scope.selectionStartMoment).startOf('month').diff(moment(todayStartMoment).startOf('month'), 'months');

          if (monthsInFuture > 0) {
            scrollToMonth = moment(todayStartMoment).startOf('month').add(monthsInFuture, 'months').format('MMYYYY');
          }

          if (monthsInFuture < 0) {
            firstMonthToDisplay = moment($scope.selectionStartMoment).startOf('month');
          }

          if (monthsInFuture > numberMonthsToDisplay) {
            // If we're editing an existing date selection that is in a future month,
            // generate all the months that fall between the present month and that future month
            // plus an additional month (allows for better auto-scroll down to selected month)
            numberMonthsToDisplay = monthsInFuture + 2;
          }

        } else {
          $scope.selectionStartMoment = moment().startOf('day');
          $scope.selectionEndMoment = moment().endOf('day');
        }

        // Insert initial batch on months into the list
        for (var i = 0; i < numberMonthsToDisplay; i++) {
          _insertMonth(moment(firstMonthToDisplay).add(i, 'months'));
        }

        // Simulate having scrolled to the bottom of the list of months
        // in rare case the months don't extend past the bottom of the viewport
        // upon initial load
        $rootScope.$emit('infiniteScroll:complete');

        $scope.$on('datepicker:scrollToMonth', function(e, targetMoment) {
          var monthElement = document.getElementById(targetMoment.format('MMYYYY'));
          if (monthElement) {
            $element[0].scrollTop = monthElement.offsetTop;
          }
        });

        _displaySelectedDays();

        $scope.showMoreMonths = function() {
          var promise = $q.resolve();
          for (var i = 0; i < monthBatchSize; i++) {
            promise = promise.then(function() {
              return _insertMonth();
            });
          }
          return promise;
        };

        $scope.selectDay = function(day) {
          if (day) {
            var selectedMoment = day.startMoment;

            if ($scope.singleDay ) {
              $scope.selectionStartMoment = moment(selectedMoment);
              $scope.selectionEndMoment = moment(selectedMoment).endOf('day');
            } else {
              if (awaitingManualSelection
                || !$scope.selectionStartMoment
                || selectedMoment.isBefore($scope.selectionStartMoment, 'day')
                || ($scope.selectionEndMoment && $scope.selectionEndMoment.isAfter(moment($scope.selectionStartMoment).endOf('day')))) {
                  // We're staring a new selection
                $scope.selectionStartMoment = moment(selectedMoment);
                awaitingManualSelection = false;
              }

              $scope.selectionEndMoment = moment(selectedMoment).endOf('day');
            }
            _displaySelectedDays();
          }
        };

        function _insertMonth(momentInMonth) {

          var startMoment;
          var newMonth;

          if (momentInMonth) {
            startMoment = moment(momentInMonth).startOf('month');
          }

          if (!startMoment) {
            // Infer which month we need to insert from what months are already in the $scope.months array
            startMoment = moment($scope.months[$scope.months.length-1].startMoment).add(1, 'month');
          }

          var promise = $scope.includeFacilityAssignments ?
            facilityAssignmentsService.getFacilityAssignmentsInMonth(startMoment.unix(), moment(startMoment).endOf('month').unix()):
            $q.resolve([]);

          return promise
          .then(function(facilityAssignments) {
            newMonth = {
              name: startMoment.format('MMMM'),
              startMoment: startMoment,
              weeks: _generateWeeks(startMoment, config.firstDayOfWeek, facilityAssignments)
            };

            _pushToCorrectPosition(newMonth);
          });
        }

        function _pushToCorrectPosition(newMonth) {
          $scope.months.push(newMonth);
          var i = $scope.months.length - 1;
          var item = $scope.months[i];
          while (i > 0 && item.startMoment.unix() < $scope.months[i-1].startMoment.unix()) {
            $scope.months[i] = $scope.months[i-1];
            i -= 1;
          }
          $scope.months[i] = item;
        }

        function _generateWeeks(startMoment, firstDayOfWeek, facilityAssignments) {

          var i, len, idx;
          var weeks = [];

          idx = (moment(startMoment).startOf('month').day() + 7 - firstDayOfWeek) % 7;
          weeks.length = Math.ceil((idx + moment(startMoment).endOf('month').date()) / 7);
          for (i = 0, len = weeks.length; i < len; i++) {
            weeks[i] = [null, null, null, null, null, null, null];
          }
          for (i = 0, len = moment(startMoment).endOf('month').date(); i < len; i++) {
            var dayStartMoment = moment(startMoment).add(i, 'days');
            var hasFacilityAssignment = false;
            if (facilityAssignments.length) {
              hasFacilityAssignment = _.findIndex(facilityAssignments, function(fa) { // eslint-disable-line no-loop-func
                return fa.startDate === dayStartMoment.unix();
              }) > -1;

              if (hasFacilityAssignment && $scope.selectionStartMoment.unix() === dayStartMoment.unix()) {
                // if we have a facility assignment on the current selected day, increment day
                // because of loop, this should increment to next available day
                $scope.selectionStartMoment.add(1, 'day');
                $scope.selectionEndMoment.add(1, 'day');
              }
            }
            weeks[Math.floor((idx + i) / 7)][(idx + i) % 7] = {
              number: i + 1,
              startMoment: dayStartMoment,
              isAvailable: $scope.disabled ? false : todayStartMoment.isSameOrBefore(dayStartMoment),
              isSelected: _isSelected(dayStartMoment),
              isToday: todayStartMoment.isSame(dayStartMoment, 'day'),
              hasFacilityAssignment: hasFacilityAssignment
            };
          }

          return weeks;
        }

        function _isSelected(dayStartMoment) {
          if ($scope.selectionStartMoment && $scope.selectionEndMoment) {
            return (dayStartMoment.isSameOrAfter($scope.selectionStartMoment) && dayStartMoment.isSameOrBefore($scope.selectionEndMoment));
          } else if ($scope.selectionStartMoment) {
            return dayStartMoment.date() === todayStartMoment.date();
          } else {
            return false;
          }
        }

        function _displaySelectedDays() {
          _.each($scope.months, function(month) {
            _.each(month.weeks, function(week) {
              _.each(week, function(day) {
                if (day) { // Skip the 'null' days at the beginning and end of the month matrix
                  day.isSelected = _isSelected(day.startMoment);
                }
              });
            });
          });
        }

        function _generateDayNames(firstDayOfWeek) {
          var dayNames = [];
          for (var i = 0; i < 7; i++) {
            dayNames.push(moment().day(i).format('ddd'));
          }
          if (firstDayOfWeek > 0) {
            dayNames = dayNames.concat(dayNames.splice(0, firstDayOfWeek));
          }
          return dayNames;
        }
      }
    });
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('timepicker', ['$document', 'profileService', function($document, profileService) {
      return {
        restrict: 'E',
        templateUrl: '/app/components/timepicker/timepicker.html',
        scope: {
          clients: '=',
          selectedClients: '=',
          onEditClient: '&',
          onEditTask: '&',
          editAssign: '=',
          startTime: '=',
          endTime: '=',
          date: '=',
          readOnly: '@',
          allowOverlap: '=',
          onClientSelect: '&',
          onShowTimeDetails: '&',
          onTimeRangeSelect: '&',
          onSetAllDay: '&',
          isEditable: '=',
          trainerWorkInfo: '='
        },
        link: timepickerLink
      };

      function timepickerLink(scope, element) {
        var from, to,
          lowerLimit, upperLimit,
          events = {},
          startX = 0,
          startY = 0,
          startEl,
          x = 0,
          y = 0,
          _move = _defineMove(50),
          move = false,
          clientsContainer = angular.element(element[0].querySelector('.timepicker-container-right')),
          clients = angular.element(element[0].querySelector('.timepicker-container-right-client')),
          timeFormat = profileService.user.settings.timeFormat || 12,
          i, str00, str30;

        // define drag events
        if ('ontouchstart' in window) {
          events.moveStart = 'touchstart';
          events.move = 'touchmove';
          events.moveEnd = 'touchend';
        } else {
          events.moveStart = 'mousedown';
          events.move = 'mousemove';
          events.moveEnd = 'mouseup';
        }

        scope.timeRanges = [];
        scope.timeAvailabilities = [];

        for (i = 0; i < 24; i++) {
          str00 = '';
          str30 = '';
          if (i % 12 === 0) {
            str00 += timeFormat === 12 ? 12 : i;
            str30 += timeFormat === 12 ? 12 : i;
          } else {
            str00 += timeFormat === 12 ? i % 12 : i;
            str30 += timeFormat === 12 ? i % 12 : i;
          }

          str00 += ':00';
          str30 += ':30';

          if (timeFormat === 12) {
            str00 += i < 12 ? ' am' : ' pm';
            str30 += i < 12 ? ' am' : ' pm';
          }

          scope.timeRanges.push(str00, str30);
        }

        scope.titles = scope.timeRanges.filter(function(item, idx) { return idx % 2 === 0; });

        scope.generateStyle = generateStyle;
        scope.checkOverlap = checkOverlap;
        scope.clientSelect = clientSelect;
        scope.showTimeDetails = showTimeDetails;
        scope.checkForTrainerAvailability = checkForTrainerAvailability;

        scope.$on('timepicker:resetTime', setAllDay);
        scope.setAllDay = setAllDay;
        scope.editClient = editClient;
        scope.editTask = editTask;

        if (_.isUndefined(scope.readOnly)) {
          clientsContainer.on('mousedown', _onRangeSelect);
          clients.on('mousedown', function(event) {
            event.stopPropagation();
          });
        } else {
          clientsContainer.off('mousedown', _onRangeSelect);
        }

        scope.$watch('editAssign', function() {
          if (scope.editAssign) {
            scope.selectedClients = scope.editAssign;
            _onTimeChange();
            scope.$applyAsync(function() {
              addStretchButtonListener();
            });
          }
        });

        scope.$watch('startTime', function(newVal, oldVal) {
          if (moment.isMoment(newVal) && newVal.isValid()) {
            if (!moment(newVal).isSame(moment(oldVal))) {
              scope.selectedClients.timeFrom = momentToInteger(newVal, 'start');
              _onTimeChange();
            }
          } else {
            setAllDay();
          }
        });

        scope.$watch('endTime', function(newVal, oldVal) {
          if (moment.isMoment(newVal) && newVal.isValid()) {
            if (!moment(newVal).isSame(moment(oldVal))) {
              scope.selectedClients.timeTo = momentToInteger(newVal, 'end');
              _onTimeChange();
            }
          } else {
            setAllDay();
          }
        });

        scope.$watch('date', function(newVal, oldVal) {
          if (moment.isMoment(newVal) && newVal.isValid()) {
            if (!moment(newVal).isSame(moment(oldVal))) {
              _onTimeChange();
            }
          }
        });

        scope.$watch('trainerWorkInfo', function(newVal, oldVal) {
          checkForTrainerAvailability();
        });

        function checkForTrainerAvailability() {
          var currentDay = scope.date ? moment(scope.date).locale('en').format('dddd').toLowerCase() : moment().locale('en').format('dddd').toLowerCase(),
            currentFacility = _convertTimeToMinutes(scope.trainerWorkInfo && scope.trainerWorkInfo.days ? scope.trainerWorkInfo.days[currentDay] : []),
            otherFacilities = _convertTimeToMinutes(scope.trainerWorkInfo && scope.trainerWorkInfo.otherFacilityHours ? scope.trainerWorkInfo.otherFacilityHours[currentDay] : []),
            tempMinutes = {},
            timeRange,
            outputTimeRange = [],
            i, j;

          // Iterate through the minutes of the day in 30 minute blocks.
          for (i = 0; i < 1440; i += 30) {
            timeRange = { isAvailable: false };
            // If no availability exists, make sure the whole thing is light colored (availabile colored).  This is really important.
            if (currentFacility.length === 0) {
              timeRange.isAvailable = true;
            }
            // Checks the trainers availability in other facilities.  isAvailable returns true/false if it falls in availability window
            for (j = 0; j < otherFacilities.length; j++ ) {
              tempMinutes = otherFacilities[j];
              if ((i >= tempMinutes.min && (i + 30) <= tempMinutes.max ) ||
                (i > tempMinutes.min && (i + 30) <= tempMinutes.min) ||
                (i < tempMinutes.max && (i + 30) >= tempMinutes.max) ||
                (i >= (tempMinutes.min - 15) && (i + 30) <= tempMinutes.max)
              ) {
                timeRange.isAvailable = false;

                if (i < tempMinutes.max && (i - 15) >= tempMinutes.max) {
                  timeRange.isAvailable = true;
                }
              }
            }
            // Checks the trainers availability in the current facilities.  isAvailable returns true/false if it falls in availability window
            for (j = 0; j < currentFacility.length; j++ ) {
              tempMinutes = currentFacility[j];
              if ((i >= tempMinutes.min && (i + 30) <= tempMinutes.max ) ||
                (i > tempMinutes.min && (i + 30) <= tempMinutes.min) ||
                (i < tempMinutes.max && (i + 30) >= tempMinutes.max) ||
                (i >= (tempMinutes.min + 15) && (i + 30) <= tempMinutes.max)
              ) {
                timeRange.isAvailable = true;

                if (i < tempMinutes.max && (i + 15) >= tempMinutes.max) {
                  timeRange.isAvailable = false;
                }
              }
            }
            outputTimeRange.push(timeRange);
          }
          scope.timeAvailabilities = outputTimeRange;
        }

        function _convertTimeToMinutes(inputArray) {
          return inputArray.map(function(time) {
            var tempMinutes = {},
              tempFacilityRange = time.min.split(':');

            tempMinutes.min = ((+tempFacilityRange[0]) * 60) + (+tempFacilityRange[1]);
            tempFacilityRange = time.max.split(':');
            tempMinutes.max = ((+tempFacilityRange[0]) * 60) + (+tempFacilityRange[1]);
            return tempMinutes;
          });
        }

        function _onTimeChange() {

          var targetDate = scope.date || moment();

          scope.startTime = moment(targetDate).startOf('day').minute(scope.selectedClients.timeFrom * 60);
          scope.endTime = moment(targetDate).startOf('day').minute(scope.selectedClients.timeTo * 60);

          if (scope.selectedClients.timeFrom === 0 && scope.selectedClients.timeTo === 24) {
            scope.startTime = null;
            scope.endTime = null;
            setAllDay();
          } else {
            scope.allDaySet = false;
          }
          scope.checkForTrainerAvailability();
        }

        function onMoveStart(e) {
          e.preventDefault();
          e.stopPropagation();

          if (!_.isUndefined(scope.selectedClients.timeFrom)) {
            from = scope.selectedClients.timeFrom * 2;
            to = scope.selectedClients.timeTo * 2;
          }
          startX = e.pageX || e.touches[0].pageX;
          startY = e.pageY || e.touches[0].pageY;

          $document.on(events.move, _move);
          $document.on(events.moveEnd, _moveEnd);
        }

        function _removeListeners() {
          $document.off(events.move, _move);
          $document.off(events.moveEnd, _moveEnd);
        }

        function clientSelect(client) {
          if (scope.onClientSelect) {
            scope.onClientSelect({ $item: client });
          }
        }

        function showTimeDetails() {
          if (scope.onShowTimeDetails) {
            scope.onShowTimeDetails();
          }
        }

        function generateStyle(client) {
          return {
            top: client.timeFrom * 100 + 13 + 'px',
            height: (client.timeTo - client.timeFrom) * 94 + 'px'
          };
        }

        function checkOverlap() {
          var selectedClient = scope.selectedClients,
            timeFrom,
            timeTo,
            clients;

          if (!selectedClient) {
            return false;
          }

          timeFrom = selectedClient.timeFrom;
          timeTo = selectedClient.timeTo;

          clients = _.filter(scope.clients, function(client) {
            return client._id !== selectedClient._id;
          });

          if (clients.length === 0) {
            return false;
          }

          return _.some(clients, function(client) {
            return !(
              (timeFrom < client.timeFrom && timeTo <= client.timeFrom) ||
              (timeFrom >= client.timeTo && timeTo > client.timeTo)
            );
          });
        }

        function setAllDay() {

          // unselect all selected rows
          if (scope.selectedClients) {
            scope.selectedClients.timeFrom = null;
            scope.selectedClients.timeTo = null;
          }

          scope.allDaySet = true;

          scope.onSetAllDay();
        }

        function _onRangeSelect(event) {
          scope.onTimeRangeSelect();

          if (event.target.className.indexOf('timepicker-container-right-item') === -1) {
            return false;
          }
          move = false;
          event.preventDefault();
          startEl = angular.element(event.target);
          while (!startEl.hasClass('timepicker-container-right-item')) {
            startEl = startEl.parent();
          }


          from = Array.prototype.indexOf.call(clientsContainer.children(), startEl[0]);

          if (scope.allowOverlap) {
            lowerLimit = 0;
            upperLimit = 24;
          } else {
            lowerLimit = scope.clients.filter(function(e) {
              return e.timeTo * 2 <= from;
            }).reduce(function(rez, next) {
              return Math.max(next.timeTo, rez);
            }, 0);
            upperLimit = scope.clients.filter(function(e) {
              return e.timeFrom * 2 >= from + 1;
            }).reduce(function(rez, next) {
              return Math.min(next.timeFrom, rez);
            }, 99);
          }

          to = from + 1 === upperLimit * 2 ? from + 1 : from + 2;

          scope.selectedClients.timeTo = to / 2;
          scope.selectedClients.timeFrom = from / 2;
          _onTimeChange();

          scope.$apply();
          addStretchButtonListener();
        }

        function _checkLimits() {
          if (scope.selectedClients.timeFrom < lowerLimit) {
            scope.selectedClients.timeFrom = lowerLimit;
            if (scope.selectedClients.timeFrom === scope.selectedClients.timeTo) {
              scope.selectedClients.timeTo += 0.5;
            }
            _removeListeners();
            _onTimeChange();
          }
          if (scope.selectedClients.timeTo > upperLimit) {
            scope.selectedClients.timeTo = upperLimit;
            if (scope.selectedClients.timeFrom === scope.selectedClients.timeTo) {
              scope.selectedClients.timeFrom -= 0.5;
            }
            _removeListeners();
            _onTimeChange();
          }
        }

        function _defineMove(interval) {
          var now, directionChanged, prev = 0;

          return function(event) {
            now = Date.now();
            if (now - prev > interval) {
              event.stopPropagation();
              y = (event.pageY || event.touches[0].pageY) - startY;
              x = (event.pageX || event.touches[0].pageX) - startX;

              if (y > (to - from) * (-50)) {
                scope.selectedClients.timeTo = (to + y / 50) / 2;
                if (directionChanged) {
                  scope.selectedClients.timeFrom = Math.floor(to + y / 50) / 2;
                  directionChanged = false;
                }
              } else {
                scope.selectedClients.timeFrom = (to + y / 50) / 2;
                scope.selectedClients.timeTo = from / 2;
                directionChanged = true;
              }
              _checkLimits();
              scope.$apply();

              prev = now;
            }
          };
        }

        function _moveEnd(event) {
          y = (event.pageY || event.changedTouches[0].pageY) - startY;
          x = (event.pageX || event.changedTouches[0].pageX) - startX;
          if (y > (to - from) * (-50)) {
            scope.selectedClients.timeTo = Math.ceil(to + y / 50) / 2;
          } else {
            scope.selectedClients.timeFrom = Math.floor(to + y / 50) / 2;
            scope.selectedClients.timeTo = from / 2;
          }
          _removeListeners();
          _onTimeChange();
          scope.$apply();
        }

        function addStretchButtonListener() {
          var dragger = angular.element(element[0].querySelector('.timepicker-container-right-client-dragger'));
          dragger.on(events.moveStart, onMoveStart);
        }

        function editClient(client) {
          if (scope.onEditClient) {
            scope.onEditClient({ $item: client });
          }
        }

        function editTask(task) {
          if (scope.onEditTask) {
            scope.onEditTask({ $item: task });
          }
        }

        function momentToInteger(momentTime, placement) {
          var intgr = momentTime.get('hours') + (momentTime.get('minutes') ? 0.5 : 0);
          if (placement === 'end' && intgr === 0) {
            intgr = 24;
          }
          return intgr;
        }

      }
    }]);
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('taskpicker', ['$document', function($document) {
      return {
        restrict: 'E',
        templateUrl: '/app/components/taskpicker/taskpicker.html',
        scope: {
          clients: '=',
          selectedClients: '=',
          onEditClient: '&',
          onEditTask: '&',
          editAssign: '=',
          readOnly: '@',
          onClientSelect: '&',
          onSetAllDay: '&',
          isEditable: '='
        },
        link: taskpickerLink
      };

      function taskpickerLink(scope, element) {

        scope.clientSelect = clientSelect;

        scope.$on('taskpicker:resetTime', setAllDay);
        scope.setAllDay = setAllDay;
        scope.editClient = editClient;
        scope.editTask = editTask;

        scope.$watch('editAssign', function() {
          if (scope.editAssign) {
            scope.selectedClients = scope.editAssign;
          }
        });

        function clientSelect(client) {
          if (scope.onClientSelect) {
            scope.onClientSelect({ $item: client });
          }
        }

        function setAllDay() {

          // unselect all selected rows
          if (scope.selectedClients) {
            scope.selectedClients.timeFrom = null;
            scope.selectedClients.timeTo = null;
          }

          scope.onSetAllDay();
        }

        function editClient(client) {
          if (scope.onEditClient) {
            scope.onEditClient({ $item: client });
          }
        }

        function editTask(task) {
          if (scope.onEditTask) {
            scope.onEditTask({ $item: task });
          }
        }

      }
    }]);
}());

(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('ptDaySchedule', ['profileService', function(profileService) {

      return {
        templateUrl: '/app/components/day-schedule/day-schedule.html',
        require: ['?^form'],
        scope: {
          times: '=',
          day: '<',
          editable: '='
        },
        link: function(scope, element, attrs, ctrl) {
          var formCtrl = ctrl[0],
            timeFormat = +profileService.user.settings.timeFormat || 12;
          scope.addHours = addHours;
          scope.removeHours = removeHours;
          scope.userHas24HourFormat = (timeFormat === 24);

          function addHours() {
            scope.times.push({
              min: new Date(1970, 0, 1, 10, 0, 0),
              max: new Date(1970, 0, 1, 10, 0, 0)
            });
            if (formCtrl) {
              formCtrl.$setDirty();
            }
          }

          function removeHours(time) {
            scope.times.splice(scope.times.indexOf(time), 1);
            if (formCtrl) {
              formCtrl.$setDirty();
            }
          }

        }
      };
    }]);

}());
(function() {
  'use strict';

  rzSliderOptions.$inject = ['RzSlider', 'rzSliderTicksCount'];
  angular.module('ptCrm')
    .value('rzSliderTicksCount', 12)
    .run(rzSliderOptions);


  function rzSliderOptions(RzSlider, rzSliderTicksCount) {

    /**
     * patched method Slider.updateTicksScale from node_module/angularjs-slider/src/rzslider.js:736
     * always shows the given number of dashes
     *
     */
    RzSlider.prototype.updateTicksScale = function() {


      if (!this.options.showTicks) {
        return;
      }

      // freeze number of ticks in sliders
      var ticksCount = rzSliderTicksCount;

      this.scope.ticks = [];
      for (var i = 0; i < ticksCount; i++) {
        var value = this.roundStep(this.minValue + i * this.step);
        var tick = {
          selected: this.isTickSelected(value)
        };
        if (tick.selected && this.options.getSelectionBarColor) {
          tick.style = {
            'background-color': this.getSelectionBarColor()
          };
        }
        if (this.options.ticksTooltip) {
          tick.tooltip = this.options.ticksTooltip(value);
          tick.tooltipPlacement = this.options.vertical ? 'right' : 'top';
        }
        if (this.options.showTicksValues) {
          tick.value = this.getDisplayValue(value);
          if (this.options.ticksValuesTooltip) {
            tick.valueTooltip = this.options.ticksValuesTooltip(value);
            tick.valueTooltipPlacement = this.options.vertical ? 'right' : 'top';
          }
        }
        this.scope.ticks.push(tick);
      }
    };
  }


}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('segmentSlider', function() {
      sliderCtrl.$inject = ['$scope'];
      return {
        bindToController: {
          value: '=',
          options: '=',
          onEnd: '&'
        },
        controllerAs: 'slider',
        controller: sliderCtrl,
        template:
          '<div class="segment-slider">' +
            '<div class="segment-slider__control segment-slider__control--increase" ' +
              'ng-click="slider.increase()"></div>' +
            '<rzslider ng-if="slider.optReady" ' +
              'rz-slider-model="slider.val" ' +
              'rz-slider-options="slider.opt">' +
            '</rzslider>' +
            '<div class="segment-slider__control segment-slider__control--decrease" ' +
              'ng-click="slider.decrease()"></div>' +
          '</div>'
      };

      function sliderCtrl($scope) {

        var vm = this;

        vm.opt = _.clone(vm.options);
        vm.val = 0;

        vm.increase = increase;
        vm.decrease = decrease;

        $scope.$watch(getValue, updateValue);

        updateOptions();

        function updateOptions() {
          if (_.isObject(vm.opt)) {
            vm.opt = _.extend({}, vm.opt, generateOptions(vm.opt), getDefaultSliderOptions());
            vm.opt.onChange = valueChanged;
            vm.opt.onEnd = vm.onEnd;

            vm.val = vm.opt.default || vm.opt.floor;
          }

          vm.optReady = true;
        }

        function getValue() {
          return vm.value;
        }

        function updateValue(value) {
          if (value !== vm.val) {
            vm.val = value || vm.opt.default || vm.opt.floor;
            valueChanged();
          }
        }

        function valueChanged() {
          vm.val = +(+vm.val).toFixed(vm.opt.precision) || vm.opt.floor;

          vm.value = vm.val;

          if (vm.onChange) {
            vm.onChange();
          }
        }

        function increase() {
          var newVal = vm.val + vm.opt.step;
          vm.val = _.min([newVal, vm.opt.ceil]);
          _triggerSliderChange();
        }

        function decrease() {
          var newVal = vm.val - vm.opt.step;
          vm.val = _.max([newVal, vm.opt.floor]);
          _triggerSliderChange();
        }

        function _triggerSliderChange() {
          vm.opt.onChange();
          vm.opt.onEnd();
        }
      }


      function getDefaultSliderOptions() {
        return {
          vertical: true,
          hideLimitLabels: true,
          showTicks: true
        };
      }

      function generateOptions(opt) {
        return {
          floor: opt.minValue,
          ceil: opt.maxValue,
          step: opt.increment,
          precision: opt.increment < 1 ? 1 : 0
        };
      }
    });
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('userCard', function() {
      return {
        templateUrl: '/app/components/user-card/user-card.html',
        bindToController: {
          user: '=',
          isRemovable: '=',
          remove: '&',
          role: '@?',
          moveable: '=',
          arrow: '='
        },
        controllerAs: 'card',
        controller: function() {
        }
      };
    });

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('libraryCard', function() {
      var SPRINT8_REGEX = /sprint\s8/i,

        // ========= HELPERS ===========

        imageLookup = {
          bike: '//images.jhtassets.com/924391af84a225d36fdb5c726cb2a531b589e539/',
          stepper: '//images.jhtassets.com/47b3756904136919d50b49c9f95ffb2bda3477e8/',
          treadmill: '//images.jhtassets.com/1b517b7ed1aef6db68a9b1bd736b96c5a9598244/',
          climbmill: '//images.jhtassets.com/e513570080625da8af5c215a25356a710ae1cb4c/',
          'elliptical-arc': '//images.jhtassets.com/f1fa94df4b0c34e49a6e59874cf366f65cde0b4c/',
          common: '//images.jhtassets.com/fbea4f75aee396e61378ee78a9d9ee37cc001e74/',
          sprint8: '//images.jhtassets.com/d17d412e18d6b030bb2c119ad18d7ff79236f026/'
        };

      function _getImageName(exercise) {

        var imageName;

        if (SPRINT8_REGEX.test(exercise.title)) {
          imageName = 'sprint8';
        } else {
          switch (exercise.equipmentType) {
          case 'Bike':
          case 'Stepper':
          case 'Treadmill':
          case 'Climbmill':
            imageName = exercise.equipmentType.toLowerCase();
            break;
          case 'Elliptical':
          case 'Arc_Trainer':
            imageName = 'elliptical-arc';
            break;
          default:
            imageName = 'common';
          }
        }
        return imageLookup[imageName];
      }

      return {
        templateUrl: '/app/components/library-card/library-card.html',
        replace: true,
        bindToController: {
          onEditCard: '&',
          onPrintCard: '&',
          onDeleteCard: '&',
          data: '=',
          index: '=?',
          type: '@?',
          editPermission: '=',
          deletePermission: '=',
          hideDeleteIcon: '=',
          hidePrintIcon: '=',
          hideEditIcon: '=',
          disableFlip: '=',
          addButton: '=',
          addButtonCallback: '&',
          removeButton: '=',
          removeButtonCallback: '&'
        },
        controllerAs: 'card',
        controller: ['$scope', 'exercisersService', 'exercisesService', function($scope, exercisersService, exercisesService) {

          var vm = this;

          $scope.disableFlip = vm.disableFlip;

          vm.metrics = vm.type === 'exercises' ? exercisersService.parseExercise(vm.data).metrics : '';
          vm.getImagePath = getImagePath;

          // ========= INIT =============
          if (vm.type === 'trainingSets') {
            vm.data.exercises = exercisesService.extendExercises(vm.data.exercises);
          }

          if (vm.type === 'trainingPlans') {
            vm.data.title = vm.data.planName;
          }

          // ========= PUBLIC METHODS ===========
          function getImagePath() {
            var primaryImage,
              pic;
            if (!_.isEmpty(vm.data.images)) {
              pic = _.find(vm.data.images, { isPrimary: true }) || vm.data.images[0];
              primaryImage = pic.picturePath ? pic.picturePath : null;
            } else if (vm.data.picture) {
              primaryImage = vm.data.picture;
            }

            return primaryImage || _getImageName(vm.data);
          }

        }],
        link: function(scope, element) {
          var clickX,
            clickY,
            simpleClick;

          element.on('mousedown', function(evt) {
            clickX = evt.clientX;
            clickY = evt.clientY;
          });

          element.on('mouseup', function(evt) {
            var addClass;

            simpleClick = Math.abs(clickX - evt.clientX) < 10 && Math.abs(clickY - evt.clientY) < 10;

            if (scope.card.addButton && !scope.card.removeButton) {
              addClass = 'add-button--active';
            } else if (scope.card.removeButton && !scope.card.addButton) {
              addClass = 'remove-button--active';
            } else if (!scope.disableFlip) {
              addClass = 'active';
            }

            if (addClass && simpleClick) {
              element.toggleClass(addClass);
            }
          });
        }
      };
    });

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('backButton', ['$state', 'USER_HOME_PAGE', 'popup', '$window', '$translate', function($state, USER_HOME_PAGE, popup, $window, $translate) {
      return {
        restrict: 'C',
        link: backButtonLink,
        scope: {
          needConfirmation: '<'
        }
      };

      function backButtonLink($scope, $element) {

        $element.on('click', onBackButtonClick);

        function onBackButtonClick() {
          if ($scope.needConfirmation) {
            popup.confirm({
              title: $translate.instant('ARE_YOU_SURE?'),
              description: $translate.instant('CHANGES_WILL_BE_DISCARDED'),
              okText: $translate.instant('Yes')
            }).then(_goToPrevState);
          } else {
            _goToPrevState();
          }
        }

        function _goToPrevState() {
          $window.history.back();
        }
      }
    }]);
}());
(function() {
  'use strict';


  popupService.$inject = ['$uibModal', '$translate', '$templateRequest', '$q'];
  angular.module('ptCrm')
    .service('popup', popupService);

  function popupService($uibModal, $translate, $templateRequest, $q) {
    return {
      show: show,
      confirm: confirm,
      alert: alert
    };

    /**
     * A service that helps you to create custom popups
     *
     * @constructor
     * @param {Object} options The object has following properties:
     *
     * - **cssClass** – `{string}` class that would be applied to popup content
     * - **title** – `{string}` popup title
     * - **description** – `{string}` popup description
     * - **content** – `{string}` popup description
     * - **templateUrl** – `{string}` url to the template, which will be included into content
     * - **backdrop** - `{string}` option to determine backdrop behavior
     * - **okAction** – `{function}` function called after 'ok' click
     * - **okText** – `{string}` text of 'ok' button
     * - **cancelAction** – `{function}` function called after 'cancel' click
     * - **cancelText** – `{string}` text of 'ok' button
     * - **showCancel** – `{boolean}` condition to show/hide 'cancel' button
     * - **showOk** – `{boolean}` condition to show/hide 'ok' button
     * - **showLoading** – `{function}` function changed isLoading param
     * - **afterModalRendered** – `{function}` callback to execute after the
     *   modal's content has been rendered
     *
     */

    function show(options) {
      options = options || {};

      var modalInstance = $uibModal.open({
        windowClass: options.windowClass,
        templateUrl: '/app/components/popup/_popup.html',
        backdrop: options.backdrop || true,
        controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
          angular.extend($scope, options.scope || {});

          $scope.isLoading = false;
          $scope.cssClass = options.cssClass || '';
          $scope.title = options.title;
          $scope.description = options.description;
          $scope.content = options.content;

          var contentPromise = options.templateUrl ?
            $templateRequest(options.templateUrl) :
            $q.when(options.template || options.content || '');

          contentPromise.then(function(content) {
            $scope.content = content;
          });

          $scope.ok = function() {
            var closeFn = options.okAction || $uibModalInstance.close;
            if (arguments.length) {
              $scope.okArgs = arguments;
            }
            closeFn($scope, $uibModalInstance);
          };

          $scope.close = function() {
            $uibModalInstance.dismiss('close');
          };

          $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
          };

          $scope.back = function() {
            var closeFn = options.backAction || $uibModalInstance.close;
            closeFn($scope, $uibModalInstance);
          };

          $scope.showLoading = function(flag) {
            $scope.isLoading = flag;
          };

          $scope.showCancel = !_.isUndefined(options.showCancel) ? options.showCancel : true;
          $scope.showOk = !_.isUndefined(options.showOk) ? options.showOk : true;
          $scope.cancelText = options.cancelText || $translate.instant('CANCEL');
          $scope.okText = options.okText || $translate.instant('OK');
          $scope.showBack = _.isUndefined(options.showBack) ? false : options.showBack;
        }]
      });

      modalInstance.rendered.then(options.afterModalRendered);

      return modalInstance.result;
    }

    function confirm(options) {
      options = _.extend({
        title: $translate.instant('ARE_YOU_SURE?')
      }, options || {});

      return show(options);
    }


    function alert(options) {
      options = _.extend({
        showCancel: false
      }, options, {});

      return show(options);
    }

  }
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('searchClearer', function() {
      return {
        template: '<div class="library-search__cancel" ng-click="clearer.clear()"></div>',
        replace: true,
        bindToController: {
          searchTerm: '=',
          refreshFn: '&'
        },
        controllerAs: 'clearer',
        controller: ['$timeout', function($timeout) {
          var vm = this;

          vm.clear = function() {
            vm.searchTerm = '';
            $timeout(function() {
              vm.refreshFn();
            });
          };
        }]
      };
    });
}());
function durationInputCtrl() {
  var minutesInHour = 60,
    nextInputs = {
      _hours: '_minutes'
    };

  this.minuteFocus = false;
  this.editMode = false;

  this.$onChanges = function(changes) {
    var currentValue = changes.metricValue.currentValue;
    if (currentValue) {
      var timeParts = breakDownInputDuration(currentValue);
      this._hours = leftPadNumber(timeParts[0]);
      this._minutes = leftPadNumber(timeParts[1]);
    } else {
      this._hours = null;
      this._minutes = null;
    }
  };

  this.handleDurationInputChanges = function(field) {
    if (this[field].length > 2) {
      this[field] = this[field].slice(-2);
    }

    if (this[field].length === 2) {
      this.focusNextInput(field);
    }

    this.onUpdate({ $event: this.zipDuration() });
  };

  this.focusOnInput = function() {
    this.focusOnMe = true;
  };

  this.padOnBlur = function(field) {
    this[field] = leftPadNumber(this[field]);
  };

  this.focusNextInput = function(field) {
    if (nextInputs[field] && nextInputs[field] === '_minutes') {
      this.minuteFocus = true;
    }
  };

  this.toggleEditMode = function(value) {
    this.editMode = value;
  };

  this.zipDuration = function() {
    return ((+this._hours || 0) * minutesInHour)
      + (+this._minutes || 0);
  };

  function breakDownInputDuration(duration) {
    var remainderAfterHours = duration % minutesInHour;

    return [
      (duration - remainderAfterHours) / minutesInHour,
      remainderAfterHours
    ];
  }

  function leftPadNumber(number) {
    if (number) {
      return ('' + number).length === 1 ? '0' + number : number;
    }
    return '00';
  }
}

angular.module('ptCrm').component('durationInput', {
  templateUrl: '/app/components/duration-input/duration-input.component.html',
  controller: durationInputCtrl,
  controllerAs: 'durationInputCtrl',
  bindings: {
    metricValue: '<', // numbers ONLY
    onUpdate: '&',
    focusValue: '<'
  }
});

customizeExerciseCtrl.$inject = ['sprint8ExerciseHelperService', 'sprint8constant', '$translate', 'profileService', 'exerciseMetaData'];function customizeExerciseCtrl(sprint8ExerciseHelperService, sprint8constant, $translate, profileService, exerciseMetaData) {
  this.editPermission = 'WORKOUT_ASSIGNMENTS_OTHER_CREATE';
  var INVALID_SET_LEVEL_FALLBACK_VALUE = sprint8constant.INVALID_SET_LEVEL_FALLBACK_VALUE,
    INVALID_DEFAULT_LEVEL_FALLBACK_VALUE = sprint8constant.INVALID_DEFAULT_LEVEL_FALLBACK_VALUE,
    SPRINT8_CARDIO_PROGRAM_ID = sprint8constant.SPRINT8_CARDIO_PROGRAM_ID;
  this.MIGROS_CARDIO_PROGRAM_IDS = [58, 59, 60];
  this.currentExercise = {};
  this.exerciseClassification = '';

  this.$onInit = function() {
    this.currentExercise = angular.copy(this.exercise);
    if (this.currentExercise) {
      this.exerciseClassification = this.classifyExercise(this.currentExercise);
    }
  };

  this.$onChanges = function(changes) {
    if (changes.exercise.currentValue) {
      this.currentExercise = angular.copy(changes.exercise.currentValue);
      this.exerciseClassification = this.classifyExercise(this.currentExercise);
    }
  };

  // takes in an exercise and determines which component is required given data strucutre and specific field values
  this.classifyExercise = function(exerciseToClassify) {
    var classification = exerciseMetaData($translate, profileService.user.settings.measurementUnit, angular).classifyExercise(exerciseToClassify);
    if (classification === 'sprint8-exercise') {
      this.handleInvalidSprint8Level(exerciseToClassify);
      this.setSprint8Default(exerciseToClassify);
    }
    return classification;
  };

  this.handleUpdate = function(exercise) {
    this.onUpdate({ $event: exercise });
  };

  this.handleInvalidSprint8Level = function(exercise) {
    if (!sprint8ExerciseHelperService.validLevel(exercise.assignedProfile.cardioProgram.level)) {
      // error, set value isn't valid
      this.handleLevelUpdate(INVALID_SET_LEVEL_FALLBACK_VALUE);
    }
  };

  this.handleEquipmentType = function(equipmentType) {
    if (equipmentType === '') {
      delete this.currentExercise.equipmentType;
    } else {
      this.currentExercise.equipmentType = equipmentType;
    }
    this.onUpdate({ $event: this.currentExercise });
  };

  // params: sets, as in an array of 'set' for strength exercises
  this.handleSetsUpdate = function(sets) {
    this.currentExercise.assignedProfile.segments = sets;
    this.onUpdate({ $event: this.currentExercise });
  };

  this.handleLevelUpdate = function(newLevel) {
    this.exercise.assignedProfile.cardioProgram.level = newLevel;
    this.onUpdate({ $event: this.exercise });
  };

  // used to handle description changes for strenght assignments only
  this.handleAssignmentDescriptionUpdate = function(descriptionString) {
    if (typeof descriptionString === 'string') {
      this.currentExercise.description = descriptionString;
      this.onUpdate({ $event: this.currentExercise });
    }
  };

  this.handleCardioProgramUpdate = function(updatedCardioProgram) {
    if (updatedCardioProgram.cardioProgramId === this.currentExercise.assignedProfile.cardioProgram.cardioProgramId) {
      this.currentExercise.assignedProfile.cardioProgram = updatedCardioProgram;
      this.onUpdate({ $event: this.currentExercise });
    }
  };

  this.setSprint8Default = function(exercise) {
    if (exercise.assignedProfile.cardioProgram.level === undefined) {
      var lvlMetric = exercise.preset.metrics.find(function(metric) {
          if (metric.name === 'level' && metric.validation && metric.validation.default) {
            return metric;
          }
        }),
        defaultLevel = lvlMetric.validation.default;
      if (defaultLevel && sprint8ExerciseHelperService.validLevel(defaultLevel)) {
        this.handleLevelUpdate(defaultLevel);
      } else {
        // error, default value doesn't exist or is invalid
        this.handleLevelUpdate(INVALID_DEFAULT_LEVEL_FALLBACK_VALUE);
      }
    }
  };
}

// CustomizeExercise determines type of exercise and uses the correct component
// onUpdate calls back with modified copy of the exercise
angular.module('ptCrm').component('customizeExercise', {
  templateUrl: '/app/components/customize-exercise-components/customize-exercise.html',
  controller: customizeExerciseCtrl,
  controllerAs: 'customizeExerciseCtrl',
  bindings: {
    exercise: '<',
    onUpdate: '&',
    // Either 'exercise' or 'assignment' depending on whether this component is being used to
    // Create/edit an exercise template or create/edit an assignment/training set/facility assignment
    // This is passed DIRECTLY to the component in the HTML
    context: '@'
  }
});
function cardioProgramRangeCtrl() {
  this.showWarningMsg = false;
  this.$onChanges = function(changes) {
    if (changes.exercise.currentValue) {
      this.exercise = angular.copy(changes.exercise.currentValue);
      this.copyExerciseForSlider = angular.copy(changes.exercise.currentValue);
      this.minSliderLessThanMaxSlider(this.copyExerciseForSlider);
    }
  };
  this.updateSliders = function() {
    if (this.minSliderLessThanMaxSlider(this.copyExerciseForSlider)) {
      this.onUpdate({ $event: this.copyExerciseForSlider });
    }
  };
  this.updateEnum = function() {
    this.onUpdate({ $event: this.exercise });
  };
  this.minSliderLessThanMaxSlider = function(exercise) {
    var maxRegex = /max/,
      minRegex = /min/,

      maxMetric = _.find(exercise.preset.metrics, function(metric) {
        return maxRegex.test(metric.name);
      }),

      minMetric = _.find(exercise.preset.metrics, function(metric) {
        return minRegex.test(metric.name);
      });

    if (maxMetric && maxMetric.name && minMetric && minMetric.name &&
        exercise.assignedProfile.cardioProgram[minMetric.name] >
            exercise.assignedProfile.cardioProgram[maxMetric.name]) {
      this.showWarningMsg = true;
      return false;
    }
    this.showWarningMsg = false;
    return true;
  };
}

angular.module('ptCrm')
  .component('cardioProgramRange', {
    templateUrl: '/app/components/customize-exercise-components/components/cardio-program-range.html',
    controller: cardioProgramRangeCtrl,
    controllerAs: 'cardioProgramRangeCtrl',
    bindings: {
      exercise: '<',
      editPermission: '<',
      onUpdate: '&'
    }
  });

connectedExerciseSegmentsCtrl.$inject = ['$scope', '$timeout', '$rootScope'];function connectedExerciseSegmentsCtrl($scope, $timeout, $rootScope) {
  var vm = this,
    handleEvents = _handleSegmentScrollEvents();

  angular.extend(vm, {
    addSegment: addSegment,
    moreSegmentsAvailable: moreSegmentsAvailable,
    activateSegment: activateSegment,
    canDeleteSegments: canDeleteSegments,
    deleteActiveSegment: deleteActiveSegment,
    resetActiveSegment: resetActiveSegment,
    sliderValueChanged: sliderValueChanged,
    segmentProgressHeight: segmentProgressHeight,
    handleUpdate: handleUpdate
  });

  this.$onChanges = function(changes) {
    if (changes.exercise.currentValue) {
      this.exercise = angular.copy(changes.exercise.currentValue);
      vm.metrics = _.clone(this.exercise.preset.metrics);
      vm.segments = _.get(this.exercise, 'assignedProfile.segments') || [];
      vm.activeSegment = null;
      setActiveSegmentToCurrentOrFirstSegment();
      recalculateTotalDuration();
    }
  };

  function setActiveSegmentToCurrentOrFirstSegment() {
    var currentActiveSegment = _.filter(vm.segments, { _isActive: true }) || {};
    // if no current, set it to first one. Else if there is a currentActiveSegment, use it.
    if (currentActiveSegment.length === 0) {
      if (_.isObject(vm.segments[0])) {
        return;
      }
      // initialize exercise with no segments
      addSegment();
      vm.activeSegment = vm.segments[0];
    } else if (currentActiveSegment.length === 1) {
      vm.activeSegment = currentActiveSegment[0];
    }
  }

  function addSegment() {
    if (!moreSegmentsAvailable()) {
      return false;
    }

    if (vm.segments.length > 0) {
      vm.segments.push(getPreviousSetValues(vm.segments.length));
    } else {
      vm.segments.push(getEquipmentDefaultValues());
    }

    _refreshScroll();
    vm.onUpdate({ $event: vm.exercise });

    if (vm.scrollInstance) {
      $timeout(function() {
        // scroll to the last segment
        if (vm.scrollInstance.pages.length) {
          vm.scrollInstance.goToPage(vm.scrollInstance.pages.length, 0);
        }
        handleEvents();
      });
    }

    var hasIsActiveSegment = vm.segments.some(function(segment) {
      return segment._isActive;
    });
    if (hasIsActiveSegment) {
      activateSegment(vm.segments[vm.segments.length - 1]);
    }

  }

  function moreSegmentsAvailable() {
    return vm.exercise && vm.exercise.preset.maxSegments > vm.segments.length;
  }

  function activateSegment(segment) {
    // toggle state
    if (_.isObject(segment) && segment._isActive) {
      segment = null;
    }

    vm.activeSegment = segment;
    var activeSegment = _.find(vm.segments, { _isActive: true }) || {};
    activeSegment._isActive = false;

    if (_.isObject(segment)) {
      segment._isActive = true;
    }
  }

  function canDeleteSegments() {
    // the number of segments should be at least 1
    return vm.segments.length > 1;
  }

  function deleteActiveSegment() {
    var activeSegmentIndex = _.indexOf(vm.segments, vm.activeSegment),
      newActiveSegmentIndex = 0;
    if (activeSegmentIndex > -1) {
      vm.segments.splice(activeSegmentIndex, 1);

      // select previous segment or first segment
      newActiveSegmentIndex = _.max([activeSegmentIndex - 1, 0]);
      activateSegment(vm.segments[newActiveSegmentIndex]);
      this.onUpdate({ $event: this.exercise });
      _refreshScroll();
    }
  }

  function resetActiveSegment() {
    if (vm.activeSegment) {
      _.extend(vm.activeSegment, getEquipmentDefaultValues());
      this.onUpdate({ $event: this.exercise });
    }
  }
  function sliderValueChanged(metricName) {
    this.onUpdate({ $event: this.exercise });
  }

  function segmentProgressHeight(segmentInformation) {

    if (vm.exercise.equipmentType === 'Treadmill') {
      return ((segmentInformation.startingSpeed / 20) * 100) + '%';
    }

    return ((segmentInformation.startingResistance / 20) * 100) + '%';

  }

  // ============ HELPERS ======================
  function getEquipmentDefaultValues() {
    return _.reduce(vm.exercise.preset.metrics, function(mem, metric) {
      if (metric.forSegment) {
        mem[metric.name] = metric.validation.default;
      }
      return mem;
    }, {});
  }
  function getPreviousSetValues(previousSegmentNumber) {
    return _.reduce(vm.exercise.preset.metrics, function(mem, metric) {
      if (metric.forSegment) {
        mem[metric.name] = vm.exercise.assignedProfile.segments[previousSegmentNumber - 1][metric.name];
      }
      return mem;
    }, {});
  }
  function recalculateTotalDuration() {
    // pretty sure this code is creating a loop leading to high scripting time
    $timeout(function() {
      if (!_.isEmpty(vm.segments)) {
        var total = _.reduce(vm.segments, function(time, segment) {
          return time + (+segment.duration || 0);
        }, 0);
        vm.exercise.totalDuration = total.toFixed(1);
      }
    });
  }
  function _handleSegmentScrollEvents() {
    return _.once(function() {
      vm.scrollInstance.on('refresh', _updateIscrollLimits);
      vm.scrollInstance.on('scrollEnd', _updateIscrollLimits);
    });
  }
  function _updateIscrollLimits() {
    $timeout(function() {
      vm.scrollInstance._enableLeft = false;
      vm.scrollInstance._enableRight = false;

      if (vm.scrollInstance.hasHorizontalScroll) {
        vm.scrollInstance._enableLeft = vm.scrollInstance.x !== 0;
        vm.scrollInstance._enableRight = vm.scrollInstance.x !== vm.scrollInstance.maxScrollX;
      }
    });
  }
  function _refreshScroll() {
    $rootScope.$emit('iscroll:refresh');
  }

  function handleUpdate(exercise) {
    vm.onUpdate({ $event: exercise });
  }
}


angular.module('ptCrm')
  .component('connectedExerciseSegments', {
    templateUrl: '/app/components/customize-exercise-components/components/connected-exercise-segments.html',
    controller: connectedExerciseSegmentsCtrl,
    controllerAs:'connectedExerciseSegmentsCtrl',
    bindings: {
      exercise: '<',
      editPermission: '<',
      onUpdate: '&'
    }
  });
function exerciseDescriptionCtrl() {
  // this func update the exercise when the description changes.
  this.update = function() {
    this.onUpdate({ $event: this.exercise });
  };
}

angular.module('ptCrm').component('exerciseDescription', {
  templateUrl: '/app/components/customize-exercise-components/components/exercise-description.html',
  controller: exerciseDescriptionCtrl,
  controllerAs: 'exerciseDescriptionCtrl',
  bindings: {
    exercise: '<',
    onUpdate: '&'
  }
});

nonConnectedExerciseDetailsCtrl.$inject = ['exercisesService', '$translate'];function nonConnectedExerciseDetailsCtrl(exercisesService, $translate) {
  this.metricsList = {};
  this.$onChanges = function(changes) {
    if (changes.exercise.currentValue) {
      this.exercise = angular.copy(changes.exercise.currentValue);
    }
    // without this, ng-repeat rebuilds the dom in a way that you can't continously edit numbers
    if (!angular.equals(this.exercise.preset.metrics, this.metricsList)) {
      this.metricsList = this.exercise.preset.metrics;
    }
  };
  this.updateExercise = function(exercise) {
    this.onUpdate({ $event: exercise });
  };

  this.handleCategoryChange = function(category) {
    if (category === '') {
      delete this.exercise.category;
    } else {
      this.exercise.category = category;
    }
    this.onUpdate({ $event: this.exercise });
  };

  this.$onInit = function() {
    exercisesService.getExerciseCategories().then(function(response) {
      this.categories = response.data.map(translateAndConvertToObj);
    }.bind(this));
  };

  this.handleMetricUpdate = function(newValue, metricName) {
    this.exercise.assignedProfile.global[metricName] = newValue;
    this.updateExercise(this.exercise);
  };

  function translateAndConvertToObj(category) {
    var transString = $translate.instant(category.name);
    return {
      value:category.name,
      translated: transString
    };
  }
}

// onUpdate is called by html
angular.module('ptCrm').component('nonConnectedExerciseDetails', {
  templateUrl: '/app/components/customize-exercise-components/components/non-connected-exercise-details.html',
  controller: nonConnectedExerciseDetailsCtrl,
  controllerAs: 'nonConnectedExerciseDetailsCtrl',
  bindings: {
    exercise: '<',
    editPermission: '<',
    onUpdate: '&',
    // Either 'exercise' or 'assignment' depending on whether this component is being used to
    // create/edit an exercise template or create/edit an assignment/training set/facility assignment
    context: '@'
  }
});
function virtualActiveExerciseCtrl() {
  var vm = this;
  vm.$onChanges = function(changes) {
    if (changes.exercise.currentValue) {
      vm.exercise = angular.copy(changes.exercise.currentValue);
      vm.setLocations();
      vm.locationToObjArray();
    }
  };
  vm.updateSliders = function() {
    vm.onCardioProgramUpdate({ $event: vm.exercise.assignedProfile.cardioProgram });
  };
  vm.updateLocation = function(newLocation) {
    vm.exercise.assignedProfile.cardioProgram.location = newLocation;
    vm.onCardioProgramUpdate({ $event: vm.exercise.assignedProfile.cardioProgram });
  };

  vm.setLocations = function() {
    if (vm.exercise && Array.isArray(vm.exercise.preset.metrics)) {
      var metricWithLocation = function(metric) {
          return metric.name === 'location';
        },
        locationMetric = vm.exercise.preset.metrics.find(metricWithLocation);
      if (hasLocations(locationMetric)) {
        vm.locations = locationMetric.validation.enum.sort();

        var invalidLocation = !vm.locations.includes(vm.exercise.assignedProfile.cardioProgram.location); // eslint-disable-line

        // don't want location to be empty if we can prevent it
        if (invalidLocation && locationMetric.validation.default) {
          vm.exercise.assignedProfile.cardioProgram.location = locationMetric.validation.default;
          vm.onCardioProgramUpdate({ $event: vm.exercise.assignedProfile.cardioProgram });
        }
      }
    }
  };

  function hasLocations(locationMetric) {
    return locationMetric && locationMetric.validation && Array.isArray(locationMetric.validation.enum);
  }

  vm.locationToObjArray = function() {
    vm.objLocations = vm.locations.map(function(x) {
      return { value: x, translated: x };
    });
  };
}

angular.module('ptCrm')
  .component('virtualActiveExercise', {
    templateUrl: '/app/components/customize-exercise-components/components/virtual-active-exercise.html',
    controller: virtualActiveExerciseCtrl,
    controllerAs: 'virtualActiveExerciseCtrl',
    bindings: {
      exercise: '<',
      editPermission: '<',
      onCardioProgramUpdate: '&' // returns updated cardioProgram
    }
  });

sprint8ExerciseLevelCtrl.$inject = ['$scope', '$document', '$timeout', '$element', 'sprint8ExerciseHelperService', 'sprint8constant'];function sprint8ExerciseLevelCtrl($scope, $document, $timeout, $element, sprint8ExerciseHelperService, sprint8constant) {
  this.legendData = {};
  this.$onInit = function() {
    this.LEGEND_COLORS = sprint8constant.LEGEND_COLORS;
    if (this.validParams()) {
      this.sprintLevel = angular.copy(this.sprintLevel);
      this.equipmentType = angular.copy(this.equipmentType);
      this.updateProps();
    }
  };

  this.$onChanges = function(changes) {
    if (this.validParams()) {
      this.sprintLevel = angular.copy(this.sprintLevel);
      this.equipmentType = angular.copy(this.equipmentType);
      this.updateProps();
    }
  };

  this.validParams = function(equipmentType) {
    return (sprint8ExerciseHelperService.validLevel(this.sprintLevel) &&
            sprint8ExerciseHelperService.validEquipmentType(this.equipmentType));
  };

  this.updateProps = function() {
    for (var category in sprint8constant.LVL_CATEGORIES) {
      if ( sprint8constant.LVL_CATEGORIES[category].lvls.includes(this.sprintLevel) ) {
        this.selectedCategory = sprint8constant.LVL_CATEGORIES[category];
      }
    }
    this.legendData.sprintTxtArray = sprint8ExerciseHelperService.getAllSprintIntervalTxt(this.equipmentType);
    this.legendData.recoveryTxtArray = sprint8ExerciseHelperService.getAllActiveRecoverTxt(this.equipmentType);
  };

  this.setLevelCategory = function(category) {
    this.selectedCategory = sprint8constant.LVL_CATEGORIES[category];
    this.setLvl(this.selectedCategory.lvls[0]);
  };

  this.setLvl = function(lvl) {
    if (sprint8ExerciseHelperService.validLevel(lvl)) {
      this.sprintLevel = lvl;
      this.onUpdate({ $event: this.sprintLevel });
    }
  };
}

angular.module('ptCrm')
  .component('sprint8ExerciseLevel', {
    templateUrl: '/app/components/customize-exercise-components/components/sprint8-exercise-level/sprint8-exercise-level.html',
    controller: sprint8ExerciseLevelCtrl,
    controllerAs: 's8lvlCtrl',
    bindings: {
      equipmentType: '<',
      sprintLevel: '<',
      onUpdate: '&'
    }
  });
angular.module('ptCrm')
  .directive('sprint8ExerciseLevelLegend', function() {
    return {
      templateUrl:'/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-legend.html',
      scope:{
        myTitle: '@',
        myColor: '@',
        mySubText: '<'
      } // isolated scope
    };
  });
/* global Chart */

sprint8ExerciseLevelChart.$inject = ['sprint8ExerciseHelperService', '$translate'];
function sprint8ExerciseLevelChart(sprint8ExerciseHelperService, $translate) {

  this.$onInit = function() {
    if (this.propsAreValid()) {
      this.updateChart();
    }
  };

  this.$onChanges = function(changes) {
    if (changes && this.propsAreValid()) {
      this.updateChart();
    }
  };

  this.$postLink = function() {
    this.createChart();
    this.updateChart();
  };

  this.propsAreValid = function() {
    return (sprint8ExerciseHelperService.validLevel(this.sprintLevel) &&
      sprint8ExerciseHelperService.validEquipmentType(this.equipmentType));
  };

  var chartUnit = '';
  // this is needed as a var not this.chartUnit
  // because chartjs plugins will not recongize the scope

  this.updateChart = function() {
    if (this.myChart !== undefined && this.propsAreValid()) {

      var newData = sprint8ExerciseHelperService.getLevelIntervalData(this.equipmentType, this.sprintLevel),
        largestDataPoint = sprint8ExerciseHelperService.getLargestDataPoint(this.equipmentType) || 10;

      this.myChart.data.datasets[0].data = newData;
      this.myChart.chart.options.scales.yAxes[0].ticks.suggestedMax = largestDataPoint + 1;

      chartUnit = sprint8ExerciseHelperService.getChartUnits(this.equipmentType);

      this.myChart.update();
    }
  };

  this.createChart = function() {
    var canvasT = angular.element(document.querySelector('#myChart'));
    canvasT = canvasT.length === 1 ? canvasT[0] : canvasT;

    var context = canvasT.getContext('2d'), // eslint-disable-line
      ctx = context;

    this.myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: sprint8ExerciseHelperService.getChartLabels(),
        datasets: [
          {
            label: $translate.instant('RESISTANCE_SPEED'),
            data: [],
            backgroundColor: sprint8ExerciseHelperService.getChartBackgroundColors(),
            borderWidth: 1
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        events: [
          'click'
        ],
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false
              },
              categoryPercentage: 0.90,
              barPercentage: 1.0,
              fontColor: 'rgb(117,117,117)',
              drawOnChartArea: true
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true
              },
              display: false
            }
          ]
        }
      }
    });

    // only want to register plugin if it hasn't been globally registered yet
    if (!_.find(Chart.plugins.getAll(), { id: 'sprint8Labels' })) {
      // this plugin draws the speed/resistance on top of the sprint intervals
      // sizes are in pixels
      Chart.plugins.register({
        id: 'sprint8Labels',
        afterDatasetsDraw: function(chart, options) {
          var ctx = chart.ctx,
            ctxSubText = chart.ctx;
          chart.data.datasets.forEach(function(dataset, i) {
            var meta = chart.getDatasetMeta(i);
            if (!meta.hidden) {
              var fontStyle = 'bold', // eslint-disable-line
                fontFamily = 'Roboto',
                padding = 5,
                chartWidth = 30;
              if (meta.data[0]) {
                // if data did not get passed and reactive chartjs fails, use 30px as the default
                chartWidth = meta.data[0]._view.width !== undefined ? meta.data[0]._view.width : 30;
              }
              // fontSize in in pixels
              var fontSize = 16; // eslint-disable-line
              switch (true) {
              case (chartWidth > 35):
                fontSize = 18;
                break;
              case (chartWidth > 25):
                fontSize = 16;
                break;
              default:
                fontSize = 12;
                break;
              }

              ctx.fillStyle = 'rgb(255,255,255)';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              meta.data.forEach(function(element, index) {
                var position = element.tooltipPosition(),
                  dataString = dataset.data[index].toString();
                if (dataString.length < 2 && !dataString.includes('.')) {
                  dataString += '.0';
                }
                // if the chart is wide enough, write white text over the bar
                if (chartWidth >= 17) {
                  // text is written on top of sprint intervals ie, every other bar on the chart
                  if (index % 2 === 1) {
                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                    ctx.fillText(dataString, position.x, position.y + element.height() - (1.5 * fontSize));
                    ctxSubText.font = Chart.helpers.fontString(fontSize - 5, fontStyle, fontFamily);
                    ctxSubText.fillText(chartUnit, position.x, position.y + element.height() - (0.5 * fontSize) - 2);
                  }
                }
                // if the chart is more narrow, write grey text on top of the bar
                if (chartWidth < 17 && chartWidth > 9) {
                  // text is written on top of sprint intervals ie, every other bar on the chart
                  if (index % 2 === 1) {
                    ctx.fillStyle = 'rgb(117,117,117)';
                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                    ctx.fillText(dataString, position.x, position.y - (1.5 * fontSize));
                    ctxSubText.font = Chart.helpers.fontString(fontSize - 5, fontStyle, fontFamily);
                    ctxSubText.fillText(chartUnit, position.x, position.y - (0.5 * fontSize) - 2);
                  }
                }
              });
            }
          });
        }
      });
    }
  };

}

angular.module('ptCrm')
  .component('sprint8ExerciseLevelChart', {
    templateUrl: '/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-chart.html',
    controller: sprint8ExerciseLevelChart,
    controllerAs: 's8ChartCtrl',
    bindings: {
      sprintLevel: '<',
      equipmentType: '<'
    }
  });

strengthExerciseSetsCtrl.$inject = ['profileService', '$translate', 'strengthEquipment'];function strengthExerciseSetsCtrl(profileService, $translate, strengthEquipment) {
  this.SECONDS_PER_REP = 3;
  var EQUIPMENT_TYPE_ARRAY = strengthEquipment.getTypes();

  this.$onInit = function() {
    this.sets = angular.copy(this.sets);
    this.description = angular.copy(this.description);
    this.equipmentType = angular.copy(this.equipmentType);
    this.validateEquipmentType();
    this.maxWeight = 0;
    this.calculateComputedValues();
    this.userUnit = 'lbs';
    profileService.update().then(function(response) {
      this.userUnit = response.user.settings.measurementUnit === 'M' ? 'kgs' : 'lbs';
    }.bind(this));
  };

  this.$onChanges = function(changes) {
    if (changes.sets) {
      this.sets = angular.copy(this.sets);
      this.calculateComputedValues();
    }
    if (changes.description) {
      this.description = angular.copy(this.description);
    }
    if (changes.equipmentType) {
      this.equipmentType = angular.copy(this.equipmentType);
      this.validateEquipmentType();
    }
  };

  this.validateEquipmentType = function() {
    if (this.equipmentType && !EQUIPMENT_TYPE_ARRAY.includes(this.equipmentType) ) {
      this.equipmentType = '';
      this.equipmentTypeUpdate();
    }
  };

  this.calculateComputedValues = function() {
    this.maxWeight = this.sets.reduce(function(rtnVal, set) {
      return set.weight>rtnVal ? set.weight : rtnVal;
    }, 0);
    this.totalRestTime = this.sets.reduce(function(rtn, set) {
      var timeToPerformSet = angular.isNumber(set.reps) ? set.reps * this.SECONDS_PER_REP : 0;
      return rtn + set.restTime + timeToPerformSet;
    }.bind(this), 0);
  };

  this.translatedEquipmentTypesObjArray = EQUIPMENT_TYPE_ARRAY
    .map(translateAndConvertToObj)
    .sort(equipmentTypeSort);

  // returns {value:'', translate:''}
  function translateAndConvertToObj(equipmentType) {
    var transString = $translate.instant(equipmentType.toUpperCase());
    return {
      value:equipmentType,
      translated: transString
    };
  }

  // Ignores case and accepts non ascii chars - 'other' comes last
  function equipmentTypeSort(t1, t2) {
    return t1.translated.toUpperCase().localeCompare(t2.translated.toUpperCase());
  }

  this.handleUpdate = function(updatedSets) {
    if (!updatedSets.length >= 1) {
      this.onWeightSetUpdate({ $event: this.sets });
    } else {
      this.onWeightSetUpdate({ $event: updatedSets });
    }
  };

  this.updatedDescription = function(exercise) {
    this.onAssignmentDescriptionUpdate({ $event: exercise.description });
  };

  this.equipmentTypeUpdate = function(updated) {
    this.onEquipmentTypeUpdate({ $event: updated });
  };
}

angular.module('ptCrm').component('strengthExerciseSets', {
  templateUrl: '/app/components/customize-exercise-components/components/strength-exercise-sets/strength-exercise-sets.html',
  controller: strengthExerciseSetsCtrl,
  controllerAs: 'setCtrl',
  bindings: {
    exercise: '<',
    sets: '<', // array of sets, each set has weight (int), reps (int), and restTime (int in seconds)
    description: '<', // description of the strength exercise
    context: '@', // either working with an assignment or an exercise next line
    equipmentType: '@', // NOTE: see strengthEquipment.service for valid equipmentTypes
    onEquipmentTypeUpdate: '&', // called with updated equipment type. If equipmentType is 'none', a blank string is returned
    onWeightSetUpdate: '&', // returns updated array of sets - as defined above
    onAssignmentDescriptionUpdate: '&' // returns updated description if changed - ONLY for when context is assignment
  }
});

advancedStrengthCtrl.$inject = ['profileService', 'config'];function advancedStrengthCtrl(profileService, config) {
  this.imagePath = config.assetBaseUrl;
  if (this.imagePath && this.imagePath[this.imagePath.length -1] !== '/') {
    this.imagePath += '/';
  }

  this.MAX_NUMBER_OF_SETS = 250;
  this.KG_INCREMENT = 1.0;
  // metricsObj is used for validation
  this.metricsObj = {
    weight: {
      default: 25,
      // default increment is for imperial/lbs and is changed to KG_INCREMENT if in 'metric' units
      increment: 1,
      maxValue: 999,
      minValue: 0,
      precision: 2e0 // round to nearest half
    },
    reps: {
      default: 10,
      increment: 1,
      maxValue: 99,
      minValue: 0,
      precision: 1e0 // round to nearest whole number
    },
    restTime: {
      minValue: 0,
      maxValue: 999,
      increment: 5,
      default: 20,
      precision: 1e0 // round to nearest whole number
    }
  };
  // without this, any/every change will un-collapse all the sets in the UI
  this.internalStateCollapsedSetsTracker = [];

  this.$onInit = function() {
    this.sets = angular.copy(this.sets);
    this._fillInSets(this.sets);
    this.userUnit = 'LB';
    // .update() is used to get the profile
    profileService.update().then(function(response) {
      // checking if in metric unit of measurement ('M') instead of imperial ('I')
      if (response.user.settings.measurementUnit === 'M') {
        this.userUnit = 'KG';
        this.metricsObj.weight.increment = this.KG_INCREMENT;
      }
    }.bind(this));
  };

  this.$onChanges = function(changes) {
    if (changes.sets.currentValue) {
      this.sets = angular.copy(this.sets);
      this._fillInSets(this.sets);
    }
  };

  // used to fill in any required properties with defaults
  this._fillInSets = function(sets) {
    if (sets.length === 0) {
      sets.push({});
      this._sendUpdate();
    }
    var valueChanged = false,
      i;
    for (i = 0; i < sets.length; i++) {
      if (sets[i].weight === undefined) {
        sets[i].weight = this.metricsObj.weight.default;
        valueChanged = true;
      }
      if (sets[i].reps === undefined) {
        sets[i].reps = this.metricsObj.reps.default;
        valueChanged = true;
      }
      if (sets[i].restTime === undefined) {
        sets[i].restTime = this.metricsObj.restTime.default;
        valueChanged = true;
      }
    }
    // only call _sendUpdate after all values for all sets have been filled in
    if (valueChanged) {
      this._sendUpdate();
    }
  };

  this.manuallySetValue = function() {
    this._sendUpdate();
  };

  this.incrementMetric = function(metricName, set) {
    set[metricName] += this.metricsObj[metricName].increment;
    this._sendUpdate();
  };

  this.decrementMetric = function(metricName, set) {
    set[metricName] -= this.metricsObj[metricName].increment;
    this._sendUpdate();
  };

  this.addSet = function() {
    var newSet = angular.copy(this.sets[this.sets.length - 1]);
    this.sets.push(newSet);
    this._sendUpdate();
  };

  this.deleteSet = function(setIdx) {
    if (this.sets.length > 1 && setIdx < this.sets.length && setIdx > -1) {
      this.sets.splice(setIdx, 1);
    }
    this._sendUpdate();
  };

  // for each set...
  // checks each set's metrics (uses default if invalid)
  // rounds metrics to nearest lvl of precision
  // rounds metrics that are outside of range (ie between min/max)
  this._sendUpdate = function() {
    this.sets.forEach(function(set) {
      // for each metric metricsObj: ie weight/reps/restTime
      for (var metric in this.metricsObj) {
        // eslint recommended check/gaurd
        if (this.metricsObj.hasOwnProperty(metric)) {
          if (set[metric] === undefined || !angular.isNumber(set[metric])) {
            set[metric] = this.metricsObj[metric].default;
          } else {
            set[metric] = parseFloat((Math.round(set[metric] * 10) / 10).toFixed(this.metricsObj[metric].precision));
            if (set[metric] < this.metricsObj[metric].minValue) {
              set[metric] = this.metricsObj[metric].minValue;
            } else if (set[metric] > this.metricsObj[metric].maxValue) {
              set[metric] = this.metricsObj[metric].maxValue;
            }
          }
        } // end of eslint gaurd
      } // end of for metric in metricsObj
    }.bind(this));
    this.onUpdate({ $event: this.sets });
  };

  this.canAddSet = function() {
    return this.sets.length < this.MAX_NUMBER_OF_SETS;
  };
}

// HUGE ASSUMPTION: a set's weight is already converted to the user's personal settings: user.settings.measurementUnit (i.e. lbs or kgs)
angular.module('ptCrm').component('advancedStrength', {
  templateUrl: '/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrength.html',
  controller: advancedStrengthCtrl,
  controllerAs: 'advStrCtrl',
  bindings: {
    sets: '<', // array of sets, [ {weight:int, reps:int, restTime:int}, {...}] // if empty array, will create one set with weight/reps/restTime from the passed metrics
    onUpdate: '&' // returns updated array of sets - as defined above
  }
});

functionalExerciseSetsCtrl.$inject = ['$translate', 'strengthEquipment'];function functionalExerciseSetsCtrl($translate, strengthEquipment) {
  this.$onInit = function() {
    this.sets = angular.copy(this.sets);
    this.description = angular.copy(this.description);
    this.equipmentType = angular.copy(this.equipmentType);
  };

  this.$onChanges = function(changes) {
    if (changes.equipmentType) {
      this.equipmentType = angular.copy(this.equipmentType);
      this.validateEquipmentType();
    }
  };

  this.translatedEquipmentTypesObjArray = strengthEquipment.getTypes('functional')
    .map(translateAndConvertToObj)
    .sort(equipmentTypeSort);

  this.equipmentTypeUpdate = function(updated) {
    this.onEquipmentTypeUpdate({ $event: updated });
  };
  this.handleUpdate = function(updatedSets) {
    this.onSetUpdate({ $event: updatedSets });
  };
  this.updatedDescription = function(exercise) {
    this.onDescriptionUpdate({ $event: exercise.description });
  };

  this.validateEquipmentType = function() {
    if (this.equipmentType && !strengthEquipment.getTypes('functional').includes(this.equipmentType) ) {
      this.equipmentType = '';
      this.equipmentTypeUpdate();
    }
  };

  // Ignores case and accepts non ascii chars - 'other' comes last
  function equipmentTypeSort(t1, t2) {
    return t1.translated.toUpperCase().localeCompare(t2.translated.toUpperCase());
  }
  // returns {value:'', translate:''}
  function translateAndConvertToObj(equipmentType) {
    var transString = $translate.instant(equipmentType.toUpperCase());
    return {
      value:equipmentType,
      translated: transString
    };
  }
}

angular.module('ptCrm').component('functionalExerciseSets', {
  templateUrl: '/app/components/customize-exercise-components/components/functional-exercise-sets/functional-exercise.html',
  controller: functionalExerciseSetsCtrl,
  controllerAs: 'functionalSetsCtrl',
  bindings: {
    exercise: '<',
    sets: '<',
    equipmentType: '@',
    description: '<',
    context: '@',
    onDescriptionUpdate: '&',
    onEquipmentTypeUpdate: '&',
    onSetUpdate: '&'
  }
});

functionalExerciseCtrl.$inject = ['config', 'profileService'];function functionalExerciseCtrl(config, profileService) {
  this.imagePath = config.assetBaseUrl;
  if (this.imagePath && this.imagePath[this.imagePath.length -1] !== '/') {
    this.imagePath += '/';
  }
  this.weightUnit = profileService.user.settings.measurementUnit === 'M' ? 'KG' : 'LB';
  this.MAX_NUMBER_OF_SETS = 250;
  this.KG_INCREMENT = 1.0;

  // metricsObj is used for validation
  this.metricsObj = {
    duration: {
      default: 30,
      increment: 5,
      maxValue: 300,
      minValue: 0,
      precision: 1e0 // round to nearest whole number
    },
    weight: {
      default: 0,
      increment:1,
      maxValue: 1000,
      minValue: 0,
      precision: 2e0
    },

    reps: {
      default: 10,
      increment: 1,
      maxValue: 999,
      minValue: 0,
      precision: 1e0 // round to nearest whole number
    },
    restTime: {
      minValue: 0,
      maxValue: 999,
      increment: 5,
      default: 20,
      precision: 1e0 // round to nearest whole number
    },
    type: {
      default : 'standard',
      enum : [
        'standard',
        'toFailure',
        'asManyReps'
      ]
    }
  };
  // without this, any/every change will un-collapse all the sets in the UI
  this.internalStateCollapsedSetsTracker = [];

  this.$onInit = function() {
    this.sets = angular.copy(this.sets);
    this._fillInSets(this.sets);
  };
  this.$onChanges = function(changes) {
    if (changes.sets.currentValue) {
      this.sets = angular.copy(this.sets);
      this._fillInSets(this.sets);
    }
  };
  // used to fill in any required properties with defaults
  this._fillInSets = function(sets) {
    if (sets.length === 0) {
      sets.push({});
      this._sendUpdate();
    }
    var valueChanged = false,
      i;
    for (i = 0; i < sets.length; i++) {
      if (sets[i].duration === undefined) {
        sets[i].duration = this.metricsObj.duration.default;
        valueChanged = true;
      }
      if (sets[i].weight === undefined) {
        sets[i].weight = this.metricsObj.weight.default;
        valueChanged = true;
      }
      if (sets[i].reps === undefined) {
        sets[i].reps = this.metricsObj.reps.default;
        valueChanged = true;
      }
      if (sets[i].restTime === undefined) {
        sets[i].restTime = this.metricsObj.restTime.default;
        valueChanged = true;
      }
      if (sets[i].type === undefined) {
        sets[i].type = this.metricsObj.type.default;
        valueChanged = true;
      }

    }
    // only call _sendUpdate after all values for all sets have been filled in
    if (valueChanged) {
      this._sendUpdate();
    }
  };

  this.manuallySetValue = function() {
    this._sendUpdate();
  };

  this.incrementMetric = function(metricName, set) {
    set[metricName] += this.metricsObj[metricName].increment;
    this._sendUpdate();
  };

  this.decrementMetric = function(metricName, set) {
    set[metricName] -= this.metricsObj[metricName].increment;
    this._sendUpdate();
  };

  this.addSet = function() {
    var newSet = angular.copy(this.sets[this.sets.length - 1]);
    this.sets.push(newSet);
    this._sendUpdate();
  };

  this.deleteSet = function(setIdx) {
    if (this.sets.length > 1 && setIdx < this.sets.length && setIdx > -1) {
      this.sets.splice(setIdx, 1);
    }
    this._sendUpdate();
  };

  // for each set...
  // checks each set's metrics (uses default if invalid)
  // rounds metrics to nearest lvl of precision
  // rounds metrics that are outside of range (ie between min/max)
  this._sendUpdate = function() {
    this.sets.forEach(function(set) {
      if (set.type === 'standard') {
        set.duration = 0;
        set.reps = this._correctValue(set.reps, this.metricsObj.reps);
      } else if (set.type === 'asManyReps') {
        set.reps = 0;
        set.duration = this._correctValue(set.duration, this.metricsObj.duration);
      } else {
        set.reps = 0;
        set.duration = 0;
      }
      set.weight = this._correctValue(set.weight, this.metricsObj.weight);
      if (set.restTime !== 0) {
        set.restTime = this._correctValue(set.restTime, this.metricsObj.restTime);
      }
    }.bind(this));
    this.onUpdate({ $event: this.sets });
  };

  this._correctValue = function(value, metric) {
    if (value === undefined || !angular.isNumber(value)) {
      return metric.default;
    }
    var tempValue = parseFloat((Math.round(value * 10) / 10).toFixed(metric.precision));
    if (value < metric.minValue) {
      tempValue = metric.minValue;
    } else if (value > metric.maxValue) {
      tempValue = metric.maxValue;
    }
    return tempValue;
  };

  this.canAddSet = function() {
    return this.sets.length < this.MAX_NUMBER_OF_SETS;
  };
  this.typeChange = function() {
    this._sendUpdate();
  };
}

angular.module('ptCrm').component('customizeFunctional', {
  templateUrl: '/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional.html',
  controller: functionalExerciseCtrl,
  controllerAs: 'functCtrl',
  bindings: {
    sets: '<', // array of sets, [ {duration:int, reps:int, restTime:int}, {...}] // if empty array, will create one set with duration/reps/restTime from the passed metrics
    onUpdate: '&' // returns updated array of sets - as defined above
  }
});

metricCardCtrl.$inject = ['config'];function metricCardCtrl(config) {
  this.basePath = config.assetBaseUrl;
  if (this.basePath && this.basePath[this.basePath.length -1] !== '/') {
    this.basePath += '/';
  }
  this.$onInit = function() {
    this.editType = this.editType || null;
  };

  this.$onChanges = function() {
    this.metricName = angular.copy(this.metricName);
  };

  this.focusOnInput = function() {
    this.focusOnMe = true;
  };

  this.handleDurationChange = function(newValue) {
    this.onMetricValueUpdate({ $event: newValue });
  };
}

angular.module('ptCrm').component('metricCard', {
  templateUrl: '/app/components/metric-card/metric-card.html',
  controller: metricCardCtrl,
  controllerAs: 'metricCtrl',
  bindings: {
    metricName: '@',
    metricValue: '<', // numbers ONLY
    metricUnit: '@', // optional
    editType: '@', // { "number" | "duration" | null } defaults to null -> ie, non-editable
    onMetricValueUpdate: '&' // only works if there is an editType
  }
});

exerciseMediaController.$inject = ['$q', '$http', 'config'];function exerciseMediaController($q, $http, config) {
  var vm = this,
    youTubeRegExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
    vimeoRegExp = /^(http:\/\/|https:\/\/)?(www\.)?(vimeo\.com\/)([0-9]+)$/;
  vm.fileError = false;
  vm.exerciseImages = [];
  vm.exerciseVideo = undefined;
  vm.selectedImageIdx = 0;

  vm.$onChanges = function(changes) {
    if (changes.images && changes.images.currentValue && !vm.exerciseImages.length) {
      vm.exerciseImages = angular.copy(changes.images.currentValue);
      $q.all(vm.exerciseImages.map(vm._setTransformData))
        .then(function(images) {
          vm.exerciseImages = angular.copy(images);
          vm.selectedImageIdx = 0;
        });
    }
    if (changes.video && changes.video.currentValue && !vm.exerciseVideo) {
      vm.exerciseVideo = angular.copy(changes.video.currentValue);
      vm.onVideoChange();
    }
  };

  vm.selectedImage = function() {
    return vm.exerciseImages[vm.selectedImageIdx];
  };

  vm.addImage = function(file) {
    if (file[0].type === 'image/png' || file[0].type === 'image/jpeg') {
      vm.exerciseImages.push({ loading: true });

      return _upload(file[0])
        .then(function(res) {
          var lastIndex = vm.exerciseImages.length - 1;
          vm.exerciseImages[lastIndex].picturePath = res;
          return vm._setTransformData(vm.exerciseImages[lastIndex], lastIndex);
        })
        .then(function() {
          if (vm.exerciseImages.length === 1 && !vm.exerciseImages[0].isPrimary) {
            vm.exerciseImages[0].isPrimary = true;
          }
          vm.updateExerciseMedia();
        });
    }
    return vm.toggleFileError();
  };

  function _upload(image) {
    var formData = new FormData();
    formData.append('picture', image);

    return $http.post(config.apiBase + '/images?isCRM=true', formData, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    })
      .then(function(response) {
        return response.data && response.data.url;
      });
  }

  vm.toggleFileError = function() {
    vm.fileError = !vm.fileError;
  };

  vm.selectImage = function(idx) {
    vm.selectedImageIdx = idx;
  };

  vm.updateExerciseMedia = function() {
    vm.onUpdate({
      $event: {
        images: vm.exerciseImages.map(function(image) {
          return _.pick(image, ['_id', 'picturePath', 'transform', 'isPrimary']);
        }),
        video: vm.exerciseVideo
      }
    });
  };

  vm.setAsPrimary = function(idx) {
    vm.exerciseImages.forEach(function(img, loopIdx) {
      img.isPrimary = (idx === loopIdx);
    });
    vm.updateExerciseMedia();
  };

  vm.removeImage = function(idx) {
    var removedPrimary = vm.exerciseImages[idx].isPrimary;
    vm.exerciseImages.splice(idx, 1);
    vm.updateExerciseMedia();
    if (removedPrimary) { vm.setAsPrimary(0); }
  };

  vm.getBackgroundColor = function(idx) {
    var currentTransform = vm.exerciseImages[idx].transform || vm.exerciseImages[idx].pictureTransform;
    return vm.parseTransform(currentTransform).b;
  };

  vm.getTransformType = function(idx) {
    var currentTransform = vm.exerciseImages[idx].transform || vm.exerciseImages[idx].pictureTransform;
    return vm.parseTransform(currentTransform).c;
  };

  vm.generateTransformString = function(transformObj) {
    var transform = '';

    if (transformObj.ar) {
      transform += 'ar_' + transformObj.ar;
    }

    if (transformObj.c) {
      transform += ',c_' + transformObj.c;
    }

    if (transformObj.b) {
      transform += ',b_' + transformObj.b;
    }

    return transform;
  };

  vm.parseTransform = function(transformString) {
    if (!transformString) {
      return {};
    }

    var transforms = transformString.split(','),
      transformObj = {};

    _.each(transforms, function(transform) {
      var tokens = transform.split('_');

      if (tokens.length === 2) {
        transformObj[tokens[0]] = tokens[1];
      }
    });

    return transformObj;
  };

  vm.setBackgroundColor = function(idx, color) {
    var currentTransform = vm.exerciseImages[idx].transform || vm.exerciseImages[idx].pictureTransform,
      transformObj = vm.parseTransform(currentTransform);

    transformObj.b = color;
    vm.exerciseImages[idx].transform = vm.exerciseImages[idx].pictureTransform = vm.generateTransformString(transformObj);
    vm.updateExerciseMedia();
  };

  vm.setTransform = function(idx, type) {
    var transformObj = {
      ar: 1.00,
      c: type,
      b: vm.getBackgroundColor(idx)
    };

    if (type === 'pad' && !transformObj.b) {
      transformObj.b = 'white';
    }

    vm.exerciseImages[idx].transform = vm.exerciseImages[idx].pictureTransform = vm.generateTransformString(transformObj);
    vm.updateExerciseMedia();
  };

  vm._setTransformData = function(image, idx) {
    if (!image.resolved) {
      image.loading = true;
    }
    return $q(function(resolve, reject) {
      var img = new Image();

      img.onload = function() {
        image.aspectRatio = img.width / img.height;

        if (!(image.transform || image.pictureTransform)) {
          // if there is not a transform already set

          if (image.aspectRatio >= 1.00) {
            vm.setTransform(idx, 'fill');
          } else {
            vm.setTransform(idx, 'pad');
          }
        }
        if (!image.resolved) {
          image.loading = false;
        }
        image.resolved = true;
        resolve(image);
      };

      img.onerror = function() {
        reject();
      };

      img.src = image.picturePath;
    });
  };

  vm.onVideoChange = function() {
    if (_isValidVideo(vm.exerciseVideo)) {
      vm.showVideoPreview = true;
      vm.showVideoError = false;
      vm.updateExerciseMedia();
    } else {
      vm.showVideoError = true;
      vm.showVideoPreview = false;
    }
  };

  vm.clearVideo = function() {
    vm.exerciseVideo = undefined;
    vm.showVideoPreview = false;
    vm.showVideoError = false;
    vm.updateExerciseMedia();
  };

  function _isValidVideo(url) {
    return youTubeRegExp.test(url) || vimeoRegExp.test(url);
  }
}

angular.module('ptCrm')
  .component('exerciseMedia', {
    templateUrl: '/app/components/exercise-media/exercise-media.component.html',
    controller: exerciseMediaController,
    controllerAs: 'exerciseMediaCtrl',
    bindings: {
      images: '<',
      video: '<',
      onUpdate: '&'
    }
  });
assignmentTypeCtrl.$inject = ['savedTrainingPlanService', 'popup', '$translate'];function assignmentTypeCtrl(savedTrainingPlanService, popup, $translate) {

  var nextTabs = {
    assignment: {
      tabName: 'chooseClient',
      translationKey: 'CLIENTS'
    },
    trainingPlan: {
      tabName: 'chooseClient',
      translationKey: 'CLIENTS'
    },
    facility: {
      tabName: 'selectTime',
      translationKey: 'DATE_TIME'
    }
  };

  this.assignmentName = '';
  this.savedTrainingPlans = savedTrainingPlanService.getTrainingPlansPaginateList({});
  this.selectedPlan = this.savedPlan;

  this.$onChanges = function(changes) {
    if (changes.type) {
      if (changes.type.currentValue) {
        this.type = angular.copy(changes.type.currentValue);
      }
      if (!changes.type.currentValue && !this.type) {
        this.onTypeUpdate({ $event: 'trainingPlan' });
      }
    }

    if (changes.name && changes.name.currentValue) {
      this.assignmentName = angular.copy(changes.name.currentValue);
    }
  };

  this.setPlan = function(newPlan) {
    this.selectedPlan = newPlan;

    if (this.selectedPlan) {
      this.assignmentName = this.selectedPlan.planName;
      this.setName();
    }

    this.onPlanUpdate({ $event: this.selectedPlan });
  };

  this.setType = function(newValue) {
    this.onTypeUpdate({ $event: newValue });
  };

  this.setName = function() {
    this.onNameUpdate({ $event: this.assignmentName });
  };

  this.goToNextTab = function() {
    if (this.canAdvanceTab()) {
      this.onTabAdvance({ $event: nextTabs[this.type].tabName });
    } else {
      popup.alert({
        title: $translate.instant('INFORMATION_REQUIRED'),
        description: $translate.instant('NEED_ASSIGNMENT_TITLE')
      });
    }
  };

  this.nextButtonText = function() {
    return nextTabs[this.type].translationKey;
  };

  this.canAdvanceTab = function() {
    if (this.type === 'trainingPlan') {
      return this.assignmentName.length;
    }
    return true;
  };
}

angular.module('ptCrm')
  .component('assignmentType', {
    templateUrl: '/app/components/assignment-workflow/assignment-type/assignment-type.html',
    controller: assignmentTypeCtrl,
    controllerAs: 'assignmentTypeCtrl',
    bindings: {
      type: '<',
      name: '<',
      savedPlan: '<',
      onTypeUpdate: '&',
      onTabAdvance: '&',
      onNameUpdate: '&',
      onPlanUpdate: '&',
      isEdit: '<',
      isCopy: '<'
    }
  });


chooseClientController.$inject = ['$scope', 'profileService', 'exercisersService', 'popup', '$translate'];function chooseClientController($scope, profileService, exercisersService, popup, $translate) {
  this.trainerDropdown = false;
  this.trainers = exercisersService.getStaffPaginateList({ isAssignmentFlow: true });
  this.loadTrainers = _loadTrainers;
  this.loadTrainers();

  this.clients = exercisersService.getClientPaginateList({ isAssignmentFlow: true });
  this.loadClients = _loadClients;
  this.loadClients();

  this.$onChanges = function(changes) {
    if (changes.trainer) {
      this._handleVariableChange(changes.trainer, 'selectedTrainer', profileService.user, this.onTrainerChange);
    }
    if (changes.exercisers) {
      this._handleVariableChange(changes.exercisers, 'selectedClients', [], this.onExercisersChange);
    }
  };

  this.goToTab = function(newTab) {
    if (newTab === 'selectTime') {
      if (this.canGoToTimePage()) {
        this.onTabChange({ $event: newTab });
      } else {
        popup.alert({
          title: $translate.instant('INFORMATION_REQUIRED'),
          description: $translate.instant('NEED_CLIENTS')
        });
      }
    } else {
      this.onTabChange({ $event: newTab });
    }
  };

  this.toggleTrainerDropdown = function() {
    this.trainerDropdown = !this.trainerDropdown;
  };

  this.changeTrainer = function(newTrainer) {
    this.selectedTrainer = newTrainer;
    if (this.trainerDropdown) {
      this.toggleTrainerDropdown();
    }
    $scope.chooseClientCtrl.onTrainerChange({ $event: this.selectedTrainer });
  };

  this.clientIsSelected = function(clientId) {
    return _.findIndex(this.selectedClients, function(item) {
      return item._id === clientId;
    }) > -1;
  };

  this.removeClientById = function(clientId) {
    var idx = _.findIndex(this.selectedClients, function(item) {
      return item._id === clientId;
    });
    this.selectedClients.splice(idx, 1);
    $scope.chooseClientCtrl.onExercisersChange({ $event: this.selectedClients });
  };

  this.addClient = function(client) {
    this.selectedClients.push(client);
    $scope.chooseClientCtrl.onExercisersChange({ $event: this.selectedClients });
  };

  this.removeClient = function(idx) {
    this.selectedClients.splice(idx, 1);
    $scope.chooseClientCtrl.onExercisersChange({ $event: this.selectedClients });
  };

  this.canGoToTimePage = function() {
    return this.selectedTrainer && this.selectedClients.length;
  };

  function _filterSelectedUsers(users, selectedUsers) {
    return _.differenceBy(users, selectedUsers, '_id');
  }

  function _loadTrainers(isUpdate) {
    return this.trainers
      .extendDefaultParams({ search: this.trainerSearch })
      .load({
        update: isUpdate,
        responseExtract: function(trainers) {
          return _filterSelectedUsers(trainers, [this.selectedTrainer]);
        }
      });
  }

  function _loadClients(isUpdate) {
    return this.clients
      .extendDefaultParams({ search: this.clientSearch })
      .load({
        update: isUpdate,
        responseExtract: function(clients) {
          return _filterSelectedUsers(clients, this.selectedClients);
        }
      });
  }

  this._handleVariableChange = function(change, stateVar, defaultVal, callback) {
    if (change.currentValue) {
      this[stateVar] = angular.copy(change.currentValue);
    }
    if (!change.currentValue && !this[stateVar]) {
      callback({ $event: defaultVal });
    }
  };

}


angular.module('ptCrm')
  .component('chooseClient', {
    templateUrl: '/app/components/assignment-workflow/choose-client/choose-client.html',
    controller: chooseClientController,
    controllerAs: 'chooseClientCtrl',
    bindings: {
      onTabChange: '&',
      trainer: '<',
      exercisers: '<',
      onTrainerChange: '&',
      onExercisersChange: '&'
    }
  });



reviewAssignmentCtrl.$inject = ['$translate', 'profileService'];function reviewAssignmentCtrl($translate, profileService) {

  this.$onChanges = function(changes) {
    if (changes.weeks || changes.trainingSessions || changes.exercises) {
      this.trainingPlanSessions = generateTrainingPlanSessions(this.trainingSessions, this.exercises, this.weeks);
    }
  };

  this.goToTab = function(newTab) {
    this.onTabChange({ $event: newTab });
  };

  this.saveTrainingPlan = function() {
    this.onSaveTrainingPlan();
  };

  this.save = function() {
    this.onSave();
  };

  this.showPDF = function() {
    this.onPdfRequest();
  };

  this.toggleWeek = function(idx) {
    this.trainingPlanSessions[idx].expanded = !this.trainingPlanSessions[idx].expanded;
  };

  this.toggleSessionInWeek = function(weekIdx, sessionIdx) {
    this.trainingPlanSessions[weekIdx].sessions[sessionIdx].expanded = !this.trainingPlanSessions[weekIdx].sessions[sessionIdx].expanded;
  };

  function generateTrainingPlanSessions(sessions, exercises, weeks) {
    var arr = [];
    _.range(0, weeks).forEach(function(weekIdx) {
      arr.push({
        weekIdx: weekIdx,
        weekName: $translate.instant('WEEK_N', { n: (weekIdx + 1) }),
        expanded: false,
        sessions: _makePlanSessionsObj(sessions, exercises, weekIdx * sessions.length)
      });
      arr[arr.length - 1].weekSubtitle = _makeWeekSubtitle(arr[arr.length - 1].sessions);
    });
    return arr;
  }

  function _makePlanSessionsObj(sessions, exercises, startCount) {
    return sessions.map(function(item, idx) {
      return {
        sessionNum: idx + startCount,
        expanded: false,
        title: $translate.instant('TRAINING_SESSION_N', { n: (idx + startCount + 1) }) + ': ' + item.name,
        exercises: exercises[idx]
      };
    });
  }

  function _makeWeekSubtitle(sessions) {
    if (sessions.length === 1) {
      return '(' + $translate.instant('TRAINING_SESSION_N', { n: (sessions[0].sessionNum + 1) }) + ')';
    }
    var range = (sessions[0].sessionNum + 1) + ' - ' + (sessions[sessions.length - 1].sessionNum + 1);
    return '(' + $translate.instant('TRAINING_SESSION_RANGE', { n: range }) + ')';
  }

  this.formatTrainingProgramDate = function(startDate) {
    return moment(startDate).format(profileService.user.settings.dateFormat);
  };

  this.trainingProgramRepeatsString = function() {
    if (this.weeks === 1) {
      return $translate.instant('TRAINING_SESSION_ONE_TIME');
    }
    return $translate.instant('TRAINING_SESSION_N_TIMES', { n: this.weeks });
  };
}

angular.module('ptCrm')
  .component('reviewSave', {
    templateUrl: '/app/components/assignment-workflow/review-save/review-save.html',
    controller: reviewAssignmentCtrl,
    controllerAs: 'reviewAssignmentCtrl',
    bindings: {
      type: '<',
      name: '<',
      startDate: '<',
      endDate: '<',
      weeks: '<',
      clients: '<',
      trainingSessions: '<',
      exercises: '<',
      onTabChange: '&',
      onSaveTrainingPlan: '&',
      onSave: '&',
      saveTrainingPlanLoading: '<',
      trainingPlanLoading: '<',
      onPdfRequest: '&'
    }
  });

selectTimeController.$inject = ['$scope', 'popup', '$translate'];function selectTimeController($scope, popup, $translate) {
  this.$onChanges = function(changes) {
    if (changes.startDate) {
      this._handleVariableChange(changes.startDate, 'startDateInternal', moment().startOf('day'), this.onStartDateChange);
    }
    if (changes.endDate) {
      this._handleVariableChange(changes.endDate, 'endDateInternal', moment().endOf('day'), this.onEndDateChange);
    }
    if (changes.trainingSessions) {
      this._handleVariableChange(changes.trainingSessions, 'trainingSessionsInternal', [{ idx: 0, name: '' }], this.onTrainingSessionsChange);
    }
    if (changes.weeks) {
      this._handleVariableChange(changes.weeks, 'weeksInternal', 1, this.onWeeksChange);
    }
    if (changes.name) {
      this._handleVariableChange(changes.name, 'nameInternal', '', this.onNameChange);
    }
  };

  this.weeksOptions = _.range(1, 53);

  this.goToTab = function(newTab) {
    if (newTab === 'sessionSetup') {
      if (this.canGoToExerciseTab()) {
        this.onTabChange({ $event: newTab });
      } else {
        popup.alert({
          title: $translate.instant('INFORMATION_REQUIRED'),
          description: $translate.instant('NEED_SESSIONS')
            + (this.type === 'trainingPlanTemplate' ? '\n' + $translate.instant('NEED_ASSIGNMENT_TITLE') : '')
        });
      }
    } else {
      this.onTabChange({ $event: newTab });
    }
  };

  this.trainingTitle = function(index) {
    return 'Enter Training Session ' + index + ' Title';
  };

  this.setTrainingSessions = function() {
    this.onTrainingSessionsChange({ $event: this.trainingSessionsInternal });
  };

  this.addTrainingSession = function() {
    if (this.trainingSessionsInternal.length <= 20) {
      var newObj = { idx: _.clone(this.trainingSessionsInternal.length), name: '' };
      this.trainingSessionsInternal.push(newObj);
      this.onTrainingSessionsChange({ $event: this.trainingSessionsInternal });
    }
  };

  this.deleteTrainingSession = function(index) {
    var clone = _.cloneDeep(this.trainingSessionsInternal);
    clone.splice(index, 1);
    this.onTrainingSessionsChange({ $event: clone });
  };

  this.setWeeks = function() {
    this.onWeeksChange({ $event: this.weeksInternal });
  };

  this.setName = function() {
    this.onNameChange({ $event: this.nameInternal });
  };

  this.handleStartDateChange = function(newStartDate) {
    this.onStartDateChange({ $event: newStartDate });
  };

  this.handleEndDateChange = function(newEndDate) {
    this.onEndDateChange({ $event: newEndDate });
  };

  this.canGoToExerciseTab = function() {
    var retVal = this.weeks && this.trainingSessionsInternal && this.trainingSessionsInternal.length
      && _.every(this.trainingSessionsInternal, function(title) {
        return title.name.length > 0;
      });

    if (this.type !== 'trainingPlanTemplate') {
      retVal = retVal && this.startDateInternal;
    } else {
      // need name for 'trainingPlanTemplate' type
      retVal = retVal && this.nameInternal && this.nameInternal.length;
    }

    return retVal;
  };

  this._handleVariableChange = function(change, stateVar, defaultVal, callback) {
    if (change.currentValue) {
      this[stateVar] = angular.copy(change.currentValue);
    }
    if (!change.currentValue && !this[stateVar]) {
      callback({ $event: defaultVal });
    }
  };
}


angular.module('ptCrm')
  .component('selectTimeFrame', {
    templateUrl: '/app/components/assignment-workflow/select-time-frame/select-time-frame.html',
    controller: selectTimeController,
    controllerAs: 'selectTimeCtrl',
    bindings: {
      onTabChange: '&',
      startDate: '<',
      endDate: '<',
      trainingSessions: '<',
      weeks: '<',
      onStartDateChange: '&',
      onEndDateChange: '&',
      onTrainingSessionsChange: '&',
      onWeeksChange: '&',
      type: '<',
      disableTimeChanges: '<',
      name: '<',
      onNameChange: '&',
      isEdit: '<'
    }
  });

sessionSetupCustomizeController.$inject = ['$scope', 'exercisesService', 'exercisersService', 'trainingSetService', 'popup', '$translate'];function sessionSetupCustomizeController($scope, exercisesService, exercisersService, trainingSetService, popup, $translate) {
  var vm = this;
  vm.exercises = exercisesService.getTemplatesPaginateList({}, exercisersService.extendExercises);
  vm.trainingSets = trainingSetService.getTrainingSetsPaginateList({ withExercises: true });
  vm.trainingSets.load();
  vm.exercises.label = 'EXERCISES';
  vm.trainingSets.label = 'TRAINING_SETS';
  vm.selectedSessionIndex = 0;
  vm.activeExerciseIndex = 0;
  vm.isEditMode = false; 

  vm.goToTab = function(newTab) {
    if (newTab === 'reviewSave') {
      if (vm.canGoToReviewTab()) {
        this.onTabChange({ $event: newTab });
      } else {
        popup.alert({
          title: $translate.instant('INFORMATION_REQUIRED'),
          description: $translate.instant('NEED_SESSION_EXERCISES')
        });
      }
    } else {
      this.onTabChange({ $event: newTab });
    }
  };

  this.$onChanges = function(changes) {
    if (changes.trainingPlanExercises) {
      this._handleVariableChange(
        changes.trainingPlanExercises,
        'trainingPlanExercisesInternal',
        createDefaultExerciseArray(vm.trainingSessions.length),
        this.onTrainingPlansExerciseChange
      );
    }
  };

  $scope.$watch(function() {
    return $scope.sessionSetupCustomizeCtrl.trainingPlanExercisesInternal;
  }, function(newVal, oldVal) {
    $scope.sessionSetupCustomizeCtrl.onTrainingPlansExerciseChange({ $event: newVal });
  }, true);


  vm.update = function(session) {
    vm.activeExerciseIndex = 0;
    vm.selectedSessionIndex = vm.trainingSessions.indexOf(session);
    vm.isEditMode = false;
  };

  vm._handleVariableChange = function(change, stateVar, defaultVal, callback) {
    if (change.currentValue) {
      this[stateVar] = angular.copy(change.currentValue);
    }
    if (!change.currentValue && !this[stateVar]) {
      callback({ $event: defaultVal });
    }
  };

  function createDefaultExerciseArray(length) {
    var arr = [],
      i;
    for (i = 0; i < length; i++) {
      arr.push([]);
    }
    return arr;
  }

  vm.getExercisesParams = function() {
    return {
      clientId: ''
    };
  };

  vm.getExerciseLoadParams = function() {
    return {
      responseExtract: exercisesService.extendExercises
    };
  };

  vm.setActiveExerciseIndex = function(newIndex) {
    vm.activeExerciseIndex = newIndex;
  };

  vm.handleExerciseUpdate = function(updatedExercise) {
    if (updatedExercise !== undefined) {
      vm.trainingPlanExercisesInternal[vm.selectedSessionIndex][vm.activeExerciseIndex] = updatedExercise;
    }
  };

  vm.customizeExercise = function() {
    if (!vm.isEditMode) {
      vm.activeExerciseIndex = 0;
      vm.isEditMode = true;
    }
  };

  vm.pickExercise = function() {
    if (vm.isEditMode) {
      vm.isEditMode = false;
    }
  };

  vm.isAnyExerciseSelected = function() {
    return vm.trainingPlanExercisesInternal && vm.trainingPlanExercisesInternal[vm.selectedSessionIndex].length === 0;
  };

  vm.canGoToReviewTab = function() {
    return _.every(vm.trainingPlanExercisesInternal, function(exerciseArray) {
      return exerciseArray.length > 0;
    });
  };
}

angular.module('ptCrm')
  .component('sessionSetupCustomize', {
    templateUrl: '/app/components/assignment-workflow/session-setup-customize/session-setup-customize.html',
    controller: sessionSetupCustomizeController,
    controllerAs: 'sessionSetupCustomizeCtrl',
    bindings: {
      onTabChange: '&',
      trainingPlanExercises: '<',
      trainingSessions: '<',
      onTrainingPlansExerciseChange: '&',
      type: '<'
    }
  });

datepickerController.$inject = ['$scope'];function datepickerController($scope) {
  var vm = this;

  vm.$onChanges = function(changes) {
    if (changes.startDate) {
      vm._handleVariableChange(changes.startDate, 'startDateInternal', moment().startOf('day'), vm.onStartDateChange);
    }
    if (changes.endDate) {
      vm._handleVariableChange(changes.endDate, 'endDateInternal', moment().endOf('day'), vm.onEndDateChange);
    }
  };

  $scope.$watch(function() {
    return vm.startDateInternal;
  }, function(newValue, oldValue) {
    if (newValue && oldValue && newValue.diff(oldValue) !== 0) {
      vm.onStartDateChange({ $event: newValue });
    }
  });

  $scope.$watch(function() {
    return vm.endDateInternal;
  }, function(newValue, oldValue) {
    if (newValue && oldValue && newValue.diff(oldValue) !== 0) {
      vm.onEndDateChange({ $event: newValue });
    }
  });

  vm._handleVariableChange = function(change, stateVar, defaultVal, callback) {
    if (change.currentValue) {
      vm[stateVar] = angular.copy(change.currentValue);
    }
    if (!change.currentValue && !vm[stateVar]) {
      callback({ $event: defaultVal });
    }
  };
}

angular.module('ptCrm').component('scrollingDatepickerComponent', {
  templateUrl: '/app/components/scrolling-datepicker-component/scrolling-datepicker.html',
  controller: datepickerController,
  controllerAs: 'datepickerCtrl',
  bindings: {
    startDate: '<',
    endDate: '<',
    singleDay: '<',
    includeFacilityAssignments: '<',
    disabled: '<',
    onStartDateChange: '&',
    onEndDateChange: '&',
    depth: '<'
  }
});angular.module('ptCrm')
  .constant('sprint8constant', {
    // used by customize-exercise
    INVALID_SET_LEVEL_FALLBACK_VALUE: 2,
    INVALID_DEFAULT_LEVEL_FALLBACK_VALUE: 4,
    SPRINT8_CARDIO_PROGRAM_ID: 18,
    // used by sprint8-exercise-level
    LVL_CATEGORIES: {
      B: { color: '#e04e2d', fullName: 'BEGINNER', lvls: [1, 2, 3, 4, 5] },
      I: { color: '#009abd', fullName: 'INTERMEDIATE', lvls: [6, 7, 8, 9, 10] },
      A: { color: '#cfcf2b', fullName: 'ADVANCED', lvls: [11, 12, 13, 14, 15] },
      E: { color: '#ff9f19', fullName: 'ELITE', lvls: [16, 17, 18, 19, 20] }
    },
    LEGEND_COLORS: [
      'rgba(201, 207, 55, 1.0 )',
      'rgba(255, 158, 23, 1.0 )',
      'rgba(108, 185, 55, 1.0 )',
      'rgba(102, 182, 207, 1.0 )'
    ],
    // used by sprint8-exercice-helper.service -> mostly consumed by sprint8-exercise-level-chart
    MIN_LEVEL: 1,
    MAX_LEVEL: 20,
    DEFAULT_UNIT: 'LVL',
    DEFAULT_LARGEST_DATA_POINT: 20,
    CHART_BACKGROUND_COLORS: ['rgba(201, 207, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(108, 185, 55, 1.0)', 'rgba(255, 158, 23, 1.0)', 'rgba(102, 182, 207, 1.0)'],
    CHART_LABELS: ['3:00', '0:30', '1:30', '0:30', '1:30', '0:30', '1:30', '0:30', '1:30', '0:30', '1:30', '0:30', '1:30', '0:30', '1:30', '0:30', '2:30'],
    MASTER_CHART_DATA: {
      Treadmill: {
        levels: [
          { intervalData: [0.5, 3.2, 1.5, 3.2, 1.5, 3.5, 1.5, 3.5, 1.5, 3.7, 1.5, 3.7, 1.5, 3.7, 1.5, 3.7, 1.5], sprintIntervalTxt: ['3.2-3.7', '3.0'], activeRecoverTxt: ['1.5', '0.0'] },
          { intervalData: [0.5, 3.7, 1.5, 3.7, 1.5, 4, 1.5, 4, 1.5, 4.2, 1.5, 4.2, 1.5, 4.2, 1.5, 4.2, 1.5], sprintIntervalTxt: ['3.7-4.2', '3.0'], activeRecoverTxt: ['1.5', '0.0'] },
          { intervalData: [0.5, 4.2, 1.5, 4.2, 1.5, 4.4, 1.5, 4.4, 1.5, 4.6, 1.5, 4.6, 1.5, 4.6, 1.5, 4.6, 1.5], sprintIntervalTxt: ['4.2-4.6', '3.0'], activeRecoverTxt: ['1.5', '0.0'] },
          { intervalData: [0.5, 4.6, 1.5, 4.6, 1.5, 4.8, 1.5, 4.8, 1.5, 5, 1.5, 5, 1.5, 5, 1.5, 5, 1.5], sprintIntervalTxt: ['4.6-5', '3.0'], activeRecoverTxt: ['1.5', '0.0'] },
          { intervalData: [0.5, 4.9, 1.5, 4.9, 1.5, 5.1, 1.5, 5.1, 1.5, 5.3, 1.5, 5.3, 1.5, 5.3, 1.5, 5.3, 1.5], sprintIntervalTxt: ['4.9-5.3', '3.0'], activeRecoverTxt: ['1.5', '0.0'] },
          { intervalData: [0.5, 5, 2, 5, 2, 5.2, 2, 5.2, 2, 5.5, 2, 5.5, 2, 5.5, 2, 5.5, 2], sprintIntervalTxt: ['5-5.5', '4.0'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [0.5, 5.3, 2, 5.3, 2, 5.5, 2, 5.5, 2, 5.8, 2, 5.8, 2, 5.8, 2, 5.8, 2], sprintIntervalTxt: ['5.3-5.8', '4.0'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [0.5, 5.8, 2, 5.8, 2, 6, 2, 6, 2, 6.3, 2, 6.3, 2, 6.3, 2, 6.3, 2], sprintIntervalTxt: ['5.8-6.3', '4.0'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [0.5, 6, 2, 6, 2, 6.3, 2, 6.3, 2, 6.5, 2, 6.5, 2, 6.5, 2, 6.5, 2], sprintIntervalTxt: ['6-6.5', '4.0'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [0.5, 6.5, 2, 6.5, 2, 6.7, 2, 6.7, 2, 7, 2, 7, 2, 7, 2, 7, 2], sprintIntervalTxt: ['6.5-7', '4.0'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [0.5, 7, 2.5, 7, 2.5, 7.2, 2.5, 7.2, 2.5, 7.5, 2.5, 7.5, 2.5, 7.5, 2.5, 7.5, 2.5], sprintIntervalTxt: ['7-7.5', '5.0'], activeRecoverTxt: ['2.5', '0.0'] },
          { intervalData: [0.5, 7.5, 2.5, 7.5, 2.5, 7.7, 2.5, 7.7, 2.5, 8, 2.5, 8, 2.5, 8, 2.5, 8, 2.5], sprintIntervalTxt: ['7.5-8', '5.0'], activeRecoverTxt: ['2.5', '0.0'] },
          { intervalData: [0.5, 8, 2.5, 8, 2.5, 8.2, 2.5, 8.2, 2.5, 8.5, 2.5, 8.5, 2.5, 8.5, 2.5, 8.5, 2.5], sprintIntervalTxt: ['8-8.5', '5.0'], activeRecoverTxt: ['2.5', '0.0'] },
          { intervalData: [0.5, 8.5, 2.5, 8.5, 2.5, 8.7, 2.5, 8.7, 2.5, 9, 2.5, 9, 2.5, 9, 2.5, 9, 2.5], sprintIntervalTxt: ['8.5-9', '5.0'], activeRecoverTxt: ['2.5', '0.0'] },
          { intervalData: [0.5, 9, 2.5, 9, 2.5, 9.2, 2.5, 9.2, 2.5, 9.5, 2.5, 9.5, 2.5, 9.5, 2.5, 9.5, 2.5], sprintIntervalTxt: ['9-9.5', '5.0'], activeRecoverTxt: ['2.5', '0.0'] },
          { intervalData: [0.5, 9.5, 3, 9.5, 3, 9.7, 3, 9.7, 3, 10, 3, 10, 3, 10, 3, 10, 3], sprintIntervalTxt: ['9.5-10', '6.0'], activeRecoverTxt: ['3', '1.0'] },
          { intervalData: [0.5, 10, 3, 10, 3, 10.2, 3, 10.2, 3, 10.5, 3, 10.5, 3, 10.5, 3, 10.5, 3], sprintIntervalTxt: ['10-10.5', '6.0'], activeRecoverTxt: ['3', '1.0'] },
          { intervalData: [0.5, 10.5, 3, 10.5, 3, 10.7, 3, 10.7, 3, 11, 3, 11, 3, 11, 3, 11, 3], sprintIntervalTxt: ['10.5-11', '6.0'], activeRecoverTxt: ['3', '1.0'] },
          { intervalData: [0.5, 11, 3, 11, 3, 11.2, 3, 11.2, 3, 11.5, 3, 11.5, 3, 11.5, 3, 11.5, 3], sprintIntervalTxt: ['11-11.5', '6.0'], activeRecoverTxt: ['3', '2.0'] },
          { intervalData: [0.5, 11.5, 6, 11.5, 6, 11.7, 6, 11.7, 6, 12, 6, 12, 6, 12, 6, 12, 6], sprintIntervalTxt: ['11.5-12', '6.0'], activeRecoverTxt: ['6', '2.0'] }
        ],
        sprintIntervalTranslation0: 'N_MPH',
        sprintIntervalTranslation1: 'PCT_INCLINE',
        unit: 'MPH',
        maxValue: 12
      },
      Bike: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10'], activeRecoverTxt: ['1'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20'], activeRecoverTxt: ['2'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25'], activeRecoverTxt: ['3'] }
        ],
        sprintIntervalTranslation0: 'N_LVL',
        unit: 'LVL',
        maxValue: 25
      },
      Elliptical: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10'], activeRecoverTxt: ['1'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20'], activeRecoverTxt: ['2'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25'], activeRecoverTxt: ['3'] }
        ],
        sprintIntervalTranslation0: 'N_LVL',
        unit: 'LVL',
        maxValue: 25
      },
      Arc_Trainer: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25', '60'], activeRecoverTxt: ['3', '0.0'] }
        ],
        sprintIntervalTranslation0: 'N_LVL',
        sprintIntervalTranslation1: 'PCT_INCLINE',
        unit: 'LVL',
        maxValue: 25
      }
    },
    MASTER_CHART_DATA_METRIC: {
      Treadmill: {
        levels: [
          { intervalData: [0.8, 5.1, 2.4, 5.1, 2.4, 5.6, 2.4, 5.6, 2.4, 6, 2.4, 6, 2.4, 6, 2.4, 6, 2.4], sprintIntervalTxt: ['5.1-6 KM', '3.0'], activeRecoverTxt: ['2.4 KM', '0.0'] },
          { intervalData: [0.8, 6, 2.4, 6, 2.4, 6.4, 2.4, 6.4, 2.4, 6.8, 2.4, 6.8, 2.4, 6.8, 2.4, 6.8, 2.4], sprintIntervalTxt: ['6-6.8 KM', '3.0'], activeRecoverTxt: ['2.4 KM', '0.0'] },
          { intervalData: [0.8, 6.8, 2.4, 6.8, 2.4, 7.1, 2.4, 7.1, 2.4, 7.4, 2.4, 7.4, 2.4, 7.4, 2.4, 7.4, 2.4], sprintIntervalTxt: ['6.8-7.4 KM', '3.0'], activeRecoverTxt: ['2.4 KM', '0.0'] },
          { intervalData: [0.8, 7.4, 2.4, 7.4, 2.4, 7.7, 2.4, 7.7, 2.4, 8, 2.4, 8, 2.4, 8, 2.4, 8, 2.4], sprintIntervalTxt: ['7.4-8 KM', '3.0'], activeRecoverTxt: ['2.4 KM', '0.0'] },
          { intervalData: [0.8, 7.9, 2.4, 7.9, 2.4, 8.2, 2.4, 8.2, 2.4, 8.5, 2.4, 8.5, 2.4, 8.5, 2.4, 8.5, 2.4], sprintIntervalTxt: ['7.9-8.5 KM', '3.0'], activeRecoverTxt: ['2.4 KM', '0.0'] },
          { intervalData: [0.8, 8, 3.2, 8, 3.2, 8.4, 3.2, 8.4, 3.2, 8.9, 3.2, 8.9, 3.2, 8.9, 3.2, 8.9, 3.2], sprintIntervalTxt: ['8-8.9 KM', '4.0'], activeRecoverTxt: ['3.2 KM', '0.0'] },
          { intervalData: [0.8, 8.5, 3.2, 8.5, 3.2, 8.9, 3.2, 8.9, 3.2, 9.3, 3.2, 9.3, 3.2, 9.3, 3.2, 9.3, 3.2], sprintIntervalTxt: ['8.5-9.3 KM', '4.0'], activeRecoverTxt: ['3.2 KM', '0.0'] },
          { intervalData: [0.8, 9.3, 3.2, 9.3, 3.2, 9.7, 3.2, 9.7, 3.2, 10.1, 3.2, 10.1, 3.2, 10.1, 3.2, 10.1, 3.2], sprintIntervalTxt: ['9.3-10.1 KM', '4.0'], activeRecoverTxt: ['3.2 KM', '0.0'] },
          { intervalData: [0.8, 9.7, 3.2, 9.7, 3.2, 10.1, 3.2, 10.1, 3.2, 10.5, 3.2, 10.5, 3.2, 10.5, 3.2, 10.5, 3.2], sprintIntervalTxt: ['9.7-10.5 KM', '4.0'], activeRecoverTxt: ['3.2 KM', '0.0'] },
          { intervalData: [0.8, 10.5, 3.2, 10.5, 3.2, 10.8, 3.2, 10.8, 3.2, 11.3, 3.2, 11.3, 3.2, 11.3, 3.2, 11.3, 3.2], sprintIntervalTxt: ['10.5-11.3 KM', '4.0'], activeRecoverTxt: ['3.2 KM', '0.0'] },
          { intervalData: [0.8, 11.3, 4, 11.3, 4, 11.6, 4, 11.6, 4, 12.1, 4, 12.1, 4, 12.1, 4, 12.1, 4], sprintIntervalTxt: ['11.3-12.1 KM', '5.0'], activeRecoverTxt: ['4 KM', '0.0'] },
          { intervalData: [0.8, 12.1, 4, 12.1, 4, 12.4, 4, 12.4, 4, 12.9, 4, 12.9, 4, 12.9, 4, 12.9, 4], sprintIntervalTxt: ['12.1-12.9 KM', '5.0'], activeRecoverTxt: ['4 KM', '0.0'] },
          { intervalData: [0.8, 12.9, 4, 12.9, 4, 13.2, 4, 13.2, 4, 13.7, 4, 13.7, 4, 13.7, 4, 13.7, 4], sprintIntervalTxt: ['12.9-13.7 KM', '5.0'], activeRecoverTxt: ['4 KM', '0.0'] },
          { intervalData: [0.8, 13.7, 4, 13.7, 4, 14, 4, 14, 4, 14.5, 4, 14.5, 4, 14.5, 4, 14.5, 4], sprintIntervalTxt: ['13.7-14.5 KM', '5.0'], activeRecoverTxt: ['4 KM', '0.0'] },
          { intervalData: [0.8, 14.5, 4, 14.5, 4, 14.8, 4, 14.8, 4, 15.3, 4, 15.3, 4, 15.3, 4, 15.3, 4], sprintIntervalTxt: ['14.5-15.3 KM', '5.0'], activeRecoverTxt: ['4 KM', '0.0'] },
          { intervalData: [0.8, 15.3, 4.8, 15.3, 4.8, 15.6, 4.8, 15.6, 4.8, 16.1, 4.8, 16.1, 4.8, 16.1, 4.8, 16.1, 4.8], sprintIntervalTxt: ['15.3-16.1 KM', '6.0'], activeRecoverTxt: ['4.8 KM', '1.0'] },
          { intervalData: [0.8, 16.1, 4.8, 16.1, 4.8, 16.4, 4.8, 16.4, 4.8, 16.9, 4.8, 16.9, 4.8, 16.9, 4.8, 16.9, 4.8], sprintIntervalTxt: ['16.1-16.9 KM', '6.0'], activeRecoverTxt: ['4.8 KM', '1.0'] },
          { intervalData: [0.8, 16.9, 4.8, 16.9, 4.8, 17.2, 4.8, 17.2, 4.8, 17.7, 4.8, 17.7, 4.8, 17.7, 4.8, 17.7, 4.8], sprintIntervalTxt: ['16.9-17.7 KM', '6.0'], activeRecoverTxt: ['4.8 KM', '1.0'] },
          { intervalData: [0.8, 17.7, 4.8, 17.7, 4.8, 18, 4.8, 18, 4.8, 18.5, 4.8, 18.5, 4.8, 18.5, 4.8, 18.5, 4.8], sprintIntervalTxt: ['17.7-18.5 KM', '6.0'], activeRecoverTxt: ['4.8 KM', '2.0'] },
          { intervalData: [0.8, 18.5, 9.7, 18.5, 9.7, 18.8, 9.7, 18.8, 9.7, 19.3, 9.7, 19.3, 9.7, 19.3, 9.7, 19.3, 9.7], sprintIntervalTxt: ['18.5-19.3 KM', '6.0'], activeRecoverTxt: ['9.7 KM', '2.0'] }
        ],
        sprintIntervalTranslation0: 'N_KM',
        sprintIntervalTranslation1: 'PCT_INCLINE',
        unit: 'KM',
        maxValue: 19.3
      },
      Bike: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10'], activeRecoverTxt: ['1'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20'], activeRecoverTxt: ['2'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25'], activeRecoverTxt: ['3'] }
        ],
        sprintIntervalTranslation0: 'N_LVL',
        unit: 'LVL',
        maxValue: 25
      },
      Elliptical: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9'], activeRecoverTxt: ['1'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10'], activeRecoverTxt: ['1'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19'], activeRecoverTxt: ['2'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20'], activeRecoverTxt: ['2'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24'], activeRecoverTxt: ['3'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25'], activeRecoverTxt: ['3'] }
        ],
        unit: 'LVL',
        sprintIntervalTranslation0: 'N_LVL',
        maxValue: 25
      },
      Arc_Trainer: {
        levels: [
          { intervalData: [1, 3, 1, 3, 1, 4, 1, 4, 1, 6, 1, 6, 1, 6, 1, 6, 1], sprintIntervalTxt: ['3-6', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 4, 1, 4, 1, 5, 1, 5, 1, 7, 1, 7, 1, 7, 1, 7, 1], sprintIntervalTxt: ['4-7', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 5, 1, 5, 1, 6, 1, 6, 1, 8, 1, 8, 1, 8, 1, 8, 1], sprintIntervalTxt: ['5-8', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 6, 1, 6, 1, 7, 1, 7, 1, 9, 1, 9, 1, 9, 1, 9, 1], sprintIntervalTxt: ['6-9', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [1, 7, 1, 7, 1, 8, 1, 8, 1, 10, 1, 10, 1, 10, 1, 10, 1], sprintIntervalTxt: ['7-10', '30'], activeRecoverTxt: ['1', '0.0'] },
          { intervalData: [2, 8, 2, 8, 2, 9, 2, 9, 2, 11, 2, 11, 2, 11, 2, 11, 2], sprintIntervalTxt: ['8-11', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 9, 2, 9, 2, 10, 2, 10, 2, 12, 2, 12, 2, 12, 2, 12, 2], sprintIntervalTxt: ['9-12', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 10, 2, 10, 2, 11, 2, 11, 2, 13, 2, 13, 2, 13, 2, 13, 2], sprintIntervalTxt: ['10-13', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 11, 2, 11, 2, 12, 2, 12, 2, 14, 2, 14, 2, 14, 2, 14, 2], sprintIntervalTxt: ['11-14', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 12, 2, 12, 2, 13, 2, 13, 2, 15, 2, 15, 2, 15, 2, 15, 2], sprintIntervalTxt: ['12-15', '40'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 13, 2, 13, 2, 14, 2, 14, 2, 16, 2, 16, 2, 16, 2, 16, 2], sprintIntervalTxt: ['13-16', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 14, 2, 14, 2, 15, 2, 15, 2, 17, 2, 17, 2, 17, 2, 17, 2], sprintIntervalTxt: ['14-17', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 15, 2, 15, 2, 16, 2, 16, 2, 18, 2, 18, 2, 18, 2, 18, 2], sprintIntervalTxt: ['15-18', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 16, 2, 16, 2, 17, 2, 17, 2, 19, 2, 19, 2, 19, 2, 19, 2], sprintIntervalTxt: ['16-19', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [2, 17, 2, 17, 2, 18, 2, 18, 2, 20, 2, 20, 2, 20, 2, 20, 2], sprintIntervalTxt: ['17-20', '50'], activeRecoverTxt: ['2', '0.0'] },
          { intervalData: [3, 18, 3, 18, 3, 19, 3, 19, 3, 21, 3, 21, 3, 21, 3, 21, 3], sprintIntervalTxt: ['18-21', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 19, 3, 19, 3, 20, 3, 20, 3, 22, 3, 22, 3, 22, 3, 22, 3], sprintIntervalTxt: ['19-22', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 20, 3, 20, 3, 21, 3, 21, 3, 23, 3, 23, 3, 23, 3, 23, 3], sprintIntervalTxt: ['20-23', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 21, 3, 21, 3, 22, 3, 22, 3, 24, 3, 24, 3, 24, 3, 24, 3], sprintIntervalTxt: ['21-24', '60'], activeRecoverTxt: ['3', '0.0'] },
          { intervalData: [3, 22, 3, 22, 3, 23, 3, 23, 3, 25, 3, 25, 3, 25, 3, 25, 3], sprintIntervalTxt: ['22-25', '60'], activeRecoverTxt: ['3', '0.0'] }
        ],
        sprintIntervalTranslation0: 'N_LVL',
        sprintIntervalTranslation1: 'PCT_INCLINE',
        unit: 'LVL',
        maxValue: 25
      }
    }
  });
/* eslint-disable one-var */
TimepickerController.$inject = ['profileService', '$element', '$scope', '$document', 'assignmentsService', 'workInfoService'];
function TimepickerController(profileService, $element, $scope, $document, assignmentsService, workInfoService) {
  var vm = this,
    timeFormat = profileService.user.settings.timeFormat || 12,
    events = {},
    clientsContainer = angular.element($element[0].querySelector('.timepicker-container-right')),
    clients = angular.element($element[0].querySelector('.timepicker-container-right-client')),
    upperLimit = 24,
    startX = 0,
    startY = 0,
    x = 0,
    y = 0,
    to,
    from;

  vm.allDaySet = false; // todo: set automatically

  if ('ontouchstart' in window) {
    events.moveStart = 'touchstart';
    events.move = 'touchmove';
    events.moveEnd = 'touchend';
  } else {
    events.moveStart = 'mousedown';
    events.move = 'mousemove';
    events.moveEnd = 'mouseup';
  }

  vm.$onInit = function() {
    vm.timeRanges = _makeTimeRanges();
    vm.titles = vm.timeRanges.filter(function(item, idx) { return idx % 2 === 0; });
    vm.selectedClientsInternal = assignmentsService.prepareSelectedClients(vm.selectedClients);
    vm.allDaySet = vm.timeframe ? _.isEqual(vm.timeframe, [0, 86399]): false;

    if (vm.selectedTrainer) {
      _handleTrainerChange();
    }

    if (vm.timeframe) {
      _handleRangeChange();
    }

    clientsContainer.on('mousedown', _onRangeSelect);
    clients.on('mousedown', function(event) {
      event.stopPropagation();
    });
  };

  vm.$onChanges = function(changes) {
    if (changes.timerange && changes.timerange.currentValue) {
      _handleRangeChange();
    }

    if (changes.selectedTrainer && changes.selectedTrainer.currentValue) {
      _handleTrainerChange();
    }

    if (changes.startDate && changes.startDate.currentValue) {
      if (vm.selectedTrainer && vm.trainerWorkInfo) {
        vm.timeAvailabilities = _checkForTrainerAvailability();
      }
    }

    if (changes.selectedClients && changes.selectedTrainer.currentValue) {
      vm.selectedClientsInternal = assignmentsService.prepareSelectedClients(vm.selectedClients);
    }
  };

  vm.generateStyle = function(client) {
    return {
      top: client.timeFrom * 100 + 10 + 'px',
      height: (client.timeTo - client.timeFrom) * 100 + 'px'
    };
  };

  vm.setAllDay = function() {
    vm.allDaySet = true;

    vm.onTimeframeChange({
      $event: [0, 86399]
    });
  };

  function rangeChange() {
    if (vm.selectedClientsInternal.timeFrom === 0 && vm.selectedClientsInternal.timeTo === 24) {
      vm.setAllDay();
    } else {
      vm.onTimeframeChange({
        $event: [
          vm.selectedClientsInternal.timeFrom * 3600,
          vm.selectedClientsInternal.timeTo * 3600 - 1
        ]
      });
    }
  }

  function _handleRangeChange() {
    if (_.isEqual(vm.timeframe, [0, 86399])) {
      vm.allDaySet = true;
    } else {
      vm.selectedClientsInternal.timeFrom = Math.floor(vm.timeframe[0] / 3600);
      vm.selectedClientsInternal.timeTo = Math.floor((vm.timeframe[1] + 1) / 3600);
    }
  }

  function _handleTrainerChange() {
    workInfoService.getStaffWorkInfo(vm.selectedTrainer._id)
      .then(function(workInfo) {
        vm.trainerWorkInfo = workInfo;
        vm.timeAvailabilities = _checkForTrainerAvailability();
      });
  }

  function _onRangeSelect() {
    if (vm.allDaySet) {
      vm.allDaySet = false;
    }
    if (event.target.className.indexOf('timepicker-container-right-item') === -1) {
      return false;
    }
    event.preventDefault();
    var startEl = angular.element(event.target);
    while (!startEl.hasClass('timepicker-container-right-item')) {
      startEl = startEl.parent();
    }


    from = Array.prototype.indexOf.call(clientsContainer.children(), startEl[0]);
    to = from + 1 === upperLimit * 2 ? from + 1 : from + 2;

    vm.selectedClientsInternal.timeTo = to / 2;
    vm.selectedClientsInternal.timeFrom = from / 2;

    rangeChange();

    $scope.$apply();
    _addStretchButtonListener();
  }

  function _checkForTrainerAvailability() {
    var currentDay = vm.startDate ? moment(vm.startDate).locale('en').format('dddd').toLowerCase() : moment().locale('en').format('dddd').toLowerCase(),
      currentFacility = _convertTimeToMinutes(vm.trainerWorkInfo && vm.trainerWorkInfo.days ? vm.trainerWorkInfo.days[currentDay] : []),
      otherFacilities = _convertTimeToMinutes(vm.trainerWorkInfo && vm.trainerWorkInfo.otherFacilityHours ? vm.trainerWorkInfo.otherFacilityHours[currentDay] : []),
      tempMinutes = {},
      timeRange,
      outputTimeRange = [],
      i,
      j;

    // Iterate through the minutes of the day in 30 minute blocks.
    for (i = 0; i < 1440; i += 30) {
      timeRange = { isAvailable: false };
      // If no availability exists, make sure the whole thing is light colored (availabile colored).  This is really important.
      if (currentFacility.length === 0) {
        timeRange.isAvailable = true;
      }
      // Checks the trainers availability in other facilities.  isAvailable returns true/false if it falls in availability window
      for (j = 0; j < otherFacilities.length; j++ ) {
        tempMinutes = otherFacilities[j];
        if ((i >= tempMinutes.min && (i + 30) <= tempMinutes.max ) ||
          (i > tempMinutes.min && (i + 30) <= tempMinutes.min) ||
          (i < tempMinutes.max && (i + 30) >= tempMinutes.max) ||
          (i >= (tempMinutes.min - 15) && (i + 30) <= tempMinutes.max)
        ) {
          timeRange.isAvailable = false;

          if (i < tempMinutes.max && (i - 15) >= tempMinutes.max) {
            timeRange.isAvailable = true;
          }
        }
      }
      // Checks the trainers availability in the current facilities.  isAvailable returns true/false if it falls in availability window
      for (j = 0; j < currentFacility.length; j++ ) {
        tempMinutes = currentFacility[j];
        if ((i >= tempMinutes.min && (i + 30) <= tempMinutes.max ) ||
          (i > tempMinutes.min && (i + 30) <= tempMinutes.min) ||
          (i < tempMinutes.max && (i + 30) >= tempMinutes.max) ||
          (i >= (tempMinutes.min + 15) && (i + 30) <= tempMinutes.max)
        ) {
          timeRange.isAvailable = true;

          if (i < tempMinutes.max && (i + 15) >= tempMinutes.max) {
            timeRange.isAvailable = false;
          }
        }
      }
      outputTimeRange.push(timeRange);
    }
    return outputTimeRange;
  }

  function _convertTimeToMinutes(inputArray) {
    return inputArray.map(function(time) {
      var tempMinutes = {},
        tempFacilityRange = time.min.split(':');

      tempMinutes.min = ((+tempFacilityRange[0]) * 60) + (+tempFacilityRange[1]);
      tempFacilityRange = time.max.split(':');
      tempMinutes.max = ((+tempFacilityRange[0]) * 60) + (+tempFacilityRange[1]);
      return tempMinutes;
    });
  }

  function _makeTimeRanges() {
    var str00,
      str30,
      arr = [];
    for (var i = 0; i < 24; i++) {
      str00 = '';
      str30 = '';
      if (i % 12 === 0) {
        str00 += timeFormat === 12 ? 12 : i;
        str30 += timeFormat === 12 ? 12 : i;
      } else {
        str00 += timeFormat === 12 ? i % 12 : i;
        str30 += timeFormat === 12 ? i % 12 : i;
      }

      str00 += ':00';
      str30 += ':30';

      if (timeFormat === 12) {
        str00 += i < 12 ? ' am' : ' pm';
        str30 += i < 12 ? ' am' : ' pm';
      }

      arr.push(str00, str30);
    }
    return arr;
  }

  function _addStretchButtonListener() {
    var dragger = angular.element($element[0].querySelector('.timepicker-container-right-client-dragger'));
    dragger.on(events.moveStart, _onMoveStart);
  }

  function _onMoveStart(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!_.isUndefined(vm.selectedClientsInternal.timeFrom)) {
      from = vm.selectedClientsInternal.timeFrom * 2;
      to = vm.selectedClientsInternal.timeTo * 2;
    }
    startX = e.pageX || e.touches[0].pageX;
    startY = e.pageY || e.touches[0].pageY;

    $document.on(events.move, _move);
    $document.on(events.moveEnd, _moveEnd);
  }

  function _move() {
    var now,
      directionChanged,
      prev = 0;

    return function(event) {
      now = Date.now();
      if (now - prev > 50) {
        event.stopPropagation();
        y = (event.pageY || event.touches[0].pageY) - startY;
        x = (event.pageX || event.touches[0].pageX) - startX;

        if (y > (to - from) * (-50)) {
          vm.selectedClientsInternal.timeTo = (to + y / 50) / 2;
          if (directionChanged) {
            vm.selectedClientsInternal.timeFrom = Math.floor(to + y / 50) / 2;
            directionChanged = false;
          }
        } else {
          vm.selectedClientsInternal.timeFrom = (to + y / 50) / 2;
          vm.selectedClientsInternal.timeTo = from / 2;
          directionChanged = true;
        }
        rangeChange();
        $scope.$apply();

        prev = now;
      }
    };
  }

  function _moveEnd(event) {
    y = (event.pageY || event.changedTouches[0].pageY) - startY;
    x = (event.pageX || event.changedTouches[0].pageX) - startX;
    if (y > (to - from) * (-50)) {
      vm.selectedClientsInternal.timeTo = Math.ceil(to + y / 50) / 2;
    } else {
      vm.selectedClientsInternal.timeFrom = Math.floor(to + y / 50) / 2;
      vm.selectedClientsInternal.timeTo = from / 2;
    }
    rangeChange();
    _removeListeners();
    $scope.$apply();
  }

  function _removeListeners() {
    $document.off(events.move, _move);
    $document.off(events.moveEnd, _moveEnd);
  }
}

angular.module('ptCrm').component('timepickerComponent', {
  templateUrl: '/app/components/timepicker-component/timepicker.html',
  controller: TimepickerController,
  controllerAs: 'timepickerCtrl',
  bindings: {
    startDate: '<',
    timeframe: '<',
    selectedClients: '<',
    selectedTrainer: '<',
    onTimeframeChange: '&',
    onAllDay: '&'
  }
});
DatetimeDetailsController.$inject = ['config', 'assignmentsService'];function DatetimeDetailsController(config, assignmentsService) {
  var vm = this;
  vm.timeDurationOptions = config.assignmentDurationOptions;
  vm.recurrenceOptions = config.assignmentRecurrenceOptions;
  vm.recurrenceForm = {
    form: {}
  };
  vm.inferredRecurrenceMoments = [];
  vm.pastRecurrenceMoments = [];

  vm.$onChanges = function(changes) {
    if (changes.startDate && changes.startDate.currentValue) {
      _handleDateChange();
      _calculateRecurrences();
    }

    if (changes.endDate && changes.endDate.currentValue) {
      _handleDateChange();
      _calculateRecurrences();
    }

    if (changes.timeframe && changes.timeframe.currentValue) {
      vm.timeframeInternal = changes.timeframe.currentValue;
      _handleTimeframeChange();
      _calculateRecurrences();
    }

    if (changes.recurrence) {
      _handleVariableChange(changes.recurrence, 'recurrenceInternal', {
        recurrenceType: 'once',
        recurrenceGap: 1,
        recurrenceNumber: 1
      }, vm.onRecurrenceChange);
      _calculateRecurrences();
    }
  };

  vm.showSchedule = function() {
    vm.onShowSchedule();
  };

  vm.onDurationSelect = function(duration) {
    var clone = _.clone(vm.timeframeInternal);
    clone[1] = clone[0] + duration.asSeconds() - 1;

    vm.onTimeframeChange({ $event: clone });
  };

  vm.handleRecurrenceChange= function() {
    _calculateRecurrences();
    vm.onRecurrenceChange({ $event: vm.recurrenceInternal });
  };

  vm.disableTimeDurationOption = function(option) {
    var startHours = vm.startTime ? moment(vm.startTime).hours() : moment(vm.startDate).hours(),
      startMinutes = vm.startTime ? moment(vm.startTime).minutes() : moment(vm.startDate).minutes(),
      hoursToMidnight = 24 - (startHours + (startMinutes / 60));
    return hoursToMidnight < option.asHours();
  };

  vm.checkRecurrenceOptionValidity = function(option) {
    if (option === 'daily' && vm.isSameDay === false) {
      if (vm.recurrenceInternal && vm.recurrenceInternal.recurrenceType === 'daily') {
        _resetRecurrence();
      }
      return false;
    }
    if (option === 'weekly' && vm.endDate.diff(vm.startDate, 'days') >= 7) {
      if (vm.recurrenceInternal && vm.recurrenceInternal.recurrenceType === 'weekly') {
        _resetRecurrence();
      }
      return false;
    }
    if (option === 'monthly' && vm.endDate.diff(vm.startDate, 'days') >= 28) {
      if (vm.recurrenceInternal && vm.recurrenceInternal.recurrenceType === 'monthly') {
        _resetRecurrence();
      }
      return false;
    }
    return true;
  };

  vm.getRecurrenceUnit = assignmentsService.getRecurrenceUnit;

  function _resetRecurrence() {
    vm.recurrenceInternal.recurrenceType = 'once';
    vm.recurrenceInternal.recurrenceNumber = 1;
  }

  function _handleDateChange() {
    if (vm.startDate && vm.endDate) {
      vm.isSameDay = vm.startDate.isSame(vm.endDate, 'day');
    }
  }

  function _handleTimeframeChange() {
    if (vm.timeframeInternal && _.isNumber(vm.timeframeInternal[0]) && _.isNumber(vm.timeframeInternal[1])) {
      vm.startTime = moment(vm.startDate).add(vm.timeframeInternal[0], 'seconds');
      vm.endTime = moment(vm.startDate).add(vm.timeframeInternal[1], 'seconds');
      vm.selectedDuration = moment.duration(moment(vm.endTime).add(1, 'second').diff(moment(vm.startTime), 'minutes'), 'minutes');
    }
  }

  function _handleVariableChange(change, stateVar, defaultVal, callback) {
    if (change.currentValue) {
      vm[stateVar] = angular.copy(change.currentValue);
    }
    if (!change.currentValue && !vm[stateVar]) {
      callback({ $event: defaultVal });
    }
  }

  function _calculateRecurrences() {
    if (vm.recurrenceInternal && vm.endDate) {
      var startMoment = vm.endTime || vm.endDate;
      vm.inferredRecurrenceMoments = assignmentsService.calculateInferredRecurrences(startMoment, vm.recurrenceInternal);
      vm.pastRecurrenceMoments = _.filter(vm.inferredRecurrenceMoments, function(recurrenceMoment) {
        return recurrenceMoment.isBefore(moment());
      });

      // Make sure the recurrenceType is still valid
      if (vm.recurrenceInternal.recurrenceType !== 'once') {
        _.each(vm.recurrenceOptions, function(option) {
          vm.checkRecurrenceOptionValidity(option);
        });
      }
    } else {
      vm.inferredRecurrenceMoments = [];
      vm.pastRecurrenceMoments = [];
    }
  }
}

angular.module('ptCrm').component('datetimeDetailsComponent', {
  templateUrl: '/app/components/datetime-details-component/datetime-details.html',
  controller: DatetimeDetailsController,
  controllerAs: 'datetimeDetailsCtrl',
  bindings: {
    startDate: '<',
    endDate: '<',
    timeframe: '<',
    onTimeframeChange: '&',
    onShowSchedule: '&',
    recurrence: '<',
    onRecurrenceChange: '&',
    isEditingIndividualRecurrence: '<',
    disableRecurrence: '<'
  }
});
function workoutNameCtrl() {

  this.componentWorkoutName = '';

  this.$onChanges = function(change) {
    if (change.workoutName && change.workoutName.currentValue) {
      this.componentWorkoutName = change.workoutName.currentValue;
    }
  };

  this.textInput = function() {
    this.onNameUpdate({ $event: this.componentWorkoutName });
  };

  this.showPlaceholder = function() {
    if (this.context === 'wotd') {
      return 'ENTER_TITLE_OPTIONAL';
    } else if (this.context === 'trainingPlan') {
      return 'ENTER_TITLE';
    }
    return 'ASSIGNMENT_NAME_OPTIONAL';
  };
}

angular.module('ptCrm')
  .component('workoutName', {
    templateUrl: '/app/components/workout-name/workout-name.component.html',
    controller: workoutNameCtrl,
    controllerAs: 'workoutNameCtrl',
    bindings: {
      workoutName: '@',
      onNameUpdate: '&',
      context: '@'
    }
  });

function createExerciseDropdownCtrl() {

  this.onOptionSelect = function(item) {
    this.currentSelectedOption = _.find(this.options, {
      translated: item
    });

    this.currentSelectedOptionDisplay = this.currentSelectedOption.translated;

    this.handleDropdownChange({ $event: this.currentSelectedOption.value });
  };

  this.$onChanges = function() {
    if (this.options || this.currentSelection) {
      this.currentSelectedOption = this.currentSelection ? _.find(this.options, {
        value: this.currentSelection
      }) : null;

      this.currentSelectedOptionDisplay = this.currentSelectedOption ? this.currentSelectedOption.translated : '';

      this.displayedOptions = _.map(this.options, 'translated');
    }
  };
}

angular.module('ptCrm')
  .component('createExerciseDropdown', {
    templateUrl: '/app/components/create-exercise-dropdown/create-exercise-dropdown.component.html',
    controller: createExerciseDropdownCtrl,
    controllerAs: 'createExerciseDropdownCtrl',
    bindings: {
      title: '@',
      options: '<',
      currentSelection: '<',
      handleDropdownChange: '&'
    }
  });

metricEdit.$inject = ['config'];function metricEdit(config) {
  var vm = this;

  vm.inputMetricConfig = {
    duration: {
      type: 'time',
      precision: 0,
      maximumValue: 1000,
      minimumValue: 0,
      increment: 1
    },
    distance: {
      type: 'number',
      precision: 1,
      maximumValue: 1000,
      minimumValue: 0,
      increment: 1
    },
    calories: {
      type: 'number',
      precision: 0,
      maximumValue: 1000,
      minimumValue: 0,
      increment: 1
    },
    avgSpeed: {
      type: 'number',
      precision: 1,
      maximumValue: 100,
      minimumValue: 0,
      increment: 1
    },
    avgIncline: {
      type: 'number',
      precision: 1,
      maximumValue: 100,
      minimumValue: 0,
      increment: 1
    },
    avgResistance: {
      type: 'number',
      precision: 1,
      maximumValue: 20,
      minimumValue: 0,
      increment: 0.5
    }
  };

  vm.imagePath = config.assetBaseUrl;
  if (vm.imagePath && vm.imagePath[vm.imagePath.length -1] !== '/') {
    vm.imagePath += '/';
  }

  vm.internalProfile = {};

  vm.$onChanges = function(changes) {
    if (changes.profile.currentValue) {
      if (_.isEmpty(changes.profile.previousValue)) {
        vm.initialProfile = _.clone(changes.profile.currentValue);
      }

      vm.editable = vm.displayMetrics.filter(function(item) {
        return item.editable;
      });

      vm.editable.forEach(function(item) {
        if (!vm.profile[item.name]) {
          vm.internalProfile[item.name] = 0;
        } else {
          vm.internalProfile[item.name] = _.round(vm.profile[item.name], vm.inputMetricConfig[item.name].precision);
        }
      });
      if (_.isEmpty(changes.profile.previousValue)) {
        vm.sendUpdate();
      }
    }
  };

  vm.decrementMetric = function(prop) {
    vm.internalProfile[prop] -= vm.inputMetricConfig[prop].increment;
    vm.sendUpdate();
  };

  vm.incrementMetric = function(prop) {
    vm.internalProfile[prop] += vm.inputMetricConfig[prop].increment;
    vm.sendUpdate();
  };

  vm.manuallySetValue = function() {
    vm.sendUpdate();
  };

  vm.sendUpdate = function() {
    var toSubmit = {};

    if (vm.profile.workoutSource) {
      toSubmit.workoutSource = vm.profile.workoutSource;
    }

    _.forEach(vm.editable, function(item) {
      if (_.has(vm.internalProfile, item.name) && _.isNumber(vm.internalProfile[item.name])) {
        toSubmit[item.name] = boundValue(
          _.round(vm.internalProfile[item.name], vm.inputMetricConfig[item.name].precision),
          vm.inputMetricConfig[item.name].minimumValue,
          vm.inputMetricConfig[item.name].maximumValue
        );
      } else if (_.has(vm.internalProfile, item.name) && !_.isNumber(vm.internalProfile[item.name])) {
        toSubmit[item.name] = boundValue(
          _.round(vm.internalProfile[item.name], vm.inputMetricConfig[item.name].precision) || 0,
          vm.inputMetricConfig[item.name].minimumValue,
          vm.inputMetricConfig[item.name].maximumValue
        );
      }

      if (!_.has(vm.initialProfile, item.name) && toSubmit[item.name] === 0) {
        delete toSubmit[item.name];
      }
    });

    console.log(toSubmit);

    vm.onUpdate({ $event: toSubmit });
  };

  function boundValue(value, minimum, maximum) {
    if (value < minimum) {
      return minimum;
    } else if (value > maximum) {
      return maximum;
    }
    return value;
  }
}

angular.module('ptCrm').component('metricEdit', {
  templateUrl: '/app/components/metric-edit/metric-edit.html',
  controller: metricEdit,
  controllerAs: 'metricEditCtrl',
  bindings: {
    profile: '<', // exercise completedProfile
    displayMetrics: '<',
    onUpdate: '&' // returns updated completedProfile data
  }
});(function() {
  'use strict';

  forgotRequestCtrl.$inject = ['forgotPasswordService', '$stateParams', '$state'];
  angular.module('ptCrm')
    .controller('forgotRequestCtrl', forgotRequestCtrl);

  function forgotRequestCtrl(forgotPasswordService, $stateParams, $state) {
    var vm = this;

    vm.email = $stateParams.email;

    vm.submit = function(email) {
      forgotPasswordService.request(email)
      .then(function() {
        $state.go('^.sent', {
          email: email
        });
      })
      .catch(function(e) {
        $state.go('^.error', {
          email: email
        });
      });
    };

  }
}());
(function() {
  'use strict';

  forgotResetCtrl.$inject = ['forgotPasswordService', '$stateParams', '$state'];
  angular.module('ptCrm')
    .controller('forgotResetCtrl', forgotResetCtrl);

  function forgotResetCtrl(forgotPasswordService, $stateParams, $state) {
    var vm = this;

    vm.token = $stateParams.token;

    vm.submit = function(password) {
      forgotPasswordService.reset(vm.token, password)
      .then(function() {
        $state.go('^.success');
      })
      .catch(function(e) {
        switch (e.data.message) {
        case 'Invalid Token' :
          $state.go('^.invalid');
          break;
        case 'Expired Token' :
          $state.go('^.expired');
          break;
        default :
          $state.go('^.error');
        }
      });
    };

  }
}());
(function() {

  'use strict';

  libraryController.$inject = ['$scope', 'trainingSetService', 'exercisesService', 'savedTrainingPlanService', '$state', 'printService', 'popup', '$translate', '$window'];
  angular.module('ptCrm')
    .controller('LibraryController', libraryController);

  function libraryController($scope, trainingSetService, exercisesService, savedTrainingPlanService, $state, printService, popup, $translate, $window) {

    $window.onclick = function(event) {
      if (vm.showDropdown) {
        var isDropdownButton = event.target.classList.contains('training-library__tags-dropdown-button'),
          isTag = event.target.classList.contains('training-library__tags-dropdown-item');
        if (!isTag && !isDropdownButton) {
          vm.toggleShowDropdown();
          $scope.$apply();
        }
      }
    };

    var vm = this;
    vm.filterByName = filterByName;
    vm.filterByTag = filterByTag;

    vm.exercises = exercisesService.getTemplatesPaginateList({}, exercisesService.extendExercises);
    vm.editExercise = editExercise;
    vm.printExerciseTemplate = printExerciseTemplate;

    vm.trainingSets = trainingSetService.getTrainingSetsPaginateList();
    vm.editTrainingSet = editTrainingSet;
    vm.printTrainingSet = printTrainingSet;

    vm.trainingPlans = savedTrainingPlanService.getTrainingPlansPaginateList({});
    vm.deleteTrainingPlan = deleteTrainingPlan;
    vm.printSavedTrainingPlan = printSavedTrainingPlan;
    vm.editSavedTrainingPlan = editSavedTrainingPlan;

    vm.scope = $scope;

    vm.showTab = showTab;
    vm.getCardPermission = getCardPermission;
    vm.activeTab = '';


    vm.allExercises = exercisesService.getAllExercises({}, exercisesService.extendExercises);
    vm.allExercises.load();

    vm.setFilterTag = setFilterTag;
    vm.checkIfTabIsSelected = checkIfTabIsSelected;
    vm.removeTagFromSelectedTagList = removeTagFromSelectedTagList;

    // go through promise and assign data
    exercisesService.getAvailableExerciseTags().then(function(value) {
      vm.allTags = value.all;
      vm.buttonTags = value.atLeastOneExercise.slice(0, 5);
      vm.dropdownTags = value.atLeastOneExercise.slice(5);
    });

    vm.allTags = '';
    vm.buttonTags = '';
    vm.dropdownTags = '';
    vm.showDropdown = false;
    vm.toggleShowDropdown = toggleShowDropdown;
    vm.selectedTagList = [];

    function setFilterTag(tag) {

      if (tag === 'allExercises' ) {
        vm.selectedTagList = [];
      } else if (_.find(vm.selectedTagList, function(item) { return item._id === tag._id; })) {
        removeTagFromSelectedTagList(tag);
      } else {
        vm.selectedTagList.push(tag);
      }

      filterByTag();
    }
    function toggleShowDropdown() {
      return vm.showDropdown = !vm.showDropdown; // eslint-disable-line
    }

    function removeTagFromSelectedTagList(tagToRemove) {
      var tagIndex = _.findIndex(vm.selectedTagList, function(item) { return item._id === tagToRemove._id; });
      vm.selectedTagList.splice(tagIndex, 1);
    }

    function checkIfTabIsSelected(tag) {
      return _.findIndex(vm.selectedTagList, function(item) { return item._id === tag._id; }) > -1;
    }

    function filterByName() {
      vm.exercises
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
      vm.trainingSets
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
      vm.trainingPlans
        .extendDefaultParams({ search: vm.search })
        .load({ update: true });
    }

    function filterByTag() {
      var queryParamObject = {};
      if (vm.selectedTagList.length > 0) {
        queryParamObject.tag = _.map(vm.selectedTagList, function(tag) { return tag.tag; });
      } else {
        queryParamObject.tag = '';
      }
      if (vm.search) {
        queryParamObject.search = vm.search;
      }
      vm.exercises
        .extendDefaultParams(queryParamObject)
        .load({ update: true });

    }

    vm.filters = {
      isOpen: false,
      toggle: toggleFiltersBlock,
      select: selectFilter,
      list: _getFiltersList()
    };

    function selectFilter(filter) {
      filter._isSelected = !filter._isSelected;

      // TODO: implement
    }

    function editExercise(exercise) {
      $state.go('app.library.exercise', { id: exercise._id });
    }

    function printExerciseTemplate(item) {
      printService.printExerciseTemplate(item);
    }

    function editTrainingSet(set) {
      $state.go('app.library.set', { id: set._id });
    }

    function printTrainingSet(item) {
      printService.printTrainingSet(item);
    }

    function deleteTrainingPlan(plan) {
      // TODO: add confirmation dialog
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_TRAINING_PLAN'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_TRAINING_PLAN'),
        okText: $translate.instant('DELETE_TRAINING_PLAN')
      })
        .then(function() {
          savedTrainingPlanService.deleteTrainingPlan(plan._id)
            .then(function() {
              vm.trainingPlans
                .extendDefaultParams({ search: vm.search })
                .load({ update: true });
            });
        });
    }

    function printSavedTrainingPlan(plan) {
      printService.printSavedTrainingPlan(plan);
    }

    function editSavedTrainingPlan(plan) {
      $state.go('app.library.training_program_template', { id: plan._id });
    }

    function toggleFiltersBlock() {
      vm.filters.isOpen = !vm.filters.isOpen;
    }

    function showTab(subject) {
      vm.activeTab = subject;
    }

    function getCardPermission(card, type, action) {
      var subject = type + '_' + action,
        restricted = card.restricted ? '+RESTRICTED_FLAG_UPDATE' : '',
        chainWide = card.chainWide ? '+CHAIN_WIDE_UPDATE' : '';
      return subject + restricted + chainWide;
    }

    // TODO: integrate
    function _getFiltersList() {
      return [{
        title: 'FACILITY',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }, {
        title: 'Equipment',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill', _isSelected: true },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }, {
        title: 'EXERCISE/PROGRAM_TYPE',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' }
        ]
      }, {
        title: 'EXERCISE/PROGRAM_TYPE',
        items: [
          { title: 'ALL' },
          { title: 'Treadmill' },
          { title: 'Studio' },
          { title: 'Rolling Hills' },
          { title: 'Virtual active' },
          { title: 'Lorem Ipsum' }
        ]
      }];
    }
  }

}());
(function() {

  'use strict';
  CreateAssignmentController.$inject = ['exercisersService', 'exercisesService', 'camelToSnakeCaseFilter', 'trainingSetService', 'assignmentsService', 'profileService', '$scope', '$rootScope', '$state', 'USER_HOME_PAGE', 'popup', '$translate', '$q', '$timeout', 'config', '$filter', 'workInfoService', '$uibModal'];
  angular.module('ptCrm')
    .controller('CreateAssignmentController', CreateAssignmentController);

  function CreateAssignmentController(exercisersService, exercisesService, camelToSnakeCaseFilter, trainingSetService, assignmentsService,
    profileService, $scope, $rootScope, $state, USER_HOME_PAGE, popup, $translate, $q, $timeout, config, $filter, workInfoService, $uibModal) {

    var vm = this,

      assignmentId = $state.params.id,
      userId = $state.params.userId,
      copyFromId = $state.params.copyFrom;

    // if userId is defined it means we got singleAssignment
    // otherwise it's massAssignment
    vm.isEdit = !!assignmentId;
    vm.isCopy = !!copyFromId;
    vm.allowEditingSeries = !vm.isEdit || vm.isCopy || $state.params.editSeries;

    // we need scope for dragula directives
    vm.scope = $scope;
    vm.today = moment();
    vm.isLoading = false;
    vm.trainerDropdown = false;

    vm.clients = exercisersService.getClientPaginateList({ isAssignmentFlow: true });
    vm.clients.label = 'CLIENTS';

    vm.trainers = exercisersService.getStaffPaginateList({ isAssignmentFlow: true });

    vm.initialDataIsLoaded = false;

    vm.selectedClients = [];
    vm.selectedTrainers = [];
    vm.selectedExercises = [];

    vm.recurrenceOptions = config.assignmentRecurrenceOptions;
    vm.timeDurationOptions = config.assignmentDurationOptions;
    vm.canPickTime = true;

    if (!vm.isEdit) {
      vm.recurrence = {
        recurrenceType: 'once',
        recurrenceGap: 1,
        recurrenceNumber: 1
      };
    }

    _.extend(vm, {
      loadClients: loadClients,
      removeClient: removeClient,
      loadTrainers: loadTrainers,
      removeTrainer: removeTrainer,
      isClientSelected: isClientSelected,
      isRequiredDataFilled: isRequiredDataFilled,
      isAssignmentReadyToSave: isAssignmentReadyToSave,
      checkErrors: checkErrors,
      activateDateTab: activateDateTab,
      navigateToDateTab: navigateToDateTab,
      checkTimeAvailability: checkTimeAvailability,
      getExercisesParams: getExercisesParams,
      getExerciseLoadParams: getExerciseLoadParams,
      navigateToDateTimeDetails: navigateToDateTimeDetails,
      setAllDay: setAllDay,
      activateTrainerTab: activateTrainerTab,
      activateExerciseTab: activateExerciseTab,
      activateExerciseProfileTab: activateExerciseProfileTab,
      validateDurationOption: validateDurationOption,
      goEditSeries: goEditSeries,
      save: save,
      remove: remove,
      parseDate: parseDate,
      parseTime: parseTime,
      handleExerciseUpdate: handleExerciseUpdate,
      setActiveExerciseIndex: setActiveExerciseIndex,
      handleNameChange: handleNameChange,
      addClient: addClient,
      clientIsSelected: clientIsSelected,
      removeClientById: removeClientById,
      toggleTrainerDropdown: toggleTrainerDropdown,
      changeTrainer: changeTrainer
    });

    // events
    $scope.$on('clients.drop-model', _refreshScroll);
    $scope.$on('trainers.drop-model', _refreshScroll);

    $scope.$watch(function() {
      return { start: vm.startDateStart, end: vm.endDateEnd };
    }, datesChanged, true);

    $scope.$watch(function() {
      return vm.selectedClients;
    }, selectedClientsChanged, true);

    $scope.$watch(function() {
      return vm.selectedTrainers;
    }, function(newVal, oldVal) {

      _replaceTrainer(newVal, oldVal);

      if (vm.selectedTrainers.length === 1) {
        workInfoService.getStaffWorkInfo(vm.selectedTrainers[0]._id).then(function(value) {
          vm.selectedTrainerWorkInfo = value;
        });
      } else {
        vm.selectedTrainerWorkInfo = null;
      }
    }, true);

    _init();

    // //////////////////////////////////////////////////////////////////////

    function _init() {
      _resetPageState();
      _checkStateParamsDate();

      $q.allSettled([
        getInitialUserDetails(),
        getInitialAssignmentDetails(),
        loadTrainers(),
        loadClients()
      ]).finally(function() {
        vm.initialDataIsLoaded = true;

        var currentUser = _.assign({}, profileService.user);

        if (_.isEmpty(vm.selectedTrainers) && _.includes(currentUser.roles, 'facility_staff')) {
          vm.selectedTrainers.push(currentUser);
        }

        if (vm.isCopy) {
          $timeout(function() {
            $rootScope.$broadcast('tabs:select', 'time-select');
          });
        }
      });
    }

    function getInitialAssignmentDetails() {
      var promise;
      if (assignmentId) {
        promise = assignmentsService.getAssignmentsById(assignmentId).then(fetchAssignmentDetails);
      } else if (copyFromId) {
        promise = assignmentsService.getAssignmentsById(copyFromId).then(fetchAssignmentDetails);
      } else {
        promise = $q.resolve();
      }
      return promise;
    }

    function getInitialUserDetails() {
      return !userId ?
        $q.resolve() :
        exercisersService.getExerciser(userId).then(function(client) {
          vm.selectedClients.push(client);
        });
    }

    function datesChanged() {
      if (vm.startDateStart && vm.endDateEnd) {
        checkTimeAvailability();
      }

      if (vm.canPickTime) {

        // Activate the timepicker tab
        $timeout(function() {
          // timeout ensures the datetime-schedule tab is no longer disabled
          // when broadcasting this event
          $rootScope.$broadcast('tabs:select', 'datetime-schedule');
        });

        if (vm.startDate && vm.endDate) {
          assignmentsService.getAssignments({
            startDate: moment(vm.startDate).startOf('day').unix(),
            endDate: moment(vm.startDate).endOf('day').unix()
          }).then(function(response) {
            var allAssignments = assignmentsService.getAppointedAssignments(response.data);
            vm.timelineClients = _.filter(allAssignments, function(assignment) {
              return assignment.scheduleType ?
                assignment.scheduleType === 'appointment' :
                !(assignment.timeFrom === 0 && assignment.timeTo === 24);
            });
            vm.anytimeClients = _.chain(allAssignments)
              .filter(function(assignment) {
                return assignment.scheduleType ?
                  assignment.scheduleType !== 'appointment' :
                  assignment.timeFrom === 0 && assignment.timeTo === 24;
              })
              .sortBy(['dateFrom', 'dateTo', 'caption']).value();
          });
        }
      } else {
        vm.timelineClients = [];
        vm.anytimeClients = [];
      }
    }

    function selectedClientsChanged(newValue, oldValue) {
      vm.timelineSelectedClients = assignmentsService.prepareSelectedClients(newValue);

      if (newValue.length > oldValue.length) {
        vm.selectedClients = oldValue.concat(_.differenceBy(newValue, oldValue, '_id'));
      }

      // clear exercises, and reload for single user (could be talored)
      if (((newValue && newValue.length === 1) || (oldValue && oldValue.length === 1)) && vm.exercises) {
        vm.exercises.reset();
      }
    }

    function parseDate() {
      if (vm.startDateStart && vm.endDateEnd) {
        return $filter('dateFormatter')(moment(vm.startDateStart), 'dateShort') + ((vm.endDateEnd.isSame(vm.startDateStart, 'day')) ? '' : ' - ' +
          $filter('dateFormatter')(moment(vm.endDateEnd), 'dateShort'));
      }
      return '';
    }

    function parseTime(time) {
      if (time) {
        return $filter('dateFormatter')(moment(time), 'time');
      }
    }

    function removeTrainer(index) {
      var trainer = vm.selectedTrainers[index];
      vm.selectedTrainers = [];
      vm.trainers.items.unshift(trainer);
    }

    function loadClients(isUpdate) {
      return vm.clients
        .extendDefaultParams({ search: vm.clientSearch })
        .load({
          update: isUpdate,
          responseExtract: function(clients) {
            return filterSelectedUsers(clients, vm.selectedClients);
          }
        });
    }

    function loadTrainers(isUpdate) {
      return vm.trainers
        .extendDefaultParams({ search: vm.trainerSearch })
        .load({
          update: isUpdate,
          responseExtract: function(trainers) {
            return filterSelectedUsers(trainers, vm.selectedTrainers);
          }
        });
    }

    function getExercisesParams() {
      var isSingleUser = vm.selectedClients.length === 1;

      return {
        clientId: isSingleUser ? vm.selectedClients[0]._id : ''
      };
    }

    function getExerciseLoadParams() {
      return {
        responseExtract: exercisesService.extendExercises
      };
    }

    function activateTrainerTab() {
      var currentUser = _.assign({}, profileService.user);

      if (_.isEmpty(vm.selectedTrainers) && _.includes(currentUser.roles, 'facility_staff')) {
        vm.selectedTrainers.push(currentUser);
      }

      $rootScope.$emit('infiniteScroll:complete');
      _refreshScroll();
    }

    function activateExerciseTab() {
      vm.isExerciseTabWasSelected = true;
      vm.exercises = exercisesService.getTemplatesPaginateList({}, exercisersService.extendExercises);
      vm.trainingSets = trainingSetService.getTrainingSetsPaginateList({ withExercises: true });
      vm.exercises.label = 'EXERCISES';
      vm.exercises.load();
      vm.trainingSets.label = 'TRAINING_SETS';
      vm.trainingSets.load();
      $rootScope.$emit('infiniteScroll:complete');
      _refreshScroll();
    }

    function activateExerciseProfileTab() {
      $timeout(function() {
        $scope.$broadcast('rzSliderForceRender');
      });
    }

    function activateDateTab(startDate, endDate) {
      if (!vm.isDateTabWasActivated && startDate) {
        vm.startDateStart = moment(startDate);
        vm.endDateEnd = moment(endDate);
      }

      checkTimeAvailability();

      vm.isDateTabWasActivated = true;

      return true;
    }

    function navigateToDateTab() {
      // Scroll to the relevant month
      if (vm.startDateStart) {
        $timeout(function() {
          $scope.$broadcast('datepicker:scrollToMonth', vm.startDateStart);
        });
      }
    }

    function _checkStateParamsDate() {
      if ($state.params.startDate && $state.params.endDate) {
        activateDateTab(moment.unix($state.params.startDate), moment.unix($state.params.endDate));
      }
    }

    function checkTimeAvailability() {
      vm.canPickTime = moment(vm.startDateStart).isSame(vm.endDateEnd, 'day');
      if (!vm.canPickTime) {
        setAllDay();
      }
    }

    function isClientSelected() {
      return vm.selectedClients.length;
    }

    function isRequiredDataFilled() {
      return !!(vm.selectedClients.length && vm.selectedTrainers.length);
    }

    function isAssignmentReadyToSave() {
      return !(currentErrorsList().length);
    }

    function currentErrorsList() {
      var errorsList = [];
      if (vm.selectedClients.length === 0) {
        errorsList.push($translate.instant('SELECT_AT_LEAST_ONE_CLIENT'));
      }
      if (vm.selectedTrainers.length === 0) {
        errorsList.push($translate.instant('SELECT_AT_LEAST_ONE_TRAINER'));
      }
      if (vm.selectedExercises.length === 0) {
        errorsList.push($translate.instant('SELECT_AT_LEAST_ONE_EXERCISE'));
      }
      if (!(vm.startDate || vm.startDateStart) || !(vm.endDate || vm.endDateEnd)) {
        errorsList.push($translate.instant('SELECT_ASSIGNMENT_DATE'));
      }

      return errorsList;
    }

    function checkErrors() {
      if (!currentErrorsList().length) {
        save();
      } else {
        return $uibModal.open({
          windowClass: 'modal--delete-training-plan',
          templateUrl: '/app/user/tabs/assignments/create-assignment-modal.html',
          resolve: {
            errorList: currentErrorsList
          },
          controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.title = $translate.instant('UNABLE_TO_CREATE_ASSIGNMENT');
            $scope.errors = $scope.$resolve.errorList;
            $scope.okText = $translate.instant('OK');
            $scope.close = function() {
              $uibModalInstance.dismiss();
            };
          }]
        });
      }
    }

    function navigateToDateTimeDetails() {
      $rootScope.$broadcast('tabs:select', 'datetime-details');
    }

    function setAllDay() {
      vm.startDate = null;
      vm.endDate = null;
      vm.scheduleType = 'single_day';
      navigateToDateTimeDetails();
    }

    function navigateToUserDetails(user) {
      if (user && user.exerciserId) {
        $state.go('app.users.details', { userId: user.exerciserId });
      }
    }

    function save() {
      vm.isLoading = true;
      saveAssignment()
        .then(function() {
          if (vm.selectedClients.length === 1) {
            return $state.go('app.users.details', { userId: vm.selectedClients[0]._id , roles :'client' });
          }
          return $state.go(USER_HOME_PAGE.URL);
        }, function(error) {
          if (error !== 'cancel' && error !== 'backdrop click') {
            var errorTitle = vm.isEdit ?
              $translate.instant('ERROR_CANNOT_UPDATE_ASSIGNMENT') :
              $translate.instant('ERROR_CANNOT_SAVE_ASSIGNMENT');

            return popup.alert({
              title: errorTitle,
              description: error
            });
          }
        })
        .finally(function() {
          vm.isLoading = false;
        });
    }

    function saveAssignment() {
      var clients = vm.selectedClients,
        promise = $q.resolve();

      if (vm.isEdit) {
        if (vm.allowEditingSeries) {
          promise = promise.then(function() {
            return popup.confirm({
              title: $translate.instant('CONFIRM_SERIES_CHANGES'),
              description: $translate.instant('EDIT_SERIES_NOTICE'),
              okText: $translate.instant('EDIT_SERIES')
            });
          });
        }
        promise = promise.then(function() {
          return assignmentsService.updateMassAssignment(_createRequestBody(), clients, assignmentId, vm.allowEditingSeries);
        });
      } else {
        promise = promise.then(function() {
          return assignmentsService.createAssignment(_createRequestBody(), clients);
        });
      }

      return promise;
    }

    function _resetPageState() {
      vm.selectedExercises.length = 0;
      vm.selectedClients.length = 0;
      vm.selectedTrainers.length = 0;

      vm.isDateTabWasActivated = false;
      vm.isExerciseTabWasSelected = false;

      vm.startDateStart = null;
      vm.endDateEnd = null;
      vm.startDate = null;
      vm.endDate = null;
      vm.scheduleType = 'single_day';
    }

    function _refreshScroll() {
      $rootScope.$emit('iscroll:refresh');
    }

    function _replaceTrainer(newSelectedTrainers, oldSelectedTrainers) {
      if (newSelectedTrainers.length > 1 && oldSelectedTrainers.length) {
        var newTrainer = _.reject(newSelectedTrainers, { _id: oldSelectedTrainers[0]._id }),
          oldTrainer = oldSelectedTrainers[0];
        vm.trainers.items.unshift(oldTrainer);
        vm.selectedTrainers = newTrainer;
      }
    }

    function _createRequestBody() {
      var body = {
        startDate: vm.startDate ? vm.startDate.unix() : vm.startDateStart.unix(),
        endDate: vm.endDate ? moment(vm.startDate).add(vm.endDate - vm.startDate, 'ms').unix() - 1 : vm.endDateEnd.unix(),
        exercises: _.map(vm.selectedExercises, prepareExercise),
        exercisers: _.map(vm.selectedClients, '_id'),
        trainerId: _.get(vm.selectedTrainers[0], '_id')
      };

      body.scheduleType = _getScheduleType(body.startDate, body.endDate);

      if (vm.name || (vm.isEdit && vm.name === '')) {
        body.name = vm.name;
      }

      if (vm.allowEditingSeries && vm.recurrence && vm.recurrence.recurrenceType !== 'once') {
        body.recurrence = angular.copy(vm.recurrence);

        body.recurrence.recurrenceIntervals = _calculateRecurrenceIntervals(body.startDate, body.endDate, body.recurrence);

        delete body.recurrence.recurrenceIdx;
        delete body.recurrence.recurrenceRef;
      }

      return body;
    }

    function _getScheduleType(startDate, endDate) {
      var dayLength = 86399,
        duration = endDate - startDate;

      if (duration < dayLength) {
        return 'appointment';
      } else if (duration === dayLength) {
        return 'single_day';
      }
      return 'multi_day';
    }

    function prepareExercise(exercise) {
      // in order for the DB to keep track of tailored exercises, we need the templateId
      // to be on the exercise object, so upon first use in an assignment, it will be the
      // template's _id, otherwise, exerciseTemplate should come back as part of the original
      // object, so we can just leave it alone
      exercise.exerciseTemplateId = exercise.exerciseTemplateId || exercise._id;
      return _.omit(exercise, [
        'restricted',
        'facility',
        'totalDuration',
        'completedManually',
        'pictureUrl',
        'id',
        '_id',
        'isEditable',
        'featured'
      ]);
    }

    function fetchAssignmentDetails(assignment) {
      vm.selectedExercises = mergeExercises(vm.selectedExercises, assignment.exercises);
      vm.selectedExercises = exercisesService.extendExercises(vm.selectedExercises);
      activateExerciseTab();
      activateDateTab();

      if (vm.isEdit) {
        vm.scheduleType = assignment.scheduleType;
        vm.startDate = moment.unix(assignment.startDate);
        vm.endDate = moment.unix(assignment.endDate);
        vm.startDateStart = moment.unix(assignment.startDate).startOf('day');
        vm.endDateEnd = moment.unix(assignment.endDate).endOf('day');
      }

      if (assignment.recurrence && vm.isEdit) {
        vm.recurrence = assignment.recurrence;
      } else {
        vm.recurrence = {
          recurrenceType: 'once',
          recurrenceGap: 1,
          recurrenceNumber: 1
        };
      }

      if (assignment.name) {
        vm.name = assignment.name;
      }

      vm.editAssignment = assignment;

      var clientIds = _.map(assignment.exercisers, '_id'),
        currentUser = _.assign({}, profileService.user),
        trainerId = vm.isCopy && _.includes(currentUser.roles, 'facility_staff') ? currentUser._id : assignment.trainerId,
        promises = [];

      if (trainerId) {
        promises.push(getTrainersByIds([trainerId]).then(function(trainers) {
          vm.selectedTrainers = trainers;
        }));
      }

      if (clientIds.length) {
        promises.push(getClientsByIds(clientIds).then(function(clients) {
          vm.selectedClients = clients;
          vm.activeAssignment = assignmentsService.getAppointedAssignment(clients[0], vm.editAssignment);
        }));
      }

      return $q.all(promises);
    }

    function remove() {
      return popup.confirm({
        title: $translate.instant(vm.allowEditingSeries ? 'DELETE_THIS_SERIES?' : 'DELETE_THIS_ASSIGNMENT?'),
        description: $translate.instant(vm.allowEditingSeries ? 'PLEASE_CONFIRM_DELETE_SERIES' : 'PLEASE_CONFIRM_DELETE_ASSIGNMENT'),
        okText: $translate.instant(vm.allowEditingSeries ? 'DELETE_SERIES' : 'DELETE_ASSIGNMENT')
      }).then(function() {
        return assignmentsService.deleteMassAssignment(vm.editAssignment._id, vm.allowEditingSeries)
          .then(function() {
            $state.go(USER_HOME_PAGE.URL);
          }, function() {
            return popup.alert({
              title: $translate.instant(vm.allowEditingSeries ? 'ERROR_CANNOT_DELETE_SERIES' : 'ERROR_CANNOT_DELETE_ASSIGNMENT')
            });
          });
      });
    }

    function mergeExercises(selectedExercises, exercises) {
      return _.chain(selectedExercises)
        .concat(exercises)
        .value();
    }

    function getClientsByIds(ids) {
      var clientPromises = _.map(ids, exercisersService.getExerciser);

      return $q.allSettled(clientPromises).then(function(results) {
        return _.chain(results)
          .filter('value')
          .map('value')
          .value();
      });
    }
    function getTrainersByIds(ids) {
      var trainersPromises = _.map(ids, exercisersService.getTrainers);

      return $q.allSettled(trainersPromises).then(function(results) {
        return _.chain(results)
          .filter('value')
          .map('value')
          .value();
      });
    }

    function filterSelectedUsers(users, selectedUsers) {
      return _.differenceBy(users, selectedUsers, '_id');
    }


    function validateDurationOption(duration) {
      var hoursToMidnight = 24 - (moment(vm.startTime).hours() + moment(vm.startTime).minutes() / 60);
      return hoursToMidnight < duration.asHours();
    }

    function goEditSeries() {
      assignmentsService.goEditRecurringAssignment(true, $state.params);
    }

    function handleExerciseUpdate(updatedExercise) {
      if (updatedExercise !== undefined) {
        this.selectedExercises[this.activeExerciseIndex] = updatedExercise;
      }
    }

    function handleNameChange(newName) {
      vm.name = newName;
    }

    vm.activeExerciseIndex = 0;

    function setActiveExerciseIndex(newIndex) {
      vm.activeExerciseIndex = newIndex;
    }

    function addClient(client) {
      vm.selectedClients.push(client);
    }

    function removeClient(idx) {
      vm.selectedClients.splice(idx, 1);
    }

    function clientIsSelected(clientId) {
      return _.findIndex(vm.selectedClients, function(item) {
        return item._id === clientId;
      }) > -1;
    }

    function removeClientById(clientId) {
      var idx = _.findIndex(vm.selectedClients, function(item) {
        return item._id === clientId;
      });
      vm.selectedClients.splice(idx, 1);
    }

    function toggleTrainerDropdown() {
      vm.trainerDropdown = !vm.trainerDropdown;
    }

    function changeTrainer(trainer) {
      vm.selectedTrainers[0] = trainer;
      if (vm.trainerDropdown) {
        toggleTrainerDropdown();
      }
    }

    function _calculateRecurrenceIntervals(startDate, endDate, recurrenceObj) {
      var recurrenceIntervals = [],
        typeToMomentString = {
          daily: 'day',
          weekly: 'week',
          monthly: 'month'
        },
        recurrenceIndex = recurrenceObj.recurrenceIdx || 1,
        i,
        offset;

      // start at 1 because of indexing magic and because we want every occurrence except the first one
      for (i = 1; i < recurrenceObj.recurrenceNumber; i++) {
        var obj = {}; // eslint-disable-line

        // Calculate interval start/end dates using an offset relative to the current recurrence index.
        offset = i - recurrenceIndex + 1;

        obj.startDate = moment.unix(startDate)
          .add(offset * recurrenceObj.recurrenceGap, typeToMomentString[recurrenceObj.recurrenceType]).unix();
        obj.endDate = moment.unix(endDate)
          .add(offset * recurrenceObj.recurrenceGap, typeToMomentString[recurrenceObj.recurrenceType]).unix();
        recurrenceIntervals.push(obj);
      }
      return recurrenceIntervals;
    }
  }
}());
angular.module('ptCrm')
.controller('CreateAssignmentWorkflowController', ['savedTrainingPlanService', 'trainingPlanService', 'popup', '$translate', '$state', 'printService', 'exercisersService', '$q', function(savedTrainingPlanService, trainingPlanService, popup, $translate, $state, printService, exercisersService, $q) {
  var vm = this;

  vm.currentTab = 'assignmentType';
  if ($state.params.userId) {
    vm.userId = $state.params.userId;
  }
  vm.isEdit = !!$state.params.id;
  vm.editId = $state.params.id;
  vm.canEditTimes = true;
  vm.copyFromId = $state.params.copyFrom;
  vm.isCopy = !!$state.params.copyFrom;

  _.extend(vm, {
    changeAssignmentCreationTab: changeAssignmentCreationTab,
    changeAssignmentType: changeAssignmentType,
    changeAssignmentName: changeAssignmentName,
    changeSelectedSavedTrainingPlan: changeSelectedSavedTrainingPlan,
    changeStartDate: changeStartDate,
    changeEndDate: changeEndDate,
    changeTrainingSessions: changeTrainingSessions,
    changeWeeks: changeWeeks,
    saveTrainingPlan: saveTrainingPlan,
    save: save,
    changeTrainer: changeTrainer,
    changeExercisers: changeExercisers,
    changeTrainingPlansExercise: changeTrainingPlansExercise,
    showPDF: showPDF
  });

  init();

  function init() {
    if (vm.isEdit || vm.isCopy) {
      return trainingPlanService.getTrainingPlanById(vm.isEdit ? vm.editId : vm.copyFromId)
      .then(function(plan) {
        if (vm.isEdit) {
          if (!plan.editable) {
            popup.alert({
              title: $translate.instant('CANNOT_EDIT_TRAINING_PROGRAM'),
              description: $translate.instant('ERROR_CANNOT_EDIT_TRAINING_PLAN_MESSAGE')
            })
            .then(function() {
              $state.go('app.dashboard');
            })
            .catch(function() {
              $state.go('app.dashboard');
            });
          }
          vm.editPlan = plan;
          vm.canEditTimes = moment.unix(plan.startDate).unix() > moment().unix();
          changeAssignmentName(plan.planName);
          changeStartDate(moment.unix(plan.startDate));
          changeEndDate(moment.unix(plan.startDate).endOf('day'));
        } else {
          vm.copyPlan = plan;
          var currentDate = moment(),
            newStartDate = currentDate.unix(),
            newEndDate = currentDate.endOf('day').unix();
          changeAssignmentName(plan.planName);
          changeStartDate(moment.unix(newStartDate));
          changeEndDate(moment.unix(newEndDate));
        }
        changeWeeks(plan.repeats);
        changeTrainingSessions(_getTrainingSessionsFromWorkouts(plan.workouts));
        changeTrainingPlansExercise(_getExercisesFromWorkouts(plan.workouts));

        return $q.all([
          _getClientsByIds(plan.exercisers),
          _getTrainersByIds([plan.trainerId])
        ])
        .then(function(users) {
          changeExercisers(users[0]);
          changeTrainer(users[1][0]);
        });
      });
    } else if (vm.userId) {
      return _getClientsByIds([vm.userId])
      .then(function(clients) {
        changeExercisers(clients);
      });
    }
  }

  function changeAssignmentCreationTab(inputTag) {
    if (inputTag) {
      vm.currentTab = inputTag;
    }
  }

  function changeAssignmentType(newType) {
    vm.assignmentType = newType;
  }

  function changeAssignmentName(newName) {
    vm.assignmentName = newName;
  }

  function changeStartDate(newStartDate) {
    vm.startDate = newStartDate;
  }

  function changeEndDate(newEndDate) {
    vm.endDate = newEndDate;
  }

  function changeTrainingSessions(newSessions) {
    if (vm.trainingSessions && (vm.trainingSessions.length < newSessions.length) && vm.trainingPlansExercise) {
      vm.trainingPlansExercise.push([]);
    }

    if (vm.trainingSessions && (vm.trainingSessions.length > newSessions.length) && vm.trainingPlansExercise) {
      var deletedIdx = _.differenceBy(vm.trainingSessions, newSessions, 'idx')[0].idx;
      if (vm.trainingPlansExercise[deletedIdx]) {
        vm.trainingPlansExercise.splice(deletedIdx, 1);
      }
    }
    vm.trainingSessions = _reIndexTrainingSessions(newSessions);
  }

  function changeWeeks(newWeeks) {
    vm.weeks = newWeeks;
  }

  function saveTrainingPlan() {
    var body = _makeSavedPlanBody(),
      promise;

    if (vm.selectedSavedTrainingPlan) {
      promise = savedTrainingPlanService.editTrainingPlan(body, vm.selectedSavedTrainingPlan._id);
    } else {
      promise = savedTrainingPlanService.createTrainingPlan(body);
    }

    vm.savingSavedTrainingPlan = true;
    return promise
    .then(function(response) {
      changeSelectedSavedTrainingPlan(response);
    })
    .catch(function(error) {
      if (error.status === 409) {
        return popup.alert({
          title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
          description: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM_MESSAGE')
        });
      }
      return popup.alert({
        title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
        description: error
      });
    })
    .finally(function() {
      vm.savingSavedTrainingPlan = false;
    });
  }

  function save() {
    var body = {
        planName: vm.assignmentName,
        trainerId: vm.trainer._id,
        exercisers: vm.exercisers.map(function(ex) { return ex._id; }),
        startDate: vm.startDate.unix(),
        workoutsToShow: vm.trainingSessions.length,
        repeats: vm.weeks,
        workouts: _generateWorkouts()
      },
      promise;

    if (vm.isEdit) {
      promise = trainingPlanService.updateTrainingPlanById(vm.editId, body);
    } else {
      promise = trainingPlanService.createTrainingPlan(body);
    }

    vm.savingTrainingPlan = true;
    return promise
    .then(function() {
      $state.go('app.dashboard');
    })
    .catch(function(error) {
      if (error.status === 400 && error.data.message.indexOf('startdate') > -1) {
        return popup.alert({
          title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
          description: $translate.instant('ERROR_START_DATE_TRAINING_PROGRAM')
        });
      }
      return popup.alert({
        title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
        description: error
      });
    })
    .finally(function() {
      vm.savingTrainingPlan = false;
    });
  }

  function changeTrainer(newTrainer) {
    vm.trainer = newTrainer;
  }

  function changeExercisers(newExercisers) {
    vm.exercisers = newExercisers;
  }

  function changeTrainingPlansExercise(newExercises) {
    vm.trainingPlansExercise = newExercises;
  }

  function changeSelectedSavedTrainingPlan(savedPlan) {
    vm.selectedSavedTrainingPlan = savedPlan;

    if (!vm.selectedSavedTrainingPlan) {
      return;
    }

    changeAssignmentName(vm.selectedSavedTrainingPlan.planName);
    changeWeeks(vm.selectedSavedTrainingPlan.repeats);
    changeTrainingSessions(_getTrainingSessionsFromWorkouts(vm.selectedSavedTrainingPlan.workouts));
    changeTrainingPlansExercise(_getExercisesFromWorkouts(vm.selectedSavedTrainingPlan.workouts));
  }

  function showPDF() {
    return printService.printOnTheFlyTrainingPlan(_makeSavedPlanBody());
  }

  function _reIndexTrainingSessions(sessions) {
    return sessions.map(function(session, index) {
      session.idx = index;
      return session;
    });
  }

  function _generateWorkouts() {
    return vm.trainingSessions.map(function(session, index) {
      var workout = {
        name: session.name,
        exercises: vm.trainingPlansExercise[index]
      };

      if (vm.editPlan && vm.editPlan.workouts[index] && vm.editPlan.workouts[index]._id) {
        workout._id = vm.editPlan.workouts[index]._id;
      }

      return workout;
    });
  }

  function _getTrainingSessionsFromWorkouts(workouts) {
    var arr = [];
    workouts.forEach(function(item, index) {
      arr.push({
        name: item.name,
        idx: index
      });
    });
    return arr;
  }

  function _getExercisesFromWorkouts(workouts) {
    var arr = [];
    workouts.forEach(function(item) {
      arr.push(item.exercises);
    });
    return arr;
  }

  function _makeSavedPlanBody() {
    return {
      planName: vm.assignmentName,
      workoutsToShow: vm.trainingSessions.length,
      repeats: vm.weeks,
      workouts: _generateWorkouts()
    };
  }

  function _getClientsByIds(ids) {
    var clientPromises = _.map(ids, exercisersService.getExerciser);
    return $q.allSettled(clientPromises).then(function(results) {
      return _.chain(results)
        .filter('value')
        .map('value')
        .value();
    });
  }

  function _getTrainersByIds(ids) {
    var TrainerPromises = _.map(ids, exercisersService.getTrainers);
    return $q.allSettled(TrainerPromises).then(function(results) {
      return _.chain(results)
        .filter('value')
        .map('value')
        .value();
    });
  }
}]);
/* eslint-disable one-var */
(function() {

  'use strict';

  TaskController.$inject = ['exercisersService', 'taskService', 'assignmentsService', '$state', '$scope', 'profileService', 'popup', '$translate', '$q', '$rootScope', 'config', '$timeout', '$filter', 'workInfoService'];
  angular.module('ptCrm')
    .controller('TaskController', TaskController);

  function TaskController(exercisersService, taskService, assignmentsService,
    $state, $scope, profileService, popup, $translate, $q, $rootScope, config, $timeout, $filter, workInfoService) {

    var vm = this;
    vm.form = {};
    vm.task = getFormattedTask();
    vm.today = moment();
    vm.isEdit = !!$state.params.id;
    vm.timeSlots = [];
    vm.anytimeClients = [];
    vm.selectedUserWorkInfo = null;

    vm.remove = remove;
    vm.save = save;
    vm.activateDateTab = activateDateTab;
    vm.parseDate = parseDate;
    vm.resetAppointmentTime = resetAppointmentTime;
    vm.navigateToUserDetails = navigateToUserDetails;
    vm.onEditAssigment = onEditAssigment;
    vm.onEditTask = onEditTask;
    vm.navigateToDateTimeDetails = navigateToDateTimeDetails;
    vm.navigateToDateTab = navigateToDateTab;
    vm.validateDurationOption = validateDurationOption;
    vm.setAllDay = setAllDay;

    vm.timeDurationOptions = config.assignmentDurationOptions;

    // ========= FOR date-time PICKER ==========
    $scope.$watch(function() {
      return {
        start: vm.task.startDate,
        end: vm.task.endDate
      };
    }, prepareTimeline, true);

    $scope.$watch(function() {
      return vm.task.users.length;
    }, prepareNamePlate);

    $scope.$watch(function() {
      return vm.task.users.length;
    }, prepareTimeline);

    init();
    function init() {
      updatePermissions();
      vm.users = exercisersService.getStaffPaginateList(null, filterOutClients);

      if (vm.isEdit) {
        taskService.getTask($state.params.id).then(function(task) {

          // if there is no task -> create
          if (!task) {
            console.warn('No task with id', $state.params.id); // eslint-disable-line no-console
            $state.params.id = '';
            vm.isEdit = false;
            return;
          }
          _.extend(vm.task, getFormattedTask(task));

          // now dateTab is ready for rendering
          vm.isDateTabWasActivated = true;
          fetchUserDetails(task.users[0]);
        });
      } else {

        if ($state.params.startDate || $state.params.endDate) {
          vm.isDateTabWasActivated = true;
        }

        // user was selected on previous page
        // now only one user for one task
        if ($state.params.userId) {
          fetchUserDetails($state.params.userId);
        }
      }
    }

    // =================================================================
    // ========================== PUBLIC METHODS =======================
    // =================================================================
    function remove(id) {
      popup.confirm().then(function() {
        taskService.deleteTask(id).then(function() {
          $state.go('app.library.list');
        });
      });
    }

    function save(task) {
      var formattedTask = formatTask(task),
        isValid = isTaskValid(formattedTask);
      if (!isValid) {
        return popup.alert({
          title: $translate.instant('ERROR_CANNOT_SAVE_TASK')
        });
      }
      var promise = vm.isEdit ?
        taskService.editTask(formattedTask) :
        taskService.createTask(formattedTask);

      promise.then(function(task) {
        $state.go('app.calendar', {
          date: task.startTime,
          userId: task.users[0]
        });
      }, function() {
        var errorMessage = vm.isEdit ?
          $translate.instant('ERROR_CANNOT_UPDATE_TASK') :
          $translate.instant('ERROR_CANNOT_SAVE_TASK');

        return popup.alert({ title: errorMessage });
      });

    }

    // ============= for date-time picker ================
    function activateDateTab(startDate, endDate) {
      if (!vm.isDateTabWasActivated && startDate) {
        vm.task.startDate = moment(startDate);
        vm.task.endDate = moment(endDate);
      }

      checkTimeAvailability();

      vm.isDateTabWasActivated = true;

      return true;
    }

    function navigateToDateTab() {
      // Scroll to the relevant month
      if (vm.task.startDate) {
        $timeout(function() {
          $scope.$broadcast('datepicker:scrollToMonth', vm.startDate);
        });
      }
    }

    function parseDate() {
      if (vm.task.startDate && vm.task.endDate) {
        return $filter('dateFormatter')(moment(vm.task.startDate), 'dateShort') + ((vm.task.endDate.isSame(vm.task.startDate, 'day')) ? '' : ' - ' +
          $filter('dateFormatter')(moment(vm.task.endDate), 'dateShort'));
      }
      return '';

    }

    function resetAppointmentTime() {
      vm.task.appointment.startTime = null;
      vm.task.appointment.endTime = null;
    }

    // =================================================================
    // ========================== HELPERS ==============================
    // =================================================================


    function isTaskValid(task) {
      return task.title && task.endTime && task.startTime && !_.isEmpty(task.users);
    }

    function formatTask(task) {
      var formattedTask = {
        _id: task._id,
        users: _.map(task.users, '_id'),
        title: task.title,
        description: task.description
      };

      if (isInsideOneDay() && task.appointment.startTime && task.appointment.endTime) {
        formattedTask.startTime = moment(task.appointment.startTime).set({
          year: task.startDate.year(),
          month: task.startDate.month(),
          date: task.startDate.date()
        }).unix();
        formattedTask.endTime = moment(task.appointment.endTime).set({
          year: task.endDate.year(),
          month: task.endDate.month(),
          date: task.endDate.date()
        }).unix();
      } else {
        formattedTask.startTime = moment(task.startDate).startOf('day').unix();
        formattedTask.endTime = moment(task.endDate).add(1, 'day').startOf('day').unix();
      }
      return formattedTask;
    }

    function getFormattedTask(task) {
      task = task || {};
      return {
        _id: task._id || $state.params._id,
        users: [], // users will be placed here after fetchUserDetails()
        appointment: {
          endTime: task.endTime && moment.unix(task.endTime) || null,
          startTime: task.startTime && moment.unix(task.startTime) || null
        },
        startDate: getMoment(task.startTime || $state.params.startDate, 'start'),
        endDate: getMoment(task.endTime || $state.params.endDate, 'end'),
        title: task.title,
        description: task.description
      };
    }

    function getMoment(date, dayTime) {
      return date && moment.unix(date)[dayTime + 'Of']('day');
    }

    function fetchUserDetails(userId) {
      return exercisersService.getStaffExerciser(userId).then(function(user) {
        vm.task.users.push(user);
        prepareNamePlate(vm.task.users);
      });
    }

    function filterOutClients(users) {
      return _.filter(users, function(user) {
        return _.intersection(user.roles, ['facility_staff']).length;
      });
    }

    // ============= for date-time picker ================
    function navigateToDateTimeDetails() {
      $rootScope.$broadcast('tabs:select', 'datetime-details');
    }

    function validateDurationOption(duration) {
      var hoursToMidnight = 24 - (moment(vm.task.appointment.startTime).hours() + moment(vm.task.appointment.startTime).minutes() / 60);
      return hoursToMidnight < duration.asHours();
    }

    function setAllDay() {
      resetAppointmentTime();
      navigateToDateTimeDetails();
    }

    function isInsideOneDay() {
      return moment(vm.task.startDate).isSame(vm.task.endDate, 'day');
    }

    function checkTimeAvailability() {
      vm.task.canPickTime = isInsideOneDay();
      if (!vm.task.canPickTime) {
        setAllDay();
      }
    }

    function prepareNamePlate(newValue, oldValue) {
      if (newValue !== oldValue) {

        vm.namePlate = assignmentsService.prepareSelectedClients(vm.task.users);
        vm.namePlate.type = 'task';
      }
    }

    function updatePermissions() {
      var isMy = vm.task.users[0] &&
        (vm.task.users[0]._id === 'me' || vm.task.users[0]._id === profileService.user._id);
      vm.createPermission = isMy ? 'TASKS_SELF_CREATE' : 'TASKS_OTHER_CREATE';
      vm.editPermission = isMy ? 'TASKS_SELF_UPDATE' : 'TASKS_OTHER_UPDATE';
      vm.deletePermission = isMy ? 'TASKS_SELF_DELETE' : 'TASKS_OTHER_DELETE';
    }

    function prepareTimeline(newValue, oldValue) {

      if (newValue !== oldValue && vm.task.users[0] && vm.isDateTabWasActivated) {
        updatePermissions();
        checkTimeAvailability();
        if (vm.task.canPickTime) {

          // Activate the timepicker tab
          $timeout(function() {
            // timeout ensures the datetime-schedule tab is no longer disabled
            // when broadcasting this event
            $rootScope.$broadcast('tabs:select', 'datetime-schedule');
          });

          $q.all({
            assignments: fetchAssignments(),
            tasks: fetchTasks(),
            workInfo: workInfoService.getStaffWorkInfo(vm.task.users[0]._id)
          }).then(function(responses) {
            var tasks = _.map(responses.tasks.data, taskService.prepareTask.bind(null, vm.task.users[0])),
              assignments = assignmentsService.getAppointedAssignments(responses.assignments.data),
              allAssignments = assignments.concat(tasks);

            if (vm.isEdit) {
              vm.taskOnEdit = _.find(tasks, { _id: vm.task._id });
            }

            vm.timeSlots = _.filter(allAssignments, function(assignment) {
              return !(assignment.timeFrom === 0 && assignment.timeTo === 24);
            });
            vm.anytimeClients = _.chain(allAssignments)
              .filter(function(assignment) {
                return assignment.timeFrom === 0 && assignment.timeTo === 24;
              })
              .sortBy(['dateFrom', 'dateTo', 'caption']).value();

            vm.selectedUserWorkInfo = responses.workInfo;
          });
        }
      }
    }

    function fetchAssignments() {
      return assignmentsService.getAssignments({
        startDate: moment(vm.task.startDate).startOf('day').unix(),
        endDate: moment(vm.task.startDate).endOf('day').unix()
      }).catch(function(error) {
        console.warn('getAssignments unsuccessful', error); // eslint-disable-line no-console
        return {};
      });
    }

    function fetchTasks() {
      return taskService.getTasks({
        userId: vm.task.users[0]._id,
        startTime: moment(vm.task.startDate).startOf('day').unix(),
        endTime: moment(vm.task.startDate).add(1, 'day').startOf('day').unix()
      }).catch(function(error) {
        console.warn('getTasks unsuccessful', error); // eslint-disable-line no-console
        return {};
      });
    }

    //  ============= navigators =================
    function navigateToUserDetails(item) {
      return $state.go('app.users.details', { userId: item.exerciserId });
    }
    function onEditAssigment(item) {
      if (item.recurrence) {
        assignmentsService.chooseAssignmentEditMode({ id: item._id, userId: item.exerciserId });
      } else {
        $state.go('app.assignment', { id: item._id, userId: item.exerciserId });
      }
    }
    function onEditTask(item) {
      return $state.go('app.task', { id: item._id, userId: item.exerciserId });
    }

  }
}());
(function() {

  'use strict';

  CreateTrainingSetController.$inject = ['$state', '$timeout', '$scope', 'popup', '$translate', 'exercisesService', 'exerciseImagesService', 'trainingSetService', 'USER_HOME_PAGE', '$q'];
  angular.module('ptCrm')
    .controller('CreateTrainingSetController', CreateTrainingSetController);

  function CreateTrainingSetController(
    $state, $timeout, $scope, popup, $translate, exercisesService, exerciseImagesService, trainingSetService, USER_HOME_PAGE, $q) {

    var vm = this;

    vm.activeExerciseIndex = 0;
    vm.editExercise = editExercise;
    vm.setVideo = setVideo;
    vm.save = save;
    vm.cancel = cancel;
    vm.remove = remove;
    vm.isLoading = false;
    vm.deletePermission = false;
    vm.handleExerciseUpdate = handleExerciseUpdate;
    vm.setActiveExerciseIndex = setActiveExerciseIndex;
    vm.isSetValid = isSetValid;

    // should be availiable before carusel init
    vm.set = {
      imagesList: exerciseImagesService.getInstance()
    };


    if ($state.params.id) {
      vm.isEdit = true;
      fetchTraingSetAndInit($state.params.id);
    } else {
      vm.isEdit = false;
      init({});
      vm.exercises = exercisesService.getTemplatesPaginateList(null, exercisesService.extendExercises);
      vm.exercises.label = 'EXERCISES';
      vm.exercises.load();
    }


    function init(set) {
      vm.set = {
        _id: set._id,
        title: set.title,
        description: set.description,
        video: set.video,
        imagesList: set.imagesList || exerciseImagesService.getInstance(),
        exercises: set.exercises || [],
        restricted: set.restricted,
        chainWide: set.chainWide,
        featured: set.featured
      };
    }

    function fetchTraingSetAndInit(id) {
      return trainingSetService.getTrainingSet(id)
        .then(function(set) {
          if (set.restricted && !exercisesService.hasPermission('RESTRICTED_FLAG_UPDATE')) {
            return $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
          }
          vm.deletePermission = updateDeletePermission(set);
          set.exercises = exercisesService.extendExercises(set.exercises);

          if (set.picture) {
            set.imagesList = exerciseImagesService.getInstance();
            set.imagesList.setTrainingSetImage(set.picture, set.pictureTransform);
          }

          init(set);

          // load exercises for tiles
          vm.exercises = exercisesService.getTemplatesPaginateList(null, exercisesService.extendExercises);
          vm.exercises.load();
        });
    }

    // =============== METHODS ============
    function editExercise(exercise) {
      $state.go('app.library.exercise', { id: exercise._id });
    }


    function setVideo(videoUrl) {
      vm.set.video = videoUrl;
    }

    function save(set) {
      var formattedSet = _formatSet(set),
        promise = $q.resolve();
      return promise.then(function() {
        vm.isLoading = true;
        return vm.isEdit ?
          trainingSetService.editTrainingSet(formattedSet) :
          trainingSetService.createTrainingSet(formattedSet);
      })
        .then(function() {
          vm.isLoading = false;
          $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
        });
    }

    function cancel() {
      return popup.confirm({
        title: $translate.instant('ARE_YOU_SURE?'),
        okText: $translate.instant('CANCEL_TRAINING_SET')
      }).then(function() {
        return $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
      });
    }


    function remove(id) {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_TRAINING_SET?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_TRAINING_SET'),
        okText: $translate.instant('DELETE_TRAINING_SET')
      })
        .then(function() {
          return trainingSetService.deleteTrainingSet(id)
            .then(function() {
              $state.go('app.library.list', { tab: 'TRAINING_SETS_READ' });
            }, function() {
              return popup.alert({
                title: $translate.instant('ERROR_CANNOT_DELETE_TRAINING_SET')
              });
            });
        });
    }


    //  ================= HELPERS ==============
    function _formatSet(set) {
      var formatted = {
          _id: set._id,
          title: set.title,
          description: set.description,
          video: set.video || undefined,
          exercises: _.map(set.exercises || [], function(ex) {
            if (!ex.exerciseTemplateId) {
              ex.exerciseTemplateId= ex._id;
            }
            ex._id = undefined;
            return ex;
          }),
          restricted: set.restricted,
          chainWide: set.chainWide,
          featured: set.featured
        },
        setImage = set.imagesList.getTrainingSetImage();

      if (setImage) {
        formatted.picture = setImage.picturePath || null;
        formatted.pictureTransform = setImage.pictureTransform || null;
      }
      return formatted;
    }


    function isSetValid(formattedSet) {
      return formattedSet.title && !_.isEmpty(formattedSet.exercises);
    }

    function updateDeletePermission(set) {
      return 'TRAINING_SETS_DELETE' +
        (set.restricted ? '+RESTRICTED_FLAG_DELETE' : '') +
        (set.chainWide ? '+CHAIN_WIDE_DELETE' : '');
    }

    vm.activateExerciseProfileTab = function() {
      $timeout(function() {
        $scope.$broadcast('rzSliderForceRender');
      });
    };

    function handleExerciseUpdate(updatedExercise) {
      if (updatedExercise !== undefined) {
        vm.set.exercises[vm.activeExerciseIndex] = updatedExercise;
      }
    }

    function setActiveExerciseIndex(newIndex) {
      vm.activeExerciseIndex = newIndex;
    }


  }

}());
(function() {

  'use strict';

  rosterController.$inject = ['exercisersService'];
  angular.module('ptCrm')
    .controller('RosterController', rosterController);

  function rosterController(exercisersService) {

    var vm = this;

    vm.clientsList = exercisersService.getClientStaffPaginateList();
    vm.loadClients = loadClients;
    vm.filterByName = filterByName;
    vm.getUrlByGroup = getUrlByGroup;
    vm.getUserViewPermission = getUserViewPermission;
    vm.isStaff = isStaff;

    loadClients();

    function loadClients() {
      return vm.clientsList.loadClientStaff();
    }

    function filterByName() {
      vm.clientsList
        .extendDefaultParams({ search: vm.search })
        .loadClientStaff({ update: true });
    }

    function getUrlByGroup(person) {
      // Does not appear to be called anywhere. Do not use!
      return person.group === 'facility-staff' ? 'facility-staff' : 'client';
    }

    function getUserViewPermission(client) {
      return _.includes(client.roles, 'client') ? 'ROSTER_CLIENT_VIEW_READ' : 'ROSTER_NON_CLIENT_VIEW_READ';
    }

    function isStaff(person) {
      return _.includes(person.roles, 'facility_staff');
    }
  }

}());
(function() {

  'use strict';

  ExerciseController.$inject = ['exercisesService', '$state', '$q', 'toastr', '$translate', 'popup', 'USER_HOME_PAGE', 'metricsService'];
  angular.module('ptCrm')
    .controller('ExerciseController', ExerciseController);

  function ExerciseController(exercisesService, $state, $q, toastr, $translate,
    popup, USER_HOME_PAGE, metricsService) {

    var vm = this,
      exerciseId = $state.params.id,
      validTag = /^[^\s\t\r\n].+[^\s\t\r\n]$/;

    init();

    function init() {
      vm.exercise = {
        preset: {},
        assignedProfile: {
          segments: [],
          global: {}
        }
      };
      vm.exerciseId = exerciseId;
      vm.isEdit = !!exerciseId;
      vm.exerciseImages = [];
      vm.details = {};
      vm.equipmentPresets = [];
      vm.selectedEquipment = null;
      vm.isConnected = false;
      vm.totalDuration = 0;
      vm.isLoading = false;
      vm.exerciseTags = [];
      vm.availableTags = [];
      vm.tagCreatePermission = exercisesService.hasPermission('TAGS_CREATE');
      vm.tagUpdatePermission = exercisesService.hasPermission('TAGS_UPDATE');
      vm.tagDeletePermission = vm.tagUpdatePermission; // May be restricted in the future
    }

    // define public methods in the followong way to avoid "too many statements" error
    angular.extend(vm, {
      isActiveEquipment: isActiveEquipment,
      selectEquipment: selectEquipment,
      setVideo: setVideo,
      createExercise: createExercise,
      deleteExercise: deleteExercise,
      cancelExercise: cancelExercise,
      handleExerciseUpdate: handleExerciseUpdate,
      createTagObject: createTagObject,
      handleMediaUpdate: handleMediaUpdate
    });

    _init();

    function _init() {
      vm.isLoading = true;

      var initPromises = [
        fetchEquipmentPresets(),
        fetchCurrentExercise(),
        getAvailableExerciseTags()
      ];

      if (vm.isEdit) {
        initPromises.push(getExerciseTags());
      }

      $q.allSettled(initPromises).finally(function() {
        vm.isLoading = false;
        setEditParams();
      });
    }

    function fetchEquipmentPresets() {
      return metricsService.getEquipmentPresets().then(function(data) {
        vm.equipmentPresets = exercisesService.extendExercises(data);
      });
    }

    function fetchCurrentExercise() {
      if (!exerciseId) {
        return $q.resolve();
      }

      return exercisesService.getExercise(exerciseId).then(function(response) {
        if (response.restricted && !exercisesService.hasPermission('RESTRICTED_FLAG_UPDATE')) {
          $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
        } else {
          vm.exercise = response;
        }
      });
    }

    function setEditParams() {
      vm.details = _.pick(vm.exercise, ['_id', 'description', 'title', 'restricted', 'chainWide', 'featured']);

      vm.exerciseVideo = vm.exercise.video;
      vm.exerciseImages = vm.exercise.images;

      var equipmentPresets = _.find(vm.equipmentPresets, function(element) {
        if (element.equipmentType) {
          return element.equipmentType === vm.exercise.equipmentType;
        }

        return element.category === vm.exercise.category;
      });
      selectEquipment(equipmentPresets);

      vm.exercise.assignedProfile.global = _.pick(vm.exercise.assignedProfile.global, _.map(vm.selectedEquipment.metrics, 'name'));
      vm.selectedEquipment.category = vm.exercise.category;
    }

    function setVideo(val) {
      vm.exerciseVideo = val;
    }

    function setImages(val) {
      vm.exerciseImages = val;
    }

    function handleMediaUpdate(update) {
      setImages(update.images);
      setVideo(update.video);
    }

    function editExercise() {
      return popup.confirm({
        title: $translate.instant('UPDATE_EXISTING_ASSIGNMENTS'),
        description: $translate.instant('UPDATE_EXISTING_ASSIGNMENTS_INFO'),
        okText: $translate.instant('UPDATE_EXISTING_ASSIGNMENTS_CONFIRM'),
        cancelText: $translate.instant('DO_NOT_UPDATE')
      })
        .then(function() {
          // this means they hit OK
          _updateExercise(true);
        })
        .catch(function(err) {
          if (err === 'close') {
            // this means they hit the X
            return;
          }
          // this means they hit DO_NOT_UPDATE
          _updateExercise(false);
        });
    }

    function _updateExercise(updateAssigned) {
      if (!validateExercise()) {
        return false;
      }
      vm.isLoading = true;
      exercisesService.updateExercise(exerciseId, getExerciseFormatData(), updateAssigned)
        .then(function() {
          return setAllExerciseTags();
        })
        .then(function() {
          vm.isLoading = false;
          $state.go('app.library.list', { tab: 'EXERCISES_READ' });
        })
        .catch(function() {
          vm.isLoading = false;
          toastr.error($translate.instant('ERROR_CANNOT_UPDATE_EXERCISE'));
        });
    }

    function deleteExercise() {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_EXERCISE?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_EXERCISE'),
        okText: $translate.instant('DELETE_EXERCISE')
      })
        .then(function() {
          return exercisesService.deleteExercise(exerciseId)
            .then(function() {
              $state.go('app.library.list', { tab: 'EXERCISES_READ' });
            }, function() {
              toastr.error($translate.instant('ERROR_CANNOT_DELETE_EXERCISE'));
            });
        });
    }

    function createExercise() {

      if (vm.isLoading) {
        return;
      }

      if (vm.isEdit) {
        editExercise();
        return;
      }
      if (!validateExercise()) {
        return false;
      }

      vm.isLoading = true;

      exercisesService.createExercise(getExerciseFormatData())
        .then(function(resp) {
          vm.exerciseId = resp._id;

          return setAllExerciseTags();
        })
        .finally(function() {
          vm.isLoading = false;
          $state.go('app.library.list', { tab: 'EXERCISES_READ' });
        })
        .catch(function() {
          toastr.error($translate.instant('ERROR_CANNOT_CREATE_EXERCISE'));
        });
    }

    function getExerciseFormatData() {
      var formatted = {
        title: vm.details.title,
        description: vm.exercise.description,
        chainWide: vm.details.chainWide,
        restricted: vm.details.restricted,
        featured: vm.details.featured,
        equipmentType: vm.exercise.equipmentType || vm.selectedEquipment.equipmentType,
        category: vm.selectedEquipment.category || 'Other',
        video: vm.exerciseVideo,
        assignedProfile: makeAssignedProfile(),
        preset: _.pick(vm.selectedEquipment, 'maxSegments', 'metrics'),
        tags: _.uniq(_.map(vm.exerciseTags, 'tag'))
      };

      if (vm.exerciseImages && vm.exerciseImages.length) {
        formatted.images = vm.exerciseImages;
      }
      if (!formatted.equipmentType || formatted.equipmentType === undefined || formatted.equipmentType === null) {
        formatted.equipmentType = '';
      }
      return formatted;
    }

    function validateExercise() {
      if (!vm.selectedEquipment) {
        toastr.warning($translate.instant('WARN_CHOOSE_EQUIPMENT_TYPE'));
        return false;
      }

      if (!vm.details.title) {
        toastr.warning($translate.instant('WARN_SET_EXERCISE_TITLE'));
        return false;
      }

      return true;
    }

    function selectEquipment(eq, fromSelectEquipmentType) {
      if (isActiveEquipment(eq)) {
        return;
      }
      vm.selectedEquipment = _.assign({}, eq);
      if (fromSelectEquipmentType) {
        vm.exercise.preset.metrics = vm.selectedEquipment.metrics;
        vm.exercise.preset.maxSegments = vm.selectedEquipment.maxSegments;
        vm.exercise.equipmentType = vm.selectedEquipment.equipmentType;
        vm.exercise.category = vm.selectedEquipment.category;
        // because we only changed deep components above, we need to angular.copy to
        // trigger $onChange in customize-exercise component
        vm.exercise = angular.copy(vm.exercise);
        // reset the global and segments if user select new equipment type
        vm.exercise.assignedProfile.global = {};
        vm.exercise.assignedProfile.segments = [];
      }
      vm.isConnected = !!vm.selectedEquipment.equipmentType;
    }

    function isActiveEquipment(eq) {
      return vm.selectedEquipment &&
        vm.selectedEquipment.equipmentType === eq.equipmentType &&
        vm.selectedEquipment.category === eq.category;
    }

    function cancelExercise() {
      popup.confirm({
        title: $translate.instant('ARE_YOU_SURE?'),
        okText: $translate.instant('YES')
      }).then(function() {
        $state.go(USER_HOME_PAGE.URL, _.extend($state.params, USER_HOME_PAGE.PARAMS));
      });
    }

    function handleExerciseUpdate(update) {
      if (update !== undefined) {
        vm.exercise = update;
      }
    }

    function makeAssignedProfile() {
      var segmentExercise = vm.selectedEquipment.maxSegments > 0;
      return {
        global: segmentExercise ? {} : vm.exercise.assignedProfile.global,
        segments: segmentExercise ? vm.exercise.assignedProfile.segments : []
      };
    }

    function getExerciseTags() {
      return exercisesService.getExerciseTags(vm.exerciseId)
        .then(function(exerciseTags) {
          vm.exerciseTags = exerciseTags;
        });
    }

    function getAvailableExerciseTags() {
      return exercisesService.getAvailableExerciseTags()
        .then(function(availableTags) {
          vm.availableTags = availableTags.all;
        });
    }

    function differenceByTag(tag) {
      return tag.tag;
    }

    function setAllExerciseTags() {
      if (!vm.tagUpdatePermission) {
        return;
      }

      return exercisesService.getExerciseTags(vm.exerciseId)
        .then(function(currentTags) {
          return $q.all(
            // Find tags to add
            _.map(_.differenceBy(vm.exerciseTags, currentTags, differenceByTag), function(tag) {
              return exercisesService.setExerciseTag(vm.exerciseId, tag.tag);
            }).concat(
              // Find tags to remove
              _.map(_.differenceBy(currentTags, vm.exerciseTags, differenceByTag), function(tag) {
                if (!tag._id) {
                  return;
                }

                return exercisesService.removeExerciseTag(vm.exerciseId, tag._id);
              })
            )
          );
        });
    }

    function createTagObject(tag) {
      // Tag is a valid string (not just spaces)
      if (!validTag.test(tag)) {
        return;
      }

      // Avoid duplicates
      if (vm.exerciseTags.findIndex(function(existingTag) {
        return existingTag.tag === tag;
      }) > -1) {
        return;
      }

      return {
        tag: tag
      };
    }
  }

}());

TrainingProgramTemplateController.$inject = ['$state', 'printService', 'savedTrainingPlanService', 'popup', '$translate'];angular.module('ptCrm')
  .controller('TrainingProgramTemplateController', TrainingProgramTemplateController);

function TrainingProgramTemplateController($state, printService, savedTrainingPlanService, popup, $translate) {
  var vm = this;

  vm.editId = $state.params.id;
  vm.currentTab = 'selectTime';
  vm.trainingProgramName = '';

  init();

  function init() {
    if (vm.editId) {
      return savedTrainingPlanService.getTrainingPlan(vm.editId)
      .then(function(savedPlan) {
        vm.handleNameChange(savedPlan.planName);
        vm.changeWeeks(savedPlan.repeats);
        vm.changeTrainingSessions(_getTrainingSessionsFromWorkouts(savedPlan.workouts));
        vm.changeTrainingPlansExercise(_getExercisesFromWorkouts(savedPlan.workouts));
      });
    }
  }

  vm.handleNameChange = function(newName) {
    vm.trainingProgramName = newName;
  };

  vm.changeWeeks = function(newWeeks) {
    vm.weeks = newWeeks;
  };

  vm.changeTrainingSessions = function(newSessions) {
    if (vm.trainingSessions && (vm.trainingSessions.length < newSessions.length) && vm.trainingPlansExercise) {
      vm.trainingPlansExercise.push([]);
    }

    if (vm.trainingSessions && (vm.trainingSessions.length > newSessions.length) && vm.trainingPlansExercise) {
      var deletedIdx = _.differenceBy(vm.trainingSessions, newSessions, 'idx')[0].idx;
      if (vm.trainingPlansExercise[deletedIdx]) {
        vm.trainingPlansExercise.splice(deletedIdx, 1);
      }
    }
    vm.trainingSessions = _reIndexTrainingSessions(newSessions);
  };

  vm.changeTrainingPlansExercise = function(newExercises) {
    vm.trainingPlansExercise = newExercises;
  };

  vm.changeTab = function(newTab) {
    vm.currentTab = newTab;
  };

  vm.showPDF = function() {
    return printService.printOnTheFlyTrainingPlan(_makeSavedPlanBody());
  };

  vm.save = function() {
    var body = _makeSavedPlanBody(),
      promise;

    if (vm.editId) {
      promise = savedTrainingPlanService.editTrainingPlan(body, vm.editId);
    } else {
      promise = savedTrainingPlanService.createTrainingPlan(body);
    }

    vm.savingTrainingPlan = true;
    return promise
    .then(function() {
      vm.savingTrainingPlan = false;
      $state.go('app.library.list', { tab: 'training-programs' });
    })
    .catch(function(error) {
      if (error.status === 409) {
        return popup.alert({
          title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
          description: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM_MESSAGE')
        });
      }
      return popup.alert({
        title: $translate.instant('ERROR_SAVING_TRAINING_PROGRAM'),
        description: error
      });
    })
    .finally(function() {
      vm.savingTrainingPlan = false;
    });
  };

  function _reIndexTrainingSessions(sessions) {
    return sessions.map(function(session, index) {
      session.idx = index;
      return session;
    });
  }

  function _generateWorkouts() {
    return vm.trainingSessions.map(function(session, index) {
      return {
        name: session.name,
        exercises: vm.trainingPlansExercise[index]
      };
    });
  }

  function _makeSavedPlanBody() {
    return {
      planName: vm.trainingProgramName,
      workoutsToShow: vm.trainingSessions.length,
      repeats: vm.weeks,
      workouts: _generateWorkouts()
    };
  }

  function _getTrainingSessionsFromWorkouts(workouts) {
    var arr = [];
    workouts.forEach(function(item, index) {
      arr.push({
        name: item.name,
        idx: index
      });
    });
    return arr;
  }

  function _getExercisesFromWorkouts(workouts) {
    var arr = [];
    workouts.forEach(function(item) {
      arr.push(item.exercises);
    });
    return arr;
  }
}angular.module('ptCrm').controller('maintenanceCtrl', function() {
  this.refresh = function() {
    window.location.hash = '';
    window.location.reload();
  };
});(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('PrivacyController', ['$scope', '$rootScope', '$state', '$translate', '$window', function($scope,$rootScope, $state,$translate,$window) {
      var vm = this;
      $scope.imageSrc=$translate.instant('ICON_ARROW_LEFT');
      $scope.data = $translate.instant('PRIVACY_POLICY_CONTENT');
      $scope.navigateToLoginPage = function() {
        return $window.history.back();
      };
    }]);
}());

(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('TermsOfUseController', ['$scope', '$rootScope', '$state', '$translate', '$window', function($scope,$rootScope, $state,$translate,$window) {
      var vm = this;
      $scope.imageSrc=$translate.instant('ICON_ARROW_LEFT');
      $scope.data = $translate.instant('TERMS_OF_USE_CONTENT');
      $scope.navigateToLoginPage = function() {
        return $window.history.back();
      };
    }]);
}());

(function() {
  'use strict';
  angular.module('ptCrm').controller('TermsAndConditionsCtrl', ['$scope', '$state', '$translate', function($scope,$state,$translate) {
    this.date=new Date().getFullYear();
    this.imageSrc=$translate.instant('ICON_LOGO_MATRIX_WHITE');
    this.navigateToPrivacyPolicy = function() {
      return $state.go('privacy');
    };
    this.navigateToTermsOfUsePolicy = function() {
      return $state.go('termsofuse');
    };
  }]);
}());

(function() {
  'use strict';

  angular.module('ptCrm')
    .controller('PermissionGroupsCtrl', ['permissionGroupsService', 'permissionsService', '$translate', 'popup', 'profileService', '$q', function(permissionGroupsService, permissionsService,
      $translate, popup, profileService, $q) {
      var vm = this;

      vm.forms = {};
      vm.copy = copy;
      vm.remove = remove;
      vm.add = add;
      vm.save = save;
      vm.reset = reset;
      vm.formDirty = formDirty;
      vm.dirtyOverride = false;

      vm.myPermissons = {};
      vm.permissionGroups = {};
      vm.masterPermissions = null;

      loadPermissions();

      function loadPermissions() {
        $q.all({
          groups: permissionGroupsService.getGroups(),
          myPermissons: permissionsService.getStaffUserPermissions(profileService.user._id),
          masterPermissions: permissionsService.getMasterPermissions()
        }).then(setInitState);
      }

      function setInitState(response) {
        vm.permissionGroups = response.groups.data;
        vm.myPermissons = response.myPermissons;
        vm.backup = angular.copy(vm.permissionGroups);
        var invertedMasterPermissionSubjects = _.map(response.masterPermissions.subjects, function(subject) {
          return {
            name: subject.name,
            options: _.mapValues(subject.options, function(){
              return false;
            })
          };
        });
        vm.masterPermissions = invertedMasterPermissionSubjects;
        _.each(vm.permissionGroups, function(perm){
          perm.subjects = _mergeMasterPermissions(perm.subjects, vm.masterPermissions);
        });
        if (vm.permissionGroups[0]) {
          vm.blank = createBlank(vm.permissionGroups[0]);
        } else {
          getFormattedGroup().then(function(emptyGroup) {
            vm.blank = createBlank(emptyGroup);
          });
        }
      }

      // ============ Methods =============
      function add() {
        var group = angular.copy(vm.blank);
        group._isNew = true;
        group._virtualId = getVirtualId();
        delete group._id;
        vm.permissionGroups.push(group);
        vm.dirtyOverride = true;
      }

      function save() {
        popup.confirm({
          title: $translate.instant('ARE_YOU_SURE_SAVE?'),
          description: $translate.instant('CHANGED_GROUP_PERMISSION'),
          templateUrl: '/app/settings/tabs/permissionGroups/deleteGroup.html',
          okText: $translate.instant('SAVE_CHANGES')
        }).then(function() {
          return updateGroups();
        }).then(function() {
          reset();
        });
      }

      function reset() {
        vm.permissionGroups = angular.copy(vm.backup);
        vm.dirtyOverride = false;
      }

      function formDirty() {
        return _.some(vm.forms, function(form) {
          return form ? form.$dirty : false;
        }) || vm.dirtyOverride;
      }

      function remove(group) {
        var userGroups = vm.myPermissons.groups;
        var popupContent = {
          templateUrl: '/app/settings/tabs/permissionGroups/deleteGroup.html',
          okText: $translate.instant('DELETE_GROUP')
        };

        if (_.includes(userGroups, group._id)) {
          popupContent = _.extend(popupContent, {
            title: $translate.instant('ARE_YOU_SURE?'),
            description: $translate.instant('ADMINISTRATE_PERMISSION')
          });
        } else {
          popupContent = _.extend(popupContent, {
            title: $translate.instant('DELETE_THIS_GROUP?'),
            description: $translate.instant('PLEASE_CONFIRM_DELETE_GROUP'),
            scope: {
              group: group
            }
          });
        }
        popup.confirm(popupContent).then(function() {
          group.isDeleted = true;
          vm.dirtyOverride = true;
        });
      }

      function copy(group) {
        var newGroup = angular.copy(group);
        newGroup._isNew = true;
        newGroup._virtualId = getVirtualId();
        delete newGroup._id;

        // shouldn't be able to create duplicate default roles
        delete newGroup.role;
        newGroup.isDefault = false;

        vm.permissionGroups.push(newGroup);
        permissionGroupsService.createGroup(newGroup).then(function(data) {
          _updateGroupId(newGroup, data);
        });
        delete newGroup._isNew;
      }

      // =========== PRIVATE METHODS ==========
      function updateGroups() {
        let updatedPermissionGroups = [],
         promises = [];
      
        _.each(vm.permissionGroups, function(permissionGroup) {
          let backupList = angular.copy(permissionGroup);
          backupList.subjects = _filterTruthyOptions(backupList.subjects);
      
          if (backupList.isDeleted) {
            if (!backupList._isNew) {
              promises.push(permissionGroupsService.deleteGroup(backupList._id));
            }
          } else if (backupList._isNew) {
            promises.push(
              permissionGroupsService.createGroup(backupList).then(function(data) {
                _updateGroupId(backupList, data);
                delete backupList._isNew;
                delete permissionGroup._isNew;
                permissionGroup._id = data._id;
                updatedPermissionGroups.push(permissionGroup);
              })
            );
          } else if (vm.forms[permissionGroup._id || permissionGroup._virtualId].$dirty) {
            promises.push(permissionGroupsService.setGroups(backupList));
            updatedPermissionGroups.push(permissionGroup);
          } else {
            updatedPermissionGroups.push(permissionGroup);
          }
          vm.forms[permissionGroup._id || permissionGroup._virtualId].$setPristine();
        });
        return Promise.all(promises).then(function() {
          vm.backup = angular.copy(updatedPermissionGroups);
        });
      }
      

      function _filterTruthyOptions(backupList){
        return backupList.filter(function(item){
          item.options = Object.entries(item.options)
          .reduce(function(result, key) {
            if (key[1]) {
              result[key[0]] = key[1];
            }
            return result;
          }, {});
          return !_.isEmpty(item.options);
        });
      }

      function _mergeMasterPermissions(permGrp, masterPermissions){
        var newMasterPermissions = angular.copy(masterPermissions);
        for(var i = 0, l = newMasterPermissions.length; i < l; i++) {
          for(var j = 0, ll = permGrp.length; j < ll; j++) {
            if(newMasterPermissions[i].name === permGrp[j].name) {
              for(var key in newMasterPermissions[i].options) {
                if(key in permGrp[j].options){
                  newMasterPermissions[i].options[key] = permGrp[j].options[key];
                }
              }
              break;
            }
          }
        }
        return newMasterPermissions; 
      }

      function createBlank(permissionGroup) {
        var blank = angular.copy(permissionGroup);
        blank.name = $translate.instant('NEW_PERMISSION_GROUP');
        blank.subjects = _mergeMasterPermissions(blank.subjects, vm.masterPermissions);
        blank.subjects = _.sortBy(blank.subjects, 'name');
        _.each(blank.subjects, function(subject) {
          _.each(subject.options, function(option, key) {
            subject.options[key] = false;
          });
        });
        delete blank.role;
        // blank permission grups shouldn't be a 'default' permission group
        blank.isDefault = false;

        return blank;
      }

      function _updateGroupId(group, data) {
        group._id = data._id;

        delete group._virtualId;
        vm.backup = angular.copy(vm.permissionGroups);
      }

      function getFormattedGroup() {
        return permissionGroupsService.getSubjects().then(function(subjects) {
          var emptyGroup = {
            subjects: _.map(subjects, function(subject) {
              return {
                name: subject.name,
                options: _.invert(subject.options)
              };
            })
          };
          return emptyGroup;
        });
      }

      function getVirtualId() {
        return _.uniqueId('virtual_');
      }

    }]);
}());
(function() {
  'use strict';

  permissionGroupsService.$inject = ['$http', 'config'];
  angular.module('ptCrm')
    .service('permissionGroupsService', permissionGroupsService);

  function permissionGroupsService($http, config) {
    return {
      getGroups: getPermissionGroups,
      setGroups: updatePermissionGroups,
      getSubjects: getAvailablePermissionSubjects,
      deleteGroup: deletePermissionGroup,
      createGroup: createPermissionGroup
    };

    function getPermissionGroups() {
      return $http.get(config.apiBase + '/permission_groups?isCRM=true')
      .then(function(response) {
        return response.data;
      });
    }

    function updatePermissionGroups(permissionGroup) {
      return $http.put(config.apiBase + '/permission_groups/' + permissionGroup._id + '?isCRM=true', {
        name: permissionGroup.name,
        subjects: permissionGroup.subjects
      });
    }

    function deletePermissionGroup(permissionGroupId) {
      return $http.delete(config.apiBase + '/permission_groups/' + permissionGroupId + '?isCRM=true');
    }

    function createPermissionGroup(permissionGroups) {
      return $http.post(config.apiBase + '/permission_groups?isCRM=true', {
        name: permissionGroups.name,
        subjects: permissionGroups.subjects
      }).then(function(response) {
        return response.data;
      });
    }


    function getAvailablePermissionSubjects() {
      return $http.get(config.apiBase + '/permission_subjects?isCRM=true').then(function(response) {
        return response.data;
      });
    }
  }
}());


(function() {
  'use strict';

  angular.module('ptCrm')
    .controller('FacilitySettingsCtrl', ['$translate', 'popup', 'profileService', '$q', 'config', 'facilityService', 'permissionsService', '$uibModal', '$state', 'PermissionStore', function($translate, popup, profileService, $q, config, facilityService, permissionsService, $uibModal, $state, PermissionStore) {
      var vm = this;

      vm.facility = {};
      vm.languages = config.availableLanguages.map(function(langCode) { return langCode.toUpperCase(); });
      vm.save = save;
      vm.reset = reset;
      vm.canChangeMembershipGroups = canChangeMembershipGroups;

      vm.membershipGroup = [];

      vm.editMembership = editMembership;
      vm.deleteMembership = deleteMembership;
      vm.createMembership = createMembership;

      facilityService.getFacility(profileService.user.activeFacility._id)
        .then(function(facility) {
          vm.facility = setDefaults(facility);
          vm.backup = angular.copy(vm.facility);
        });

      facilityService.getFacilityMembershipGroups(profileService.user.activeFacility._id)
        .then(function(groups) {
          vm.membershipGroup = groups;
          vm.membershipGroup.map(function(group) {
            facilityService.getMembershipGroupMembers(profileService.user.activeFacility._id, group._id)
              .then(function(members) {
                group.members = members;
              });
          });
        });

      function save() {
        popup.confirm({
          title: $translate.instant('ARE_YOU_SURE_SAVE?'),
          okText: $translate.instant('SAVE_CHANGES')
        }).then(function() {
          vm.facility._id = undefined;
          vm.facility.riskSettings = undefined;
          vm.facility.permissionGroups = undefined;
          if (vm.facility.masterFacility === null) {
            vm.facility.masterFacility = undefined;
          }
          facilityService.updateFacility(vm.facility, profileService.user.activeFacility._id)
            .then(function() {
              vm.backup = angular.copy(vm.facility);
              vm.forms.settings.$setPristine();
            });
        });
        vm.forms.settings.$setPristine();
      }

      function reset() {
        vm.facility = angular.copy(vm.backup);
        vm.forms.settings.$setPristine();
      }

      function setDefaults(facility) {
        if (!facility.settings) {
          facility.settings = {};
        }

        if (!facility.settings.notices) {
          facility.settings.notices = {};
        }

        ['trainerAssignedChanged',
          'workoutAssignedChanged',
          'administrative',
          'taskAssignmentChange',
          'atRisk',
          'noteCreated'].forEach(function(key) {
          if (!facility.settings.notices[key]) {
            facility.settings.notices[key] = false;
          }
        });
        return facility;
      }
      function canChangeMembershipGroups(permissionList) {
        var permissions = Object.keys(PermissionStore.getStore());
        function includesValue(mainArr, target) {
          return target.some(function(value) {
            return mainArr.includes(value);
          });
        }
        return includesValue(permissions, permissionList);
      }

      function editMembership(membership) {
        var index = vm.membershipGroup.findIndex(function(group) {
            return group.name === membership.name;
          }),
          selectedMembership = vm.membershipGroup[index];
        $uibModal.open({
          windowClass: 'edit-membership-modal',
          templateUrl: '/app/settings/tabs/membership-groups/edit-membership-group.html',
          controller: 'editMembershipGroupCtrl',
          controllerAs: 'editCtrl',
          bindToController: true,
          resolve: {
            membershipGroup: function() {
              return selectedMembership;
            },
            facilityId: function() {
              return vm.facility._id;
            }
          }
        }).result.then(function(data) {
          selectedMembership.name = data.newGroupName;
          vm.membershipGroup[index] = selectedMembership;
          $state.reload();
        });
      }

      function deleteMembership(membership) {
        var index = vm.membershipGroup.findIndex(function(group) {
            return group.name === membership.name;
          }),
          selectedMembership = vm.membershipGroup[index];
        $uibModal.open({
          templateUrl: '/app/settings/tabs/membership-groups/delete-membership-group.html',
          controller: 'deleteMembershipGroupCtrl',
          controllerAs: 'deleteCtrl',
          bindToController: true,
          resolve: {
            membershipGroup: function() {
              return selectedMembership;
            },
            facilityId: function() {
              return vm.facility._id;
            }
          }
        }).result.then(function(data) {
          vm.membershipGroup.splice(index, 1);
        });
      }

      function createMembership() {
        $uibModal.open({
          windowClass: 'add-membership-modal',
          templateUrl: '/app/settings/tabs/membership-groups/add-membership-group.html',
          controller: 'addMembershipGroupCtrl',
          controllerAs: 'addCtrl',
          bindToController: true,
          resolve: {
            facilityId: function() {
              return vm.facility._id;
            }
          }
        }).result.then(function(data) {
          vm.membershipGroup.push(data.newMembershipGroup);
          $state.reload();
        });
      }

    }]);
}());

(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('SettingsController', function() {
      var vm = this;

      vm.colorpickers = {
        main: false,
        action: false,
        selected: false,
        inTheGym: false
      };
      vm.selectedColorPicker = '';

      vm.onColorCheckboxClick = onColorCheckboxClick;
      vm.updateColor = updateColor;
      vm.resetColor = resetColor;

      function onColorCheckboxClick(colorName) {
        Object.keys(vm.colorpickers).map(function(key) {
          if (key !== colorName) {
            vm.colorpickers[key] = false;
          }
        });
        vm.selectedColorPicker = colorName;
      }

      function updateColor(color) {
        color.currentColor = color.newColor;
        closeColorPickerDropdown();
      }

      function resetColor(color) {
        color.newColor = color.currentColor;
        closeColorPickerDropdown();
      }

      function closeColorPickerDropdown() {
        Object.keys(vm.colorpickers).map(function(value) {
          vm.colorpickers[value] = false;
        });
      }


      // TODO: @afilenko remove when data will be received from server
      vm.mainColor = {
        currentColor: 'rgb(103, 130, 138)',
        newColor: 'rgb(103, 130, 138)'
      };

      vm.actionColor = {
        currentColor: 'rgb(21, 92, 150)',
        newColor: 'rgb(21, 92, 150)'
      };

      vm.selectedColor = {
        currentColor: 'rgb(245, 177, 32)',
        newColor: 'rgb(245, 177, 32)'
      };

      vm.inTheGymColor = {
        currentColor: 'rgb(34, 55, 69)',
        newColor: 'rgb(34, 55, 69)'
      };
    });
}());
(function() {
  'use strict';
  angular.module('ptCrm')
    .controller('RiskController', ['riskService', 'popup', '$translate', function RiskCtrl(riskService, popup, $translate) {
      var vm = this;
      vm.risks = {};
      vm.form = {};

      vm.save = save;
      vm.reset = init;

      init();

      function init() {
        riskService.getRisks().then(function(risks) {
          vm.risks = risks;
          vm.form.$setPristine();
        });
      }

      function save(risks) {
        var isValid = _.every(risks, isNaturalNumber);
        if (isValid) {
          riskService.updateRisks(risks)
            .then(function() {
              vm.form.$setPristine();
            });
        } else {
          popup.alert({
            title: $translate.instant('ONLY_NATURAL_NUMBERS')
          });
        }
      }

      function isNaturalNumber(str) {
        var pattern = /^(0|([1-9]\d*))$/;
        return pattern.test(str);
      }

    }]);
}());
angular.module('ptCrm').controller('editMembershipGroupCtrl', ['$uibModalInstance', 'membershipGroup', 'facilityId', 'facilityService', 'userService', 'exercisersService', function($uibModalInstance, membershipGroup, facilityId, facilityService, userService, exercisersService) {
  var vm = this;
  vm.membershipGroup = membershipGroup;
  vm.facilityId = facilityId;
  vm.clientsList = exercisersService.getClientPaginateList();
  vm.loadUsers = loadUsers;
  vm.oldMembershipGroupTitle = vm.membershipGroup.name;
  vm.newMembershipGroupTitle = vm.oldMembershipGroupTitle;
  vm.checkedUsers = [];
  vm.originalUsers = [];
  vm.users = [];
  vm.searchedUsers = [];
  vm.isLoading = true;

  loadUsers();

  function loadUsers() {
    vm.clientsList.load();
  }

  facilityService.getMembershipGroupMembers(vm.facilityId, vm.membershipGroup._id)
    .then(function(result) {
      vm.checkedUsers = _.map(result, function(user) {
        return user.userId;
      });
      vm.originalUsers = vm.checkedUsers.slice();
    });

  vm.duplicateCheck = function() {
    return vm.duplicateText && vm.newMembershipGroupTitle === vm.duplicateText;
  };

  vm.submit = function() {
    vm.loading = true;
    facilityService.updateMembershipGroup(vm.facilityId, vm.membershipGroup._id, vm.newMembershipGroupTitle)
      .then(function() {
        vm.membershipGroup.name = vm.newMembershipGroupTitle;
        for (var j = 0; j < vm.originalUsers.length; j++) { // eslint-disable-line
          if (!vm.checkedUsers.includes(vm.originalUsers[j])) {
            removeUserFromGroup(vm.originalUsers[j]);
          }
        }
        var groupId = []; // eslint-disable-line
        groupId.push(vm.membershipGroup._id);
        for (var i = 0; i < vm.checkedUsers.length; i++) { // eslint-disable-line
          userService.updateClientUserMembershipGroups(vm.facilityId, vm.checkedUsers[i], groupId, true);
        }
        vm.loading = false;
        $uibModalInstance.close({ newGroupName: vm.membershipGroup.name, updatedGroupId: vm.membershipGroup._id });
      })
      .catch(function(err) {
        if (err.status === 400) {
          vm.duplicateText = vm.newMembershipGroupTitle;
          vm.loading = false;
        }
      });
  };

  vm.dismiss = function() {
    if (!vm.loading) {
      $uibModalInstance.dismiss();
    }
  };

  vm.checkAll = function($event) {
    var checkbox = $event.target;
    if (checkbox.checked) {
      for (var i = 0; i < vm.users.length; i++) { // eslint-disable-line
        if (!vm.shouldBeChecked(vm.users[i]._id)) {
          vm.checkedUsers.push(vm.users[i]._id);
        }
      }
    } else {
      for (var j = 0; j < vm.users.length; j++) { // eslint-disable-line
        var index = vm.checkedUsers.indexOf(vm.users[j]._id); // eslint-disable-line
        vm.checkedUsers.splice(index, 1);
      }
    }
  };

  vm.addToCheckedUsers = function($event, id) {
    var checkbox = $event.target;
    if (checkbox.checked) {
      vm.checkedUsers.push(id);
    } else {
      var index = vm.checkedUsers.indexOf(id); // eslint-disable-line
      vm.checkedUsers.splice(index, 1);
      vm.allChecked = false;
    }
  };

  vm.shouldBeChecked = function(id) {
    return vm.checkedUsers.includes(id);
  };

  function removeUserFromGroup(currentUser) {
    userService.getUserMembershipGroups(vm.facilityId, currentUser) //eslint-disable-line
      .then(function(groups) {
        groups = [];
        groups.push(vm.membershipGroup._id);
        userService.deleteUserMembershipGroup(vm.facilityId, currentUser, groups);
      });
  }

  vm.searchByName = function() {
    vm.clientsList
    .extendDefaultParams({ search: vm.search })
    .load({ update: true });
  };
}]);angular.module('ptCrm').controller('deleteMembershipGroupCtrl', ['$uibModalInstance', 'membershipGroup', 'facilityId', 'facilityService', function($uibModalInstance, membershipGroup, facilityId, facilityService) {
  var vm = this;
  vm.membershipGroup = membershipGroup;
  vm.facilityId = facilityId;
  vm.submit = function() {
    vm.loading = true;
    facilityService.deleteMembershipGroup(vm.facilityId, vm.membershipGroup._id)
      .then(function() {
        vm.loading = false;
        $uibModalInstance.close({ deletedGroup: vm.membershipGroup._id });
      });
  };
  vm.dismiss = function() {
    if (!vm.loading) {
      $uibModalInstance.dismiss();
    }
  };
}]);angular.module('ptCrm').controller('addMembershipGroupCtrl', ['$uibModalInstance', 'facilityId', 'facilityService', 'userService', 'profileService', 'exercisersService', function($uibModalInstance, facilityId, facilityService, userService, profileService, exercisersService) {
  var vm = this;
  vm.clientsList = exercisersService.getClientPaginateList();
  vm.facilityId = facilityId;
  vm.users = [];
  vm.loadUsers = loadUsers;
  vm.checkedUsers = [];
  vm.searchedUsers = [];
  vm.isLoading = true;

  loadUsers();

  vm.duplicateCheck = function() {
    return vm.duplicateText && vm.newMembershipGroupTitle === vm.duplicateText;
  };

  function loadUsers() {
    vm.clientsList.load();
  }

  vm.submit = function() {
    vm.loading = true;
    facilityService.createMembershipGroup(vm.facilityId, vm.newMembershipGroupTitle)
      .then(function() {
        facilityService.getFacilityMembershipGroups(vm.facilityId)
          .then(function(membershipGroups) {
            var index = membershipGroups.findIndex(function(group) {
              return group.name === vm.newMembershipGroupTitle;
            });
            vm.newMembershipGroup = membershipGroups[index];
            for (var i = 0; i < vm.checkedUsers.length; i++) { // eslint-disable-line
              var groupId = []; // eslint-disable-line
              groupId.push(vm.newMembershipGroup._id);
              userService.updateClientUserMembershipGroups(vm.facilityId, vm.checkedUsers[i], groupId, true);
            }
            vm.loading = false;
            $uibModalInstance.close({ newMembershipGroup: vm.newMembershipGroup });
          });
      })
      .catch(function(err) {
        if (err.status === 400) {
          vm.duplicateText = vm.newMembershipGroupTitle;
          vm.loading = false;
        }
      });
  };
  vm.dismiss = function() {
    if (!vm.loading) {
      $uibModalInstance.dismiss();
    }
  };

  vm.checkAll = function($event) {
    var checkbox = $event.target;
    if (checkbox.checked) {
      for (var i = 0; i < vm.users.length; i++) { // eslint-disable-line
        if (!vm.shouldBeChecked(vm.users[i]._id)) {
          vm.checkedUsers.push(vm.users[i]._id);
        }
      }
    } else {
      for (var j = 0; j < vm.users.length; j++) { // eslint-disable-line
        var index = vm.checkedUsers.indexOf(vm.users[j]._id); // eslint-disable-line
        vm.checkedUsers.splice(index, 1);
      }
    }
  };

  vm.addToCheckedUsers = function($event, id) {
    var checkbox = $event.target;
    if (checkbox.checked) {
      vm.checkedUsers.push(id);
    } else {
      var index = vm.checkedUsers.indexOf(id); // eslint-disable-line
      vm.checkedUsers.splice(index, 1);
      vm.allChecked = false;
    }
  };

  vm.shouldBeChecked = function(id) {
    return vm.checkedUsers.includes(id);
  };

  vm.searchByName = function() {
    vm.clientsList
    .extendDefaultParams({ search: vm.search })
    .load({ update: true });
  };
}]);(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('bindHtmlCompile', ['$compile', function($compile) {
      return {
        restrict: 'A',
        link: function(scope, element, attrs) {
          scope.$watch(function() {
            return scope.$eval(attrs.bindHtmlCompile);
          }, function(value) {
            element.html(value && value.toString());

            // If scope is provided use it, otherwise use parent scope
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          });
        }
      };

    }]);

}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('integerOnly', function() {
      return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
          function fromUser(text) {
            var transformedInput = String(text).replace(/[^0-9]/g, '');
            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return Number(transformedInput);
          }

          ngModelCtrl.$parsers.push(fromUser);
        }
      };
    });
}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('dragulaConfigure', function() {
      return {
        bindToController: {
          dragulaScope: '=',
          dragulaCopy: '=',
          dragulaBag: '@',
          dragulaDirection: '@',
          dragulaMoveOn: '@',
          dragulaInvalid: '@'
        },
        controllerAs: 'dragulaConf',
        controller: ['$scope', 'dragulaService', function($scope, dragulaService) {
          var vm = this;

          dragulaService.options(vm.dragulaScope, vm.dragulaBag, {
            copy: vm.dragulaCopy,
            revertOnSpill: vm.dragulaCopy,
            moves: function(el, container, handler) {

              if (vm.dragulaMoveOn) {
                return angular.element(handler).hasClass(vm.dragulaMoveOn);
              }

              return true;

            },
            invalid: function(el) {
              if (vm.dragulaInvalid) {
                return angular.element(el).hasClass(vm.dragulaInvalid);
              }
              return false;
            },
            direction: vm.dragulaDirection || 'vertical'
          });
        }]
      };
    });

}());
(function() {
  'use strict';

  angular.module('ptCrm')

    /**
     * infinite-scroll specifies a function to call when the container
     * is scrolled within a certain range from the bottom of the container
     *
     * @param {string} infinite-scroll Function from controller to be called
     * @param {boolean} can-load If set to false, infinite-scroll wont be called
     * @param {number} threshold Range in pixels, within infinite-scroll can be called
     *
     * @example
     <example>
       <ul style='height: 300px; overflow: auto;'
         infinite-scroll='updateData()'
         can-load='moreDataIsAvailable'
         threshold='30'>
         <li>lorem ipsum</li>
         ...
       </ul>
     </example>
     */

    .directive('infiniteScroll', ['$window', '$q', '$rootScope', '$timeout', function($window, $q, $rootScope, $timeout) {
      return function(scope, element, attrs) {
        var offset = parseInt(attrs.threshold, 10) || 0,
          el = element[0],
          windowEl = angular.element($window),
          debouncedScroll = _debouncedScroll(),
          isLoading = false;

        var deregisterInfiniteComplete =
          $rootScope.$on('infiniteScroll:complete', debouncedScroll);
        element.on('scroll', debouncedScroll);
        windowEl.on('resize', debouncedScroll);
        scope.$on('$destroy', _deregisterHandlers);

        function _debouncedScroll() {
          return _.debounce(function() {
            if (!isLoading &&
            scope.$eval(attrs.canLoad) &&
            el.offsetParent &&
            el.scrollTop + el.offsetHeight >= el.scrollHeight - offset) {
              isLoading = true;
              var result = scope.$apply(attrs.infiniteScroll);
              $q.when(result).finally(function() {
                _.defer(function() {
                  isLoading = false;

                  // In case user is already scrolled to bottom before
                  // the debounce process opens a window of opportunity
                  // to load more data
                  $timeout(function() {
                    _debouncedScroll();
                  }, 250); // The timeout gets passed the _.debounce timeframe
                });
              });
            }
          }, 200);
        }

        function _deregisterHandlers() {
          windowEl.off('resize', debouncedScroll);
          deregisterInfiniteComplete();
        }

      };
    }]);

}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('unixDateInput', function() {
      return {
        require: 'ngModel',
        priority: 1,
        link: function(scope, ele, attr, ngModel) {
          // view to model
          ngModel.$parsers.push(function(value) {
            return moment(value).unix();
          });

          // model to view
          ngModel.$formatters.push(function(value) {
            return value ? moment.unix(value).toDate() : null;
          });
        }
      };
    });
}());

// This directive was taken from pt-mobile project
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('chart', pieChartDirective);

  function pieChartDirective() {

    return {
      restrict: 'A',
      scope: {
        data: '='
      },
      link: linkFn
    };


    function linkFn(scope, element) {

      if (element[0].tagName.toLowerCase() !== 'canvas') {
        console.error('chart directive requires "<canvas>" element'); // eslint-disable-line no-console
        return false;
      }

      var canvas = element[0],
        context = canvas.getContext('2d'),
        defaultFillColor = '#aaaaaa';

      scope.$watch(function() {
        return scope.data;
      }, function(data) {
        if (data && data.length) {
          pie(context, canvas.width, canvas.height, data);
        }
      }, true);


      function pie(ctx, w, h, dataList) {
        var radius = h / 2;
        var centerX = w / 2;
        var centerY = h / 2;
        var lastEnd = 0;

        var offset = Math.PI / 2;
        var labelXY = [];

        // clear canvas
        context.clearRect(0, 0, w, h);

        ctx.textAlign = 'center';
        ctx.font = '30px Arial';

        var total = 0;

        for (var n = 0; n < dataList.length; n++) {
          total += dataList[n].value;
        }

        for (var x = 0; x < dataList.length; x++) {
          var sectorPart = dataList[x].value;
          ctx.beginPath();
          ctx.fillStyle = dataList[x].color || defaultFillColor;
          ctx.moveTo(centerX, centerY);
          var arcSector = Math.PI * (2 * sectorPart / total);
          ctx.arc(centerX, centerY, radius, lastEnd - offset, lastEnd + arcSector - offset, false);
          ctx.lineTo(centerX, centerY);
          ctx.fill();
          ctx.closePath();

          labelXY.push(lastEnd + arcSector / 2 + Math.PI + offset);

          lastEnd += arcSector;
        }

        var lradius = radius / 2,
          percentValuesSum = 0;

        ctx.font = 'bold 20px Arial';
        ctx.strokeStyle = 'rgb(255,255,255)';
        ctx.fillStyle = 'rgb(255,255,255)';

        for (var i = 0; i < labelXY.length; i++) {
          var langle = labelXY[i],
            dx = centerX + lradius * Math.cos(langle),
            dy = centerY + lradius * Math.sin(langle),
            percentValue = Math.round(dataList[i].value / total * 100);

          // calculate last value as diff 100 and sum of other values
          if (i !== labelXY.length - 1) {
            percentValuesSum += percentValue;
          } else {
            percentValue = 100 - percentValuesSum;
          }

          if (percentValue && percentValue > 3) {
            ctx.fillText(percentValue + '%', dx, dy);
          }
        }
      }
    }

  }
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .directive('input', function() {
      return {
        restrict: 'E',
        require: '?ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
          if (
            typeof ngModelCtrl !== 'undefined'
            && typeof attr.type !== 'undefined'
            && attr.type === 'number'
            && ngModelCtrl
          ) {
            ngModelCtrl.$formatters.push(function(modelValue) {
              return Number(modelValue);
            });

            ngModelCtrl.$parsers.push(function(viewValue) {
              return Number(viewValue);
            });
          }
        }
      };
    });
}());
(function() {

  'use strict';

  angular.module('ptCrm')
    .config(['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
      uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
      uibDatepickerPopupConfig.appendToBody = true;
    }]);
}());
(function() {
  'use strict';

  angular.module('ptCrm')
  .directive('ngMobileClick', function() {
    return function(scope, elem, attrs) {
      elem.bind('touchstart', function(e) {
        e.preventDefault();
        e.stopPropagation();

        scope.$apply(attrs.ngClick);
      });
    };
  });
}());
(function() {
  'use strict';

  angular.module('ptCrm')
  .directive('ngIscrollTap', function() {
    return function(scope, elem, attrs) {
      elem.bind('tap', function(e) {
        e.preventDefault();
        e.stopPropagation();

        scope.$apply(attrs.ngClick);
      });
    };
  });
}());
(function() {
  'use strict';

  angular.module('ptCrm')
    .directive('matchWidthToValue', function() {
      return {
        require: 'ngModel',
        priority: 1,
        link: function(scope, ele, attr, ngModel) {

          function setWidth(value) {
            var newWidth = '1em';
            if (value) {
              newWidth = ((+value.toString().length + 1) * 0.5) + 'em';
            }
            ele[0].style.width = newWidth;
          }

          // view to model
          ngModel.$parsers.push(function(value) {
            setWidth(value);
            return value;
          });

          // model to view
          ngModel.$formatters.push(function(value) {
            setWidth(value);
            return value;
          });
        }
      };
    });
}());
/**
 * Directive: sets the cursors focus upon an action
 */
angular.module('ptCrm').directive('focusMe', ['$parse', function($parse) {
  return {
    link: function(scope, element, attrs) {
      var model = $parse(attrs.focusMe);
      scope.$watch(model, function(value) {
        if (value === true) {
          setTimeout(function() {
            element[0].focus();
            element[0].select();
          });
        }
      });

      element.bind('blur', function() {
        scope.$apply(model.assign(scope, false));
      });
    }
  };
}]);/**
 * Directive: auto resizes the width of the input based on it's input
 */
angular.module('ptCrm').directive('autoResizeInput', function() {
  return {
    scope: {
      ngModel: '='
    },
    controller: function() {

      // checks that input needs to be resized
      this.$doCheck = function() {
        if (this.myInput !== undefined && this.mySpan !== undefined) {
          resizeInput(this.mySpan, this.myInput);
        }
      };
    },
    link: function(scope, element, attr, controller) {
      var mySpan = angular.element('<span class = "myHidden">spancontent</span>');
      controller.mySpan = mySpan;
      // jqueryLite magic to add our span before the input for proper width calculations
      element.parent()[0].insertBefore(mySpan[0], element[0]);

      var myInput = element[0];
      element.addClass('autoResizeInput');
      controller.myInput = myInput;

      resizeInput(mySpan, myInput);

      scope.$watch('ngModel', function(newValue) {
        if (newValue !== undefined) {
          resizeInput(mySpan, myInput);
        }
      }, true);
    }
  };
});

// span is used for calculating desired width of input
function resizeInput(mySpan, myInput) {
  setTimeout(function() {
    // .offsetWidth is ONLY available if metric is viewable on the screen
    // ie if the input is hidden in another "tab", offsetWidth is NOT defined
    if (mySpan[0] && mySpan[0].offsetWidth >= 0) {
      mySpan[0].textContent = myInput.value || 0;
      myInput.style.width = mySpan[0].offsetWidth + 'px';
    }
  });
}
angular.module('ptCrm').directive('durationValidation', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, modelCtrl) {

      modelCtrl.$parsers.push(function(inputValue) {
        var max = +attrs.durationValidation,
          transformedInput = inputValue.replace(/[^0-9]/g, '');

        if (+transformedInput > max) {
          transformedInput = '' + max;
        } else if (+transformedInput < 0) {
          transformedInput = '' + 0;
        }

        if (transformedInput !== inputValue) {
          modelCtrl.$setViewValue(transformedInput);
          modelCtrl.$render();
        }

        return transformedInput;
      });
    }
  };
});angular.module('ptCrm').directive('fileDrop', ['fileVerify', function(fileVerify) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);
      element.bind('drop', dropHandler);

      function dropHandler(angularEvent) {
        var event = angularEvent.originalEvent || angularEvent;
        var files = event.dataTransfer.files;
        event.preventDefault();
        var filesOutput = [];
        for (var i = 0; i < files.length; i++) {
          filesOutput.push(files.item(i));
        }

        var allowedFiles = fileVerify.verifyFileList(filesOutput);
        if (allowedFiles.length !== filesOutput.length) {
          scope.$eval(attrs.onFileError)();
        }
        if (allowedFiles.length) {
          scope.$eval(attrs.onFileDrop)(allowedFiles);
        }
      }
      function processDragOverOrEnter(angularEvent) {
        var event = angularEvent.originalEvent || angularEvent;
        if (event) {
          event.preventDefault();
        }
      }
    }
  };
}]);angular.module('ptCrm').directive('fileRead', ['fileVerify', function(fileVerify) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.bind('change', changeHandler);

      function changeHandler(angularEvent) {
        var event = angularEvent.originalEvent || angularEvent;
        var files = event.target.files;
        event.preventDefault();
        var filesOutput = [];
        for (var i = 0; i < files.length; i++) {
          filesOutput.push(files.item(i));
        }
        var allowedFiles = fileVerify.verifyFileList(filesOutput);
        if (allowedFiles.length !== filesOutput.length) {
          scope.$eval(attrs.onFileError)();
        }
        if (allowedFiles.length) {
          scope.$eval(attrs.onFileRead)(allowedFiles);
        }
      }
    }
  };
}]);(function() {
  'use strict';

  facilityAssignments.$inject = ['$scope', '$state', 'profileService', 'facilityAssignmentsService', 'popup', '$filter', '$translate', 'facilityService'];
  angular.module('ptCrm').controller('FacilityAssignmentsController', facilityAssignments);

  function facilityAssignments($scope, $state, profileService, facilityAssignmentsService, popup, $filter, $translate, facilityService) {

    var vm = this;

    vm.monthOffset = 6;
    vm.isLoading = true;

    vm.selectedDate = moment();

    $scope.$on('calendar-body:day:init', chooseDateIfReady);

    vm.showTimeline = false;
    vm.timelineDisplayDate = null;

    vm.idsWithDefaultTitles = [];

    // public methods
    vm.selectMonth = selectMonth;
    vm.chooseDate = chooseDate;
    vm.addEvent = addEvent;
    vm.showWOTDMenu = showWOTDMenu;
    vm.canAddEvent = _.includes(profileService.permissionNames, 'FACILITY_ASSIGNMENTS_CREATE');

    _calculateRange();

    function selectMonth(monthNumber, year) {
      var newDate = moment(vm.selectedDate).set('month', monthNumber).set('year', year);
      _updateSelectedDate(newDate);
      _calculateRange();

      $scope.$broadcast('calendar:month:changed', monthNumber, year);
    }

    function _updateSelectedDate(date) {
      vm.selectedDate = date;
    }

    function chooseDateIfReady() {
      var args = arguments;
      chooseDate.apply(null, args);
      vm.isLoading = false;
    }

    function chooseDate(clickEvent, day) {
      _updateSelectedDate(day.moment);
    }

    function showWOTDMenu(day) {
      vm.counter = _setDefaultTitleCounter(day);
      var dayCopy = day;
      dayCopy.events = _.sortBy(dayCopy.events, 'title');
      dayCopy.events = _setDefaultWOTDTitles(dayCopy.events);
      vm.modal = popup.show({
        title: $translate.instant('WOTDS') + ' - ' + $filter('dateFormatter')(day.moment.unix(), 'dateShort'),
        showCancel: false,
        showOk: false,
        templateUrl: '/app/facilityAssignments/facility-assignments.modal.html',
        cssClass: 'modal--select-from-list',
        backdrop: 'static',
        scope: {
          day: dayCopy,
          addEvent: addEvent,
          shouldDisable: shouldDisable,
          displayNumberOfGroups: displayNumberOfGroups
        }
      });
    }

    function addEvent(event, scope, day) {
      if (shouldDisable(day)) {
        return;
      }

      var params = {
        id: event !== 'new' ? event._id : event,
        counter: event !== 'new' ? vm.counter : ++vm.counter
        // counter: vm.counter
      };

      if (vm.idsWithDefaultTitles.includes(params.id)) {
        params.title = event.title;
      }

      if (params.id === 'new') {
        if (!vm.canAddEvent) {
          return;
        }
        facilityAssignmentsService.setNewAssignmentDate(vm.selectedDate.startOf('day').unix(), vm.selectedDate.endOf('day').unix());
      }
      if (scope) {
        scope.cancel();
      }
      return $state.go('app.facility_assignment', params);
    }

    function shouldDisable(day) {
      return day && !day.current && !moment().isBefore(day.moment);
    }

    function _calculateRange() {
      var range,
        selectedDate = moment(vm.selectedDate)
          .set('date', 1)
          .subtract(vm.monthOffset, 'months');

      range = [{
        number: selectedDate.month(),
        displayText: selectedDate.format('MM'),
        year: selectedDate.format('YYYY')
      }];

      vm.fromYear = selectedDate.year();
      for (var month = 0; month < 11; month++) {
        selectedDate.add(1, 'months');
        range.push({
          number: selectedDate.month(),
          displayText: selectedDate.format('MM'),
          year: selectedDate.format('YYYY')
        });
      }
      vm.toYear = selectedDate.year();

      vm.monthRange = range;
    }

    function _setDefaultTitleCounter(day) {
      var highestNum = 0;
      if (!day.events) {
        return 0;
      }
      day.events.forEach(function(wotd) {
        if (wotd.title && wotd.title.includes('WOTD')) {
          var splitTitle = wotd.title.split('-'),
            wotdNum = parseInt(splitTitle[1], 10);
          if (wotdNum > highestNum) {
            highestNum = wotdNum;
          }
        }
      });
      return highestNum;
    }

    function _setDefaultWOTDTitles(wotds) {
      for (var i = 0; i < wotds.length; i++) {
        if (!wotds[i].title) {
          vm.counter++;
          wotds[i].title = $translate.instant('WOTD') + ' - ' + vm.counter;
          vm.idsWithDefaultTitles.push(wotds[i]._id);
        } else if (wotds[i].title && wotds[i].title.includes('WOTD')) {
          wotds[i].title = wotds[i].title.replace('WOTD', $translate.instant('WOTD'));
          vm.idsWithDefaultTitles.push(wotds[i]._id);
        }
      }
      return wotds;
    }

    function displayNumberOfGroups(event) {
      if ((event.membershipGroupIds && event.membershipGroupIds.length === 0) || !event.membershipGroupIds) {
        return $translate.instant('ALL_USERS');
      } else if (event.membershipGroupIds && event.membershipGroupIds.length === facilityService.membershipGroups.length) {
        return $translate.instant('ALL_GROUPS');
      }
      return event.membershipGroupIds.length === 1 ? event.membershipGroupIds.length + ' ' + $translate.instant('GROUP') :
        event.membershipGroupIds.length + ' ' + $translate.instant('GROUPS');
    }

  }
}());
(function() {
  'use strict';

  facilityAssignment.$inject = ['$state', '$q', '$translate', 'facilityAssignmentsService', 'popup', 'exercisesService', 'exercisersService', 'trainingSetService', '$rootScope', '$scope', '$timeout', '$filter', '$uibModal', 'facilityService', 'profileService'];
  angular.module('ptCrm').controller('FacilityAssignmentController', facilityAssignment);

  function facilityAssignment($state, $q, $translate, facilityAssignmentsService,
    popup, exercisesService, exercisersService, trainingSetService, $rootScope, $scope, $timeout, $filter, $uibModal, facilityService, profileService) {
    var vm = this,
      newAssignmentDate = facilityAssignmentsService.getNewAssignmentDate();

    vm.assignmentId = $state.params.id;
    vm.isEdit = $state.params.id !== 'new';

    vm.exercises = exercisesService.getTemplatesPaginateList({}, exercisersService.extendExercises);
    vm.trainingSets = trainingSetService.getTrainingSetsPaginateList({ withExercises: true });

    vm.exercises.label = 'EXERCISES';
    vm.exercises.load();

    vm.trainingSets.label = 'TRAINING_SETS';
    vm.trainingSets.load();

    vm.isLoading = true;
    vm.displayDate = '';

    vm.getExerciseLoadParams = getExerciseLoadParams;
    vm.save = save;
    vm.remove = remove;

    vm.handleExerciseUpdate = handleExerciseUpdate;
    vm.setActiveExerciseIndex = setActiveExerciseIndex;
    vm.handleNameChange = handleNameChange;
    vm.allGroupCount = [];
    vm.selected = [];
    vm.selectedGroup = selectedGroup;
    vm.checked = checked;
    vm.membershipGroupModal = membershipGroupModal;
    vm.allMembershipGroupIds = [];


    facilityService.getFacilityMembershipGroups(profileService.user.activeFacility._id)
      .then(function(groups) {
        vm.membershipGroups = groups;
        vm.membershipGroups.map(function(group) {
          vm.allMembershipGroupIds.push(group._id);
          return facilityService.getMembershipGroupMembers(profileService.user.activeFacility._id, group._id)
            .then(function(membershipGroupMembers) {
              group.members = membershipGroupMembers;
              group.members.forEach(function(member) {
                if (!vm.allGroupCount.includes(member.userId)) {
                  vm.allGroupCount.push(member.userId);
                }
              });
            });
        });
      });
    facilityService.getFacility(profileService.user.activeFacility._id)
      .then(function(facility) {
        vm.membershipGroupsEnabled = facility.settings.membershipGroups || false;
      });

    _init();


    function _init() {
      var initialPromise = vm.isEdit ?
        facilityAssignmentsService.getFacilityAssignmentById(vm.assignmentId) :
        $q.resolve(false);

      initialPromise.then(function(res) {
        vm.selectedExercises = res && exercisesService.extendExercises(res.exercises) || [];
        vm.startDate = res && +res.startDate || newAssignmentDate.startDate || null;
        vm.endDate = res && +res.endDate || newAssignmentDate.endDate || null;
        vm.displayDate = $filter('dateFormatter')(vm.startDate, 'dateShort');
        vm.selected = res.membershipGroupIds && res.membershipGroupIds.slice() || [];
        if ($state.params.title) {
          vm.title = $state.params.title;
          vm.defaultTitle = $state.params.title;
        } else if (res.title !== undefined && res.title !== ' ') {
          vm.title = res.title;
        } else {
          vm.title = $translate.instant('WOTD') + ' - ' + $state.params.counter;
          vm.defaultTitle = $translate.instant('WOTD') + ' - ' + $state.params.counter;
        }
        _validateDates();
      })
        .finally(function() {
          vm.isLoading = false;
        });
    }

    function selectedGroup($event, group_id) {
      var itsChecked = $event.target.checked;
      if (itsChecked) {
        if (group_id === 'All Users') {
          vm.selected = [];
          vm.allGroups = false;
        }
        if (group_id === 'All Groups') {
          vm.selected = vm.allMembershipGroupIds.slice();
        } else {
          vm.selected.push(group_id);
        }
      } else if (group_id === 'All Groups') {
        vm.selected = [];
        vm.allGroups = false;
      } else {
        vm.allGroups = false;
        // eslint-disable-next-line one-var
        var idx = vm.selected.indexOf(group_id);
        vm.selected.splice(idx, 1);
      }
    }

    function checked(group_id) {
      return _.includes(vm.selected,group_id);
    }
    function membershipGroupModal() {
      $uibModal.open({
        windowClass: 'modal--membership-group',
        controller: 'FacilityAssignmentModalController',
        controllerAs: 'facilityAssignment',
        templateUrl: '/app/facilityAssignments/facilityAssignment/tabs/membershipGroupModal.html',
        bindToController: true
      });
    }

    function _validateDates() {
      var showError = !vm.startDate || !vm.endDate,
        secondsInDayMinusOne = (24 * 60 * 60) - 1;

      // show error if there isn't the exact right distance between dates
      showError = showError ||
      moment.unix(vm.endDate).diff(moment.unix(vm.startDate), 'seconds') !== secondsInDayMinusOne;

      if (showError) {
        popup.confirm({
          title: $translate.instant('INVALID_DATE'),
          okText: $translate.instant('BACK_TO_FACILITY_ASSIGNMENTS'),
          showCancel: false,
          showBack: false,
          cancelAction: _goToFacilityAssignments
        }).then(_goToFacilityAssignments)
          .catch(_goToFacilityAssignments);
      }
    }

    function _goToFacilityAssignments() {
      $state.go('app.facility_assignments');
    }

    function getExerciseLoadParams() {
      return {
        responseExtract: exercisesService.extendExercises
      };
    }

    function activateExerciseProfileTab() {
      $timeout(function() {
        $scope.$broadcast('rzSliderForceRender');
      });
    }

    function save() {
      saveAssignment()
        .then(function() {
          return _goToFacilityAssignments();
        }, function(error) {
          var errorTitle = vm.isEdit ?
            $translate.instant('ERROR_CANNOT_UPDATE_ASSIGNMENT') :
            $translate.instant('ERROR_CANNOT_SAVE_ASSIGNMENT');

          return popup.alert({
            title: errorTitle,
            description: error
          });
        })
        .finally(function() {
          vm.isLoading = false;
        });
    }

    function remove() {
      return popup.confirm({
        title: $translate.instant('DELETE_THIS_FACILITY_ASSIGNMENT?'),
        description: $translate.instant('PLEASE_CONFIRM_DELETE_FACILITY_ASSIGNMENT'),
        okText: $translate.instant('DELETE_FACILITY_ASSIGNMENT')
      }).then(function() {
        return facilityAssignmentsService.deleteFacilityAssignment(vm.assignmentId)
          .then(function() {
            _goToFacilityAssignments();
          }, function() {
            return popup.alert({
              title: $translate.instant('ERROR_CANNOT_DELETE_FACILITY_ASSIGNMENT')
            });
          });
      });
    }

    function saveAssignment() {
      return vm.isEdit ?
        facilityAssignmentsService.updateFacilityAssignment(vm.assignmentId, _createRequestBody()) :
        facilityAssignmentsService.createFacilityAssignment(_createRequestBody());
    }

    function _createRequestBody() {
      var requestBody = {
        startDate: vm.startDate,
        endDate: vm.endDate,
        exercises: _.map(vm.selectedExercises, prepareExercise),
        title: (vm.defaultTitle !== undefined && vm.title === vm.defaultTitle) ? 'WOTD - ' + $state.params.counter : vm.title
      };
      if (!_.includes(vm.selected,'All Users')) {
        requestBody.membershipGroupIds = vm.selected;
      } else {
        requestBody.membershipGroupIds = [];
      }
      return requestBody;
    }

    function handleNameChange(newTitle) {
      vm.title = newTitle;
    }

    function handleExerciseUpdate(updatedExercise) {
      if (updatedExercise !== undefined) {
        this.selectedExercises[this.activeExerciseIndex] = updatedExercise;
      }
    }
    vm.activeExerciseIndex = 0;

    function setActiveExerciseIndex(newIndex) {
      vm.activeExerciseIndex = newIndex;
    }

    function prepareExercise(exercise) {
      exercise.exerciseTemplateId = exercise.exerciseTemplateId || exercise._id;
      return _.omit(exercise, [
        'restricted',
        'facility',
        'totalDuration',
        'completedManually',
        'pictureUrl',
        'id',
        '_id',
        'isEditable',
        'featured'
      ]);
    }
  }
}());
angular.module('ptCrm').controller('FacilityAssignmentModalController', ['$state', '$uibModalInstance', function($state, $uibModalInstance) {
  var vm = this;
  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
  vm.goToSettings = function() {
    $uibModalInstance.close();
    $state.go('app.settings');
  };
}]);(function() {
  'use strict';

  angular
    .module('ptCrm')
    .controller(
      'MessagingController',
      ['messagingService', 'profileService', '$timeout', '$q', '$rootScope', '$state', '$translate', '$sce', '$filter', function(
        messagingService,
        profileService,
        $timeout,
        $q,
        $rootScope,
        $state,
        $translate,
        $sce,
        $filter
      ) {
        var vm = this,
          otherUserInfo;
        vm.selfId = profileService.user._id;
        vm.highlightAddressBar = false;

        vm.deliberatelyTrustDangerousHtml = function(message) {
          return $sce.trustAsHtml(message);
        };

        $rootScope.$on('messageUpdate', function() {
          // update threadlist
          vm.threadList = messagingService.threadList;

          if (vm.activeThread && $state.current.name === 'app.messaging') {
            // if we're viewing a thread, update with latest thread metadata
            vm.activeThread = _.find(vm.threadList, function(thread) {
              return vm.activeThread.threadId === thread.threadId;
            });
            // update thread if we have new messages
            _getThreadMessages(false, vm.activeThread.unreadMessages);
          }
        });

        init();

        function init() {
          vm.threadList = messagingService.threadList;
        }

        vm._newThreadRecipients = [];
        vm.newThreadRecipients = function(newValue) {
          // Set
          if (arguments.length) {
            if (newValue.length) {
              vm.highlightAddressBar = false;
            }
            return (vm._newThreadRecipients = newValue);
          }
          // Get
          return vm._newThreadRecipients;
        };

        vm.selectThread = function(thread) {
          vm.showNewThread = false;
          vm.activeThread = thread;
          _getThreadMessages(false, true);
          otherUserInfo = vm.activeThread.otherUser;
        };

        vm.activateNewThread = function() {
          vm.activeThread = null;
          vm.showNewThread = true;
          vm.messagingUsers = messagingService.messagingUsers;
          vm.highlightAddressBar = false;

          vm.searchingUsers = _.clone(vm.messagingUsers).map(function(user) {
            return {
              _id: user._id,
              firstName: user.firstName,
              fullName: user.fullName,
              lastName: user.lastName
            };
          });
        };

        vm.sendMessage = function() {
          return messagingService
            .sendMessage(vm.activeThread.otherUserId, vm.newMessage)
            .then(function() {
              _getThreadMessages(true, true);
            });
        };

        vm.sendNewMessage = function() {
          if (!vm._newThreadRecipients || !vm._newThreadRecipients.length) {
            vm.highlightAddressBar = true;
            return;
          }
          vm.highlightAddressBar = false;
          if (!vm.newThreadMessage) {
            return;
          }
          return $q
            .all(
              vm._newThreadRecipients.map(function(user) {
                return messagingService.sendMessage(
                  user._id,
                  vm.newThreadMessage
                );
              })
            )
            .then(function() {
              return messagingService.getMessages();
            })
            .then(function() {
              var threadIdToSwitchTo = vm._newThreadRecipients[0]._id,
                thread = _.find(messagingService.threadList, function(thread) {
                  return thread.otherUserId === threadIdToSwitchTo;
                });
              vm._newThreadRecipients = [];
              vm.newThreadMessage = '';
              vm.showNewThread = false;
              vm.selectThread(thread);
            });
        };

        vm.generateSystemMessage = function(message) {
          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'UnderPerformance'
          ) {
            return (
              $translate.instant('SYSTEM_MESSAGE_TAG') +
              ': ' +
              $translate.instant('UNDERPERFORMANCE_REPORT') +
              '\n' +
              $translate.instant('client') +
              ': ' +
              vm.activeThread.otherUser.firstName +
              ' ' +
              vm.activeThread.otherUser.lastName +
              '\n' +
              $translate.instant('ASSIGNMENT_TITLE') +
              ': ' +
              message.messageMetadata.assignmentName +
              '\n' +
              $translate.instant('ASSIGNMENT_START_DATE') +
              ': ' +
              $filter('dateFormatter')(
                moment.unix(message.messageMetadata.assignmentStartDate),
                'dateShort'
              ) +
              '\n' +
              $translate.instant('EXERCISE_TITLE_TAG') +
              ': ' +
              message.messageMetadata.exerciseTitle
            );
          }

          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'Skipped'
          ) {
            return (
              $translate.instant('SYSTEM_MESSAGE_TAG') +
              ': ' +
              $translate.instant('EXERCISE_SKIPPED') +
              '\n' +
              $translate.instant('client') +
              ': ' +
              vm.activeThread.otherUser.firstName +
              ' ' +
              vm.activeThread.otherUser.lastName +
              '\n' +
              $translate.instant('ASSIGNMENT_TITLE') +
              ': ' +
              message.messageMetadata.assignmentName +
              '\n' +
              $translate.instant('ASSIGNMENT_START_DATE') +
              ': ' +
              $filter('dateFormatter')(
                moment.unix(message.messageMetadata.assignmentStartDate),
                'dateShort'
              ) +
              '\n' +
              $translate.instant('EXERCISE_TITLE_TAG') +
              ': ' +
              message.messageMetadata.exerciseTitle
            );
          }

          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'Reminder'
          ) {
            return $translate.instant('REMINDER_MESSAGE', {
              name: otherUserInfo.fullName,
              date: moment
                .unix(message.time)
                .format(profileService.user.settings.dateFormat)
            });
          }

          if (
            message.messageMetadata &&
            message.messageMetadata.type === 'atRisk'
          ) {
            var phoneNumber =
              message.messageMetadata.clientPhone !== null
                ? message.messageMetadata.clientPhone
                : $translate.instant('NA');
            return (
              $translate.instant('AT_RISK_SYSTEM_MESSAGE', {
                firstName: vm.activeThread.otherUser.firstName,
                lastName: vm.activeThread.otherUser.lastName
              }) +
              ':\n' +
              $translate.instant('EMAIL_ADDRESS') +
              ': ' +
              message.messageMetadata.clientEmail +
              '\n' +
              $translate.instant('PHONE_NUMBER') +
              ': ' +
              phoneNumber
            );
          }

          return message.message;
        };

        function _scrollToBottom() {
          $timeout(function() {
            var msgContainer = document.getElementsByClassName(
              'messaging__thread-container'
            );
            if (msgContainer[0]) {
              msgContainer[0].scrollTop =
                msgContainer[0].scrollHeight - msgContainer[0].clientHeight;
            }
          }, 50);
        }

        function _getThreadMessages(afterMessageSend, refreshMessages) {
          return messagingService
            .getThread(vm.activeThread.otherUserId)
            .then(function(messages) {
              // assign thread messages
              vm.threadMessages = _.sortBy(messages, 'time');

              // clear message if we're refreshing after message send
              if (afterMessageSend) {
                vm.newMessage = '';
              }

              _scrollToBottom();

              // find message to mark as read and send update
              var messagesToMark = messages.filter(function(message) {
                return message.to === vm.selfId && message.read === false;
              });

              return _markMessagesAsRead(messagesToMark);
            })
            .then(function() {
              // To prevent infinite loop, only refresh messages after update if needed
              if (refreshMessages) {
                return messagingService.getMessages();
              }
            });
        }

        function _markMessagesAsRead(messageList) {
          return $q.all(
            messageList.map(function(message) {
              return messagingService.markMessageReadStatus(message._id, true);
            })
          );
        }
      }]
    );
}());
(function() {
  'use strict';

  angular.module('ptCrm').filter('camelToSnakeCase', function() {
    return function camelToSnakeCase(string) {
      string = string && string.replace('/', '_');
      return string && string.replace(/([A-Z])/g, '_$1').toUpperCase();
    };
  });

}());
(function() {
  'use strict';

  angular.module('ptCrm').filter('dateFormatter', ['profileService', function(profileService) {
    return function dateFormatter(dateTime, format) {

      if (!dateTime) {
        return '';
      }

      var dt = _.isNumber(dateTime) ? moment.unix(dateTime) : dateTime;

      var medFormats = {
          'MM/DD/YYYY': 'MMM D YYYY',
          'DD/MM/YYYY': 'D MMM YYYY',
          'YYYY-MM-DD': 'YYYY-MM-DD'
        },
        longFormats = {
          'MM/DD/YYYY': 'MMMM D, YYYY',
          'DD/MM/YYYY': 'D MMMM, YYYY',
          'YYYY-MM-DD': 'YYYY-MM-DD'
        },
        timeFormats = {
          12: 'h:mm A',
          24: 'H:mm'
        },
        dateFormat = profileService.user.settings.dateFormat || 'MM/DD/YYYY',
        timeFormat = timeFormats[(profileService.user.settings.timeFormat || 12)];


      switch (format) {
      case 'dateShort':
        return dt.format(dateFormat);
      case 'dateMedium':
        return dt.format(medFormats[dateFormat]);
      case 'dateLong':
        return dt.format(longFormats[dateFormat]);
      case 'time':
        return dt.format(timeFormat);
      case 'mediumDateTime':
        return dt.format(timeFormat + ' ' + dateFormat);
      case 'messagingDateTime':
        return dt.format('ddd, ' + dateFormat + ', ' + timeFormat);
      default:
        return '';
      }
    };
  }]);

}());
angular.module("templates-dist", [ '/app/auth/login.html', '/app/auth/login_form.html', '/app/calendar/calendar.html', '/app/components/add-client/add-client.modal.html', '/app/components/add-client/add-staff.modal.html', '/app/components/add-client/add-user.modal.html', '/app/components/add-client/confirm-client.modal.html', '/app/components/add-client/confirm-staff.modal.html', '/app/components/add-client/find-staff.modal.html', '/app/components/assignment-workflow/assignment-type/assignment-type.html', '/app/components/assignment-workflow/choose-client/choose-client.html', '/app/components/assignment-workflow/review-save/review-save.html', '/app/components/assignment-workflow/select-time-frame/select-time-frame.html', '/app/components/assignment-workflow/session-setup-customize/session-setup-customize.html', '/app/components/calendar/calendar-body.html', '/app/components/create-exercise-dropdown/create-exercise-dropdown.component.html', '/app/components/customize-exercise-components/components/cardio-program-range.html', '/app/components/customize-exercise-components/components/connected-exercise-segments.html', '/app/components/customize-exercise-components/components/exercise-description.html', '/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional-accordion.html', '/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional.html', '/app/components/customize-exercise-components/components/functional-exercise-sets/functional-exercise.html', '/app/components/customize-exercise-components/components/non-connected-exercise-details.html', '/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-chart.html', '/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-legend.html', '/app/components/customize-exercise-components/components/sprint8-exercise-level/sprint8-exercise-level.html', '/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrength.html', '/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrengthAccordion.html', '/app/components/customize-exercise-components/components/strength-exercise-sets/strength-exercise-sets.html', '/app/components/customize-exercise-components/components/virtual-active-exercise.html', '/app/components/customize-exercise-components/customize-exercise.html', '/app/components/datepicker/datepicker.html', '/app/components/datetime-details/datetime-details.html', '/app/components/datetime-details-component/datetime-details.html', '/app/components/day-schedule/day-schedule.html', '/app/components/duration-input/duration-input.component.html', '/app/components/embed-video/embed-video.html', '/app/components/exercise-item-details/exercise-item-details.html', '/app/components/exercise-media/exercise-media.component.html', '/app/components/exercise-multimedia/exercise-multimedia.html', '/app/components/header/facility.modal.html', '/app/components/header/header.html', '/app/components/image-carousel/image-carousel.html', '/app/components/items-selector/items-selector.html', '/app/components/items-switcher/items-switcher.html', '/app/components/left_menu/assignment_flow.html', '/app/components/left_menu/left_menu.html', '/app/components/library-card/library-card.html', '/app/components/metric-card/metric-card.html', '/app/components/metric-edit/metric-edit.html', '/app/components/popup/_popup.html', '/app/components/scrolling-datepicker/scrolling-datepicker.html', '/app/components/scrolling-datepicker-component/scrolling-datepicker.html', '/app/components/tabs/tab.html', '/app/components/tabs/tabs.html', '/app/components/task-card/task-card.html', '/app/components/taskpicker/taskpicker.html', '/app/components/time-slot/time-slot.html', '/app/components/timepicker/timepicker.html', '/app/components/timepicker-component/timepicker.html', '/app/components/user-card/user-card.html', '/app/components/users-bag/users-bag.html', '/app/components/workout-name/workout-name.component.html', '/app/dashboard/dashboard.html', '/app/facilityAssignments/facility-assignments.modal.html', '/app/facilityAssignments/facilityAssignment/facilityAssignment.html', '/app/facilityAssignments/facilityAssignment/tabs/exercise-profile.html', '/app/facilityAssignments/facilityAssignment/tabs/exercise.html', '/app/facilityAssignments/facilityAssignment/tabs/membership-groups.html', '/app/facilityAssignments/facilityAssignment/tabs/membershipGroupModal.html', '/app/facilityAssignments/facilityAssignments.html', '/app/forgot/layout.html', '/app/forgot/request/error.html', '/app/forgot/request/form.html', '/app/forgot/request/sent.html', '/app/forgot/reset/error.html', '/app/forgot/reset/expired.html', '/app/forgot/reset/form.html', '/app/forgot/reset/invalid.html', '/app/forgot/reset/success.html', '/app/layout/layout.html', '/app/library/assignment-workflow/create-assignment.html', '/app/library/create-assignment/choose-assignment-edit-mode.html', '/app/library/create-assignment/create-assignment.html', '/app/library/create-assignment/tabs/date.html', '/app/library/create-assignment/tabs/exercise-profile.html', '/app/library/create-assignment/tabs/exercise.html', '/app/library/create-assignment/tabs/personnel.html', '/app/library/exercise/exercise.html', '/app/library/exercise/tabs/choose-equip.html', '/app/library/exercise/tabs/details.html', '/app/library/exercise/tabs/multimedia.html', '/app/library/library.html', '/app/library/tabs/list.html', '/app/library/task/tabs/details.html', '/app/library/task/tabs/period.html', '/app/library/task/tabs/users.html', '/app/library/task/task.html', '/app/library/training-program-template/training-program-template.html', '/app/library/training-set/tabs/exercise-profile.html', '/app/library/training-set/tabs/exercises.html', '/app/library/training-set/tabs/training-set-details.html', '/app/library/training-set/tabs/training-set-media.html', '/app/library/training-set/training-set.html', '/app/maintenance/maintenance.html', '/app/messaging/messaging.html', '/app/privacy/privacy.html', '/app/roster/roster.html', '/app/schedule/schedule.html', '/app/settings/settings.html', '/app/settings/tabs/facility_settings.html', '/app/settings/tabs/membership-groups/add-membership-group.html', '/app/settings/tabs/membership-groups/delete-membership-group.html', '/app/settings/tabs/membership-groups/edit-membership-group.html', '/app/settings/tabs/permissionGroups/deleteGroup.html', '/app/settings/tabs/permissions.html', '/app/settings/tabs/risk.html', '/app/termsAndConditions/terms.html', '/app/termsOfUse/termsOfUse.html', '/app/unsubscribe/unsubscribe.html', '/app/user/tabs/assignments/assignment-details.html', '/app/user/tabs/assignments/assignment-row.html', '/app/user/tabs/assignments/assignment-status-modal.html', '/app/user/tabs/assignments/assignments.html', '/app/user/tabs/assignments/combined-tab.html', '/app/user/tabs/assignments/create-assignment-modal.html', '/app/user/tabs/assignments/delete-assignment-modal.html', '/app/user/tabs/assignments/delete-training-plan-modal.html', '/app/user/tabs/assignments/extend-training-plan-modal.html', '/app/user/tabs/assignments/mass-complete-modal.html', '/app/user/tabs/assignments/metric-item.html', '/app/user/tabs/assignments/skip-complete-modal.html', '/app/user/tabs/assignments/training-program-container.html', '/app/user/tabs/assignments/training-programs.html', '/app/user/tabs/assignments/workout-history-card.html', '/app/user/tabs/assignments/workout-history-details.html', '/app/user/tabs/assignments/workout-history-row.html', '/app/user/tabs/assignments/workout-history.html', '/app/user/tabs/biometrics/biometric-chart/biometric-chart.html', '/app/user/tabs/biometrics/biometric-create/biometric-create-modal.html', '/app/user/tabs/biometrics/biometric-details/biometric-details.component.html', '/app/user/tabs/biometrics/biometric-entry/biometric-entry-modal.html', '/app/user/tabs/biometrics/biometric-hidden/biometric-hidden-modal.html', '/app/user/tabs/biometrics/biometric-history/biometric-history-modal.html', '/app/user/tabs/biometrics/biometric-stats/biometric-stats.html', '/app/user/tabs/biometrics/biometrics.html', '/app/user/tabs/messaging/staffMessaging.html', '/app/user/tabs/permissions/groups-modal.html', '/app/user/tabs/permissions/permissions.html', '/app/user/tabs/reminder/reminder-modal.html', '/app/user/tabs/removeFromFacility/removeFromFacility.html', '/app/user/tabs/userDetails/certifications/certifications.html', '/app/user/tabs/userDetails/changePassword/change-password-modal.html', '/app/user/tabs/userDetails/deleteAccount/deleteAccount.html', '/app/user/tabs/userDetails/deleteUser/delete-user-modal.html', '/app/user/tabs/userDetails/facilityStaff.html', '/app/user/tabs/userDetails/settings/settings.html', '/app/user/tabs/userDetails/userDetails.html', '/app/user/tabs/userDetails/userModal/userModal.html', '/app/user/tabs/userNotes/notes.html', '/app/user/user.html' ]);
angular.module('/app/auth/login.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/auth/login.html', '<section class="login">\n' +
    '\n' +
    '  <header class="login__header">\n' +
    '    <h1 class="login__title">{{ "PERSONAL_TRAINER_PORTAL" | translate }}</h1>\n' +
    '  </header>\n' +
    '\n' +
    '  <div class="login__view" ui-view></div>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/auth/login_form.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/auth/login_form.html', '<form class="login__content login__form" name="loginCtrl.loginForm" novalidate>\n' +
    '    <h2 class="login__form-title">{{ "LOGIN" | translate }}</h2>\n' +
    '\n' +
    '    <label class="login__field-title login__field-title--spacer-lg">\n' +
    '      {{ "USERNAME" | translate }}\n' +
    '    </label>\n' +
    '    <input type="text" class="login__input" placeholder="example@example.com" autofocus\n' +
    '           ng-model="loginCtrl.user.login"\n' +
    '               required />\n' +
    '\n' +
    '    <label class="login__field-title login__field-title--spacer-lg">\n' +
    '      {{ "PASSWORD" | translate }}\n' +
    '    </label>\n' +
    '    <input type="password" class="login__input" placeholder="password"\n' +
    '           ng-model="loginCtrl.user.password"\n' +
    '           required/>\n' +
    '\n' +
    '    <a class="login__forgot" ui-sref="login.forgot.request.form({ email: loginCtrl.user.login })">{{ "FORGOT" | translate }}</a>\n' +
    '\n' +
    '    <button id="loginSubmit" class="login__submit"\n' +
    '            ng-disabled="loginCtrl.loginForm.$invalid"\n' +
    '            ng-click="loginCtrl.login()">{{ "LOGIN" | translate }}\n' +
    '    </button>\n' +
    '  </form>\n' +
    '  <span class="login__privacyPolicyIncludetag" ng-include  src="\'/app/termsAndConditions/terms.html\'"></span>');
  }]);
angular.module('/app/calendar/calendar.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/calendar/calendar.html', '<div class=\'calendar\'\n' +
    '  ng-class=\'{"calendar--timeline-view": calendar.showTimeline}\'>\n' +
    '\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-calendar"></i>\n' +
    '      <h1 class="container-header__title">{{ \'CALENDAR\' | translate }}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class=\'calendar__content\'>\n' +
    '\n' +
    '    <div class="calendar__selector"></div>\n' +
    '    <div class="calendar__header">\n' +
    '\n' +
    '      <div class="calendar__header-content">\n' +
    '        <div class="calendar__top-year">{{ calendar.fromYear }}</div>\n' +
    '\n' +
    '        <div class="calendar__top-month"\n' +
    '             ng-repeat-start="month in calendar.monthRange track by $index"\n' +
    '             ng-click="calendar.selectMonth(month.number, month.year)"\n' +
    '             ng-class="{\'calendar__top-month--selected\': $index == calendar.monthOffset}">\n' +
    '          {{month.displayText}}\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="calendar__top-separator"\n' +
    '          ng-repeat-end\n' +
    '          ng-if="month.number == 11">\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="calendar__top-year">{{ calendar.toYear }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="calendar__bodies">\n' +
    '\n' +
    '      <!--<calendar-body class="calendar__body calendar__body&#45;&#45;hidden calendar__body&#45;&#45;hidden-left"-->\n' +
    '        <!--month-offset="+1">-->\n' +
    '      <!--</calendar-body>-->\n' +
    '\n' +
    '      <!--<calendar-body class="calendar__body calendar__body&#45;&#45;hidden calendar__body&#45;&#45;hidden-right"-->\n' +
    '        <!--month-offset="+1">-->\n' +
    '      <!--</calendar-body>-->\n' +
    '\n' +
    '      <calendar-body\n' +
    '        options="{initialDate: calendar.selectedDate}"\n' +
    '        user="calendar.selectedUser"\n' +
    '        on-day-selected="calendar.chooseDate(event, day)"\n' +
    '        add-event="calendar.addEvent(day)">\n' +
    '      </calendar-body>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'timepicker-wrapper\'>\n' +
    '      <div class=\'timepicker-wrapper__header\'>\n' +
    '\n' +
    '        <div class=\'timepicker-wrapper__close\'\n' +
    '          ng-click=\'calendar.toggleTimelineVeiw()\'>\n' +
    '          <i class="icon icon-cross"></i>\n' +
    '        </div>\n' +
    '\n' +
    '        <div>\n' +
    '          <span class=\'timepicker-wrapper__control\'\n' +
    '            ng-click=\'calendar.selectSiblingDay(-1)\'>\n' +
    '            <i class="icon icon-triangle-left"></i>\n' +
    '          </span>\n' +
    '          <span>{{ calendar.timelineDisplayDate | dateFormatter:\'dateLong\' }}</span>\n' +
    '          <span class=\'timepicker-wrapper__control\'\n' +
    '            ng-click=\'calendar.selectSiblingDay(1)\'>\n' +
    '            <i class="icon icon-triangle-right"></i>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <label class="user-picker"\n' +
    '        permission\n' +
    '        permission-only="[\'WORKOUT_ASSIGNMENTS_OTHER_READ\', \'TASKS_OTHER_READ\']">\n' +
    '        <input class="user-picker__input"\n' +
    '          type="text"\n' +
    '          ng-model="calendar.searchStr"\n' +
    '          ng-model-options="{debounce: 500}"\n' +
    '          ng-blur="calendar.searchStr = calendar.selectedUser.fullName"\n' +
    '          placeholder="{{ :: \'CHOOSE_USER\' | translate }}"\n' +
    '          uib-typeahead="user as calendar.getFullUserName(user) for user in calendar.searchByName($viewValue)"\n' +
    '          typeahead-loading="userLoading"\n' +
    '          typeahead-on-select="calendar.changeUser($item)"/>\n' +
    '        <span class="user-picker__loading-icon spinner-icon__small" ng-show="userLoading || calendar.showSpinner"></span>\n' +
    '        <i class="icon icon-search user-picker__search-icon" ng-show="!userLoading && !calendar.showSpinner"></i>\n' +
    '      </label>\n' +
    '\n' +
    '      <tabs class="date-tab__picker-tabs">\n' +
    '        <tab>\n' +
    '          <tab-head>\n' +
    '            <span class="tab-head__multiline-item">\n' +
    '              <span class="button__icon button__icon--clock"></span>\n' +
    '            </span>\n' +
    '          </tab-head>\n' +
    '          <tab-content>\n' +
    '            <timepicker\n' +
    '              clients="calendar.timelineClients"\n' +
    '              on-client-select=\'calendar.navigateToUserDetails($item)\'\n' +
    '              on-edit-client="calendar.onEditAssigment($item)"\n' +
    '              on-edit-task="calendar.onEditTask($item)"\n' +
    '              is-editable="true"\n' +
    '              read-only>\n' +
    '            </timepicker>\n' +
    '          </tab-content>\n' +
    '        </tab>\n' +
    '        <tab>\n' +
    '          <tab-head>\n' +
    '            <span class="tab-head__multiline-item">\n' +
    '              <span class="button__icon button__icon--assignment"></span>\n' +
    '            </span>\n' +
    '          </tab-head>\n' +
    '          <tab-content>\n' +
    '            <taskpicker\n' +
    '              clients="calendar.anytimeClients"\n' +
    '              on-client-select=\'calendar.navigateToUserDetails($item)\'\n' +
    '              on-edit-client="calendar.onEditAssigment($item)"\n' +
    '              on-edit-task="calendar.onEditTask($item)"\n' +
    '              is-editable="true"\n' +
    '              read-only>\n' +
    '            </taskpicker>\n' +
    '          </tab-content>\n' +
    '        </tab>\n' +
    '      </tabs>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </section>\n' +
    '  <div class="calendar-loader" ng-if="calendar.isLoading">\n' +
    '    <i class="calendar-loader__icon spinner-icon"></i>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/add-client/add-client.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/add-client.modal.html', '<ng-form name=\'addClientForm\' autofill=\'false\' >\n' +
    '  <label class="data-block__container">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input type="text"\n' +
    '               required\n' +
    '               ng-model="ptApiId"\n' +
    '               name="ptApiId"\n' +
    '               placeholder="---"\n' +
    '               class="data-block__info--input user-details__input--password modal__input--pass input-clear">\n' +
    '      </div>\n' +
    '      <div ng-if="!isSmartHealth && !isUpace" class="data-block__title">{{ :: \'XID\' | translate }}</div>\n' +
    '      <div ng-if="isSmartHealth" class="data-block__title">{{ :: \'SMART_HEALTH_SEARCH_LABEL\' | translate }}</div>\n' +
    '      <div ng-if="isUpace" class="data-block__title">{{ :: \'BARCODE_SEARCH_LABEL\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </label>\n' +
    '</ng-form>\n' +
    '');
  }]);
angular.module('/app/components/add-client/add-staff.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/add-staff.modal.html', '<ng-form name=\'addFacilityForm\' autofill=\'false\' >\n' +
    '  <label class="data-block__container data-block__container--border-bottom">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass input-clear"\n' +
    '          type="text"\n' +
    '          required\n' +
    '          ng-model="firstName"\n' +
    '          name="firstName"\n' +
    '          placeholder="---">\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'FIRST_NAME\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </label>\n' +
    '  <label class="data-block__container data-block__container--border-bottom">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass input-clear"\n' +
    '          type="text"\n' +
    '          required\n' +
    '          ng-model="lastName"\n' +
    '          name="lastName"\n' +
    '          placeholder="---">\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'LAST_NAME\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </label>\n' +
    '  <label class="data-block__container data-block__container--border-bottom">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass input-clear"\n' +
    '          type="email"\n' +
    '          required\n' +
    '          ng-model="email"\n' +
    '          name="email"\n' +
    '          placeholder="email@example.com">\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </label>\n' +
    '  <label class="data-block__container data-block__container--border-bottom">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <label class="checkbox-custom">\n' +
    '        <input type="checkbox" ng-model="chainWide" />\n' +
    '        <span class="checkbox-label-small">{{ \'ADD_ORGANIZATION_WIDE\' | translate }}</label>\n' +
    '</label>\n' +
    '<label ng-show="isAdmin" class="data-block__container data-block__container">\n' +
    '  <div class="data-block__info-container">\n' +
    '    <label class="checkbox-custom">\n' +
    '      <input type="checkbox" ng-model="isDemoUser" />\n' +
    '      <span class="checkbox-label-small">Demo user</label>\n' +
    '</label>\n' +
    '</ng-form>\n' +
    '');
  }]);
angular.module('/app/components/add-client/add-user.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/add-user.modal.html', '<ul class="modal__list-wrapper">\n' +
    '  <li class="modal__list-item"\n' +
    '      ng-click="addClient(this)">\n' +
    '    <a> {{ :: "ADD_CLIENT" | translate}} </a>\n' +
    '  </li>\n' +
    '  <li class="modal__list-item"\n' +
    '      ng-click="findFacility(this)">\n' +
    '    <a> {{ :: "ADD_TRAINER_FACILITY" | translate}} </a>\n' +
    '  </li>\n' +
    '</ul>\n' +
    '');
  }]);
angular.module('/app/components/add-client/confirm-client.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/confirm-client.modal.html', '<div class="modal__popup-header">\n' +
    '  <div\n' +
    '    class="modal__popup-header--back"\n' +
    '    ng-if="showBack"\n' +
    '    ng-click="back()"\n' +
    '  ></div>\n' +
    '  <div class="modal__popup-header--title">\n' +
    '    {{ \'CONFIRM_CLIENT\' | translate }}\n' +
    '  </div>\n' +
    '  <div\n' +
    '    class="modal__popup-header--exit icon icon-cross"\n' +
    '    ng-click="confirmClientCtrl.cancel()"\n' +
    '  ></div>\n' +
    '</div>\n' +
    '<div\n' +
    '  ng-if="confirmClientCtrl.ifObject(confirmClientCtrl.user)"\n' +
    '  class="confirm-client__wrapper clearfix"\n' +
    '>\n' +
    '  <div class="confirm-client__image pull-left">\n' +
    '    <img\n' +
    '      ng-src="{{ confirmClientCtrl.user.pictureUrl || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\' }}"\n' +
    '    />\n' +
    '  </div>\n' +
    '  <div class="confirm-client__info-container pull-left">\n' +
    '    <div class="confirm-client__info border-bottom">\n' +
    '      <div class="confirm-client__name">\n' +
    '        {{confirmClientCtrl.user.firstName}} {{confirmClientCtrl.user.lastName}}\n' +
    '      </div>\n' +
    '      <div class="confirm-client__title">{{:: \'FULL_NAME\' | translate}}</div>\n' +
    '    </div>\n' +
    '    <div class="confirm-client__info border-bottom">\n' +
    '      <div class="confirm-client__email">{{confirmClientCtrl.user.email}}</div>\n' +
    '      <div class="confirm-client__title">\n' +
    '        {{:: \'EMAIL_ADDRESS\' | translate}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div\n' +
    '      ng-if="confirmClientCtrl.activeFacility.settings.membershipGroups !== undefined && confirmClientCtrl.activeFacility.settings.membershipGroups"\n' +
    '      class="confirm-client__info"\n' +
    '    >\n' +
    '      <div class="confirm-client__title">\n' +
    '        {{ :: \'MEMBERSHIP_GROUPS\' | translate }}\n' +
    '      </div>\n' +
    '      <div>\n' +
    '        <ui-select\n' +
    '          multiple\n' +
    '          ng-model="confirmClientCtrl.selectedGroups"\n' +
    '          ng-model-options="{ getterSetter: true }"\n' +
    '          close-on-select="false"\n' +
    '          on-select="confirmClientCtrl.addAllGroups($item, $model)"\n' +
    '          on-remove="confirmClientCtrl.addAllCheck($item, $model)"\n' +
    '        >\n' +
    '          <ui-select-match placeholder="+">\n' +
    '            <span class="confirm-client__groups-section"> {{$item.name}} </span>\n' +
    '          </ui-select-match>\n' +
    '          <ui-select-choices\n' +
    '            repeat="group in confirmClientCtrl.membershipGroups | filter: $select.search | orderBy: \'name\'"\n' +
    '            null-option="confirmClientCtrl.allGroups"\n' +
    '          >\n' +
    '            <span\n' +
    '              ng-class="{\'confirm-client__all-bold\': group.name === confirmClientCtrl.allGroups.name}"\n' +
    '            >\n' +
    '              {{ group.name }}\n' +
    '            </span>\n' +
    '          </ui-select-choices>\n' +
    '        </ui-select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div\n' +
    '  ng-if="!confirmClientCtrl.ifObject(confirmClientCtrl.user)"\n' +
    '  class="confirm-client__wrapper clearfix">\n' +
    '  <div\n' +
    '    class="membership-user_option"\n' +
    '    ng-repeat="user in confirmClientCtrl.user">\n' +
    '    <div class="membership-user_section-three">\n' +
    '      <label class="checkbox-custom">\n' +
    '        <input\n' +
    '          type="radio"\n' +
    '          ng-value="user"\n' +
    '          class="right-checkbox"\n' +
    '          ng-model="confirmClientCtrl.selectedUser"\n' +
    '          ng-click="confirmClientCtrl.setSelectedUser(user)"\n' +
    '        />\n' +
    '      </label>\n' +
    '    </div>\n' +
    '    <div class="membership-user_section-one">\n' +
    '      <img\n' +
    '        class="membership-user_photo"\n' +
    '        ng-src="{{user.PicUrl ? user.PicUrl : \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}"\n' +
    '      />\n' +
    '    </div>\n' +
    '    <div class="membership-user_section-two">\n' +
    '      <div class="membership-user_info">\n' +
    '        <div class="membership-user_name">{{user.FullName}}</div>\n' +
    '        <div class="membership-user_title">{{ \'NAME\' | translate }}</div>\n' +
    '      </div>\n' +
    '      <div class="membership-user_info">\n' +
    '        <div class="membership-user_email">{{user.Email}}</div>\n' +
    '        <div class="membership-user_title">\n' +
    '          {{ \'EMAIL_ADDRESS\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="membership-user_info">\n' +
    '        <div class="membership-user_email">{{user.Barcode}}</div>\n' +
    '        <div class="membership-user_title">Barcode</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div\n' +
    '      ng-if="confirmClientCtrl.activeFacility.settings.membershipGroups !== undefined && confirmClientCtrl.activeFacility.settings.membershipGroups"\n' +
    '      class="confirm-client__info"\n' +
    '    >\n' +
    '      <div class="confirm-client__title">\n' +
    '        {{ :: \'MEMBERSHIP_GROUPS\' | translate }}\n' +
    '      </div>\n' +
    '      <div>\n' +
    '        <ui-select\n' +
    '          multiple\n' +
    '          ng-model="confirmClientCtrl.selectedGroups"\n' +
    '          ng-model-options="{ getterSetter: true }"\n' +
    '          close-on-select="false"\n' +
    '          on-select="confirmClientCtrl.addAllGroups($item, $model)"\n' +
    '          on-remove="confirmClientCtrl.addAllCheck($item, $model)"\n' +
    '        >\n' +
    '          <ui-select-match placeholder="+">\n' +
    '            <span class="confirm-client__groups-section"> {{$item.name}} </span>\n' +
    '          </ui-select-match>\n' +
    '          <ui-select-choices\n' +
    '            repeat="group in confirmClientCtrl.membershipGroups | filter: $select.search | orderBy: \'name\'"\n' +
    '            null-option="confirmClientCtrl.allGroups"\n' +
    '          >\n' +
    '            <span\n' +
    '              ng-class="{\'confirm-client__all-bold\': group.name === confirmClientCtrl.allGroups.name}"\n' +
    '            >\n' +
    '              {{ group.name }}\n' +
    '            </span>\n' +
    '          </ui-select-choices>\n' +
    '        </ui-select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="footer-buttons">\n' +
    '  <button\n' +
    '    type="submit"\n' +
    '    ng-click="confirmClientCtrl.submit()"\n' +
    '    autofocus\n' +
    '    class="button button-action"\n' +
    '    ng-disabled="!confirmClientCtrl.selectedUser && confirmClientCtrl.isSmartHealth"\n' +
    '    >\n' +
    '    <i\n' +
    '      class="roster-load-more__icon spinner-icon"\n' +
    '      ng-if="confirmClientCtrl.isLoading">\n' +
    '    </i>\n' +
    '    {{ \'CONFIRM\' | translate }}\n' +
    '  </button>\n' +
    '\n' +
    '  <div\n' +
    '    class="button button-assertive button-clear pull-right"\n' +
    '    ng-click="confirmClientCtrl.cancel()">\n' +
    '    {{ \'CANCEL\' | translate }}\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/add-client/confirm-staff.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/confirm-staff.modal.html', '<div class="confirm-client__wrapper clearfix">\n' +
    '  <div class="confirm-client__image pull-left">\n' +
    '    <img ng-src="{{ user.pictureUrl || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\' }}">\n' +
    '  </div>\n' +
    '  <div class="confirm-client__info-container pull-left">\n' +
    '    <div class="confirm-client__info border-bottom">\n' +
    '      <div class="confirm-client__name">\n' +
    '        {{user.firstName}} {{user.lastName}}\n' +
    '      </div>\n' +
    '      <div class="confirm-client__title">\n' +
    '        {{:: \'FULL_NAME\' | translate}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="confirm-client__info">\n' +
    '      <div class="confirm-client__email">\n' +
    '        {{user.email}}\n' +
    '      </div>\n' +
    '      <div class="confirm-client__title">\n' +
    '        {{:: \'EMAIL_ADDRESS\' | translate}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-show="isAdmin">\n' +
    '      <label class="checkbox-custom">\n' +
    '        <input type="checkbox" ng-model="user.isDemoUser" />\n' +
    '        <span class="checkbox-label-small">Demo user</label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/add-client/find-staff.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/add-client/find-staff.modal.html', '<ng-form name=\'findFacilityForm\' autofill=\'false\' >\n' +
    '  <div class="data-block__container">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass"\n' +
    '          type="email"\n' +
    '          required\n' +
    '          ng-model="email"\n' +
    '          name="email"\n' +
    '          placeholder="email@example.com">\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</ng-form>\n' +
    '');
  }]);
angular.module('/app/components/assignment-workflow/assignment-type/assignment-type.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/assignment-workflow/assignment-type/assignment-type.html', '<div class="assignment-type">\n' +
    '  <div class="workflow__nav-bar">\n' +
    '    <div class="workflow__nav-bar-btn">\n' +
    '      <!-- Placeholder  -->\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-right"\n' +
    '      ng-if="assignmentTypeCtrl.type"\n' +
    '      ng-class="{ \'workflow__nav-bar-btn--disabled\': !assignmentTypeCtrl.canAdvanceTab() }"\n' +
    '      ng-click="assignmentTypeCtrl.goToNextTab()">\n' +
    '        {{ assignmentTypeCtrl.nextButtonText() | translate }} <i class="icon icon-triangle-right"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- TODO - unify flow -->\n' +
    '\n' +
    '  <!-- <div class="assignment-type__btn-container">\n' +
    '    <div ng-click="assignmentTypeCtrl.setType(\'assignment\')"\n' +
    '      class="assignment-type__btn"\n' +
    '      ng-class="{\'assignment-type__btn--inactive\': assignmentTypeCtrl.type !== \'assignment\'}">\n' +
    '      {{ \'ASSIGNED\' | translate }}\n' +
    '    </div>\n' +
    '    <div ng-click="assignmentTypeCtrl.setType(\'trainingPlan\')"\n' +
    '      class="assignment-type__btn"\n' +
    '      ng-class="{\'assignment-type__btn--inactive\': assignmentTypeCtrl.type !== \'trainingPlan\'}">\n' +
    '      {{ \'TRAINING_PROGRAM\' | translate }}\n' +
    '    </div>\n' +
    '    <div ng-click="assignmentTypeCtrl.setType(\'facility\')"\n' +
    '      class="assignment-type__btn"\n' +
    '      ng-class="{\'assignment-type__btn--inactive\': assignmentTypeCtrl.type !== \'facility\'}">\n' +
    '      {{ \'WOTD\' | translate }}\n' +
    '    </div>\n' +
    '  </div> -->\n' +
    '\n' +
    '  <div class="assignment-type__input-container"\n' +
    '    ng-if="assignmentTypeCtrl.type === \'assignment\' || assignmentTypeCtrl.type === \'trainingPlan\'">\n' +
    '    <input class="assignment-type__input"\n' +
    '      type="text"\n' +
    '      ng-model="assignmentTypeCtrl.assignmentName"\n' +
    '      placeholder="{{assignmentTypeCtrl.type === \'trainingPlan\' ? \'ENTER_TITLE\': \'ENTER_TITLE_OPTIONAL\' | translate }}"\n' +
    '      ng-change="assignmentTypeCtrl.setName()">\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignment-type__new-plan-button"\n' +
    '    ng-class="{\'assignment-type__new-plan-button--selected\': !assignmentTypeCtrl.selectedPlan}"\n' +
    '    ng-click="assignmentTypeCtrl.setPlan(null)"\n' +
    '    ng-if="assignmentTypeCtrl.type === \'trainingPlan\' && (!assignmentTypeCtrl.isEdit && !assignmentTypeCtrl.isCopy)">\n' +
    '    <div class="assignment-type__new-plan-button__text">\n' +
    '      {{ \'NEW_TRAINING_PROGRAM\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignment-type__saved-plan-container"\n' +
    '    ng-init="assignmentTypeCtrl.savedTrainingPlans.load()"\n' +
    '    ng-if="assignmentTypeCtrl.type === \'trainingPlan\' && (!assignmentTypeCtrl.isEdit && !assignmentTypeCtrl.isCopy)">\n' +
    '    <div ng-repeat="plan in assignmentTypeCtrl.savedTrainingPlans.items"\n' +
    '      class="assignment-type__saved-plan"\n' +
    '      ng-class="{\'assignment-type__saved-plan--selected\': assignmentTypeCtrl.selectedPlan._id === plan._id}"\n' +
    '      ng-click="assignmentTypeCtrl.setPlan(plan)">\n' +
    '      <div class="assignment-type__saved-plan-title">\n' +
    '        {{ plan.planName }}\n' +
    '      </div>\n' +
    '      <div class="assignment-type__saved-plan-weeks">\n' +
    '        {{ plan.repeats }} {{ (plan.repeats === 1 ? \'WEEK\' : \'WEEKS\') | translate }}\n' +
    '      </div>\n' +
    '      <div class="assignment-type__saved-plan-workouts">\n' +
    '        {{ plan.workoutsToShow }} {{ \'WORKOUTS\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/assignment-workflow/choose-client/choose-client.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/assignment-workflow/choose-client/choose-client.html', '<div class="choose-client">\n' +
    '  <div class="workflow__nav-bar">\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-left" ng-click="chooseClientCtrl.goToTab(\'assignmentType\')">\n' +
    '      <i class="icon icon-triangle-left"></i> {{ \'ASSIGNMENT_TYPE\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-right"\n' +
    '      ng-class="{ \'workflow__nav-bar-btn--disabled\': !chooseClientCtrl.canGoToTimePage() }"\n' +
    '      ng-click="chooseClientCtrl.goToTab(\'selectTime\')">\n' +
    '      {{ \'DATE_TIME\' | translate }} <i class="icon icon-triangle-right"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="user-tab__container">\n' +
    '    <div class="user-tab__selected-container-assignment-view">\n' +
    '      <div class="user-tab__selected-container-assignment-view-section">\n' +
    '        {{ \'TRAINER\' | translate}}\n' +
    '      </div>\n' +
    '      <user-card\n' +
    '        class="user-tab__selected-trainer"\n' +
    '        user="chooseClientCtrl.selectedTrainer"\n' +
    '        moveable="false"\n' +
    '        arrow="chooseClientCtrl.trainerDropdown ? \'up\' : \'down\'"\n' +
    '        ng-click="chooseClientCtrl.toggleTrainerDropdown()"\n' +
    '      ></user-card>\n' +
    '      <div class="user-tab__trainer-dropdown" ng-if="chooseClientCtrl.trainerDropdown">\n' +
    '        <library-search>\n' +
    '          <div class="library-search">\n' +
    '            <div class="library-search__icon"></div>\n' +
    '            <input type="text"\n' +
    '              class="library-search__input"\n' +
    '              placeholder="{{ :: \'SEARCH\' | translate }}"\n' +
    '              ng-model-options="{ debounce: 500 }"\n' +
    '              ng-model="chooseClientCtrl.trainerSearch"\n' +
    '              ng-change="chooseClientCtrl.loadTrainers(true)">\n' +
    '            <search-clearer\n' +
    '              search-term="chooseClientCtrl.trainerSearch"\n' +
    '              refresh-fn="chooseClientCtrl.loadTrainers(true)">\n' +
    '            </search-clearer>\n' +
    '          </div>\n' +
    '        </library-search>\n' +
    '        <user-card\n' +
    '          class="user-tab__selected-trainer"\n' +
    '          user="trainer"\n' +
    '          ng-repeat="trainer in chooseClientCtrl.trainers.items track by trainer._id"\n' +
    '          ng-click="chooseClientCtrl.changeTrainer(trainer)"\n' +
    '        ></user-card>\n' +
    '      </div>\n' +
    '      <div class="user-tab__selected-container-section" ng-if="!chooseClientCtrl.trainerDropdown">\n' +
    '        {{ \'CLIENTS\' | translate }}\n' +
    '      </div>\n' +
    '      <div class="user-tab__selected-users" ng-if="!chooseClientCtrl.trainerDropdown">\n' +
    '        <div class="user-tab__user-placeholder" ng-if="!chooseClientCtrl.selectedClients.length">\n' +
    '          <i class="icon icon-info_outline user-tab__user-placeholder-icon"></i>\n' +
    '          {{ \'CLICK_TO_ADD_USERS\' | translate }}\n' +
    '        </div>\n' +
    '        <user-card class="user-tab__selected-user"\n' +
    '          user="client"\n' +
    '          moveable="false"\n' +
    '          ng-click="chooseClientCtrl.removeClient($index)"\n' +
    '          ng-repeat="client in chooseClientCtrl.selectedClients track by client._id">\n' +
    '        </user-card>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="user-tab__client-container-new-workflow">\n' +
    '      <library-search>\n' +
    '        <div class="library-search">\n' +
    '          <div class="library-search__icon"></div>\n' +
    '          <input type="text"\n' +
    '            class="library-search__input"\n' +
    '            placeholder="{{\'SEARCH\' |translate}}"\n' +
    '            ng-model-options="{ debounce: 500 }"\n' +
    '            ng-model="chooseClientCtrl.clientSearch"\n' +
    '            ng-change="chooseClientCtrl.loadClients(true)">\n' +
    '          <search-clearer\n' +
    '            search-term="chooseClientCtrl.clientSearch"\n' +
    '            refresh-fn="chooseClientCtrl.loadClients(true)">\n' +
    '          </search-clearer>\n' +
    '        </div>\n' +
    '      </library-search>\n' +
    '\n' +
    '      <div class="user-tab__users"\n' +
    '        infinite-scroll=\'chooseClientCtrl.loadClients()\'\n' +
    '        can-load=\'chooseClientCtrl.clients.nextPage\'\n' +
    '        threshold=\'30\'\n' +
    '        ng-click="chooseClientCtrl.trainerDropdown && chooseClientCtrl.toggleTrainerDropdown()">\n' +
    '\n' +
    '        <user-card class="user-tab__user"\n' +
    '          ng-class="{\n' +
    '            \'user-tab__user--selected\': chooseClientCtrl.clientIsSelected(client._id),\n' +
    '            \'user-tab__user--disabled\': chooseClientCtrl.trainerDropdown\n' +
    '          }"\n' +
    '          user="client"\n' +
    '          moveable="false"\n' +
    '          ng-repeat="client in chooseClientCtrl.clients.items track by client._id"\n' +
    '          ng-click="chooseClientCtrl.clientIsSelected(client._id) ? chooseClientCtrl.removeClientById(client._id) : chooseClientCtrl.addClient(client)">\n' +
    '        </user-card>\n' +
    '\n' +
    '        <div class=\'user-tab__no-users\'\n' +
    '          ng-if=\'!chooseClientCtrl.clients.items.length && !chooseClientCtrl.clients.nextPage\'>\n' +
    '          {{ "NO_CLIENTS" | translate }}\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'roster-load-more\' ng-if=\'chooseClientCtrl.clients.nextPage\'>\n' +
    '          <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '          {{ \'LOADING_MORE_CLIENTS\' | translate }}\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/assignment-workflow/review-save/review-save.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/assignment-workflow/review-save/review-save.html', '<div class="review">\n' +
    '  <div class="workflow__nav-bar">\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-left"\n' +
    '      ng-click="reviewAssignmentCtrl.goToTab(\'sessionSetup\')">\n' +
    '      <i class="icon icon-triangle-left"></i> {{ \'SETUP\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn-set">\n' +
    '      <div class="workflow__nav-bar-btn--pdf"\n' +
    '        ng-click="reviewAssignmentCtrl.showPDF()">\n' +
    '      </div>\n' +
    '      <div class="workflow__nav-bar-btn--save-plan"\n' +
    '        ng-if="!reviewAssignmentCtrl.saveTrainingPlanLoading && reviewAssignmentCtrl.type !== \'trainingPlanTemplate\'"\n' +
    '        ng-click="!reviewAssignmentCtrl.saveTrainingPlanLoading && reviewAssignmentCtrl.saveTrainingPlan()">\n' +
    '      </div>\n' +
    '      <div class="workflow__nav-bar-btn--save-plan-loading"\n' +
    '        ng-if="reviewAssignmentCtrl.saveTrainingPlanLoading"\n' +
    '      ></div>\n' +
    '      <div class="workflow__nav-bar-btn--save"\n' +
    '        ng-if="!reviewAssignmentCtrl.trainingPlanLoading"\n' +
    '        ng-click="!reviewAssignmentCtrl.trainingPlanLoading && reviewAssignmentCtrl.save()">\n' +
    '          {{ \'SAVE\' | translate }}\n' +
    '      </div>\n' +
    '      <div class="workflow__nav-bar-btn--save-loading"\n' +
    '        ng-if="reviewAssignmentCtrl.trainingPlanLoading"\n' +
    '      ></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="review__assignment-info">\n' +
    '    <div class="review__assignment-info--header">\n' +
    '      {{ \'ASSIGNMENT_INFO\' | translate }}\n' +
    '    </div>\n' +
    '    <div>\n' +
    '      <div class="review__training-program">\n' +
    '        <img src="//images.jhtassets.com/6d44af1d4cab21ca821c45527eac5524333cafc1/" alt="{{ \'TRAINING_PROGRAM\' | translate }}" class="review-img__training-program">\n' +
    '        <div class="review__assignment-info--header">{{ \'TRAINING_PROGRAM\' | translate }} / "{{ reviewAssignmentCtrl.name }}"</span></div>\n' +
    '      </div>\n' +
    '      <div class="review__training-program">\n' +
    '        <img src="//images.jhtassets.com/bac774ef57c89e5859be04746ddcba81809e56cf/" alt="{{ \'TRAINING_PROGRAM_START_DATE\' | translate }}" class="review-img__training-program">\n' +
    '        <div class="review__assignment-info--header" ng-if="reviewAssignmentCtrl.type !== \'trainingPlanTemplate\'">{{ \'TRAINING_PROGRAM_START_DATE\' | translate }}\n' +
    '          {{ reviewAssignmentCtrl.formatTrainingProgramDate(reviewAssignmentCtrl.startDate) }}\n' +
    '        </div>\n' +
    '        <span class="review__assignment-info--repeat">*{{ reviewAssignmentCtrl.trainingProgramRepeatsString() }} </span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="review__clients" ng-if="reviewAssignmentCtrl.type !== \'trainingPlanTemplate\'">\n' +
    '    <div class="review__clients-header">\n' +
    '      {{\'CLIENTS\' | translate}}\n' +
    '    </div>\n' +
    '    <user-card ng-repeat="client in reviewAssignmentCtrl.clients track by client._id" user="client"></user-card>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="review__exercises">\n' +
    '    <div class="review__exercises-header">\n' +
    '      {{\'EXERCISES\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="review__exercises-week" ng-repeat="week in reviewAssignmentCtrl.trainingPlanSessions">\n' +
    '      <div class="review__exercises-week-bar" ng-click="reviewAssignmentCtrl.toggleWeek($index)">\n' +
    '        <div class="review__exercises-week-name">\n' +
    '          {{week.weekName}} {{week.weekSubtitle}}\n' +
    '        </div>\n' +
    '        <div class="review__exercises-session-arrow" ng-if="!reviewAssignmentCtrl.trainingPlanSessions[$index].expanded">\n' +
    '          <img src="//images.jhtassets.com/3538848d5f0d56d14dfb8941b74bd629c86bbab7/">\n' +
    '        </div>\n' +
    '        <div class="review__exercises-session-arrow" ng-if="reviewAssignmentCtrl.trainingPlanSessions[$index].expanded">\n' +
    '          <img src="//images.jhtassets.com/447ebadef8fe188b8ef534cb6f23e1f12134bf5b/">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="review__exercises-week-contents" ng-if="reviewAssignmentCtrl.trainingPlanSessions[$index].expanded">\n' +
    '        <div ng-repeat="session in week.sessions" class="review__exercises-session">\n' +
    '          <div class="review__exercises-session-bar" ng-click="reviewAssignmentCtrl.toggleSessionInWeek($parent.$index, $index)">\n' +
    '            <div class="review__exercises-session-name">\n' +
    '              {{session.title}}\n' +
    '            </div>\n' +
    '            <div class="review__exercises-session-arrow" ng-if="!reviewAssignmentCtrl.trainingPlanSessions[$parent.$index].sessions[$index].expanded">\n' +
    '              <img src="//images.jhtassets.com/3538848d5f0d56d14dfb8941b74bd629c86bbab7/">\n' +
    '            </div>\n' +
    '            <div class="review__exercises-session-arrow" ng-if="reviewAssignmentCtrl.trainingPlanSessions[$parent.$index].sessions[$index].expanded">\n' +
    '              <img src="//images.jhtassets.com/447ebadef8fe188b8ef534cb6f23e1f12134bf5b/">\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="review__exercises-session-contents" ng-if="reviewAssignmentCtrl.trainingPlanSessions[$parent.$index].sessions[$index].expanded">\n' +
    '            <library-card\n' +
    '              class="review__exercises-session-exercise"\n' +
    '              ng-repeat="exercise in session.exercises"\n' +
    '              type="exercises"\n' +
    '              data="exercise"\n' +
    '              hide-edit-icon="true"\n' +
    '              hide-print-icon="true"\n' +
    '              disable-flip="true"\n' +
    '              add-button="false"\n' +
    '              remove-button="false">\n' +
    '            </library-card>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/assignment-workflow/select-time-frame/select-time-frame.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/assignment-workflow/select-time-frame/select-time-frame.html', '<div class="date-tab">\n' +
    '  <div class="workflow__nav-bar">\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-left"\n' +
    '      ng-if="selectTimeCtrl.type !== \'trainingPlanTemplate\'"\n' +
    '      ng-click="selectTimeCtrl.type === \'facility\' ? selectTimeCtrl.goToTab(\'assignmentType\') : selectTimeCtrl.goToTab(\'chooseClient\')">\n' +
    '      <i class="icon icon-triangle-left"></i> {{ selectTimeCtrl.type === \'facility\' ? \'ASSIGNMENT_TYPE\' : \'CLIENTS\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-left"\n' +
    '      ng-if="selectTimeCtrl.type === \'trainingPlanTemplate\'">\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-right"\n' +
    '      ng-class="{ \'workflow__nav-bar-btn--disabled\': !selectTimeCtrl.canGoToExerciseTab() }"\n' +
    '      ng-click="selectTimeCtrl.goToTab(\'sessionSetup\')">\n' +
    '        {{ \'SETUP\' | translate }} <i class="icon icon-triangle-right"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="date-tab__picker-wrapper date-tab__scrolling-datepicker-wrapper" ng-if="selectTimeCtrl.type !== \'trainingPlanTemplate\'">\n' +
    '    <scrolling-datepicker-component\n' +
    '      start-date="selectTimeCtrl.startDateInternal"\n' +
    '      end-date="selectTimeCtrl.endDateInternal"\n' +
    '      single-day="true"\n' +
    '      include-facility-assignments="selectTimeCtrl.type === \'facility\'"\n' +
    '      disabled="selectTimeCtrl.disableTimeChanges"\n' +
    '      on-start-date-change="selectTimeCtrl.handleStartDateChange($event)"\n' +
    '      on-end-date-change="selectTimeCtrl.handleEndDateChange($event)",\n' +
    '      depth="2"\n' +
    '    ></scrolling-datepicker-component>\n' +
    '  </div>\n' +
    '  <div class="date-tab__picker-wrapper scroll-area"\n' +
    '    ng-class="{\'date-tab__picker-wrapper--no-datepicker\': selectTimeCtrl.type === \'trainingPlanTemplate\'}"\n' +
    '    ng-if="selectTimeCtrl.type === \'trainingPlan\' || selectTimeCtrl.type === \'trainingPlanTemplate\'">\n' +
    '    <div class="workflow__title" ng-if="selectTimeCtrl.type !== \'trainingPlanTemplate\'">\n' +
    '      <div class="workflow__title-headers">\n' +
    '      {{ \'TRAINING_PROGRAM_START_DATE\' | translate }}\n' +
    '      </div>\n' +
    '      <div class="workflow__title-start-time">\n' +
    '        {{selectTimeCtrl.startDateInternal.format(\'MMMM DD\')}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="workflow__title" ng-if="selectTimeCtrl.type === \'trainingPlanTemplate\'">\n' +
    '      <div class="workflow__title-row">\n' +
    '        <span class="workflow__title-index">\n' +
    '        </span>\n' +
    '        <input class="workflow__title-titles"\n' +
    '          type="text"\n' +
    '          ng-model="selectTimeCtrl.nameInternal"\n' +
    '          placeholder="{{\'ENTER_TITLE\' | translate }}"\n' +
    '          ng-change="selectTimeCtrl.setName()">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="workflow__title">\n' +
    '      <div class="workflow__title-headers">\n' +
    '        <select class="workflow__title-items"\n' +
    '          ng-class="{\'workflow__title-items--disabled\': selectTimeCtrl.disableTimeChanges}"\n' +
    '          ng-model="selectTimeCtrl.weeksInternal"\n' +
    '          ng-change="selectTimeCtrl.setWeeks()"\n' +
    '          ng-options="x for x in selectTimeCtrl.weeksOptions"\n' +
    '          ng-disabled="selectTimeCtrl.disableTimeChanges">\n' +
    '        </select>\n' +
    '        {{ \'WEEKS\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="workflow__title">\n' +
    '      <div class="workflow__title-headers">\n' +
    '        {{ \'TRAINING_SESSIONS\' | translate }}\n' +
    '      </div>\n' +
    '      <div class="workflow__title-row" ng-repeat="title in selectTimeCtrl.trainingSessionsInternal track by $index">\n' +
    '        <span class="workflow__title-index">\n' +
    '            {{$index + 1}}\n' +
    '        </span>\n' +
    '        <input class="workflow__title-titles" type="text"\n' +
    '          placeholder="{{selectTimeCtrl.trainingTitle($index + 1)}}"\n' +
    '          ng-model="selectTimeCtrl.trainingSessionsInternal[$index].name"\n' +
    '          ng-change="selectTimeCtrl.setTrainingSessions()"></input>\n' +
    '        <i ng-if="!selectTimeCtrl.isEdit && selectTimeCtrl.trainingSessionsInternal.length > 1" class="icon icon-cross workflow__title-icon" ng-click="selectTimeCtrl.deleteTrainingSession($index)"></i>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="!selectTimeCtrl.isEdit && selectTimeCtrl.trainingSessionsInternal.length < 20" class="workflow__title-button" ng-click="selectTimeCtrl.addTrainingSession()">\n' +
    '      <i class="icon icon-ion-plus"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="date-tab__picker-wrapper" ng-if="selectTimeCtrl.type === \'facility\'">\n' +
    '    <div class="workflow__title">\n' +
    '      <div class="workflow__title-headers">\n' +
    '        {{\'WOTD\' | translate}}\n' +
    '      </div>\n' +
    '      <div class="workflow__title-start-time">\n' +
    '        {{selectTimeCtrl.startDateInternal.format(\'MMMM DD\')}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/assignment-workflow/session-setup-customize/session-setup-customize.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/assignment-workflow/session-setup-customize/session-setup-customize.html', '<div class="customize-tab">\n' +
    '  <div class="workflow__nav-bar">\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-left"\n' +
    '         ng-click="sessionSetupCustomizeCtrl.goToTab(\'selectTime\')">\n' +
    '      <i class="icon icon-triangle-left"></i> {{ sessionSetupCustomizeCtrl.type === \'trainingPlanTemplate\' ? \'PROGRAM\' : \'PROGRAM_DURATION\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="customize-tab__dropdown-container" ng-if="sessionSetupCustomizeCtrl.type === \'trainingPlan\' || sessionSetupCustomizeCtrl.type === \'trainingPlanTemplate\'">\n' +
    '      <select class="training-session-dropdown"\n' +
    '              ng-model="sessionSetupCustomizeCtrl.trainingSession"\n' +
    '              ng-options="((session.idx + 1) + \' - \' + session.name) for session in sessionSetupCustomizeCtrl.trainingSessions"\n' +
    '              ng-init="sessionSetupCustomizeCtrl.trainingSession=sessionSetupCustomizeCtrl.trainingSessions[0]"\n' +
    '              ng-change="sessionSetupCustomizeCtrl.update(sessionSetupCustomizeCtrl.trainingSession)"\n' +
    '      >\n' +
    '      </select>\n' +
    '    </div>\n' +
    '    <div class="customize-tab__button-container">\n' +
    '      <button class="exercise-button"\n' +
    '              ng-class="{\'button-selected\' : !sessionSetupCustomizeCtrl.isEditMode}"\n' +
    '              ng-click="sessionSetupCustomizeCtrl.pickExercise()">{{\'PICK_EXERCISES\' | translate}}\n' +
    '      </button>\n' +
    '      <button ng-disabled="sessionSetupCustomizeCtrl.isAnyExerciseSelected()"\n' +
    '              ng-click="sessionSetupCustomizeCtrl.customizeExercise()"\n' +
    '              class="customize-exercise-button"\n' +
    '              ng-class="{\'customize-exercise-button__disabled\': sessionSetupCustomizeCtrl.isAnyExerciseSelected(),\n' +
    '               \'button-selected\' : sessionSetupCustomizeCtrl.isEditMode }">{{\'CUSTOMIZE\' | translate}}\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="workflow__nav-bar-btn workflow__nav-bar-btn-right"\n' +
    '      ng-class="{ \'workflow__nav-bar-btn--disabled\': !sessionSetupCustomizeCtrl.canGoToReviewTab() }"\n' +
    '      ng-click="sessionSetupCustomizeCtrl.goToTab(\'reviewSave\')">\n' +
    '      {{ \'REVIEW_SAVE\' | translate }} <i class="icon icon-triangle-right"></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="!sessionSetupCustomizeCtrl.isEditMode" class="customize-tab__exercise_component">\n' +
    '    <pt-items-selector\n' +
    '      items-lists="[ sessionSetupCustomizeCtrl.exercises, sessionSetupCustomizeCtrl.trainingSets ]"\n' +
    '      selected-items="sessionSetupCustomizeCtrl.trainingPlanExercisesInternal[sessionSetupCustomizeCtrl.selectedSessionIndex]"\n' +
    '      hide-print-icon="true"\n' +
    '      get-item-params="sessionSetupCustomizeCtrl.getExercisesParams"\n' +
    '      get-load-params="sessionSetupCustomizeCtrl.getExerciseLoadParams"\n' +
    '      item-type="exercises"\n' +
    '      bag-type="trainingSets"\n' +
    '      drag-copy="true"\n' +
    '      show-tags="true">\n' +
    '    </pt-items-selector>\n' +
    '  </div>\n' +
    '  <div ng-if="sessionSetupCustomizeCtrl.isEditMode" class="create-exercise__customize">\n' +
    '    <pt-items-switcher\n' +
    '      selected-items="sessionSetupCustomizeCtrl.trainingPlanExercisesInternal[sessionSetupCustomizeCtrl.selectedSessionIndex]"\n' +
    '      bag-type="workoutAssignmentOther",\n' +
    '      on-index-update = "sessionSetupCustomizeCtrl.setActiveExerciseIndex(newIndex)">\n' +
    '    </pt-items-switcher>\n' +
    '    <div class="exercise-profile">\n' +
    '      <customize-exercise\n' +
    '        exercise=\'sessionSetupCustomizeCtrl.trainingPlanExercisesInternal[sessionSetupCustomizeCtrl.selectedSessionIndex][sessionSetupCustomizeCtrl.activeExerciseIndex]\'\n' +
    '        on-update=\'sessionSetupCustomizeCtrl.handleExerciseUpdate($event)\'\n' +
    '        context=\'assignment\'>\n' +
    '      </customize-exercise>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/calendar/calendar-body.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/calendar/calendar-body.html', '<div class="calendar-body">\n' +
    '\n' +
    '  <div class="calendar-body__month">\n' +
    '    <span class="calendar-body__month--number">\n' +
    '      {{body.getSelectedMonthNumber()}}\n' +
    '    </span>\n' +
    '    {{ body.getSelectedMonthName() | uppercase}}\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="calendar-body__week">\n' +
    '    <div class="calendar-body__weekday"\n' +
    '      ng-repeat="day in ::body.weekdays track by $index"\n' +
    '      ng-bind="::day">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div>\n' +
    '    <div ng-repeat="week in body.weeks track by $index">\n' +
    '      <div class="calendar-day calendar-day--single-event"\n' +
    '           ng-repeat="date in week track by $index"\n' +
    '           ng-class="{\n' +
    '             \'calendar-day--current\': date.current,\n' +
    '             \'calendar-day--past\': !date.isFuture && !date.current,\n' +
    '             \'calendar-day--selected\': !monthOffset && date.selected,\n' +
    '             \'calendar-day--empty\': date && date.isFuture && !date.events.length,\n' +
    '             \'calendar-day--no-date\': !date,\n' +
    '             \'calendar-day--hover-plus\': (!date.events.length || !options.facilityAssignmentsCalendar) && hoverPlus && body.canAddEvent}"\n' +
    '           ng-click="body.onDaySelected(date, $event)"\n' +
    '           ng-init="hoverPlus = false"\n' +
    '           ng-mouseenter="hoverPlus = true"\n' +
    '           ng-mouseleave="hoverPlus = false">\n' +
    '        <div class="calendar-day__add-event"\n' +
    '          ng-click="body.addEvent(date)"\n' +
    '        ></div>\n' +
    '        <div class="calendar-day__number" ng-bind="date.day"></div>\n' +
    '        <div class="calendar-day__events"\n' +
    '          ng-if="date.events.length && !options.facilityAssignmentsCalendar"\n' +
    '          ng-bind="date.events.length"></div>\n' +
    '        <div class="calendar-day__fa-event"\n' +
    '          ng-if="date.events.length && options.facilityAssignmentsCalendar"\n' +
    '          ng-class="{\'calendar-day__hover-runner\': hoverRunner}"\n' +
    '          ng-init="hoverRunner = false"\n' +
    '          ng-mouseenter="hoverRunner = true"\n' +
    '          ng-mouseleave="hoverRunner = false"\n' +
    '          ng-click="body.addEvent(date)"\n' +
    '        >\n' +
    '          <span class="calendar-day__event-count"\n' +
    '          ng-if="date.events.length >= 2">({{ date.events.length }})</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/create-exercise-dropdown/create-exercise-dropdown.component.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/create-exercise-dropdown/create-exercise-dropdown.component.html', '<div class="create-exercise-dropdown">\n' +
    '    <div class="create-exercise-dropdown__title">{{ createExerciseDropdownCtrl.title }}</div>\n' +
    '    <ui-select class="select-custom"\n' +
    '        search-enabled="false"\n' +
    '        ng-model="createExerciseDropdownCtrl.currentSelectedOptionDisplay"\n' +
    '        on-select="createExerciseDropdownCtrl.onOptionSelect($item)">\n' +
    '        <ui-select-match class="create-exercise-dropdown__selected-option" placeholder="{{ \'CHOOSE_EQUIPMENT_TYPE\' | translate | uppercase }}">\n' +
    '            <span class="create-exercise-dropdown__option">\n' +
    '                {{ createExerciseDropdownCtrl.currentSelectedOptionDisplay | uppercase }}\n' +
    '            </span>\n' +
    '        </ui-select-match>\n' +
    '        <ui-select-choices repeat="option in createExerciseDropdownCtrl.displayedOptions track by $index">\n' +
    '            <span class="create-exercise-dropdown__option">\n' +
    '                {{ option | uppercase }}\n' +
    '            </span>\n' +
    '        </ui-select-choices>\n' +
    '    </ui-select>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/cardio-program-range.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/cardio-program-range.html', '<div class="exercise-profile__cardio-program">\n' +
    '  <div class="exercise-profile__sliders fade-onload">\n' +
    '    <div class="exercise-profile__sliders-list">\n' +
    '      <h2 ng-if="cardioProgramRangeCtrl.showWarningMsg" ng-style="{\'background-color\':\'red\', \'color\':\'yellow\'}"> {{ \'SLIDER_WARNING\' | translate }} </h2>\n' +
    '      <div class="exercise-profile__sliders-item"\n' +
    '        ng-repeat="metric in cardioProgramRangeCtrl.exercise.preset.metrics">\n' +
    '        <div segment-slider\n' +
    '          ng-if="!metric.validation.enum"\n' +
    '          value="cardioProgramRangeCtrl.copyExerciseForSlider.assignedProfile.cardioProgram[metric.name]"\n' +
    '          options="metric.validation"\n' +
    '          on-end="cardioProgramRangeCtrl.updateSliders()">\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-if="metric.validation.enum"\n' +
    '          ng-repeat="val in metric.validation.enum"\n' +
    '          class="exercise-profile__buttons">\n' +
    '          <div class="exercise-profile__buttons-button">\n' +
    '            <input ng-model="cardioProgramRangeCtrl.exercise.assignedProfile.cardioProgram[metric.name]"\n' +
    '            type="radio"\n' +
    '            ng-value="val"\n' +
    '            ng-change = "cardioProgramRangeCtrl.updateEnum()"\n' +
    '            id="{{\'btn\'+ $index}}">\n' +
    '            <label for="{{\'btn\'+ $index}}"><span></span>{{val | lowercase | camelToSnakeCase | translate}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="exercise-profile__sliders-item-title">{{ metric.name | camelToSnakeCase | translate }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/connected-exercise-segments.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/connected-exercise-segments.html', '<div class="exercise-profile__info exercise-profile__info--training-set">\n' +
    '\n' +
    '  <!--============= TOP TILES WITH SUMMARY METRICS ================ -->\n' +
    '  <div class="exercise-profile__tiles">\n' +
    '    <div pt-centered>\n' +
    '        <metric-card ng-repeat="metric in connectedExerciseSegmentsCtrl.exercise.preset.metrics"\n' +
    '            metric-name="{{ metric.title | translate }}"\n' +
    '            metric-value="metric.name !== \'duration\' ? connectedExerciseSegmentsCtrl.exercise.assignedProfile.segments[0][metric.name] : connectedExerciseSegmentsCtrl.exercise.totalDuration"\n' +
    '            metric-unit="{{ metric.unit | camelToSnakeCase | translate }}"\n' +
    '            on-metric-value-update="connectedExerciseSegmentsCtrl.handleUpdate($event)"\n' +
    '        ></metric-card>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <!--============= SEGMENTS ================ -->\n' +
    '  <div class="exercise-profile__segments">\n' +
    '    <div class="exercise-profile__segments-title-center">{{ :: \'EXERCISE_PROFILE_HEADER\' | translate }}</div>\n' +
    '    <div class="exercise-profile__segments-content">\n' +
    '\n' +
    '      <!--============= SCROLL LEFT BUTTON ===========-->\n' +
    '      <div class="exercise-profile__segments-controls exercise-profile__segments-controls--left">\n' +
    '        <div class="exercise-profile__segments-control"\n' +
    '             ng-disabled="!connectedExerciseSegmentsCtrl.scrollInstance._enableLeft"\n' +
    '             ng-click="connectedExerciseSegmentsCtrl.scrollInstance.prev()">\n' +
    '          <i class="icon icon-arrow-back"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="exercise-profile__segments-controls exercise-profile__segments-controls">\n' +
    '\n' +
    '        <!--============= SCROLL RIGHT BUTTON ===========-->\n' +
    '        <div class="exercise-profile__segments-control"\n' +
    '             ng-disabled="!connectedExerciseSegmentsCtrl.scrollInstance._enableRight"\n' +
    '             ng-click="connectedExerciseSegmentsCtrl.scrollInstance.next()">\n' +
    '          <i class="icon icon-arrow-forward"></i>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="exercise-profile__segments-list">\n' +
    '\n' +
    '        <div class="exercise-profile__segments-list-wrapper iscroll-wrapper"\n' +
    '            iscroll="{scrollX: true, scrollY: false, mouseWheel: false, click: true, snap: true}"\n' +
    '            iscroll-instance="connectedExerciseSegmentsCtrl.scrollInstance">\n' +
    '\n' +
    '          <div class="iscroll-scroller iscroll-scroller--horizontal exercise-profile__segments-list-content">\n' +
    '            <div class="exercise-profile__segments-item"\n' +
    '                ng-repeat="segment in connectedExerciseSegmentsCtrl.segments"\n' +
    '                ng-class="{active: segment._isActive}"\n' +
    '                ng-click="connectedExerciseSegmentsCtrl.activateSegment(segment)">\n' +
    '\n' +
    '              <div class="exercise-profile__segments-counter">{{ $index + 1 }}</div>\n' +
    '              <div class="exercise-profile__segments-level-container">\n' +
    '                <div class="exercise-profile__segments-level"\n' +
    '                    ng-style="{height: connectedExerciseSegmentsCtrl.segmentProgressHeight(segment)}">\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <!--============= ADD SEGMENT BUTTON ===========-->\n' +
    '            <div class="exercise-profile__segments-control"\n' +
    '                permission\n' +
    '                permission-only="connectedExerciseSegmentsCtrl.editPermission"\n' +
    '                ng-click="connectedExerciseSegmentsCtrl.addSegment()"\n' +
    '                ng-disabled="!connectedExerciseSegmentsCtrl.moreSegmentsAvailable()">\n' +
    '              <i class="icon icon-ion-plus"></i>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!--============= SEGMENT DETAILS POPUP ================ -->\n' +
    '<div class="exercise-profile__sliders fade-onload"\n' +
    '     permission\n' +
    '     permission-only="connectedExerciseSegmentsCtrl.editPermission"\n' +
    '     ng-if="connectedExerciseSegmentsCtrl.activeSegment">\n' +
    '\n' +
    '  <div class="exercise-profile__sliders">\n' +
    '    <div class="exercise-profile__sliders-item"\n' +
    '         ng-repeat="metric in connectedExerciseSegmentsCtrl.exercise.preset.metrics | filter: {forSegment: true}">\n' +
    '      <div segment-slider\n' +
    '           value="connectedExerciseSegmentsCtrl.activeSegment[metric.name]"\n' +
    '           options="metric.validation"\n' +
    '           on-end="connectedExerciseSegmentsCtrl.sliderValueChanged(metric.name)">\n' +
    '      </div>\n' +
    '      <div class="exercise-profile__sliders-item-title">{{ metric.name | camelToSnakeCase | translate }}</div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="exercise-profile__sliders-buttons">\n' +
    '        <button class="exercise-profile__sliders-button exercise-profile__sliders-button--danger"\n' +
    '                ng-disabled="!connectedExerciseSegmentsCtrl.canDeleteSegments()"\n' +
    '                ng-click="connectedExerciseSegmentsCtrl.deleteActiveSegment()">\n' +
    '          {{ :: \'DELETE_SEGMENT\' | translate }}\n' +
    '        </button>\n' +
    '        <button class="exercise-profile__sliders-button"\n' +
    '                ng-click="connectedExerciseSegmentsCtrl.resetActiveSegment()">\n' +
    '          {{ :: \'RESET_SEGMENT\' | translate }}\n' +
    '        </button>\n' +
    '      </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '<!--============= EXERCISE DESCRIPTION ================ -->\n' +
    '<div pt-centered>\n' +
    '  <exercise-description\n' +
    '    exercise="connectedExerciseSegmentsCtrl.exercise"\n' +
    '    on-update="connectedExerciseSegmentsCtrl.handleUpdate($event)">\n' +
    '  </exercise-description>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/exercise-description.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/exercise-description.html', '<label class="create-exercise-details__description-title">\n' +
    '  <div class="customize-exercise__description">\n' +
    '    {{ :: \'DESCRIPTION\'  | translate}}\n' +
    '  </div>\n' +
    '  <textarea class="create-exercise-details__description"\n' +
    '            ng-model="exerciseDescriptionCtrl.exercise.description"\n' +
    '            ng-blur="exerciseDescriptionCtrl.update()"\n' +
    '            placeholder="{{ :: \'ENTER_DETAILS_EXERCISE\' | translate }}"\n' +
    '            >\n' +
    '  </textarea>\n' +
    '</label>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional-accordion.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional-accordion.html', '<div role="tab" id="{{::headingId}}" ng-click="toggleOpen()" aria-selected="{{!isOpen}}" class="panel-heading">\n' +
    '    <h3 class="panel-title">\n' +
    '        <a data-toggle="collapse" aria-expanded="{{!isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle"\n' +
    '            uib-accordion-transclude="heading" ng-disabled="isDisabled" style="text-decoration: none;">\n' +
    '            <span uib-accordion-header ng-class="{\'text-muted\': isDisabled}">{{heading}}</span>\n' +
    '            <img class="pull-right functional-exercise__collapse-button"\n' +
    '                src="https://images.jhtassets.com/09d6004551ecab85c8b37bcaf1321932b79424cd/"\n' +
    '                ng-class="{\'functional-exercise__collapse-button--down\': !isOpen}">\n' +
    '        </a>\n' +
    '    </h3>\n' +
    '</div>\n' +
    '<div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!!isOpen}}" role="tabpanel" class="panel-collapse collapse functional-exercise__panel"\n' +
    '    uib-collapse="!!isOpen">\n' +
    '    <div class="panel-body" ng-transclude></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional.html', '<div class="functional-exercise">\n' +
    '    <uib-accordion ng-repeat="set in functCtrl.sets">\n' +
    '        <div uib-accordion-group class="panel-default" is-open="functCtrl.internalStateCollapsedSetsTracker[$index]" template-url="/app/components/customize-exercise-components/components/functional-exercise-sets/customize-functional-accordion.html">\n' +
    '            <uib-accordion-heading>\n' +
    '                <div class="functional-exercise__set-number">{{$index + 1}}</div>\n' +
    '                <div class="functional-exercise__values-row">\n' +
    '                    <span ng-if="set.weight > 0">\n' +
    '                        <span class="functional-exercise__value" >{{set.weight}}</span>\n' +
    '                        <span class="functional-exercise__unit" >{{functCtrl.weightUnit| translate}}</span>\n' +
    '                        <span class="functional-exercise__value">/</span>\n' +
    '                    </span>\n' +
    '                    <span ng-if="set.type === \'standard\'">\n' +
    '                        <span class="functional-exercise__value" >{{set.reps}}</span>\n' +
    '                        <span class="functional-exercise__unit">{{ \'REPS\' | translate}}</span>\n' +
    '                    </span>\n' +
    '                    <span ng-if="set.type === \'toFailure\' || set.type === \'asManyReps\'">\n' +
    '                        <span class="functional-exercise__unit" ng-if="set.type === \'toFailure\'">{{ \'UF\' | translate }}</span>   \n' +
    '                        <span class="functional-exercise__unit" ng-if="set.type === \'asManyReps\'">{{ \'AMAP\' | translate }}</span>\n' +
    '                    </span>\n' +
    '                    <span ng-if="set.type === \'asManyReps\'">\n' +
    '                        <span class="functional-exercise__value">/{{set.duration}}</span>\n' +
    '                        <span class="functional-exercise__unit">{{ \'SEC\' | translate }}</span>\n' +
    '                    </span>\n' +
    '                    <span ng-if="functCtrl.sets.length > 1">\n' +
    '                        <span class="functional-exercise__value">/{{set.restTime}}</span>\n' +
    '                        <span class="functional-exercise__unit">{{ \'SEC\' | translate }}</span>\n' +
    '                    </span>\n' +
    '                </div>\n' +
    '                <img ng-src="{{ functCtrl.imagePath }}fonts/icon-delete.svg" class="functional-exercise__remove-button" ng-click="functCtrl.deleteSet($index)" ng-hide="functCtrl.sets.length===1">\n' +
    '            </uib-accordion-heading>\n' +
    '            <div class="functional-exercise__value-picker functional-exercise__weight-grouping">\n' +
    '                <form name="form" class="form-inline" novalidate>\n' +
    '                    <div class="form-group-weight">\n' +
    '                        <label class="functional-exercise__value-picker-label">{{ \'WEIGHT\' | translate }}:</label>\n' +
    '                        <br>\n' +
    '                        <div class="input-group functional-exercise__input-group">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.weight - functCtrl.metricsObj.weight.increment < functCtrl.metricsObj.weight.minValue"\n' +
    '                                    class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.decrementMetric(\'weight\',set)">\n' +
    '                                    <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                            <img class="functional-exercise__input-edit-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                            <input name="input" type=\'number\' ng-model="set.weight" class="form-control functional-exercise__number-input" ng-blur="functCtrl.manuallySetValue()">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.weight + functCtrl.metricsObj.weight.increment > functCtrl.metricsObj.weight.maxValue"\n' +
    '                                    class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.incrementMetric(\'weight\',set)">\n' +
    '                                    <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '                <form name="form" class="form-inline" novalidate>\n' +
    '                    <div class="form-group">\n' +
    '                        <label class="functional-exercise__value-picker-label">{{ \'REST_TIME\' | translate }} ({{ \'SEC\' | translate }}):</label>\n' +
    '                        <br>\n' +
    '                        <div class="input-group functional-exercise__input-group">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.restTime - functCtrl.metricsObj.restTime.increment < functCtrl.metricsObj.restTime.minValue"\n' +
    '                                    class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.decrementMetric(\'restTime\',set)">\n' +
    '                                    <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                            <img class="functional-exercise__input-edit-icon" src="{{ functCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                            <input name="input" type=\'number\' ng-model="set.restTime" class="form-control functional-exercise__number-input" ng-blur="functCtrl.manuallySetValue()">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                 <button ng-disabled="form.input.$invalid || set.restTime + functCtrl.metricsObj.restTime.increment > functCtrl.metricsObj.restTime.maxValue"\n' +
    '                                    class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.incrementMetric(\'restTime\',set)">\n' +
    '                                    <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '            <div class="functional-radio-container">\n' +
    '                <div class="functional-exercise__value-picker">\n' +
    '                    <form name="form" class="form-inline" novalidate>\n' +
    '                        <div class="input-group radio">\n' +
    '                            <label class="functional-exercise__value-picker-label functional-exercise__checkbox-label" >\n' +
    '                                <input type="radio" ng-model="set.type" value="standard" ng-change="functCtrl.typeChange()" >\n' +
    '                                <img class="functional-exercise__checkbox-img" \n' +
    '                                    ng-src="{{ set.type === \'standard\' ? \'//images.jhtassets.com/7b31cab26903dd249e70020b877c375950619a20/\' : \'//images.jhtassets.com/784df7de262dee8663e219eb6f1524f486050dac/\' }}">\n' +
    '                                <span class="functional-exercise__checkbox-text">{{ \'Reps\'| translate }}</span> \n' +
    '                            </label>\n' +
    '                            </br> \n' +
    '                            <label class="functional-exercise__value-picker-label functional-exercise__checkbox-label">\n' +
    '                                <input type="radio" ng-model="set.type" value="asManyReps" ng-change="functCtrl.typeChange()" >\n' +
    '                                <img class="functional-exercise__checkbox-img" \n' +
    '                                    ng-src="{{ set.type === \'asManyReps\' ? \'//images.jhtassets.com/7b31cab26903dd249e70020b877c375950619a20/\' : \'//images.jhtassets.com/784df7de262dee8663e219eb6f1524f486050dac/\' }}">\n' +
    '                                <span class="functional-exercise__checkbox-text">{{\'AMAP\'| translate }}</span>\n' +
    '                            </label>\n' +
    '                            <br>\n' +
    '                            <label class="functional-exercise__value-picker-label functional-exercise__checkbox-label">\n' +
    '                                <input type="radio" ng-model="set.type" value="toFailure" ng-change="functCtrl.typeChange()">\n' +
    '                                <img class="functional-exercise__checkbox-img" \n' +
    '                                    ng-src="{{ set.type === \'toFailure\' ? \'//images.jhtassets.com/7b31cab26903dd249e70020b877c375950619a20/\' : \'//images.jhtassets.com/784df7de262dee8663e219eb6f1524f486050dac/\' }}">\n' +
    '                                <span class="functional-exercise__checkbox-text">{{\'UF\'| translate }}</span>\n' +
    '                            </label>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '                <div>\n' +
    '                    <form name="form" class="form-inline" novalidate>\n' +
    '                        <div class="form-group">\n' +
    '                            <label class="functional-exercise__value-picker-label">{{ \'REPS\' | translate }}:</label>\n' +
    '                            <br>\n' +
    '                            <div class="input-group functional-exercise__input-group">\n' +
    '                                <span class="input-group-btn">\n' +
    '                                    <button ng-disabled="form.input.$invalid || set.reps - functCtrl.metricsObj.reps.increment < functCtrl.metricsObj.reps.minValue ||\n' +
    '                                                            set.type !== \'standard\'"\n' +
    '                                        class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.decrementMetric(\'reps\',set)">\n' +
    '                                        <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                    </button>\n' +
    '                                </span>\n' +
    '                                <img class="functional-exercise__input-edit-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                                <input name="input" type=\'number\' ng-model="set.reps" class="form-control functional-exercise__number-input" ng-blur="functCtrl.manuallySetValue()"\n' +
    '                                        ng-disabled="set.type !== \'standard\'">\n' +
    '                                <span class="input-group-btn">\n' +
    '                                    <button ng-disabled="form.input.$invalid || set.reps + functCtrl.metricsObj.reps.increment > functCtrl.metricsObj.reps.maxValue ||\n' +
    '                                            set.type !== \'standard\'"\n' +
    '                                        class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.incrementMetric(\'reps\',set)">\n' +
    '                                        <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                    </button>\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                    <form name="form" class="form-inline" novalidate>\n' +
    '                        <div class="form-group functional-exercise__duration-group">\n' +
    '                            <label class="functional-exercise__value-picker-label">{{ \'DURATION\' | translate }} ({{ \'SEC\' | translate }}):</label>\n' +
    '                            <br>\n' +
    '                            <div class="input-group functional-exercise__input-group">\n' +
    '                                <span class="input-group-btn">\n' +
    '                                    <button ng-disabled="form.input.$invalid || set.duration - functCtrl.metricsObj.duration.increment < functCtrl.metricsObj.duration.minValue || set.type !== \'asManyReps\'" \n' +
    '                                        class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.decrementMetric(\'duration\',set)">\n' +
    '                                        <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                    </button>\n' +
    '                                </span>\n' +
    '                                <img class="functional-exercise__input-edit-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                                <input name="input" type=\'number\' ng-model="set.duration" class="form-control functional-exercise__number-input" ng-blur="functCtrl.manuallySetValue()" ng-disabled="set.type !== \'asManyReps\'">\n' +
    '                                <span class="input-group-btn">\n' +
    '                                    <button ng-disabled="form.input.$invalid || set.duration + functCtrl.metricsObj.duration.increment > functCtrl.metricsObj.duration.maxValue || set.type !== \'asManyReps\'"\n' +
    '                                        class="btn btn-default functional-exercise__increment-button" type="button" ng-click="functCtrl.incrementMetric(\'duration\',set)">\n' +
    '                                        <img class="functional-exercise__increment-button-icon" ng-src="{{ functCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                    </button>\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </form>\n' +
    '                </div>\n' +
    '            </div> \n' +
    '        </div>\n' +
    '    </uib-accordion>\n' +
    '    <button type="button" class="btn btn-primary btn-lg btn-block functional-exercise__add-set-button" ng-click="functCtrl.addSet()" ng-disabled="!functCtrl.canAddSet()">\n' +
    '        <img class="functional-exercise__increment-button-icon-white" ng-src="{{ functCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '    </button>\n' +
    '</div>\n' +
    '\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/functional-exercise-sets/functional-exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/functional-exercise-sets/functional-exercise.html', '<div>\n' +
    '  <create-exercise-dropdown\n' +
    '    title="{{ \'EQUIPMENT_TYPE\' | translate}}"\n' +
    '    options="functionalSetsCtrl.translatedEquipmentTypesObjArray"\n' +
    '    current-selection="functionalSetsCtrl.equipmentType"\n' +
    '    handle-dropdown-change="functionalSetsCtrl.equipmentTypeUpdate($event)"\n' +
    '  ></create-exercise-dropdown>\n' +
    '  <customize-functional\n' +
    '    sets="functionalSetsCtrl.sets"\n' +
    '    on-update="functionalSetsCtrl.handleUpdate($event)">\n' +
    '  </customize-functional>\n' +
    '  <div class="strength-exercise__padding">\n' +
    '    <exercise-description\n' +
    '      exercise="functionalSetsCtrl.exercise"\n' +
    '      on-update="functionalSetsCtrl.updatedDescription($event)">\n' +
    '    </exercise-description>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/non-connected-exercise-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/non-connected-exercise-details.html', '<div class="exercise-profile__info">\n' +
    '    <create-exercise-dropdown\n' +
    '        title="{{ \'EXERCISE_CATEGORY\' | translate}}"\n' +
    '        options="nonConnectedExerciseDetailsCtrl.categories"\n' +
    '        current-selection="nonConnectedExerciseDetailsCtrl.exercise.category"\n' +
    '        handle-dropdown-change="nonConnectedExerciseDetailsCtrl.handleCategoryChange($event)"\n' +
    '    ></create-exercise-dropdown>\n' +
    '\n' +
    '    <div pt-centered>\n' +
    '        <metric-card ng-repeat="metric in nonConnectedExerciseDetailsCtrl.metricsList"\n' +
    '            metric-name="{{ metric.title | translate }}"\n' +
    '            metric-value="nonConnectedExerciseDetailsCtrl.exercise.assignedProfile.global[metric.name]"\n' +
    '            metric-unit="{{ metric.unit | camelToSnakeCase | translate }}"\n' +
    '            edit-type="{{ metric.name === \'duration\' ? \'duration\' : \'number\' }}"\n' +
    '            on-metric-value-update="nonConnectedExerciseDetailsCtrl.handleMetricUpdate($event, metric.name)"\n' +
    '        ></metric-card>\n' +
    '    </div>\n' +
    '\n' +
    '    <div pt-centered>\n' +
    '      <exercise-description\n' +
    '        exercise="nonConnectedExerciseDetailsCtrl.exercise"\n' +
    '        on-update="nonConnectedExerciseDetailsCtrl.updateExercise($event)">\n' +
    '      </exercise-description>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-chart.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-chart.html', '<div class="chart-container sprint8__chart-container">\n' +
    '    <canvas id="myChart"></canvas>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-legend.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/sprint8-exercise-level/helpers/sprint8-exercise-level-legend.html', '<div class="legend_item">\n' +
    '    <div class="square" ng-style="{\'background\': myColor}"></div>\n' +
    '    <div class="infoBox">\n' +
    '      <div class="title">{{myTitle}}</div>\n' +
    '      <div class="speed">{{mySubText[0]}}</div>\n' +
    '      <div class="incline">{{mySubText[1]}}</div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/components/customize-exercise-components/components/sprint8-exercise-level/sprint8-exercise-level.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/sprint8-exercise-level/sprint8-exercise-level.html', '<div class="sprint8">\n' +
    '  <div class="sprint8__selector">\n' +
    '    <div class="sprint8__nav_category">\n' +
    '      <div class="sprint8__sTabs">\n' +
    '        <div class="sprint8__tabB" ng-click="s8lvlCtrl.setLevelCategory(\'B\')">{{ \'BEGINNER_ABBREV\' | translate }}</div>\n' +
    '        <div class="sprint8__tabI" ng-click="s8lvlCtrl.setLevelCategory(\'I\')">{{ \'INTERMEDIATE_ABBREV\' | translate }}</div>\n' +
    '        <div class="sprint8__tabA" ng-click="s8lvlCtrl.setLevelCategory(\'A\')">{{ \'ADVANCED_ABBREV\' | translate }}</div>\n' +
    '        <div class="sprint8__tabE" ng-click="s8lvlCtrl.setLevelCategory(\'E\')">{{ \'ELITE_ABBREV\' | translate }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="sprint8__levels_nav container-fluid" ng-style="{\'background-color\': s8lvlCtrl.selectedCategory.color}">\n' +
    '      <div class="row">\n' +
    '        <div class="sprint8__level_lvlName hidden-xs col-sm-4 col-md-3 sprint8__vertical-center">\n' +
    '          {{ s8lvlCtrl.selectedCategory.fullName + \'_CAPS\' | translate }} {{ \'LEVELS_CAPS\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="sprint8__level_bubbles col-xs-12 col-sm-8 col-md-9">\n' +
    '          <ul>\n' +
    '            <li ng-repeat="lvl in s8lvlCtrl.selectedCategory.lvls" ng-style="s8lvlCtrl.sprintLevel == lvl ? {\'color\': s8lvlCtrl.selectedCategory.color, \'background-color\': \'white\'} : {}"\n' +
    '              ng-click="s8lvlCtrl.setLvl(lvl)">\n' +
    '              {{lvl}}\n' +
    '            </li>\n' +
    '          </ul>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="sprint8__chart">\n' +
    '      <sprint8-exercise-level-chart\n' +
    '        equipment-type="s8lvlCtrl.equipmentType"\n' +
    '        sprint-level="s8lvlCtrl.sprintLevel">\n' +
    '      </sprint8-exercise-level-chart>\n' +
    '    </div>\n' +
    '    <div class="sprint8__legend">\n' +
    '      <div class="container-fluid">\n' +
    '        <div class="row">\n' +
    '          <span class="col-xs-6 col-sm-3">\n' +
    '            <sprint8-exercise-level-legend\n' +
    '              my-title="{{ \'WARMUP\' | translate }}"\n' +
    '              my-color="{{s8lvlCtrl.LEGEND_COLORS[0]}}">\n' +
    '            </sprint8-exercise-level-legend>\n' +
    '          </span>\n' +
    '          <span class="col-xs-6 col-sm-3">\n' +
    '            <sprint8-exercise-level-legend\n' +
    '              my-title="{{ \'SPRINT_INTERVAL\' | translate }}"\n' +
    '              my-color="{{s8lvlCtrl.LEGEND_COLORS[1]}}"\n' +
    '              my-sub-text="s8lvlCtrl.legendData.sprintTxtArray[s8lvlCtrl.sprintLevel-1]">\n' +
    '            </sprint8-exercise-level-legend>\n' +
    '          </span>\n' +
    '          <span class="col-xs-6 col-sm-3">\n' +
    '            <sprint8-exercise-level-legend\n' +
    '              my-title="{{ \'ACTIVE_RECOVERY\' | translate }}"\n' +
    '              my-color="{{s8lvlCtrl.LEGEND_COLORS[2]}}"\n' +
    '              my-sub-text="s8lvlCtrl.legendData.recoveryTxtArray[s8lvlCtrl.sprintLevel-1]">\n' +
    '            </sprint8-exercise-level-legend>\n' +
    '          </span>\n' +
    '          <span class="col-xs-6 col-sm-3">\n' +
    '            <sprint8-exercise-level-legend\n' +
    '              my-title="{{ \'COOL_DOWN\' | translate }}"\n' +
    '              my-color="{{s8lvlCtrl.LEGEND_COLORS[3]}}">\n' +
    '            </sprint8-exercise-level-legend>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrength.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrength.html', '<div class="advanced-strength">\n' +
    '    <div class="advanced-strength__title">{{ \'SETS\' | translate }}</div>\n' +
    '    <uib-accordion ng-repeat="set in advStrCtrl.sets">\n' +
    '        <div uib-accordion-group class="panel-default" is-open="advStrCtrl.internalStateCollapsedSetsTracker[$index]" template-url="/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrengthAccordion.html">\n' +
    '            <uib-accordion-heading>\n' +
    '                <div class="advanced-strength__set-number">{{$index + 1}}</div>\n' +
    '                <div class="advanced-strength__values-row">\n' +
    '                    <span class="advanced-strength__value">{{set.weight}}</span> <span class="advanced-strength__unit">{{advStrCtrl.userUnit | translate}}</span>\n' +
    '                    /\n' +
    '                    <span class="advanced-strength__value">{{set.reps}}</span> <span class="advanced-strength__unit">{{ \'REPS\' | translate}}</span>\n' +
    '                </div>\n' +
    '                <img ng-src="{{ advStrCtrl.imagePath }}fonts/icon-delete.svg" class="advanced-strength__remove-button" ng-click="advStrCtrl.deleteSet($index)" ng-hide="advStrCtrl.sets.length===1">\n' +
    '            </uib-accordion-heading>\n' +
    '            <div class="advanced-strength__value-picker">\n' +
    '                <form name="form" class="form-inline" novalidate>\n' +
    '                    <div class="form-group">\n' +
    '                        <label class="advanced-strength__value-picker-label">{{ \'WEIGHT\' | translate }} ({{advStrCtrl.userUnit | translate}}) </label>\n' +
    '                        <br>\n' +
    '                        <div class="input-group advanced-strength__input-group">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.weight <= advStrCtrl.metricsObj.weight.minValue" class="btn btn-default advanced-strength__increment-button"\n' +
    '                                    type="button" ng-click="advStrCtrl.decrementMetric(\'weight\',set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                            <img class="advanced-strength__input-edit-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                            <input name="input" type=\'number\' ng-model="set.weight" class="form-control advanced-strength__number-input" ng-blur="advStrCtrl.manuallySetValue()">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.weight >= advStrCtrl.metricsObj.weight.maxValue" class="btn btn-default advanced-strength__increment-button"\n' +
    '                                    type="button" ng-click="advStrCtrl.incrementMetric(\'weight\', set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '            <br>\n' +
    '            <div class="advanced-strength__value-picker">\n' +
    '                <form name="form" class="form-inline" novalidate>\n' +
    '                    <div class="form-group">\n' +
    '                        <label class="advanced-strength__value-picker-label">{{ \'REPS\' | translate }}:</label>\n' +
    '                        <br>\n' +
    '                        <div class="input-group advanced-strength__input-group">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.reps - advStrCtrl.metricsObj.reps.increment < advStrCtrl.metricsObj.reps.minValue"\n' +
    '                                    class="btn btn-default advanced-strength__increment-button" type="button" ng-click="advStrCtrl.decrementMetric(\'reps\',set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                            <img class="advanced-strength__input-edit-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                            <input name="input" type=\'number\' ng-model="set.reps" class="form-control advanced-strength__number-input" ng-blur="advStrCtrl.manuallySetValue()">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.reps + advStrCtrl.metricsObj.reps.increment > advStrCtrl.metricsObj.reps.maxValue"\n' +
    '                                    class="btn btn-default advanced-strength__increment-button" type="button" ng-click="advStrCtrl.incrementMetric(\'reps\',set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '            <br>\n' +
    '            <div class="advanced-strength__value-picker">\n' +
    '                <form name="form" class="form-inline" novalidate>\n' +
    '                    <div class="form-group">\n' +
    '                        <label class="advanced-strength__value-picker-label">{{ \'REST_TIME\' | translate }} ({{ \'SEC\' | translate }}):</label>\n' +
    '                        <br>\n' +
    '                        <div class="input-group advanced-strength__input-group">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.restTime - advStrCtrl.metricsObj.restTime.increment < advStrCtrl.metricsObj.restTime.minValue"\n' +
    '                                    class="btn btn-default advanced-strength__increment-button" type="button" ng-click="advStrCtrl.decrementMetric(\'restTime\',set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                            <img class="advanced-strength__input-edit-icon" src="{{ advStrCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                            <input name="input" type=\'number\' ng-model="set.restTime" class="form-control advanced-strength__number-input" ng-blur="advStrCtrl.manuallySetValue()">\n' +
    '                            <span class="input-group-btn">\n' +
    '                                <button ng-disabled="form.input.$invalid || set.restTime + advStrCtrl.metricsObj.restTime.increment > advStrCtrl.metricsObj.restTime.maxValue"\n' +
    '                                    class="btn btn-default advanced-strength__increment-button" type="button" ng-click="advStrCtrl.incrementMetric(\'restTime\',set)">\n' +
    '                                    <img class="advanced-strength__increment-button-icon" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </form>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </uib-accordion>\n' +
    '    <button type="button" class="btn btn-primary btn-lg btn-block advanced-strength__add-set-button" ng-click="advStrCtrl.addSet()" ng-disabled="!advStrCtrl.canAddSet()">\n' +
    '        <img class="advanced-strength__increment-button-icon-white" ng-src="{{ advStrCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '    </button>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrengthAccordion.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/strength-exercise-sets/sharable/advancedStrengthAccordion.html', '<div role="tab" id="{{::headingId}}" ng-click="toggleOpen()" aria-selected="{{!isOpen}}" class="panel-heading">\n' +
    '    <h3 class="panel-title">\n' +
    '        <a data-toggle="collapse" aria-expanded="{{!isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle"\n' +
    '            uib-accordion-transclude="heading" ng-disabled="isDisabled" style="text-decoration: none;">\n' +
    '            <span uib-accordion-header ng-class="{\'text-muted\': isDisabled}">{{heading}}</span>\n' +
    '            <img class="pull-right advanced-strength__collapse-button"\n' +
    '                src="https://images.jhtassets.com/09d6004551ecab85c8b37bcaf1321932b79424cd/"\n' +
    '                ng-class="{\'advanced-strength__collapse-button--down\': !isOpen}">\n' +
    '        </a>\n' +
    '    </h3>\n' +
    '</div>\n' +
    '<div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!!isOpen}}" role="tabpanel" class="panel-collapse collapse"\n' +
    '    uib-collapse="!!isOpen">\n' +
    '    <div class="panel-body" ng-transclude></div>\n' +
    '</div>');
  }]);
angular.module('/app/components/customize-exercise-components/components/strength-exercise-sets/strength-exercise-sets.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/strength-exercise-sets/strength-exercise-sets.html', '<div class="strength-exercise">\n' +
    '  <create-exercise-dropdown\n' +
    '    title="{{ \'STRENGTH_MACHINE_TYPE\' | translate}}"\n' +
    '    options="setCtrl.translatedEquipmentTypesObjArray"\n' +
    '    current-selection="setCtrl.equipmentType"\n' +
    '    handle-dropdown-change="setCtrl.equipmentTypeUpdate($event)"\n' +
    '  ></create-exercise-dropdown>\n' +
    '  <div class="metric-card-container">\n' +
    '    <metric-card\n' +
    '      metric-name="{{ \'TOTAL_SETS\' | translate }}"\n' +
    '      metric-value="setCtrl.sets.length"\n' +
    '      metric-unit="{{ \'SETS\' | translate }}"\n' +
    '    ></metric-card>\n' +
    '    <metric-card\n' +
    '      metric-name="{{ \'MAX_WEIGHT\' | translate }}"\n' +
    '      metric-value="setCtrl.maxWeight"\n' +
    '      metric-unit="{{ setCtrl.userUnit | translate }}"\n' +
    '    ></metric-card>\n' +
    '    <metric-card\n' +
    '      metric-name="{{ \'TOTAL_SECONDS\' | translate }}"\n' +
    '      metric-value="setCtrl.totalRestTime"\n' +
    '      metric-unit="{{ \'SEC\' | translate }}"\n' +
    '    ></metric-card>\n' +
    '  </div>\n' +
    '  <advanced-strength\n' +
    '      sets="setCtrl.sets"\n' +
    '      on-update="setCtrl.handleUpdate($event)">\n' +
    '  </advanced-strength>\n' +
    '  <div class="strength-exercise__padding">\n' +
    '    <exercise-description\n' +
    '      exercise="setCtrl.exercise"\n' +
    '      on-update="setCtrl.updatedDescription($event)">\n' +
    '    </exercise-description>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/components/virtual-active-exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/components/virtual-active-exercise.html', '<div class="exercise-profile__cardio-program">\n' +
    '  <div class="exercise-profile__sliders fade-onload">\n' +
    '    <div class="exercise-profile__sliders-list">\n' +
    '\n' +
    '      <!-- show enum metric - ie - location -->\n' +
    '      <create-exercise-dropdown\n' +
    '        title="{{ \'LOCATION\' | translate }}"\n' +
    '        options="virtualActiveExerciseCtrl.objLocations"\n' +
    '        current-selection="virtualActiveExerciseCtrl.exercise.assignedProfile.cardioProgram.location"\n' +
    '        handle-dropdown-change="virtualActiveExerciseCtrl.updateLocation($event)"\n' +
    '      ></create-exercise-dropdown>\n' +
    '\n' +
    '      <!-- show non-enum metrics -->\n' +
    '      <div class="exercise-profile__sliders-item"\n' +
    '        ng-repeat="metric in virtualActiveExerciseCtrl.exercise.preset.metrics">\n' +
    '        <div segment-slider\n' +
    '          ng-if="!metric.validation.enum" \n' +
    '          value="virtualActiveExerciseCtrl.exercise.assignedProfile.cardioProgram[metric.name]"\n' +
    '          options="metric.validation"\n' +
    '          on-end="virtualActiveExerciseCtrl.updateSliders()">\n' +
    '        </div>\n' +
    '        <div ng-if="!metric.validation.enum" class="exercise-profile__sliders-item-title">{{ metric.name | camelToSnakeCase | translate }}</div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
  }]);
angular.module('/app/components/customize-exercise-components/customize-exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/customize-exercise-components/customize-exercise.html', '<div ng-switch=\'customizeExerciseCtrl.exerciseClassification\' class="customize-exercise__content">\n' +
    '    <non-connected-exercise-details\n' +
    '        exercise=\'customizeExerciseCtrl.currentExercise\'\n' +
    '        edit-permission=\'customizeExerciseCtrl.editPermission\'\n' +
    '        ng-switch-when=\'non-connected-exercise\'\n' +
    '        on-update=\'customizeExerciseCtrl.handleUpdate($event)\'\n' +
    '        context=\'{{customizeExerciseCtrl.context}}\'>\n' +
    '    </non-connected-exercise-details>\n' +
    '\n' +
    '    <connected-exercise-segments\n' +
    '        exercise=\'customizeExerciseCtrl.currentExercise\'\n' +
    '        edit-permission=\'customizeExerciseCtrl.editPermission\'\n' +
    '        ng-switch-when=\'connected-exercise\'\n' +
    '        on-update=\'customizeExerciseCtrl.handleUpdate($event)\'>\n' +
    '    </connected-exercise-segments>\n' +
    '\n' +
    '    <cardio-program-range\n' +
    '        exercise=\'customizeExerciseCtrl.currentExercise\'\n' +
    '        edit-permission=\'customizeExerciseCtrl.editPermission\'\n' +
    '        ng-switch-when=\'migros-exercise|thr-exercise\'\n' +
    '        ng-switch-when-separator=\'|\'\n' +
    '        on-update=\'customizeExerciseCtrl.handleUpdate($event)\'>\n' +
    '    </cardio-program-range>\n' +
    '\n' +
    '    <virtual-active-exercise\n' +
    '        exercise="customizeExerciseCtrl.currentExercise"\n' +
    '        edit-permission="customizeExerciseCtrl.editPermission"\n' +
    '        ng-switch-when="virtual-active-exercise"\n' +
    '        on-cardio-program-update="customizeExerciseCtrl.handleCardioProgramUpdate($event)">\n' +
    '    </virtual-active-exercise>\n' +
    '\n' +
    '    <sprint8-exercise-level\n' +
    '        equipment-type=\'customizeExerciseCtrl.exercise.equipmentType\'\n' +
    '        sprint-level=\'customizeExerciseCtrl.exercise.assignedProfile.cardioProgram.level\'\n' +
    '        ng-switch-when="sprint8-exercise"\n' +
    '        on-update="customizeExerciseCtrl.handleLevelUpdate($event)">\n' +
    '    </sprint8-exercise-level>\n' +
    '\n' +
    '    <strength-exercise-sets\n' +
    '        exercise=\'customizeExerciseCtrl.currentExercise\'\n' +
    '        ng-switch-when=\'strength-exercise\'\n' +
    '        sets=\'customizeExerciseCtrl.currentExercise.assignedProfile.segments\'\n' +
    '        description=\'customizeExerciseCtrl.currentExercise.description\'\n' +
    '        context=\'{{customizeExerciseCtrl.context}}\'\n' +
    '        equipment-type=\'{{customizeExerciseCtrl.currentExercise.equipmentType}}\'\n' +
    '        on-equipment-type-update=\'customizeExerciseCtrl.handleEquipmentType($event)\'\n' +
    '        on-weight-set-update="customizeExerciseCtrl.handleSetsUpdate($event)"\n' +
    '        on-assignment-description-update="customizeExerciseCtrl.handleAssignmentDescriptionUpdate($event)">\n' +
    '    </strength-exercise-sets>\n' +
    '\n' +
    '    <functional-exercise-sets\n' +
    '        exercise=\'customizeExerciseCtrl.currentExercise\'\n' +
    '        ng-switch-when=\'functional-exercise\'\n' +
    '        sets=\'customizeExerciseCtrl.currentExercise.assignedProfile.segments\'\n' +
    '        description=\'customizeExerciseCtrl.currentExercise.description\'\n' +
    '        context=\'{{customizeExerciseCtrl.context}}\'\n' +
    '        equipment-type=\'{{customizeExerciseCtrl.currentExercise.equipmentType}}\'\n' +
    '        on-equipment-type-update=\'customizeExerciseCtrl.handleEquipmentType($event)\'\n' +
    '        on-description-update="customizeExerciseCtrl.handleAssignmentDescriptionUpdate($event)"\n' +
    '        on-set-update="customizeExerciseCtrl.handleSetsUpdate($event)">\n' +
    '    </functional-exercise-sets>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/datepicker/datepicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/datepicker/datepicker.html', '<div class=\'datepicker\' ng-class="{\'ng-invalid\': !isValid && true}">\n' +
    '  <div ng-if="!collapsed" class=\'datepicker__container\'>\n' +
    '    <div class=\'datepicker__header\'>\n' +
    '      <div class=\'datepicker__prev\' ng-click=\'prev()\'>\n' +
    '        <img src="//images.jhtassets.com/24aa3742430a6aa24cac94fccb886943098681ec/">\n' +
    '      </div>\n' +
    '      <div class=\'datepicker__title\'>{{getTitle()}}</div>\n' +
    '      <div class=\'datepicker__next\' ng-click=\'next()\'>\n' +
    '        <img src="//images.jhtassets.com/becccdb54fe56925875de5bd98804462cf3774a7/">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class=\'datepicker__row\' ng-if=\'weeks\' data-ng-repeat=\'week in weeks\'>\n' +
    '      <div data-ng-repeat=\'day in week track by $index\'\n' +
    '        class=\'datepicker__ceil-container\'>\n' +
    '        <div class=\'datepicker__ceil\'\n' +
    '             ng-class="{\'datepicker__ceil--day\': day >= 0,\n' +
    '            \'datepicker__ceil--inactive\': !day,\n' +
    '           \'datepicker__ceil--selected\': isSelected(day),\n' +
    '            \'datepicker__ceil--current\': day && day === now(),\n' +
    '           \'datepicker__ceil--not-availiable\': !isAvailiable(day)}"\n' +
    '             ng-click=\'selectDay(day)\'>{{day || " "}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/datetime-details/datetime-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/datetime-details/datetime-details.html', '<div class="datetime-details">\n' +
    '  <div class="datetime-details__section">\n' +
    '    <div class="datetime-details__block">\n' +
    '        <div class="datetime-details__datetime">\n' +
    '          <div class="datetime-details__datetime__date">\n' +
    '            <div class="datetime-details__number">\n' +
    '                {{ dateStartMoment | dateFormatter:\'dateShort\' }}\n' +
    '            </div>\n' +
    '            <div class="datetime-details__label">\n' +
    '              <span ng-if="!isSameDay">{{ :: \'START_DATE\' | translate }}</span>\n' +
    '              <span ng-if="isSameDay">{{ :: \'DATE\' | translate }}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="datetime-details__datetime__time" ng-if="timeStartMoment">\n' +
    '            <div class="datetime-details__number">\n' +
    '              <a href ng-click="showSchedule()">{{ timeStartMoment | dateFormatter:\'time\' }}</a>\n' +
    '            </div>\n' +
    '            <div class="datetime-details__label">\n' +
    '              <span ng-if="isSameDay">{{ :: \'TIME\' | translate }}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-if="!isSameDay" class="datetime-details__block">\n' +
    '        <div class="datetime-details__number">\n' +
    '            {{ dateEndMoment | dateFormatter:\'dateShort\' }}\n' +
    '        </div>\n' +
    '        <div class="datetime-details__label">{{ :: \'END_DATE\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section" ng-if="timeStartMoment">\n' +
    '    <div class="datetime-details__block">\n' +
    '      <div class="datetime-details__text">\n' +
    '          {{\'DURATION\' | translate}}\n' +
    '      </div>\n' +
    '      <ui-select\n' +
    '        class="select-custom"\n' +
    '        search-enabled="false"\n' +
    '        append-to-body="true"\n' +
    '        ng-model="timeDuration.selected">\n' +
    '        <ui-select-match>\n' +
    '          <span class="datetime-details__selection">{{$select.selected.humanize()}}</span>\n' +
    '        </ui-select-match>\n' +
    '        <ui-select-choices repeat="option in timeDurationOptions" ui-disable-choice="disableTimeDurationOption(option)">\n' +
    '          <span\n' +
    '            ng-bind="::option.humanize()"></span>\n' +
    '        </ui-select-choices>\n' +
    '      </ui-select>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section" ng-if="!isEditingIndividualRecurrence && !disableRecurrence" ng-form="recurrenceForm.form">\n' +
    '    <div class="datetime-details__block">\n' +
    '      <div class="datetime-details__text">\n' +
    '          {{\'WILL_OCCUR\' | translate}}\n' +
    '      </div>\n' +
    '      <ui-select\n' +
    '        ng-if="::!recurrence.recurrenceIdx"\n' +
    '        class="select-custom"\n' +
    '        search-enabled="false"\n' +
    '        append-to-body="true"\n' +
    '        ng-model="recurrence.recurrenceType">\n' +
    '        <ui-select-match>\n' +
    '          <span class="datetime-details__selection">{{ \'RECURRENCE_OPTION_\' + $select.selected | uppercase | translate }}</span>\n' +
    '        </ui-select-match>\n' +
    '        <ui-select-choices repeat="option in recurrenceOptions" ui-disable-choice="!checkRecurrenceOptionValidity(option)">\n' +
    '          <span\n' +
    '            ng-bind="\'RECURRENCE_OPTION_\' + option | uppercase | translate"></span>\n' +
    '        </ui-select-choices>\n' +
    '      </ui-select>\n' +
    '      <div ng-if="::recurrence.recurrenceIdx">\n' +
    '        {{ \'RECURRENCE_OPTION_\' + recurrence.recurrenceType | uppercase | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="datetime-details__block" ng-if="recurrence.recurrenceType !== \'once\'">\n' +
    '      <span class="datetime-details__text">{{\'FOR\' | translate}}</span>\n' +
    '      <span class="datetime-details__number">\n' +
    '          <input\n' +
    '            name="recurrenceNumber"\n' +
    '            class="input--inline-text input--real-time-validation"\n' +
    '            ng-class="{\'input--clear\' : recurrence.recurrenceNumber }"\n' +
    '            type="number"\n' +
    '            ng-model="recurrence.recurrenceNumber"\n' +
    '            ng-model-options="{ allowInvalid: true }"\n' +
    '            match-width-to-value\n' +
    '            ng-min="pastRecurrenceMoments.length || 1" />\n' +
    '      </span>\n' +
    '      <span class="datetime-details__text">{{getRecurrenceUnit(recurrence.recurrenceType) | uppercase | translate}}</span>\n' +
    '      <div ng-if="recurrenceForm.form.recurrenceNumber.$invalid" class="text-error">\n' +
    '        {{ \'RECURRENCE_NUMBER_INVALID\' | translate }}\n' +
    '        <span ng-if="pastRecurrenceMoments.length">{{ \'RECURRENCES_HAVE_PASSED\' | translate }}</span>\n' +
    '      </div>\n' +
    '      <div ng-if=":: recurrence.recurrenceIdx">\n' +
    '        {{ \'INITIAL_RECURRENCE\' | translate }}\n' +
    '        {{ inferredRecurrenceMoments[0] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if="pastRecurrenceMoments.length">\n' +
    '        {{ \'NEXT_EDITABLE_RECURRENCE\' | translate }}\n' +
    '        {{ inferredRecurrenceMoments[pastRecurrenceMoments.length] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if="recurrence.recurrenceNumber > 1">\n' +
    '        {{ \'FINAL_RECURRENCE\' | translate }}\n' +
    '        {{ inferredRecurrenceMoments[inferredRecurrenceMoments.length - 1] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if=":: recurrence.recurrenceIdx">\n' +
    '        {{ \'RECURRENCES_REMAINING\' | translate }}\n' +
    '        {{ inferredRecurrenceMoments.length - pastRecurrenceMoments.length }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section" ng-if="isEditingIndividualRecurrence">\n' +
    '      <p>{{ \'INDIVIDUAL_OCCURRENCE_DESCRIPTION\' | translate }}</p>\n' +
    '      <a href ng-click="editSeries()">{{ \'EDIT_SERIES\' | translate }}</a>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/datetime-details-component/datetime-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/datetime-details-component/datetime-details.html', '<div class="datetime-details">\n' +
    '  <div class="datetime-details__section">\n' +
    '    <div class="datetime-details__block">\n' +
    '      <div class="datetime-details__datetime">\n' +
    '        <div class="datetime-details__datetime__date">\n' +
    '          <div class="datetime-details__number">\n' +
    '              {{ datetimeDetailsCtrl.startDate | dateFormatter:\'dateShort\' }}\n' +
    '          </div>\n' +
    '          <div class="datetime-details__label">\n' +
    '            <span ng-if="!datetimeDetailsCtrl.isSameDay">{{ :: \'START_DATE\' | translate }}</span>\n' +
    '            <span ng-if="datetimeDetailsCtrl.isSameDay">{{ :: \'DATE\' | translate }}</span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="datetime-details__datetime__time" ng-if="datetimeDetailsCtrl.startTime">\n' +
    '          <div class="datetime-details__number">\n' +
    '            <a href ng-click="datetimeDetailsCtrl.showSchedule()">{{ datetimeDetailsCtrl.startTime | dateFormatter:\'time\' }}</a>\n' +
    '          </div>\n' +
    '          <div class="datetime-details__label">\n' +
    '            <span ng-if="datetimeDetailsCtrl.isSameDay">{{ :: \'TIME\' | translate }}</span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="!datetimeDetailsCtrl.isSameDay" class="datetime-details__block">\n' +
    '      <div class="datetime-details__number">\n' +
    '          {{ datetimeDetailsCtrl.endDate | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div class="datetime-details__label">{{ :: \'END_DATE\' | translate }}</div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section" ng-if="datetimeDetailsCtrl.startTime">\n' +
    '    <div class="datetime-details__block">\n' +
    '      <div class="datetime-details__text">\n' +
    '          {{\'DURATION\' | translate}}\n' +
    '      </div>\n' +
    '      <ui-select\n' +
    '        class="select-custom"\n' +
    '        search-enabled="false"\n' +
    '        append-to-body="true"\n' +
    '        ng-model="datetimeDetailsCtrl.selectedDuration"\n' +
    '        on-select="datetimeDetailsCtrl.onDurationSelect($item)">\n' +
    '        <ui-select-match>\n' +
    '          <span class="datetime-details__selection">{{$select.selected.humanize()}}</span>\n' +
    '        </ui-select-match>\n' +
    '        <ui-select-choices repeat="option in datetimeDetailsCtrl.timeDurationOptions" ui-disable-choice="datetimeDetailsCtrl.disableTimeDurationOption(option)">\n' +
    '          <span\n' +
    '            ng-bind="::option.humanize()"></span>\n' +
    '        </ui-select-choices>\n' +
    '      </ui-select>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section"\n' +
    '    ng-if="!datetimeDetailsCtrl.isEditingIndividualRecurrence && !datetimeDetailsCtrl.disableRecurrence"\n' +
    '    ng-form="datetimeDetailsCtrl.recurrenceForm.form">\n' +
    '    <div class="datetime-details__block">\n' +
    '      <div class="datetime-details__text">\n' +
    '          {{\'WILL_OCCUR\' | translate}}\n' +
    '      </div>\n' +
    '      <ui-select\n' +
    '        ng-if="::!datetimeDetailsCtrl.recurrenceInternal.recurrenceIdx"\n' +
    '        class="select-custom"\n' +
    '        search-enabled="false"\n' +
    '        append-to-body="true"\n' +
    '        ng-model="datetimeDetailsCtrl.recurrenceInternal.recurrenceType"\n' +
    '        on-select="datetimeDetailsCtrl.handleRecurrenceChange()">\n' +
    '        <ui-select-match>\n' +
    '          <span class="datetime-details__selection">{{ \'RECURRENCE_OPTION_\' + $select.selected | uppercase | translate }}</span>\n' +
    '        </ui-select-match>\n' +
    '        <ui-select-choices repeat="option in datetimeDetailsCtrl.recurrenceOptions" ui-disable-choice="!datetimeDetailsCtrl.checkRecurrenceOptionValidity(option)">\n' +
    '          <span\n' +
    '            ng-bind="\'RECURRENCE_OPTION_\' + option | uppercase | translate"></span>\n' +
    '        </ui-select-choices>\n' +
    '      </ui-select>\n' +
    '      <div ng-if="::datetimeDetailsCtrl.recurrenceInternal.recurrenceIdx">\n' +
    '        {{ \'RECURRENCE_OPTION_\' + datetimeDetailsCtrl.recurrenceInternal.recurrenceType | uppercase | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="datetime-details__block" ng-if="datetimeDetailsCtrl.recurrenceInternal.recurrenceType !== \'once\'">\n' +
    '      <span class="datetime-details__text">{{\'FOR\' | translate}}</span>\n' +
    '      <span class="datetime-details__number">\n' +
    '          <input\n' +
    '            name="recurrenceNumber"\n' +
    '            class="input--inline-text input--real-time-validation"\n' +
    '            ng-class="{\'input--clear\' : datetimeDetailsCtrl.recurrenceInternal.recurrenceNumber }"\n' +
    '            type="number"\n' +
    '            ng-model="datetimeDetailsCtrl.recurrenceInternal.recurrenceNumber"\n' +
    '            ng-model-options="{ allowInvalid: true }"\n' +
    '            match-width-to-value\n' +
    '            ng-change="datetimeDetailsCtrl.handleRecurrenceChange()"\n' +
    '            ng-min="datetimeDetailsCtrl.pastRecurrenceMoments.length || 1" />\n' +
    '      </span>\n' +
    '      <span class="datetime-details__text">{{datetimeDetailsCtrl.getRecurrenceUnit(datetimeDetailsCtrl.recurrenceInternal.recurrenceType) | uppercase | translate}}</span>\n' +
    '      <div ng-if="datetimeDetailsCtrl.recurrenceForm.form.recurrenceNumber.$invalid" class="text-error">\n' +
    '        {{ \'RECURRENCE_NUMBER_INVALID\' | translate }}\n' +
    '        <span ng-if="datetimeDetailsCtrl.pastRecurrenceMoments.length">{{ \'RECURRENCES_HAVE_PASSED\' | translate }}</span>\n' +
    '      </div>\n' +
    '      <div ng-if=":: datetimeDetailsCtrl.recurrenceInternal.recurrenceIdx">\n' +
    '        {{ \'INITIAL_RECURRENCE\' | translate }}\n' +
    '        {{ datetimeDetailsCtrl.inferredRecurrenceMoments[0] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if="datetimeDetailsCtrl.pastRecurrenceMoments.length">\n' +
    '        {{ \'NEXT_EDITABLE_RECURRENCE\' | translate }}\n' +
    '        {{ datetimeDetailsCtrl.inferredRecurrenceMoments[datetimeDetailsCtrl.pastRecurrenceMoments.length] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if="datetimeDetailsCtrl.recurrenceInternal.recurrenceNumber > 1">\n' +
    '        {{ \'FINAL_RECURRENCE\' | translate }}\n' +
    '        {{ datetimeDetailsCtrl.inferredRecurrenceMoments[datetimeDetailsCtrl.inferredRecurrenceMoments.length - 1] | dateFormatter:\'dateShort\' }}\n' +
    '      </div>\n' +
    '      <div ng-if=":: datetimeDetailsCtrl.recurrenceInternal.recurrenceIdx">\n' +
    '        {{ \'RECURRENCES_REMAINING\' | translate }}\n' +
    '        {{ datetimeDetailsCtrl.inferredRecurrenceMoments.length - datetimeDetailsCtrl.pastRecurrenceMoments.length }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="datetime-details__section" ng-if="datetimeDetailsCtrl.isEditingIndividualRecurrence">\n' +
    '    <p>{{ \'INDIVIDUAL_OCCURRENCE_DESCRIPTION\' | translate }}</p>\n' +
    '    <a href ng-click="datetimeDetailsCtrl.editSeries()">{{ \'EDIT_SERIES\' | translate }}</a>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/components/day-schedule/day-schedule.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/day-schedule/day-schedule.html', '<div class="pt-day-schedule">\n' +
    '  <div class="pt-day-schedule__day">{{ day | camelToSnakeCase | translate}}</div>\n' +
    '  <div class="pt-day-schedule__time" ng-repeat="time in times" ng-if="time">\n' +
    '\n' +
    '    <div class="pt-day-schedule__time pt-day-schedule__time--start">\n' +
    '      <div uib-timepicker\n' +
    '        ng-if="userHas24HourFormat"\n' +
    '        show-spinners="false"\n' +
    '        ng-disabled="!editable"\n' +
    '        ng-model="time.min"\n' +
    '        show-meridian="false">\n' +
    '      </div>\n' +
    '      <div uib-timepicker\n' +
    '        ng-if="!userHas24HourFormat"\n' +
    '        show-spinners="false"\n' +
    '        ng-disabled="!editable"\n' +
    '        ng-model="time.min">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div ng-if="userHas24HourFormat" class="pt-day-schedule__time-divider-24">-</div>\n' +
    '    <div ng-if="!userHas24HourFormat" class="pt-day-schedule__time-divider">-</div>\n' +
    '    <div class="pt-day-schedule__time pt-day-schedule__time--end">\n' +
    '      <div uib-timepicker\n' +
    '        ng-if="userHas24HourFormat"\n' +
    '        show-spinners="false"\n' +
    '        ng-disabled="!editable"\n' +
    '        ng-model="time.max"\n' +
    '        show-meridian="false">\n' +
    '      </div>\n' +
    '      <div uib-timepicker\n' +
    '        ng-if="!userHas24HourFormat"\n' +
    '        show-spinners="false"\n' +
    '        ng-disabled="!editable"\n' +
    '        ng-model="time.max">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="editable" class="pt-day-schedule__time pt-day-schedule__time--remove" ng-click="removeHours(time)">\n' +
    '      <a class="pt-day-schedule__remove" href ng-click="removeHours(time)">&times;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="!times.length" class="pt-day-schedule__time pt-day-schedule__time--na-block"> {{ \'NA\' | translate }}</div>\n' +
    '  <div ng-if="editable" class="pt-day-schedule__add-hour" ng-click="addHours()">+{{ :: \'ADD_HOURS\' | translate}}</div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/duration-input/duration-input.component.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/duration-input/duration-input.component.html', '<input type="text"\n' +
    '    class="card-body__duration-input"\n' +
    '    ng-model="durationInputCtrl._hours"\n' +
    '    ng-focus="durationInputCtrl.toggleEditMode(true);"\n' +
    '    placeholder="{{durationInputCtrl.editMode ? \'hh\' : \'- -\'}}"\n' +
    '    ng-maxlength="3"\n' +
    '    ng-change="durationInputCtrl.handleDurationInputChanges(\'_hours\')"\n' +
    '    focus-me="durationInputCtrl.focusValue"\n' +
    '    ng-blur="durationInputCtrl.padOnBlur(\'_hours\'); durationInputCtrl.toggleEditMode(false)"\n' +
    '    duration-validation="99"\n' +
    '    onClick="this.setSelectionRange(0, this.value.length)">:\n' +
    '<input type="text"\n' +
    '    class="card-body__duration-input"\n' +
    '    ng-model="durationInputCtrl._minutes"\n' +
    '    ng-focus="durationInputCtrl.toggleEditMode(true);"\n' +
    '    placeholder="{{durationInputCtrl.editMode ? \'mm\' : \'- -\'}}"\n' +
    '    ng-maxlength="3"\n' +
    '    ng-change="durationInputCtrl.handleDurationInputChanges(\'_minutes\')"\n' +
    '    focus-me="durationInputCtrl.minuteFocus"\n' +
    '    ng-blur="durationInputCtrl.padOnBlur(\'_minutes\'); durationInputCtrl.toggleEditMode(false)"\n' +
    '    duration-validation="59"\n' +
    '    onClick="this.setSelectionRange(0, this.value.length)">');
  }]);
angular.module('/app/components/embed-video/embed-video.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/embed-video/embed-video.html', '<div class="pt-embed-video">\n' +
    '  <iframe ng-if="trustedYoutubeSrc" width="100%" height="100%" ng-src="{{trustedYoutubeSrc}}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n' +
    '  <iframe ng-if="trustedVimeoSrc" ng-src="{{trustedVimeoSrc}}" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>\n' +
    '</div>');
  }]);
angular.module('/app/components/exercise-item-details/exercise-item-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/exercise-item-details/exercise-item-details.html', '<div class="create-exercise-details">\n' +
    '\n' +
    '  <input class="create-exercise-details__title"\n' +
    '    permission\n' +
    '    permission-only="itemCtrl.editPermission"\n' +
    '    permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '    permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '    type="text"\n' +
    '    maxlength="50"\n' +
    '    ng-model="itemCtrl.item.title"\n' +
    '    placeholder="{{ itemCtrl.type + \'Title\' | camelToSnakeCase | translate }}"/>\n' +
    '\n' +
    '  <label class="checkbox-custom create-exercise-details__checkbox-container"\n' +
    '    permission\n' +
    '    permission-only="\'RESTRICTED_FLAG_READ\'"\n' +
    '    ng-if="itemCtrl.type === \'trainingSets\' || itemCtrl.type === \'exercises\'">\n' +
    '    <input\n' +
    '      permission\n' +
    '      permission-only="\'RESTRICTED_FLAG_CREATE\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '      permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '      type="checkbox"\n' +
    '      ng-model="itemCtrl.item.restricted">\n' +
    '    <span class="checkbox-label">{{ :: \'RESTRICTED\' | translate }}</span>\n' +
    '  </label>\n' +
    '\n' +
    '  <label class="checkbox-custom create-exercise-details__checkbox-container"\n' +
    '    permission\n' +
    '    permission-only="\'CHAIN_WIDE_READ\'">\n' +
    '    <input type="checkbox"\n' +
    '      permission\n' +
    '      permission-only="itemCtrl.item.chainWide && itemCtrl.item._id ?\n' +
    '        \'CHAIN_WIDE_DELETE\' :\n' +
    '        \'CHAIN_WIDE_CREATE\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '      permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '      ng-model="itemCtrl.item.chainWide">\n' +
    '    <span class="checkbox-label">{{ :: \'CHAIN_WIDE\' | translate }}</span>\n' +
    '  </label>\n' +
    '\n' +
    '  <label class="checkbox-custom create-exercise-details__checkbox-container"\n' +
    '    permission\n' +
    '    permission-only="\'EXERCISES_READ\'"\n' +
    '    ng-if="itemCtrl.type !== \'task\'">\n' +
    '    <input type="checkbox"\n' +
    '      permission\n' +
    '      permission-only="\'EXERCISES_CREATE\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '      permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '      ng-model="itemCtrl.item.featured">\n' +
    '    <span class="checkbox-label">{{ :: \'FEATURED\' | translate }}</span>\n' +
    '  </label>\n' +
    '\n' +
    '  <label class="create-exercise-details__description-title"\n' +
    '    ng-if="itemCtrl.type === \'task\'">\n' +
    '    <div class="create-exercise-details__checkbox-container">\n' +
    '      {{ :: \'DESCRIPTION\'  | translate}}\n' +
    '    </div>\n' +
    '    <textarea class="create-exercise-details__description"\n' +
    '      permission\n' +
    '      permission-only="itemCtrl.editPermission"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '      permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '      maxlength="681"\n' +
    '      ng-model="itemCtrl.item.description">\n' +
    '    </textarea>\n' +
    '  </label>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/exercise-media/exercise-media.component.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/exercise-media/exercise-media.component.html', '<div class="exercise-media__container">\n' +
    '  <div class="exercise-media__images-container">\n' +
    '    <div class="exericse-media__images-title">{{ \'IMAGES\' | translate }}</div>\n' +
    '    <div class="exercise-media__images-drop-area">\n' +
    '      <div class="drop-down__drop-zone"\n' +
    '        file-drop\n' +
    '        on-file-drop="exerciseMediaCtrl.addImage"\n' +
    '        on-file-error="exerciseMediaCtrl.toggleFileError">\n' +
    '        <div>\n' +
    '          {{ \'NOTE_FILE_DROP\' | translate }}\n' +
    '          <div class="drop-down__file-input-wrapper">\n' +
    '            <input type="file"\n' +
    '              id="noteFileBrowse"\n' +
    '              file-read\n' +
    '              on-file-read="exerciseMediaCtrl.addImage"\n' +
    '              on-file-error="exerciseMediaCtrl.toggleFileError"\n' +
    '              class="drop-down__file-input"\n' +
    '              multiple>\n' +
    '            <label for="noteFileBrowse">{{ \'NOTE_FILE_BROWSE\' | translate }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="drop-down__info-text">\n' +
    '            {{ \'EXERCISE_IMAGE_REQUIREMENTS\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="exercise-media__file-error">\n' +
    '        <span ng-if="exerciseMediaCtrl.fileError"\n' +
    '          ng-click="exerciseMediaCtrl.toggleFileError()"\n' +
    '          class="drop-down__file-remove"></span>\n' +
    '        <span ng-if="exerciseMediaCtrl.fileError" class="drop-down__error-text">{{ \'NOTE_FILE_ERROR\' | translate }}</span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="exercise-media__images-editor" ng-if="exerciseMediaCtrl.exerciseImages.length">\n' +
    '      <div class="exercise-media__images-selector">\n' +
    '        <div class="exercise-media__preview-container" ng-repeat="image in exerciseMediaCtrl.exerciseImages" ng-click="exerciseMediaCtrl.selectImage($index)">\n' +
    '          <div class="exercise-media__preview" ng-class="{\n' +
    '            \'exercise-media__preview--active\': $index === exerciseMediaCtrl.selectedImageIdx,\n' +
    '            \'pt-image-carousel__list-item-image-container--white\': exerciseMediaCtrl.getBackgroundColor($index) === \'white\',\n' +
    '            \'pt-image-carousel__list-item-image-container--black\': exerciseMediaCtrl.getBackgroundColor($index) === \'black\'\n' +
    '          }">\n' +
    '            <div class="exercise-media__preview-index">{{$index + 1}}</div>\n' +
    '            <div ng-if="image.loading" class="exercise-media__preview-loading">\n' +
    '              <img src="https://images.jhtassets.com/ed8bcd4f3070937a3a93f485d1f20b6f511c05de/" class="exercise-media__preview-loading-circle">\n' +
    '            </div>\n' +
    '            <img class="exercise-media__preview-image"\n' +
    '                 ng-if="image.aspectRatio < 1.00"\n' +
    '                 ng-class="{ \'exercise-media__image-img--cover\': exerciseMediaCtrl.getTransformType($index) === \'pad\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="image.picture || image.picturePath"/>\n' +
    '            <img class="exercise-media__preview-image"\n' +
    '                 ng-if="image.aspectRatio >= 1.00"\n' +
    '                 ng-class="{ \'exercise-media__image-img--contain\': exerciseMediaCtrl.getTransformType($index) === \'pad\', \'exercise-media__image-img--cover\': exerciseMediaCtrl.getTransformType($index) === \'fill\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="image.picture || image.picturePath"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="exercise-media__images-view">\n' +
    '        <div class="exercise-media__image">\n' +
    '          <div class="pt-image-carousel__image-controls">\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--selected-cover-image\': exerciseMediaCtrl.selectedImage().isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-cover-image\': !exerciseMediaCtrl.selectedImage().isPrimary\n' +
    '              }"\n' +
    '              ng-click="exerciseMediaCtrl.setAsPrimary(exerciseMediaCtrl.selectedImageIdx)"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-fixed-width\': !exerciseMediaCtrl.selectedImage().isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-fixed-width\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) !== \'pad\',\n' +
    '                \'pt-image-carousel__image-control--selected-fixed-width\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) === \'pad\'\n' +
    '              }"\n' +
    '              ng-click="exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.setTransform(exerciseMediaCtrl.selectedImageIdx, \'pad\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-fixed-height\': !exerciseMediaCtrl.selectedImage().isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-fixed-height\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) !== \'fill\',\n' +
    '                \'pt-image-carousel__image-control--selected-fixed-height\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) === \'fill\'\n' +
    '              }"\n' +
    '            ng-click="exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.setTransform(exerciseMediaCtrl.selectedImageIdx, \'fill\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-black-bckground\': !exerciseMediaCtrl.selectedImage().isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-black-bckground\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) !== \'black\',\n' +
    '                \'pt-image-carousel__image-control--selected-black-bckground\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) === \'black\'\n' +
    '              }"\n' +
    '              ng-click="exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.setBackgroundColor(exerciseMediaCtrl.selectedImageIdx, \'black\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-white-bckground\': !exerciseMediaCtrl.selectedImage().isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-white-bckground\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) !== \'white\',\n' +
    '                \'pt-image-carousel__image-control--selected-white-bckground\': exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) === \'white\'\n' +
    '              }"\n' +
    '              ng-click="exerciseMediaCtrl.selectedImage().isPrimary && exerciseMediaCtrl.setBackgroundColor(exerciseMediaCtrl.selectedImageIdx, \'white\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control pt-image-carousel__image-control--delete-image"\n' +
    '              ng-click="exerciseMediaCtrl.removeImage(exerciseMediaCtrl.selectedImageIdx)"></div>\n' +
    '          </div>\n' +
    '          <div class="pt-image-carousel__list-item-image-container"\n' +
    '               ng-show="exerciseMediaCtrl.selectedImage"\n' +
    '               ng-class=" { \'pt-image-carousel__list-item-image-container--white\': exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) === \'white\', \'pt-image-carousel__list-item-image-container--black\': exerciseMediaCtrl.getBackgroundColor(exerciseMediaCtrl.selectedImageIdx) === \'black\' }">\n' +
    '            <div ng-if="exerciseMediaCtrl.selectedImage().loading" class="exercise-media__loading">\n' +
    '              <img src="https://images.jhtassets.com/ed8bcd4f3070937a3a93f485d1f20b6f511c05de/" class="exercise-media__loading-circle">\n' +
    '            </div>\n' +
    '            <img class="exercise-media__image-img"\n' +
    '                 ng-if="exerciseMediaCtrl.selectedImage().aspectRatio < 1.00"\n' +
    '                 ng-class="{ \'exercise-media__image-img--cover\': exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) === \'pad\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="exerciseMediaCtrl.selectedImage().picture || exerciseMediaCtrl.selectedImage().picturePath"/>\n' +
    '            <img class="exercise-media__image-img"\n' +
    '                 ng-if="exerciseMediaCtrl.selectedImage().aspectRatio >= 1.00"\n' +
    '                 ng-class="{ \'exercise-media__image-img--contain\': exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) === \'pad\', \'exercise-media__image-img--cover\': exerciseMediaCtrl.getTransformType(exerciseMediaCtrl.selectedImageIdx) === \'fill\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="exerciseMediaCtrl.selectedImage().picture || exerciseMediaCtrl.selectedImage().picturePath"/>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="exercise-media__video-container">\n' +
    '    <div class="exercise-media__video-title">{{ \'VIDEO_YOUTUBE_OR_VIMEO\' | translate }}</div>\n' +
    '    <div class="exercise-media__video-input">\n' +
    '      <input\n' +
    '        type="text"\n' +
    '        placeholder="{{ :: \'PASTE_VIDEO_URL\' | translate }}"\n' +
    '        ng-model="exerciseMediaCtrl.exerciseVideo"\n' +
    '        ng-change="exerciseMediaCtrl.onVideoChange()"\n' +
    '        class="exercise-media__video-input-form">\n' +
    '      <div class="exercise-media__video-input-clear-button" ng-click="exerciseMediaCtrl.clearVideo()">{{ \'CLEAR\' | translate }}</div>\n' +
    '    </div>\n' +
    '    <div class="exercise-media__video-preview" ng-if="exerciseMediaCtrl.showVideoPreview">\n' +
    '      <pt-embed-video url="exerciseMediaCtrl.exerciseVideo"></pt-embed-video>\n' +
    '    </div>\n' +
    '    <div class="exercise-media__video-error" ng-if="exerciseMediaCtrl.showVideoError">\n' +
    '      {{ \'INVALID_VIDEO_URL\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/components/exercise-multimedia/exercise-multimedia.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/exercise-multimedia/exercise-multimedia.html', '<div>\n' +
    '  <div class="upload-multimedia-block">\n' +
    '    <div class="upload-multimedia-block__header">\n' +
    '      <div class="upload-multimedia-block__title">\n' +
    '        {{ :: \'FILE_REQUIREMENTS\'  | translate }}\n' +
    '      </div>\n' +
    '      <div class="upload-multimedia-block__note">\n' +
    '        {{ :: \'IMAGE_REQUIREMENTS_NOTE\'  | translate }}\n' +
    '      </div>\n' +
    '      <div class="upload-multimedia-block__requirement-wrapper clearfix">\n' +
    '        <div class="upload-multimedia-block__requirement upload-multimedia-block__requirement--left">\n' +
    '          <table>\n' +
    '            <tr>\n' +
    '              <td class="upload-multimedia-block__table-column upload-multimedia-block__table-column--number">1.</td>\n' +
    '              <td class="upload-multimedia-block__table-column">\n' +
    '                {{ :: \'FILE_MUST_BE_A_VALID_JPG_OR_PNG\' | translate }}\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '            <tr>\n' +
    '              <td></td>\n' +
    '              <td class="upload-multimedia-block__table-column upload-multimedia-block__table-column--note">{{ :: \'IMAGE_REQUIREMENTS_FORMATS_NOT_ALLOWED\'  | translate }}</td>\n' +
    '            </tr>\n' +
    '          </table>\n' +
    '        </div>\n' +
    '        <div class="upload-multimedia-block__requirement upload-multimedia-block__requirement--right">\n' +
    '          <table>\n' +
    '            <tr>\n' +
    '              <td class="upload-multimedia-block__table-column upload-multimedia-block__table-column--number">2.</td>\n' +
    '              <td class="upload-multimedia-block__table-column">\n' +
    '              {{ :: \'FILE_DIMENSIONS_FOR_EXERCISE_IMAGE\' | translate}}\n' +
    '              </td>\n' +
    '            </tr>\n' +
    '          </table>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="upload-multimedia-block__content">\n' +
    '      <div class="upload-multimedia-block__main-content upload-multimedia-block__main-content--images">\n' +
    '        <div class="upload-multimedia-block__images-carousel">\n' +
    '          <pt-image-carousel\n' +
    '            images-limit="exMultCtrl.imagesLimit"\n' +
    '            images-list="exMultCtrl.imagesList"></pt-image-carousel>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="upload-multimedia-block"\n' +
    '  ng-if="exMultCtrl.type !== \'trainingSet\'">\n' +
    '    <div class="upload-multimedia-block__header">\n' +
    '      <div class="upload-multimedia-block__title">\n' +
    '        {{ :: \'VIDEO_REQUIREMENTS\'  | translate }}\n' +
    '      </div>\n' +
    '      <div class="upload-multimedia-block__note">\n' +
    '        {{ :: \'VIDEO_REQUIREMENTS_NOTE\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="upload-multimedia-controls">\n' +
    '      <div ng-click="exMultCtrl.onVideoPreview()" class="upload-multimedia-controls__button upload-multimedia-controls__button pull-right">\n' +
    '        <span ng-if="!exMultCtrl.showEmbedVideo">{{ :: \'ADD_VIDEO\'  | translate }}</span>\n' +
    '        <span ng-if="exMultCtrl.showEmbedVideo">{{ :: \'REPLACE_VIDEO\'  | translate }}</span>\n' +
    '      </div>\n' +
    '      <div class="upload-multimedia-controls__action-row upload-multimedia-controls__action-row--url upload-multimedia-controls__action-row--left">\n' +
    '        <input\n' +
    '        ng-keypress="($event.which === 13) ? exMultCtrl.onVideoPreview() : 0"\n' +
    '        type="text"\n' +
    '        placeholder="{{ :: \'PASTE_VIDEO_URL\' | translate }}"\n' +
    '        ng-model="exMultCtrl.videoUrl"\n' +
    '        ng-change="exMultCtrl.onVideoUrlChange()"\n' +
    '        class="pt-crm-input pt-crm-input--blue">\n' +
    '        <div ng-if="exMultCtrl.isVideoUrlInvalid" class="upload-multimedia-controls__invalid-text">{{ :: \'VIDEO_URL_IS_INVALID\'  | translate }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="upload-multimedia-block__content">\n' +
    '      <div class="upload-multimedia-block__main-content">\n' +
    '        <div ng-if="!exMultCtrl.showEmbedVideo" class="upload-multimedia-block__preview-text">{{ :: \'VIDEO_PREVIEW\'  | translate }}</div>\n' +
    '        <pt-embed-video ng-if="exMultCtrl.showEmbedVideo" url="exMultCtrl.videoUrlForEmbedVideo" on-invalid="exMultCtrl.onVideoUrlInvalid()"></pt-embed-video>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/header/facility.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/header/facility.modal.html', '<ul class="modal__list-wrapper">\n' +
    '  <li class="modal__list-item"\n' +
    '    permission\n' +
    '    permission-only="\'CURRENT_FACILITY_READ\'"\n' +
    '    ng-click="selectNewFacility(facility)"\n' +
    '    ng-disabled="isLoading"\n' +
    '    ng-repeat="facility in facilities"\n' +
    '    ng-class="{ \'modal__list-item--active-facility\': selectedFacility === facility._id }"\n' +
    '    ng-class="{ \'modal__list-item-disabled\': isLoading }">\n' +
    '    <div>\n' +
    '      {{facility.name}}\n' +
    '      <div class="pull-right spinner-icon__small"\n' +
    '        ng-if="(selectedFacility === facility._id) && isLoading">\n' +
    '      </div>\n' +
    '      <div class="pull-right permissions-groups-pop-up__group-selected-icon"\n' +
    '        ng-if="(selectedFacility === facility._id) && !isLoading">\n' +
    '        &#x2713;\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </li>\n' +
    '</ul>\n' +
    '');
  }]);
angular.module('/app/components/header/header.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/header/header.html', '<div class="main-header">\n' +
    '  <div class="top-profile" uib-dropdown is-open="status.isopen">\n' +
    '    <img class="top-profile__face" ng-src="{{user.pictureUrl}}">\n' +
    '    <a class="top-profile__link" uib-dropdown-toggle>\n' +
    '      <span class="top-profile__profile-block">\n' +
    '        <div class="top-profile__name-block">\n' +
    '          <span class="top-profile__name">{{ :: user.firstName }}</span>\n' +
    '          <span class="top-profile__facility">{{ :: user.activeFacility.name }}</span>\n' +
    '        </div>\n' +
    '        <span class="top-profile__arrow"></span>\n' +
    '      </span>\n' +
    '    </a>\n' +
    '\n' +
    '    <ul class="top-profile__dropdown" uib-dropdown-menu role="menu">\n' +
    '      <li class="top-profile__dropdown-item" role="menuitem">\n' +
    '        <a class="top-profile__link"\n' +
    '          ui-sref-active=\'active\'\n' +
    '          ui-sref=\'app.users.details({userId: "me"})\'>\n' +
    '          <i class="top-profile__icon icon icon-user"></i>\n' +
    '          <span>{{ :: "PROFILE" | translate }}</span>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li class="top-profile__dropdown-item"\n' +
    '        permission\n' +
    '        permission-only="\'CURRENT_FACILITY_READ\'"\n' +
    '        role="menuitem"\n' +
    '        ng-if="header.facilities.length > 1">\n' +
    '        <a class="top-profile__link" ng-click="header.showAllFacilities()">\n' +
    '          <i class="top-profile__icon icon icon-home"></i>\n' +
    '          <span>{{ :: "CHANGE_FACILITY" | translate }}</span>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '      <li class="divider"></li>\n' +
    '      <li class="top-profile__dropdown-item" role="menuitem">\n' +
    '        <a class="top-profile__link" ng-click="header.logout()">\n' +
    '          <i class="top-profile__icon icon icon-exit"></i>\n' +
    '          <span>{{ :: "LOG_OUT" | translate }}</span>\n' +
    '        </a>\n' +
    '      </li>\n' +
    '    </ul>\n' +
    '  </div>\n' +
    '\n' +
    '  <h1 class="main-header__title">{{"PERSONAL_TRAINER_PORTAL" | translate}}</h1>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/image-carousel/image-carousel.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/image-carousel/image-carousel.html', '<div>\n' +
    '  <div class="pt-image-carousel"\n' +
    '    ngf-drop="imageCarouselCtrl.imagesList.add($files, imageCarouselCtrl.imagesLimit)"\n' +
    '    ngf-max-size="3MB"\n' +
    '    ngf-pattern="\'image/*\'"\n' +
    '    ngf-multiple="false">\n' +
    '    <div class="pt-image-carousel__gallery">\n' +
    '      <ul class="pt-image-carousel__list"\n' +
    '       rn-carousel\n' +
    '       rn-carousel-index="carouselIndex"\n' +
    '       rn-carousel-controls>\n' +
    '        <li class="pt-image-carousel__list-item"\n' +
    '          ng-repeat="image in imageCarouselCtrl.imagesList.items">\n' +
    '          <div ng-show="!image.loading" class="pt-image-carousel__image-controls">\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--selected-cover-image\': image.isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-cover-image\': !image.isPrimary\n' +
    '              }"\n' +
    '              ng-mouseover="{ \'pt-image-carousel__image-control--hover-cover-image\': !image.isPrimary}"\n' +
    '              ng-click="imageCarouselCtrl.imagesList.setAsPrimary(image)"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-fixed-width\': !image.isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-fixed-width\': image.isPrimary && imageCarouselCtrl.getTransformType(image) !== \'pad\',\n' +
    '                \'pt-image-carousel__image-control--selected-fixed-width\': image.isPrimary && imageCarouselCtrl.getTransformType(image) === \'pad\'\n' +
    '              }"\n' +
    '              ng-click="image.isPrimary && imageCarouselCtrl.setTransform(image, \'pad\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-fixed-height\': !image.isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-fixed-height\': image.isPrimary && imageCarouselCtrl.getTransformType(image) !== \'fill\',\n' +
    '                \'pt-image-carousel__image-control--selected-fixed-height\': image.isPrimary && imageCarouselCtrl.getTransformType(image) === \'fill\'\n' +
    '              }"\n' +
    '            ng-click="image.isPrimary && imageCarouselCtrl.setTransform(image, \'fill\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-black-bckground\': !image.isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-black-bckground\': image.isPrimary && imageCarouselCtrl.getBackgroundColor(image) !== \'black\',\n' +
    '                \'pt-image-carousel__image-control--selected-black-bckground\': image.isPrimary && imageCarouselCtrl.getBackgroundColor(image) === \'black\'\n' +
    '              }"\n' +
    '              ng-click="image.isPrimary && imageCarouselCtrl.setBackgroundColor(image, \'black\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control"\n' +
    '              ng-class="{\n' +
    '                \'pt-image-carousel__image-control--disabled-white-bckground\': !image.isPrimary,\n' +
    '                \'pt-image-carousel__image-control--default-white-bckground\': image.isPrimary && imageCarouselCtrl.getBackgroundColor(image) !== \'white\',\n' +
    '                \'pt-image-carousel__image-control--selected-white-bckground\': image.isPrimary && imageCarouselCtrl.getBackgroundColor(image) === \'white\'\n' +
    '              }"\n' +
    '              ng-click="image.isPrimary && imageCarouselCtrl.setBackgroundColor(image, \'white\')"></div>\n' +
    '            <div class="pt-image-carousel__image-control pt-image-carousel__image-control--delete-image"\n' +
    '              ng-click="imageCarouselCtrl.imagesList.remove(image)"></div>\n' +
    '          </div>\n' +
    '          <div ng-if="image.loading" class="pt-image-carousel__loading-circle-container">\n' +
    '            <img src="https://images.jhtassets.com/ed8bcd4f3070937a3a93f485d1f20b6f511c05de/" class="pt-image-carousel__loading-circle">\n' +
    '          </div>\n' +
    '          <div class="pt-image-carousel__list-item-image-container"\n' +
    '               ng-class=" { \'pt-image-carousel__list-item-image-container--white\': imageCarouselCtrl.getBackgroundColor(image) === \'white\', \'pt-image-carousel__list-item-image-container--black\': imageCarouselCtrl.getBackgroundColor(image) === \'black\' }">\n' +
    '            <img class="pt-image-carousel__list-item-image"\n' +
    '                 ng-if="image.aspectRatio < 1.00"\n' +
    '                 ng-class="{ \'pt-image-carousel__list-item-image--cover\': imageCarouselCtrl.getTransformType(image) === \'pad\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="image.picture || image.picturePath"/>\n' +
    '            <img class="pt-image-carousel__list-item-image"\n' +
    '                 ng-if="image.aspectRatio >= 1.00"\n' +
    '                 ng-class="{ \'pt-image-carousel__list-item-image--contain\': imageCarouselCtrl.getTransformType(image) === \'pad\', \'pt-image-carousel__list-item-image--cover\': imageCarouselCtrl.getTransformType(image) === \'fill\' }"\n' +
    '                 draggable="false"\n' +
    '                 ngf-src="image.picture || image.picturePath"/>\n' +
    '          </div>\n' +
    '        </li>\n' +
    '      </ul>\n' +
    '      <div class="pt-image-carousel__indicators"\n' +
    '        rn-carousel-indicators\n' +
    '        ng-if="imageCarouselCtrl.imagesList.items.length > 1"\n' +
    '        slides="imageCarouselCtrl.imagesList.items" rn-carousel-index="carouselIndex">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="pt-image-carousel-control">\n' +
    '    <div class="upload-multimedia-controls__button upload-multimedia-controls__button pull-left"\n' +
    '      ng-show="imageCarouselCtrl.imagesList.items.length < imageCarouselCtrl.imagesLimit"\n' +
    '      ngf-select=\'imageCarouselCtrl.imagesList.add($files)\'\n' +
    '      ngf-max-size="10MB"\n' +
    '      ngf-pattern="\'image/*\'"\n' +
    '      ngf-multiple="false">\n' +
    '      {{ :: \'BROWSE\'  | translate }}\n' +
    '    </div>\n' +
    '    <div class="upload-multimedia-controls__action-row upload-multimedia-controls__action-row--drag upload-multimedia-controls__action-row">\n' +
    '      {{ :: \'IMAGE_UPLOAD_INSTRUCTION\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/items-selector/items-selector.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/items-selector/items-selector.html', '<div class="exercise-tab__items-selector-container">\n' +
    '\n' +
    '  <div class="items-selector">\n' +
    '    <div class="client-card-placeholder" ng-if="!selectorCtrl.selectedItems.length">\n' +
    '      <div class="client-card-placeholder__text">\n' +
    '        <div>\n' +
    '          <div><i class="icon icon-ion-plus"></i></div>\n' +
    '          {{ \'drop_\' + selectorCtrl.itemType + \'_here\' | camelToSnakeCase | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="items-selector__selected-list-container">\n' +
    '      <div class="items-selector__selected-list scroll-wrapper scroll--vertical draggable-destination"\n' +
    '        ng-sortable="selectorCtrl.sortableDestinationConfig">\n' +
    '        <library-card class="items-selector__selected-item draggable"\n' +
    '          ng-repeat="item in selectorCtrl.selectedItems"\n' +
    '          data="item"\n' +
    '          index="$index + 1"\n' +
    '          type="{{ :: selectorCtrl.itemType }}"\n' +
    '          hide-print-icon="selectorCtrl.hidePrintIcon"\n' +
    '          hide-edit-icon="true"\n' +
    '          disable-flip="true"\n' +
    '          remove-button="true"\n' +
    '          remove-button-callback="selectorCtrl.removeItem($index)">\n' +
    '        </library-card>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="exercise-tab__items-list-container">\n' +
    '\n' +
    '    <div ng-sortable="selectorCtrl.sortableRemoveAreaConfig" class="items-selector__item-removal-area" ng-show="selectorCtrl.allowItemRemoval">\n' +
    '      <div ng-repeat="item in selectorCtrl.removedItems">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <library-search>\n' +
    '      <div class="library-search">\n' +
    '        <div class="library-search__icon"></div>\n' +
    '        <input type="text"\n' +
    '        class="library-search__input"\n' +
    '        placeholder="{{\'SEARCH\' | translate}}"\n' +
    '        ng-model-options="{ debounce: 500 }"\n' +
    '        ng-model="selectorCtrl.itemSearch"\n' +
    '        ng-change="selectorCtrl.filterItems()">\n' +
    '        <search-clearer\n' +
    '          search-term="selectorCtrl.itemSearch"\n' +
    '          refresh-fn="selectorCtrl.filterItems()">\n' +
    '        </search-clearer>\n' +
    '      </div>\n' +
    '    </library-search>\n' +
    '\n' +
    '    <tabs hide-if-singular="true" class="items-selector__tabs">\n' +
    '      <tab ng-repeat="itemsList in selectorCtrl.itemsLists track by $index">\n' +
    '\n' +
    '          <tab-head>\n' +
    '            <div class="tab-head__item-block" ng-click="selectorCtrl.changeTab(itemsList.label)">\n' +
    '              <span class="tab-head__multiline-item">{{ itemsList.label | translate }}</span>\n' +
    '            </div>\n' +
    '          </tab-head>\n' +
    '\n' +
    '        <tab-content>\n' +
    '          <!--================= TAB FILTERING BAR ========== -->\n' +
    '\n' +
    '          <div class="training-library__tags-bar" ng-if="selectorCtrl.selectedTab === \'EXERCISES\'">\n' +
    '            <!-- Exercises bar -->\n' +
    '            <div class="training-library__tags-item"\n' +
    '                 ng-class="{\'training-library__tags-item--selected\': selectorCtrl.selectedTagList.length === 0}"\n' +
    '                 ng-click="selectorCtrl.setFilterTag(\'allExercises\')">\n' +
    '              {{ :: \'ALL_EXERCISES\' | translate }}\n' +
    '              <span class="training-library__tags-item-count">({{selectorCtrl.allExercises.items.length}})</span>\n' +
    '            </div>\n' +
    '            <div ng-repeat="tag in selectorCtrl.buttonTags"\n' +
    '                 class="training-library__tags-item"\n' +
    '                 ng-click="selectorCtrl.setFilterTag(tag)"\n' +
    '                 ng-class="{\'training-library__tags-item--selected\': selectorCtrl.checkIfTabIsSelected(tag)}"\n' +
    '            >\n' +
    '              {{tag.tag}}\n' +
    '              <span class="training-library__tags-item-count">({{tag.exerciseCount}})</span>\n' +
    '            </div>\n' +
    '            <div ng-if="selectorCtrl.dropdownTags.length > 0"\n' +
    '                 class="training-library__tags-dropdown-button"\n' +
    '                 ng-click="selectorCtrl.toggleShowDropdown()"\n' +
    '            >\n' +
    '              {{ :: \'MORE_TAGS\' | translate }}\n' +
    '              <div class="training-library__tags-item-dropdown-icon"\n' +
    '                   ng-class="{\'training-library__tags-item-dropdown-icon--up\': selectorCtrl.showDropdown}"></div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-if="selectorCtrl.showDropdown"\n' +
    '               class="training-library__tags-dropdown-container">\n' +
    '            <div ng-repeat="tag in selectorCtrl.dropdownTags"\n' +
    '                 class="training-library__tags-dropdown-item"\n' +
    '                 ng-class="{\'training-library__tags-dropdown-item--selected\': selectorCtrl.checkIfTabIsSelected(tag)}"\n' +
    '                 ng-click="selectorCtrl.setFilterTag(tag)">\n' +
    '              {{tag.tag}}\n' +
    '              <span class="training-library__tags-item-count">({{tag.exerciseCount}})</span>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="exercise-tab__items-list"\n' +
    '            ng-class="{\'exercise-tab__items-list__height-with-tabs\': selectorCtrl.selectedTab === \'EXERCISES\'}"\n' +
    '            infinite-scroll=\'itemsList.load()\'\n' +
    '            can-load=\'itemsList.nextPage\'\n' +
    '            threshold=\'500\'>\n' +
    '            <div class="draggable-source"\n' +
    '              ng-sortable="selectorCtrl.sortableSourceConfig">\n' +
    '\n' +
    '              <library-card class="exercise-tab__exercise draggable"\n' +
    '                permission\n' +
    '                permission-only="selectorCtrl.itemType + \'Read\' | camelToSnakeCase"\n' +
    '                ng-repeat="item in itemsList.items track by item._id"\n' +
    '                data="item"\n' +
    '                type="{{ :: selectorCtrl.itemType }}"\n' +
    '                hide-print-icon="selectorCtrl.hidePrintIcon"\n' +
    '                hide-edit-icon="!selectorCtrl.editItem || item.isEditable"\n' +
    '                on-edit-card="selectorCtrl.editItem(item)"\n' +
    '                disable-flip="true"\n' +
    '                add-button="true"\n' +
    '                add-button-callback="selectorCtrl.addItem(item)">\n' +
    '                <span>{{ :: item.title }}</span>\n' +
    '              </library-card>\n' +
    '\n' +
    '              <div class="exercise-tab__no-itemsList"\n' +
    '                permission\n' +
    '                permission-only="selectorCtrl.itemType + \'Read\' | camelToSnakeCase"\n' +
    '                ng-if="itemsList && !itemsList.items.length && !itemsList.nextPage">\n' +
    '                {{ \'no_\' + selectorCtrl.itemType + \'_available\' | camelToSnakeCase | translate }}\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="roster-load-more"\n' +
    '                permission\n' +
    '                permission-only="selectorCtrl.itemType + \'Read\' | camelToSnakeCase"\n' +
    '                ng-if="itemsList && itemsList.nextPage && selectorCtrl.loadMoreItems">\n' +
    '                <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '                {{ \'loadingMore_\'  + selectorCtrl.itemType | camelToSnakeCase | translate }}\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '\n' +
    '          </tab-content>\n' +
    '        </tab>\n' +
    '      </tabs>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/items-switcher/items-switcher.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/items-switcher/items-switcher.html', '<div class="items-switcher">\n' +
    '    <library-card class="items-switcher__selected-item"\n' +
    '      ng-repeat="item in switcherCtrl.selectedItems"\n' +
    '      ng-class="{\n' +
    '      \'items-switcher__selected-item--inactive\': $index !== switcherCtrl.activeItemIndex\n' +
    '      }"\n' +
    '      data="item"\n' +
    '      index="$index + 1"\n' +
    '      ng-click="switcherCtrl.activateItem($index)"\n' +
    '      type="{{ :: switcherCtrl.bagType }}"\n' +
    '      hide-print-icon="true"\n' +
    '      hide-edit-icon="true"\n' +
    '      disable-flip="true">\n' +
    '    </library-card>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/left_menu/assignment_flow.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/left_menu/assignment_flow.html', '<div class="modal-button-container">\n' +
    '    <button class="button button-action" ng-click="ok(\'assignment\')">{{\'ASSIGNED\' | translate}}</button>\n' +
    '    <button class="button button-action" ng-click="ok(\'trainingPlan\')">{{\'TRAINING_PROGRAM\' | translate}}</button>\n' +
    '</div>');
  }]);
angular.module('/app/components/left_menu/left_menu.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/left_menu/left_menu.html', '<div class="left-menu-wrapper">\n' +
    '  <div class="left-menu" ng-class="{opened: menu.isOpened}">\n' +
    '    <div class="left-menu__section left-menu__section--top">\n' +
    '\n' +
    '      <div class=\'left-menu__section-content\'>\n' +
    '        <div class="left-menu__item"\n' +
    '          pt-crm-left-menu-toggle>\n' +
    '\n' +
    '          <div class=\'menu-toggler\'\n' +
    '            ng-class=\'{active: menu.isOpened}\'>\n' +
    '            <div class=\'menu-toggler-content\'></div>\n' +
    '          </div>\n' +
    '          <span class="left-menu__item-name">{{ :: "CLOSE" | translate }}</span>\n' +
    '        </div>\n' +
    '\n' +
    '        <a class="left-menu__item"\n' +
    '          ui-sref-active="active"\n' +
    '          ui-sref="app.dashboard"\n' +
    '          permission\n' +
    '          permission-only="\'DASHBOARD_VIEW_READ\'">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--dashboard"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "DASHBOARD" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           ui-sref-active="active"\n' +
    '           ui-sref="app.calendar"\n' +
    '           permission\n' +
    '           permission-only="\'SCHEDULE_VIEW_READ\'">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--schedule"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "CALENDAR" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           ui-sref-active="{\'active\': \'app.library\'}"\n' +
    '           ui-sref="app.library.list"\n' +
    '           permission\n' +
    '           permission-only="\'TRAINING_LIBRARY_VIEW_READ\'">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--library"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "TRAINING_LIBRARY" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '          ui-sref-active="{\'active\': \'app.users\'}"\n' +
    '          ui-sref="app.users.list"\n' +
    '          permission\n' +
    '          permission-only="[\'ROSTER_CLIENT_VIEW_READ\', \'ROSTER_NON_CLIENT_VIEW_READ\']">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--roster"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "ROSTER" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           ui-sref-active="{\'active\': \'app.facilityAssignments\'}"\n' +
    '           ui-sref="app.facility_assignments"\n' +
    '           permission\n' +
    '           permission-only="\'FACILITY_ASSIGNMENTS_READ\'"\n' +
    '           ng-if="menu.showWorkoutOfTheDay">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--facilityAssignments"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "WOTD" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           ui-sref-active="{\'active\': \'app.messaging\'}"\n' +
    '           ui-sref="app.messaging"\n' +
    '           permission\n' +
    '           permission-only="\'MESSAGES_READ\'"\n' +
    '           ng-if="menu.showMessaging">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--messaging"></div>\n' +
    '          <div ng-if="menu.unreadMessages" class="left-menu__item-unread"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "MESSAGING" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           ui-sref-active="active"\n' +
    '           ui-sref="app.settings"\n' +
    '           permission\n' +
    '           permission-only="\'SETTINGS_VIEW_READ\'">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--settings"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "SETTINGS" | translate }}</span>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="left-menu__section left-menu__section--bottom left-menu__add-item">\n' +
    '        <a class="left-menu__item"\n' +
    '          ui-sref-active="{\'active\': \'app.assignment\' || \'app.trainingPlan\' }"\n' +
    '          permission\n' +
    '          permission-only="[\'WORKOUT_ASSIGNMENTS_OTHER_CREATE\', \'WORKOUT_ASSIGNMENTS_SELF_CREATE\']"\n' +
    '          ng-click="menu.assignmentFlowSelect()">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--new_assignment"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "NEW_ASSIGNMENT" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '          ui-sref-active="active"\n' +
    '          ui-sref="app.library.exercise"\n' +
    '          permission\n' +
    '          permission-only="\'EXERCISES_CREATE\'">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--new_workout"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "NEW_EXERCISE" | translate }}</span>\n' +
    '        </a>\n' +
    '        <a class="left-menu__item"\n' +
    '           permission\n' +
    '           permission-only="\'USERS_ADMIN_CREATE\'"\n' +
    '           ng-click="menu.addUser()">\n' +
    '          <div class="left-menu__item-img left-menu__item-img--add_client"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "ADD_USER" | translate}}</span>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '        <div class="left-menu__section--collapsed-button-container">\n' +
    '        <a class="left-menu__item" ng-click="menu.toggleCollapsedBtns()">\n' +
    '          <div id="left-menu_blue_add_icon" class="left-menu__item-img left-menu__item-img--collapsed_add_icon"></div>\n' +
    '          <span class="left-menu__item-name">{{ :: "ADD" | translate }}</span>\n' +
    '        </a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div id="collapsed-blue-icons-container" class="blue-icons-container left-menu__section--bottom blue-icons-container__hide">\n' +
    '  <a class="left-menu__item"\n' +
    '        ui-sref-active="{\'active\': \'app.assignment\' || \'app.trainingPlan\' }"\n' +
    '        permission\n' +
    '        permission-only="[\'WORKOUT_ASSIGNMENTS_OTHER_CREATE\', \'WORKOUT_ASSIGNMENTS_SELF_CREATE\']"\n' +
    '        ng-click="menu.assignmentFlowSelect()">\n' +
    '  <div class="left-menu__item-img left-menu__item-img--new_assignment"></div>\n' +
    '  <span class="left-menu__item-name">{{ :: "NEW_ASSIGNMENT" | translate }}</span>\n' +
    '  </a>\n' +
    '  <a class="left-menu__item"\n' +
    '        ui-sref-active="active"\n' +
    '        ui-sref="app.library.exercise"\n' +
    '        permission\n' +
    '        permission-only="\'EXERCISES_CREATE\'">\n' +
    '      <div class="left-menu__item-img left-menu__item-img--new_workout"></div>\n' +
    '      <span class="left-menu__item-name">{{ :: "NEW_EXERCISE" | translate }}</span>\n' +
    '  </a>\n' +
    '  <a class="left-menu__item"\n' +
    '        permission\n' +
    '        permission-only="\'USERS_ADMIN_CREATE\'"\n' +
    '        ng-click="menu.addUser()">\n' +
    '      <div class="left-menu__item-img left-menu__item-img--add_client"></div>\n' +
    '      <span class="left-menu__item-name">{{ :: "ADD_USER" | translate}}</span>\n' +
    '  </a>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/library-card/library-card.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/library-card/library-card.html', '<div class=\'library-card\'>\n' +
    '  <div class=\'library-card__front\'>\n' +
    '    <div class=\'library-card__img-wrapper\'>\n' +
    '      <div class=\'library-card__featured\' ng-if="card.data.featured">\n' +
    '        <div class=\'library-card__featured-card\'></div>\n' +
    '      </div>\n' +
    '        <img class=\'library-card__img\' ng-src="{{ :: card.getImagePath() }}"/>\n' +
    '    </div>\n' +
    '    <div class=\'library-card__content\'>\n' +
    '      <div class=\'library-card__title\'>{{ :: card.data.title || card.data.planName }}</div>\n' +
    '      <div class=\'library-card__description\'>{{ card.data.equipmentType ? card.data.equipmentType :  card.data.category  | uppercase | translate }}</div>\n' +
    '    </div>\n' +
    '    <div ng-if="card.index"\n' +
    '        class="library-card__item-index js-drag-handle">\n' +
    '      <span class="library-card__item-index__content">\n' +
    '        {{card.index}}\n' +
    '      </span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class=\'library-card__back\' ng-if=" :: !card.disableFlip">\n' +
    '    <div class=\'library-card__content-center library-card__back__edit-icon\'\n' +
    '      permission\n' +
    '      permission-only="card.editPermission"\n' +
    '      ng-if="!card.hideEditIcon"\n' +
    '      ng-click="card.onEditCard(card.data)">\n' +
    '      <i class=\'icon icon-edit\'></i>\n' +
    '    </div>\n' +
    '    <div class=\'library-card__content-center library-card__back__delete-icon\'\n' +
    '         permission\n' +
    '         permission-only="card.deletePermission"\n' +
    '         ng-if="!card.hideDeleteIcon"\n' +
    '         ng-click="card.onDeleteCard(card.data)"\n' +
    '         >\n' +
    '      <i class=\'icon icon-delete\'></i>\n' +
    '    </div>\n' +
    '    <div class=\'library-card__content-center\'>\n' +
    '      <i class="icon library-card__print"\n' +
    '        ng-if="!card.hidePrintIcon"\n' +
    '        ng-click="card.onPrintCard(card.data)">\n' +
    '      </i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class=\'library-card__add-button\' ng-if=" :: card.addButton" ng-click="card.addButtonCallback()">\n' +
    '    <span class="library-card__icon-wrapper">\n' +
    '      <i class="icon icon-ion-plus"></i>\n' +
    '    </span>\n' +
    '  </div>\n' +
    '  <div class=\'library-card__remove-button\' ng-if=" :: card.removeButton" ng-click="card.removeButtonCallback()">\n' +
    '    <span class="library-card__icon-wrapper">\n' +
    '      <i class="icon icon-ion-minus"></i>\n' +
    '    </span>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/metric-card/metric-card.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/metric-card/metric-card.html', '<section class="metric-card" ng-class="metricCtrl.editType ? \'metric-card-editable\' : \'\' ">\n' +
    '    <div class="card-header">\n' +
    '        <div>{{ metricCtrl.metricName }}</div>\n' +
    '        <img ng-if="metricCtrl.editType"\n' +
    '            ng-src="{{ metricCtrl.basePath }}fonts/icon-edit.svg"\n' +
    '            ng-click="metricCtrl.focusOnInput();">\n' +
    '        </div>\n' +
    '\n' +
    '    <div class="card-body" ng-if="metricCtrl.editType !== \'duration\'">\n' +
    '        <input\n' +
    '            auto-resize-input\n' +
    '            ng-readonly="!metricCtrl.editType"\n' +
    '            ng-disabled="!metricCtrl.editType"\n' +
    '            focus-me="metricCtrl.focusOnMe"\n' +
    '            ng-model="metricCtrl.metricValue"\n' +
    '            ng-readonly="!metricCtrl.editType"\n' +
    '            type="number"\n' +
    '            placeholder="0"\n' +
    '            min="0"\n' +
    '            ng-change="metricCtrl.onMetricValueUpdate({$event: metricCtrl.metricValue});">\n' +
    '        <div class="unit">\n' +
    '            {{ metricCtrl.metricUnit }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="duration-body" ng-if="metricCtrl.editType === \'duration\'">\n' +
    '        <duration-input metric-value="metricCtrl.metricValue"\n' +
    '            on-update="metricCtrl.handleDurationChange($event)"\n' +
    '            focus-value="metricCtrl.focusOnMe">\n' +
    '        </duration-input>\n' +
    '    </div>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/components/metric-edit/metric-edit.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/metric-edit/metric-edit.html', '<div>\n' +
    '    <form name="form" class="form-inline metric-edit__grid" novalidate>\n' +
    '        <div class="form-group metric-edit__pillbox" ng-repeat="item in metricEditCtrl.editable">\n' +
    '            <label class="advanced-strength__value-picker-label">\n' +
    '                <span>{{ item.title }}</span>\n' +
    '                <span ng-if="item.unit">({{ item.unit }})</span>\n' +
    '                <span ng-if="!item.unit && metricEditCtrl.inputMetricConfig[item.name].type === \'time\'">({{ \'MIN\' | translate }})</span>\n' +
    '            </label>\n' +
    '            <br>\n' +
    '            <div class="input-group advanced-strength__input-group">\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button ng-disabled="form.input.$invalid || metricEditCtrl.internalProfile[item.name] <= metricEditCtrl.inputMetricConfig[item.name].minimumValue" class="btn btn-default advanced-strength__increment-button"\n' +
    '                        type="button" ng-click="metricEditCtrl.decrementMetric(item.name)">\n' +
    '                        <img class="advanced-strength__increment-button-icon" ng-src="{{ metricEditCtrl.imagePath }}fonts/icon-minus.svg">\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '                <img class="advanced-strength__input-edit-icon" ng-src="{{ metricEditCtrl.imagePath }}fonts/icon-desktop-edit.png">\n' +
    '                <input name="input" type=\'number\' ng-model="metricEditCtrl.internalProfile[item.name]" ng-placeholder="0" class="form-control advanced-strength__number-input" ng-blur="metricEditCtrl.manuallySetValue(item.name)">\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button ng-disabled="form.input.$invalid || metricEditCtrl.internalProfile[item.name] >= metricEditCtrl.inputMetricConfig[item.name].maximumValue" class="btn btn-default advanced-strength__increment-button"\n' +
    '                        type="button" ng-click="metricEditCtrl.incrementMetric(item.name)">\n' +
    '                        <img class="advanced-strength__increment-button-icon" ng-src="{{ metricEditCtrl.imagePath }}fonts/icon-plus.svg">\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</div>');
  }]);
angular.module('/app/components/popup/_popup.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/popup/_popup.html', '<div class="{{ cssClass }}">\n' +
    '\n' +
    '  <form ng-submit=\'ok()\'>\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--back" ng-if=\'showBack\' ng-click="back()"></div>\n' +
    '      <div class="modal__popup-header--title">{{ title }}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross"\n' +
    '        ng-click="close()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'modal__content\'>\n' +
    '      <div class=\'modal__content-description\'\n' +
    '        ng-if=\'description\'>{{ description }}</div>\n' +
    '\n' +
    '      <div class=\'modal__content-template\' bind-html-compile=\'content\'></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <button type=\'submit\' autofocus ng-if=\'showOk\'\n' +
    '        class="button button-action">\n' +
    '        <i class="roster-load-more__icon spinner-icon"\n' +
    '          ng-if="isLoading">\n' +
    '        </i>\n' +
    '        {{ okText }}\n' +
    '      </button>\n' +
    '\n' +
    '      <div class="button button-assertive button-clear pull-right"\n' +
    '        ng-if=\'showCancel\'\n' +
    '        ng-click=\'cancel()\'>\n' +
    '        {{ cancelText }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/scrolling-datepicker/scrolling-datepicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/scrolling-datepicker/scrolling-datepicker.html', '<div class="scrolling-datepicker" infinite-scroll="showMoreMonths()" can-load="true" threshold="1000">\n' +
    '  <div class="datepicker" ng-class="{\'ng-invalid\': !isValid && true}" ng-repeat="month in months" id="{{ ::month.startMoment.format(\'MMYYYY\') }}">\n' +
    '    <div class="datepicker__container">\n' +
    '      <div class="datepicker__header">\n' +
    '        <div class="datepicker__title">{{ ::month.name }} {{ ::month.startMoment.year() }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="datepicker__day-names">\n' +
    '        <div class="datepicker__ceil-container" ng-repeat="dayName in dayNames">\n' +
    '          <div class="datepicker__day-name">{{ ::dayName }}</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="datepicker__row" ng-if="month.weeks" ng-repeat="week in month.weeks">\n' +
    '        <div ng-repeat="day in week track by $index"\n' +
    '          class="datepicker__ceil-container">\n' +
    '          <div class="datepicker__ceil"\n' +
    '              ng-class="{\'datepicker__ceil--day\': day.number >= 0,\n' +
    '              \'datepicker__ceil--inactive\': !day,\n' +
    '            \'datepicker__ceil--selected\': day.isSelected,\n' +
    '              \'datepicker__ceil--current\': day.isToday,\n' +
    '            \'datepicker__ceil--not-availiable\': !day.isAvailable,\n' +
    '            \'datepicker__ceil--facility-assignment\': day.isAvailable && day.hasFacilityAssignment}"\n' +
    '              ng-click="(day.isAvailable && !day.hasFacilityAssignment) && selectDay(day)">{{ ::day.number || " "}}\n' +
    '          </div>\n' +
    '          <!-- <div class="datepicker__ceil--facility-assignment" ng-if="day.isAvailable && day.hasFacilityAssignment">icon</div> -->\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="roster-load-more">\n' +
    '    <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '    {{ \'LOADING_MORE\' | translate }}\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/scrolling-datepicker-component/scrolling-datepicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/scrolling-datepicker-component/scrolling-datepicker.html', '<scrolling-datepicker\n' +
    '  start-moment="datepickerCtrl.startDateInternal"\n' +
    '  end-moment="datepickerCtrl.endDateInternal"\n' +
    '  single-day="datepickerCtrl.singleDay"\n' +
    '  include-facility-assignments="datepickerCtrl.includeFacilityAssignments"\n' +
    '  disabled="datepickerCtrl.disableTimeChanges"\n' +
    '></scrolling-datepicker>\n' +
    '');
  }]);
angular.module('/app/components/tabs/tab.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/tabs/tab.html', '<li class="tab-head__item"\n' +
    '    ng-class="{\'tab-head__item--active\': active, \'tab-head__item--right\': button, \'tab-head__item--disabled\': disabled}"\n' +
    '    ng-click="tabClick()">\n' +
    '\n' +
    '</li>\n' +
    '');
  }]);
angular.module('/app/components/tabs/tabs.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/tabs/tabs.html', '<div class="tabs">\n' +
    '  <ul class="tab-head" ng-show="!tabsCtrl.hideIfSingular || tabsCtrl.tabs.length > 1" ng-transclude></ul>\n' +
    '\n' +
    '  <div class="tab-content">\n' +
    '    <div class="tab-content__panel"\n' +
    '         ng-repeat="tab in tabsCtrl.tabs"\n' +
    '         ng-class="{\'tab-content__panel--active\': tab.active}"\n' +
    '         tab-content tab-instance="tab">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/task-card/task-card.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/task-card/task-card.html', '<div class="taskpicker-container-right-client-wrapper"\n' +
    '  ng-class="{\'taskpicker-container-right-client-wrapper--task\': taskCtrl.item.type === \'task\'}">\n' +
    '\n' +
    '  <div permission\n' +
    '  permission-only="taskCtrl.readPermission">\n' +
    '    <img class="taskpicker-container-right-client-img"\n' +
    '      ng-src="{{taskCtrl.item.img}}">\n' +
    '    <div class="taskpicker-container-header">\n' +
    '      <div class="taskpicker-container-right-client-time">\n' +
    '        {{taskCtrl.item.dateFrom | dateFormatter:\'dateMedium\'}}\n' +
    '      </div>\n' +
    '      <div class="taskpicker-container-right-client-corner"\n' +
    '        permission\n' +
    '        permission-only="taskCtrl.editPermission"\n' +
    '        ng-if="taskCtrl.isEditable && !taskCtrl.isPassedAssignment"\n' +
    '        ng-click="taskCtrl.editTaskCard($event, client)">\n' +
    '        <i class=\'icon icon-edit\'></i>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="taskpicker-container-right-client-name">\n' +
    '      {{taskCtrl.item.caption}}\n' +
    '    </div>\n' +
    '    <div class="taskpicker-container-right-client-location">\n' +
    '      {{taskCtrl.item.name}}\n' +
    '    </div>\n' +
    '    <div class="taskpicker-container-footer">\n' +
    '      <i class=\'icon icon-info_outline taskpicker-info-icon\'\n' +
    '        title="{{::taskCtrl.item.title + \'\\n\' + taskCtrl.item.description}}" ng-if="taskCtrl.isTask(taskCtrl.item)" permission\n' +
    '        permission-only="taskCtrl.readPermission" ng-click="taskCtrl.showTaskInfo($event)">\n' +
    '      </i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '<div>\n' +
    '');
  }]);
angular.module('/app/components/taskpicker/taskpicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/taskpicker/taskpicker.html', '<div class="taskpicker">\n' +
    '  <div class="taskpicker-header">\n' +
    '    <button class="taskpicker-title"\n' +
    '      ng-click="setAllDay()">{{ :: \'ANYTIME\' | translate }}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="taskpicker-container">\n' +
    '    <task-card class="taskpicker-container-right-client" ng-repeat="client in clients"\n' +
    '      ng-click="clientSelect(client)"\n' +
    '      ng-if="(editAssign && (editAssign._id === client._id)) ? false : true"\n' +
    '      edit-card="client.type === \'task\' ? editTask : editClient"\n' +
    '      is-editable="isEditable"\n' +
    '      item="client">\n' +
    '    </task-card>\n' +
    '\n' +
    '    <div class="taskpicker-container-right-client"\n' +
    '         ng-if="selectedClients && !(selectedClients.timeFrom >= 0 && selectedClients.timeTo)"\n' +
    '         ng-class="{\'taskpicker-container-right-client--conflict\': checkOverlap()}"\n' +
    '         ng-style="generateStyle(selectedClients)">\n' +
    '      <div class="taskpicker-container-right-client-wrapper"\n' +
    '        ng-class="{\'taskpicker-container-right-client-wrapper--task\': selectedClients.type === \'task\'}">\n' +
    '        <img class="taskpicker-container-right-client-img"\n' +
    '             ng-src="{{selectedClients.img}}">\n' +
    '\n' +
    '        <div class="taskpicker-container-right-client-time">\n' +
    '          {{taskCtrl.item.dateFrom | dateFormatter:\'dateMedium\'}}\n' +
    '        </div>\n' +
    '        <div class="taskpicker-container-right-client-name">\n' +
    '          {{selectedClients.caption}}\n' +
    '        </div>\n' +
    '        <div class="taskpicker-container-right-client-location">\n' +
    '          {{selectedClients.club}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
  }]);
angular.module('/app/components/time-slot/time-slot.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/time-slot/time-slot.html', '<div class="timepicker-container-right-client-wrapper"\n' +
    '  ng-class="{\'timepicker-container-right-client-wrapper--task\': timeCtrl.item.type === \'task\'}">\n' +
    '\n' +
    '  <div permission\n' +
    '  permission-only="timeCtrl.readPermission">\n' +
    '    <img class="timepicker-container-right-client-img"\n' +
    '      ng-class="{\'timepicker-container-right-client-img--half-hour\': timeCtrl.item.timeTo - timeCtrl.item.timeFrom <= 0.5}"\n' +
    '      ng-src="{{timeCtrl.item.img}}">\n' +
    '\n' +
    '    <div class="timepicker-container-right-client-time">\n' +
    '      {{timeRanges[timeCtrl.item.timeFrom * 2]}} - {{timeRanges[timeCtrl.item.timeTo * 2]}}\n' +
    '    </div>\n' +
    '    <div class="timepicker-container-right-client-name">\n' +
    '      {{timeCtrl.item.caption}}\n' +
    '    </div>\n' +
    '    <div class="timepicker-container-right-client-location">\n' +
    '      {{timeCtrl.item.name}}\n' +
    '    </div>\n' +
    '    <i class=\'icon icon-info_outline timepicker-info-icon\'\n' +
    '      ng-class="{\'timepicker-info-icon--half-hour\': timepickerCtrl.selectedClientsInternal.timeTo - timepickerCtrl.selectedClientsInternal.timeFrom <= 0.5}"\n' +
    '      title="{{::timeCtrl.item.title + \'\\n\' + timeCtrl.item.description}}"\n' +
    '      ng-if="timeCtrl.isTask(timeCtrl.item)"\n' +
    '      permission\n' +
    '      permission-only="timeCtrl.readPermission"\n' +
    '      ng-click="timeCtrl.showTaskInfo($event)">\n' +
    '    </i>\n' +
    '    <div class="timepicker-container-right-client-corner"\n' +
    '      permission\n' +
    '      permission-only="timeCtrl.editPermission"\n' +
    '      ng-if="timeCtrl.isEditable && !timeCtrl.isPassedAssignment"\n' +
    '      ng-click="timeCtrl.editTimeSlot($event, client)">\n' +
    '      <i class=\'icon icon-edit\'></i>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/timepicker/timepicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/timepicker/timepicker.html', '<div class="timepicker">\n' +
    '  <div class="timepicker-header">\n' +
    '    <button class="timepicker-title" ng-click="setAllDay()">\n' +
    '      <i ng-show="allDaySet" class="icon icon-checkmark"></i>\n' +
    '      {{ :: \'ANYTIME\' | translate }}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="timepicker-container">\n' +
    '    <div class="timepicker-container-left">\n' +
    '      <div class="timepicker-container-left-item"\n' +
    '           data-ng-repeat="title in titles">\n' +
    '        {{title}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <pt-time-slot class="timepicker-container-right-client"\n' +
    '      ng-class="{\'timepicker-container-right-client--overlappable\': allowOverlap}"\n' +
    '      ng-repeat="client in clients"\n' +
    '      ng-click="clientSelect(client)"\n' +
    '      ng-if="(editAssign && (editAssign._id === client._id)) ? false : true"\n' +
    '      ng-style="generateStyle(client)"\n' +
    '      edit-slot="client.type === \'task\' ? editTask : editClient"\n' +
    '      is-editable="isEditable"\n' +
    '      item="client">\n' +
    '    </pt-time-slot>\n' +
    '\n' +
    '    <div class="timepicker-container-right-client"\n' +
    '         ng-if="selectedClients.timeFrom >= 0 && selectedClients.timeTo"\n' +
    '         ng-class="{\'timepicker-container-right-client--conflict\': checkOverlap()}"\n' +
    '         ng-style="generateStyle(selectedClients)">\n' +
    '      <div class="timepicker-container-right-client-wrapper"\n' +
    '        ng-class="{\'timepicker-container-right-client-wrapper--task\': selectedClients.type === \'task\'}"\n' +
    '        ng-click="showTimeDetails()">\n' +
    '        <img class="timepicker-container-right-client-img"\n' +
    '             ng-class="{\'timepicker-container-right-client-img--half-hour\': selectedClients.timeTo - selectedClients.timeFrom <= 0.5}"\n' +
    '             ng-src="{{selectedClients.img}}">\n' +
    '\n' +
    '        <div class="timepicker-container-right-client-time">\n' +
    '          {{timeRanges[selectedClients.timeFrom * 2]}} - {{timeRanges[selectedClients.timeTo * 2]}}\n' +
    '        </div>\n' +
    '        <div class="timepicker-container-right-client-name">\n' +
    '          {{selectedClients.caption}}\n' +
    '        </div>\n' +
    '        <div class="timepicker-container-right-client-location">\n' +
    '          {{selectedClients.club}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="timepicker-container-right-client-dragger"></div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="timepicker-container-right">\n' +
    '      <div class="timepicker-container-right-item"\n' +
    '        data-ng-repeat="item in timeAvailabilities track by $index"\n' +
    '        ng-class="{\'timepicker-container-right-item-availability\': !item.isAvailable}">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/timepicker-component/timepicker.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/timepicker-component/timepicker.html', '<div class="timepicker">\n' +
    '  <div class="timepicker-header">\n' +
    '    <button class="timepicker-title" ng-click="timepickerCtrl.setAllDay()">\n' +
    '      <i ng-show="timepickerCtrl.allDaySet" class="icon icon-checkmark"></i>\n' +
    '      {{ :: \'ANYTIME\' | translate }}\n' +
    '    </button>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="timepicker-container">\n' +
    '    <div class="timepicker-container-left">\n' +
    '      <div class="timepicker-container-left-item"\n' +
    '           data-ng-repeat="title in timepickerCtrl.titles">\n' +
    '        {{title}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="timepicker-container-right-client"\n' +
    '         ng-if="timepickerCtrl.selectedClientsInternal.timeFrom >= 0\n' +
    '          && timepickerCtrl.selectedClientsInternal.timeTo && !timepickerCtrl.allDaySet"\n' +
    '         ng-style="timepickerCtrl.generateStyle(timepickerCtrl.selectedClientsInternal)">\n' +
    '      <div class="timepicker-container-right-client-wrapper">\n' +
    '        <img class="timepicker-container-right-client-img"\n' +
    '             ng-class="{\'timepicker-container-right-client-img--half-hour\': timepickerCtrl.selectedClientsInternal.timeTo - timepickerCtrl.selectedClientsInternal.timeFrom <= 0.5}"\n' +
    '             ng-src="{{timepickerCtrl.selectedClientsInternal.img}}">\n' +
    '\n' +
    '        <div class="timepicker-container-right-client-time">\n' +
    '          {{timepickerCtrl.timeRanges[timepickerCtrl.selectedClientsInternal.timeFrom * 2]}} - {{timepickerCtrl.timeRanges[timepickerCtrl.selectedClientsInternal.timeTo * 2]}}\n' +
    '        </div>\n' +
    '        <div class="timepicker-container-right-client-name">\n' +
    '          {{timepickerCtrl.selectedClientsInternal.caption}}\n' +
    '        </div>\n' +
    '        <div class="timepicker-container-right-client-location">\n' +
    '          {{timepickerCtrl.selectedClientsInternal.club}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="timepicker-container-right-client-dragger"></div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="timepicker-container-right">\n' +
    '      <div class="timepicker-container-right-item"\n' +
    '        data-ng-repeat="item in timepickerCtrl.timeAvailabilities track by $index"\n' +
    '        ng-class="{\'timepicker-container-right-item-availability\': !item.isAvailable}">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/user-card/user-card.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/user-card/user-card.html', '<div class="user-card" ng-class="{\'user-card--remove\':card.isRemove}">\n' +
    '  <img ng-src="{{card.user.pictureUrl || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}" class="user-card__img">\n' +
    '  <div class="user-card__content">\n' +
    '    <div class="user-card__name">{{card.user.firstName}} {{card.user.lastName}}</div>\n' +
    '    <div class="user-card__work">{{card.user.clientProfile.club.name}}</div>\n' +
    '  </div>\n' +
    '  <div class="user-card__icon user-card__icon--delete"\n' +
    '       ng-if="card.isRemovable"\n' +
    '       ng-click="card.remove()"></div>\n' +
    '  <div ng-if="card.arrow" class="user-card__icon user-card__icon--move" ng-class="{\n' +
    '    \'user-card__icon--up\': card.arrow === \'up\',\n' +
    '    \'user-card__icon--down\': card.arrow === \'down\',\n' +
    '  }"></div>\n' +
    '  <div ng-if="card.moveable" class="user-card__icon user-card__icon--move"></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/users-bag/users-bag.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/users-bag/users-bag.html', '<div class="user-tab__selected-users-task iscroll-wrapper"\n' +
    '     iscroll="{scrollX: true, scrollY:false, mouseWheel:false, click:false}"\n' +
    '     dragula-configure\n' +
    '     dragula-scope="bagCtrl.scope"\n' +
    '     dragula-bag="usersList.items"\n' +
    '     dragula-invalid="client-card-placeholder__text"\n' +
    '     dragula-direction="horizontal">\n' +
    '\n' +
    '  <div class="iscroll-scroller iscroll-scroller--horizontal">\n' +
    '    <div class="client-card-placeholder"\n' +
    '         ng-if="bagCtrl.usersList"\n' +
    '         ng-show="bagCtrl.selectedUsers.length < bagCtrl.bagLimit"\n' +
    '         dragula="\'usersList.items\'"\n' +
    '         dragula-scope="bagCtrl.scope"\n' +
    '         dragula-model="bagCtrl.selectedUsers">\n' +
    '      <div class="client-card-placeholder__text">\n' +
    '        {{ \'drop_\' + bagCtrl.userType + \'_here\' | camelToSnakeCase | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <user-card class="user-tab__selected-user"\n' +
    '      ng-repeat="user in bagCtrl.selectedUsers track by user._id"\n' +
    '      is-removable="true"\n' +
    '      user="user"\n' +
    '      remove="bagCtrl.deselectUser($index)">\n' +
    '    </user-card>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="user-tab__scrollbar"></div>\n' +
    '\n' +
    '<library-search>\n' +
    '  <div class="library-search">\n' +
    '    <div class="library-search__icon"></div>\n' +
    '    <input type="text"\n' +
    '      class="library-search__input"\n' +
    '      placeholder="{{ :: \'SEARCH\' | translate }}"\n' +
    '      ng-model-options="{ debounce: 500 }"\n' +
    '      ng-model="bagCtrl.searchStr"\n' +
    '      ng-change="bagCtrl.loadUsers(bagCtrl.searchStr)">\n' +
    '    <search-clearer\n' +
    '      search-term="bagCtrl.searchStr"\n' +
    '      refresh-fn="bagCtrl.loadUsers(bagCtrl.searchStr)">\n' +
    '    </search-clearer>\n' +
    '  </div>\n' +
    '</library-search>\n' +
    '\n' +
    '<div class="user-tab__users"\n' +
    '     permission\n' +
    '     permission-only="bagCtrl.editBagPermission"\n' +
    '     dragula="\'usersList.items\'"\n' +
    '     dragula-scope="bagCtrl.scope"\n' +
    '     dragula-model="bagCtrl.usersList.items"\n' +
    '     infinite-scroll=\'bagCtrl.loadUsers()\'\n' +
    '     can-load=\'bagCtrl.usersList.nextPage\'\n' +
    '     threshold=\'100\'>\n' +
    '\n' +
    '  <user-card class="user-tab__user"\n' +
    '     ng-repeat="user in bagCtrl.usersList.items track by user._id"\n' +
    '     user="user">\n' +
    '  </user-card>\n' +
    '  <div class="user-tab__no-users"\n' +
    '    ng-if="bagCtrl.usersList && !bagCtrl.usersList.items.length && !bagCtrl.usersList.nextPage">\n' +
    '    {{ \'NO_USERS_AVAILABLE\' | translate }}\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="roster-load-more"\n' +
    '    ng-if="bagCtrl.usersList && bagCtrl.usersList.nextPage">\n' +
    '    <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '    {{ \'loadingMore_\'  + bagCtrl.userType | camelToSnakeCase | translate }}\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/components/workout-name/workout-name.component.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/components/workout-name/workout-name.component.html', '<div class="workout-name"\n' +
    '  ng-class="{ \'workout-name--plan\': workoutNameCtrl.context === \'trainingPlan\' }">\n' +
    '  <div class="workout-name__vertical-separator"></div>\n' +
    '  <form class="workout-name__form">\n' +
    '    <div class="workout-name__input-wrapper">\n' +
    '      <input class="workout-name__text-input"\n' +
    '        type="text"\n' +
    '        name="workoutName"\n' +
    '        ng-model="workoutNameCtrl.componentWorkoutName"\n' +
    '        ng-change="workoutNameCtrl.textInput(workoutNameCtrl.componentWorkoutName)"\n' +
    '        placeholder="{{ workoutNameCtrl.showPlaceholder() | translate }}">\n' +
    '      <label for="workoutName" class="workout-name__text-label" >\n' +
    '        {{ workoutNameCtrl.showPlaceholder() | translate }}\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/dashboard/dashboard.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/dashboard/dashboard.html', '<div class="dashboard">\n' +
    '  <header class="container-header">\n' +
    '    <div class=\'container-header__content\'>\n' +
    '      <div class="container-header__caption">{{ dashboard.today | dateFormatter:\'dateLong\' }}</div>\n' +
    '\n' +
    '      <i class=\'container-header__icon icon icon-schedule\'></i>\n' +
    '      <h1 class="container-header__title">{{ \'WELCOME\' | translate}} {{ user.firstName }}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '\n' +
    '  <section class=\'dashboard__content\'>\n' +
    '\n' +
    '    <div class="dashboard__right-section">\n' +
    '      <div class=\'dashboard__list\'>\n' +
    '        <div class=\'dashboard__list-title\'>{{ "TODAYS_APPOINTMENT" | translate }}</div>\n' +
    '        <div class="timepicker-wrapper">\n' +
    '          <tabs class="date-tab__picker-tabs">\n' +
    '            <tab>\n' +
    '              <tab-head>\n' +
    '                <span class="tab-head__multiline-item">\n' +
    '                  <span class="button__icon button__icon--clock"></span>\n' +
    '                </span>\n' +
    '              </tab-head>\n' +
    '              <tab-content>\n' +
    '                <timepicker\n' +
    '                  clients="dashboard.timelineClients"\n' +
    '                  on-edit-client="dashboard.onEditAssigment($item)"\n' +
    '                  on-edit-task="dashboard.onEditTask($item)"\n' +
    '                  on-client-select=\'dashboard.navigateToUserDetails($item)\'\n' +
    '                  is-editable="true"\n' +
    '                  read-only\n' +
    '                  trainer-work-info=\'dashboard.workInfo\'>\n' +
    '                </timepicker>\n' +
    '              </tab-content>\n' +
    '            </tab>\n' +
    '            <tab>\n' +
    '              <tab-head>\n' +
    '                <span class="tab-head__multiline-item">\n' +
    '                  <span class="button__icon button__icon--assignment"></span>\n' +
    '                </span>\n' +
    '              </tab-head>\n' +
    '              <tab-content>\n' +
    '                <taskpicker\n' +
    '                  clients="dashboard.anytimeClients"\n' +
    '                  on-edit-client="dashboard.onEditAssigment($item)"\n' +
    '                  on-edit-task="dashboard.onEditTask($item)"\n' +
    '                  on-client-select=\'dashboard.navigateToUserDetails($item)\'\n' +
    '                  is-editable="true"\n' +
    '                  read-only>\n' +
    '                </taskpicker>\n' +
    '              </tab-content>\n' +
    '            </tab>\n' +
    '          </tabs>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="dashboard__left-section">\n' +
    '\n' +
    '      <div permission\n' +
    '      permission-only="\'INTERESTED_READ\'"\n' +
    '      class=\'dashboard__list dashboard__interested\'>\n' +
    '        <div class=\'dashboard__list-title\'>{{ :: "INTERESTED" | translate }}</div>\n' +
    '\n' +
    '        <div class=\'client-item client-item--no-label\'\n' +
    '          ng-repeat=\'client in dashboard.clients.interested\'\n' +
    '          ui-sref=\'app.users.details({userId: client._id,roles: client.roles[0]})\'>\n' +
    '\n' +
    '          <div class=\'client-item__left\'>\n' +
    '            <img class=\'client-item__picture\' ng-src=\'{{ client.pictureUrl || "//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png" }}\'/>\n' +
    '\n' +
    '            <div class=\'client-item__title\'>\n' +
    '              <div>{{ client.firstName }} {{ client.lastName }}</div>\n' +
    '              <span class=\'client-item__caption\'>{{ client.location }}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'client-item--empty\'\n' +
    '          ng-if=\'!dashboard.clients.interested.length\'>\n' +
    '          {{ :: "NO_CLIENTS" | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class=\'dashboard__list\'>\n' +
    '        <div class=\'dashboard__list-title\'>{{ :: "IN_THE_GYM" | translate }}</div>\n' +
    '\n' +
    '        <div class=\'client-item client-item--ingym\'\n' +
    '          ng-repeat=\'client in dashboard.clients.in_gym\'\n' +
    '          ui-sref=\'app.users.details({userId: client._id,roles: client.roles[0]})\'>\n' +
    '\n' +
    '          <div class=\'client-item__left\'>\n' +
    '            <img class=\'client-item__picture\' ng-src=\'{{ client.pictureUrl || "//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png" }}\'/>\n' +
    '            <div class=\'client-item__label\'>\n' +
    '              <!-- TODO: add custom icons -->\n' +
    '              <div class=\'client-item__label-icon\'></div>\n' +
    '            </div>\n' +
    '            <div class=\'client-item__title\'>\n' +
    '              <div>{{ client.firstName }} {{ client.lastName }}</div>\n' +
    '              <span class=\'client-item__caption\'>{{ client.location }}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'client-item--empty\'\n' +
    '          ng-if=\'!dashboard.clients.in_gym.length\'>\n' +
    '          {{ :: "NO_CLIENTS" | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class=\'dashboard__list\'>\n' +
    '        <div class=\'dashboard__list-title\'>{{ :: "MISSING_IN_ACTION" | translate }}</div>\n' +
    '\n' +
    '        <div class=\'client-item client-item--missing\'\n' +
    '          ng-repeat=\'client in dashboard.clients.at_risk\'\n' +
    '          ui-sref=\'app.users.details({userId: client._id,roles: client.roles[0]})\'>\n' +
    '\n' +
    '          <div class=\'client-item__right\'>\n' +
    '            <div class=\'client-item__info\'>\n' +
    '              <div class=\'client-item__info-content\'>\n' +
    '                <div class=\'client-item__info-title\'\n' +
    '                  ng-if=\'client.clientProfile.lastWorkoutDate\'>{{ client.clientProfile.lastWorkoutDate | dateFormatter:\'dateShort\' }}</div>\n' +
    '                <div class=\'client-item__info-title\'\n' +
    '                  ng-if=\'!client.clientProfile.lastWorkoutDate\'>-//-</div>\n' +
    '                <div class=\'client-item__info-caption\'>{{ :: \'LAST_WORKOUT\' | translate }}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class=\'client-item__left\'>\n' +
    '            <img class=\'client-item__picture\' ng-src=\'{{ client.pictureUrl || "//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png" }}\'/>\n' +
    '            <div class=\'client-item__label\'>\n' +
    '              <!-- TODO: add custom icons -->\n' +
    '              <div class=\'client-item__label-icon\'></div>\n' +
    '            </div>\n' +
    '            <div class=\'client-item__title\'>\n' +
    '              <div>{{ client.firstName }} {{ client.lastName }}</div>\n' +
    '              <span class=\'client-item__caption\'>{{ client.location }}</span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'client-item--empty\'\n' +
    '          ng-if=\'!dashboard.clients.at_risk.length\'>\n' +
    '          {{ :: "NO_CLIENTS" | translate }}\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facility-assignments.modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facility-assignments.modal.html', '<ul class="modal__list-wrapper">\n' +
    '  <li class="modal__list-item-wotd"\n' +
    '    ng-repeat="event in day.events"\n' +
    '    ng-click="addEvent(event, this, day)"\n' +
    '    ng-class="{ \'modal__list-item-wotd-disabled\': shouldDisable(day) }">\n' +
    '    <span class="modal__list-item-wotd-icon"></span>\n' +
    '    <div>\n' +
    '      <div class="modal__list-item-wotd-title">\n' +
    '        {{ event.title }}\n' +
    '      </div>\n' +
    '      <div class="modal__list-item-wotd-groups">\n' +
    '        {{displayNumberOfGroups(event)}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </li>\n' +
    '  <li class="modal__list-item-wotd-add"\n' +
    '    ng-click="addEvent(\'new\', this, day)"\n' +
    '    ng-class="{ \'modal__list-item-wotd-disabled\': shouldDisable(day) }">\n' +
    '    <span class="modal__list-item-wotd-icon--add"></span>\n' +
    '    <div class="modal__list-item-wotd-title">{{\'ADD_WOTD\' | translate }}</div>\n' +
    '  </li>\n' +
    '</ul>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignment/facilityAssignment.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignment/facilityAssignment.html', '<section class="create-assignment" ng-form="createCtrl.assignmentForm" novalidate>\n' +
    '  <header class="create-assignment__header">\n' +
    '    <!--TODO: calculate needConfirmation programmly-->\n' +
    '    <span class="back-button"\n' +
    '      need-confirmation="true"></span>\n' +
    '    <h1 class="create-assignment__header-title">\n' +
    '      {{ :: facilityAssignment.isEdit ? \'UPDATE_FACILITY_ASSIGNMENT\' : \'CREATE_NEW_FACILITY_ASSIGNMENT\' | translate}} - {{facilityAssignment.displayDate}}\n' +
    '    </h1>\n' +
    '\n' +
    '    <workout-name\n' +
    '      workout-name="{{facilityAssignment.title}}"\n' +
    '      on-name-update="facilityAssignment.handleNameChange($event)"\n' +
    '      context="wotd"\n' +
    '    ></workout-name>\n' +
    '\n' +
    '    <div class="button button-assertive pull-right exercise-delete-btn set-delete-btn"\n' +
    '      permission\n' +
    '      permission-only="\'FACILITY_ASSIGNMENTS_DELETE\'"\n' +
    '      ng-if="facilityAssignment.isEdit"\n' +
    '      ng-click="facilityAssignment.remove()">\n' +
    '      <span class="button__icon button__icon--delete-exercise"></span>\n' +
    '      {{ :: \'DELETE_FACILITY_ASSIGNMENT\' | translate }}\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="create-assignment__content">\n' +
    '    <tabs theme="dark">\n' +
    '      <tab>\n' +
    '        <tab-head>\n' +
    '          <span>\n' +
    '            {{facilityAssignment.selectedExercises.length}} {{ :: \'EXERCISES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include src="\'/app/facilityAssignments/facilityAssignment/tabs/exercise.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab is-disabled="!facilityAssignment.selectedExercises.length"\n' +
    '        select=\'facilityAssignment.activateExerciseProfileTab()\'>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_PROFILES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '            src="\'/app/facilityAssignments/facilityAssignment/tabs/exercise-profile.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab ng-if="facilityAssignment.membershipGroupsEnabled">\n' +
    '        <tab-head>\n' +
    '          <span>\n' +
    '           {{ :: \'MEMBERSHIP_GROUPS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include src="\'/app/facilityAssignments/facilityAssignment/tabs/membership-groups.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab class=\'tab-action\'\n' +
    '        permission\n' +
    '        permission-only="\'FACILITY_ASSIGNMENTS_UPDATE\'"\n' +
    '        ng-if="facilityAssignment.isEdit"\n' +
    '        is-button="true"\n' +
    '        is-disabled="!facilityAssignment.selectedExercises.length || facilityAssignment.isLoading">\n' +
    '        <tab-head\n' +
    '          ng-click="facilityAssignment.save()">\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'UPDATE_FACILITY_ASSIGNMENT\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '      <tab class=\'tab-action\'\n' +
    '        permission\n' +
    '        permission-only="\'FACILITY_ASSIGNMENTS_CREATE\'"\n' +
    '        ng-if="!facilityAssignment.isEdit"\n' +
    '        is-button="true"\n' +
    '        is-disabled="!facilityAssignment.selectedExercises.length || facilityAssignment.isLoading">\n' +
    '        <tab-head\n' +
    '          ng-click="facilityAssignment.save()">\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'CREATE_NEW_FACILITY_ASSIGNMENT\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '    </tabs>\n' +
    '  </section>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignment/tabs/exercise-profile.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignment/tabs/exercise-profile.html', '<div class="create-exercise__customize">\n' +
    '  <pt-items-switcher\n' +
    '    selected-items="facilityAssignment.selectedExercises"\n' +
    '    bag-type="workoutAssignmentOther"\n' +
    '    on-index-update = "facilityAssignment.setActiveExerciseIndex(newIndex)">\n' +
    '  </pt-items-switcher>\n' +
    '  <div class="exercise-profile">\n' +
    '    <customize-exercise\n' +
    '      exercise="facilityAssignment.selectedExercises[facilityAssignment.activeExerciseIndex]"\n' +
    '      on-update=\'facilityAssignment.handleExerciseUpdate($event)\'\n' +
    '      context=\'assignment\'>\n' +
    '    </customize-exercise>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignment/tabs/exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignment/tabs/exercise.html', '<pt-items-selector\n' +
    '  items-lists="[ facilityAssignment.exercises, facilityAssignment.trainingSets ]"\n' +
    '  selected-items="facilityAssignment.selectedExercises"\n' +
    '  id="facilityAssignment.set._id"\n' +
    '  hide-print-icon="true"\n' +
    '  get-load-params="facilityAssignment.getExerciseLoadParams"\n' +
    '  item-type="exercises"\n' +
    '  bag-type="trainingSets"\n' +
    '  drag-copy="true">\n' +
    '</pt-items-selector>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignment/tabs/membership-groups.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignment/tabs/membership-groups.html', '<div class="membership-content">\n' +
    '    <div class="membership-page-title">{{ \'MEMBERSHIP_TITLE\' | translate }}</div>\n' +
    '        <div class="title-container">\n' +
    '            <div class="title-text">{{ \'GROUPS\' | translate }}</div>\n' +
    '            <div class="title-text-two">{{ \'GROUP_MEMBERS\' | translate }}</div>\n' +
    '            <div class="ghost-class"></div>\n' +
    '        </div>\n' +
    '        <div class="user-container">\n' +
    '            <div class="user-combo">\n' +
    '                <label>\n' +
    '                    <input class="membership-checkbox"\n' +
    '                    type="checkbox"\n' +
    '                    ng-model="facilityAssignment.allUsers"\n' +
    '                    ng-click="facilityAssignment.selectedGroup($event, \'All Users\')">\n' +
    '                </label>\n' +
    '                <div class="user-name">{{ \'ALL_USERS\' | translate }}</div>\n' +
    '            </div>\n' +
    '            <div class="group-count">--</div>\n' +
    '            <div class="roster-icon"></div>\n' +
    '        </div>\n' +
    '        <div class="membership-container">\n' +
    '                <div class="user-combo">\n' +
    '                    <label>\n' +
    '                        <input class="membership-checkbox"\n' +
    '                        type="checkbox"\n' +
    '                        ng-model="facilityAssignment.allGroups"\n' +
    '                        ng-click="facilityAssignment.selectedGroup($event,\'All Groups\')"\n' +
    '                        ng-disabled="facilityAssignment.allUsers">\n' +
    '                    </label>\n' +
    '                    <div class="membership-groups">\n' +
    '                        <div class="membership-name">{{ \'ALL_GROUPS\' | translate }}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="membership-count">{{facilityAssignment.allGroupCount.length}}</div>\n' +
    '                <div permission permission-except="\'FACILITY_SETTINGS_READ\'" class="ghost-div"></div>\n' +
    '                <div permission permission-only="\'FACILITY_SETTINGS_READ\'" class="arrow-icon"\n' +
    '                ng-click="facilityAssignment.membershipGroupModal()"></div>\n' +
    '            </div>\n' +
    '        <div class="membership-container"\n' +
    '            ng-repeat="group in facilityAssignment.membershipGroups">\n' +
    '                <div class="user-combo">\n' +
    '                    <label>\n' +
    '                        <input class="membership-checkbox"\n' +
    '                        type="checkbox"\n' +
    '                        ng-click="facilityAssignment.selectedGroup($event, group._id)"\n' +
    '                        ng-checked="facilityAssignment.checked(group._id)"\n' +
    '                        ng-disabled="facilityAssignment.allUsers">\n' +
    '\n' +
    '                    </label>\n' +
    '                    <div class="membership-groups">\n' +
    '                        <div class="membership-name">{{group.name}}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="membership-count">{{group.members.length}}</div>\n' +
    '                <div permission permission-except="\'FACILITY_SETTINGS_READ\'" class="ghost-div"></div>\n' +
    '                <div permission permission-only="\'FACILITY_SETTINGS_READ\'" class="arrow-icon"\n' +
    '                ng-click="facilityAssignment.membershipGroupModal()"></div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignment/tabs/membershipGroupModal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignment/tabs/membershipGroupModal.html', '    <div class="membershipModal-container">\n' +
    '        <div class="membershipModalTitle-container">\n' +
    '            <div class="membershipModalTitle">{{ \'MEMBERSHIP_MODAL_TITLE\' | translate }}</div>\n' +
    '            <div class="modal__popup-header--exit icon icon-cross"\n' +
    '            ng-click="facilityAssignment.cancel()"></div>\n' +
    '        </div>\n' +
    '        <div class="membershipModal-body-container">\n' +
    '            <div class="membershipModal-body">\n' +
    '                {{ \'MEMBERSHIP_MODAL_BODY\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="button-container">\n' +
    '            <div class="modal-button-1">\n' +
    '                <div class="modal-button-text"\n' +
    '                ng-click="facilityAssignment.goToSettings()">{{ \'LEAVE_PAGE\' | translate }}</div>\n' +
    '            </div>\n' +
    '            <div class="modal-button-2">\n' +
    '                <div class="modal-button-text"\n' +
    '                ng-click="facilityAssignment.cancel()">{{ \'STAY_ON_PAGE\' | translate}}</div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '');
  }]);
angular.module('/app/facilityAssignments/facilityAssignments.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/facilityAssignments/facilityAssignments.html', '<div class="facility_assignments">\n' +
    '\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content ">\n' +
    '        <i class="icon-menu__item-img icon-menu__item-img--facilityAssignmentDark"></i>\n' +
    '      <h1 class="container-header__title">{{ \'WOTD\' | translate}}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class=\'calendar__content\'>\n' +
    '\n' +
    '    <div class="calendar__selector"></div>\n' +
    '    <div class="calendar__header">\n' +
    '\n' +
    '      <div class="calendar__header-content">\n' +
    '        <div class="calendar__top-year">{{ facilityAssignments.fromYear }}</div>\n' +
    '\n' +
    '        <div class="calendar__top-month"\n' +
    '             ng-repeat-start="month in facilityAssignments.monthRange track by $index"\n' +
    '             ng-click="facilityAssignments.selectMonth(month.number, month.year)"\n' +
    '             ng-class="{\'calendar__top-month--selected\': $index == facilityAssignments.monthOffset}">\n' +
    '          {{month.displayText}}\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="calendar__top-separator"\n' +
    '          ng-repeat-end\n' +
    '          ng-if="month.number == 11">\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="calendar__top-year">{{ facilityAssignments.toYear }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="calendar__bodies">\n' +
    '\n' +
    '      <calendar-body\n' +
    '        options="{initialDate: facilityAssignments.selectedDate, facilityAssignmentsCalendar: true}"\n' +
    '        on-day-selected="facilityAssignments.chooseDate(event, day)"\n' +
    '        can-add-event="facilityAssignments.canAddEvent"\n' +
    '        add-event="facilityAssignments.showWOTDMenu(day)">\n' +
    '      </calendar-body>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </section>\n' +
    '  <div class="calendar-loader" ng-if="facilityAssignments.isLoading">\n' +
    '    <i class="calendar-loader__icon spinner-icon"></i>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/forgot/layout.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/layout.html', '<ui-view class="login__content" />\n' +
    '');
  }]);
angular.module('/app/forgot/request/error.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/request/error.html', '<div class="alert alert-danger alert--callout" role="alert">\n' +
    '	<p class="alert__msg">{{ "ERROR_PASSWORD_RESET_REQUEST" | translate }}</p>\n' +
    '	<div class="alert__action"><a ui-sref="login.forgot.request.form">{{ "RESET_PASSWORD" | translate }}</a></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/forgot/request/form.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/request/form.html', '<form class="login__form" name="forgotRequestCtrl.form" novalidate>\n' +
    '  <h2 class="login__form-title">{{ "RESET_PASSWORD" | translate }}</h2>\n' +
    '  <label class="login__field-title login__field-title--spacer-lg">\n' +
    '    {{ "EMAIL" | translate }}\n' +
    '  </label>\n' +
    '  <input class="login__input" placeholder="example@example.com" autofocus\n' +
    '         type="email"\n' +
    '         ng-model="forgotRequestCtrl.email"\n' +
    '         required />\n' +
    '  <button class="login__submit"\n' +
    '          ng-disabled="forgotRequestCtrl.form.$invalid"\n' +
    '          ng-click="forgotRequestCtrl.submit(forgotRequestCtrl.email)">{{ "CONTINUE" | translate }}\n' +
    '  </button>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/forgot/request/sent.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/request/sent.html', '<form class="login__form" novalidate>\n' +
    '  <h2 class="login__form-title">{{ "RESET_PASSWORD" | translate }}</h2>\n' +
    '  <p>{{ "EMAIL_SENT_TO" | translate }} {{sent.email}}</p>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/forgot/reset/error.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/reset/error.html', '<div class="alert alert-danger alert--callout" role="alert">\n' +
    '	<p class="alert__msg">{{ "ERROR_PASSWORD_RESET" | translate }}</p>\n' +
    '	<div class="alert__action"><a ui-sref="login.forgot.request.form">{{ "RESET_PASSWORD" | translate }}</a></div>\n' +
    '</div>');
  }]);
angular.module('/app/forgot/reset/expired.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/reset/expired.html', '<div class="alert alert-danger alert--callout" role="alert">\n' +
    '	<p class="alert__msg">{{ "ERROR_EXPIRED_PASSWORD_RESET_TOKEN" | translate }}</p>\n' +
    '	<div class="alert__action"><a ui-sref="login.forgot.request.form">{{ "RESET_PASSWORD" | translate }}</a></div>\n' +
    '</div>');
  }]);
angular.module('/app/forgot/reset/form.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/reset/form.html', '<form class="login__form" name="forgotResetCtrl.form" novalidate>\n' +
    '  <h2 class="login__form-title">{{ "RESET_PASSWORD" | translate }}</h2>\n' +
    '  <label class="login__field-title login__field-title--spacer-lg" for="new-password">\n' +
    '    {{ "NEW_PASSWORD" | translate }}\n' +
    '  </label>\n' +
    '  <input id="new-password" class="login__input" placeholder="·······" autofocus\n' +
    '    type="password"\n' +
    '    name="newPassword"\n' +
    '    ng-model="forgotResetCtrl.password"\n' +
    '    ng-minlength="6"\n' +
    '    ng-model-options="{ updateOn: \'blur\' }"\n' +
    '    required />\n' +
    '  <div ng-messages="forgotResetCtrl.form.newPassword.$error">\n' +
    '    <ng-message when="minlength" class="data-block__error">{{\'PASSWORD_MIN_LENGTH\' | translate}}</ng-message>\n' +
    '  </div>\n' +
    '\n' +
    '   <label class="login__field-title login__field-title--spacer-lg" for="new-password-confirmation">\n' +
    '    {{ "CONFIRM_NEW_PASSWORD" | translate }}\n' +
    '  </label>\n' +
    '  <input id="new-password-confirmation" class="login__input" placeholder="·······"\n' +
    '    type="password"\n' +
    '    name="confirmNewPassword"\n' +
    '    ng-model="forgotResetCtrl.passwordConfirmation"\n' +
    '    compare-to="forgotResetCtrl.password"\n' +
    '    ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 100, \'blur\': 0 } }"\n' +
    '    required />\n' +
    '  <div ng-messages="forgotResetCtrl.form.confirmNewPassword.$error">\n' +
    '    <ng-message when="compareTo" class="data-block__error">{{\'PASSWORD_DOES_NOT_MATCH\' | translate}}</ng-message>\n' +
    '  </div>\n' +
    '  \n' +
    '  <button class="login__submit"\n' +
    '          ng-disabled="forgotResetCtrl.form.$invalid"\n' +
    '          ng-click="forgotResetCtrl.submit(forgotResetCtrl.password)">{{ "CONTINUE" | translate }}\n' +
    '  </button>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/forgot/reset/invalid.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/reset/invalid.html', '<div class="alert alert-danger alert--callout" role="alert">\n' +
    '	<p class="alert__msg">{{ "ERROR_INVALID_PASSWORD_RESET_TOKEN" | translate }}</p>\n' +
    '	<div class="alert__action"><a ui-sref="login.forgot.request.form">{{ "RESET_PASSWORD" | translate }}</a></div>\n' +
    '</div>');
  }]);
angular.module('/app/forgot/reset/success.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/forgot/reset/success.html', '<div class="login__form">\n' +
    '  <h2 class="login__form-title">{{ "SUCCESS" | translate }}</h2>\n' +
    '  <p>{{ "PASSWORD_RESET_SUCCESS" | translate }}</p>\n' +
    '  <button ui-sref="login.form" class="login__submit">{{ "LOGIN" | translate }}\n' +
    '  </button>\n' +
    '</div>');
  }]);
angular.module('/app/layout/layout.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/layout/layout.html', '<div class="main-container">\n' +
    '  <pt-crm-header></pt-crm-header>\n' +
    '  <pt-crm-left-menu></pt-crm-left-menu>\n' +
    '  <div class="container">\n' +
    '    <div ui-view class=\'container-view fade-onload\'></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/assignment-workflow/create-assignment.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/assignment-workflow/create-assignment.html', '<section class="workflow">\n' +
    '  <div class="workflow__header">\n' +
    '    <div class="workflow__header-title">\n' +
    '        {{ (!createWorkflowCtrl.isEdit ? \'CREATE_TRAINING_PROGRAM\' : \'UPDATE_TRAINING_PROGRAM\' )| translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="workflow__workflow-bar">\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': createWorkflowCtrl.currentTab === \'assignmentType\'}">\n' +
    '      {{\'ASSIGNMENT_TYPE\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': createWorkflowCtrl.currentTab === \'chooseClient\'}">\n' +
    '      {{\'CHOOSE_CLIENTS\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': createWorkflowCtrl.currentTab === \'selectTime\'}">\n' +
    '      {{\'SELECT_TIME_FRAME\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': createWorkflowCtrl.currentTab === \'sessionSetup\'}">\n' +
    '      {{\'SETUP\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': createWorkflowCtrl.currentTab === \'reviewSave\'}">\n' +
    '      {{\'REVIEW_SAVE\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="workflow__workflow-tab">\n' +
    '    <assignment-type ng-if="createWorkflowCtrl.currentTab === \'assignmentType\'"\n' +
    '      type="createWorkflowCtrl.assignmentType"\n' +
    '      name="createWorkflowCtrl.assignmentName"\n' +
    '      saved-plan="createWorkflowCtrl.selectedSavedTrainingPlan"\n' +
    '      on-type-update="createWorkflowCtrl.changeAssignmentType($event)"\n' +
    '      on-tab-advance="createWorkflowCtrl.changeAssignmentCreationTab($event)"\n' +
    '      on-name-update="createWorkflowCtrl.changeAssignmentName($event)"\n' +
    '      on-plan-update="createWorkflowCtrl.changeSelectedSavedTrainingPlan($event)"\n' +
    '      is-edit="createWorkflowCtrl.isEdit"\n' +
    '      is-copy="createWorkflowCtrl.isCopy"\n' +
    '    >\n' +
    '    </assignment-type>\n' +
    '    <select-time-frame ng-if="createWorkflowCtrl.currentTab === \'selectTime\'"\n' +
    '      on-tab-change="createWorkflowCtrl.changeAssignmentCreationTab($event)"\n' +
    '      on-start-date-change="createWorkflowCtrl.changeStartDate($event)"\n' +
    '      start-date="createWorkflowCtrl.startDate"\n' +
    '      end-date="createWorkflowCtrl.endDate"\n' +
    '      on-end-date-change="createWorkflowCtrl.changeEndDate($event)"\n' +
    '      training-sessions="createWorkflowCtrl.trainingSessions"\n' +
    '      on-training-sessions-change="createWorkflowCtrl.changeTrainingSessions($event)"\n' +
    '      weeks="createWorkflowCtrl.weeks"\n' +
    '      on-weeks-change="createWorkflowCtrl.changeWeeks($event)"\n' +
    '      type="createWorkflowCtrl.assignmentType"\n' +
    '      disable-time-changes="!createWorkflowCtrl.canEditTimes"\n' +
    '      is-edit="createWorkflowCtrl.isEdit"\n' +
    '    >\n' +
    '    </select-time-frame>\n' +
    '    <choose-client ng-if="createWorkflowCtrl.currentTab === \'chooseClient\'"\n' +
    '      on-tab-change="createWorkflowCtrl.changeAssignmentCreationTab($event)"\n' +
    '      on-trainer-change="createWorkflowCtrl.changeTrainer($event)"\n' +
    '      trainer="createWorkflowCtrl.trainer"\n' +
    '      on-exercisers-change="createWorkflowCtrl.changeExercisers($event)"\n' +
    '      exercisers="createWorkflowCtrl.exercisers"\n' +
    '    >\n' +
    '    </choose-client>\n' +
    '    <session-setup-customize ng-if="createWorkflowCtrl.currentTab === \'sessionSetup\'"\n' +
    '     on-tab-change="createWorkflowCtrl.changeAssignmentCreationTab($event)"\n' +
    '     training-sessions="createWorkflowCtrl.trainingSessions"\n' +
    '     training-plan-exercises="createWorkflowCtrl.trainingPlansExercise"\n' +
    '     on-training-plans-exercise-change="createWorkflowCtrl.changeTrainingPlansExercise($event)"\n' +
    '     type="createWorkflowCtrl.assignmentType"\n' +
    '    >\n' +
    '    </session-setup-customize>\n' +
    '    <review-save ng-if="createWorkflowCtrl.currentTab === \'reviewSave\'"\n' +
    '      type="createWorkflowCtrl.assignmentType"\n' +
    '      name="createWorkflowCtrl.assignmentName"\n' +
    '      start-date="createWorkflowCtrl.startDate"\n' +
    '      end-date="createWorkflowCtrl.endDate"\n' +
    '      weeks="createWorkflowCtrl.weeks"\n' +
    '      clients="createWorkflowCtrl.exercisers"\n' +
    '      training-sessions="createWorkflowCtrl.trainingSessions"\n' +
    '      exercises="createWorkflowCtrl.trainingPlansExercise"\n' +
    '      weeks="createWorkflowCtrl.weeks"\n' +
    '      on-tab-change="createWorkflowCtrl.changeAssignmentCreationTab($event)"\n' +
    '      on-save-training-plan="createWorkflowCtrl.saveTrainingPlan()"\n' +
    '      on-save="createWorkflowCtrl.save()"\n' +
    '      save-training-plan-loading="createWorkflowCtrl.savingSavedTrainingPlan"\n' +
    '      training-plan-loading="createWorkflowCtrl.savingTrainingPlan"\n' +
    '      on-pdf-request="createWorkflowCtrl.showPDF()"\n' +
    '    ></review-save>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/choose-assignment-edit-mode.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/choose-assignment-edit-mode.html', '<ul class="modal__list-wrapper">\n' +
    '    <li class="modal__list-item"\n' +
    '        ng-click="isLoading || editAssignment(null, stateParams, ok)"\n' +
    '        ng-class="{ \'modal__list-item-disabled\': isLoading }">\n' +
    '        <div>\n' +
    '            {{ :: "EDIT_INDIVIDUAL_OCCURRENCE" | translate}}\n' +
    '            <div class="pull-right spinner-icon__small"\n' +
    '                ng-if="isLoading && editType === \'SINGLE\'">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '    <li class="modal__list-item"\n' +
    '        ng-click="isLoading || editAssignment(true, stateParams, ok)"\n' +
    '        ng-class="{ \'modal__list-item-disabled\': isLoading }">\n' +
    '        <div>\n' +
    '            {{ :: "EDIT_SERIES" | translate}}\n' +
    '            <div class="pull-right spinner-icon__small"\n' +
    '                ng-if="isLoading && editType === \'SERIES\'">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/create-assignment.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/create-assignment.html', '<section class="create-assignment" ng-form="createCtrl.assignmentForm" novalidate>\n' +
    '  <header class="create-assignment__header">\n' +
    '    <!--TODO: calculate needConfirmation programmly-->\n' +
    '    <span class="back-button"\n' +
    '      need-confirmation="true"></span>\n' +
    '    <h1 class="create-assignment__header-title">\n' +
    '      {{ :: createCtrl.isEdit ? \'BACK\' : \'CREATE_NEW_ASSIGNMENT\' | translate}}\n' +
    '    </h1>\n' +
    '\n' +
    '    <workout-name\n' +
    '      workout-name="{{createCtrl.name}}"\n' +
    '      on-name-update="createCtrl.handleNameChange($event)"\n' +
    '    ></workout-name>\n' +
    '\n' +
    '    <div class="button button-assertive pull-right exercise-delete-btn set-delete-btn"\n' +
    '      permission\n' +
    '      permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_DELETE\'"\n' +
    '      ng-if="createCtrl.isEdit"\n' +
    '      ng-click="createCtrl.remove()">\n' +
    '      <span class="button__icon button__icon--delete-exercise"></span>\n' +
    '      {{ :: createCtrl.allowEditingSeries ? \'DELETE_SERIES\' : \'DELETE_ASSIGNMENT\' | translate }}\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="create-assignment__content">\n' +
    '\n' +
    '    <tabs theme="dark">\n' +
    '      <tab>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ createCtrl.selectedClients.length }} {{ :: \'CLIENTS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include src="\'/app/library/create-assignment/tabs/personnel.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab name="time-select" is-disabled="!createCtrl.isRequiredDataFilled()"\n' +
    '        select=\'createCtrl.activateDateTab() && createCtrl.navigateToDateTab()\'>\n' +
    '\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-if="!createCtrl.isDateTabWasActivated">\n' +
    '            {{ :: \'PICK_DATE_TIME\' | translate }}\n' +
    '          </span>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-if="createCtrl.isDateTabWasActivated">\n' +
    '            {{ createCtrl.parseDate() }}\n' +
    '            <span class="create-assignment__dark-text"\n' +
    '              ng-if="createCtrl.canPickTime && createCtrl.startDate">\n' +
    '              <br/>\n' +
    '              <span class="text-timestamp">{{ createCtrl.parseTime(createCtrl.startDate) }}</span>\n' +
    '              <span ng-show="createCtrl.endDate">\n' +
    '                -\n' +
    '                <span class="text-timestamp">{{ createCtrl.parseTime(createCtrl.endDate) }}</span>\n' +
    '              </span>\n' +
    '            </span>\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include ng-if="createCtrl.isDateTabWasActivated" src="\'/app/library/create-assignment/tabs/date.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '\n' +
    '\n' +
    '      <!--================== CHOOSE EXERCISE ===============-->\n' +
    '      <tab is-disabled="!createCtrl.isRequiredDataFilled()"\n' +
    '        select=\'createCtrl.activateExerciseTab()\'>\n' +
    '\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-if="!createCtrl.isExerciseTabWasSelected">\n' +
    '            {{ :: \'CHOOSE_EXERCISE\' | translate }}\n' +
    '          </span>\n' +
    '          <span ng-if="createCtrl.isExerciseTabWasSelected">\n' +
    '            {{createCtrl.selectedExercises.length}} {{ :: \'EXERCISES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include ng-if="createCtrl.isRequiredDataFilled() && createCtrl.isExerciseTabWasSelected" src="\'/app/library/create-assignment/tabs/exercise.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--========= Exercises Profile===========-->\n' +
    '      <tab is-disabled="!createCtrl.selectedExercises.length"\n' +
    '        select=\'createCtrl.activateExerciseProfileTab()\'\n' +
    '      >\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_PROFILES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '                      src="\'/app/library/create-assignment/tabs/exercise-profile.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <li class="tab-head__item tab-action tab-head__item--right"\n' +
    '        ng-class="{\'tab-head__item--disabled\': !createCtrl.isAssignmentReadyToSave() || createCtrl.isLoading }"\n' +
    '        ng-click="createCtrl.checkErrors()"\n' +
    '        ng-if="!createCtrl.recurrence || createCtrl.recurrence.recurrenceType === \'once\' || !createCtrl.allowEditingSeries">\n' +
    '        <span class="tab-head__multiline-item">\n' +
    '          {{ :: createCtrl.isEdit ? \'EDIT_ASSIGNMENT\' : \'CREATE_WORKOUT\' | translate }}\n' +
    '        </span>\n' +
    '      </li>\n' +
    '      <li class="tab-head__item tab-action tab-head__item--right"\n' +
    '        ng-class="{\'tab-head__item--disabled\': !createCtrl.isAssignmentReadyToSave() || createCtrl.isLoading }"\n' +
    '        ng-click="createCtrl.checkErrors()"\n' +
    '        ng-if="createCtrl.recurrence && createCtrl.recurrence.recurrenceType !== \'once\' && createCtrl.allowEditingSeries">\n' +
    '        <span class="tab-head__multiline-item">\n' +
    '          {{ :: createCtrl.isEdit ? \'EDIT_SERIES\' : \'CREATE_SERIES\' | translate }}\n' +
    '        </span>\n' +
    '      </li>\n' +
    '\n' +
    '      <tab class=\'tab-assertive button-clear\'\n' +
    '        is-button="true"\n' +
    '        ng-hide="createCtrl.isEdit">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ui-sref="app.dashboard">\n' +
    '            {{ :: \'CANCEL_WORKOUT\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '    </tabs>\n' +
    '\n' +
    '  </section>\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/tabs/date.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/tabs/date.html', '<div class="date-tab">\n' +
    '  <div class="date-tab__bar">\n' +
    '    <span class="date-tab__bar-text">{{\'DATE\' | translate}}</span>\n' +
    '    <span class="date-tab__bar-text date-tab__bar-text--time"\n' +
    '          ng-if="createCtrl.canPickTime">\n' +
    '      {{\'TIME\' | translate}}\n' +
    '    </span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="date-tab__picker-wrapper date-tab__scrolling-datepicker-wrapper">\n' +
    '    <scrolling-datepicker\n' +
    '      start-moment="createCtrl.startDateStart"\n' +
    '      end-moment="createCtrl.endDateEnd"\n' +
    '    ></scrolling-datepicker>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="date-tab__picker-wrapper">\n' +
    '    <tabs class="date-tab__picker-tabs tabs--short tabs--fit">\n' +
    '      <tab name="datetime-schedule" is-disabled="!createCtrl.canPickTime">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '              {{\'TIME\' | translate}}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <timepicker clients="createCtrl.timelineClients"\n' +
    '            selected-clients="createCtrl.timelineSelectedClients"\n' +
    '            edit-assign="createCtrl.activeAssignment"\n' +
    '            on-set-all-day="createCtrl.setAllDay()"\n' +
    '            on-time-range-select="createCtrl.navigateToDateTimeDetails()"\n' +
    '            on-show-time-details="createCtrl.navigateToDateTimeDetails()"\n' +
    '            start-time="createCtrl.startDate"\n' +
    '            end-time="createCtrl.endDate"\n' +
    '            date="createCtrl.startDateStart"\n' +
    '            allow-overlap="true"\n' +
    '            trainer-work-info="createCtrl.selectedTrainerWorkInfo">\n' +
    '          </timepicker>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab name="datetime-details">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{\'DETAILS\' | translate}}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <datetime-details\n' +
    '            start-date="createCtrl.startDateStart"\n' +
    '            end-date="createCtrl.endDateEnd"\n' +
    '            start-time="createCtrl.startDate"\n' +
    '            end-time="createCtrl.endDate"\n' +
    '            disable-recurrence="createCtrl.isEdit && !createCtrl.recurrence.recurrenceIdx"\n' +
    '            recurrence="createCtrl.recurrence"\n' +
    '            recurrence-options="createCtrl.recurrenceOptions"\n' +
    '            time-duration-options="createCtrl.timeDurationOptions"\n' +
    '            time-duration-option-validator="createCtrl.validateDurationOption"\n' +
    '            is-editing-individual-recurrence="createCtrl.isEdit && createCtrl.recurrence.recurrenceIdx && !createCtrl.allowEditingSeries"\n' +
    '            on-edit-series="createCtrl.goEditSeries()"\n' +
    '          ></datetime-details>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '    </tabs>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/tabs/exercise-profile.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/tabs/exercise-profile.html', '<div class="create-exercise__customize">\n' +
    '  <pt-items-switcher\n' +
    '    selected-items="createCtrl.selectedExercises"\n' +
    '    bag-type="workoutAssignmentOther",\n' +
    '    on-index-update = "createCtrl.setActiveExerciseIndex(newIndex)">\n' +
    '  </pt-items-switcher>\n' +
    '  <div class="exercise-profile">\n' +
    '    <customize-exercise\n' +
    '      exercise=\'createCtrl.selectedExercises[createCtrl.activeExerciseIndex]\'\n' +
    '      on-update=\'createCtrl.handleExerciseUpdate($event)\'\n' +
    '      context=\'assignment\'>\n' +
    '    </customize-exercise>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/tabs/exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/tabs/exercise.html', '<pt-items-selector\n' +
    '  items-lists="[ createCtrl.exercises, createCtrl.trainingSets ]"\n' +
    '  selected-items="createCtrl.selectedExercises"\n' +
    '  id="createCtrl.set._id"\n' +
    '  hide-print-icon="true"\n' +
    '  get-item-params="createCtrl.getExercisesParams"\n' +
    '  get-load-params="createCtrl.getExerciseLoadParams"\n' +
    '  item-type="exercises"\n' +
    '  bag-type="trainingSets"\n' +
    '  drag-copy="true">\n' +
    '</pt-items-selector>\n' +
    '');
  }]);
angular.module('/app/library/create-assignment/tabs/personnel.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/create-assignment/tabs/personnel.html', '<div class="user-tab__container">\n' +
    '  <div class="user-tab__selected-container">\n' +
    '    <div class="user-tab__selected-container-section">\n' +
    '      {{ \'TRAINER\' | translate}}\n' +
    '    </div>\n' +
    '    <user-card\n' +
    '      class="user-tab__selected-trainer"\n' +
    '      user="createCtrl.selectedTrainers[0]"\n' +
    '      moveable="false"\n' +
    '      arrow="createCtrl.trainerDropdown ? \'up\' : \'down\'"\n' +
    '      ng-click="createCtrl.toggleTrainerDropdown()"\n' +
    '    ></user-card>\n' +
    '    <div class="user-tab__trainer-dropdown" ng-if="createCtrl.trainerDropdown">\n' +
    '      <library-search>\n' +
    '        <div class="library-search">\n' +
    '          <div class="library-search__icon"></div>\n' +
    '          <input type="text"\n' +
    '            class="library-search__input"\n' +
    '            placeholder="{{ :: \'SEARCH\' | translate }}"\n' +
    '            ng-model-options="{ debounce: 500 }"\n' +
    '            ng-model="createCtrl.trainerSearch"\n' +
    '            ng-change="createCtrl.loadTrainers(true)">\n' +
    '          <search-clearer\n' +
    '            search-term="createCtrl.trainerSearch"\n' +
    '            refresh-fn="createCtrl.loadTrainers(true)">\n' +
    '          </search-clearer>\n' +
    '        </div>\n' +
    '      </library-search>\n' +
    '      <user-card\n' +
    '        class="user-tab__selected-trainer"\n' +
    '        user="trainer"\n' +
    '        ng-repeat="trainer in createCtrl.trainers.items track by trainer._id"\n' +
    '        ng-click="createCtrl.changeTrainer(trainer)"\n' +
    '      ></user-card>\n' +
    '    </div>\n' +
    '    <div class="user-tab__selected-container-section" ng-if="!createCtrl.trainerDropdown">\n' +
    '      {{ \'CLIENTS\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="user-tab__selected-users" ng-if="!createCtrl.trainerDropdown">\n' +
    '      <div class="user-tab__user-placeholder" ng-if="!createCtrl.selectedClients.length">\n' +
    '        <i class="icon icon-info_outline user-tab__user-placeholder-icon"></i>\n' +
    '        {{ \'CLICK_TO_ADD_USERS\' | translate }}\n' +
    '      </div>\n' +
    '      <user-card class="user-tab__selected-user"\n' +
    '        user="client"\n' +
    '        moveable="false"\n' +
    '        ng-click="createCtrl.removeClient($index)"\n' +
    '        ng-repeat="client in createCtrl.selectedClients track by client._id">\n' +
    '      </user-card>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="user-tab__client-container">\n' +
    '    <library-search>\n' +
    '      <div class="library-search">\n' +
    '        <div class="library-search__icon"></div>\n' +
    '        <input type="text"\n' +
    '          class="library-search__input"\n' +
    '          placeholder="{{\'SEARCH\' |translate}}"\n' +
    '          ng-model-options="{ debounce: 500 }"\n' +
    '          ng-model="createCtrl.clientSearch"\n' +
    '          ng-change="createCtrl.loadClients(true)">\n' +
    '        <search-clearer\n' +
    '          search-term="createCtrl.clientSearch"\n' +
    '          refresh-fn="createCtrl.loadClients(true)">\n' +
    '        </search-clearer>\n' +
    '      </div>\n' +
    '    </library-search>\n' +
    '\n' +
    '\n' +
    '    <div class="user-tab__users"\n' +
    '      infinite-scroll=\'createCtrl.loadClients()\'\n' +
    '      can-load=\'createCtrl.clients.nextPage\'\n' +
    '      threshold=\'30\'\n' +
    '      ng-click="createCtrl.trainerDropdown && createCtrl.toggleTrainerDropdown()">\n' +
    '\n' +
    '      <user-card class="user-tab__user"\n' +
    '        ng-class="{\n' +
    '          \'user-tab__user--selected\': createCtrl.clientIsSelected(client._id),\n' +
    '          \'user-tab__user--disabled\': createCtrl.trainerDropdown\n' +
    '        }"\n' +
    '        user="client"\n' +
    '        moveable="false"\n' +
    '        ng-repeat="client in createCtrl.clients.items track by client._id"\n' +
    '        ng-click="createCtrl.clientIsSelected(client._id) ? createCtrl.removeClientById(client._id) : createCtrl.addClient(client)">\n' +
    '      </user-card>\n' +
    '\n' +
    '      <div class=\'user-tab__no-users\'\n' +
    '        ng-if=\'!createCtrl.clients.items.length && !createCtrl.clients.nextPage\'>\n' +
    '        {{ "NO_CLIENTS" | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class=\'roster-load-more\' ng-if=\'createCtrl.clients.nextPage\'>\n' +
    '        <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '        {{ \'LOADING_MORE_CLIENTS\' | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/exercise/exercise.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/exercise/exercise.html', '<section class="create-exercise">\n' +
    '  <header class="create-exercise__header">\n' +
    '    <a class="back-button" need-confirmation="true"></a>\n' +
    '    <h1 class="create-exercise__header-title"\n' +
    '        ng-if="exerciseCtrl.isEdit ">\n' +
    '      {{ :: \'EDIT\' | translate}} {{ exerciseCtrl.exercise.title }}\n' +
    '    </h1>\n' +
    '    <h1 class="create-exercise__header-title"\n' +
    '      ng-if="!exerciseCtrl.isEdit ">\n' +
    '      {{ :: \'CREATE_NEW_EXERCISE\' | translate}}\n' +
    '    </h1>\n' +
    '    <div class="button button-assertive pull-right exercise-delete-btn"\n' +
    '         permission\n' +
    '         permission-only="exerciseCtrl.exercise.restricted ?\n' +
    '            \'EXERCISES_DELETE+RESTRICTED_FLAG_DELETE\' : \'EXERCISES_DELETE\'"\n' +
    '         ng-if="exerciseCtrl.isEdit"\n' +
    '         ng-click="exerciseCtrl.deleteExercise()">\n' +
    '      <span class="button__icon button__icon--delete-exercise"></span>\n' +
    '      {{ \'DELETE_EXERCISE\' | translate }}\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="create-exercise__content">\n' +
    '\n' +
    '    <tabs theme="dark">\n' +
    '      <tab>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'CHOOSE_EQUIPMENT_TYPE\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/library/exercise/tabs/choose-equip.html\'" class="create-exercise__equipments"></div>\n' +
    '        </tab-content>\n' +
    '\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab is-disabled=\'!exerciseCtrl.selectedEquipment\'>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_PROFILE\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <customize-exercise\n' +
    '            exercise="exerciseCtrl.exercise"\n' +
    '            on-update="exerciseCtrl.handleExerciseUpdate($event)"\n' +
    '            context="exercise">\n' +
    '          </customize-exercise>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab is-disabled=\'!exerciseCtrl.selectedEquipment\'>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_DETAILS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/library/exercise/tabs/details.html\'"></div>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab is-disabled=\'!exerciseCtrl.selectedEquipment\'>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_IMAGE\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/library/exercise/tabs/multimedia.html\'" class="create-exercise-image"></div>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab class=\'tab-action\'\n' +
    '        is-button="true">\n' +
    '        <tab-head\n' +
    '          ng-class="{\'create-exercise__tab-title--disabled\': exerciseCtrl.isLoading}"\n' +
    '          ng-click="exerciseCtrl.createExercise()">\n' +
    '          <span class="tab-head__multiline-item tab-head__item--save">\n' +
    '            <i class="create-exercise__tab-title-icon spinner-icon" ng-if="exerciseCtrl.isLoading"></i>\n' +
    '            {{ exerciseCtrl.isEdit ? \'SAVE_CHANGES\' : \'CREATE_EXERCISE\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab class=\'tab-assertive button-clear\'\n' +
    '        is-button="true">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-click="exerciseCtrl.cancelExercise()">\n' +
    '            {{ :: \'CANCEL\' | translate}}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '    </tabs>\n' +
    '\n' +
    '  </section>\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/exercise/tabs/choose-equip.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/exercise/tabs/choose-equip.html', '<div class="create-exercise__equipment"\n' +
    '  ng-class="{\'create-exercise__equipment--active\': exerciseCtrl.isActiveEquipment(equipment)}"\n' +
    '  ng-repeat="equipment in exerciseCtrl.equipmentPresets"\n' +
    '  ng-click="exerciseCtrl.selectEquipment(equipment, true)">\n' +
    '  <img class="create-exercise__equipment-img"\n' +
    '    ng-src="{{ equipment.pictureUrl }}">\n' +
    '  <div class=\'create-exercise__equipment-content\'>\n' +
    '    <div class="create-exercise__equipment-type">{{ (equipment.equipmentType || equipment.category) | uppercase | translate }}</div>\n' +
    '    <div class="create-exercise__equipment-program"> {{ equipment.title }}</div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/exercise/tabs/details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/exercise/tabs/details.html', '<!--<div>-->\n' +
    '  <!--<input class=\'create-exercise-details__title\'-->\n' +
    '         <!--type=\'text\'-->\n' +
    '         <!--ng-model=\'exerciseCtrl.exerciseTitle\'-->\n' +
    '         <!--placeholder=\'{{ "EXERCISE_TITLE" | translate }}\'/>-->\n' +
    '\n' +
    '  <!--<label for="create-exercise-details__description"-->\n' +
    '    <!--class="create-exercise-details__description-title">-->\n' +
    '    <!--{{\'EXERCISE_DESCRIPTION\'| translate}}-->\n' +
    '  <!--</label>-->\n' +
    '  <!--<textarea class="create-exercise-details__description"-->\n' +
    '    <!--id="create-exercise-details__description"-->\n' +
    '    <!--ng-model="exerciseCtrl.exerciseDescription">-->\n' +
    '  <!--</textarea>-->\n' +
    '\n' +
    '<!--</div>-->\n' +
    '<pt-exercise-item-details\n' +
    '  item="exerciseCtrl.details"\n' +
    '  type="exercises"\n' +
    '></pt-exercise-item-details>\n' +
    '\n' +
    '<div class="create-exercise-details__tags create-exercise-dropdown">\n' +
    '  <div>{{ \'TAGS\' | translate }}</div>\n' +
    '\n' +
    '  <!-- This select does not allow tag creation -->\n' +
    '  <ui-select\n' +
    '    ng-if="!exerciseCtrl.tagCreatePermission"\n' +
    '    ng-disabled="!exerciseCtrl.tagUpdatePermission"\n' +
    '    multiple\n' +
    '    ng-model="exerciseCtrl.exerciseTags"\n' +
    '    close-on-select="false"\n' +
    '  >\n' +
    '    <ui-select-match\n' +
    '      ui-lock-choice="!exerciseCtrl.tagDeletePermission"\n' +
    '      placeholder="+"\n' +
    '    >\n' +
    '    <span>\n' +
    '      {{$item.tag}}\n' +
    '    </span>\n' +
    '    </ui-select-match>\n' +
    '    <ui-select-choices repeat="tag in exerciseCtrl.availableTags | filter: $select.search">\n' +
    '      <span>\n' +
    '        {{tag.tag}}\n' +
    '      </span>\n' +
    '    </ui-select-choices>\n' +
    '  </ui-select>\n' +
    '\n' +
    '  <!-- This select allows tag creation -->\n' +
    '  <ui-select\n' +
    '    ng-if="exerciseCtrl.tagCreatePermission"\n' +
    '    ng-disabled="!exerciseCtrl.tagUpdatePermission"\n' +
    '    multiple\n' +
    '    tagging="exerciseCtrl.createTagObject"\n' +
    '    tagging-label="false"\n' +
    '    ng-model="exerciseCtrl.exerciseTags"\n' +
    '    close-on-select="false"\n' +
    '  >\n' +
    '    <ui-select-match\n' +
    '      ui-lock-choice="!exerciseCtrl.tagDeletePermission"\n' +
    '      placeholder="+"\n' +
    '    >\n' +
    '    <span>\n' +
    '      {{$item.tag}}\n' +
    '    </span>\n' +
    '    </ui-select-match>\n' +
    '    <ui-select-choices repeat="tag in exerciseCtrl.availableTags | filter: $select.search">\n' +
    '      <span>\n' +
    '        {{tag.tag}}\n' +
    '      </span>\n' +
    '    </ui-select-choices>\n' +
    '  </ui-select>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/exercise/tabs/multimedia.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/exercise/tabs/multimedia.html', '<exercise-media\n' +
    '  images="exerciseCtrl.exerciseImages"\n' +
    '  video="exerciseCtrl.exerciseVideo"\n' +
    '  on-update="exerciseCtrl.handleMediaUpdate($event)"\n' +
    '></exercise-media>\n' +
    '');
  }]);
angular.module('/app/library/library.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/library.html', '<section class="training-library">\n' +
    '\n' +
    '  <!--================ HEADER WITH BUTTONS ================-->\n' +
    '  <header\n' +
    '    class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-books"></i>\n' +
    '      <h1 class="container-header__title">{{:: \'TRAINING_LIBRARY\' | translate}}</h1>\n' +
    '\n' +
    '      <div class="button-toolbar pull-right">\n' +
    '        <div class="button button-action box"\n' +
    '          permission\n' +
    '          permission-only="\'EXERCISES_CREATE\'"\n' +
    '          ui-sref="app.library.exercise">\n' +
    '          <span class="button__icon button__icon--add-exercise"></span>\n' +
    '          <span class="toggle-shrink"> {{ :: \'NEW_EXERCISE\' | translate }} </span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="button button-action"\n' +
    '          permission\n' +
    '          permission-only="\'TRAINING_SETS_CREATE\'"\n' +
    '          ui-sref="app.library.set">\n' +
    '          <span class="button__icon button__icon--add-assignment"></span>\n' +
    '          <span class="toggle-shrink">{{ :: \'NEW_TRAINING_SET\' | translate }}</span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="button button-action"\n' +
    '          permission\n' +
    '          permission-only="\'SAVED_TRAINING_PLANS_CREATE\'"\n' +
    '          ui-sref="app.library.training_program_template">\n' +
    '          <span class="button__icon button__icon--add-training-plan"></span>\n' +
    '          <span class="toggle-shrink">{{ :: \'NEW_TRAINING_PROGRAM_TEMPLATE\' | translate }}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '  </header>\n' +
    '\n' +
    '\n' +
    '  <!-- ============== SEARCH   ==========-->\n' +
    '  <!-- Only exercise read permission -> search works only for exercises-->\n' +
    '  <div permission\n' +
    '    permission-only="\'EXERCISES_READ\'">\n' +
    '    <div class="library-search">\n' +
    '      <div class="library-search__icon"></div>\n' +
    '      <input type="text"\n' +
    '        class="library-search__input"\n' +
    '        placeholder="{{ :: \'SEARCH\' | translate }}"\n' +
    '        ng-model="library.search"\n' +
    '        ng-model-options="{debounce: 500}"\n' +
    '        ng-change="library.filterByName(library.activeTab)">\n' +
    '      <search-clearer\n' +
    '        search-term="library.search"\n' +
    '        refresh-fn="library.filterByName()">\n' +
    '      </search-clearer>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!--================= TABS FOR SETS AND EXERCISES ========== -->\n' +
    '  <tabs class="training-library__tabs">\n' +
    '\n' +
    '    <!--========= EXERCISES ===========-->\n' +
    '    <tab permission\n' +
    '      permission-only="\'EXERCISES_READ\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '      name="exercises"\n' +
    '      select="library.showTab(\'EXERCISES\')">\n' +
    '      <tab-head>\n' +
    '          <span class="button__icon button__icon--exercise training-library__icon--add-exercise"></span>\n' +
    '          <span class="toggle-shrink">\n' +
    '            {{ :: \'EXERCISES\' | translate }}\n' +
    '          </span>\n' +
    '      </tab-head>\n' +
    '    </tab>\n' +
    '\n' +
    '    <!--========= TRAINING_SETS ===========-->\n' +
    '    <tab permission\n' +
    '      permission-only="\'TRAINING_SETS_READ\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '      name="training-sets"\n' +
    '      select="library.showTab(\'TRAINING_SETS\')">\n' +
    '      <tab-head>\n' +
    '          <span class="button__icon button__icon--assignment training-library__icon--add-assignment"></span>\n' +
    '          <span class="toggle-shrink">\n' +
    '            {{ :: \'TRAINING_SETS\' | translate }}\n' +
    '          </span>\n' +
    '      </tab-head>\n' +
    '    </tab>\n' +
    '\n' +
    '    <!--========= TRAINING_PROGRAMS ===========-->\n' +
    '    <tab permission\n' +
    '         permission-only="\'SAVED_TRAINING_PLANS_READ\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '      name="training-programs"\n' +
    '      select="library.showTab(\'TRAINING_PROGRAMS\')">\n' +
    '      <tab-head>\n' +
    '          <span class="button__icon button__icon--training-library training-library__icon--add-training-program"></span>\n' +
    '          <span class="toggle-shrink">\n' +
    '            {{ :: \'TRAINING_PROGRAMS\' | translate }}\n' +
    '          </span>\n' +
    '      </tab-head>\n' +
    '    </tab>\n' +
    '  </tabs>\n' +
    '\n' +
    '  <ng-include permission\n' +
    '    permission-only="[\'EXERCISES_READ\', \'TRAINING_SETS_READ\', \'WORKOUT_ASSIGNMENTS_OTHER_CREATE\', \'SAVED_TRAINING_PLANS_CREATE\']"\n' +
    '    src="\'/app/library/tabs/list.html\'">\n' +
    '  </ng-include>\n' +
    '\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/tabs/list.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/tabs/list.html', '<section class="exercise-tab">\n' +
    '  <!-- ============== TRAINING SETS ==========-->\n' +
    '  <div class="training-library__tabs-content"\n' +
    '    ng-if="library.activeTab === \'TRAINING_SETS\'">\n' +
    '\n' +
    '    <div class="exercise-tab__exercises"\n' +
    '      ng-init="library.trainingSets.load()"\n' +
    '      permission\n' +
    '      permission-only="\'TRAINING_SETS_READ\'"\n' +
    '      infinite-scroll="library.trainingSets.load()"\n' +
    '      can-load="library.trainingSets.nextPage"\n' +
    '      threshold="250">\n' +
    '\n' +
    '      <div class="library-cards">\n' +
    '\n' +
    '        <library-card\n' +
    '          ng-repeat="set in library.trainingSets.items"\n' +
    '          exercise="set"\n' +
    '          type="trainingSets"\n' +
    '          data="set"\n' +
    '          on-edit-card="library.editTrainingSet(set)"\n' +
    '          on-print-card="library.printTrainingSet(set)"\n' +
    '          edit-permission="library.getCardPermission(set, \'TRAINING_SETS\', \'UPDATE\')"\n' +
    '          delete-permission="library.getCardPermission(set, \'TRAINING_SETS\', \'DELETE\')"\n' +
    '          hide-print-icon="!set.exercises.length">\n' +
    '        </library-card>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="client-item--empty"\n' +
    '        ng-if=\'!library.trainingSets.items.length && !library.trainingSets.nextPage\'>\n' +
    '        {{ :: "NO_TRAINING_SETS" | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="roster-load-more" ng-if="library.trainingSets.nextPage">\n' +
    '        <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '        {{ :: \'LOADING_MORE_TRAINING_SETS\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- ============== EXERCISES ==========-->\n' +
    '  <div class="training-library__tabs-content"\n' +
    '    ng-if="library.activeTab === \'EXERCISES\'">\n' +
    '    <!--================= TAB FILTERING BAR ========== -->\n' +
    '    <div class="training-library__tags-bar">\n' +
    '      <!-- Exercises bar -->\n' +
    '      <div class="training-library__tags-item"\n' +
    '        ng-class="{\'training-library__tags-item--selected\': library.selectedTagList.length === 0}"\n' +
    '        ng-click="library.setFilterTag(\'allExercises\')">\n' +
    '        {{ :: \'ALL_EXERCISES\' | translate }}\n' +
    '        <span class="training-library__tags-item-count">({{library.allExercises.items.length}})</span>\n' +
    '      </div>\n' +
    '      <div ng-repeat="tag in library.buttonTags"\n' +
    '        class="training-library__tags-item"\n' +
    '        ng-click="library.setFilterTag(tag)"\n' +
    '        ng-class="{\'training-library__tags-item--selected\': library.checkIfTabIsSelected(tag)}"\n' +
    '        >\n' +
    '        {{tag.tag}}\n' +
    '        <span class="training-library__tags-item-count">({{tag.exerciseCount}})</span>\n' +
    '      </div>\n' +
    '      <div ng-if="library.dropdownTags.length > 0"\n' +
    '        class="training-library__tags-dropdown-button"\n' +
    '        ng-click="library.toggleShowDropdown()"\n' +
    '        >\n' +
    '        {{ :: \'MORE_TAGS\' | translate }}\n' +
    '        <div class="training-library__tags-item-dropdown-icon"\n' +
    '\n' +
    '        ng-class="{\'training-library__tags-item-dropdown-icon--up\': library.showDropdown}"></div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="library.showDropdown"\n' +
    '      class="training-library__tags-dropdown-container">\n' +
    '      <div ng-repeat="tag in library.dropdownTags"\n' +
    '        class="training-library__tags-dropdown-item"\n' +
    '        ng-class="{\'training-library__tags-dropdown-item--selected\': library.checkIfTabIsSelected(tag)}"\n' +
    '        ng-click="library.setFilterTag(tag)">\n' +
    '        {{tag.tag}}\n' +
    '        <span class="training-library__tags-item-count">({{tag.exerciseCount}})</span>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="exercise-tab__exercises"\n' +
    '      ng-init="library.exercises.load()"\n' +
    '      permission\n' +
    '      permission-only="\'EXERCISES_READ\'"\n' +
    '      infinite-scroll="library.exercises.load()"\n' +
    '      can-load="library.exercises.nextPage"\n' +
    '      threshold="250">\n' +
    '\n' +
    '      <div class="library-cards">\n' +
    '\n' +
    '        <library-card\n' +
    '          ng-repeat="exercise in library.exercises.items"\n' +
    '          exercise="exercise"\n' +
    '          type="exercises"\n' +
    '          data="exercise"\n' +
    '          on-edit-card="library.editExercise(exercise)"\n' +
    '          on-print-card="library.printExerciseTemplate(exercise)"\n' +
    '          edit-permission="library.getCardPermission(exercise, \'EXERCISES\', \'UPDATE\')"\n' +
    '          delete-permission="library.getCardPermission(exercise, \'EXERCISES\', \'UPDATE\')"         \n' +
    '          hide-edit-icon="exercise.isEditable">\n' +
    '        </library-card>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="client-item--empty"\n' +
    '        ng-if="!library.exercises.items.length && !library.exercises.nextPage">\n' +
    '        {{ :: \'NO_EXERCISES\' | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="roster-load-more" ng-if="library.exercises.nextPage">\n' +
    '        <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '        {{ :: \'LOADING_MORE_EXERCISES\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- ============== Training Programs ========== -->\n' +
    '  <div class="training-library__tabs-content"\n' +
    '    ng-if="library.activeTab === \'TRAINING_PROGRAMS\'">\n' +
    '    <div class="exercise-tab__exercises"\n' +
    '      ng-init="library.trainingPlans.load()"\n' +
    '      permission\n' +
    '      permission-only="\'SAVED_TRAINING_PLANS_READ\'"\n' +
    '      infinite-scroll="library.trainingPlans.load()"\n' +
    '      can-load="library.trainingPlans.nextPage"\n' +
    '      threshold="250">\n' +
    '\n' +
    '      <div class="library-cards">\n' +
    '\n' +
    '        <library-card\n' +
    '          ng-repeat="plan in library.trainingPlans.items"\n' +
    '          exercise="plan"\n' +
    '          type="trainingPlans"\n' +
    '          data="plan"\n' +
    '          on-delete-card="library.deleteTrainingPlan(plan)"\n' +
    '          on-print-card="library.printSavedTrainingPlan(plan)"\n' +
    '          on-edit-card="library.editSavedTrainingPlan(plan)"\n' +
    '          edit-permission="library.getCardPermission(plan, \'SAVED_TRAINING_PLANS\', \'UPDATE\')"\n' +
    '          delete-permission="library.getCardPermission(plan, \'SAVED_TRAINING_PLANS\', \'DELETE\')"\n' +
    '          hide-edit-icon="plan.isEditable"\n' +
    '          >\n' +
    '        </library-card>\n' +
    '\n' +
    '      </div>\n' +
    '      <div class="client-item--empty"\n' +
    '        ng-if="!library.trainingPlans.items.length && !library.trainingPlans.nextPage">\n' +
    '        {{ :: \'NO_EXERCISES\' | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="roster-load-more" ng-if="library.trainingPlans.nextPage">\n' +
    '        <div class="roster-load-more__icon spinner-icon"></div>\n' +
    '        {{ :: \'LOADING_MORE_EXERCISES\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="client-item--empty"\n' +
    '    ng-show="!library.activeTab"\n' +
    '    ng-if="!library.exercises.items.length && !library.exercises.nextPage\n' +
    '        && !library.trainingSets.items.length && !library.trainingSets.nextPage">\n' +
    '    {{ :: "NO_ITEMS" | translate }}\n' +
    '  </div>\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/task/tabs/details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/task/tabs/details.html', '<pt-exercise-item-details\n' +
    '  item="taskCtrl.task"\n' +
    '  edit-permission="taskCtrl.editPermission"\n' +
    '  type="task"\n' +
    '></pt-exercise-item-details>\n' +
    '');
  }]);
angular.module('/app/library/task/tabs/period.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/task/tabs/period.html', '<div class="date-tab">\n' +
    '  <div class="date-tab__bar">\n' +
    '    <span class="date-tab__bar-text">{{\'START_DATE\' | translate}}</span>\n' +
    '    <span class="date-tab__bar-text date-tab__bar-text--time"\n' +
    '      ng-if="taskCtrl.task.canPickTime">\n' +
    '      {{\'TIME\' | translate}}\n' +
    '    </span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="date-tab__picker-wrapper date-tab__scrolling-datepicker-wrapper">\n' +
    '    <scrolling-datepicker\n' +
    '      start-moment="taskCtrl.task.startDate"\n' +
    '      end-moment="taskCtrl.task.endDate"\n' +
    '    ></scrolling-datepicker>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="date-tab__picker-wrapper">\n' +
    '    <tabs class="date-tab__picker-tabs tabs--short tabs--fit">\n' +
    '      <tab name=\'datetime-schedule\' is-disabled="!taskCtrl.task.canPickTime">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{\'TIME\' | translate}}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <timepicker\n' +
    '            clients="taskCtrl.timeSlots"\n' +
    '            selected-clients="taskCtrl.namePlate"\n' +
    '            edit-assign="taskCtrl.taskOnEdit"\n' +
    '            on-time-range-select="taskCtrl.navigateToDateTimeDetails()"\n' +
    '            on-show-time-details="taskCtrl.navigateToDateTimeDetails()"\n' +
    '            on-client-select=\'taskCtrl.navigateToUserDetails($item)\'\n' +
    '            on-set-all-day="taskCtrl.setAllDay()"\n' +
    '            on-edit-client="taskCtrl.onEditAssigment($item)"\n' +
    '            on-edit-task="taskCtrl.onEditTask($item)"\n' +
    '            start-time="taskCtrl.task.appointment.startTime"\n' +
    '            end-time="taskCtrl.task.appointment.endTime"\n' +
    '            date="taskCtrl.task.startDate"\n' +
    '            allow-overlap="true"\n' +
    '            trainer-work-info="taskCtrl.selectedUserWorkInfo">\n' +
    '          </timepicker>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab name="datetime-details">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{\'DETAILS\' | translate}}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <datetime-details\n' +
    '            start-date="taskCtrl.task.startDate"\n' +
    '            end-date="taskCtrl.task.endDate"\n' +
    '            start-time="taskCtrl.task.appointment.startTime"\n' +
    '            end-time="taskCtrl.task.appointment.endTime"\n' +
    '            time-duration-options="taskCtrl.timeDurationOptions"\n' +
    '            time-duration-option-validator="taskCtrl.validateDurationOption"\n' +
    '            disable-recurrence="true"\n' +
    '          ></datetime-details>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '    </tabs>\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/task/tabs/users.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/task/tabs/users.html', '<section class="exercise-tab training-set__tab-content">\n' +
    '  <pt-users-bag class="task__users-bag"\n' +
    '    users-list="taskCtrl.users"\n' +
    '    selected-users="taskCtrl.task.users"\n' +
    '    id="taskCtrl.task._id"\n' +
    '    bag-type="trainingSets"\n' +
    '    edit-bag-permission="taskCtrl.editPermission"\n' +
    '    bag-limit="1"\n' +
    '    user-type="users">\n' +
    '  </pt-users-bag>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/task/task.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/task/task.html', '<section class="create-assignment task" ng-form="taskCtrl.form" novalidate>\n' +
    '  <header class="create-assignment__header">\n' +
    '    <a class="back-button"></a>\n' +
    '    <h1 class="create-assignment__header-title">\n' +
    '      {{ :: taskCtrl.isEdit ? \'EDIT_TASK\' : \'CREATE_TASK\' | translate }}\n' +
    '    </h1>\n' +
    '\n' +
    '    <div class="button button-assertive pull-right exercise-delete-btn set-delete-btn"\n' +
    '      permission\n' +
    '      permission-only="taskCtrl.deletePermission"\n' +
    '      ng-if="taskCtrl.task._id"\n' +
    '      ng-click="taskCtrl.remove(taskCtrl.task._id)">\n' +
    '      <span class="button__icon button__icon--delete-exercise"></span>\n' +
    '      {{ :: \'DELETE_TASK\' | translate }}\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="create-assignment__content">\n' +
    '\n' +
    '    <tabs theme="dark">\n' +
    '      <tab>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ taskCtrl.task.users.length }} {{ :: \'USERS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include src="\'/app/library/task/tabs/users.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--============ PERIOD ==============-->\n' +
    '      <tab is-disabled="!taskCtrl.task.users.length"\n' +
    '        select="taskCtrl.activateDateTab() && taskCtrl.navigateToDateTab()">\n' +
    '\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-if="!taskCtrl.isDateTabWasActivated">\n' +
    '            {{ :: \'PICK_DATE_TIME\' | translate }}\n' +
    '          </span>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-if="taskCtrl.isDateTabWasActivated">\n' +
    '            {{taskCtrl.parseDate()}}\n' +
    '            <span class="create-assignment__dark-text"\n' +
    '              ng-if="taskCtrl.task.canPickTime && taskCtrl.task.appointment.startTime">\n' +
    '              <br/>\n' +
    '              {{ taskCtrl.task.appointment.startTime | dateFormatter: \'time\' }} -\n' +
    '              {{ taskCtrl.task.appointment.endTime | dateFormatter: \'time\' }}\n' +
    '            </span>\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include ng-if="taskCtrl.isDateTabWasActivated" src="\'/app/library/task/tabs/period.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '\n' +
    '\n' +
    '      <!--================== TASK DETAILS ===============-->\n' +
    '      <tab>\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'TASK_DETAILS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include src="\'/app/library/task/tabs/details.html\'"></ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab class=\'tab-action\'\n' +
    '        is-button="true"\n' +
    '        is-disabled="!taskCtrl.task.users.length || !taskCtrl.isDateTabWasActivated">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-click="taskCtrl.save(taskCtrl.task)">\n' +
    '            {{ :: taskCtrl.isEdit ? \'EDIT_TASK\' : \'CREATE_TASK\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab class=\'tab-assertive button-clear\'\n' +
    '        is-button="true">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ui-sref="app.dashboard">\n' +
    '            {{ :: \'CANCEL\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '    </tabs>\n' +
    '\n' +
    '  </section>\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/training-program-template/training-program-template.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-program-template/training-program-template.html', '<section class="workflow">\n' +
    '  <div class="workflow__header">\n' +
    '    <div class="workflow__header-title">\n' +
    '        {{ (!trainingProgramCtrl.editId ? \'CREATE_TRAINING_PROGRAM\' : \'UPDATE_TRAINING_PROGRAM\' )| translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="workflow__workflow-bar">\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': trainingProgramCtrl.currentTab === \'selectTime\'}">\n' +
    '      {{\'PROGRAM\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': trainingProgramCtrl.currentTab === \'sessionSetup\'}">\n' +
    '      {{\'SETUP\' | translate}}\n' +
    '    </div>\n' +
    '    <div class="workflow__workflow-bar-items"\n' +
    '      ng-class="{\'workflow__workflow-bar-items-selected\': trainingProgramCtrl.currentTab === \'reviewSave\'}">\n' +
    '      {{\'REVIEW_SAVE\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="workflow__workflow-tab">\n' +
    '    <select-time-frame ng-if="trainingProgramCtrl.currentTab === \'selectTime\'"\n' +
    '      on-tab-change="trainingProgramCtrl.changeTab($event)"\n' +
    '      training-sessions="trainingProgramCtrl.trainingSessions"\n' +
    '      on-training-sessions-change="trainingProgramCtrl.changeTrainingSessions($event)"\n' +
    '      weeks="trainingProgramCtrl.weeks"\n' +
    '      on-weeks-change="trainingProgramCtrl.changeWeeks($event)"\n' +
    '      name="trainingProgramCtrl.trainingProgramName"\n' +
    '      on-name-change="trainingProgramCtrl.handleNameChange($event)"\n' +
    '      type="\'trainingPlanTemplate\'">\n' +
    '    </select-time-frame>\n' +
    '    <session-setup-customize ng-if="trainingProgramCtrl.currentTab === \'sessionSetup\'"\n' +
    '      on-tab-change="trainingProgramCtrl.changeTab($event)"\n' +
    '      training-sessions="trainingProgramCtrl.trainingSessions"\n' +
    '      training-plan-exercises="trainingProgramCtrl.trainingPlansExercise"\n' +
    '      on-training-plans-exercise-change="trainingProgramCtrl.changeTrainingPlansExercise($event)"\n' +
    '      type="\'trainingPlanTemplate\'">\n' +
    '    </session-setup-customize>\n' +
    '    <review-save ng-if="trainingProgramCtrl.currentTab === \'reviewSave\'"\n' +
    '      type="\'trainingPlanTemplate\'"\n' +
    '      name="trainingProgramCtrl.trainingProgramName"\n' +
    '      weeks="trainingProgramCtrl.weeks"\n' +
    '      training-sessions="trainingProgramCtrl.trainingSessions"\n' +
    '      exercises="trainingProgramCtrl.trainingPlansExercise"\n' +
    '      on-tab-change="trainingProgramCtrl.changeTab($event)"\n' +
    '      on-save="trainingProgramCtrl.save()"\n' +
    '      training-plan-loading="trainingProgramCtrl.savingTrainingPlan"\n' +
    '      on-pdf-request="trainingProgramCtrl.showPDF()"\n' +
    '    ></review-save>\n' +
    '  </div>\n' +
    '</section>');
  }]);
angular.module('/app/library/training-set/tabs/exercise-profile.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-set/tabs/exercise-profile.html', '<div class="create-exercise__customize">\n' +
    '  <pt-items-switcher\n' +
    '    selected-items="createSetCtrl.set.exercises"\n' +
    '    bag-type="trainingSets"\n' +
    '    on-index-update = "createSetCtrl.setActiveExerciseIndex(newIndex)">\n' +
    '  </pt-items-switcher>\n' +
    '  <div class="exercise-profile">\n' +
    '    <customize-exercise\n' +
    '      exercise="createSetCtrl.set.exercises[createSetCtrl.activeExerciseIndex]"\n' +
    '      on-update=\'createSetCtrl.handleExerciseUpdate($event)\'\n' +
    '      context=\'assignment\'>\n' +
    '    </customize-exercise>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/library/training-set/tabs/exercises.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-set/tabs/exercises.html', '<section class="exercise-tab training-set__tab-content">\n' +
    '  <pt-items-selector\n' +
    '    items-lists="[ createSetCtrl.exercises ]"\n' +
    '    edit-item="createSetCtrl.editExercise"\n' +
    '    selected-items="createSetCtrl.set.exercises"\n' +
    '    active-item-index="createSetCtrl.activeExerciseIndex"\n' +
    '    is-chain-wide="createSetCtrl.set.chainWide"\n' +
    '    id="createSetCtrl.set._id"\n' +
    '    bag-type="trainingSets"\n' +
    '    hide-print-icon="true"\n' +
    '    item-type="exercises"\n' +
    '    drag-copy="true">\n' +
    '  </pt-items-selector>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/library/training-set/tabs/training-set-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-set/tabs/training-set-details.html', '<pt-exercise-item-details\n' +
    '  item="createSetCtrl.set"\n' +
    '  type="trainingSets"\n' +
    '></pt-exercise-item-details>\n' +
    '');
  }]);
angular.module('/app/library/training-set/tabs/training-set-media.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-set/tabs/training-set-media.html', '<pt-exercise-multimedia\n' +
    '  images-list="createSetCtrl.set.imagesList"\n' +
    '  images-limit="1"\n' +
    '  type="trainingSet"\n' +
    '  video="createSetCtrl.set.video"\n' +
    '  on-video-update="createSetCtrl.setVideo(url)"\n' +
    '>\n' +
    '</pt-exercise-multimedia>\n' +
    '');
  }]);
angular.module('/app/library/training-set/training-set.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/library/training-set/training-set.html', '<!--THIS PAGE IS AVAILIABLE IF YOU HAVE\n' +
    'TRAINING_SETS_READ OR TRAINING_SETS_UPDATE PERMISSSION -->\n' +
    '\n' +
    '<section\n' +
    '  class="create-assignment" novalidate>\n' +
    '  <header class="create-assignment__header">\n' +
    '    <a class="back-button" need-confirmation="true"></a>\n' +
    '    <h1 class="create-assignment__header-title">\n' +
    '      {{ :: createSetCtrl.isEdit ? \'EDIT_TRAINING_SET\' : \'CREATE_TRAINING_SET\' | translate}}\n' +
    '    </h1>\n' +
    '\n' +
    '\n' +
    '    <div class="button button-assertive pull-right exercise-delete-btn set-delete-btn"\n' +
    '      permission\n' +
    '      permission-only="createSetCtrl.deletePermission"\n' +
    '      ng-if="createSetCtrl.set._id"\n' +
    '      ng-click="createSetCtrl.remove(createSetCtrl.set._id)">\n' +
    '        <span class="button__icon button__icon--delete-exercise"></span>\n' +
    '        {{ :: \'DELETE_TRAINING_SET\' | translate }}\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="create-assignment__content">\n' +
    '\n' +
    '    <tabs theme="dark">\n' +
    '\n' +
    '      <!--========= Exercises tab===========-->\n' +
    '      <tab permission\n' +
    '        permission-only="\'EXERCISES_READ\'"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ createSetCtrl.set.exercises.length }} {{ :: \'EXERSCISES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '            src="\'/app/library/training-set/tabs/exercises.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--========= Exercises Profile===========-->\n' +
    '      <tab permission\n' +
    '        permission-only="\'EXERCISES_READ\'"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '        is-disabled="!createSetCtrl.set.exercises.length"\n' +
    '        select="createSetCtrl.activateExerciseProfileTab()">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'EXERCISE_PROFILES\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '            src="\'/app/library/training-set/tabs/exercise-profile.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--========= SET MEDIA ===========-->\n' +
    '      <tab permission\n' +
    '         permission-only="\'TRAINING_SETS_READ\'"\n' +
    '         permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '         is-disabled="!createSetCtrl.set.exercises.length">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'TRAINING_SET_MEDIA\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '            src="\'/app/library/training-set/tabs/training-set-media.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--========= SET MEDIA ===========-->\n' +
    '      <tab permission\n' +
    '        permission-only="[\'TRAINING_SETS_READ\', \'TRAINING_SETS_UPDATE\']"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '        is-disabled="!createSetCtrl.set.exercises.length">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'TRAINING_SET_DETAILS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <ng-include class="training-set"\n' +
    '            src="\'/app/library/training-set/tabs/training-set-details.html\'">\n' +
    '          </ng-include>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--  ========= CREATE tab===========-->\n' +
    '\n' +
    '      <tab class=\'tab-action\'\n' +
    '        is-disabled=\'!createSetCtrl.isSetValid(createSetCtrl.set)\'\n' +
    '        is-button="true"\n' +
    '        permission\n' +
    '        permission-only="createSetCtrl.set.chainWide ?\n' +
    '          (createSetCtrl.set._id ? \'CHAIN_WIDE_UPDATE\' : \'CHAIN_WIDE_CREATE\'):\n' +
    '          (createSetCtrl.set._id ? \'TRAINING_SETS_UPDATE\' : \'TRAINING_SETS_CREATE\')">\n' +
    '        <tab-head>\n' +
    '          <button class="tab-head__multiline-item"\n' +
    '            ng-click="createSetCtrl.save(createSetCtrl.set)"\n' +
    '            ng-disabled="createSetCtrl.isLoading">\n' +
    '            <i class="create-exercise__tab-title-icon spinner-icon" ng-if="createSetCtrl.isLoading"></i>\n' +
    '            {{ :: createSetCtrl.isEdit ? \'EDIT_SET\' : \'SAVE_SET\' | translate}}\n' +
    '          </button>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '      <!--  ========= CANCEL tab===========-->\n' +
    '      <tab class=\'tab-assertive button-clear\'\n' +
    '        is-button="true"\n' +
    '        permission\n' +
    '        permission-only="createSetCtrl.set.chainWide ?\n' +
    '          (createSetCtrl.set._id ? \'CHAIN_WIDE_UPDATE\' : \'CHAIN_WIDE_CREATE\'):\n' +
    '          (createSetCtrl.set._id ? \'TRAINING_SETS_UPDATE\' : \'TRAINING_SETS_CREATE\')">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item"\n' +
    '            ng-click="createSetCtrl.cancel()">\n' +
    '            {{ :: \'CANCEL\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '      </tab>\n' +
    '\n' +
    '    </tabs>\n' +
    '\n' +
    '  </section>\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/maintenance/maintenance.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/maintenance/maintenance.html', '<section class="login">\n' +
    '\n' +
    '    <header class="login__header">\n' +
    '      <h1 class="login__title">ENGAGE 360</h1>\n' +
    '    </header>\n' +
    '\n' +
    '    <div class="login__view">\n' +
    '        <div class="login__content login__form">\n' +
    '            <h2 class="login__form-title">Planned Maintenance</h2>\n' +
    '\n' +
    '            Engage 360 is currently offline for planned maintenance, and should be back online shortly. Please refresh the page or try again in a few minutes.\n' +
    '\n' +
    '            <button class="login__submit"\n' +
    '                ng-click="maintenanceCtrl.refresh()">Refresh\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>');
  }]);
angular.module('/app/messaging/messaging.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/messaging/messaging.html', '<section class="roster">\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-envelope"></i>\n' +
    '      <h1 class="container-header__title">{{ \'MESSAGING\' | translate}}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <div class="messaging">\n' +
    '    <div class="messaging__thread-list">\n' +
    '      <div\n' +
    '        class="messaging__thread-list-item"\n' +
    '        ng-click="messaging.activateNewThread()"\n' +
    '      >\n' +
    '        <img\n' +
    '          class="messaging__thread-list-item-picture messaging__thread-list-item-picture--new"\n' +
    '          src="//images.jhtassets.com/677b6b5924cb4be374bdae52fa52de04cb52c7bd/"\n' +
    '        />\n' +
    '        <div class="messaging__thread-list-item-name">\n' +
    '          {{ "NEW" | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div\n' +
    '        class="messaging__thread-list-item"\n' +
    '        ng-repeat="thread in messaging.threadList | orderBy:\'-mostRecent\'" ng-if="thread.otherUser"\n' +
    '        ng-click="messaging.selectThread(thread)"\n' +
    '      >\n' +
    '        <img\n' +
    '          class="messaging__thread-list-item-picture"\n' +
    '          ng-src="{{thread.otherUser.picture || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}"\n' +
    '        />\n' +
    '        <div\n' +
    '          class="messaging__thread-list-item-name"\n' +
    '          ng-class="{\n' +
    '                        \'messaging__thread-list-item-name--active\': messaging.activeThread.threadId === thread.threadId,\n' +
    '                        \'messaging__thread-list-item-name--unread\': thread.unreadMessages\n' +
    '                    }"\n' +
    '        >\n' +
    '          {{thread.otherUser.firstName}} {{thread.otherUser.lastName}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="messaging__thread" ng-if="messaging.activeThread">\n' +
    '      <div class="messaging__thread-title">\n' +
    '        {{messaging.activeThread.otherUser.firstName}}\n' +
    '        {{messaging.activeThread.otherUser.lastName}}\n' +
    '      </div>\n' +
    '      <div class="messaging__thread-container">\n' +
    '        <div\n' +
    '          ng-if="messaging.threadMessages"\n' +
    '          ng-repeat="message in messaging.threadMessages"\n' +
    '        >\n' +
    '          <div\n' +
    '            class="messaging__thread-message-time"\n' +
    '            ng-class="{\n' +
    '                            \'messaging__thread-message-time-systemMessage\': message.systemMessage === true,\n' +
    '                            \'messaging__thread-message-time-other\': message.to === messaging.selfId,\n' +
    '                            \'messaging__thread-message-time-self\': message.to !== messaging.selfId\n' +
    '                        }"\n' +
    '          >\n' +
    '            {{message.time | dateFormatter:\'messagingDateTime\'}}\n' +
    '          </div>\n' +
    '          <div\n' +
    '            class="messaging__thread-message"\n' +
    '            ng-class="{\n' +
    '                            \'messaging__thread-message-other\': message.to === messaging.selfId,\n' +
    '                            \'messaging__thread-message-self\': message.to !== messaging.selfId,\n' +
    '                            \'messaging__thread-message-systemMessage\': message.systemMessage === true\n' +
    '                        }"\n' +
    '          >\n' +
    '            <div\n' +
    '              ng-if="!message.systemMessage"\n' +
    '              ng-bind-html="messaging.deliberatelyTrustDangerousHtml(message.message)"\n' +
    '            ></div>\n' +
    '            <div\n' +
    '              class="messaging__thread-message-systemMessage_message"\n' +
    '              ng-if="message.systemMessage"\n' +
    '            >\n' +
    '              <div\n' +
    '                class="messaging__thread-message-systemMessage_icon"\n' +
    '                ng-class="{ \'messaging__thread-message-systemMessage_icon-reminder\': message.messageMetadata.type === \'Reminder\',\n' +
    '                                           \'messaging__thread-message-systemMessage_icon-at_risk\': message.messageMetadata.type === \'atRisk\' }"\n' +
    '                ng-if="message.systemMessage"\n' +
    '              ></div>\n' +
    '              {{ messaging.generateSystemMessage(message) }}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="messaging__thread-form-container">\n' +
    '        <div class="messaging__thread-form">\n' +
    '          <textarea\n' +
    '            class="messaging__thread-form-input"\n' +
    '            ng-model="messaging.newMessage"\n' +
    '            ng-attr-placeholder="{{\'MESSAGE\' | translate}}"\n' +
    '          ></textarea>\n' +
    '          <div\n' +
    '            class="messaging__thread-form-button"\n' +
    '            ng-click="messaging.sendMessage()"\n' +
    '          >\n' +
    '            <!-- TODO - Show loading indicator when sending message-->\n' +
    '            <img\n' +
    '              class="messaging__thread-form-icon"\n' +
    '              src="//images.jhtassets.com/e2b41dba2f13f1c075561bad40b7af2cdae00e2e/"\n' +
    '            />\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="messaging__thread" ng-if="messaging.showNewThread">\n' +
    '      <div\n' +
    '        class="messaging__new"\n' +
    '        ng-class="{\'messaging__new-highlight-error\': messaging.highlightAddressBar}"\n' +
    '      >\n' +
    '        <div\n' +
    '          class="messaging__new-prompt"\n' +
    '          ng-class="{\'messaging__new-prompt-highlight-error\': messaging.highlightAddressBar}"\n' +
    '        >\n' +
    '          To:\n' +
    '        </div>\n' +
    '        <div class="messaging__new-select">\n' +
    '          <ui-select\n' +
    '            multiple\n' +
    '            ng-model="messaging.newThreadRecipients"\n' +
    '            ng-model-options="{ getterSetter: true }"\n' +
    '            close-on-select="false"\n' +
    '          >\n' +
    '            <ui-select-match placeholder="+">\n' +
    '              <span> {{$item.fullName}} </span>\n' +
    '            </ui-select-match>\n' +
    '            <ui-select-choices\n' +
    '              repeat="user in messaging.searchingUsers | filter: $select.search | orderBy: \'user.fullName\' "\n' +
    '            >\n' +
    '              <span> {{user.fullName}} </span>\n' +
    '            </ui-select-choices>\n' +
    '          </ui-select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="messaging__thread-form-container">\n' +
    '        <div class="messaging__thread-form">\n' +
    '          <textarea\n' +
    '            class="messaging__thread-form-input"\n' +
    '            ng-model="messaging.newThreadMessage"\n' +
    '            ng-attr-placeholder="{{\'MESSAGE\' | translate}}"\n' +
    '          ></textarea>\n' +
    '          <div\n' +
    '            class="messaging__thread-form-button"\n' +
    '            ng-click="messaging.sendNewMessage()"\n' +
    '          >\n' +
    '            <!-- TODO - Show loading indicator when sending message-->\n' +
    '            <img\n' +
    '              class="messaging__thread-form-icon"\n' +
    '              src="//images.jhtassets.com/e2b41dba2f13f1c075561bad40b7af2cdae00e2e/"\n' +
    '            />\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/privacy/privacy.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/privacy/privacy.html', '<div\n' +
    '  ng-controller="PrivacyController as privacyCtrl"\n' +
    '  class="login__privacyPolicyPage"\n' +
    '>\n' +
    '  <div class="login__privacyPageBackDiv" ng-click="navigateToLoginPage()">\n' +
    '    <img src="{{imageSrc}}" alt="Back\n' +
    '    Icon" class="login__privacyBackButtonIcon">\n' +
    '    <span class="login__privacyBackButton">{{ "BACK" | translate | uppercase }}</span>\n' +
    '  </div>\n' +
    '  <div markdown-to-html="data" class="login__privacyPageDescription"></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/roster/roster.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/roster/roster.html', '<section class="roster">\n' +
    '\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-users"></i>\n' +
    '      <h1 class="container-header__title">{{ \'ROSTER\' | translate}}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <library-search>\n' +
    '    <div class="library-search">\n' +
    '      <div class="library-search__icon"></div>\n' +
    '      <input type="text"\n' +
    '        class="library-search__input"\n' +
    '        placeholder="{{ \'SEARCH\' | translate}}"\n' +
    '        ng-model="roster.search"\n' +
    '        ng-model-options="{debounce: 500}"\n' +
    '        ng-change="roster.filterByName()">\n' +
    '      <search-clearer\n' +
    '        search-term="roster.search"\n' +
    '        refresh-fn="roster.filterByName()">\n' +
    '      </search-clearer>\n' +
    '    </div>\n' +
    '  </library-search>\n' +
    '\n' +
    '  <section class=\'roster__content\'\n' +
    '    infinite-scroll=\'roster.loadClients()\'\n' +
    '    can-load=\'roster.clientsList.nextPage\'\n' +
    '    threshold=\'30\'>\n' +
    '\n' +
    '    <div class=\'client-item fade-onload\'\n' +
    '      ng-repeat=\'client in roster.clientsList.items\'\n' +
    '      ng-class=\'{ "client-item-staff": roster.isStaff(client) }\'\n' +
    '      permission\n' +
    '      permission-only="roster.getUserViewPermission(client)"\n' +
    '      ui-sref=\'app.users.details({userId: client._id,prevState: "app.users.list",roles: client.roles[0]})\'>\n' +
    '\n' +
    '      <div class=\'client-item__right\'>\n' +
    '<!--\n' +
    '        <div class=\'client-item__info\'>\n' +
    '          <div class=\'client-item__info-content\'>\n' +
    '            <div class=\'client-item__info-title\'>{{ ::client.remain }} {{ \'REMAIN\' | translate }}</div>\n' +
    '            <div class=\'client-item__info-caption\'>{{ \'TRAINING_EXPIRES\' | translate }}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    ' -->\n' +
    '        <div class=\'client-item__info\'>\n' +
    '          <div class=\'client-item__info-content\'>\n' +
    '            <div class=\'client-item__info-title\'\n' +
    '              ng-if=\'client.clientProfile.lastWorkoutDate\'>{{ client.clientProfile.lastWorkoutDate | dateFormatter:\'dateShort\' }}</div>\n' +
    '            <div class=\'client-item__info-title\'\n' +
    '              ng-if=\'!client.clientProfile.lastWorkoutDate\'>-//-</div>\n' +
    '            <div class=\'client-item__info-caption\'>{{ \'LAST_WORKOUT\' | translate }}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'client-item__info\'>\n' +
    '          <div class=\'client-item__info-content\'>\n' +
    '            <div class=\'client-item__info-title\'\n' +
    '              ng-if=\'client.clientProfile.nextAssignmentDate\'>{{ client.clientProfile.nextAssignmentDate | dateFormatter:\'dateShort\'  }}</div>\n' +
    '            <div class=\'client-item__info-title\'\n' +
    '              ng-if=\'!client.clientProfile.nextAssignmentDate\'>-//-</div>\n' +
    '            <div class=\'client-item__info-caption\'>{{ \'NEXT_WORKOUT\' | translate }}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class=\'client-item__left\'>\n' +
    '        <img class=\'client-item__picture\'\n' +
    '          ng-src=\'{{ client.pictureUrl || "//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png" }}\'/>\n' +
    '        <div class=\'client-item__label\' ng-class=\'{ "client-item__label-staff": roster.isStaff(client) }\'>\n' +
    '          <!-- TODO: add custom icons -->\n' +
    '          <div class=\'client-item__label-icon\'></div>\n' +
    '        </div>\n' +
    '        <div class=\'client-item__title\'>\n' +
    '          <div>{{ client.firstName }} {{ client.lastName }}</div>\n' +
    '          <span class=\'client-item__caption\'>{{ client.location }}</span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'client-item--empty\'\n' +
    '      ng-if=\'!roster.clientsList.items.length && !roster.clientsList.nextPage\'>\n' +
    '      {{ "NO_CLIENTS" | translate }}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'roster-load-more\' ng-if=\'roster.clientsList.nextPage\'>\n' +
    '      <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '      {{ \'LOADING_MORE_CLIENTS\' | translate }}\n' +
    '    </div>\n' +
    '  </section>\n' +
    '\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/schedule/schedule.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/schedule/schedule.html', '<section class="schedule">\n' +
    '\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-calendar"></i>\n' +
    '      <h1 class="container-header__title">{{ \'CALENDAR\' | translate}}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/settings/settings.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/settings.html', '<section class="settings">\n' +
    '\n' +
    '  <header class="container-header">\n' +
    '    <div class="container-header__content">\n' +
    '      <i class="container-header__icon icon icon-gear"></i>\n' +
    '      <h1 class="container-header__title">{{ :: \'SETTINGS\' | translate}}</h1>\n' +
    '    </div>\n' +
    '  </header>\n' +
    '\n' +
    '  <section class="settings__content">\n' +
    '\n' +
    '    <tabs theme="dark">\n' +
    '\n' +
    '      <tab name=\'risk\'\n' +
    '        permission\n' +
    '        permission-only="\'RISK_CALCULATIONS_READ\'"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'RISK_CALCULATION\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/settings/tabs/risk.html\'" class="settings__risk"></div>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '      <tab name=\'permission-groups\'\n' +
    '        permission\n' +
    '        permission-only="\'PERMISSIONS_GROUPS_READ\'"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'PERMISSION_GROUPS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/settings/tabs/permissions.html\'" class="settings__permissions"></div>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '      <tab name=\'facility-settings\'\n' +
    '        permission\n' +
    '        permission-only="\'FACILITY_SETTINGS_READ\'"\n' +
    '        permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '        <tab-head>\n' +
    '          <span class="tab-head__multiline-item">\n' +
    '            {{ :: \'FACILITY_SETTINGS\' | translate }}\n' +
    '          </span>\n' +
    '        </tab-head>\n' +
    '        <tab-content>\n' +
    '          <div ng-include="\'/app/settings/tabs/facility_settings.html\'" class="settings__facility"></div>\n' +
    '        </tab-content>\n' +
    '      </tab>\n' +
    '\n' +
    '    </tabs>\n' +
    '\n' +
    '  </section>\n' +
    '\n' +
    '</section>\n' +
    '');
  }]);
angular.module('/app/settings/tabs/facility_settings.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/facility_settings.html', '<div class="permission-groups"\n' +
    '  ng-controller="FacilitySettingsCtrl as FacilityCtrl">\n' +
    '\n' +
    '  <div class="facility-settings__content" ng-if=\'FacilityCtrl.facility.settings.membershipGroups !== undefined &&\n' +
    '  FacilityCtrl.facility.settings.membershipGroups\'>\n' +
    '    <h4 class="data-block__header">{{::\'MEMBERSHIP_GROUPS\' | translate}}</h4>\n' +
    '    <div class="membership_container">\n' +
    '      <div class="membership_groups" ng-class=\'{"no-memberships":!FacilityCtrl.canChangeMembershipGroups(["FACILITY_MEMBERSHIP_GROUP_CREATE", "FACILITY_MEMBERSHIP_GROUP_UPDATE", "FACILITY_MEMBERSHIP_GROUP_DELETE"]) }\' \n' +
    '      ng-repeat="group in FacilityCtrl.membershipGroup" >\n' +
    '        <div class="membership_text" >{{ group.name }} ({{ group.members.length }})</div>\n' +
    '        <div class="membership_group_icons">\n' +
    '          <div class="membership_group_edit" ng-click="FacilityCtrl.editMembership(group)" permission permission-only="\'FACILITY_MEMBERSHIP_GROUP_UPDATE\'"></div>\n' +
    '          <div class="membership_group_delete" ng-click="FacilityCtrl.deleteMembership(group)" permission permission-only="\'FACILITY_MEMBERSHIP_GROUP_DELETE\'"></div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="membership_group_add" ng-click="FacilityCtrl.createMembership()" permission permission-only="\'FACILITY_MEMBERSHIP_GROUP_CREATE\'">\n' +
    '      {{ \'ADD_NEW\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="facility-settings__content">\n' +
    '    <h4>{{::\'FACILITY_SETTINGS_DESCRIPTION\' | translate}}</h4>\n' +
    '\n' +
    '    <form name="FacilityCtrl.forms.settings">\n' +
    '      <div class="data-wrapper">\n' +
    '        <div class="data-wrapper--left">\n' +
    '\n' +
    '          <div class="data-block">\n' +
    '            <div class="data-block__header">{{::\'EMAIL_NOTIFICATION\' | translate}}</div>\n' +
    '            <div class="data-block__container">\n' +
    '              <div class="data-block__line-container user-details__email-notification"\n' +
    '                ng-repeat="(name, value) in FacilityCtrl.facility.settings.notices">\n' +
    '                <label class="checkbox-custom">\n' +
    '                  <input permission\n' +
    '                  permission-only=":: FacilityCtrl.permissions.settings.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  type="checkbox"\n' +
    '                  ng-model="FacilityCtrl.facility.settings.notices[name]"\n' +
    '                  class="data-block__info--input user-details__input--text">\n' +
    '                  <span class="checkbox-label">\n' +
    '                    {{::name | camelToSnakeCase | translate}}\n' +
    '                  </span>\n' +
    '                </label>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-wrapper--right">\n' +
    '          <div class="data-block">\n' +
    '            <div class="data-block__header">{{::\'PREFERENCES\' | translate}}</div>\n' +
    '            <div class="data-block__container user-details__units">\n' +
    '              <div ng-class="data-block__info">\n' +
    '                <ui-select\n' +
    '                  class=\'select-custom user-details__input--select\'\n' +
    '                  search-enabled=\'false\'\n' +
    '                  append-to-body=\'true\'\n' +
    '\n' +
    '                  title="{{::\'CHOOSE_UNITS\'| translate}}"\n' +
    '                  ng-model="FacilityCtrl.facility.settings.measurementUnit">\n' +
    '                  <ui-select-match\n' +
    '                    permission\n' +
    '                    permission-only=":: FacilityCtrl.permissions.settings.update"\n' +
    '                    permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                    permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                    placeholder="{{::\'CHOOSE_UNITS\'| translate}}">{{\'MEASUREMENT_UNIT_\' + $select.selected | translate }}</ui-select-match>\n' +
    '                  <ui-select-choices repeat="option in [\'I\', \'M\']">\n' +
    '                    <span\n' +
    '                      ng-bind="\'MEASUREMENT_UNIT_\' + option | translate"></span>\n' +
    '                  </ui-select-choices>\n' +
    '                </ui-select>\n' +
    '                <div class="data-block__title">{{::\'UNIT_SETTINGS\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="data-block">\n' +
    '            <div class="data-block__container">\n' +
    '              <div ng-class="data-block__info">\n' +
    '                <ui-select\n' +
    '                  class=\'select-custom user-details__input--select\'\n' +
    '                  search-enabled=\'false\'\n' +
    '                  append-to-body=\'true\'\n' +
    '\n' +
    '                  title="{{::\'CHOOSE_LANGUAGE\' | translate}}"\n' +
    '                  ng-model="FacilityCtrl.facility.settings.language">\n' +
    '                  <ui-select-match\n' +
    '                    permission\n' +
    '                    permission-only=":: FacilityCtrl.permissions.settings.update"\n' +
    '                    permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                    permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                    placeholder="{{::\'CHOOSE_LANGUAGE\' | translate}}">{{ \'LANGUAGE_\' + $select.selected | translate}}</ui-select-match>\n' +
    '                  <ui-select-choices repeat="language in FacilityCtrl.languages">\n' +
    '                    <span\n' +
    '                      ng-bind="\'LANGUAGE_\' + language | translate"></span>\n' +
    '                  </ui-select-choices>\n' +
    '                </ui-select>\n' +
    '                <div class="data-block__title">{{::\'LANGUAGE\' | translate}}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="data-block">\n' +
    '            <div class="data-block__container">\n' +
    '              <ui-select\n' +
    '                class=\'select-custom user-details__input--select\'\n' +
    '                search-enabled=\'false\'\n' +
    '                append-to-body=\'true\'\n' +
    '\n' +
    '                title="{{::\'CHOOSE_DATE_FORMAT\' | translate}}"\n' +
    '                ng-model="FacilityCtrl.facility.settings.dateFormat">\n' +
    '                <ui-select-match\n' +
    '                  permission\n' +
    '                  permission-only=":: FacilityCtrl.permissions.settings.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                  placeholder="{{::\'CHOOSE_DATE_FORMAT\' | translate}}">{{ $select.selected }}</ui-select-match>\n' +
    '                <ui-select-choices repeat="option in [\'MM/DD/YYYY\', \'DD/MM/YYYY\', \'YYYY-MM-DD\']">\n' +
    '                  <span\n' +
    '                    ng-bind="option"></span>\n' +
    '                </ui-select-choices>\n' +
    '              </ui-select>\n' +
    '              <div class="data-block__title">{{::\'DATE_FORMAT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <div class="data-block">\n' +
    '            <div class="data-block__container">\n' +
    '              <ui-select\n' +
    '                class=\'select-custom user-details__input--select\'\n' +
    '                search-enabled=\'false\'\n' +
    '                append-to-body=\'true\'\n' +
    '\n' +
    '                title="{{::\'CHOOSE_TIME_FORMAT\' | translate}}"\n' +
    '                ng-model="FacilityCtrl.facility.settings.timeFormat">\n' +
    '                <ui-select-match\n' +
    '                  permission\n' +
    '                  permission-only=":: FacilityCtrl.permissions.settings.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                  placeholder="{{::\'CHOOSE_TIME_FORMAT\' | translate}}">{{ \'TIME_FORMAT_\' + $select.selected | translate}}</ui-select-match>\n' +
    '                <ui-select-choices repeat="option in [24, 12]">\n' +
    '                  <span\n' +
    '                    ng-bind="\'TIME_FORMAT_\' + option | translate"></span>\n' +
    '                </ui-select-choices>\n' +
    '              </ui-select>\n' +
    '              <div class="data-block__title">{{::\'TIME_FORMAT\' | translate}}</div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '  <div class="tab-footer footer-buttons"\n' +
    '    permission\n' +
    '    ng-show=\'FacilityCtrl.forms.settings.$dirty\'\n' +
    '    permission-only="[\'FACILITY_SETTINGS_UPDATE\']">\n' +
    '    <div\n' +
    '      class="button button-action"\n' +
    '      ng-click="FacilityCtrl.save()">\n' +
    '      {{::\'SAVE\'  | translate}}\n' +
    '    </div>\n' +
    '    <div\n' +
    '      class="button button-assertive button-clear pull-right"\n' +
    '      ng-click="FacilityCtrl.reset()">\n' +
    '      {{::\'CANCEL\'  | translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/settings/tabs/membership-groups/add-membership-group.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/membership-groups/add-membership-group.html', '<div>\n' +
    '    <div class="modal__popup-header">\n' +
    '        <div class="modal__popup-header--title">\n' +
    '            <div>{{ \'ADD_NEW_MEMBERSHIP_GROUP\' | translate }}</div>\n' +
    '        </div>\n' +
    '        <div class="modal__popup-header--exit icon icon-cross" ng-click="addCtrl.dismiss()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        <div class="modal__content-description membership_modal-content">\n' +
    '            <label class="duplicate-label" ng-if=\'addCtrl.duplicateCheck()\'>{{ \'MEMBERSHIP_GROUP_ALREADY_EXISTS\' | translate }}</label>\n' +
    '            <label>{{ \'GROUP_TITLE\' | translate }}</label>\n' +
    '            <input ng-class=\'{"duplicate-input": addCtrl.duplicateCheck()}\' type="text" placeholder="{{ \'ENTER_TEXT_HERE\' | translate }}"\n' +
    '                ng-model="addCtrl.newMembershipGroupTitle">\n' +
    '        </div>\n' +
    '        <div class="add-membership-search">\n' +
    '            <input class="add-membership-search-box" \n' +
    '                ng-model="addCtrl.search" \n' +
    '                ng-model-options="{ debounce: 500 }"\n' +
    '                ng-change="addCtrl.searchByName()"\n' +
    '                placeholder="{{ \'SEARCH_CLIENT\' | translate }}">\n' +
    '            <div class="add-membership-search-select">\n' +
    '                <label class="checkbox-custom">\n' +
    '                    <input\n' +
    '                        class="right-checkbox black-checkbox"\n' +
    '                        type="checkbox"\n' +
    '                        ng-model="addCtrl.allChecked"\n' +
    '                        ng-click="addCtrl.checkAll($event)">\n' +
    '                    <span class="checkbox-label">{{ \'SELECT_ALL\' | translate }}</span>\n' +
    '                </label>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="membership-user_options"\n' +
    '            infinite-scroll=\'addCtrl.loadUsers()\'\n' +
    '            can-load=\'addCtrl.clientsList.nextPage\'\n' +
    '            threshold=\'10\'\n' +
    '        >\n' +
    '            <div class="membership-user_option" ng-repeat="user in addCtrl.clientsList.items">\n' +
    '                <div class="membership-user_section-one">\n' +
    '                    <img class="membership-user_photo" ng-src="{{user.pictureUrl ? user.pictureUrl : \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}">\n' +
    '                </div>\n' +
    '                <div class="membership-user_section-two">\n' +
    '                    <div class="membership-user_info">\n' +
    '                        <div class="membership-user_name">{{user.firstName}} {{user.lastName}}</div>\n' +
    '                        <div class="membership-user_title">{{ \'NAME\' | translate }}</div>\n' +
    '                    </div>\n' +
    '                    <div class="membership-user_info">\n' +
    '                        <div class="membership-user_email">{{user.email}}</div>\n' +
    '                        <div class="membership-user_title">{{ \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="membership-user_section-three">\n' +
    '                    <label class="checkbox-custom">\n' +
    '                        <input\n' +
    '                            type="checkbox"\n' +
    '                            class="right-checkbox"\n' +
    '                            ng-checked="addCtrl.shouldBeChecked(user._id)"\n' +
    '                            ng-click="addCtrl.addToCheckedUsers($event, user._id)">\n' +
    '                            <span class="checkbox-label" ng-if="addCtrl.shouldBeChecked(user._id)">{{ \'CLIENT_ADDED\' | translate }}</span>\n' +
    '                            <span class="checkbox-label" ng-if="!addCtrl.shouldBeChecked(user._id)">{{ \'ADD_CLIENT\' | translate }}</span>\n' +
    '                    </label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class=\'roster-load-more\' ng-if=\'addCtrl.clientsList.nextPage\'>\n' +
    '                <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '                {{ \'LOADING_MORE_CLIENTS\' | translate }}\n' +
    '              </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '        <div class="uncomplete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button-action" ng-click=\'addCtrl.submit()\' ng-disabled=\'!addCtrl.newMembershipGroupTitle\'>\n' +
    '                <div ng-if="!addCtrl.loading">\n' +
    '                    {{ \'SAVE\' | translate }}</div>\n' +
    '                <div ng-if="addCtrl.loading" class="roster-load-more__icon spinner-icon"></div>\n' +
    '            </button>\n' +
    '            <div class="button button-assertive button-clear pull-right" ng-click=\'addCtrl.dismiss()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/settings/tabs/membership-groups/delete-membership-group.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/membership-groups/delete-membership-group.html', '<div>\n' +
    '    <div class="modal__popup-header">\n' +
    '        <div class="modal__popup-header--title">\n' +
    '            <div>{{ \'DELETE_MEMBERSHIP_GROUP\' | translate }}</div>\n' +
    '        </div>\n' +
    '        <div class="modal__popup-header--exit icon icon-cross" ng-click="deleteCtrl.dismiss()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        <div class="modal__content-description">\n' +
    '            {{ \'ACTION_CANNOT_BE_UNDONE\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '        <div class="uncomplete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button-action"\n' +
    '                ng-click=\'deleteCtrl.submit()\'>\n' +
    '                <div ng-if="!deleteCtrl.loading">\n' +
    '                    {{ \'YES\' | translate }}</div>\n' +
    '                <div ng-if="deleteCtrl.loading" class="roster-load-more__icon spinner-icon"></div>\n' +
    '            </button>\n' +
    '            <div class="button button-assertive button-clear pull-right"\n' +
    '                ng-click=\'deleteCtrl.dismiss()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/settings/tabs/membership-groups/edit-membership-group.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/membership-groups/edit-membership-group.html', '<div>\n' +
    '    <div class="modal__popup-header">\n' +
    '        <div class="modal__popup-header--title">\n' +
    '            <div>{{ \'EDIT_MEMBERSHIP_GROUP\' | translate }}</div>\n' +
    '        </div>\n' +
    '        <div class="modal__popup-header--exit icon icon-cross" ng-click="editCtrl.dismiss()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        <div class="modal__content-description membership_modal-content">\n' +
    '            <label class="duplicate-label" ng-if=\'editCtrl.duplicateCheck()\'>{{ \'MEMBERSHIP_GROUP_ALREADY_EXISTS\' | translate }}</label>\n' +
    '            <label>{{ \'GROUP_TITLE\' | translate }}</label>\n' +
    '            <input type="text" ng-class=\'{"duplicate-input": editCtrl.duplicateCheck()}\' ng-value="editCtrl.oldMembershipGroupTitle" ng-model="editCtrl.newMembershipGroupTitle">\n' +
    '        </div>\n' +
    '        <div class="add-membership-search">\n' +
    '            <input class="add-membership-search-box" \n' +
    '                ng-model="editCtrl.search" \n' +
    '                ng-model-options="{ debounce: 500 }"\n' +
    '                ng-change="editCtrl.searchByName()"\n' +
    '                placeholder="{{ \'SEARCH_CLIENT\' | translate }}">\n' +
    '            <div class="add-membership-search-select">\n' +
    '                <label class="checkbox-custom">\n' +
    '                    <input\n' +
    '                        class="right-checkbox black-checkbox"\n' +
    '                        type="checkbox"\n' +
    '                        ng-model="editCtrl.allChecked"\n' +
    '                        ng-click="editCtrl.checkAll($event)">\n' +
    '                    <span class="checkbox-label">{{ \'SELECT_ALL\' | translate }}</span>\n' +
    '                </label>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="membership-user_options"\n' +
    '            infinite-scroll=\'editCtrl.loadUsers()\'\n' +
    '            can-load=\'editCtrl.clientsList.nextPage\'\n' +
    '            threshold=\'10\'\n' +
    '        >\n' +
    '            <div class="membership-user_option" ng-repeat="user in editCtrl.clientsList.items">\n' +
    '                <div class="membership-user_section-one">\n' +
    '                    <img class="membership-user_photo" ng-src="{{user.pictureUrl ? user.pictureUrl : \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}">\n' +
    '                </div>\n' +
    '                <div class="membership-user_section-two">\n' +
    '                    <div class="membership-user_info">\n' +
    '                        <div class="membership-user_name">{{user.firstName}} {{user.lastName}}</div>\n' +
    '                        <div class="membership-user_title">{{ \'NAME\' | translate }}</div>\n' +
    '                    </div>\n' +
    '                    <div class="membership-user_info">\n' +
    '                        <div class="membership-user_email">{{user.email}}</div>\n' +
    '                        <div class="membership-user_title">{{ \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="membership-user_section-three">\n' +
    '                    <label class="checkbox-custom">\n' +
    '                        <input\n' +
    '                            type="checkbox"\n' +
    '                            class="right-checkbox"\n' +
    '                            ng-checked="editCtrl.shouldBeChecked(user._id)"\n' +
    '                            ng-click="editCtrl.addToCheckedUsers($event, user._id)">\n' +
    '                        <span class="checkbox-label" ng-if="editCtrl.shouldBeChecked(user._id)">{{ \'CLIENT_ADDED\' | translate }}</span>\n' +
    '                        <span class="checkbox-label" ng-if="!editCtrl.shouldBeChecked(user._id)">{{ \'ADD_CLIENT\' | translate }}</span>\n' +
    '                    </label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class=\'roster-load-more\' ng-if=\'editCtrl.clientsList.nextPage\'>\n' +
    '                <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '                {{ \'LOADING_MORE_CLIENTS\' | translate }}\n' +
    '              </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '        <div class="uncomplete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button-action"\n' +
    '                ng-click=\'editCtrl.submit()\' ng-disabled=\'!editCtrl.newMembershipGroupTitle\'>\n' +
    '                <div ng-if="!editCtrl.loading">\n' +
    '                    {{ \'SAVE\' | translate }}</div>\n' +
    '                <div ng-if="editCtrl.loading" class="roster-load-more__icon spinner-icon"></div>\n' +
    '            </button>\n' +
    '            <div class="button button-assertive button-clear pull-right"\n' +
    '                ng-click=\'editCtrl.dismiss()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/settings/tabs/permissionGroups/deleteGroup.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/permissionGroups/deleteGroup.html', '<div class="data-block__container modal--delete-acc__details" ng-if="group">\n' +
    '  <div class="data-block__info-container">\n' +
    '    <div class="data-block__info">\n' +
    '        <span class="data-block__info--input user-details__input--text">\n' +
    '          {{ :: group.name }}\n' +
    '        </span>\n' +
    '    </div>\n' +
    '    <div class="data-block__title">\n' +
    '      {{ :: \'GROUP_NAME\' | translate }}</div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/settings/tabs/permissions.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/permissions.html', '<div class="permission-groups"\n' +
    '  ng-controller="PermissionGroupsCtrl as  PermissionsCtrl">\n' +
    '\n' +
    '  <div class="permission-groups__content">\n' +
    '    \n' +
    '    <ng-form class="drop-down"\n' +
    '      ng-repeat="(i, permissionGroup) in PermissionsCtrl.permissionGroups"\n' +
    '      name=\'PermissionsCtrl.forms["{{ (permissionGroup._id || permissionGroup._virtualId) }}"]\'\n' +
    '      ng-show="!permissionGroup.isDeleted">\n' +
    '\n' +
    '      <div class="drop-down__group-container fade-onload">\n' +
    '\n' +
    '        <div class="drop-down__group-header">\n' +
    '          <input permission\n' +
    '            permission-only="permissionGroup._isNew ? \'PERMISSIONS_GROUPS_CREATE\' : \'PERMISSIONS_GROUPS_UPDATE\'"\n' +
    '            permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '            permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '            type="text"\n' +
    '            ng-model="permissionGroup.name"\n' +
    '            class="drop-down__group-title">\n' +
    '\n' +
    '          <div class="drop-down__group-button drop-down__group-button--hide"\n' +
    '            ng-class="{\'drop-down__group-button--hide--collapsed\': !permissionGroup.isExpanded}"\n' +
    '            ng-click="permissionGroup.isExpanded = !permissionGroup.isExpanded">\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="drop-down__group-button drop-down__group-button--remove"\n' +
    '            permission\n' +
    '            permission-only="\'PERMISSIONS_GROUPS_DELETE\'"\n' +
    '            ng-if="!permissionGroup.isDefault || !!permissionGroup._virtualId"\n' +
    '            ng-click="PermissionsCtrl.remove(permissionGroup)">\n' +
    '          </div>\n' +
    '\n' +
    '          <div permission\n' +
    '            permission-only="\'PERMISSIONS_GROUPS_CREATE\'"\n' +
    '            class="drop-down__group-button drop-down__group-button--copy"\n' +
    '            ng-click="PermissionsCtrl.copy(permissionGroup)">\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="drop-down__group-content" ng-if="permissionGroup.isExpanded">\n' +
    '          <div class="permission-groups__item-group-container"\n' +
    '            ng-repeat="(k, subject) in permissionGroup.subjects">\n' +
    '\n' +
    '            <div class="permission-groups__item-group-header">{{ :: subject.name | translate }}</div>\n' +
    '            <div class=\'permission-groups__item-group-options\'>\n' +
    '              <label class="checkbox-custom permission-groups__item-group-option"\n' +
    '                ng-repeat="(subjName, subjValue) in subject.options">\n' +
    '                <input permission\n' +
    '                  permission-only="permissionGroup._isNew ? \'PERMISSIONS_GROUPS_CREATE\' : \'PERMISSIONS_GROUPS_UPDATE\'"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  type="checkbox"\n' +
    '                  ng-model="subject.options[subjName]">\n' +
    '                <span class="checkbox-label">{{ :: subjName | translate }}</span>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </ng-form>\n' +
    '\n' +
    '    <div permission\n' +
    '      permission-only="\'PERMISSIONS_GROUPS_CREATE\'"\n' +
    '      ng-click="PermissionsCtrl.add()"\n' +
    '      class="button button-full button-large button-primary">\n' +
    '      {{ :: \'ADD_PERMISSION_GROUP\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="tab-footer footer-buttons"\n' +
    '    ng-show="PermissionsCtrl.formDirty()"\n' +
    '    permission\n' +
    '    permission-only="[\'PERMISSIONS_GROUPS_UPDATE\', \'PERMISSIONS_GROUPS_DELETE\', \'PERMISSIONS_GROUPS_CREATE\']">\n' +
    '    <div\n' +
    '      class="button button-action"\n' +
    '      ng-click="PermissionsCtrl.save()">\n' +
    '      {{::\'SAVE\'  | translate}}\n' +
    '    </div>\n' +
    '    <div\n' +
    '      class="button button-assertive button-clear pull-right"\n' +
    '      ng-click="PermissionsCtrl.reset()">\n' +
    '      {{::\'CANCEL\'  | translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/settings/tabs/risk.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/settings/tabs/risk.html', '<form\n' +
    '  ng-controller="RiskController as riskCtrl"\n' +
    '  ng-submit="riskCtrl.save(riskCtrl.risks)"\n' +
    '  name="riskCtrl.form">\n' +
    '  <div class="clearfix risk">\n' +
    '    <div ng-repeat="(risk, value) in riskCtrl.risks"\n' +
    '      class="risk__container">\n' +
    '      <div class="risk__title-container">\n' +
    '        <input class="data-block__info--input risk__input"\n' +
    '          permission\n' +
    '          permission-only="\'RISK_CALCULATIONS_UPDATE\'"\n' +
    '          permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '          permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '          type="number"\n' +
    '          min="1"\n' +
    '          step="1"\n' +
    '          ng-model="riskCtrl.risks[risk]">\n' +
    '        <span>\n' +
    '          {{ risk + \'_subject\'  | camelToSnakeCase | translate }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="risk__content-container">\n' +
    '        <b>{{ risk + \'_title\'  | camelToSnakeCase | translate }}</b>\n' +
    '        <div>\n' +
    '          {{ risk + \'_description\'  | camelToSnakeCase | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="footer-buttons">\n' +
    '    <input type="submit" class="button button-action"\n' +
    '     permission\n' +
    '     permission-only="\'RISK_CALCULATIONS_UPDATE\'"\n' +
    '     value="{{::\'SAVE\'  | translate}}"\n' +
    '     ng-show=\'riskCtrl.form.$dirty\'/>\n' +
    '    <div permission\n' +
    '         permission-only="\'RISK_CALCULATIONS_UPDATE\'"\n' +
    '         ng-show=\'riskCtrl.form.$dirty\'\n' +
    '         ng-click="riskCtrl.reset()"\n' +
    '         class="button button-clear button-assertive pull-right">\n' +
    '      {{::\'CANCEL\'  | translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/termsAndConditions/terms.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/termsAndConditions/terms.html', '<div ng-controller="TermsAndConditionsCtrl as termsCtrl">\n' +
    '  <div class="login__matrixImage">\n' +
    '    <span>\n' +
    '      <img\n' +
    '        src="{{termsCtrl.imageSrc}}" alt="MatrixIcon"\n' +
    '      />\n' +
    '    </span>\n' +
    '  </div>\n' +
    '  <div class="login__privacyPolicyLink">\n' +
    '    <span ng-click="termsCtrl.navigateToTermsOfUsePolicy()">\n' +
    '      {{ "TERMS_AND_CONDITIONS" | translate }}</span\n' +
    '    >\n' +
    '    <span>|</span>\n' +
    '    <span ng-click="termsCtrl.navigateToPrivacyPolicy()">\n' +
    '      {{ "PRIVACY_POLICY" | translate }}</span\n' +
    '    >\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="login__matrixFitnessLogo">\n' +
    '    © {{termsCtrl.date}} {{"MATRIX_FITNESS" | translate}}\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/termsOfUse/termsOfUse.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/termsOfUse/termsOfUse.html', '<div\n' +
    '  ng-controller="TermsOfUseController as termsOfUseCtrl"\n' +
    '  class="login__privacyPolicyPage"\n' +
    '>\n' +
    '  <div class="login__privacyPageBackDiv" ng-click="navigateToLoginPage()">\n' +
    '    <img src="{{imageSrc}}" alt="BackIcon" class="login__privacyBackButtonIcon">\n' +
    '    <span class="login__privacyBackButton">{{ "BACK" | translate | uppercase }}</span>\n' +
    '  </div>\n' +
    '  <div markdown-to-html="data" class="login__privacyPageDescription"></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/unsubscribe/unsubscribe.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/unsubscribe/unsubscribe.html', '<section class="login">\n' +
    '\n' +
    '    <header class="login__header">\n' +
    '      <h1 class="login__title">{{ "PERSONAL_TRAINER_PORTAL" | translate }}</h1>\n' +
    '    </header>\n' +
    '\n' +
    '    <div class="login__view">\n' +
    '        <div class="login__content login__form">\n' +
    '            {{ \'THANKYOU_MESSAGE\' | translate}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>');
  }]);
angular.module('/app/user/tabs/assignments/assignment-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/assignment-details.html', '<div class="assignments__exercise-container"\n' +
    '  ng-class="{\n' +
    '    \'assignments__exercise-container--assignment\': !assignment.trainingPlan\n' +
    '  }"\n' +
    '  ng-if="assignment.showDetails">\n' +
    '  <div ng-if="userCtrl.incompleteExercises(assignment.exercises) > 1" class="skip-complete-all-container">\n' +
    '    <div class="skip-all" ng-click="userCtrl.onMassCompleteAssignment(assignment.exercises, true, $event)">\n' +
    '      <div class="icon-skip"></div>\n' +
    '      {{ \'SKIP_ALL\' | translate | uppercase}}\n' +
    '    </div>\n' +
    '    <div class="complete-all" ng-click="userCtrl.onMassCompleteAssignment(assignment.exercises, false, $event)">\n' +
    '      <div class="icon-check"></div>\n' +
    '      {{ \'COMPLETE_ALL\' | translate | uppercase }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="assignments__exercise-card"\n' +
    '    ng-repeat="exercise in assignment.exercises"\n' +
    '    ng-class="{\n' +
    '    \'assignments__exercise--uncompleted\': exercise.completeState === \'not_complete\',\n' +
    '    \'assignments__exercise--passed\': assignment.isPassed\n' +
    '    }"\n' +
    '    ng-click="userCtrl.showCompletionState(assignment, exercise, plan)">\n' +
    '    <ng-include src="\'/app/user/tabs/assignments/metric-item.html\'"></ng-include>\n' +
    '    <div class="assignments__exercise-details"></div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/assignment-row.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/assignment-row.html', '<div class="assignments__assignment"\n' +
    '  ng-class="{\n' +
    '    \'assignments__assignment--open\': assignment.showDetails\n' +
    '  }"\n' +
    '  ng-click="assignment.showDetails = !assignment.showDetails">\n' +
    '  <div class="assignments__header-caption">{{assignment.title}}</div>\n' +
    '  <div class="assignments__header-caption">{{assignment.date}}</div>\n' +
    '  <div class="assignments__header-caption">{{assignment.completedCount}} / {{assignment.count}} {{\'EXERCISES\' | translate}}</div>\n' +
    '  <div ng-if="userCtrl.assignmentFromCurrentFacility(assignment)" class="assignments__header-caption assignments__header-caption--button-container">\n' +
    '    <div class="assignments__button assignments__button--delete"\n' +
    '      ng-click="userCtrl.onDeleteAssignment(assignment, $event)"\n' +
    '      ng-class="{\'assignments__button--disabled\' : assignment.isPassed}"></div>\n' +
    '    <div class="assignments__button assignments__button--print"\n' +
    '      ng-click="userCtrl.printAssignment(assignment, $event)"></div>\n' +
    '    <div class="assignments__button assignments__button--copy"\n' +
    '      permission\n' +
    '      permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '      ng-click="userCtrl.onCopyAssignment(assignment, $event)">\n' +
    '    </div>\n' +
    '    <div class="assignments__button assignments__button--edit"\n' +
    '      permission\n' +
    '      permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '      ng-class="{\'assignments__button--disabled\': assignment.isPassed}"\n' +
    '      ng-click="userCtrl.onEditAssigment(assignment, $event)">\n' +
    '    </div>\n' +
    '    <div class="assignments__button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': assignment.showDetails}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-if="!userCtrl.assignmentFromCurrentFacility(assignment)" class="assignments__header-caption assignments__header-caption--button-container">\n' +
    '      <div class="assignments__button assignments__button--facility">\n' +
    '        {{assignment.facility.name}}\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--show"\n' +
    '        ng-class="{\'assignments__button--collapsed\': assignment.showDetails}">\n' +
    '      </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/assignment-status-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/assignment-status-modal.html', '<!--HEADER-->\n' +
    '<div class="modal__popup-header assignment-status__header">\n' +
    '  <div ng-if="!workoutStatusController.selectedPlan" class="assignment-status__assignment-date-selector">\n' +
    '    <span class=\'timepicker-wrapper__control\'\n' +
    '      ng-click=\'workoutStatusController.selectAssignment(1)\'>\n' +
    '\n' +
    '      <i class="icon icon-triangle-left"></i>\n' +
    '    </span>\n' +
    '\n' +
    '    <span>{{workoutStatusController.selectedAssignment.date}}</span>\n' +
    '\n' +
    '    <span class=\'timepicker-wrapper__control\'\n' +
    '      ng-click=\'workoutStatusController.selectAssignment(-1)\'>\n' +
    '\n' +
    '      <i class="icon icon-triangle-right"></i>\n' +
    '    </span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-if="!workoutStatusController.selectedPlan" class="assignment-status__exercise-selector">\n' +
    '    <span class=\'timepicker-wrapper__control\'\n' +
    '      ng-click=\'workoutStatusController.selectExercise(-1)\'>\n' +
    '\n' +
    '      <i class="icon icon-triangle-left"></i>\n' +
    '    </span>\n' +
    '\n' +
    '    <span>\n' +
    '      {{ workoutStatusController.selectedExerciseIndex + 1 }}\n' +
    '      of\n' +
    '      {{ workoutStatusController.selectedAssignment.exercises.length }}\n' +
    '    </span>\n' +
    '\n' +
    '    <span class=\'timepicker-wrapper__control\'\n' +
    '      ng-click=\'workoutStatusController.selectExercise(1)\'>\n' +
    '\n' +
    '      <i class="icon icon-triangle-right"></i>\n' +
    '    </span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="modal__popup-header--exit icon icon-cross"\n' +
    '    ng-click="workoutStatusController.closeModal()"></div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!--CONTENT-->\n' +
    '\n' +
    '<div class="modal__content-template assignment-status clearfix">\n' +
    '\n' +
    '  <div class="assignment-status__title">\n' +
    '    {{ workoutStatusController.selectedExercise.title }}\n' +
    '  </div>\n' +
    '\n' +
    '  <!--ASSIGNED-->\n' +
    '  <div class="assignment-status__column assignment-status__assigned-stats clearfix" ng-if="!workoutStatusController.editState">\n' +
    '\n' +
    '    <div class="data-block__header">\n' +
    '      {{ :: \'ASSIGNED\' | translate }}\n' +
    '    </div>\n' +
    '    <div class="flex-grid" ng-repeat="segment in workoutStatusController.selectedExercise.assignedProfile.segments"\n' +
    '      ng-if="(!workoutStatusController.exerciseIsStrength() && !workoutStatusController.exerciseIsFunctional())\n' +
    '      && workoutStatusController.selectedExercise.assignedProfile.segments.length > 0">\n' +
    '      <div class="assignment-status__exercise-param assignment-status__exercise-param--value flex-grid-col">\n' +
    '        {{ \'INTERVAL\' | translate}} {{$index + 1}}\n' +
    '      </div>\n' +
    '      <div class="flex-grid-col" ng-repeat="item in workoutStatusController.nonStrengthFields" ng-if="segment[item.field] > -1">\n' +
    '        <div class="assignment-status__exercise-param">\n' +
    '          <div class="assignment-status__exercise-param--value">\n' +
    '            {{ segment[item.field] }}\n' +
    '            <span class="assignment-status__exercise-param--units">\n' +
    '              {{ workoutStatusController.selectedExercise.assignedData[item.field].unit }}\n' +
    '            </span>\n' +
    '          </div>\n' +
    '          <div class="assignment-status__exercise-param--name">\n' +
    '            {{ :: item.translation | translate }}\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="flex-grid" ng-if="(!workoutStatusController.exerciseIsStrength() && !workoutStatusController.exerciseIsFunctional())\n' +
    '    && workoutStatusController.selectedExercise.assignedProfile.segments.length < 1">\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col"\n' +
    '           ng-repeat="item in workoutStatusController.selectedExercise.displayData"\n' +
    '           ng-show="workoutStatusController.isShowable(item)">\n' +
    '          <div class="assignment-status__exercise-param--value">{{ item.value }}</div>\n' +
    '          <div class="assignment-status__exercise-param--name">\n' +
    '            {{ item.title }}\n' +
    '          </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="flex-grid" ng-if="workoutStatusController.exerciseIsStrength()\n' +
    '      && workoutStatusController.selectedExercise.assignedProfile.segments.length"\n' +
    '      ng-repeat="set in workoutStatusController.selectedExercise.assignedProfile.segments">\n' +
    '      <div class="assignment-status__exercise-param assignment-status__exercise-param--value flex-grid-col">\n' +
    '        {{ \'SET\' | translate}} {{$index + 1}}\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          {{ set.weight }}\n' +
    '          <span class="assignment-status__exercise-param--units">\n' +
    '            {{  workoutStatusController.weightUnit | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          {{ \'WEIGHT\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          {{ set.reps }}\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          {{ \'REPS\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          {{ set.restTime }}\n' +
    '          <span class="assignment-status__exercise-param--units">\n' +
    '            {{ \'SEC\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          {{ \'REST_TIME\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="flex-grid" ng-if="workoutStatusController.exerciseIsFunctional()\n' +
    '    && workoutStatusController.selectedExercise.assignedProfile.segments.length"\n' +
    '    ng-repeat="set in workoutStatusController.selectedExercise.assignedProfile.segments">\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '      <div class="assignment-status__exercise-param--value">\n' +
    '        {{ \'SET\' | translate}} {{$index + 1}}\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param--name">\n' +
    '        {{ workoutStatusController.getSetTypeTranslation(set.type) }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '      <div class="assignment-status__exercise-param--value">\n' +
    '        {{ set.weight }}\n' +
    '        <span class="assignment-status__exercise-param--units">\n' +
    '          {{  workoutStatusController.weightUnit | translate }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param--name">\n' +
    '        {{ \'WEIGHT\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.reps">\n' +
    '      <div class="assignment-status__exercise-param--value">\n' +
    '        {{ set.reps }}\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param--name">\n' +
    '        {{ \'REPS\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col" ng-if="!set.reps"></div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.type === \'asManyReps\'">\n' +
    '      <div class="assignment-status__exercise-param--value">\n' +
    '        {{ set.duration }}\n' +
    '        <span class="assignment-status__exercise-param--units">\n' +
    '          {{ \'SEC\' | translate }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param--name">\n' +
    '        {{ \'DURATION\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.type !== \'asManyReps\'"></div>\n' +
    '    <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '      <div class="assignment-status__exercise-param--value">\n' +
    '        {{ set.restTime }}\n' +
    '        <span class="assignment-status__exercise-param--units">\n' +
    '          {{ \'SEC\' | translate }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param--name">\n' +
    '        {{ \'REST_TIME\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!--COMPLETED-->\n' +
    '  <div class="assignment-status__column assignment-status__completed-stats clearfix" ng-if="!workoutStatusController.editState">\n' +
    '\n' +
    '    <div class="data-block__header">\n' +
    '      <span>{{ :: \'ACCOMPLISHED\' | translate }}</span>\n' +
    '      <span class="assignments__change"  ng-if="workoutStatusController.canEditData()" ng-click="workoutStatusController.toggleEdit()"></span>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div ng-if="workoutStatusController.isSkipped(workoutStatusController.selectedExercise)"\n' +
    '      style="color:red; text-align: center;">\n' +
    '      {{\'EXERCISE_SKIPPED\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="flex-grid" ng-if="!workoutStatusController.exerciseIsStrength() && !workoutStatusController.exerciseIsFunctional() && workoutStatusController.selectedExercise.completedProfile">\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col"\n' +
    '        ng-repeat="item in workoutStatusController.selectedExercise.displayData"\n' +
    '        ng-show="workoutStatusController.isShowable(item)">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-class="{\n' +
    '            \'greater\': item.comparison === 1,\n' +
    '            \'less\': item.comparison === -1\n' +
    '          }">{{ item.completedValue ? item.completedValue : item.value }}</span>\n' +
    '          <span class="assignment-status__exercise-param--units" ng-if="item.unit">{{ item.unit }} </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          {{ item.title }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="workoutStatusController.exerciseIsStrength()\n' +
    '      && workoutStatusController.selectedExercise.completedProfile.segments.length"\n' +
    '      ng-repeat="set in workoutStatusController.selectedExercise.completedProfile.segments" class="flex-grid">\n' +
    '      <div class="assignment-status__exercise-param assignment-status__exercise-param--value flex-grid-col">\n' +
    '        {{ \'SET\' | translate}} {{$index + 1}}\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet" ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'weight\', set.weight)">\n' +
    '            {{ set.weight }}\n' +
    '            <span class="assignment-status__exercise-param--units">\n' +
    '              {{ workoutStatusController.weightUnit | translate }}\n' +
    '            </span>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'weight\', set.weight)">\n' +
    '            {{ \'WEIGHT\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet" ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'reps\', set.reps)" >\n' +
    '            {{ set.reps }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'reps\', set.reps)">\n' +
    '            {{ \'REPS\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet">\n' +
    '              {{ set.restTime }}\n' +
    '              <span class="assignment-status__exercise-param--units">\n' +
    '                {{ \'SEC\' | translate }}\n' +
    '              </span>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span>\n' +
    '            {{ \'REST_TIME\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="workoutStatusController.exerciseIsFunctional()\n' +
    '      && workoutStatusController.selectedExercise.completedProfile.segments.length"\n' +
    '      ng-repeat="set in workoutStatusController.selectedExercise.completedProfile.segments" class="flex-grid">\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          {{ \'SET\' | translate}} {{$index + 1}}\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          {{ workoutStatusController.getSetTypeTranslation(set.type) }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet" ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'weight\', set.weight)">\n' +
    '            {{ set.weight }}\n' +
    '            <span class="assignment-status__exercise-param--units">\n' +
    '              {{ workoutStatusController.weightUnit | translate }}\n' +
    '            </span>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'weight\', set.weight)">\n' +
    '            {{ \'WEIGHT\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.reps">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet" ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'reps\', set.reps)" >\n' +
    '            {{ set.reps }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'reps\', set.reps)">\n' +
    '            {{ \'REPS\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col" ng-if="!set.reps"></div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.type === \'asManyReps\'">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet" ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'duration\', set.duration)" >\n' +
    '            {{ set.duration }}\n' +
    '            <span class="assignment-status__exercise-param--units">\n' +
    '              {{ \'SEC\' | translate }}\n' +
    '            </span>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span ng-class="workoutStatusController.compareStrengthExercise(workoutStatusController.selectedExercise.assignedProfile, $index, \'duration\', set.duration)">\n' +
    '            {{ \'DURATION\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col" ng-if="set.type !== \'asManyReps\'"></div>\n' +
    '      <div class="assignment-status__exercise-param flex-grid-col">\n' +
    '        <div class="assignment-status__exercise-param--value">\n' +
    '          <span ng-if="set.missingSet" class="less">- -</span>\n' +
    '          <span ng-if="!set.missingSet">\n' +
    '              {{ set.restTime }}\n' +
    '              <span class="assignment-status__exercise-param--units">\n' +
    '                {{ \'SEC\' | translate }}\n' +
    '              </span>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="assignment-status__exercise-param--name">\n' +
    '          <span>\n' +
    '            {{ \'REST_TIME\' | translate }}\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!--EDIT-->\n' +
    '  <div class="assignment-status__edit-stats clearfix" ng-if="workoutStatusController.editState">\n' +
    '    <div class="data-block__header data-block__header-edit">\n' +
    '      <span class="data-block__header--clickable" ng-click="workoutStatusController.toggleEdit()">{{ :: \'BACK\' | translate }}</span>\n' +
    '      <span class="data-block__header--button" ng-click="workoutStatusController.saveCompletionData()">{{ :: \'SAVE\' | translate }}</span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="workoutStatusController.exerciseIsStrength()">\n' +
    '      <advanced-strength\n' +
    '        sets="workoutStatusController.editableProfile.segments"\n' +
    '        on-update="workoutStatusController.completedSegmentsEdit($event)">\n' +
    '      </advanced-strength>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="workoutStatusController.exerciseIsFunctional()">\n' +
    '      <customize-functional\n' +
    '        sets="workoutStatusController.editableProfile.segments"\n' +
    '        on-update="workoutStatusController.completedSegmentsEdit($event)">\n' +
    '      </customize-functional>\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-if="!workoutStatusController.exerciseIsStrength() && !workoutStatusController.exerciseIsFunctional()">\n' +
    '      <metric-edit\n' +
    '        profile="workoutStatusController.editableProfile"\n' +
    '        display-metrics="workoutStatusController.selectedExercise.displayData"\n' +
    '        on-update="workoutStatusController.completedProfileEdit($event)"\n' +
    '      ></metric-edit>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="modal__content-template assignment-status clearfix" ng-if="!workoutStatusController.editState">\n' +
    '  <div class="assignment-status__column"\n' +
    '    ng-if="workoutStatusController.selectedExercise.description">\n' +
    '\n' +
    '    <div class="data-block__header">\n' +
    '      {{ :: \'ASSIGNED_DESCRIPTION\' | translate }}\n' +
    '    </div>\n' +
    '\n' +
    '    <pre class="assignment-status__exercise-param--user-feedback"\n' +
    '      ng-bind="workoutStatusController.selectedExercise.description">\n' +
    '    </pre>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignment-status__column"\n' +
    '    ng-if="workoutStatusController.selectedExercise.exerciserDescription">\n' +
    '\n' +
    '    <div class="data-block__header">\n' +
    '      {{ :: \'ACCOMPLISHED_DESCRIPTION\' | translate }}\n' +
    '    </div>\n' +
    '\n' +
    '    <pre class="assignment-status__exercise-param--user-feedback"\n' +
    '      ng-bind="workoutStatusController.selectedExercise.exerciserDescription">\n' +
    '    </pre>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="assignment-status__feedback"\n' +
    '  ng-if="!workoutStatusController.editState && workoutStatusController.selectedExercise.feedback">\n' +
    '\n' +
    '  <div class="data-block__header">\n' +
    '    {{ :: \'USER_WORKOUT_FEEDBACK\' | translate }}\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignment-status__exercise-param--emoji" ng-if="workoutStatusController.selectedExercise.emoji">\n' +
    '    {{workoutStatusController.selectedExercise.emoji}}\n' +
    '  </div>\n' +
    '\n' +
    '  <pre class="assignment-status__exercise-param--user-feedback"\n' +
    '    ng-bind="workoutStatusController.selectedExercise.feedback">\n' +
    '  </pre>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/assignments.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/assignments.html', '<div class="assignments"\n' +
    '  ng-init=\'userCtrl.initialLoadAssignments()\'\n' +
    '  infinite-scroll=\'userCtrl.loadAssignments()\'\n' +
    '  can-load=\'userCtrl.assignments.nextPage && !userCtrl.initialLoad\'\n' +
    '  threshold=\'30\'>\n' +
    '\n' +
    '  <div class="assignments__header">\n' +
    '    <div class="assignments__header-text">{{\'ASSIGNED\' | translate}}</div>\n' +
    '    <div class="assignments__header-text">{{\'DATE_RANGE\' | translate}}</div>\n' +
    '    <div class="assignments__header-text">{{\'COMPLETED\' | translate}}</div>\n' +
    '    <div class="assignments__header-text"></div> <!--for controls-->\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__section"\n' +
    '    ng-click="userCtrl.showFuture = !userCtrl.showFuture">\n' +
    '    <div class="assignments__section-label">{{ \'FUTURE_ASSIGNMENTS\' | translate }}</div>\n' +
    '    <div class="assignments__button assignments__section-button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': userCtrl.showFuture}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__future-assignments-list" ng-if="userCtrl.showFuture">\n' +
    '    <div class=\'roster-load-more\' ng-if=\'userCtrl.assignments.items[userCtrl.assignments.items.length-1].isPassed == false\'>\n' +
    '      <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '        {{ :: \'LOADING_MORE_FUTURE_WORKOUTS\' | translate }}\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-repeat="assignment in userCtrl.futureAssignments | orderBy:\'startDate\' track by assignment._id "\n' +
    '      ng-class="{\n' +
    '        \'assignments__other-facility\': !userCtrl.assignmentFromCurrentFacility(assignment) && !assignment.showDetails,\n' +
    '        \'assignments__other-facility--no-border\': !userCtrl.assignmentFromCurrentFacility(assignment) && assignment.showDetails,\n' +
    '      }"\n' +
    '      class="assignments__future-assignment-container">\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/assignment-row.html\'"></ng-include>\n' +
    '      <ng-include class="assignment__exercise-container--assignment" src="\'/app/user/tabs/assignments/assignment-details.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__section"\n' +
    '    ng-click="userCtrl.showPast = !userCtrl.showPast">\n' +
    '    <div class="assignments__section-label">{{ \'WORKOUT_HISTORY\' | translate }}</div>\n' +
    '    <div class="assignments__button assignments__section-button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': userCtrl.showPast}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__past-assignments-list" ng-if="userCtrl.showPast">\n' +
    '    <div ng-repeat="assignment in userCtrl.pastAssignments track by $index"\n' +
    '      ng-class="{\n' +
    '        \'assignments__other-facility\': !userCtrl.assignmentFromCurrentFacility(assignment) && !assignment.showDetails,\n' +
    '        \'assignments__other-facility--no-border\': !userCtrl.assignmentFromCurrentFacility(assignment) && assignment.showDetails,\n' +
    '      }"\n' +
    '      class="assignments__past-assignment-container">\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/assignment-row.html\'"></ng-include>\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/assignment-details.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class=\'calendar-loader\' ng-if=\'userCtrl.completeSkipLoading\'>\n' +
    '    <div class=\'calendar-loader__icon spinner-icon\'></div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=\'roster-load-more\' ng-if=\'userCtrl.assignments.nextPage || scrollLoadingRequired\'>\n' +
    '    <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '    {{ :: \'LOADING_MORE_WORKOUTS\' | translate }}\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/combined-tab.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/combined-tab.html', '<div>\n' +
    '    <div class="combined__btn-container">\n' +
    '        <div ng-click="userCtrl.changeSubtab(\'assignments\')"\n' +
    '            class="combined__btn"\n' +
    '            ng-class="{ \'combined__btn--active\': userCtrl.selectedAssignmentSubtab === \'assignments\' }">\n' +
    '            {{ \'ASSIGNMENTS\' | translate }}\n' +
    '        </div>\n' +
    '        <div ng-click="userCtrl.changeSubtab(\'training-plans\')"\n' +
    '            class="combined__btn"\n' +
    '            ng-class="{ \'combined__btn--active\': userCtrl.selectedAssignmentSubtab === \'training-plans\' }">\n' +
    '            {{ \'TRAINING_PROGRAMS\' | translate }}\n' +
    '        </div>\n' +
    '        <div ng-click="userCtrl.changeSubtab(\'workout-history\')"\n' +
    '            ng-if="userCtrl.workoutHistoryEnabled && userCtrl.facilityWorkoutHistoryEnabled"\n' +
    '            class="combined__btn"\n' +
    '            ng-class="{ \'combined__btn--active\': userCtrl.selectedAssignmentSubtab === \'workout-history\' }">\n' +
    '            {{ \'HISTORY\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-if="userCtrl.selectedAssignmentSubtab === \'assignments\'">\n' +
    '        <ng-include src="\'/app/user/tabs/assignments/assignments.html\'"></ng-include>\n' +
    '    </div>\n' +
    '    <div ng-if="userCtrl.selectedAssignmentSubtab === \'training-plans\'">\n' +
    '        <ng-include src="\'/app/user/tabs/assignments/training-programs.html\'"></ng-include>\n' +
    '    </div>\n' +
    '    <div ng-if="userCtrl.selectedAssignmentSubtab === \'workout-history\'">\n' +
    '        <ng-include src="\'/app/user/tabs/assignments/workout-history.html\'"></ng-include>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/create-assignment-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/create-assignment-modal.html', '<div>\n' +
    '  <form ng-submit=\'close()\'>\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--title">{{ title }}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross"\n' +
    '        ng-click="close()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'modal__content\'>\n' +
    '      <div class=\'modal__content-description\'\n' +
    '        ng-repeat=\'error in errors\'>{{ error }}</div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <button type=\'submit\' autofocus \n' +
    '      class="button button-action">\n' +
    '        <i class="roster-load-more__icon spinner-icon"\n' +
    '          ng-if="isLoading">\n' +
    '        </i>\n' +
    '        {{ okText }}\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/delete-assignment-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/delete-assignment-modal.html', '<div>\n' +
    '    <form ng-submit=\'ok()\'>\n' +
    '        <div class="modal__popup-header">\n' +
    '            <div class="modal__popup-header--title">\n' +
    '                {{ \'DELETE_THIS_ASSIGNMENT?\' | translate }}\n' +
    '            </div>\n' +
    '            <div class="modal__popup-header--exit icon icon-cross"\n' +
    '                ng-click="deleteAssignmentModalController.cancel()"></div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="modal__content">\n' +
    '            <div class="modal__content-description">\n' +
    '                <div ng-if="deleteAssignmentModalController.hasRecurrence">\n' +
    '                    {{ \'ASSIGNMENT_MULTIPLE_OCCURRENCES\' | translate}}\n' +
    '                </div>\n' +
    '                <div ng-if="!deleteAssignmentModalController.hasRecurrence">\n' +
    '                    {{ \'PLEASE_CONFIRM_DELETE_ASSIGNMENT\' | translate }}\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="modal__content-recurrence" ng-if="deleteAssignmentModalController.hasRecurrence">\n' +
    '                <div class=\'modal__content-radio-group\'>\n' +
    '                    <div>\n' +
    '                        <input ng-model="deleteAssignmentModalController.deleteAllOccurrences"\n' +
    '                            type="radio"\n' +
    '                            ng-value="false"\n' +
    '                            name="cancel" /><label>{{ \'DELETE_CURRENT_OCCURRENCE\' | translate }}</label>\n' +
    '                    </div>\n' +
    '                    <div>\n' +
    '                        <input ng-model="deleteAssignmentModalController.deleteAllOccurrences"\n' +
    '                            type="radio"\n' +
    '                            ng-value="true"\n' +
    '                            name="cancel"><label>{{ \'DELETE_ALL_OCCURRENCES\' | translate }}</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="modal__content-multiple-users" ng-if="deleteAssignmentModalController.hasMultipleUsers">\n' +
    '                {{ \'DELETE_FOR_ALL_USERS\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="footer-buttons">\n' +
    '            <button type=\'submit\' autofocus class="button button-action" ng-click=\'deleteAssignmentModalController.submit()\'>\n' +
    '                {{ \'DELETE\' | translate }}\n' +
    '            </button>\n' +
    '        \n' +
    '            <div class="button button-assertive button-clear pull-right" ng-click=\'deleteAssignmentModalController.cancel()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/delete-training-plan-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/delete-training-plan-modal.html', '<div>\n' +
    '  <form ng-submit=\'ok()\'>\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--title">{{ \'HOW_DO_YOU_WANT_TO_PROCEED\' | translate }}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross"\n' +
    '           ng-click="deleteTrainingPlanController.cancel()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'modal__content\'>\n' +
    '      <div class=\'modal__content-description\'>\n' +
    '        {{ \'DELETE_TRAINING_PLAN_MODAL_DESCRIPTION\' | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class=\'modal__content-controls\'>\n' +
    '        <div class=\'modal__content-radio-group\'>\n' +
    '          <div>\n' +
    '            <input ng-model="deleteTrainingPlanController.endEarly"\n' +
    '                   type="radio"\n' +
    '                   ng-value="true"\n' +
    '                   name="cancel" /><label>{{ \'END_EARLY_OPTION\' | translate }}</label>\n' +
    '          </div>\n' +
    '          <div>\n' +
    '            <input ng-model="deleteTrainingPlanController.endEarly"\n' +
    '                   type="radio"\n' +
    '                   ng-value="false"\n' +
    '                   name="cancel"><label>{{ \'DELETE_OPTION\' | translate }}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'modal__content-checkbox\'>\n' +
    '          <input ng-model="deleteTrainingPlanController.allUsers"\n' +
    '                 type="checkbox"><label>{{ \'DELETE_PROGRAM_ALL_CLIENTS\' | translate }}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <button type=\'submit\' autofocus\n' +
    '              class="button button-action"\n' +
    '              ng-click=\'deleteTrainingPlanController.submit()\'>\n' +
    '        {{ deleteTrainingPlanController.endEarly ? \'END_TRAINING_PROGRAM_EARLY_BUTTON\' : \'DELETE_TRAINING_PLAN_BUTTON\' | translate }}\n' +
    '      </button>\n' +
    '\n' +
    '      <div class="button button-assertive button-clear pull-right"\n' +
    '           ng-click=\'deleteTrainingPlanController.cancel()\'>\n' +
    '        {{ \'CANCEL\' | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/extend-training-plan-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/extend-training-plan-modal.html', '<div>\n' +
    '  <form ng-submit="ok()">\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--title">{{ \'EXTEND_YOUR_TRAINING_PROGRAM\' | translate }}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross"\n' +
    '           ng-click="extendTrainingPlanController.cancel()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=\'modal__content\'>\n' +
    '      <div class=\'modal__content-description  modal__extend-plan\'>\n' +
    '        <div>\n' +
    '          <div class="pull-left">{{ \'TRAINING_PROGRAM\' | translate }}:</div>\n' +
    '          <div class="pull-right"><b>{{ extendTrainingPlanController.trainingProgram.planName }}</b></div>\n' +
    '        </div>\n' +
    '        <div class="modal__extend-plan--weeks">\n' +
    '          <div class="pull-left">{{ \'CURRENT_NUMBER_OF_WEEKS\' | translate }}:</div>\n' +
    '          <div class="pull-right"><b>{{ extendTrainingPlanController.trainingProgram.repeats }}</b></div>\n' +
    '        </div>\n' +
    '        <div class="modal__extend-plan--select-ext">\n' +
    '          <div class="pull-left">{{ \'SELECT_NUM_WEEKS_TO_EXTEND\' | translate }}:</div>\n' +
    '          <select class="pull-right" ng-model="extendTrainingPlanController.numWeeks" ng-options="week for week in extendTrainingPlanController.weekOptions">\n' +
    '          </select>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <div class="button button-assertive button-clear pull-left"\n' +
    '            ng-click=\'extendTrainingPlanController.cancel()\'>\n' +
    '        {{ \'CANCEL\' | translate }}\n' +
    '      </div>\n' +
    '      <button type=\'submit\' autofocus\n' +
    '              class="button button-action pull-right"\n' +
    '              ng-click=\'extendTrainingPlanController.submit()\'>\n' +
    '        {{ \'SAVE_CHANGES\' | translate }}\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/mass-complete-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/mass-complete-modal.html', '<div>\n' +
    '    <div class="modal__popup-header">\n' +
    '        <div class="modal__popup-header--title">\n' +
    '            <div>{{ \'ARE_YOU_SURE\' | translate }}</div>\n' +
    '        </div>\n' +
    '        <div class="modal__popup-header--exit icon icon-cross" ng-click="massCompleteModalController.cancel()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        <div class="modal__content-description">\n' +
    '            <div ng-if="massCompleteModalController.isSkip" class="skip-description">{{ \'SKIP_ALL_DESCRIPTION\' | translate }}</div>\n' +
    '            <div ng-if="!massCompleteModalController.isSkip" class="complete-description">{{ \'COMPLETE_ALL_DESCRIPTION\' | translate }}</div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '        <div class="uncomplete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button-action"\n' +
    '                ng-click=\'massCompleteModalController.submit()\'>\n' +
    '                <div ng-if="massCompleteModalController.isSkip && !massCompleteModalController.loading">{{ \'SKIP_ALL_EXERCISES\' | translate }}</div>\n' +
    '                <div ng-if="!massCompleteModalController.isSkip && !massCompleteModalController.loading">{{ \'COMPLETE_ALL_EXERCISES\' | translate }}</div>\n' +
    '                <div ng-if="massCompleteModalController.loading" class="roster-load-more__icon spinner-icon"></div>\n' +
    '            </button>\n' +
    '            <div class="button button-assertive button-clear pull-right"\n' +
    '                ng-click=\'massCompleteModalController.cancel()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/metric-item.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/metric-item.html', '<div class="assignments__exercise-count-container">\n' +
    '  <span class="assignments__exercise-count-container--index">{{$index+1}}</span>\n' +
    '</div>\n' +
    '<div class="assignments__exercise-details"\n' +
    '     ng-class="{\n' +
    '      \'assignments__exercise-complete-green-bar\': exercise.completeState !== \'not_complete\' && !userCtrl.isExerciseSkipped(exercise),\n' +
    '      \'assignments__exercise-skipped-yellow-bar\': exercise.completeState !== \'not_complete\' && userCtrl.isExerciseSkipped(exercise)\n' +
    '    }">\n' +
    '  <div class="assignments__exercise-title-container">\n' +
    '    <div class="assignments__exercise-details__exercise-title">\n' +
    '      {{exercise.title}}\n' +
    '    </div>\n' +
    '    <div class="assignments__exercise-checkbox">\n' +
    '      <div ng-if="exercise.completedDate" class="assignments__exercise-complete-date">{{exercise.completedDate | dateFormatter: \'dateShort\'}}</div>\n' +
    '      <img class="assignments__exercise-title-img"\n' +
    '            ng-src="{{(exercise.completeState !== \'not_complete\') ? \'//images.jhtassets.com/7b31cab26903dd249e70020b877c375950619a20/\' : \'//images.jhtassets.com/784df7de262dee8663e219eb6f1524f486050dac/\'}}"\n' +
    '            ng-click="userCtrl.onCompleteExercise(exercise, $event)">\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="assignments__exercise-details__exercise-params">\n' +
    '    <div ng-if="exercise.completeState !== \'not_complete\' && userCtrl.isExerciseSkipped(exercise)">\n' +
    '      {{\'EXERCISE_SKIPPED\' | translate}}\n' +
    '    </div>\n' +
    '    <div ng-if="!userCtrl.isExerciseSkipped(exercise)">\n' +
    '      <div ng-repeat="item in exercise.displayData"\n' +
    '           class="assignments__exercise-details__exercise-param">\n' +
    '        <div ng-if="userCtrl.isShowable(item)" class="assignments__exercise-param-val">\n' +
    '          <span ng-class="{\n' +
    '            \'assignments__exercise-param-val--greater\': item.comparison === 1,\n' +
    '            \'assignments__exercise-param-val--less\': item.comparison === -1\n' +
    '          }">{{ item.completedValue ? item.completedValue: item.value }}</span>\n' +
    '          <span class="assignments__exercise-param-unit" ng-if="item.unit">{{ item.unit }}</span>\n' +
    '        </div>\n' +
    '        <div ng-if="userCtrl.isShowable(item)" class="assignments__exercise-param-name">{{ item.title }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/skip-complete-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/skip-complete-modal.html', '<div>\n' +
    '    <div class="modal__popup-header">\n' +
    '        <div class="modal__popup-header--title">\n' +
    '            <div ng-if="completeExerciseModalController.isCompleted && completeExerciseModalController.hasId" \n' +
    '                class="uncomplete-exercise">\n' +
    '                {{ \'MARK_EXERCISE_INCOMPLETE\' | translate }}\n' +
    '            </div>\n' +
    '            <div ng-if="!completeExerciseModalController.isCompleted && completeExerciseModalController.hasId"\n' +
    '                class="complete-exercise">\n' +
    '                {{ \'MARK_EXERCISE_COMPLETE_OR_SKIPPED\' | translate}}\n' +
    '            </div>\n' +
    '            <div ng-if="!completeExerciseModalController.hasId" \n' +
    '                class="uncomplete-exercise">\n' +
    '                {{\'CANNOT_COMPLETE_EXERCISE\' | translate}}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="modal__popup-header--exit icon icon-cross" ng-click="completeExerciseModalController.cancel()">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        <div class="modal__content-description">\n' +
    '            <div ng-if="completeExerciseModalController.isCompleted && completeExerciseModalController.hasId"\n' +
    '                class="uncomplete-exercise">\n' +
    '                {{ \'CONFIRM_MARK_EXERCISE_INCOMPLETE\' | translate }}\n' +
    '            </div>\n' +
    '            <div ng-if="!completeExerciseModalController.isCompleted && completeExerciseModalController.hasId"\n' +
    '                class="complete-exercise">\n' +
    '                {{ \'CONFIRM_MARK_EXERCISE_COMPLETE_OR_SKIPPED\' | translate }}\n' +
    '            </div>\n' +
    '            <div ng-if="!completeExerciseModalController.hasId"\n' +
    '                class="uncomplete-exercise">\n' +
    '                {{\'CANNOT_COMPLETE_EXERCISE_DESCRIPTION\' | translate}}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '        <div ng-if="completeExerciseModalController.isCompleted && completeExerciseModalController.hasId"\n' +
    '            class="uncomplete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button-action" ng-click=\'completeExerciseModalController.uncomplete()\'>\n' +
    '                {{ \'UNCOMPLETE\' | translate }}\n' +
    '            </button>\n' +
    '            \n' +
    '            <div class="button button-assertive button-clear pull-right" ng-click=\'completeExerciseModalController.cancel()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div ng-if="!completeExerciseModalController.isCompleted && completeExerciseModalController.hasId"\n' +
    '            class="complete-exercise">\n' +
    '            <button type=\'submit\' autofocus class="button button action skip-button" ng-click=\'completeExerciseModalController.skip()\'>\n' +
    '                <div class="icon-skip icon-skip__modal"></div>\n' +
    '                <div>{{ \'SKIP\' | translate }}</div>\n' +
    '            </button>\n' +
    '            <button type=\'submit\' autofocus class="button button action complete-button" ng-click=\'completeExerciseModalController.complete()\'>\n' +
    '                <div class="icon-check icon-check__modal"></div>\n' +
    '                <div>{{ \'COMPLETE\' | translate }}</div>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '        <div ng-if="!completeExerciseModalController.hasId"\n' +
    '            class="uncomplete-exercise">   \n' +
    '            <div class="button button-assertive button-clear pull-right" ng-click=\'completeExerciseModalController.cancel()\'>\n' +
    '                {{ \'CANCEL\' | translate }}\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/training-program-container.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/training-program-container.html', '<div class="training-plan">\n' +
    '  <div class="training-plan__bar"\n' +
    '    ng-click="userCtrl.togglePlan(plan)"\n' +
    '    ng-class="{\n' +
    '      \'training-plan__bar--open\': plan.showDetails && userCtrl.assignmentFromCurrentFacility(plan),\n' +
    '      \'training-plan__bar--other-facility\': !userCtrl.assignmentFromCurrentFacility(plan)\n' +
    '    }">\n' +
    '    <div class="training-plan__bar-info">{{ plan.planName }}</div>\n' +
    '    <div class="training-plan__bar-info" ng-if="plan.completionDate">{{ plan.completionDate | dateFormatter:\'dateLong\' }}</div>\n' +
    '    <div class="training-plan__bar-info" ng-if="!plan.completionDate">{{ plan.startDate | dateFormatter:\'dateLong\' }}</div>\n' +
    '    <div class="training-plan__bar-info" ng-if="plan.activeWeek">{{ plan.activeWeek }}</div>\n' +
    '    <div class="training-plan__bar-info" ng-if="!plan.activeWeek"></div>\n' +
    '    <div class="training-plan__bar-info" ng-if="!userCtrl.assignmentFromCurrentFacility(plan)">\n' +
    '      {{ plan.facility.name }}\n' +
    '    </div>\n' +
    '    <div class="training-plan__bar-info" ng-if="userCtrl.assignmentFromCurrentFacility(plan)"></div>\n' +
    '    <div class="training-plan__bar-arrow">\n' +
    '      <div class="training-plan__bar-arrow--up" ng-if="plan.showDetails"></div>\n' +
    '      <div class="training-plan__bar-arrow--down" ng-if="!plan.showDetails"></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="training-plan__details" ng-if="plan.showDetails">\n' +
    '    <div class="training-plan__button-bar-placeholder" ng-if="userCtrl.assignmentFromCurrentFacility(plan)"></div>\n' +
    '    <div class="training-plan__button-bar" ng-if="userCtrl.assignmentFromCurrentFacility(plan)">\n' +
    '      <div class="assignments__button assignments__button--large assignments__button--print"\n' +
    '        ng-click="userCtrl.printPlan(plan, $event)">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large assignments__button--copy"\n' +
    '        permission\n' +
    '        permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '        ng-click="userCtrl.onCopyPlan(plan, $event)">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large assignments__button--extend"\n' +
    '            ng-if="userCtrl.planIsActive(plan)"\n' +
    '            permission\n' +
    '            permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '            ng-click="userCtrl.extendPlan(plan, $event)">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large assignments__button--edit"\n' +
    '        ng-if="plan.status !== \'Cancelled\'"\n' +
    '        permission\n' +
    '        permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '        ng-class="{\'assignments__button--disabled\': assignment.isPassed}"\n' +
    '        ng-click="userCtrl.onEditPlan(plan, $event)">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large"\n' +
    '        ng-if="plan.status === \'Cancelled\'">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large assignments__button--delete"\n' +
    '        ng-if="plan.status !== \'Cancelled\'"\n' +
    '        permission\n' +
    '        permission-only="\'WORKOUT_ASSIGNMENTS_OTHER_UPDATE\'"\n' +
    '        ng-class="{\'assignments__button--disabled\': assignment.isPassed}"\n' +
    '        ng-click="userCtrl.onDeletePlan(plan, $event)">\n' +
    '      </div>\n' +
    '      <div class="assignments__button assignments__button--large"\n' +
    '        ng-if="plan.status === \'Cancelled\'">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="training-plan__details-selector">\n' +
    '      <div class="training-plan__week-container" ng-repeat="week in plan.weeks" ng-init="weekIndex = $index">\n' +
    '        <div class="training-plan__week" ng-click="week.showSessions = !week.showSessions">\n' +
    '          <div class="training-plan__week-text">\n' +
    '            <div class="training-plan__week-name">\n' +
    '              {{ \'WEEK_N\' | translate : { n: (weekIndex + 1) } }}\n' +
    '            </div>\n' +
    '            <div class="training-plan__week-arrow training-plan__week-arrow--up" ng-if="week.showSessions"></div>\n' +
    '            <div class="training-plan__week-arrow training-plan__week-arrow--down" ng-if="!week.showSessions"></div>\n' +
    '          </div>\n' +
    '          <div class="training-plan__week-border" ng-class="{\n' +
    '            \'training-plan__week-border--past\': plan.activeWeekNumber && (plan.activeWeekNumber - 1) > weekIndex,\n' +
    '            \'training-plan__week-border--active\': plan.activeWeekNumber && (plan.activeWeekNumber - 1) === weekIndex\n' +
    '          }"></div>\n' +
    '        </div>\n' +
    '        <div class="training-plan__session"\n' +
    '          ng-if="week.showSessions"\n' +
    '          ng-repeat="assignment in week"\n' +
    '          ng-init="assignmentIndex = $index"\n' +
    '          ng-click="userCtrl.selectSession(plan, weekIndex, assignmentIndex)"\n' +
    '          ng-class="{\n' +
    '            \'training-plan__session--selected\': userCtrl.selectedSessions[plan._id].weekIdx === weekIndex && userCtrl.selectedSessions[plan._id].assignmentIdx === assignmentIndex\n' +
    '          }">\n' +
    '          {{ assignment.name || \'TRAINING_SESSION_N\' | translate : { n: (weekIndex * week.length) + (assignmentIndex + 1) } }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="training-plan__details-exercises" ng-if="userCtrl.selectedSessions[plan._id]">\n' +
    '      <div class="training-plan__details-exercises-name">{{ \'WEEK_N\' | translate : { n: (userCtrl.selectedSessions[plan._id].weekIdx + 1) } }} / {{ userCtrl.selectedSessions[plan._id].assignment.name || \'TRAINING_SESSION_N\' | translate : { n: (weekIndex * week.length) + (assignmentIndex + 1) } }} </div>\n' +
    '      <div class="assignments__exercise-card"\n' +
    '           ng-repeat="exercise in userCtrl.selectedSessions[plan._id].assignment.exercises"\n' +
    '           ng-class="{\n' +
    '        \'assignments__exercise--uncompleted\': exercise.completedDate === undefined,\n' +
    '        \'assignments__exercise--passed\': assignment.isPassed\n' +
    '        }"\n' +
    '           ng-click="userCtrl.showCompletionState(userCtrl.selectedSessions[plan._id].assignment, exercise, plan)">\n' +
    '        <ng-include src="\'/app/user/tabs/assignments/metric-item.html\'"></ng-include>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/assignments/training-programs.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/training-programs.html', '<div class="assignments"\n' +
    '  ng-init=\'userCtrl.initialLoadAssignments()\'\n' +
    '  infinite-scroll=\'userCtrl.loadAssignments()\'\n' +
    '  can-load=\'userCtrl.assignments.nextPage && !userCtrl.initialLoad\'\n' +
    '  ng-if=\'userCtrl.trainingPlans.items.length\'\n' +
    '  threshold=\'30\'>\n' +
    '\n' +
    '  <div class="assignments__header">\n' +
    '    <div class="assignments__header-text">{{\'EXERCISE_TITLE\' | translate}}</div>\n' +
    '    <div class="assignments__header-text">{{\'START_DATE\' | translate}}</div>\n' +
    '    <div class="assignments__header-text">{{\'ACTIVE_WEEK\' | translate}}</div> <!--for spacing-->\n' +
    '    <div class="assignments__header-text"></div>\n' +
    '    <div class="assignments__header-text"></div> <!--for controls-->\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__section"\n' +
    '    ng-click="userCtrl.showActivePlans = !userCtrl.showActivePlans">\n' +
    '    <div class="assignments__section-label">{{\'ACTIVE_TRAINING_PROGRAMS\' | translate}}</div>\n' +
    '    <div class="assignments__button assignments__section-button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': userCtrl.showActivePlans}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__future-assignments-list" ng-if="userCtrl.showActivePlans">\n' +
    '    <div class=\'roster-load-more\' ng-if=\'!userCtrl.activeTrainingPlans.length && userCtrl.plans.nextPage\'>\n' +
    '      <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '        {{\'LOADING_MORE_ACTIVE_TRAINING_PROGRAMS\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-repeat="plan in userCtrl.activeTrainingPlans | orderBy:\'startDate\': \'reverse\' track by plan._id "\n' +
    '      ng-class="{\n' +
    '        \'assignments__other-facility\': !userCtrl.assignmentFromCurrentFacility(plan) && !plan.showDetails,\n' +
    '        \'assignments__other-facility--no-border\': !userCtrl.assignmentFromCurrentFacility(plan) && plan.showDetails,\n' +
    '      }"\n' +
    '      class="assignments__future-assignment-container">\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/training-program-container.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__header">\n' +
    '    <div class="assignments__header-text">{{\'EXERCISE_TITLE\' | translate}}</div>\n' +
    '    <div class="assignments__header-text">{{\'COMPLETION_DATE\' | translate}}</div>\n' +
    '    <div class="assignments__header-text"></div>\n' +
    '    <div class="assignments__header-text"></div> <!--for spacing-->\n' +
    '    <div class="assignments__header-text"></div> <!--for controls-->\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__section"\n' +
    '    ng-click="userCtrl.showCompletedPlans = !userCtrl.showCompletedPlans">\n' +
    '    <div class="assignments__section-label">{{\'COMPLETED_TRAINING_PROGRAMS\' | translate}}</div>\n' +
    '    <div class="assignments__button assignments__section-button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': userCtrl.showCompletedPlans}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="assignments__past-assignments-list" ng-if="userCtrl.showCompletedPlans">\n' +
    '    <div ng-repeat="plan in userCtrl.completedTrainingPlans | orderBy:\'-completionDate\' track by plan._id"\n' +
    '      ng-class="{\n' +
    '        \'assignments__other-facility\': !userCtrl.assignmentFromCurrentFacility(plan) && !plan.showDetails,\n' +
    '        \'assignments__other-facility--no-border\': !userCtrl.assignmentFromCurrentFacility(plan) && plan.showDetails,\n' +
    '      }"\n' +
    '      class="assignments__past-assignment-container">\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/training-program-container.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class=\'calendar-loader\' ng-if=\'userCtrl.completeSkipLoading\'>\n' +
    '    <div class=\'calendar-loader__icon spinner-icon\'></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class=\'roster-load-more\' ng-if=\'userCtrl.plans.nextPage || scrollLoadingRequired\'>\n' +
    '    <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '    {{\'LOADING_MORE_TRAINING_PROGRAMS\' | translate}}\n' +
    '  </div>\n' +
    '</div>\n' +
    '<div class="no-training-programs" ng-if="!userCtrl.trainingPlans.items.length">\n' +
    '  {{\'NO_TRAINING_PROGRAMS_ASSIGNED\' | translate}}\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/workout-history-card.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/workout-history-card.html', '<div class="assignments__exercise-count-container">\n' +
    '  <span class="assignments__exercise-count-container--index">{{$index+1}}</span>\n' +
    '</div>\n' +
    '<div class="assignments__exercise-details">\n' +
    '  <div class="assignments__exercise-title-container">\n' +
    '    <div class="assignments__exercise-details__exercise-title">\n' +
    '      {{exercise.cardName | uppercase | translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="assignments__exercise-details__exercise-params">\n' +
    '    <div ng-repeat="(key, val) in exercise.displayStats"\n' +
    '         class="assignments__exercise-details__exercise-param">\n' +
    '      <div ng-if="val">\n' +
    '        <div class="assignments__exercise-param-val">{{ val }}</div>\n' +
    '        <div class="assignments__exercise-param-name">{{ key | translate }}</div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/workout-history-details.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/workout-history-details.html', '<div class="assignments__exercise-container assignments__exercise-container--assignment"\n' +
    '  ng-if="entry.showDetails">\n' +
    '  <div class="assignments__exercise-card"\n' +
    '    ng-repeat="exercise in entry.exercises">\n' +
    '    <ng-include src="\'/app/user/tabs/assignments/workout-history-card.html\'"></ng-include>\n' +
    '    <div class="assignments__exercise-details"></div>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/workout-history-row.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/workout-history-row.html', '<div class="assignments__assignment"\n' +
    '  ng-class="{\n' +
    '    \'assignments__assignment--open\': entry.showDetails\n' +
    '  }"\n' +
    '  ng-click="entry.showDetails = !entry.showDetails">\n' +
    '  <div class="assignments__header-caption">{{entry.date}}</div>\n' +
    '  <div class="assignments__header-caption">{{\'EXERCISES\' | translate: { amount: entry.exercises.length} }}</div>\n' +
    '  <div class="assignments__header-caption assignments__header-caption--button-container">\n' +
    '    <div class="assignments__button assignments__button--show"\n' +
    '      ng-class="{\'assignments__button--collapsed\': entry.showDetails}">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/assignments/workout-history.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/assignments/workout-history.html', '<div ng-init="userCtrl.loadWorkoutHistory()">\n' +
    '\n' +
    '  <div class="assignments__workout-history-blurb">\n' +
    '    <i class=\'icon icon-info_outline\'></i>\n' +
    '    <span>{{ \'HISTORY_BLURB\' | translate }}</span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-if="!userCtrl.loadingHistory && userCtrl.workoutHistory.length" >\n' +
    '\n' +
    '    <div class="assignments__header">\n' +
    '      <div class="assignments__header-text">{{\'DATE\' | translate}}</div>\n' +
    '      <div class="assignments__header-text">{{\'EXERCISES\' | translate}}</div>\n' +
    '      <div class="assignments__header-text"></div> <!--for controls-->\n' +
    '    </div>\n' +
    '\n' +
    '    <div ng-repeat="entry in userCtrl.workoutHistory">\n' +
    '      <ng-include src="\'/app/user/tabs/assignments/workout-history-row.html\'"></ng-include>\n' +
    '      <ng-include class="assignment__exercise-container--assignment" src="\'/app/user/tabs/assignments/workout-history-details.html\'"></ng-include>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class=\'roster-load-more\' ng-if="!userCtrl.loadingHistory && !userCtrl.workoutHistory.length">\n' +
    '    <i class=\'icon icon-info_outline\'></i><span>{{ :: \'NO_WORKOUT_HISTORY\' | translate }}</span>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class=\'roster-load-more\' ng-if=\'userCtrl.loadingHistory \'>\n' +
    '    <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '    {{ :: \'LOADING_WORKOUT_HISTORY\' | translate }}\n' +
    '  </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-chart/biometric-chart.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-chart/biometric-chart.html', '<div class="biometric-chart">\n' +
    '    <div class="biometric-chart__title">\n' +
    '        <div class="biometric-chart__title-label">{{ chartCtrl.chartLabel }}</div>\n' +
    '        <span ng-show="chartCtrl.stats.history.length > 4">\n' +
    '          <ui-select class="select-custom"\n' +
    '              search-enabled="false"\n' +
    '              ng-model="chartCtrl.filter"\n' +
    '              on-select="chartCtrl.onFilterChange()">\n' +
    '              <ui-select-match>\n' +
    '                  <span>\n' +
    '                      {{ chartCtrl.filter | translate }}\n' +
    '                  </span>\n' +
    '              </ui-select-match>\n' +
    '              <ui-select-choices repeat="option in chartCtrl.filterOptionsTranslated track by $index">\n' +
    '                  <span>\n' +
    '                      {{ option }}\n' +
    '                  </span>\n' +
    '              </ui-select-choices>\n' +
    '          </ui-select>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '    <div class="biometric-chart__chart-container"></div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-create/biometric-create-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-create/biometric-create-modal.html', '<div class="biometric-modal">\n' +
    '    <div class="biometric-modal__top-row">\n' +
    '        <div class="biometric-modal__top-row-title">\n' +
    '            {{ \'ADD_NEW_BODY_STAT\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="biometric-modal__top-row-close" ng-click="biometricCreate.dismiss()"></div>\n' +
    '    </div>\n' +
    '    <div class="biometric-modal__form">\n' +
    '        <form name="createBiometricForm" ng-submit="biometricCreate.submit(createBiometricForm.$valid)" novalidate>\n' +
    '            <div>\n' +
    '                <label class="biometric-modal__form-label">{{ \'BODY_STAT\' | translate }}:</label>\n' +
    '                <ui-select class="select-custom"\n' +
    '                    search-enabled="false"\n' +
    '                    ng-model="biometricCreate.selectedOption">\n' +
    '                    <ui-select-match placeholder="{{ \'CHOOSE_BODY_STAT\' | translate  }}">\n' +
    '                        <span>\n' +
    '                            {{ biometricCreate.selectedOption.label }}\n' +
    '                        </span>\n' +
    '                    </ui-select-match>\n' +
    '                    <ui-select-choices repeat="option in biometricCreate.options track by $index">\n' +
    '                        <span>\n' +
    '                            {{ option.label }}\n' +
    '                        </span>\n' +
    '                    </ui-select-choices>\n' +
    '                </ui-select>\n' +
    '            </div>\n' +
    '            <div>\n' +
    '                <label class="biometric-modal__form-label">{{ \'CURRENT_VALUE\' | translate }}:</label>\n' +
    '                <input class="biometric-modal__form-input" name="currentValue" type="number" ng-model="biometricCreate.currentValue" step=".01" min="0" required>\n' +
    '                <p class="biometric-modal__error"\n' +
    '                    ng-show="createBiometricForm.currentValue.$invalid && !createBiometricForm.currentValue.$pristine">{{ \'NEED_VALID_NUMBER\' | translate }}</p>\n' +
    '            </div>\n' +
    '            <div>\n' +
    '                <label class="biometric-modal__form-label">{{ \'GOAL_VALUE_OPTIONAL\' | translate }}:</label>\n' +
    '                <input class="biometric-modal__form-input" name="goalValue" type="number" ng-model="biometricCreate.goalValue" step=".01" min="0">\n' +
    '                <p class="biometric-modal__error"\n' +
    '                    ng-show="createBiometricForm.goalValue.$invalid && !createBiometricForm.goalValue.$pristine">{{ \'NEED_VALID_NUMBER\' | translate }}</p>\n' +
    '            </div>\n' +
    '            <br>\n' +
    '            <div class="biometric-modal__bottom-row">\n' +
    '                <button class="biometric-modal__add-button"\n' +
    '                    type="submit"\n' +
    '                    ng-disabled="createBiometricForm.$invalid"\n' +
    '                    ng-class="{ \'biometric-modal__add-button--disabled\': createBiometricForm.$invalid }">\n' +
    '                    {{ \'ADD\' | translate }}\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-details/biometric-details.component.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-details/biometric-details.component.html', '<div class="biometric-details">\n' +
    '    <div class="biometric-details__top-row">\n' +
    '        <div class="biometric-details__goal" ng-if="biometricDetailsCtrl.detailsAvailable">\n' +
    '            <div class="biometric-details__goal-value">\n' +
    '                {{biometricDetailsCtrl.goalValue}}\n' +
    '            </div>\n' +
    '            <div class="biometric-details__goal-name">\n' +
    '                {{biometricDetailsCtrl.goalCaption}}\n' +
    '                <span ng-if=\'biometricDetailsCtrl.units\'>({{biometricDetailsCtrl.units | translate}})</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="biometric-details__button-container" ng-if="biometricDetailsCtrl.detailsAvailable">\n' +
    '            <div class="biometric-details__button" ng-click="biometricDetailsCtrl.handleButtonPress(\'goal\')" >\n' +
    '                {{ \'RECORD_NEW_GOAL_VALUE\' | translate }}\n' +
    '            </div>\n' +
    '            <div class="biometric-details__button" ng-click="biometricDetailsCtrl.handleButtonPress(\'entry\')">\n' +
    '                {{ \'RECORD_NEW_VALUE\' | translate }}\n' +
    '            </div>\n' +
    '            <div class="biometric-details__button-container-csv">\n' +
    '                <div class="biometric-details__button" ng-click="biometricDetailsCtrl.exportCSV()">{{ \'EXPORT_TO_CSV\' | translate }}</div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="biometric-details__top-row biometric-details__top-row--height" ng-if="!biometricDetailsCtrl.detailsAvailable">\n' +
    '        <div class="biometric-details__button" ng-click="biometricDetailsCtrl.handleButtonPress(\'entry\')">\n' +
    '            {{ \'RECORD_NEW_VALUE\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="biometric-details__button__hide" ng-click="biometricDetailsCtrl.handleButtonPress(\'hide\')">\n' +
    '            {{ \'HIDE_STAT\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="biometric-details__data-display" ng-if="biometricDetailsCtrl.detailsAvailable">\n' +
    '        <div class="biometric-details__data-display-chart">\n' +
    '            <biometric-chart stats="biometricDetailsCtrl.stats"></biometric-chart>\n' +
    '        </div>\n' +
    '        <div class="biometric-details__data-display-history">\n' +
    '            <div class="biometric-history__title-group">\n' +
    '              <div class="biometric-history__title">{{ biometricDetailsCtrl.historyCaption }}</div>\n' +
    '              <span class="biometric-details__see-all" ng-click="biometricDetailsCtrl.showAllHistory()">{{ \'SEE_ALL\' | translate | uppercase }}</span>\n' +
    '            </div>\n' +
    '            <div class="biometric-history__values" ng-repeat="change in biometricDetailsCtrl.stats.history |\n' +
    '                orderBy: \'-timestamp\' | limitTo: 4">\n' +
    '                <div class="date">{{ change.timestamp | dateFormatter:\'dateMedium\' }}</div>\n' +
    '                <div class="value">{{ biometricDetailsCtrl.formatVal(change.value) }} {{ biometricDetailsCtrl.units | translate }}</div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <br ng-if="biometricDetailsCtrl.detailsAvailable">\n' +
    '    <div class="biometric-details__container" ng-if="biometricDetailsCtrl.detailsAvailable">\n' +
    '        <div class="biometric-details__button__hide" ng-click="biometricDetailsCtrl.handleButtonPress(\'hide\')">\n' +
    '            {{ \'HIDE_STAT\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-entry/biometric-entry-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-entry/biometric-entry-modal.html', '<form ng-submit="biometricEntry.submit()">\n' +
    '	<div class="biometric-modal">\n' +
    '		<div class="biometric-modal__top-row">\n' +
    '			<div class="biometric-modal__top-row-title">\n' +
    '				{{ biometricEntry.entryType === \'goal\'? \'RECORD_NEW_GOAL_VALUE\' : \'RECORD_NEW_VALUE\'  | translate }}\n' +
    '			</div>\n' +
    '			<div class="biometric-modal__top-row-close" ng-click="biometricEntry.dismiss()"></div>\n' +
    '		</div>\n' +
    '		<div class="biometric-modal__input">\n' +
    '			<input ng-if="biometricEntry.biometricName !== \'height\'" id="biometricInput" type="number" step=".01" min="0"\n' +
    '				ng-model="biometricEntry.value">\n' +
    '			<div ng-if="biometricEntry.biometricName === \'height\'">\n' +
    '				<div ng-if="biometricEntry.units === \'M\'">\n' +
    '					<select ng-model="biometricEntry.meters" ng-options="num for num in biometricEntry.metersOptions"></select>\n' +
    '					{{ \'METER\' | translate }}\n' +
    '					<select ng-model="biometricEntry.centimeters" ng-options="num for num in biometricEntry.centimetersOptions"></select>\n' +
    '					{{ \'CM\' | translate }}\n' +
    '				</div>\n' +
    '				<div ng-if="biometricEntry.units === \'I\'">\n' +
    '					<select ng-model="biometricEntry.feet" ng-options="num for num in biometricEntry.feetOptions"></select>\n' +
    '					{{ \'FT\' | translate }}\n' +
    '					<select ng-model="biometricEntry.inches" ng-options="num for num in biometricEntry.inchesOptions"></select>\n' +
    '					{{ \'INCH\' | translate }}\n' +
    '				</div>\n' +
    '				<div class="biometric-modal__top-row-close" ng-click="biometricEntry.dismiss()"></div>\n' +
    '			</div>\n' +
    '			<div class="biometric-modal__bottom-row">\n' +
    '				<div class="biometric-modal__bottom-row-cancel" ng-click="biometricEntry.dismiss()">\n' +
    '					{{ \'CANCEL\' | translate | uppercase }}\n' +
    '				</div>\n' +
    '				<button id="addButton" class="biometric-modal__bottom-row-add" type="submit" ng-class="{\n' +
    '				\'biometric-modal__bottom-row-add--disabled\': biometricEntry.isInvalidInput()}">\n' +
    '					{{ \'ADD\' | translate }}\n' +
    '				</button>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-hidden/biometric-hidden-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-hidden/biometric-hidden-modal.html', '<div class="biometric-modal">\n' +
    '    <div class="biometric-modal__top-row">\n' +
    '        <div class="biometric-modal__top-row-title">\n' +
    '            {{ \'HIDDEN_STATS\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="biometric-modal__top-row-close" ng-click="biometricHidden.dismiss()"></div>\n' +
    '    </div>\n' +
    '    <div class="biometric-modal-hide" ng-repeat=\'stat in biometricHidden.originalList\'>\n' +
    '        <div class="biometric-modal__bottom-row-add button-show" ng-click="biometricHidden.toggleHiddenStatus($index)">\n' +
    '         <span ng-if="biometricHidden.tracker[$index]">{{ \'SHOW\' | translate }}</span>\n' +
    '         <span ng-if="!biometricHidden.tracker[$index]">{{ \'HIDE\' | translate }}</span>\n' +
    '        </div>\n' +
    '        <div class="biometric-show">\n' +
    '            {{ stat | uppercase | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="biometric-modal__bottom-row">\n' +
    '		<div class="biometric-modal__bottom-row-cancel" ng-click="biometricHidden.dismiss()">\n' +
    '			{{ \'CANCEL\' | translate | uppercase }}\n' +
    '		</div>\n' +
    '		<div class="biometric-modal__bottom-row-add" ng-click="biometricHidden.submit()">\n' +
    '			{{ \'SUBMIT\' | translate }}\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-history/biometric-history-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-history/biometric-history-modal.html', '<div class="biometric-modal">\n' +
    '  <div class="biometric-modal__top-row">\n' +
    '    <div class="biometric-modal__top-row-title">\n' +
    '      {{ \'HISTORY_STAT\' | translate : { stat : biometricHistory.getBiometricName() } }}\n' +
    '    </div>\n' +
    '    <div class="biometric-modal__top-row-close" ng-click="biometricHistory.dismiss()"></div>\n' +
    '  </div>\n' +
    '  <div class="biometric-modal__history-entry-container">\n' +
    '    <div class="biometric-modal__history-entry" ng-repeat="entry in biometricHistory.history | orderBy: \'-timestamp\'">\n' +
    '      <span class="biometric-modal__history-date">{{biometricHistory.formatUserDate(entry.timestamp)}}</span> <span class="biometric-modal__history-value">{{entry.value}} {{biometricHistory.unit | translate}}</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/biometrics/biometric-stats/biometric-stats.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometric-stats/biometric-stats.html', '<div class="biometric-list" >\n' +
    '    <div class="biometric-list__metric">\n' +
    '        <div class=\'biometric-list__value\'>\n' +
    '            {{biometricStatsCtrl.currentValue}}\n' +
    '        </div>\n' +
    '        <div class="biometric-list__trend" ng-class=\'{\n' +
    '            "biometric-list__trend--up": biometricStatsCtrl.arrowDirection === "up",\n' +
    '            "biometric-list__trend--down": biometricStatsCtrl.arrowDirection === "down",\n' +
    '            "biometric-list__trend--no-change": biometricStatsCtrl.arrowDirection === "no-change",}\'\n' +
    '             ng-if="biometricStatsCtrl.stats.biometricName !== \'height\'">\n' +
    '        </div>\n' +
    '       <div class=\'biometric-list__graph\'\n' +
    '            ng-if="biometricStatsCtrl.stats.biometricName !== \'height\'"></div>\n' +
    '    </div>\n' +
    '    <div class=\'biometric-list__name\'>\n' +
    '        {{biometricStatsCtrl.stats.biometricName | uppercase | translate}}\n' +
    '        <span ng-if=\'biometricStatsCtrl.units\'>({{biometricStatsCtrl.units | translate}})</span>\n' +
    '    </div>\n' +
    ' </div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/biometrics/biometrics.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/biometrics/biometrics.html', '<div ng-controller="biometricsController as biometrics" class="biometrics">\n' +
    '    <div class="biometrics__button-row">\n' +
    '        <div class="biometrics__button-row-hide" ng-if="biometrics.hiddenList.length > 0" ng-click="biometrics.getHiddenStats()">\n' +
    '            <div class="button__icon--hidden-stat"></div> {{ \'HIDDEN_BODY_STATS\' | translate }} ({{biometrics.hiddenList.length}})\n' +
    '        </div>\n' +
    '        <div class="biometrics__button-row-add" ng-click="biometrics.handleAddButtonPress()">\n' +
    '            <i class="icon icon-ion-plus"></i> {{ \'NEW_BODY_STAT\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="biometrics__button-row-add" ng-click="biometrics.handleCsv()">\n' +
    '             {{ \'EXPORT_TO_CSV\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="biometrics__container" ng-repeat="row in biometrics.biometrics">\n' +
    '        <div class="biometrics__row">\n' +
    '            <div class="biometrics__element"\n' +
    '                ng-repeat="stat in row"\n' +
    '                ng-class="{ \'biometrics__element--selected\': biometrics.isSelected($parent.$index, $index) }"\n' +
    '                ng-click="biometrics.toggleDetails($parent.$index, $index)">\n' +
    '                <biometric-stats stats="stat"></biometric-stats>\n' +
    '                <div class="biometrics__element-close"\n' +
    '                    ng-if="biometrics.isSelected($parent.$index, $index)">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="biometrics__details" ng-if="biometrics.showDetails($index)">\n' +
    '            <biometric-details\n' +
    '                stats="biometrics.biometrics[biometrics.selectedRow][biometrics.selectedRowElement]"\n' +
    '                on-button-press="biometrics.handleButtonPressEvent($event)"\n' +
    '            ></biometric-details>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '');
  }]);
angular.module('/app/user/tabs/messaging/staffMessaging.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/messaging/staffMessaging.html', '<div class=\'client-permissions\' ng-controller="StaffMessagesController as messaging">\n' +
    '  <div class="staffMessaging">\n' +
    '    <div class="staffMessaging__thread-list">\n' +
    '     \n' +
    '      <div\n' +
    '        class="staffMessaging__thread-list-item"\n' +
    '        ng-repeat="thread in messaging.threadList | orderBy:\'-mostRecent\'" ng-if="thread.otherUser"\n' +
    '        ng-click="messaging.selectThread(thread)"\n' +
    '      >\n' +
    '        <img\n' +
    '          class="staffMessaging__thread-list-item-picture"\n' +
    '          ng-src="{{thread.otherUser.picture || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}"\n' +
    '        />\n' +
    '        <div\n' +
    '          class="staffMessaging__thread-list-item-name"\n' +
    '          ng-class="{\n' +
    '                        \'staffMessaging__thread-list-item-name--active\': messaging.activeThread.threadId === thread.threadId,\n' +
    '                        \'staffMessaging__thread-list-item-name--unread\': thread.unreadMessages\n' +
    '                    }"\n' +
    '        >\n' +
    '          {{thread.otherUser.firstName}} {{thread.otherUser.lastName}}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="staffMessaging__thread" ng-if="messaging.activeThread">\n' +
    '      <div class="staffMessaging__thread-title">\n' +
    '        {{messaging.activeThread.otherUser.firstName}}\n' +
    '        {{messaging.activeThread.otherUser.lastName}}\n' +
    '      </div>\n' +
    '      <div class="staffMessaging__thread-staffContainer">\n' +
    '        <div\n' +
    '          ng-if="messaging.threadMessages"\n' +
    '          ng-repeat="message in messaging.threadMessages"\n' +
    '        >\n' +
    '          <div\n' +
    '            class="staffMessaging__thread-message-time"\n' +
    '            ng-class="{\n' +
    '                            \'messaging__thread-message-time-systemMessage\': message.systemMessage === true,\n' +
    '                            \'messaging__thread-message-time-other\': message.to === messaging.selfId,\n' +
    '                            \'messaging__thread-message-time-self\': message.to !== messaging.selfId\n' +
    '                        }"\n' +
    '          >\n' +
    '            {{message.time | dateFormatter:\'messagingDateTime\'}}\n' +
    '          </div>\n' +
    '          <div\n' +
    '            class="staffMessaging__thread-message"\n' +
    '            ng-class="{\n' +
    '                            \'messaging__thread-message-other\': message.to === messaging.selfId,\n' +
    '                            \'messaging__thread-message-self\': message.to !== messaging.selfId,\n' +
    '                            \'messaging__thread-message-systemMessage\': message.systemMessage === true\n' +
    '                        }"\n' +
    '          >\n' +
    '            <div\n' +
    '              ng-if="!message.systemMessage"\n' +
    '              ng-bind-html="messaging.deliberatelyTrustDangerousHtml(message.message)"\n' +
    '            ></div>\n' +
    '            <div\n' +
    '              class="staffMessaging__thread-message-systemMessage_message"\n' +
    '              ng-if="message.systemMessage"\n' +
    '            >\n' +
    '              <div\n' +
    '                class="staffMessaging__thread-message-systemMessage_icon"\n' +
    '                ng-class="{ \'messaging__thread-message-systemMessage_icon-reminder\': message.messageMetadata.type === \'Reminder\',\n' +
    '                                           \'messaging__thread-message-systemMessage_icon-at_risk\': message.messageMetadata.type === \'atRisk\' }"\n' +
    '                ng-if="message.systemMessage"\n' +
    '              ></div>\n' +
    '              {{ messaging.generateSystemMessage(message) }}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      \n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/permissions/groups-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/permissions/groups-modal.html', '<ul class="modal__list-wrapper">\n' +
    '  <li class="modal__list-item" ng-repeat="group in permissionsGroups" ng-if="!group.isDefault" ng-click="onGroupClick(group)">\n' +
    '    <div>\n' +
    '      {{::group.name}}\n' +
    '      <div ng-if="hasUserTheGroup(group)" class="pull-right permissions-groups-pop-up__group-selected-icon">&#x2713;</div>\n' +
    '    </div>\n' +
    '  </li>\n' +
    '</ul>');
  }]);
angular.module('/app/user/tabs/permissions/permissions.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/permissions/permissions.html', '<div class=\'client-permissions\' ng-controller="UserPermissionsController as permCtrl">\n' +
    '  <div class=\'client-permissions__content\'>\n' +
    '    <div class=\'client-permissions__controls\'\n' +
    '      permission\n' +
    '      permission-only="\'PERMISSIONS_GROUPS_READ\'">\n' +
    '\n' +
    '      <a class=\'button button-action\'\n' +
    '        ng-click="permCtrl.showGroupsPopup()">\n' +
    '        {{ :: \'SELECT_GROUPS\' | translate }}\n' +
    '      </a>\n' +
    '      <div class="button pull-right" permission permission-only="[\'PERMISSIONS_GROUPS_UPDATE\', \'PERMISSIONS_GROUPS_DELETE\', \'PERMISSIONS_GROUPS_CREATE\']">\n' +
    '          <a class=\'button button-action pull-right\'\n' +
    '              ui-sref=\'app.settings({tab: "permission-groups"})\'>\n' +
    '              {{ :: \'EDIT_PERMISSION_GROUPS\' | translate }}\n' +
    '          </a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <form\n' +
    '        name="permCtrl.forms.permissions"\n' +
    '        permission\n' +
    '        permission-only="\'CLUB_CHAIN_ADMIN_UPDATE\'">\n' +
    '      <div class=\'client-permissions__card\' ng-repeat="permission in permCtrl.displayedPermissions">\n' +
    '        <div class=\'client-permissions__card-header\'>\n' +
    '          <span class=\'\'>{{::permission.name | translate}}</span>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class=\'client-permissions__card-content\'>\n' +
    '          <label class=\'checkbox-custom\'\n' +
    '            ng-repeat=\'(name, value) in permission.options\'>\n' +
    '            <input\n' +
    '            type="checkbox"\n' +
    '            ng-disabled="permCtrl.disabledOptions[permission.name][name]"\n' +
    '            ng-model=\'permission.options[name]\'>\n' +
    '              <span class=\'checkbox-label\'>{{::name | translate }}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="tab-footer footer-buttons"\n' +
    '    ng-show="permCtrl.forms.permissions.$dirty"\n' +
    '    permission\n' +
    '    permission-only="[\'USER_PERMISSIONS_UPDATE\']">\n' +
    '\n' +
    '    <div class="button button-action"\n' +
    '      permission\n' +
    '      permission-only="\'USER_PERMISSIONS_UPDATE\'"\n' +
    '      ng-click="permCtrl.savePermissions()">\n' +
    '      {{ :: \'SAVE\'  | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="button button-assertive button-clear pull-right"\n' +
    '      ng-click="permCtrl.resetPermissions()">\n' +
    '      {{ :: \'CANCEL\'  | translate}}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/reminder/reminder-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/reminder/reminder-modal.html', '<div class="reminder-modal">\n' +
    '    <div class="reminder-modal__top-row">\n' +
    '        <div class="reminder-modal__top-row-title">\n' +
    '            {{ \'REMIND_ME_TO_FOLLOWUP\' | translate : { firstName: reminderCtrl.firstName } }}\n' +
    '        </div>\n' +
    '        <div class="reminder-modal__top-row-close" ng-click="reminderCtrl.dismiss()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="reminder-modal__body">\n' +
    '        {{ \'YOU_WILL_RECIEVE_FOLLOWUP\' | translate : { fullName: reminderCtrl.fullName } }}\n' +
    '        <input id="timepicker"></input>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="reminder-modal__bottom-row">\n' +
    '        <div class="reminder-modal__bottom-row-cancel" ng-click="reminderCtrl.dismiss()">\n' +
    '            {{ \'CANCEL\' | translate | uppercase }}\n' +
    '        </div>\n' +
    '        <div class="reminder-modal__bottom-row-add" ng-click="reminderCtrl.submit()" ng-class="{\n' +
    '            \'reminder-modal__bottom-row--disabled\': reminderCtrl.isInvalidInput()\n' +
    '        }">\n' +
    '            {{ \'SCHEDULE_FOLLOWUP\' | translate }}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/removeFromFacility/removeFromFacility.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/removeFromFacility/removeFromFacility.html', '<div class="data-block__container modal--delete-acc__details">\n' +
    '  <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <span class="data-block__info--input user-details__input--text">\n' +
    '          {{ :: user.firstName }} {{ :: user.lastName }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'ACCOUNT_NAME\' | translate }}</div>\n' +
    '  </div>\n' +
    '  <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <span class="data-block__info--input user-details__input--text">\n' +
    '          {{ :: facility.name }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'FACILITY\' | translate }}</div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/certifications/certifications.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/certifications/certifications.html', '<div class=\'certifications-form\'\n' +
    '  permission\n' +
    '  permission-only=":: userCtrl.permissions.certifications.read"\n' +
    '  ng-init=\'userCtrl.certifications.load()\'>\n' +
    '\n' +
    '  <div class="data-section">\n' +
    '    <div class="data-section__header">\n' +
    '      <div class="data-section__title">{{ :: \'CERTIFICATIONS\' | translate }}</div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="data-section__content">\n' +
    '      <div ng-repeat="cert in userCtrl.certifications.items | filter:{_isDeleted: \'!\'}"\n' +
    '        class="data-section__item">\n' +
    '\n' +
    '        <ng-form name=\'userCtrl.certifications.forms["{{ (cert.data._id || cert._virtualId) }}"]\'>\n' +
    '\n' +
    '          <div class="pull-right">\n' +
    '            <div permission\n' +
    '              permission-only=":: userCtrl.permissions.certifications.delete"\n' +
    '              ng-click="userCtrl.certifications.remove(cert); userCtrl.setCertificateSavebar(\'delete\')"\n' +
    '              class="button button-clear button-assertive push-top-sm">\n' +
    '                {{ :: \'DELETE\' | translate }}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__image-container data-section__upload-container">\n' +
    '\n' +
    '            <div class=\'button button-action button-clear camera-button\'\n' +
    '              permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '              ngf-select\n' +
    '              ng-model="cert.data.picture"\n' +
    '              name="file"\n' +
    '              ngf-pattern="\'image/*\'"\n' +
    '              ngf-multiple="false"\n' +
    '              tooltip-placement="bottom"\n' +
    '              uib-tooltip="{{ :: \'CHANGE_CERTIFICATION_PIC\' | translate }}"\n' +
    '              ng-change = "userCtrl.setCertificateSavebar(\'add\')">\n' +
    '              <i class="icon icon-camera"></i>\n' +
    '            </div>\n' +
    '            <img ngf-thumbnail="cert.data.picture || cert.data.picturePath"\n' +
    '              ngf-size="{width: 150}">\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__item-content">\n' +
    '\n' +
    '            <div class="inline col-md-6 col-sm-6">\n' +
    '              <div class="data-section__info-container">\n' +
    '                <input type="text"\n' +
    '                  permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  name="name"\n' +
    '                  ng-model="cert.data.name"\n' +
    '                  required\n' +
    '                  ng-change = "userCtrl.setCertificateSavebar(\'add\')"\n' +
    '                  class="data-section__info--input input-clear"\n' +
    '                  placeholder=\'type name here\'>\n' +
    '                <div class="data-section__info-description">{{ :: \'NAME\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="data-section__info-container">\n' +
    '                <input type="text"\n' +
    '                  permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  name="authority"\n' +
    '                  ng-model="cert.data.authority"\n' +
    '                  required\n' +
    '                  ng-change = "userCtrl.setCertificateSavebar(\'add\')"\n' +
    '                  class="data-section__info--input input-clear"\n' +
    '                  placeholder=\'type author here\'>\n' +
    '                <div class="data-section__info-description">{{ :: \'AUTHOR\' | translate }}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="inline col-md-6 col-sm-6">\n' +
    '              <div class="data-section__info-container">\n' +
    '                <input type="text"\n' +
    '                  uib-datepicker-popup\n' +
    '                  is-open="issuedDatePopUpIsOpen"\n' +
    '                  ng-click="issuedDatePopUpIsOpen = !issuedDatePopUpIsOpen"\n' +
    '                  permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  name="issuedDate"\n' +
    '                  ng-model="cert.data.issuedDate"\n' +
    '                  unix-date-input\n' +
    '                  required\n' +
    '                  class="data-section__info--input input-clear"\n' +
    '                  ng-change = "userCtrl.setCertificateSavebar(\'add\')"\n' +
    '                  placeholder=\'dd/mm/yyyy\'>\n' +
    '                <div class="data-section__info-description">{{ :: \'ISSUED_DATE\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="data-section__info-container">\n' +
    '                <input type="text"\n' +
    '                  uib-datepicker-popup\n' +
    '                  is-open="expirationdDatePopUpIsOpen"\n' +
    '                  ng-click="expirationdDatePopUpIsOpen = !expirationdDatePopUpIsOpen"\n' +
    '                  permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '                  permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                  permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                  name="expirationDate"\n' +
    '                  ng-model="cert.data.expirationDate"\n' +
    '                  unix-date-input\n' +
    '                  required\n' +
    '                  class="data-section__info--input input-clear"\n' +
    '                  ng-change = "userCtrl.setCertificateSavebar(\'add\')"\n' +
    '                  placeholder=\'dd/mm/yyyy\'>\n' +
    '                <div class="data-section__info-description">{{ :: \'EXPIRATION_DATE\' | translate }}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </ng-form>\n' +
    '      </div>\n' +
    '\n' +
    '      <div permission\n' +
    '          permission-only=":: userCtrl.permissions.certifications.create"\n' +
    '          ng-click="userCtrl.certifications.add(); userCtrl.setCertificateSavebar(\'add\');"\n' +
    '          class="button button-large button-full button-primary">\n' +
    '        <b>{{ :: \'ADD_CERTIFICATION\' | translate }}</b>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="footer-buttons">\n' +
    '    <div ng-if="userCtrl.showCertificateSavebar">\n' +
    '      <div ng-click="userCtrl.certifications.revertAll(); userCtrl.setCertificateSavebar(\'cancel\');"\n' +
    '        class="button button-clear button-assertive pull-right">\n' +
    '        {{ :: \'CANCEL\'  | translate }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div permission\n' +
    '        permission-only=":: userCtrl.permissions.certifications.update"\n' +
    '        ng-click="userCtrl.certifications.saveAll(); userCtrl.setCertificateSavebar(\'save\');"\n' +
    '        ng-disabled="userCtrl.certifications._isLoading"\n' +
    '        class="button button-action">\n' +
    '        {{ :: \'SAVE\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/changePassword/change-password-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/changePassword/change-password-modal.html', '<form name="changePasswordForm" ng-submit="changePasswordController.ok()" novalidate>\n' +
    '<div class="modal--add-client">\n' +
    '\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--title ng-binding">{{\'CHANGE_YOUR_PASSWORD\' | translate}}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross" ng-click="changePasswordController.cancel()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '      <div class="modal__content-template" bind-html-compile="content">\n' +
    '  <div class="data-block__container">\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass" type="password" required="required" ng-model="changePasswordController.currentPassword" name="currentPassword" placeholder="·······">\n' +
    '      </div>\n' +
    '      <div class="data-block__title ng-binding">{{\'OLD_PASSWORD\' | translate}}</div>\n' +
    '    </div>\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass" type="password" ng-minlength="6" required="required" ng-model="changePasswordController.newPassword" name="newPassword" placeholder="·······" ng-model-options="{ allowInvalid: true }">\n' +
    '      </div>\n' +
    '      <div class="data-block__title ng-binding">{{\'NEW_PASSWORD\' | translate}}</div>\n' +
    '\n' +
    '      <div ng-messages="changePasswordForm.newPassword.$error">\n' +
    '        <ng-message when="minlength" class="data-block__error">{{\'PASSWORD_MIN_LENGTH\' | translate}}</ng-message>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <input class="data-block__info--input user-details__input--password modal__input--pass" type="password" required="required" ng-model="changePasswordController.confirmNewPassword" name="confirmNewPassword" placeholder="·······" compare-to="changePasswordController.newPassword">\n' +
    '      </div>\n' +
    '      <div class="data-block__title ng-binding">{{\'CONFIRM_NEW_PASSWORD\' | translate}}</div>\n' +
    '\n' +
    '      <div ng-messages="changePasswordForm.confirmNewPassword.$error">\n' +
    '        <ng-message when="compareTo" class="data-block__error">{{\'PASSWORD_DOES_NOT_MATCH\' | translate}}</ng-message>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '  </div>\n' +
    '</div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <button type="submit" autofocus="" class="button button-action">\n' +
    '        {{\'CHANGE_PASSWORD\' | translate}}\n' +
    '      </button>\n' +
    '\n' +
    '      <div ng-if="changePasswordController.error" class="footer-buttons__error">{{\'OLD_PASSWORD_INVALID\' | translate}}</div>\n' +
    '\n' +
    '      <div class="button button-assertive button-clear pull-right" ng-click="changePasswordController.cancel()">\n' +
    '        {{\'CANCEL\' | translate}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/deleteAccount/deleteAccount.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/deleteAccount/deleteAccount.html', '<div class="data-block__container modal--delete-acc__details">\n' +
    '  <div class="data-block__info-container">\n' +
    '      <div class="data-block__info">\n' +
    '        <span class="data-block__info--input user-details__input--text">\n' +
    '          {{ :: user.firstName }} {{ :: user.lastName }}\n' +
    '        </span>\n' +
    '      </div>\n' +
    '      <div class="data-block__title">{{ :: \'ACCOUNT_NAME\' | translate }}</div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/deleteUser/delete-user-modal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/deleteUser/delete-user-modal.html', '<div class="modal--add-client">\n' +
    '\n' +
    '    <div class="modal__popup-header">\n' +
    '      <div class="modal__popup-header--title ng-binding">{{\'DELETE_ACCOUNT\' | translate}}</div>\n' +
    '      <div class="modal__popup-header--exit icon icon-cross" ng-click="deleteUserController.cancel()"></div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content">\n' +
    '        {{\'DELETE_ACCOUNT_GDPR\' | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="modal__content" style="color: #e02526" ng-if="deleteUserController.error">\n' +
    '      {{"ERROR_400" | translate}}\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '        <button ng-click="deleteUserController.ok()" autofocus="" class="button button-action">\n' +
    '          {{\'DELETE_ACCOUNT\' | translate}}\n' +
    '        </button>\n' +
    '\n' +
    '        <div class="button button-assertive button-clear pull-right" ng-click="deleteUserController.cancel()">\n' +
    '          {{\'CANCEL\' | translate}}\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '</div>');
  }]);
angular.module('/app/user/tabs/userDetails/facilityStaff.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/facilityStaff.html', '<div class="user-details">\n' +
    '<!-- ========== PERSONAL INFORAMTION =================== -->\n' +
    '  <form name="userCtrl.forms.personalInfoFacility"\n' +
    '    permission\n' +
    '    permission-only=":: userCtrl.permissions.personalDetails.read">\n' +
    '    <div class="data-wrapper">\n' +
    '\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__header">\n' +
    '          {{ :: \'PERSONAL_INFORMATION\' | translate }}\n' +
    '        </div>\n' +
    '        <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--block">\n' +
    '            <div class="data-block__info">\n' +
    '              <textarea permission\n' +
    '              permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              ng-model="userCtrl.user.personalInfo.address1"\n' +
    '              class="data-block__info--input user-details__input--area input-clear"\n' +
    '              placeholder="---">\n' +
    '              </textarea>\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'ADDRESS1\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '              <input permission\n' +
    '              permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              type="text"\n' +
    '              ng-model="userCtrl.user.personalInfo.phoneNumber1"\n' +
    '              class="data-block__info--input user-details__input--text input-clear"\n' +
    '              placeholder="+1 555.555.5555 x123">\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'PHONE_NUMBER_1\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '              <input permission\n' +
    '              permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              type="text"\n' +
    '              ng-model="userCtrl.user.personalInfo.phoneNumber2"\n' +
    '              class="data-block__info--input user-details__input--text input-clear"\n' +
    '              placeholder="+1 555.555.5555 x123">\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'PHONE_NUMBER_2\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '            <span class="data-block__info--input user-details__input--email">\n' +
    '              {{ userCtrl.user.personalInfo.email }}\n' +
    '            </span>\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '              <div permission\n' +
    '              permission-only=":: userCtrl.permissions.resetPassword.update"\n' +
    '              class="data-block__button" ng-click="userCtrl.showResetLoading || userCtrl.resetPassword()"\n' +
    '              ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }">\n' +
    '                {{ \'RESET_PASSWORD\' | translate }}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div class="data-block__info" ng-if="userCtrl.userId === user._id || userCtrl.userId === \'me\'">\n' +
    '              <div class="data-block__button" ng-click="userCtrl.showResetLoading || userCtrl.changePassword()"\n' +
    '              ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }">\n' +
    '                {{ :: \'CHANGE_PASSWORD\' | translate }}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-if="userCtrl.showDeleteButton(user)" class="data-block__info">\n' +
    '              <div permission\n' +
    '              permission-only=":: USERS_ADMIN_DELETE"\n' +
    '              class="data-block__button data-block__button--red" ng-click="userCtrl.showResetLoading || userCtrl.deleteUser()"\n' +
    '              ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }" ng-if=\'userCtrl.isEditable(["USERS_ADMIN_DELETE"])\'>\n' +
    '                {{ :: \'DELETE_ACCOUNT\' | translate }}\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container">\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '              <input class="data-block__info--input input-clear"\n' +
    '                ng-value="userCtrl.user.personalInfo.club.chain"\n' +
    '                readonly\n' +
    '                placeholder="---">\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{::\'CLUB_CHAIN\' | translate}}</div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '              <span class="data-block__info--input">\n' +
    '                {{ userCtrl.user.personalInfo.club.name}}\n' +
    '              </span>\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{::\'HOME_CLUB\' | translate}}</div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div ng-if="userCtrl.isAdmin" class="data-block__info-container data-block__info-container--2-col">\n' +
    '            <div class="data-block__info">\n' +
    '                <label class="checkbox-custom">\n' +
    '                <input type="checkbox" ng-model="userCtrl.user.personalInfo.isDemoUser" />\n' +
    '                <span class="checkbox-label-small">{{ \'IS_DEMO_USER\' | translate }}</label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <div permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '      ng-show=\'userCtrl.forms.personalInfoFacility.$dirty\'\n' +
    '      ng-click="userCtrl.save(\'personalInfo\', userCtrl.user.personalInfo, \'Facility\',userCtrl.user)"\n' +
    '      class="button button-action">\n' +
    '        {{::\'SAVE\'  | translate}}\n' +
    '      </div>\n' +
    '      <div permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '      ng-show=\'userCtrl.forms.personalInfoFacility.$dirty\'\n' +
    '      ng-click="userCtrl.reset(\'personalInfo\', \'Facility\')"\n' +
    '      class="button button-clear button-assertive pull-right">\n' +
    '        {{::\'CANCEL\'  | translate}}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '<!-- ========== CERTIFICATIONS =================== -->\n' +
    '  <div \n' +
    '    ng-include="\'/app/user/tabs/userDetails/certifications/certifications.html\'"\n' +
    '    ng-if="userCtrl.user.roles[\'facility_staff\']">\n' +
    '  </div>\n' +
    '\n' +
    '<!-- ========== WORK INFO ===========================-->\n' +
    '  <form name="userCtrl.forms.workInfo">\n' +
    '    <div class="data-wrapper">\n' +
    '      <div class="data-block data-block--without-margin">\n' +
    '        <div class="data-block__header">{{::\'WORK_INFORMATION\' | translate}}</div>\n' +
    '        <div class="user-details__schedule-wrapper">\n' +
    '          <div class="data-block__info-container data-block__info-container--block data-block__line-container--work-info">\n' +
    '            <div class="data-block__title">{{:: userCtrl.user.personalInfo.club.name}}</div>\n' +
    '          </div>\n' +
    '          <div class="data-block__info-container data-block__info-container--block user-details__schedule">\n' +
    '            <div ng-repeat="(day, times) in userCtrl.workInfo.days" class="user-details__schedule-item data-block__line-container--work-info">\n' +
    '              <pt-day-schedule day="day" times="times" editable="userCtrl.workInfo.days[day]"></pt-day-schedule>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="user-details__schedule-wrapper" ng-if="userCtrl.workInfo.otherFacilityHours">\n' +
    '          <div class="data-block__info-container data-block__info-container--block data-block__line-container--work-info">\n' +
    '            <div class="data-block__title">{{:: \'OTHER_FACILITY_HOURS\' | translate}}</div>\n' +
    '          </div>\n' +
    '          <div class="data-block__info-container data-block__info-container--block user-details__schedule">\n' +
    '            <div ng-repeat="(day, times) in userCtrl.workInfo.otherFacilityHours" class="user-details__schedule-item data-block__line-container--work-info">\n' +
    '              <pt-day-schedule day="day" times="times" editable="false"></pt-day-schedule>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="footer-buttons">\n' +
    '      <div\n' +
    '        ng-show=\'userCtrl.forms.workInfo.$dirty\'\n' +
    '        ng-click="userCtrl.saveWorkInfo(userCtrl.workInfo)"\n' +
    '        class="button button-action">\n' +
    '          {{ :: \'SAVE\'  | translate }}\n' +
    '      </div>\n' +
    '      <div\n' +
    '        ng-show=\'userCtrl.forms.workInfo.$dirty\'\n' +
    '        ng-click="userCtrl.resetWorkInfoData()"\n' +
    '        class="button button-clear button-assertive pull-right">\n' +
    '          {{ :: \'CANCEL\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '<!-- ========== CLIENT INFORMATION =================== -->\n' +
    '  <form name="userCtrl.forms.clients"\n' +
    '    ng-if="userCtrl.user.roles[\'facility_staff\']"\n' +
    '    permission\n' +
    '    permission-only=":: userCtrl.permissions.clients.read">\n' +
    '\n' +
    '    <div class="data-section">\n' +
    '      <div class="data-section__header">\n' +
    '        <div class="data-section__title">{{ :: \'ASSIGN_CLIENTS\' | translate }}</div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-section__content">\n' +
    '        <div class="data-section__item"\n' +
    '          ng-repeat="(i, client) in userCtrl.user.clients">\n' +
    '\n' +
    '          <div class="pull-right">\n' +
    '            <div class="button button-clear button-assertive push-top-sm"\n' +
    '              permission\n' +
    '              permission-only=":: userCtrl.permissions.clients.delete"\n' +
    '              ng-click="userCtrl.removeClient(client)">\n' +
    '                {{ :: \'REMOVE_CLIENT\' | translate }}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__image-container">\n' +
    '            <img class="user-page__user-img--trainer" ng-src="{{ client.pictureUrl || \'//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/\' }}">\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__item-content push-top-sm">\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--block">\n' +
    '              <div class="data-block__info">\n' +
    '                <span\n' +
    '                  class="data-block__info--input user-details__input--text user-details__trainer-input">\n' +
    '                  {{ :: client.firstName }} {{ :: client.lastName }}\n' +
    '                </span>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'NAME\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--block">\n' +
    '              <div class="data-block__info">\n' +
    '                <span\n' +
    '                  class="data-block__info--input user-details__input--email user-details__trainer-input">\n' +
    '                  {{ :: client.email}}\n' +
    '                </span>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'CONTACT\' | translate }}</div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="button button-large button-full button-primary"\n' +
    '          permission\n' +
    '          permission-only=":: userCtrl.permissions.clients.create"\n' +
    '          ng-click="userCtrl.showClientPopup()">\n' +
    '          {{ :: \'ADD_CLIENT\' | translate }}\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <div permission\n' +
    '        permission-only=":: userCtrl.permissions.clients.update"\n' +
    '        ng-show=\'userCtrl.forms.clients.$dirty\'\n' +
    '        ng-click="userCtrl.updateTrainerClients(userCtrl.user.clients)"\n' +
    '        class="button button-action">\n' +
    '        {{ :: \'UPDATE_CLIENT\'  | translate }}\n' +
    '      </div>\n' +
    '      <div permission\n' +
    '        permission-only=":: userCtrl.permissions.clients.update"\n' +
    '        ng-show=\'userCtrl.forms.clients.$dirty\'\n' +
    '        ng-click="userCtrl.reset(\'clients\')"\n' +
    '        class="button button-clear button-assertive pull-right">\n' +
    '        {{ :: \'CANCEL\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '<!-- ========== SETTINGS INFORAMTION =================== -->\n' +
    '  <div\n' +
    '    ng-init="role = \'Facility\'"\n' +
    '    ng-include="\'/app/user/tabs/userDetails/settings/settings.html\'">\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/settings/settings.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/settings/settings.html', '<form name="userCtrl.forms[\'settings\' + role]"\n' +
    '  permission\n' +
    '  permission-only=":: userCtrl.permissions.settings.read">\n' +
    '\n' +
    '  <div class="data-wrapper">\n' +
    '    <div class="data-wrapper--left">\n' +
    '\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__header">{{::\'EMAIL_NOTIFICATION\' | translate}}</div>\n' +
    '        <div class="data-block__container">\n' +
    '          <div class="data-block__line-container user-details__email-notification"\n' +
    '            ng-repeat="(name, value) in userCtrl.user.settings.notices">\n' +
    '            <label class="checkbox-custom">\n' +
    '              <input permission\n' +
    '                permission-only=":: userCtrl.permissions.settings.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                type="checkbox"\n' +
    '                ng-model="userCtrl.user.settings.notices[name]"\n' +
    '                class="data-block__info--input user-details__input--text">\n' +
    '              <span class="checkbox-label">\n' +
    '                {{::name | camelToSnakeCase | translate}}\n' +
    '              </span>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="data-wrapper--right">\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__header">{{::\'PREFERENCES\' | translate}}</div>\n' +
    '        <div class="data-block__container user-details__units">\n' +
    '          <div ng-class="data-block__info">\n' +
    '            <ui-select\n' +
    '              class=\'select-custom user-details__input--select\'\n' +
    '              search-enabled=\'false\'\n' +
    '              append-to-body=\'true\'\n' +
    '\n' +
    '              title="{{::\'CHOOSE_UNITS\'| translate}}"\n' +
    '              ng-model="userCtrl.user.settings.measurementUnit">\n' +
    '              <ui-select-match\n' +
    '                permission\n' +
    '                permission-only=":: userCtrl.permissions.settings.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                placeholder="{{::\'CHOOSE_UNITS\'| translate}}">{{\'MEASUREMENT_UNIT_\' + $select.selected | translate }}</ui-select-match>\n' +
    '              <ui-select-choices repeat="option in [\'I\', \'M\']">\n' +
    '                <span\n' +
    '                  ng-bind="\'MEASUREMENT_UNIT_\' + option | translate"></span>\n' +
    '              </ui-select-choices>\n' +
    '            </ui-select>\n' +
    '            <div class="data-block__title">{{::\'UNIT_SETTINGS\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container">\n' +
    '          <div ng-class="data-block__info">\n' +
    '            <ui-select\n' +
    '              class=\'select-custom user-details__input--select\'\n' +
    '              search-enabled=\'false\'\n' +
    '              append-to-body=\'true\'\n' +
    '\n' +
    '              title="{{::\'CHOOSE_LANGUAGE\' | translate}}"\n' +
    '              ng-model="userCtrl.user.settings.language">\n' +
    '              <ui-select-match\n' +
    '                permission\n' +
    '                permission-only=":: userCtrl.permissions.settings.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '                permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '                placeholder="{{::\'CHOOSE_LANGUAGE\' | translate}}">{{ \'LANGUAGE_\' + $select.selected | translate}}</ui-select-match>\n' +
    '              <ui-select-choices repeat="language in userCtrl.languages">\n' +
    '                <span\n' +
    '                  ng-bind="\'LANGUAGE_\' + language | translate"></span>\n' +
    '              </ui-select-choices>\n' +
    '            </ui-select>\n' +
    '            <div class="data-block__title">{{::\'LANGUAGE\' | translate}}</div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container">\n' +
    '          <ui-select\n' +
    '            class=\'select-custom user-details__input--select\'\n' +
    '            search-enabled=\'false\'\n' +
    '            append-to-body=\'true\'\n' +
    '\n' +
    '            title="{{::\'CHOOSE_DATE_FORMAT\' | translate}}"\n' +
    '            ng-model="userCtrl.user.settings.dateFormat">\n' +
    '            <ui-select-match\n' +
    '              permission\n' +
    '              permission-only=":: userCtrl.permissions.settings.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '              permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '              placeholder="{{::\'CHOOSE_DATE_FORMAT\' | translate}}">{{ $select.selected }}</ui-select-match>\n' +
    '            <ui-select-choices repeat="option in [\'MM/DD/YYYY\', \'DD/MM/YYYY\', \'YYYY-MM-DD\']">\n' +
    '              <span\n' +
    '                ng-bind="option"></span>\n' +
    '            </ui-select-choices>\n' +
    '          </ui-select>\n' +
    '          <div class="data-block__title">{{::\'DATE_FORMAT\' | translate}}</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="data-block">\n' +
    '        <div class="data-block__container">\n' +
    '          <ui-select\n' +
    '            class=\'select-custom user-details__input--select\'\n' +
    '            search-enabled=\'false\'\n' +
    '            append-to-body=\'true\'\n' +
    '\n' +
    '            title="{{::\'CHOOSE_TIME_FORMAT\' | translate}}"\n' +
    '            ng-model="userCtrl.user.settings.timeFormat">\n' +
    '            <ui-select-match\n' +
    '              permission\n' +
    '              permission-only=":: userCtrl.permissions.settings.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableUiSelect(this)"\n' +
    '              permission-on-authorized="PermissionStrategies.enableUiSelect(this)"\n' +
    '              placeholder="{{::\'CHOOSE_TIME_FORMAT\' | translate}}">{{ \'TIME_FORMAT_\' + $select.selected | translate}}</ui-select-match>\n' +
    '            <ui-select-choices repeat="option in [24, 12]">\n' +
    '              <span\n' +
    '                ng-bind="\'TIME_FORMAT_\' + option | translate"></span>\n' +
    '            </ui-select-choices>\n' +
    '          </ui-select>\n' +
    '          <div class="data-block__title">{{::\'TIME_FORMAT\' | translate}}</div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <div class="data-block" ng-if="userCtrl.facilityWorkoutHistoryEnabled">\n' +
    '        <div class="data-block__container">\n' +
    '          <label class="checkbox-custom settings__checkbox-container">\n' +
    '            <input type="checkbox"\n' +
    '              permission\n' +
    '              permission-only=":: userCtrl.permissions.settings.update"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              ng-model="userCtrl.user.settings.showWorkoutHistory">\n' +
    '            <span class="checkbox-label">{{ :: \'SHOW_WORKOUT_HISTORY\' | translate }}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="footer-buttons">\n' +
    '    <div class="button button-action"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.settings.update"\n' +
    '      ng-show="userCtrl.forms[\'settings\' + role].$dirty"\n' +
    '      ng-click="userCtrl.save(\'settings\', userCtrl.user.settings, role, userCtrl.user)">\n' +
    '      {{ :: \'SAVE\'  | translate }}\n' +
    '    </div>\n' +
    '    <div class="button button-assertive button-clear pull-right"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.settings.update"\n' +
    '      ng-show="userCtrl.forms[\'settings\' + role].$dirty"\n' +
    '      ng-click="userCtrl.reset(\'settings\', role)">\n' +
    '      {{ :: \'CANCEL\'  | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/userDetails.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/userDetails.html', '<div class="user-details">\n' +
    '\n' +
    '<!-- ========== PERSONAL INFORAMTION =================== -->\n' +
    '\n' +
    '  <form name="userCtrl.forms.personalInfoClient">\n' +
    '    <div permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.read"\n' +
    '      class="data-wrapper">\n' +
    '\n' +
    '      <div class="data-wrapper--left">\n' +
    '\n' +
    '        <div class="data-block">\n' +
    '          <div class="data-block__header">\n' +
    '            {{ :: \'PERSONAL_INFORMATION\' | translate }}\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block user-details__first-page">\n' +
    '            <div class="data-block__container user-details__first-block">\n' +
    '\n' +
    '              <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '                <div class="data-block__info">\n' +
    '                  <!-- disabled here, because for client it should be not editable\n' +
    '                  TODO: fix when new client functionality will be presented-->\n' +
    '                  <input disabled\n' +
    '                    ng-model="userCtrl.user.stats.birthday"\n' +
    '                    class="data-block__info--input client-details__input--text"\n' +
    '                    ng-click="isOpenCDatePicker1 = !isOpenCDatePicker1"\n' +
    '                    show-button-bar="false"\n' +
    '                    is-open="isOpenCDatePicker1"\n' +
    '                    popup-placement="bottom-left"\n' +
    '                    uib-datepicker-popup="{{userCtrl.dateFormat}}"\n' +
    '                    ng-model-options="{ timezone: \'UTC\' }"\n' +
    '                    placeholder="---">\n' +
    '                </div>\n' +
    '                <div class="data-block__title">{{ :: \'DATE_OF_BIRTH\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '                <div class="data-block__info">\n' +
    '                <!-- disabled here, because for client it should be not editable\n' +
    '                TODO: fix when new client functionality will be presented-->\n' +
    '                  <input disabled\n' +
    '                    ng-model="userCtrl.user.stats.gender"\n' +
    '                    class="data-block__info--input user-details__input--select">\n' +
    '                </div>\n' +
    '                <div class="data-block__title">{{ :: \'GENDER\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--block">\n' +
    '              <div class="data-block__info">\n' +
    '                <textarea permission\n' +
    '                permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                ng-model="userCtrl.user.personalInfo.address1"\n' +
    '                class="data-block__info--input user-details__input--area input-clear"\n' +
    '                placeholder="---">\n' +
    '                </textarea>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'ADDRESS1\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-block">\n' +
    '          <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '              <div class="data-block__info">\n' +
    '                <input permission\n' +
    '                permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                type="text"\n' +
    '                ng-model="userCtrl.user.personalInfo.phoneNumber1"\n' +
    '                class="data-block__info--input user-details__input--text input-clear"\n' +
    '                placeholder="-">\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'PHONE_NUMBER_1\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '              <div class="data-block__info">\n' +
    '                <input permission\n' +
    '                permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '                permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '                permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '                type="text"\n' +
    '                ng-model="userCtrl.user.personalInfo.phoneNumber2"\n' +
    '                class="data-block__info--input user-details__input--text input-clear"\n' +
    '                placeholder="-">\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'PHONE_NUMBER_2\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-block">\n' +
    '          <div class="data-block__container data-block__container--border-bottom data-block__client-info">\n' +
    '\n' +
    '            <div class="data-block__client-info-item">\n' +
    '              <div class="data-block__info-container">\n' +
    '                <div class="data-block__info">\n' +
    '                <span class="data-block__info--input user-details__input--email">\n' +
    '                  {{::userCtrl.user.personalInfo.email}}\n' +
    '                </span>\n' +
    '                </div>\n' +
    '                <div class="data-block__title">{{ :: \'EMAIL_ADDRESS\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div ng-if="userCtrl.isSmartHealthFacility && userCtrl.user.smartHealthId" class="data-block__info-container">\n' +
    '                <input class="data-block__info--input"\n' +
    '                  ng-value="userCtrl.user.smartHealthId"\n' +
    '                  readonly\n' +
    '                  placeholder="---"/>\n' +
    '                    <div class="data-block__title">{{ :: \'SMART_HEALTH_ID\' | translate }}</div>\n' +
    '              </div>\n' +
    '              <div ng-if="userCtrl.user.upaceId" class="data-block__info-container">\n' +
    '                <input class="data-block__info--input"\n' +
    '                  ng-value="userCtrl.user.upaceId"\n' +
    '                  readonly\n' +
    '                  placeholder="---"/>\n' +
    '                    <div class="data-block__title">{{ :: \'UPACE_ID\' | translate }}</div>\n' +
    '              </div>\n' +
    '              <div ng-if="userCtrl.user.npXid" class="data-block__info-container">\n' +
    '                <input class="data-block__info--input"\n' +
    '                  ng-value="userCtrl.user.npXid"\n' +
    '                  readonly\n' +
    '                  placeholder="---"/>\n' +
    '                    <div class="data-block__title">{{ :: \'XID\' | translate }}</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '              <div class="data-block__info">\n' +
    '                <div permission\n' +
    '                permission-only=":: userCtrl.permissions.resetPassword.update"\n' +
    '                class="data-block__button" ng-click="userCtrl.showResetLoading || userCtrl.resetPassword()"\n' +
    '                ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }">\n' +
    '                  {{ :: \'RESET_PASSWORD\' | translate }}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="data-block__info" ng-if="userCtrl.userId === user._id || userCtrl.userId === \'me\'">\n' +
    '                <div class="data-block__button" ng-click="userCtrl.showResetLoading || userCtrl.changePassword()"\n' +
    '                ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }">\n' +
    '                  {{ :: \'CHANGE_PASSWORD\' | translate }}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <div class="data-block__info">\n' +
    '                <div permission\n' +
    '                permission-only=":: USERS_ADMIN_DELETE"\n' +
    '                class="data-block__button data-block__button--red" ng-click="userCtrl.showResetLoading || userCtrl.deleteUser()"\n' +
    '                ng-class="{ \'data-block__button-disabled\': userCtrl.showResetLoading }" ng-if=\'userCtrl.isEditable(["USERS_ADMIN_DELETE"])\'>\n' +
    '                  {{ :: \'DELETE_ACCOUNT\' | translate }}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-block" permission\n' +
    '            permission-only="\'CURRENT_FACILITY_READ\'">\n' +
    '          <div class="data-block__container data-block__container--border-bottom">\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '              <div class="data-block__info">\n' +
    '\n' +
    '              <input class="data-block__info--input"\n' +
    '                ng-value="userCtrl.user.personalInfo.club.chain"\n' +
    '                readonly\n' +
    '                placeholder="---">\n' +
    '              </div>\n' +
    '              <!-- org_name is for automation -->\n' +
    '              <div class="org_name data-block__title">{{ :: \'CLUB_CHAIN\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--2-col">\n' +
    '              <div class="data-block__info">\n' +
    '                <!-- facility_name is for automation -->\n' +
    '              <span class="facility_name data-block__info--input">\n' +
    '                {{ userCtrl.user.personalInfo.club.name}}\n' +
    '              </span>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'HOME_CLUB\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-block" ng-if=\'userCtrl.membershipGroupEnabled\'>\n' +
    '          <div class="data-block__container">\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container data-block__info-container--membership">\n' +
    '              <div class="data-block__info">\n' +
    '                <!-- facility_name is for automation -->\n' +
    '                <span class="facility_name data-block__info--input">{{ :: \'MEMBERSHIP_GROUPS\' | translate }}</span>\n' +
    '              </div>\n' +
    '              <div class="client-membership-container"\n' +
    '                ng-class=\'{"no-memberships__user-details":!userCtrl.isEditable(["ASSIGN_MEMBERSHIP_GROUP_UPDATE", "ASSIGN_MEMBERSHIP_GROUP_DELETE"]) }\'>\n' +
    '                <div class="client-membership-groups" ng-repeat="group in userCtrl.membershipGroup" ng-if=\'userCtrl.isEditable(["ASSIGN_MEMBERSHIP_GROUP_UPDATE", "ASSIGN_MEMBERSHIP_GROUP_DELETE"])\'>\n' +
    '                  <label class="checkbox-custom">\n' +
    '                    <input\n' +
    '                      type="checkbox"\n' +
    '                      ng-click="userCtrl.updateSelection($event, group._id)"\n' +
    '                      class="data-block__info--input user-details__input--text"\n' +
    '                      ng-checked="userCtrl.isUserMembershipGroupChecked(group._id)">\n' +
    '                    <span class="checkbox-label">\n' +
    '                      {{ group.name }}\n' +
    '                    </span>\n' +
    '                  </label>\n' +
    '                </div>\n' +
    '                <div class="client-membership-groups" ng-repeat="group in userCtrl.getUserMembershipGroupNames()" ng-if=\'!userCtrl.isEditable(["ASSIGN_MEMBERSHIP_GROUP_UPDATE", "ASSIGN_MEMBERSHIP_GROUP_DELETE"])\'>\n' +
    '                    <label class="checkbox-custom">\n' +
    '                      <span class="checkbox-label">\n' +
    '                        {{ group }}\n' +
    '                      </span>\n' +
    '                    </label>\n' +
    '                  </div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-wrapper--right">\n' +
    '        <div class="data-block">\n' +
    '          <div class="data-block__header">{{ :: \'PLAN_DETAILS\' | translate }}</div>\n' +
    '          <div class="data-block__container user-details__plan-details">\n' +
    '\n' +
    '            <div class="user-details__plan-details--left-column">\n' +
    '              <div class="data-block__info-container"\n' +
    '                  ng-if="userCtrl.user.personalInfo.planDetails.lastWorkoutDate">\n' +
    '                  <div class="data-block__info">\n' +
    '                    <span class="data-block__info--input user-details__input--text user-details__plan-details--checkicon">\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="data-block__title data-block__title--hidden">✔</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="data-block__info-container">\n' +
    '                  <div class="data-block__info">\n' +
    '                    <span class="data-block__info--input--hidden user-details__input--text">\n' +
    '                      ✔\n' +
    '                    </span>\n' +
    '                  </div>\n' +
    '                  <div class="data-block__title data-block__title--hidden">✔</div>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="user-details__plan-details--right-column">\n' +
    '              <div class="data-block__info-container"\n' +
    '                ng-if="userCtrl.user.personalInfo.planDetails.lastWorkoutDate">\n' +
    '                <div class="data-block__info">\n' +
    '                  <!-- Disablie, because this data we are receiving from NetPulse -->\n' +
    '                  <input disabled\n' +
    '                    ng-model="userCtrl.user.personalInfo.planDetails.lastWorkoutDate"\n' +
    '                    ng-click="lastWorkoutDatePicker = !lastWorkoutDatePicker"\n' +
    '                    show-button-bar="false"\n' +
    '                    is-open="lastWorkoutDatePicker"\n' +
    '                    popup-placement="bottom-left"\n' +
    '                    uib-datepicker-popup="{{userCtrl.dateFormat}}"\n' +
    '                    class="data-block__info--input client-details__input--text client-details__plan-details--date">\n' +
    '                </div>\n' +
    '                <div class="data-block__title">{{ :: \'LAST_WORKOUT\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '              <div class="data-block__info-container"\n' +
    '                ng-if="userCtrl.user.personalInfo.planDetails.nextAssignmentDate">\n' +
    '                <div class="data-block__info">\n' +
    '                  <!-- Disablie, because this data we are receiving from NetPulse -->\n' +
    '                  <input disabled\n' +
    '                    ng-model="userCtrl.user.personalInfo.planDetails.nextAssignmentDate"\n' +
    '                    ng-click="nextAssignmentDatePicker = !nextAssignmentDatePicker"\n' +
    '                    show-button-bar="false"\n' +
    '                    is-open="nextAssignmentDatePicker"\n' +
    '                    popup-placement="bottom-left"\n' +
    '                    uib-datepicker-popup="{{userCtrl.dateFormat}}"\n' +
    '                    class="data-block__info--input client-details__input--text client-details__plan-details--date">\n' +
    '                </div>\n' +
    '                <div class="data-block__title">{{ :: \'NEXT_WORKOUT\' | translate }}</div>\n' +
    '              </div>\n' +
    '\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <div permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '      ng-show=\'userCtrl.forms.personalInfoClient.$dirty\'\n' +
    '      ng-click="userCtrl.savePersonalInfo(\'personalInfo\', userCtrl.user.personalInfo, \'Client\' ,userCtrl.user)"\n' +
    '      class="button button-action">\n' +
    '        {{ :: \'SAVE\'  | translate }}\n' +
    '      </div>\n' +
    '      <div permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '      ng-show=\'userCtrl.forms.personalInfoClient.$dirty\'\n' +
    '      ng-click="userCtrl.reset(\'personalInfo\', \'Client\')"\n' +
    '      class="button button-clear button-assertive pull-right">\n' +
    '        {{ :: \'CANCEL\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '<!-- ========== TRAINER INFORMATION =================== -->\n' +
    '  <form name="userCtrl.forms.trainers"\n' +
    '    permission\n' +
    '    permission-only=" :: userCtrl.permissions.trainers.read">\n' +
    '\n' +
    '    <div class="data-section">\n' +
    '      <div class="data-section__header">\n' +
    '        <div class="data-section__title">{{ :: \'TRAINER\' | translate }}</div>\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="data-section__content">\n' +
    '        <div class="data-section__item"\n' +
    '          ng-repeat="(i, trainer) in userCtrl.user.trainers">\n' +
    '\n' +
    '          <div class="pull-right">\n' +
    '            <div class="button button-clear button-assertive push-top-sm"\n' +
    '              permission\n' +
    '              permission-only="userCtrl.permissions.trainers.delete"\n' +
    '              ng-click="userCtrl.removeTrainer(trainer)">\n' +
    '                {{ :: \'REMOVE_TRAINER\' | translate }}\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__image-container">\n' +
    '            <img class="user-page__user-img--trainer" ng-src="{{ trainer.pictureUrl || \'//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/\' }}">\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-section__item-content push-top-sm">\n' +
    '            <div class="data-block__info-container data-block__info-container--block">\n' +
    '              <div class="data-block__info">\n' +
    '                <span\n' +
    '                  class="data-block__info--input user-details__input--text user-details__trainer-input">\n' +
    '                  {{::trainer.firstName}} {{::trainer.lastName}}\n' +
    '                </span>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'NAME\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="data-block__info-container data-block__info-container--block">\n' +
    '              <div class="data-block__info">\n' +
    '                <span\n' +
    '                  class="data-block__info--input user-details__input--email user-details__trainer-input">\n' +
    '                  {{::trainer.email}}\n' +
    '                </span>\n' +
    '              </div>\n' +
    '              <div class="data-block__title">{{ :: \'CONTACT\' | translate }}</div>\n' +
    '            </div>\n' +
    '\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="button button-large button-full button-primary"\n' +
    '          permission\n' +
    '          permission-only="userCtrl.permissions.trainers.create"\n' +
    '          ng-click="userCtrl.showTrainerPopup()">\n' +
    '          {{ :: \'ADD_TRAINER\' | translate }}\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="footer-buttons">\n' +
    '      <div permission\n' +
    '        permission-only="\'CLIENT_TRAINER_OTHER_UPDATE\'"\n' +
    '        ng-show=\'userCtrl.forms.trainers.$dirty\'\n' +
    '        ng-click="userCtrl.save(\'trainers\', userCtrl.user.trainers)"\n' +
    '        class="button button-action">\n' +
    '        {{ :: \'UPDATE_TRAINER\'  | translate }}\n' +
    '      </div>\n' +
    '      <div permission\n' +
    '        permission-only="[\'CLIENT_TRAINER_OTHER_UPDATE\', \'CLIENT_TRAINER_OTHER_CREATE\', \'CLIENT_TRAINER_OTHER_DELETE\']"\n' +
    '        ng-show=\'userCtrl.forms.trainers.$dirty\'\n' +
    '        ng-click="userCtrl.reset(\'trainers\')"\n' +
    '        class="button button-clear button-assertive pull-right">\n' +
    '        {{ :: \'CANCEL\'  | translate }}\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '\n' +
    '<!-- ========== SETTINGS INFORAMTION =================== -->\n' +
    '  <div\n' +
    '    ng-init="role = \'Client\'"\n' +
    '    ng-include="\'/app/user/tabs/userDetails/settings/settings.html\'">\n' +
    '  </div>\n' +
    '\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userDetails/userModal/userModal.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userDetails/userModal/userModal.html', '<form name="usersCtrl.trainerModalForm" class=\'user-details__trainer-popup-form\'>\n' +
    '\n' +
    '  <div class="modal__popup-header">\n' +
    '    <div class="modal__popup-header--title">{{ :: \'SELECT_\'+usersCtrl.user.modalType.toUpperCase()+\'_PERSON\' | translate }}</div>\n' +
    '    <div ng-click="usersCtrl.closeModal()"\n' +
    '    class="modal__popup-header--exit icon icon-cross"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="user-details__trainer-popup-search-container">\n' +
    '    <label for="searchStr" class="user-details__trainer-popup-search-icon icon icon-search"></label>\n' +
    '    <input type="text"\n' +
    '      id="searchStr"\n' +
    '      ng-model="usersCtrl.searchStr"\n' +
    '      ng-model-options="{\'debounce\': 400}"\n' +
    '      ng-change="usersCtrl.searcUsersByStr(usersCtrl.searchStr)"\n' +
    '      class="user-details__trainer-popup-search-input"\n' +
    '      placeholder="{{::\'SEARCH_\'+usersCtrl.user.modalType.toUpperCase() | translate}}">\n' +
    '\n' +
    '    <div class="user-details__trainer-popup-select-all">\n' +
    '      <label class="checkbox-custom">\n' +
    '        <input\n' +
    '          permission\n' +
    '          permission-only="usersCtrl.isMe ? \'CLIENT_TRAINER_SELF_UPDATE\' : \'CLIENT_TRAINER_OTHER_UPDATE\'"\n' +
    '          permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '          permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '          type="checkbox"\n' +
    '          ng-model="usersCtrl.isAllSelected"\n' +
    '          ng-change="usersCtrl.selectAll(usersCtrl.isAllSelected, usersCtrl.usersList.items)"\n' +
    '          class="right-checkbox black-checkbox">\n' +
    '        <span class="checkbox-label">{{ :: \'SELECT_ALL\' | translate }}</span>\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- ========== TRAINERS LIST =========== -->\n' +
    '  <div class="data-section"\n' +
    '     infinite-scroll=\'usersCtrl.loadUsers()\'\n' +
    '     can-load=\'usersCtrl.usersList.nextPage\'\n' +
    '     threshold=\'30\'>\n' +
    '\n' +
    '    <div class="data-section__content">\n' +
    '\n' +
    '      <div class="data-section__item"\n' +
    '        ng-repeat="(i, user) in usersCtrl.usersList.items">\n' +
    '\n' +
    '        <div class="pull-right push-top-md push-right-md">\n' +
    '          <label class="checkbox-custom">\n' +
    '            <input class="right-checkbox"\n' +
    '              permission\n' +
    '              permission-only="usersCtrl.isMe ? \'CLIENT_TRAINER_SELF_UPDATE\' : \'CLIENT_TRAINER_OTHER_UPDATE\'"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              type="checkbox"\n' +
    '              ng-model="user.selected">\n' +
    '            <span class="checkbox-label">{{ :: \'ADD_\' + usersCtrl.user.modalType.toUpperCase() | translate }}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-section__image-container">\n' +
    '          <img class="user-page__user-img--trainer" ng-src="{{ user.pictureUrl || \'//images.jhtassets.com/69dcdf7c42e69031c482c0c1c6cf8d5050db00d7/\' }}">\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="data-section__item-content push-top-sm">\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--block">\n' +
    '            <div class="data-block__info">\n' +
    '              <span\n' +
    '                class="data-block__info--input user-details__input--text user-details__trainer-input">\n' +
    '                {{ :: user.firstName }} {{ :: user.lastName }}\n' +
    '              </span>\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'NAME\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="data-block__info-container data-block__info-container--block">\n' +
    '            <div class="data-block__info">\n' +
    '              <span\n' +
    '                class="data-block__info--input user-details__input--email user-details__trainer-input">\n' +
    '                {{ :: user.email }}\n' +
    '              </span>\n' +
    '            </div>\n' +
    '            <div class="data-block__title">{{ :: \'CONTACT\' | translate }}</div>\n' +
    '          </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '    <div class=\'roster-load-more\' ng-if=\'usersCtrl.usersList.nextPage\'>\n' +
    '      <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '      {{ :: \'LOADING_MORE_\' + usersCtrl.user.modalType.toUpperCase() + \'S\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="footer-buttons">\n' +
    '    <div class="button button-action"\n' +
    '      permission\n' +
    '      permission-only="\'CLIENT_TRAINER_OTHER_UPDATE\'"\n' +
    '      ng-show=\'usersCtrl.trainerModalForm.$dirty\'\n' +
    '      ng-click="usersCtrl.addUsers(usersCtrl.usersList.items)">\n' +
    '      <span>{{ :: \'ADD_\' + usersCtrl.user.modalType.toUpperCase() | translate }}</span>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="button button-clear button-assertive pull-right"\n' +
    '      ng-show=\'usersCtrl.trainerModalForm.$dirty\'\n' +
    '      ng-click="usersCtrl.resetTrainers(\'trainerModal\')">\n' +
    '      {{ :: \'CANCEL\'  | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '');
  }]);
angular.module('/app/user/tabs/userNotes/notes.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/tabs/userNotes/notes.html', '<div class="notes" ng-controller="NotesController as notesCtrl">\n' +
    '  <div class="notes__content"\n' +
    '    permission\n' +
    '    permission-only="\'USER_NOTES_OTHER_READ\'">\n' +
    '\n' +
    '    <div>{{\'NOTES_INFO\' | translate }}</div>\n' +
    '\n' +
    '    <form name="notesCtrl.forms.notes"></form>\n' +
    '\n' +
    '    <div class="drop-down">\n' +
    '      <form class="drop-down__group-container"\n' +
    '        name=\'notesCtrl.forms["{{(note._id || note._virtualId)}}"]\'\n' +
    '        ng-repeat="note in notesCtrl.notes"\n' +
    '        ng-show=\'!note.isDeleted\'>\n' +
    '\n' +
    '        <div class="drop-down__group-container fade-onload">\n' +
    '          <div class="drop-down__group-header">\n' +
    '            <input permission\n' +
    '              permission-only="note._isNew ? \'USER_NOTES_OTHER_CREATE\': \'USER_NOTES_OTHER_UPDATE\'"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              type="text"\n' +
    '              ng-model="note.title"\n' +
    '              ng-focus="notesCtrl.selectText($event)"\n' +
    '              ng-change="notesCtrl.onTitleChange()"\n' +
    '              class="drop-down__group-title">\n' +
    '\n' +
    '\n' +
    '            <div class="drop-down__group-button drop-down__group-button--hide"\n' +
    '              ng-class="{\'drop-down__group-button--hide--collapsed\': !note.isExpanded}"\n' +
    '              ng-click="note.isExpanded = !note.isExpanded">\n' +
    '            </div>\n' +
    '\n' +
    '            <div permission\n' +
    '              permission-only="\'USER_NOTES_OTHER_DELETE\'"\n' +
    '              class="drop-down__group-button drop-down__group-button--remove"\n' +
    '              ng-click="notesCtrl.getConfirmationOnDeletedNote(note)">\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="note.isEdited && note.isExpanded"\n' +
    '              permission\n' +
    '              permission-only="note._isNew ? \'USER_NOTES_OTHER_CREATE\': \'USER_NOTES_OTHER_UPDATE\'"\n' +
    '              class="drop-down__group-button drop-down__group-button--cancel"\n' +
    '              ng-click="notesCtrl.cancelNoteEdit(note); note.isExpanded = false;  notesCtrl.reset(note, $index);">\n' +
    '            </div>\n' +
    '\n' +
    '            <div ng-if="note.isEdited && note.isExpanded"\n' +
    '              permission\n' +
    '              permission-only="note._isNew ? \'USER_NOTES_OTHER_CREATE\': \'USER_NOTES_OTHER_UPDATE\'"\n' +
    '              class="drop-down__group-button drop-down__group-button--apply"\n' +
    '              ng-click="notesCtrl.applyNoteEdit(note); note.isExpanded = false; notesCtrl.save(note, $index); notesCtrl.triggerIsLoading($index);">\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="drop-down__group-button drop-down__group-button--edit"\n' +
    '              permission\n' +
    '              permission-only="note._isNew ? \'USER_NOTES_OTHER_CREATE\': \'USER_NOTES_OTHER_UPDATE\'"\n' +
    '              ng-if="!note.isEdited"\n' +
    '              ng-click="notesCtrl.noteEdit(note)">\n' +
    '            </div>\n' +
    '\n' +
    '            <div class="drop-down__group-date">{{note.formattedDate | dateFormatter:\'dateShort\'}}</div>\n' +
    '\n' +
    '            <div ng-if="notesCtrl.isLoading[$index]" class="drop-down-loader__icon spinner-icon"></div>\n' +
    '          </div>\n' +
    '          <div class="drop-down__group-content" uib-collapse="!note.isExpanded">\n' +
    '            <div ng-if="note.isEdited">\n' +
    '              <trix-editor \n' +
    '              ng-click="notesCtrl.trixChange(note)"\n' +
    '              ng-style="{\'white-space\': \'pre-wrap\'}" \n' +
    '              angular-trix \n' +
    '              ng-model="note.content"\n' +
    '              >\n' +
    '            </trix-editor>\n' +
    '              <div class="drop-down__drop-zone"\n' +
    '                file-drop\n' +
    '                on-file-drop="notesCtrl.wrapAddFiles(note._id || note._virtualId)"\n' +
    '                on-file-error="notesCtrl.toggleFileError">\n' +
    '                <div>\n' +
    '                  {{ \'NOTE_FILE_DROP\' | translate }}\n' +
    '                  <div class="drop-down__file-input-wrapper">\n' +
    '                    <input type="file"\n' +
    '                      id="noteFileBrowse"\n' +
    '                      file-read\n' +
    '                      on-file-read="notesCtrl.wrapAddFiles(note._id || note._virtualId)"\n' +
    '                      on-file-error="notesCtrl.toggleFileError"\n' +
    '                      class="drop-down__file-input"\n' +
    '                      multiple>\n' +
    '                    <label for="noteFileBrowse">{{ \'NOTE_FILE_BROWSE\' | translate }}</label>\n' +
    '                  </div>\n' +
    '                </div>\n' +
    '                <div class="drop-down__info-text">\n' +
    '                    {{ \'NOTE_FILE_REQUIREMENTS\' | translate }}\n' +
    '                </div>\n' +
    '              </div>\n' +
    '              <span ng-if="notesCtrl.fileError"\n' +
    '                ng-click="notesCtrl.toggleFileError()"\n' +
    '                class="drop-down__file-remove"></span>\n' +
    '              <span ng-if="notesCtrl.fileError" class="drop-down__error-text">{{ \'NOTE_FILE_ERROR\' | translate }}</span>\n' +
    '              <div ng-if="note.files" ng-repeat="file in note.files">\n' +
    '                <span ng-click="notesCtrl.removeFile((note._id || note._virtualId), $index)"\n' +
    '                  class="drop-down__file-remove"></span>\n' +
    '                <span ng-if="!file.fileId">{{file.name}}</span>\n' +
    '                <span ng-if="file.fileId" ng-click="notesCtrl.openFile(note, file, $event)" class="drop-down__download-link">{{notesCtrl.decodeFileName(file.fileName)}}</span>\n' +
    '                <span class="drop-down__file-icon"></span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-style="{\'white-space\': \'pre-wrap\'}" ng-if="!note.isEdited" ng-bind-html="note.content"></div>\n' +
    '            <div ng-if="note.files && !note.isEdited" ng-repeat="file in note.files">\n' +
    '              <span ng-if="file.fileId" class="drop-down__download-link" ng-click="notesCtrl.openFile(note, file, $event)">{{notesCtrl.decodeFileName(file.fileName)}}</span>\n' +
    '              <span ng-if="!file.fileId">{{file.name}}</span>\n' +
    '              <span class="drop-down__file-icon"></span>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '    </div>\n' +
    '\n' +
    '    <div\n' +
    '        permission\n' +
    '        permission-only="\'USER_NOTES_OTHER_CREATE\'"\n' +
    '        ng-click="notesCtrl.add()"\n' +
    '        ng-if="!notesCtrl.creatingNewNote"\n' +
    '        class="button button-full button-large button-primary">\n' +
    '      {{ :: \'ADD_NOTE\' | translate }}\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '');
  }]);
angular.module('/app/user/user.html', []).run(["$templateCache", function($templateCache) {
    $templateCache.put('/app/user/user.html', '<section class="user-page">\n' +
    '\n' +
    '  <div class="container-header">\n' +
    '    <div class="back-button" need-confirmation="false"></div>\n' +
    '\n' +
    '    <div class="button-toolbar pull-right">\n' +
    '      <button class="button button-action pull-right"\n' +
    '        ng-if="userCtrl.user.roles[\'client\']"\n' +
    '        permission\n' +
    '        permission-only=":: userCtrl.permissions.workout.create"\n' +
    '        ng-click="userCtrl.goToUserAssignmentView()">\n' +
    '        <span class="button__icon button__icon--add-assignment"></span>\n' +
    '        {{ :: \'NEW_WORKOUT\' | translate }}\n' +
    '      </button>\n' +
    '\n' +
    '      <button class="button button-action pull-right"\n' +
    '        ng-if="userCtrl.user.roles[\'client\']"\n' +
    '        permission\n' +
    '        permission-only=":: userCtrl.permissions.reminder.create"\n' +
    '        ng-click="userCtrl.onClickReminder()">\n' +
    '        <span class="button__icon button__icon--followup"></span>\n' +
    '        {{ :: \'SCHEDULE_FOLLOWUP\' | translate }}\n' +
    '      </button>\n' +
    '\n' +
    '      <button class="button button-action pull-right"\n' +
    '        ng-if="userCtrl.user.roles[\'facility_staff\']"\n' +
    '        permission\n' +
    '        permission-only=":: userCtrl.permissions.task.create"\n' +
    '        ui-sref="app.task({prevState: \'app.users.details\', userId: userCtrl.userId})">\n' +
    '        <span class="button__icon button__icon--add-assignment"></span>\n' +
    '        {{ :: \'NEW_TASK\' | translate }}\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="user-page__profile-wrapper">\n' +
    '    <div class="user-page__profile">\n' +
    '      <div class="user-page__user-img-container">\n' +
    '        <div class="file-input__container user-page__file-input icon icon-camera"\n' +
    '          permission\n' +
    '          permission-only=":: userCtrl.permissions.personalDetails.update"\n' +
    '          ng-if="userCtrl.initialDataIsLoaded"\n' +
    '          ngf-select=\'userCtrl.updateAvatar($files[0],userCtrl.user)\'\n' +
    '          ngf-pattern="\'image/*\'"\n' +
    '          ngf-multiple="false"\n' +
    '          uib-tooltip="{{ :: \'CHANGE_AVATAR_PIC\' | translate }}"\n' +
    '          tooltip-placement="right-top">\n' +
    '        </div>\n' +
    '        <img class="user-page__user-img" ng-src="{{userCtrl.user.pictureUrl || \'//images.jhtassets.com/2932c1a7f9366821e7218457dd9acea9c2600cf7/transformed/f_png\'}}">\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="user-page__user-name">\n' +
    '        {{ :: userCtrl.user.firstName }} {{ :: userCtrl.user.lastName }}\n' +
    '      </div>\n' +
    '\n' +
    '      <div class="user-page__user-activity">\n' +
    '        <div\n' +
    '          permission\n' +
    '          ng-if="userCtrl.user.roles[ \'client\']"\n' +
    '          permission-only="\'INTERESTED_READ\'"\n' +
    '          class="user-page__user-activity-caption">\n' +
    '          <label class="checkbox-custom">\n' +
    '            <input\n' +
    '              permission\n' +
    '              permission-only="\'INTERESTED_UPDATE\'"\n' +
    '              permission-on-unauthorized="PermissionStrategies.disableElement"\n' +
    '              permission-on-authorized="PermissionStrategies.enableElement"\n' +
    '              type="checkbox"\n' +
    '              id="interested"\n' +
    '              ng-model="userCtrl.user.interested"\n' +
    '              ng-change="userCtrl.updateClientFlags(userCtrl.user.interested, \'interested\')"\n' +
    '              class="right-checkbox">\n' +
    '            <span class="checkbox-label">{{ :: \'INTERESTED\' | translate }}</span>\n' +
    '          </label>\n' +
    '        </div>\n' +
    '        <div class="user-page__user-activity-caption">\n' +
    '          <button\n' +
    '            permission\n' +
    '            permission-only="\'USER_DEACTIVATE_DELETE\'"\n' +
    '            type="button"\n' +
    '            ng-click="userCtrl.removeFromFacility(userCtrl.user)"\n' +
    '            class="right-checkbox user-page__user-remove-button">\n' +
    '            {{ :: \'DEACTIVATE_USER\' | translate }}\n' +
    '          </button>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <tabs theme="dark" ng-if=\'userCtrl.initialDataIsLoaded\'>\n' +
    '    <tab name=\'assignments\'\n' +
    '      is-hidden="!userCtrl.user.roles[\'client\']"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.assignments.read"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'WORKOUTS\' | translate}}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/assignments/combined-tab.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '\n' +
    '    <tab name=\'body-stats\'\n' +
    '      is-hidden="!userCtrl.user.roles[\'client\']"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.stats.read"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'BODY_STATS\' | translate }}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/biometrics/biometrics.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '\n' +
    '    <tab name=\'user-details\'\n' +
    '      is-hidden="!userCtrl.user.roles[\'client\']"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.read"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'CLIENT_DETAILS\' | translate }}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/userDetails/userDetails.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '\n' +
    '    <tab name=\'facility-staff-details\'\n' +
    '      is-hidden="!userCtrl.user.roles[\'facility_staff\']"\n' +
    '      permission\n' +
    '      permission-only=":: userCtrl.permissions.personalDetails.read"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'FACILITY_STAFF\' | translate }}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/userDetails/facilityStaff.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '\n' +
    '    <tab name=\'notes\'\n' +
    '      is-hidden="!userCtrl.user.roles[\'client\']"\n' +
    '      permission\n' +
    '      permission-only="\'USER_NOTES_OTHER_READ\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'NOTES\' | translate }}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/userNotes/notes.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '    <tab name=\'user-permissions\'\n' +
    '      permission\n' +
    '      permission-only="\'USER_PERMISSIONS_READ\'"\n' +
    '      permission-on-unauthorized="PermissionStrategies.disableTab">\n' +
    '      <tab-head>\n' +
    '        <span class="tab-head__multiline-item">{{ :: \'PERMISSIONS\' | translate }}</span>\n' +
    '      </tab-head>\n' +
    '      <tab-content>\n' +
    '        <ng-include src="\'/app/user/tabs/permissions/permissions.html\'"></ng-include>\n' +
    '      </tab-content>\n' +
    '    </tab>\n' +
    '    <tab name=\'messages\'\n' +
    '    permission\n' +
    '    permission-only="\'ALL_USER_MESSAGES_READ\'"\n' +
    '    permission-on-unauthorized="PermissionStrategies.disableTab"\n' +
    '    is-hidden="!userCtrl.user.roles[\'facility_staff\'] || userCtrl.isMe"\n' +
    '    >\n' +
    '    <tab-head>\n' +
    '      <span class="tab-head__multiline-item">{{ :: \'MESSAGES\' | translate }}</span>\n' +
    '    </tab-head>\n' +
    '    <tab-content>\n' +
    '      <ng-include src="\'/app/user/tabs/messaging/staffMessaging.html\'"></ng-include>\n' +
    '    </tab-content>\n' +
    '  </tab>\n' +
    '  </tabs>\n' +
    '\n' +
    '  <div class=\'roster-load-more\' ng-if=\'!userCtrl.initialDataIsLoaded\'>\n' +
    '    <div class=\'roster-load-more__icon spinner-icon\'></div>\n' +
    '  </div>\n' +
    '</section>\n' +
    '');
  }]);